export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * Represents non-fractional signed whole numeric values. Since the value may
   * exceed the size of a 32-bit integer, it's encoded as a string.
   */
  BigInt: any;
  Date: any;
  /** An exact decimal representation of a number, not to be confused with Float. */
  Decimal: any;
  /** An ISO 8601-encoded date */
  ISO8601Date: any;
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: any;
  /** Represents untyped JSON */
  JSON: any;
  /** Decimal quantity serialized with four fractional digits. */
  QuantityDecimal: any;
};

export type GAbsoluteTime = {
  __typename?: 'AbsoluteTime';
  /** Datetime. */
  datetime: Scalars['ISO8601DateTime'];
};

/** Autogenerated input type of AccessWifiMutation */
export type GAccessWifiMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Guest's email address */
  email: Scalars['String'];
  /** ID of the microsite location */
  micrositeLocationId: Scalars['ID'];
};

/** Autogenerated return type of AccessWifiMutation. */
export type GAccessWifiMutationPayload = {
  __typename?: 'AccessWifiMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The contact record created/updated */
  contact?: Maybe<GMicrositeContact>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']>;
  /** WiFi configuration including network credentials */
  wifi?: Maybe<GMicrositeWifi>;
};

/** A session for tracking account creation state during signup flows */
export type GAccountCreationSession = {
  __typename?: 'AccountCreationSession';
  /** Business address for deferred microsite creation */
  businessAddress?: Maybe<Scalars['String']>;
  /** Business name for deferred microsite creation */
  businessName?: Maybe<Scalars['String']>;
  /** Completion timestamp */
  completedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Creation timestamp */
  createdAt: Scalars['ISO8601DateTime'];
  /** User email address */
  email?: Maybe<Scalars['String']>;
  /** Auth0 user ID if existing user */
  existingAuth0UserId?: Maybe<Scalars['String']>;
  /** User first name */
  firstName?: Maybe<Scalars['String']>;
  /** Google Places API place ID for deferred microsite creation */
  googlePlaceId?: Maybe<Scalars['String']>;
  /** Unique identifier */
  id: Scalars['ID'];
  /** User last name */
  lastName?: Maybe<Scalars['String']>;
  /** Associated microsite location ID */
  micrositeLocationId?: Maybe<Scalars['ID']>;
  /** Last update timestamp */
  updatedAt: Scalars['ISO8601DateTime'];
  /** URL-friendly slug for microsite */
  urlSlug?: Maybe<Scalars['String']>;
};

/** Input for creating or updating an account creation session */
export type GAccountCreationSessionInput = {
  /** Business address for deferred microsite creation */
  businessAddress?: InputMaybe<Scalars['String']>;
  /** Business name for deferred microsite creation */
  businessName?: InputMaybe<Scalars['String']>;
  /** Set to true to mark session as complete */
  completed?: InputMaybe<Scalars['Boolean']>;
  /** User email address */
  email?: InputMaybe<Scalars['String']>;
  /** Auth0 user ID if existing user */
  existingAuth0UserId?: InputMaybe<Scalars['String']>;
  /** User first name */
  firstName?: InputMaybe<Scalars['String']>;
  /** Google Places API place ID for deferred microsite creation */
  googlePlaceId?: InputMaybe<Scalars['String']>;
  /** Session ID for updates */
  id?: InputMaybe<Scalars['ID']>;
  /** User last name */
  lastName?: InputMaybe<Scalars['String']>;
  /** Associated microsite location ID */
  micrositeLocationId?: InputMaybe<Scalars['ID']>;
  /** URL-friendly slug for microsite */
  urlSlug?: InputMaybe<Scalars['String']>;
};

/** An account profile representing a location or entity on a platform */
export type GAccountProfile = {
  __typename?: 'AccountProfile';
  /** Internal profile record ID */
  id: Scalars['ID'];
  /** Platform identifier */
  platformId: Scalars['String'];
  /** External profile ID from the platform */
  profileId: Scalars['String'];
  /** Profile display name */
  profileName?: Maybe<Scalars['String']>;
};

export type GAccountsReceivableCollectionsStatus = {
  __typename?: 'AccountsReceivableCollectionsStatus';
  id: Scalars['ID'];
  locationUuid: Scalars['String'];
  status: Scalars['String'];
};

export type GAccountsReceivableCompanyDashboard = {
  __typename?: 'AccountsReceivableCompanyDashboard';
  /** Reference date for aging bucket calculations */
  asOf: Scalars['ISO8601Date'];
  /** Paginated company summaries */
  companies: GAccountsReceivableCompanySummaryConnection;
  /** All company summaries without pagination, for CSV export */
  exportCompanies: Array<GAccountsReceivableCompanySummary>;
  /** Link to the NetSuite A/R Aging Report */
  netsuiteAgingReportUrl: Scalars['String'];
};


export type GAccountsReceivableCompanyDashboardCompaniesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type GAccountsReceivableCompanySummary = {
  __typename?: 'AccountsReceivableCompanySummary';
  arAssignee?: Maybe<GArAssignableUser>;
  companyName?: Maybe<Scalars['String']>;
  companyUuid: Scalars['String'];
  creditMemoOffsets: GAccountsReceivableCreditOffsets;
  current: GMoney;
  customerPaymentOffsets: GAccountsReceivableCreditOffsets;
  from1To30DaysPastDue: GMoney;
  from31To60DaysPastDue: GMoney;
  from61To90DaysPastDue: GMoney;
  over90DaysPastDue: GMoney;
  paymentIntentOffsets: GAccountsReceivableCreditOffsets;
  totalDue: GMoney;
  totalPastDue: GMoney;
};

/** The connection type for AccountsReceivableCompanySummary. */
export type GAccountsReceivableCompanySummaryConnection = {
  __typename?: 'AccountsReceivableCompanySummaryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GAccountsReceivableCompanySummaryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GAccountsReceivableCompanySummary>>>;
  /** Information to aid in pagination. */
  pageInfo: GPageInfo;
};

/** An edge in a connection. */
export type GAccountsReceivableCompanySummaryEdge = {
  __typename?: 'AccountsReceivableCompanySummaryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GAccountsReceivableCompanySummary>;
};

export type GAccountsReceivableCreditOffsets = {
  __typename?: 'AccountsReceivableCreditOffsets';
  current: GMoney;
  from1To30DaysPastDue: GMoney;
  from31To60DaysPastDue: GMoney;
  from61To90DaysPastDue: GMoney;
  over90DaysPastDue: GMoney;
  totalDue: GMoney;
  totalPastDue: GMoney;
};

export type GAccountsReceivableDashboard = {
  __typename?: 'AccountsReceivableDashboard';
  asOf: Scalars['ISO8601Date'];
  companies: GAccountsReceivableCompanySummaryConnection;
  exportCompanies: Array<GAccountsReceivableCompanySummary>;
  exportLocations: Array<GAccountsReceivableLocationSummary>;
  groupBy: GAccountsReceivableGroupBy;
  locations: GAccountsReceivableLocationSummaryConnection;
};


export type GAccountsReceivableDashboardCompaniesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type GAccountsReceivableDashboardLocationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export enum GAccountsReceivableGroupBy {
  /** Group by parent company */
  Company = 'COMPANY',
  /** Group by individual location */
  Location = 'LOCATION'
}

export type GAccountsReceivableInvoiceDetail = {
  __typename?: 'AccountsReceivableInvoiceDetail';
  amountRemaining: GMoney;
  dueDate: Scalars['ISO8601Date'];
  externalOrderId?: Maybe<Scalars['String']>;
  externalOrderPlatform?: Maybe<Scalars['String']>;
  invoiceUuid: Scalars['String'];
  /** Link to this invoice in NetSuite. */
  netsuiteInvoiceUrl: Scalars['String'];
  netsuiteTransactionId: Scalars['String'];
  pendingEarmarkAmount: GMoney;
  /** Link to the order detail page in the supply portal (Odeko-platform invoices only). */
  portalOrderDetailUrl?: Maybe<Scalars['String']>;
  total: GMoney;
  transactionDate: Scalars['ISO8601Date'];
  vendorName?: Maybe<Scalars['String']>;
};

export type GAccountsReceivableLocationDashboard = {
  __typename?: 'AccountsReceivableLocationDashboard';
  /** Reference date for aging bucket calculations */
  asOf: Scalars['ISO8601Date'];
  /** All location summaries without pagination, for CSV export */
  exportLocations: Array<GAccountsReceivableLocationSummary>;
  /** Paginated location summaries */
  locations: GAccountsReceivableLocationSummaryConnection;
  /** Link to the NetSuite A/R Aging Report */
  netsuiteAgingReportUrl: Scalars['String'];
};


export type GAccountsReceivableLocationDashboardLocationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type GAccountsReceivableLocationSummary = {
  __typename?: 'AccountsReceivableLocationSummary';
  arAssignee?: Maybe<GArAssignableUser>;
  autoPay: Scalars['Boolean'];
  autoStatement: Scalars['Boolean'];
  collectionsStatus?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyUuid?: Maybe<Scalars['String']>;
  creditMemoOffsets: GAccountsReceivableCreditOffsets;
  current: GMoney;
  customerPaymentOffsets: GAccountsReceivableCreditOffsets;
  from1To30DaysPastDue: GMoney;
  from31To60DaysPastDue: GMoney;
  from61To90DaysPastDue: GMoney;
  invoiceDetails: Array<GAccountsReceivableInvoiceDetail>;
  locationName?: Maybe<Scalars['String']>;
  locationUuid: Scalars['String'];
  over90DaysPastDue: GMoney;
  paymentIntentOffsets: GAccountsReceivableCreditOffsets;
  receivableNotes: Array<GReceivableNote>;
  totalDue: GMoney;
  totalPastDue: GMoney;
};

/** The connection type for AccountsReceivableLocationSummary. */
export type GAccountsReceivableLocationSummaryConnection = {
  __typename?: 'AccountsReceivableLocationSummaryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GAccountsReceivableLocationSummaryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GAccountsReceivableLocationSummary>>>;
  /** Information to aid in pagination. */
  pageInfo: GPageInfo;
};

/** An edge in a connection. */
export type GAccountsReceivableLocationSummaryEdge = {
  __typename?: 'AccountsReceivableLocationSummaryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GAccountsReceivableLocationSummary>;
};

/** Autogenerated input type of AcknowledgeBackInStockNotificationMutation */
export type GAcknowledgeBackInStockNotificationMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the back-in-stock subscription that triggered this notification */
  subscriptionId: Scalars['ID'];
};

/** Autogenerated return type of AcknowledgeBackInStockNotificationMutation. */
export type GAcknowledgeBackInStockNotificationMutationPayload = {
  __typename?: 'AcknowledgeBackInStockNotificationMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<GUserError>>;
  notification?: Maybe<GBackInStockNotification>;
};

/** Autogenerated input type of AcknowledgeConsumerOrder */
export type GAcknowledgeConsumerOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Consumer order ID. */
  consumerOrderId: Scalars['ID'];
  /**
   * Order's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
};

/** Autogenerated return type of AcknowledgeConsumerOrder */
export type GAcknowledgeConsumerOrderPayload = {
  __typename?: 'AcknowledgeConsumerOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to acknowledge the order. */
  result: GConsumerOrderResult;
};

/** Autogenerated input type of AcknowledgeDeliveryInstructionReviewMutation */
export type GAcknowledgeDeliveryInstructionReviewMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  instructionRevision: Scalars['String'];
  redelivery?: InputMaybe<Scalars['Boolean']>;
  stopId: Scalars['ID'];
};

/** Autogenerated return type of AcknowledgeDeliveryInstructionReviewMutation. */
export type GAcknowledgeDeliveryInstructionReviewMutationPayload = {
  __typename?: 'AcknowledgeDeliveryInstructionReviewMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  review?: Maybe<GDeliveryInstructionReview>;
  userErrors: Array<GUserError>;
};

export type GAcquisitionConversion = {
  __typename?: 'AcquisitionConversion';
  id: Scalars['ID'];
  name: Scalars['String'];
  netsuiteListId: Scalars['String'];
};

export type GActiveMasterHomepage = {
  __typename?: 'ActiveMasterHomepage';
  endDate: Scalars['ISO8601Date'];
  id: Scalars['ID'];
  name: Scalars['String'];
  rows: Array<GMasterHomepageRow>;
  startDate: Scalars['ISO8601Date'];
};

export type GActualRouteSummary = {
  __typename?: 'ActualRouteSummary';
  /** Planned road distance in miles; null until computed */
  miles?: Maybe<Scalars['Float']>;
  /** Stop count for this route */
  stops: Scalars['Int'];
};

export type GActualRoutesSummary = {
  __typename?: 'ActualRoutesSummary';
  /** Average volume utilization per truck as a percentage */
  avgCubicUtilizationPercent?: Maybe<Scalars['Float']>;
  /** Deliveries per route hour (total stops / driver hours) */
  dprh?: Maybe<Scalars['Float']>;
  /** Sum of driver working time for routes that have completed; null if no routes have completed yet */
  driverHours?: Maybe<Scalars['Float']>;
  /** Number of non-lobby dispatched routes */
  routeCount: Scalars['Int'];
  /** Per-route stop count and planned distance */
  routes: Array<GActualRouteSummary>;
  /**
   * Sum of planned_distance_miles for routes that have a computed value, excluding
   * routes whose every delivery stop is Metrobi (third-party); null if no routes
   * have been computed yet
   */
  totalDistanceMiles?: Maybe<Scalars['Float']>;
  /** Total stops across all dispatched routes */
  totalStops: Scalars['Int'];
};

/** Autogenerated input type of AdHocAppointmentCreate */
export type GAdHocAppointmentCreateInput = {
  /** Who's arriving — the one thing ops always has. */
  carrierName: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Notes or special instructions for the delivery. */
  comments?: InputMaybe<Scalars['String']>;
  /** Email the booking confirmation is sent to. */
  confirmationEmail?: InputMaybe<Scalars['String']>;
  /** Contact email for the delivery. */
  contactEmail?: InputMaybe<Scalars['String']>;
  /** Contact person for the delivery. */
  contactName?: InputMaybe<Scalars['String']>;
  /** Contact phone for the delivery. */
  contactPhone?: InputMaybe<Scalars['String']>;
  /** How the delivery is prioritized. */
  deliveryType?: InputMaybe<GDeliveryType>;
  freightType: GFreightType;
  /** Carrier PRO (tracking) number. */
  proNumber?: InputMaybe<Scalars['String']>;
  /** A known PO/TO reference. Omit for the PO-unknown path. */
  referenceNumber?: InputMaybe<Scalars['String']>;
  /** Standard Carrier Alpha Code, if known. */
  scacCode?: InputMaybe<Scalars['String']>;
  /** Date the freight ships, if known. */
  shipDate?: InputMaybe<Scalars['ISO8601Date']>;
  slotStartsAt: Scalars['ISO8601DateTime'];
  /** Truck or trailer number. */
  truckNumber?: InputMaybe<Scalars['String']>;
  /** PO-unknown path only — links the booking to a NetSuite vendor if ops knows it. */
  vendorNetsuiteEntityInternalId?: InputMaybe<Scalars['String']>;
  /** Required for the PO-unknown path; ignored otherwise (the confirmed reference's own warehouse is authoritative). */
  warehouseId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of AdHocAppointmentCreate. */
export type GAdHocAppointmentCreatePayload = {
  __typename?: 'AdHocAppointmentCreatePayload';
  booking?: Maybe<GDockBooking>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userErrors: Array<GDockBookingError>;
};

export type GAdHocAppointmentsNotAllowed = GUserErrorInterface & {
  __typename?: 'AdHocAppointmentsNotAllowed';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** Input for adding an item to the cart. */
export type GAddCartItemInput = {
  /** MenuItem ID */
  menuItemId: Scalars['ID'];
  /** MenuItemSize ID */
  menuItemSizeId: Scalars['ID'];
  /** List of cart item modifiers. */
  modifiers: Array<GCartItemModifierInput>;
  /** Note. */
  note?: InputMaybe<Scalars['String']>;
  /** Quantity */
  quantity: Scalars['Int'];
  /** Expected unit price of MenuItemSize. Item will only be added if its current price matches the expected price. */
  unitPrice: GMoneyInput;
};

/** Data that was provided as mutation input. */
export type GAddCartItemInputEcho = {
  __typename?: 'AddCartItemInputEcho';
  /** MenuItem ID */
  menuItemId: Scalars['ID'];
  /** MenuItemSize ID */
  menuItemSizeId: Scalars['ID'];
  /** List of cart item modifiers. */
  modifiers: Array<GCartItemModifierInputEcho>;
  /** Quantity */
  quantity: Scalars['Int'];
  /** Expected unit price of MenuItemSize. Item will only be added if its current price matches the expected price. */
  unitPrice: GMoney;
};

/** Autogenerated input type of AddFavoriteConsumerOrder */
export type GAddFavoriteConsumerOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Consumer order ID. */
  consumerOrderId: Scalars['ID'];
  /** Icon. */
  icon?: InputMaybe<Scalars['String']>;
  /** Name. */
  name?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of AddFavoriteConsumerOrder */
export type GAddFavoriteConsumerOrderPayload = {
  __typename?: 'AddFavoriteConsumerOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to add the favorite. */
  result: GFavoriteConsumerOrderResult;
};

/** Autogenerated input type of AddItemsToCart */
export type GAddItemsToCartInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Opaque token identifying a specific version of the cart. */
  fingerprint: Scalars['String'];
  /** List of items to add to the cart. */
  items: Array<GAddCartItemInput>;
};

/** Autogenerated return type of AddItemsToCart */
export type GAddItemsToCartPayload = {
  __typename?: 'AddItemsToCartPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to add items to the cart. */
  result: GCartResult;
};

/** Autogenerated input type of AddMicrositeMutation */
export type GAddMicrositeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Google Config Doc for the microsite */
  googleDocUrl?: InputMaybe<Scalars['String']>;
  /** Google Place ID to initialize microsite from */
  googlePlaceId?: InputMaybe<Scalars['String']>;
  /** Optional Odeko UUID of the microsite location */
  locationId?: InputMaybe<Scalars['ID']>;
  /** Time zone for the microsite location */
  timeZone?: InputMaybe<GMicrositeTimeZone>;
  /** Url ID (url param) of the microsite's url */
  urlId: Scalars['ID'];
};

/** Autogenerated return type of AddMicrositeMutation. */
export type GAddMicrositeMutationPayload = {
  __typename?: 'AddMicrositeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  micrositeAdminLocation: GMicrositeLocationAdmin;
};

export type GAddress = {
  __typename?: 'Address';
  /** The first line of the address */
  addressLine1: Scalars['String'];
  /** The second line of the address */
  addressLine2?: Maybe<Scalars['String']>;
  /** The state or province for the address i.e CA */
  adminDistrictLevel1: Scalars['String'];
  /** @deprecated This field is deprecated, please use 'locality' instead. */
  city: Scalars['String'];
  /** The country code for the address i.e US */
  countryCode: Scalars['String'];
  /** The latitude of the address */
  latitude?: Maybe<Scalars['Float']>;
  /** The city for the address i.e New York */
  locality: Scalars['String'];
  /** The longitude of the address */
  longitude?: Maybe<Scalars['Float']>;
  /** The postal code for the address i.e 91711 */
  postalCode: Scalars['String'];
  /** @deprecated This field is deprecated, please use 'admin_district_level_1' instead. */
  state: Scalars['String'];
};

export type GAdmin = {
  __typename?: 'Admin';
  email?: Maybe<Scalars['String']>;
  hubspotOwnerId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type GAgentArtifact = {
  __typename?: 'AgentArtifact';
  byteSize: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  kind: Scalars['String'];
  metadata: Scalars['JSON'];
  sha256: Scalars['String'];
  textPreview?: Maybe<Scalars['String']>;
};

export type GAgentRun = {
  __typename?: 'AgentRun';
  artifacts: Array<GAgentArtifact>;
  createdAt: Scalars['ISO8601DateTime'];
  engine: Scalars['String'];
  engineSessionId?: Maybe<Scalars['String']>;
  errorClass?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  finishedAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  lastHeartbeatAt?: Maybe<Scalars['ISO8601DateTime']>;
  phase: Scalars['String'];
  runtime: Scalars['String'];
  startedAt?: Maybe<Scalars['ISO8601DateTime']>;
  status: Scalars['String'];
  vendorSessionId?: Maybe<Scalars['String']>;
};


export type GAgentRunArtifactsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

/** Structured analytics tags for Algolia search segmentation. */
export type GAlgoliaAnalyticsTagInput = {
  /** Location UUID */
  locationId?: InputMaybe<Scalars['ID']>;
  /** Platform identifier */
  platform?: InputMaybe<GPlatformType>;
  /** Warehouse identifier (e.g., 'DEN1', 'NYC1') */
  warehouse?: InputMaybe<Scalars['String']>;
  /** Warehouse UUID */
  warehouseId?: InputMaybe<Scalars['ID']>;
};

export type GAllowanceRecipient = GNode & {
  __typename?: 'AllowanceRecipient';
  /** Email. */
  email: Scalars['String'];
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
};

/** The connection type for AllowanceRecipient. */
export type GAllowanceRecipientConnection = {
  __typename?: 'AllowanceRecipientConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GAllowanceRecipientEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GAllowanceRecipient>>>;
  /** Information to aid in pagination. */
  pageInfo: GPageInfo;
};

/** An edge in a connection. */
export type GAllowanceRecipientEdge = {
  __typename?: 'AllowanceRecipientEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GAllowanceRecipient>;
};

/** AllowanceRecipient sort criteria */
export type GAllowanceRecipientOrderBy = {
  /** Email. */
  email?: InputMaybe<GOrderByEnum>;
};

export type GAlreadyReportedReason = GUserErrorInterface & {
  __typename?: 'AlreadyReportedReason';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/**
 * Error indicating that an UpdateCartItems mutation failed due to ambiguity
 * introduced by the provided inputs. This can occur if two or more inputs are
 * given for the same cart item, or if an inputs lists the same modifier more than
 * once. Note that we take an all-or-nothing approach when updating cart items, so
 * any ambiguity will abort the entire operation.
 */
export type GAmbiguousCartItemUpdates = GError & {
  __typename?: 'AmbiguousCartItemUpdates';
  /** First UpdateCartItemInput involved in the ambiguity. */
  head: GUpdateCartItemInputEcho;
  /** A description of the error. */
  message: Scalars['String'];
  /** List (possibly empty) of additional UpdateCartItemInput objects involved in the ambiguity. */
  tail: Array<GUpdateCartItemInputEcho>;
};

export type GApplicableFeesItemInput = {
  id: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type GApplicableFeesSkuInput = {
  /** SKU ID */
  id: Scalars['ID'];
  quantity: Scalars['Int'];
};

/** Autogenerated input type of ApplyReward */
export type GApplyRewardInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Opaque token identifying a specific version of the cart. */
  fingerprint: Scalars['String'];
  /** Reward ID. */
  rewardId: Scalars['ID'];
};

/** Autogenerated return type of ApplyReward */
export type GApplyRewardPayload = {
  __typename?: 'ApplyRewardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to apply reward. */
  result: GCartResult;
};

/** Autogenerated input type of ApplyRoutingConfiguration */
export type GApplyRoutingConfigurationInput = {
  /** Whether Routific routes around toll roads. */
  avoidTolls?: InputMaybe<Scalars['Boolean']>;
  /** Whether Routific balances workload across vehicles. */
  balance?: InputMaybe<Scalars['Boolean']>;
  /** Length in minutes of the driver break. 0 is treated as omitted (nothing to set). */
  breakDurationMinutes?: InputMaybe<Scalars['Int']>;
  /** How much of each truck's max capacity to route against, 1-100. 100 is the current configuration. */
  capacityPercent?: InputMaybe<Scalars['Int']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /**
   * Per-cohort on/off + pinned truck counts + stop caps to persist. truckCount
   * pins the cohort's fleet; enabled (when sent) sets its on/off; maxStops (when
   * sent) sets its per-cohort stop cap (null clears it). Omit to leave the
   * warehouse's cohort configuration unchanged.
   */
  cohorts?: InputMaybe<Array<GRoutingCohortInput>>;
  /** Driver shift length in hours. Keeps the shift start and sets the end to start + this many hours. */
  driverShiftHours?: InputMaybe<Scalars['Float']>;
  /**
   * Whether a cohort with no per-cohort stop cap falls back to 25 stops per
   * vehicle. True (default) caps at 25; false routes it uncapped. A set per-cohort
   * maxStops always binds regardless.
   */
  maxStopsPerVehicle?: InputMaybe<Scalars['Boolean']>;
  /** Whether Routific minimizes the number of vehicles used. */
  minVehicles?: InputMaybe<Scalars['Boolean']>;
  /** Allowed overtime in minutes. 0 means none. */
  overtimeMinutes?: InputMaybe<Scalars['Int']>;
  /**
   * Routing rule overrides to persist, keyed by rule id, e.g. {
   * "frozen_items_first": { "enabled": true, "hours": 1 } }. Omit to leave the
   * warehouse's rules unchanged.
   */
  rules?: InputMaybe<Scalars['JSON']>;
  /** Whether Routific optimizes for shortest distance rather than time. */
  shortestDistance?: InputMaybe<Scalars['Boolean']>;
  /** Whether the nightly 3PD (Metrobi) auto-marking sweep runs for this warehouse. */
  thirdPartyEnabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * Per-vehicle-type fleet composition (count + capacity percent) to persist. Only
   * honored when multi-fleet is enabled for the warehouse; ignored otherwise. Omit
   * to leave the fleet composition unchanged; an empty list clears it.
   */
  vehicles?: InputMaybe<Array<GFleetVehicleInput>>;
  /** Routific visit-balance coefficient (>= 0). 0 disables balancing by coefficient. */
  visitBalanceCoefficient?: InputMaybe<Scalars['Float']>;
  /** Warehouse whose standing configuration to write. */
  warehouseId: Scalars['ID'];
};

/** Autogenerated return type of ApplyRoutingConfiguration. */
export type GApplyRoutingConfigurationPayload = {
  __typename?: 'ApplyRoutingConfigurationPayload';
  /** True when the apply ran without error (including a no-op re-apply). */
  applied: Scalars['Boolean'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userErrors: Array<GRoutingConfigurationError>;
};

export type GAppointmentInPast = GUserErrorInterface & {
  __typename?: 'AppointmentInPast';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of ApproveCutoffDiscrepancy */
export type GApproveCutoffDiscrepancyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  locationsVendorId: Scalars['ID'];
};

/** Autogenerated return type of ApproveCutoffDiscrepancy. */
export type GApproveCutoffDiscrepancyPayload = {
  __typename?: 'ApproveCutoffDiscrepancyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  cutoffDiscrepancyApproval?: Maybe<GCutoffDiscrepancyApproval>;
  errors: Array<GUserError>;
};

export type GArAssignableUser = {
  __typename?: 'ArAssignableUser';
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
};

export type GArAssignment = {
  __typename?: 'ArAssignment';
  assignedByUuid?: Maybe<Scalars['String']>;
  assigneeUuid: Scalars['String'];
  companyUuid: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type GArtworkUpload = {
  __typename?: 'ArtworkUpload';
  key: Scalars['String'];
  publicUrl: Scalars['String'];
  url: Scalars['String'];
};

/** Autogenerated input type of AssignCustomerTagMutation */
export type GAssignCustomerTagMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Odeko UUID of the location to tag. */
  locationId: Scalars['ID'];
  /** Id of the tag to apply, as returned by CustomerTag.id. */
  tagId: Scalars['ID'];
};

/** Autogenerated return type of AssignCustomerTagMutation. */
export type GAssignCustomerTagMutationPayload = {
  __typename?: 'AssignCustomerTagMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  location?: Maybe<GLocation>;
};

export type GAssociateBadgePayload = {
  __typename?: 'AssociateBadgePayload';
  /** ARMHR employee code, for display. Not part of the QR payload. */
  associateId: Scalars['String'];
  /** WarehouseAssociate id. */
  employeeId: Scalars['ID'];
  name: Scalars['String'];
  /**
   * Newline-delimited badge QR contents: RF-SMART login and password (when a
   * credential exists) stacked above the associate's id (the employeeId uuid),
   * which is always the last line and is the identity the public self-* operations
   * accept. Carries a live password — handle accordingly.
   */
  payload: Scalars['String'];
};

export type GAttachment = {
  __typename?: 'Attachment';
  attachmentCategory: Scalars['String'];
  /**
   * Where and when the driver app took the photo. Admin only; null for other
   * callers and for photos the app sent no capture details for.
   */
  captureDetails?: Maybe<GPhotoCaptureDetails>;
  /**
   * False when the photo-quality check judged the photo unusable; customer
   * surfaces hide it. Staff surfaces show every photo. Unclassified, refused and
   * errored photos are visible, and every photo is visible while the
   * photo_quality_customer_hiding flag is off.
   */
  customerVisible: Scalars['Boolean'];
  id: Scalars['ID'];
  objectKey: Scalars['String'];
  /**
   * Staff only: what the photo-quality classifier concluded, independent of the
   * hiding flag. HIDDEN with customerVisible true means shadow mode.
   */
  qualityStatus?: Maybe<GAttachmentQualityStatus>;
  url: Scalars['String'];
};

/** What the photo-quality classifier concluded about a photo (PhotoQuality::Verdict), independent of the customer-hiding flag. */
export enum GAttachmentQualityStatus {
  /** Every classification attempt failed; stays visible. */
  Error = 'ERROR',
  /** Scored unusable; hidden from customers once the hiding flag is on. */
  Hidden = 'HIDDEN',
  /** Classified and not flagged. */
  Ok = 'OK',
  /** The model declined to judge it; stays visible. */
  Refused = 'REFUSED',
  /** No decision yet for the current prompt version. */
  Unclassified = 'UNCLASSIFIED'
}

/** Autogenerated input type of AttachmentUrlPresignerCreate */
export type GAttachmentUrlPresignerCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of AttachmentUrlPresignerCreate. */
export type GAttachmentUrlPresignerCreatePayload = {
  __typename?: 'AttachmentUrlPresignerCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  objectKey?: Maybe<Scalars['String']>;
  presignedReadUrl?: Maybe<Scalars['String']>;
  presignedUrl?: Maybe<Scalars['String']>;
  userErrors: Array<GPresignerError>;
};

export type GAuditLog = {
  __typename?: 'AuditLog';
  causedBy: GAuditLogCausedBy;
  changeType: GAuditLogChangeType;
  date: Scalars['ISO8601DateTime'];
  field: Scalars['String'];
  id: Scalars['ID'];
  itemId?: Maybe<Scalars['ID']>;
  newValue: Scalars['String'];
  objectId: Scalars['String'];
  objectType: Scalars['String'];
  oldValue: Scalars['String'];
  user?: Maybe<GUser>;
};

export enum GAuditLogCausedBy {
  Graphql = 'GRAPHQL',
  Job = 'JOB',
  Kafka = 'KAFKA',
  User = 'USER',
  UserImport = 'USER_IMPORT'
}

export enum GAuditLogChangeType {
  Delete = 'DELETE',
  New = 'NEW',
  Set = 'SET'
}

export type GAuditLogConnection = {
  __typename?: 'AuditLogConnection';
  edges: Array<Maybe<GAuditLogEdge>>;
  nodes: Array<Maybe<GAuditLog>>;
  pageInfo: GPageInfo;
};

export type GAuditLogEdge = {
  __typename?: 'AuditLogEdge';
  cursor: Scalars['String'];
  node: GAuditLog;
};

export type GAuditLogInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type GAuditLogObjectInput = {
  id: Scalars['ID'];
  type: Scalars['String'];
};

export enum GAuditLogSortOrder {
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC'
}

export type GAuditReputation = {
  __typename?: 'AuditReputation';
  googleLocationId: Scalars['String'];
  last7Days: GTimePeriod;
  last14Days: GTimePeriod;
  last30Days: GTimePeriod;
  rating: GRating;
  reviewSentiments: GReviewSentiments;
  reviews: Array<GReview>;
  timeseries: Array<GTimeseriesEntry>;
};

/** Underlying audited model a changeHistory event came from. */
export enum GAuditResourceKind {
  /** Versions on the line-level reason rows attached to the OrderLine. */
  LineLevelDeliveryIssue = 'LINE_LEVEL_DELIVERY_ISSUE',
  /** Versions on the OrderLine row itself (delivered_quantity, fulfillment_quantity, recovery_quantity once it lands). */
  OrderLine = 'ORDER_LINE'
}

export type GAuthorizeUrl = {
  __typename?: 'AuthorizeUrl';
  url: Scalars['String'];
};

export type GAutomatedRoutingExclusion = {
  __typename?: 'AutomatedRoutingExclusion';
  /** The location associated with the excluded stop */
  locationId: Scalars['ID'];
  /** The location name captured when the run input was built */
  locationName?: Maybe<Scalars['String']>;
  reason: GAutomatedRoutingExclusionReason;
  /** The delivery route stop excluded from this run */
  stopId: Scalars['ID'];
};

export enum GAutomatedRoutingExclusionReason {
  /** The location had automated routing turned off when this run's input was built. */
  AutomatedRoutingDisabled = 'automated_routing_disabled'
}

export type GAutomatedRoutingPending = GUserErrorInterface & {
  __typename?: 'AutomatedRoutingPending';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GAutomaticDiscount = {
  __typename?: 'AutomaticDiscount';
  /** Discount applied from this automatic discount */
  discount: GMoney;
  /** Voucherify ID of automatic discount */
  id: Scalars['String'];
  /** Name of the automatic discount in Voucherify */
  name: Scalars['String'];
  /** The number of times the automatic discount can be redeemed (or null, if unlimited). */
  redemptionsAvailable?: Maybe<Scalars['Int']>;
};

export type GAvailabilityInterval = {
  /** Lower bound. */
  lowerBound: Scalars['ISO8601DateTime'];
  /** Upper bound. */
  upperBound: Scalars['ISO8601DateTime'];
};

/** A delivery day available for delivery for a location */
export type GAvailableDeliveryDay = {
  __typename?: 'AvailableDeliveryDay';
  /** The day name (e.g., "Monday", "Tuesday") */
  dayName: Scalars['String'];
  /** The day of the week as an integer (0=Sunday, 1=Monday, ..., 6=Saturday) */
  dayOfWeek: Scalars['Int'];
  /** Lead time in days from order to delivery */
  leadTime: Scalars['Int'];
  /** The next available delivery date for this day/vendor combination */
  nextDeliveryDate?: Maybe<Scalars['ISO8601Date']>;
  /** Order deadline time for this delivery day (e.g., "10:00"), also known as the order cutoff time */
  orderDeadline: Scalars['String'];
  /** The vendor associated with this delivery day */
  vendor: GVendor;
};

export type GAvailableInterval = GAvailabilityInterval & {
  __typename?: 'AvailableInterval';
  /** Lower bound. */
  lowerBound: Scalars['ISO8601DateTime'];
  /** Upper bound. */
  upperBound: Scalars['ISO8601DateTime'];
};

export type GBackInStockNotification = {
  __typename?: 'BackInStockNotification';
  acknowledgedAt?: Maybe<Scalars['ISO8601DateTime']>;
  backInStockAt: Scalars['ISO8601DateTime'];
  desiredQuantity: Scalars['Int'];
  item: GSupplyItem;
  /** The location's SKU for the notification's product, if one exists. */
  sku?: Maybe<GSku>;
  subscription: GBackInStockSubscription;
  user: GUser;
};

export type GBackInStockSubscription = {
  __typename?: 'BackInStockSubscription';
  backInStockAt?: Maybe<Scalars['ISO8601DateTime']>;
  createdAt: Scalars['ISO8601DateTime'];
  desiredQuantity: Scalars['Int'];
  id: Scalars['ID'];
  item: GSupplyItem;
  notificationAcknowledgedAt?: Maybe<Scalars['ISO8601DateTime']>;
  updatedAt: Scalars['ISO8601DateTime'];
  user: GUser;
};

/**
 * Error indicating that a mutation failed due to a bad payment processor request.
 * This occurs when expired, unsupported, or otherwise invalid payment details are
 * provided. The request should not be retried until the problem is corrected.
 */
export type GBadPaymentProcessorRequestError = GError & {
  __typename?: 'BadPaymentProcessorRequestError';
  /** A code characterizing the type of error. */
  code: Scalars['String'];
  /** A description of the error. */
  message: Scalars['String'];
};

export type GBankAccount = {
  __typename?: 'BankAccount';
  bankName: Scalars['String'];
  /**
   * Locations for which this payment method is currently the default. Lists every
   * such location, including ones the viewer is not individually assigned to, so a
   * caller can state the true scope of removing the method. Empty when the method
   * is nobody's default.
   */
  defaultForLocations: Array<GPaymentMethodDefaultLocation>;
  id: Scalars['ID'];
  last4: Scalars['String'];
  lastPaymentError?: Maybe<GPaymentError>;
};

export type GBaseBrandedItem = {
  /** Colors that are available for the item */
  baseBrandedItemColors: Array<GBaseBrandedItemColor>;
  /** Quantity ranges that differentiate price breaks for the item */
  baseBrandedItemQuantityRanges: Array<GBaseBrandedItemQuantityRange>;
  baseColor?: Maybe<GColor>;
  bottomLayerColor?: Maybe<GColor>;
  /** Artwork options for the item */
  brandedItemArtworks: Array<GBrandedItemArtwork>;
  category: GCategory;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrls: Array<Scalars['String']>;
  itemSizeLabel?: Maybe<Scalars['String']>;
  materialType?: Maybe<Scalars['String']>;
  maxOrderQty?: Maybe<Scalars['Int']>;
  minOrderQty: Scalars['Int'];
  name: Scalars['String'];
  printingMethod: GPrintingMethod;
  purchaseMultiple: Scalars['Int'];
  salesUnit: GUnit;
  shape?: Maybe<Scalars['String']>;
  subcategory: GCategory;
  wallType?: Maybe<Scalars['String']>;
  /** Warehouses the item is available in */
  warehouseBaseBrandedItems: Array<GWarehouseBaseBrandedItem>;
};

export type GBaseBrandedItemColor = {
  __typename?: 'BaseBrandedItemColor';
  centsPerSaleUnit?: Maybe<Scalars['Int']>;
  color: GColor;
  hexCode: Scalars['String'];
  id: Scalars['ID'];
  position: Scalars['Int'];
};

export type GBaseBrandedItemColorInput = {
  /** The cents price of the color per sale unit */
  centsPerSaleUnit?: InputMaybe<Scalars['Int']>;
  /** the id of the color to be used in base branded item color */
  id: Scalars['ID'];
};

export type GBaseBrandedItemInput = {
  /** Base color of the item */
  baseColor?: InputMaybe<Scalars['ID']>;
  /** Bottom layer color of the item */
  bottomLayerColor?: InputMaybe<Scalars['ID']>;
  /** Item's category */
  category: Scalars['ID'];
  /** Colors that are available for the item, including color price */
  colors: Array<GBaseBrandedItemColorInput>;
  /** Description of item */
  description?: InputMaybe<Scalars['String']>;
  /** Images for item */
  imageUrls?: InputMaybe<Array<Scalars['String']>>;
  /** Size label of the item (e.g. '16oz', '10-24oz') */
  itemSizeLabel?: InputMaybe<Scalars['String']>;
  /** Material type of the item (e.g. 'Compostable') */
  materialType?: InputMaybe<Scalars['String']>;
  maxOrderQty?: InputMaybe<Scalars['Int']>;
  minOrderQty: Scalars['Int'];
  /** Name of the base branded item */
  name: Scalars['String'];
  purchaseMultiple: Scalars['Int'];
  /** Quantity ranges that differentiate price breaks for the item */
  quantityRanges: Array<GBaseBrandedItemQuantityRangeInput>;
  /** Units item sold in */
  salesUnit: Scalars['ID'];
  /** Shape of the item */
  shape?: InputMaybe<Scalars['String']>;
  /** Item's subcategory */
  subcategory: Scalars['ID'];
  /** Wall type of the item (e.g. 'Double Wall') */
  wallType?: InputMaybe<Scalars['String']>;
  /** Warehouses the item is available in */
  warehouses: Array<GWarehouseBaseBrandedItemInput>;
};

export type GBaseBrandedItemQuantityRange = {
  __typename?: 'BaseBrandedItemQuantityRange';
  endQuantity?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  startQuantity: Scalars['Int'];
};

export type GBaseBrandedItemQuantityRangeInput = {
  endQuantity?: InputMaybe<Scalars['Int']>;
  startQuantity: Scalars['Int'];
};

/** Autogenerated input type of BatchOnboardInProgressCustomersMutation */
export type GBatchOnboardInProgressCustomersMutationInput = {
  acquisitionConversionId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Onboard exactly these records. Selecting a failed record is the decision to retry it. */
  inProgressCustomerIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Cap on how many records the run will onboard. Absent, it drains every eligible record. */
  limit?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of BatchOnboardInProgressCustomersMutation. */
export type GBatchOnboardInProgressCustomersMutationPayload = {
  __typename?: 'BatchOnboardInProgressCustomersMutationPayload';
  batchOnboardRun?: Maybe<GBatchOnboardRun>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Records handed off on the first tick. */
  enqueuedCount?: Maybe<Scalars['Int']>;
  errors: Array<Scalars['String']>;
  /** Eligible records the later ticks will pick up. */
  remainingEligibleCount?: Maybe<Scalars['Int']>;
  /** A stalled run this one retired on the way in. */
  retiredRun?: Maybe<GBatchOnboardRun>;
};

/** One triggered batch of in-progress customers moving from ready to onboarded. */
export type GBatchOnboardRun = {
  __typename?: 'BatchOnboardRun';
  finished: Scalars['Boolean'];
  /** Set once every record the run handed off has left the pipeline, or when an operator stopped it. */
  finishedAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  requestedBy: Scalars['String'];
  /** How many records the run set out to onboard. */
  requestedCount: Scalars['Int'];
  /** Unfinished with no tick inside the staleness window: its schedule was lost. Retire it, or start a new run over it. */
  stalled: Scalars['Boolean'];
  startedAt: Scalars['ISO8601DateTime'];
};

export type GBatchedDeposit = GNode & {
  __typename?: 'BatchedDeposit';
  /** Gross earnings for the period, in cents */
  earnedSubtotalCents?: Maybe<Scalars['Int']>;
  /** Currency code of gross earnings */
  earnedSubtotalCurrency: Scalars['String'];
  /** Memo describing the deposit */
  externalMemo?: Maybe<Scalars['String']>;
  /** End of the period deposits were batched for */
  for: Scalars['ISO8601Date'];
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
  /** Transaction id last fetched from the payment processor */
  lastKnownTransactionId?: Maybe<Scalars['String']>;
  /** Transaction status last fetched from the payment processor */
  lastKnownTransactionStatus?: Maybe<Scalars['String']>;
  /** Merchant deposits were batched for */
  merchant: GMerchant;
  /** Amount deducted to pay down merchant's outstanding balance, in cents */
  outstandingCents?: Maybe<Scalars['Int']>;
  /** Currency code of amount deducted */
  outstandingCurrency: Scalars['String'];
  /** Type of period deposits were batched for */
  period: GBatchedDepositPeriodEnum;
  /** When the deposit was submitted to the payment processor */
  submittedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Net amount deposited in merchant's account, in cents */
  totalCents?: Maybe<Scalars['Int']>;
  /** Currency code of net amount */
  totalCurrency: Scalars['String'];
};

/** The connection type for BatchedDeposit. */
export type GBatchedDepositConnection = {
  __typename?: 'BatchedDepositConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GBatchedDepositEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GBatchedDeposit>>>;
  /** Information to aid in pagination. */
  pageInfo: GPageInfo;
};

/** An edge in a connection. */
export type GBatchedDepositEdge = {
  __typename?: 'BatchedDepositEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GBatchedDeposit>;
};

/** BatchedDeposit sort criteria */
export type GBatchedDepositOrderBy = {
  /** End of the period deposits were batched for */
  for?: InputMaybe<GOrderByEnum>;
};

/** BatchedDeposit period values */
export enum GBatchedDepositPeriodEnum {
  /** Deposits batched daily */
  Daily = 'daily',
  /** Single, non-recurring batch */
  OneOff = 'one_off',
  /** Deposits batched weekly */
  Weekly = 'weekly'
}

/** A per-bay grid-unit offset that nudges one bay off its computed run cell within a source-backed group. */
export type GBayOffset = {
  __typename?: 'BayOffset';
  /** Bay number within the group (stable across bay_order flip). */
  bay: Scalars['Int'];
  /** Grid cells to shift the bay horizontally. */
  dx: Scalars['Int'];
  /** Grid cells to shift the bay vertically. */
  dy: Scalars['Int'];
};

/** A per-bay grid-unit offset to persist. A bay with no entry sits at its computed run cell. */
export type GBayOffsetInput = {
  /** Bay number within the group. */
  bay: Scalars['Int'];
  /** Grid cells to shift the bay horizontally. */
  dx: Scalars['Int'];
  /** Grid cells to shift the bay vertically. */
  dy: Scalars['Int'];
};

export type GBillingDetails = {
  __typename?: 'BillingDetails';
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export enum GBillingStatus {
  BelowMinimumCharge = 'BELOW_MINIMUM_CHARGE',
  ExceededFailureLimit = 'EXCEEDED_FAILURE_LIMIT',
  ExceededMaximumCharge = 'EXCEEDED_MAXIMUM_CHARGE',
  InconsistentData = 'INCONSISTENT_DATA',
  Ok = 'OK',
  TerminalError = 'TERMINAL_ERROR',
  TransientError = 'TRANSIENT_ERROR'
}

/** Interpreted bin family. `unrecognized` is the explicit fallback for names we can't parse. */
export enum GBinFamily {
  Bulk = 'BULK',
  Endcap = 'ENDCAP',
  Rack = 'RACK',
  Special = 'SPECIAL',
  Staging = 'STAGING',
  Unrecognized = 'UNRECOGNIZED'
}

/** An ordered group of interpreted bins — an aisle for racks/end-caps, or a single family group (e.g. ABULK). */
export type GBinGroup = {
  __typename?: 'BinGroup';
  bins: Array<GInterpretedBin>;
  family: GBinFamily;
  /** Aisle letter for racks/end-caps; the family token otherwise (e.g. ABULK, DOCK). */
  key: Scalars['String'];
};

export enum GBinTransferCommandStatus {
  CreatedAwaitingConfirmation = 'CREATED_AWAITING_CONFIRMATION',
  Dispatching = 'DISPATCHING',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Published = 'PUBLISHED',
  ReconciliationNeeded = 'RECONCILIATION_NEEDED',
  Succeeded = 'SUCCEEDED',
  Superseded = 'SUPERSEDED'
}

export type GBlankNote = GUserErrorInterface & {
  __typename?: 'BlankNote';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GBrandedItemArtwork = {
  __typename?: 'BrandedItemArtwork';
  artworkUri: Scalars['String'];
  colorNotes?: Maybe<Scalars['String']>;
  company: GCompany;
  id: Scalars['ID'];
  notes?: Maybe<Scalars['String']>;
};

export enum GBrandedItemCatalogStatus {
  InCatalog = 'in_catalog',
  NotInCatalog = 'not_in_catalog'
}

export type GBrandedItemDeal = {
  __typename?: 'BrandedItemDeal';
  brandedItemDealItems: Array<GBrandedItemDealItem>;
  createdAt: Scalars['ISO8601DateTime'];
  discountPercent: Scalars['Int'];
  hubspotDealId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  location: GLocation;
  status: Scalars['String'];
  subtotal: GMoney;
};

export type GBrandedItemDealInput = {
  /** Branded item deal items */
  brandedItemDealItems: Array<GBrandedItemDealItemInput>;
  /** Hubspot deal id */
  hubspotDealId?: InputMaybe<Scalars['String']>;
  /** Is doordash deal */
  isDoordash?: InputMaybe<Scalars['Boolean']>;
  /** Location uuid of the branded item deal */
  locationUuid: Scalars['String'];
  /** Status of the branded item deal */
  status?: InputMaybe<Scalars['String']>;
  /** Subtotal of the branded item deal */
  subtotal: GMoneyInput;
};

export type GBrandedItemDealItem = {
  __typename?: 'BrandedItemDealItem';
  customBrandedItem: GCustomBrandedItem;
  id: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type GBrandedItemDealItemInput = {
  /** Custom branded item */
  customBrandedItem: GCustomBrandedItemInput;
  /** Quantity of the branded item */
  quantity: Scalars['Int'];
};

/** Autogenerated input type of BulkCreateSupplierInvoiceComparisonRows */
export type GBulkCreateSupplierInvoiceComparisonRowsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  comparisonId: Scalars['ID'];
  rows: Array<GSupplierInvoiceComparisonParsedRowInput>;
};

/** Autogenerated return type of BulkCreateSupplierInvoiceComparisonRows. */
export type GBulkCreateSupplierInvoiceComparisonRowsPayload = {
  __typename?: 'BulkCreateSupplierInvoiceComparisonRowsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  rowMappings: Array<GSupplierInvoiceComparisonRowMapping>;
  supplierInvoiceComparison?: Maybe<GSupplierInvoiceComparison>;
};

export type GBulkItemError = GUserErrorInterface & {
  __typename?: 'BulkItemError';
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GBulkUpdateDeprecated = GUserErrorInterface & {
  __typename?: 'BulkUpdateDeprecated';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of BulkUpdateRouteStopsDeliveryInfo */
export type GBulkUpdateRouteStopsDeliveryInfoInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Delivery route id. */
  deliveryRouteId: Scalars['ID'];
  /** Whether to send email notifications for delivered orders. */
  triggerEmail?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of BulkUpdateRouteStopsDeliveryInfo. */
export type GBulkUpdateRouteStopsDeliveryInfoPayload = {
  __typename?: 'BulkUpdateRouteStopsDeliveryInfoPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  route?: Maybe<GRoute>;
  userErrors: Array<GRouteError>;
};

/** Autogenerated input type of BulkUpsertZipcodeDeliveryRules */
export type GBulkUpsertZipcodeDeliveryRulesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The per-weekday rules to apply. Days not present are removed from each zipcode. */
  deliveryRules: Array<GZipcodeDeliveryRuleInput>;
  /** An optional delivery window to apply to every zipcode. */
  deliveryWindow?: InputMaybe<GZipcodeDeliveryWindowInput>;
  /** The zipcodes to apply the delivery rules to */
  zipcodes: Array<Scalars['String']>;
};

/** Autogenerated return type of BulkUpsertZipcodeDeliveryRules. */
export type GBulkUpsertZipcodeDeliveryRulesPayload = {
  __typename?: 'BulkUpsertZipcodeDeliveryRulesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GUserError>;
  results: Array<GBulkZipcodeDeliveryRuleResult>;
};

export type GBulkZipcodeDeliveryRuleResult = {
  __typename?: 'BulkZipcodeDeliveryRuleResult';
  /** Errors for this zipcode, if any */
  errors: Array<GUserError>;
  /** Whether the rules were applied to this zipcode */
  success: Scalars['Boolean'];
  /** The zipcode this result is for */
  zipcode: Scalars['String'];
};

export type GBusiness = GNode & {
  __typename?: 'Business';
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
};

/** Input of a Business Search */
export type GBusinessSearchInput = {
  /** Globally unique ID */
  id: Scalars['ID'];
};

export type GBuyNowPayLater = {
  __typename?: 'BuyNowPayLater';
  borrower: GBuyNowPayLaterBorrower;
  /**
   * Locations for which this payment method is currently the default. Lists every
   * such location, including ones the viewer is not individually assigned to, so a
   * caller can state the true scope of removing the method. Empty when the method
   * is nobody's default.
   */
  defaultForLocations: Array<GPaymentMethodDefaultLocation>;
  id: Scalars['ID'];
  lastPaymentError?: Maybe<GPaymentError>;
  lender: Scalars['String'];
};

export type GBuyNowPayLaterBorrower = {
  __typename?: 'BuyNowPayLaterBorrower';
  obfuscatedEmail: Scalars['String'];
};

export type GByRating = {
  __typename?: 'ByRating';
  r1: Scalars['Int'];
  r2: Scalars['Int'];
  r3: Scalars['Int'];
  r4: Scalars['Int'];
  r5: Scalars['Int'];
};

export type GCalculateShippingSkuInput = {
  /** Numeric SKU ID */
  id: Scalars['ID'];
  quantity: Scalars['Int'];
};

/** Autogenerated input type of CancelOrderMutation */
export type GCancelOrderMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** UUID of the order to cancel */
  orderId: Scalars['ID'];
};

/** Autogenerated return type of CancelOrderMutation. */
export type GCancelOrderMutationPayload = {
  __typename?: 'CancelOrderMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GError>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of CancelProviderRoute */
export type GCancelProviderRouteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The dispatched route to cancel on the provider. */
  routeId: Scalars['ID'];
};

/** Autogenerated return type of CancelProviderRoute. */
export type GCancelProviderRoutePayload = {
  __typename?: 'CancelProviderRoutePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  route?: Maybe<GRoute>;
  userErrors: Array<GThirdPartyDispatchError>;
};

/** Autogenerated input type of CancelProvisionalOrderMutation */
export type GCancelProvisionalOrderMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The version the caller last saw, so a cancel cannot race an edit it has not seen. */
  expectedVersion: Scalars['Int'];
  id: Scalars['ID'];
};

/** Autogenerated return type of CancelProvisionalOrderMutation. */
export type GCancelProvisionalOrderMutationPayload = {
  __typename?: 'CancelProvisionalOrderMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GProvisionalOrderError>;
  provisionalOrder?: Maybe<GProvisionalOrder>;
};

export type GCandidateDockWindow = {
  __typename?: 'CandidateDockWindow';
  dock: GDock;
  /** How far over the window's cap one more booking would push it. <= 0 means the window still has room. */
  overCapBy: Scalars['Int'];
  window: GDockWindow;
};

export type GCarrierNameRequired = GUserErrorInterface & {
  __typename?: 'CarrierNameRequired';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** Shopping cart */
export type GCart = {
  __typename?: 'Cart';
  /** Consumer app user service fee. */
  appUserServiceFee: GMoney;
  /** Items in the cart. */
  cartItems: Array<GCartItem>;
  /** Delivery fee. */
  deliveryFee: GMoney;
  /** Opaque token identifying a specific version of the cart. */
  fingerprint: Scalars['String'];
  /**
   * Merchant. When the cart is empty, this field is null. When the cart contains
   * one or more items, this field reflects the merchant who sells those items.
   * Note that the cart cannot contain items from multiple merchants.
   */
  merchant?: Maybe<GMerchant>;
  /** Pickup schedule. Null if cart is empty. */
  pickupSchedule?: Maybe<GPickupSchedule>;
  /** Reward. */
  reward?: Maybe<GReward>;
  /** Reward value. */
  rewardValue: GMoney;
  /** Subtotal. */
  subtotal: GMoney;
  /** Tax. */
  tax: GMoney;
  /** Tip. */
  tip: GMoney;
  /** Total. */
  total: GMoney;
};


/** Shopping cart */
export type GCartPickupScheduleArgs = {
  asOf?: InputMaybe<Scalars['ISO8601DateTime']>;
};

/** Result of a Cart mutation that failed due to a concurrently running checkout request. */
export type GCartCheckoutInFlightError = GError & {
  __typename?: 'CartCheckoutInFlightError';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Item in shopping cart. */
export type GCartItem = GNode & {
  __typename?: 'CartItem';
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
  /** Menu item. Null if the merchant has removed the item from their menu. */
  menuItem?: Maybe<GMenuItem>;
  /** Menu item size. Null if the merchant removed the size from their menu. */
  menuItemSize?: Maybe<GMenuItemSize>;
  /** Cart item modifiers. */
  modifiers: Array<GCartItemModifier>;
  /** Note. */
  note?: Maybe<Scalars['String']>;
  /** Quantity. */
  quantity: Scalars['Int'];
  /** Unit price for menu item size (not including modifiers). */
  unitPrice: GMoney;
};

/** Cart item modifier. */
export type GCartItemModifier = GNode & {
  __typename?: 'CartItemModifier';
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
  /** Menu item modifier group. Null if the merchant has removed the group from their menu. */
  menuItemModifierGroup?: Maybe<GMenuItemModifierGroup>;
  /** Menu item modifier option. Null if the merchant has removed the option from their menu. */
  menuItemModifierOption?: Maybe<GMenuItemModifierOption>;
  /** Quantity. */
  quantity: Scalars['Int'];
  /** Unit price for menu item modifier option. */
  unitPrice: GMoney;
};

/**
 * Error indicating that a mutation failed because an item in the cart references a
 * modifier group that could not be found on the menu. This can occur if the menu
 * has changed since the item was added to the cart.
 */
export type GCartItemModifierGroupNotFound = GError & {
  __typename?: 'CartItemModifierGroupNotFound';
  /** ID of the menu item modifier group that could not be found. */
  menuItemModifierGroupId: Scalars['ID'];
  /** A description of the error. */
  message: Scalars['String'];
};

/** Input for a cart item modifier. */
export type GCartItemModifierInput = {
  /** MenuItemModifierGroup ID */
  menuItemModifierGroupId: Scalars['ID'];
  /** MenuItemModifierOption ID */
  menuItemModifierOptionId: Scalars['ID'];
  /** Quantity */
  quantity: Scalars['Int'];
  /** Expected unit price of modifier. Modifier will only be added if its current price matches the expected price. */
  unitPrice: GMoneyInput;
};

/** Data that was provided as mutation input. */
export type GCartItemModifierInputEcho = {
  __typename?: 'CartItemModifierInputEcho';
  /** MenuItemModifierGroup ID */
  menuItemModifierGroupId: Scalars['ID'];
  /** MenuItemModifierOption ID */
  menuItemModifierOptionId: Scalars['ID'];
  /** Quantity */
  quantity: Scalars['Int'];
  /** Expected unit price of modifier. Modifier will only be added if its current price matches the expected price. */
  unitPrice: GMoney;
};

/**
 * Error indicating that a mutation failed because an item in the cart references a
 * modifier option that could not be found on the menu. This can occur if the menu
 * has changed since the item was added to the cart.
 */
export type GCartItemModifierOptionNotFound = GError & {
  __typename?: 'CartItemModifierOptionNotFound';
  /** ID of the menu item modifier option that could not be found. */
  menuItemModifierOptionId: Scalars['ID'];
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating that a Cart mutation failed to add an item. */
export type GCartItemNotAdded = GError & {
  __typename?: 'CartItemNotAdded';
  /**
   * AddCartItemInput data that caused the error. Note that we take an
   * all-or-nothing approach when adding items to the cart, so one failed item
   * aborts the entire operation.
   */
  input: GAddCartItemInputEcho;
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating that a mutation failed because an item is not available at the requested pickup time. */
export type GCartItemNotAvailable = GError & {
  __typename?: 'CartItemNotAvailable';
  /** Menu item. */
  menuItem: GMenuItem;
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating that a Cart mutation failed to update an item. */
export type GCartItemNotUpdated = GError & {
  __typename?: 'CartItemNotUpdated';
  /**
   * UpdateCartItemInput data that caused the error. Note that we take an
   * all-or-nothing approach to updating items in the cart, so one failed item
   * aborts the entire operation.
   */
  input: GUpdateCartItemInputEcho;
  /** A description of the error. */
  message: Scalars['String'];
};

/**
 * Error indicating that a mutation failed because an item in the cart references a
 * size that could not be found on the menu. This can occur if the menu has changed
 * since the item was added to the cart.
 */
export type GCartItemSizeNotFound = GError & {
  __typename?: 'CartItemSizeNotFound';
  /** ID of the menu item size that could not be found. */
  menuItemSizeId: Scalars['ID'];
  /** A description of the error. */
  message: Scalars['String'];
};

/**
 * Error indicating that a mutation failed because an item in the cart could not be
 * found on the menu. This can occur if the menu has changed since the item was
 * added to the cart.
 */
export type GCartMenuItemNotFound = GError & {
  __typename?: 'CartMenuItemNotFound';
  /** ID of the menu item that could not be found. */
  menuItemId: Scalars['ID'];
  /** A description of the error. */
  message: Scalars['String'];
};

/** Result of a Cart mutation that failed due to items from multiple merchants. */
export type GCartMerchantMismatchError = GError & {
  __typename?: 'CartMerchantMismatchError';
  /** Relevant menu item IDs grouped by merchant. */
  byMerchant: Array<GMenuItemsForMerchant>;
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating that a Cart mutation failed to save the cart. */
export type GCartNotSaved = GError & {
  __typename?: 'CartNotSaved';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Result of a Cart mutation that failed because no available pickup times could be found. */
export type GCartPickupUnavailableError = GError & {
  __typename?: 'CartPickupUnavailableError';
  /** A description of the error. */
  message: Scalars['String'];
  /** Pickup schedule. */
  pickupSchedule: GPickupSchedule;
};

/** Cart mutation result. */
export type GCartResult = GCartSuccess | GErrorsResult;

/** Result of a successful Cart mutation. */
export type GCartSuccess = {
  __typename?: 'CartSuccess';
  /** Resulting cart. */
  cart: GCart;
};

export type GCatalogFilter = {
  __typename?: 'CatalogFilter';
  itemTags: GItemTagConnection;
};


export type GCatalogFilterItemTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<GItemTagFiltersInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Array<InputMaybe<GItemTagSortOrder>>>;
};

export type GCatalogFilterSelectedInput = {
  catalogStatus?: InputMaybe<GCatalogStatus>;
  categories?: InputMaybe<Array<InputMaybe<GItemsCategoryInput>>>;
  subcategories?: InputMaybe<Array<InputMaybe<GItemsSubcategoryInput>>>;
  warehouses?: InputMaybe<Array<GItemsWarehouseInput>>;
};

export type GCatalogHomepageComponent = GCollectionBanner | GCollectionCarousel | GCollectionHighlightCarousel;

export type GCatalogHomepageEntry = {
  __typename?: 'CatalogHomepageEntry';
  component: GCatalogHomepageComponent;
  position: Scalars['String'];
};

export enum GCatalogStatus {
  InCatalog = 'IN_CATALOG',
  NotInCatalog = 'NOT_IN_CATALOG'
}

export enum GCategoriesFilter {
  TopLevel = 'TOP_LEVEL'
}

export enum GCategoriesSortOrder {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  PositionAsc = 'POSITION_ASC',
  PositionDesc = 'POSITION_DESC',
  PositionTreeAsc = 'POSITION_TREE_ASC',
  PositionTreeDesc = 'POSITION_TREE_DESC'
}

export type GCategory = {
  __typename?: 'Category';
  /** Markets where something is stocked under this category, as either its category or its subcategory. */
  activeWarehouses: Array<GCollectionsHomepageEntryWarehouse>;
  /**
   * The banner to show above this category's product listings in the given market.
   *
   * Null when neither this category nor any ancestor has a banner configured for
   * that market, and also when the nearest configured banner is missing creative or
   * a destination and so cannot be rendered.
   */
  bannerDetails?: Maybe<GCategoryBannerDetails>;
  /**
   * Markets with a banner configured on this category. Not narrowed to
   * `activeWarehouses`: a banner outlives the last item in a market, and a banner
   * configured somewhere the category no longer reaches is worth seeing rather
   * than hiding.
   */
  bannerWarehouses: Array<GCollectionsHomepageEntryWarehouse>;
  createdAt: Scalars['ISO8601DateTime'];
  createdBy: Scalars['String'];
  /**
   * Whether this category's banner carries a shared creative — the one every market
   * falls back to for whatever it does not set itself.
   *
   * True means the markets absent from `bannerWarehouses` are covered rather than
   * unconfigured. Not a market list, because it is narrowed to no market: even a
   * market with its own entry still inherits every field that entry leaves out.
   */
  hasBannerDefaultCreative: Scalars['Boolean'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /**
   * Fetch the number of items in the category. If the category was queried within
   * the scope of a Location, items belonging to vendors that don't support the
   * location will be omitted.
   */
  itemCount: Scalars['Int'];
  /**
   * Same as itemCount, but implicitly filters to the warehouse of the Location the
   * category was accessed through. Raises an error if the category was not fetched
   * within the scope of a Location.
   */
  itemCountForLocation: Scalars['Int'];
  /**
   * Fetch items in the category. If the category was queried within the scope of
   * a Location, items belonging to vendors that don't support the location will be
   * omitted.
   */
  items: GItemConnection;
  name: Scalars['String'];
  parentCategory?: Maybe<GCategory>;
  position?: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
  subcategories: Array<GCategory>;
  updatedAt: Scalars['ISO8601DateTime'];
  updatedBy: Scalars['String'];
};


export type GCategoryBannerDetailsArgs = {
  warehouseId: Scalars['ID'];
};


export type GCategoryItemCountArgs = {
  catalogStatus?: InputMaybe<GCatalogStatus>;
  filters?: InputMaybe<GItemsFiltersInput>;
  warehouses?: InputMaybe<Array<GItemsWarehouseInput>>;
};


export type GCategoryItemCountForLocationArgs = {
  catalogStatus?: InputMaybe<GCatalogStatus>;
  filters?: InputMaybe<GItemsFiltersInput>;
};


export type GCategoryItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<GItemsFiltersInput>;
  first?: InputMaybe<Scalars['Int']>;
  itemTypes?: InputMaybe<Array<InputMaybe<GItemType>>>;
  last?: InputMaybe<Scalars['Int']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Array<InputMaybe<GItemsSortOrder>>>;
  vendors?: InputMaybe<Array<InputMaybe<GItemsVendorInput>>>;
  warehouses?: InputMaybe<Array<InputMaybe<GItemsWarehouseInput>>>;
};


export type GCategorySubcategoriesArgs = {
  sortOrder?: InputMaybe<Array<InputMaybe<GCategoriesSortOrder>>>;
};

/** The creative a banner falls back to, shaped like a market's entry without the market. */
export type GCategoryBannerDefaultAttributes = {
  __typename?: 'CategoryBannerDefaultAttributes';
  /** An image key, not a URL — the same value `upsertCategoryBanner` accepts. */
  desktopImage?: Maybe<Scalars['String']>;
  destinationRef?: Maybe<Scalars['String']>;
  destinationType?: Maybe<GCategoryBannerDestinationType>;
  mobileImage?: Maybe<Scalars['String']>;
  shippingBehavior?: Maybe<GCategoryBannerShippingBehavior>;
  shippingDesktopImage?: Maybe<Scalars['String']>;
  shippingMobileImage?: Maybe<Scalars['String']>;
};

/**
 * The creative every market inherits. Both images are required: a default has
 * nothing above it to inherit from, so a half-configured one would leave every
 * market it covers showing nothing.
 */
export type GCategoryBannerDefaultInput = {
  desktopImage: Scalars['String'];
  /**
   * Interpreted according to destinationType; a collection slug when COLLECTION.
   * Omit it for a banner that is shown but does not link anywhere.
   */
  destinationRef?: InputMaybe<Scalars['String']>;
  destinationType?: InputMaybe<GCategoryBannerDestinationType>;
  mobileImage: Scalars['String'];
  shippingBehavior?: InputMaybe<GCategoryBannerShippingBehavior>;
  /** Required when shippingBehavior is OVERRIDE, ignored otherwise. */
  shippingDesktopImage?: InputMaybe<Scalars['String']>;
  /** Required when shippingBehavior is OVERRIDE, ignored otherwise. */
  shippingMobileImage?: InputMaybe<Scalars['String']>;
};

/** What a category banner's destinationRef points at. */
export enum GCategoryBannerDestinationType {
  Collection = 'COLLECTION',
  /** A /catalog/collection/<slug> or /catalog/item/<uuid> path, relative to the viewer's location, in destinationRef. */
  InternalPath = 'INTERNAL_PATH'
}

/**
 * A per-market banner shown above the product listings on a category or
 * subcategory page.
 */
export type GCategoryBannerDetails = {
  __typename?: 'CategoryBannerDetails';
  desktopImageUrl: Scalars['String'];
  /** Interpreted according to destinationType; a collection slug when COLLECTION. */
  destinationRef?: Maybe<Scalars['String']>;
  /** Null together with destinationRef, on a banner that is shown but not clickable. */
  destinationType?: Maybe<GCategoryBannerDestinationType>;
  mobileImageUrl: Scalars['String'];
  shippingBehavior: GCategoryBannerShippingBehavior;
  shippingDesktopImageUrl?: Maybe<Scalars['String']>;
  shippingMobileImageUrl?: Maybe<Scalars['String']>;
  /**
   * The category this banner is configured on, which may be an ancestor of the one
   * queried. Distinguishes an inherited banner from one set on the category itself.
   */
  sourceCategoryId: Scalars['ID'];
};

export type GCategoryBannerError = {
  __typename?: 'CategoryBannerError';
  code?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/**
 * The banner configured on a category, as the admin tool needs it back to edit.
 *
 * Distinct from `Category.bannerDetails`, which serves the storefront: that field
 * resolves inheritance and returns public URLs for a single market, neither of
 * which a form can round-trip. This returns the banner configured on this category
 * alone, one entry per market, holding the image keys the upsert mutation takes.
 */
export type GCategoryBannerForEdit = {
  __typename?: 'CategoryBannerForEdit';
  category: GCategory;
  /** Null when this category has no banner of its own. */
  categoryBannerId?: Maybe<Scalars['ID']>;
  /** The creative every market inherits unless it carries its own; null when there is none. */
  defaultCreative?: Maybe<GCategoryBannerDefaultAttributes>;
  /**
   * One entry per market the banner is configured for. Markets absent here are the
   * ones an upsert would remove, so a form must send back exactly the markets it
   * means to keep.
   */
  warehouses: Array<GCategoryBannerWarehouseAttributes>;
};

export type GCategoryBannerPayload = {
  __typename?: 'CategoryBannerPayload';
  categoryBannerId?: Maybe<Scalars['ID']>;
  errors: Array<GCategoryBannerError>;
  /**
   * Markets whose creative this call removed, because they were left out of
   * `warehouseIds`. Lets a caller tell a partial list apart from a no-op save.
   */
  removedWarehouseIds?: Maybe<Array<Scalars['ID']>>;
};

/**
 * How a category banner behaves for shipping locations. Applied by the client
 * rather than resolved here: shipping is a property of a location, and a single
 * warehouse serves both shipping and delivery locations.
 */
export enum GCategoryBannerShippingBehavior {
  /** Shipping locations do not see this banner at all. */
  Hide = 'HIDE',
  /** Shipping locations see the default creative. */
  Inherit = 'INHERIT',
  /** Shipping locations see the shipping-specific creative. */
  Override = 'OVERRIDE'
}

export type GCategoryBannerWarehouseAttributes = {
  __typename?: 'CategoryBannerWarehouseAttributes';
  /** An image key, not a URL — the same value `upsertCategoryBanner` accepts. */
  desktopImage?: Maybe<Scalars['String']>;
  destinationRef?: Maybe<Scalars['String']>;
  destinationType?: Maybe<GCategoryBannerDestinationType>;
  /**
   * Whether this market has been hidden outright. False is the ordinary state, and is not the same
   * as having no creative: a market with neither falls back to `defaultCreative`, while a hidden one
   * shows nothing.
   */
  hidden: Scalars['Boolean'];
  mobileImage?: Maybe<Scalars['String']>;
  shippingBehavior?: Maybe<GCategoryBannerShippingBehavior>;
  shippingDesktopImage?: Maybe<Scalars['String']>;
  shippingMobileImage?: Maybe<Scalars['String']>;
  warehouse: GCollectionsHomepageEntryWarehouse;
};

/** The creative and behaviour for one market. */
export type GCategoryBannerWarehouseInput = {
  /** Required unless this market is hidden. */
  desktopImage?: InputMaybe<Scalars['String']>;
  /**
   * Interpreted according to destinationType; a collection slug when COLLECTION.
   * Omit it for a banner that is shown but does not link anywhere.
   */
  destinationRef?: InputMaybe<Scalars['String']>;
  destinationType?: InputMaybe<GCategoryBannerDestinationType>;
  /**
   * Hides the banner in this market outright: nobody there sees one, and the lookup stops here
   * rather than falling through to an ancestor category. Distinct from `shippingBehavior: HIDE`,
   * which only narrows the audience to shoppers who are not shipping.
   *
   * A hidden market needs no creative of its own — the usual case is hiding one that was inheriting
   * `defaultCreative` and has none — which is why the two images are optional here and required
   * everywhere else. Creative sent alongside it is still stored, so un-hiding restores it.
   */
  hidden?: InputMaybe<Scalars['Boolean']>;
  /** Required unless this market is hidden. */
  mobileImage?: InputMaybe<Scalars['String']>;
  shippingBehavior?: InputMaybe<GCategoryBannerShippingBehavior>;
  /** Required when shippingBehavior is OVERRIDE, ignored otherwise. */
  shippingDesktopImage?: InputMaybe<Scalars['String']>;
  /** Required when shippingBehavior is OVERRIDE, ignored otherwise. */
  shippingMobileImage?: InputMaybe<Scalars['String']>;
  warehouseId: Scalars['ID'];
};

export type GCategorySpendDetail = {
  __typename?: 'CategorySpendDetail';
  categoryId: Scalars['ID'];
  categoryName: Scalars['String'];
  /**
   * Projected category spend for this location (= location.spend_90d × warehouse
   * category_share_pct / 100). Drives the new expansion opportunity calculation.
   */
  expectedSpendCents: Scalars['Int'];
  gapCents: Scalars['Int'];
  locationSpendCents: Scalars['Int'];
  /** @deprecated Use expected_spend_cents. Median is retained for one release for sales context, will be removed once expected-spend numbers are validated by reps. */
  warehouseMedianCents: Scalars['Int'];
};

export enum GCategoryType {
  Branded = 'BRANDED',
  Supply = 'SUPPLY'
}

/** Kind of paper_trail audit event surfaced in changeHistory. */
export enum GChangeEventKind {
  /** A new audited row was inserted. */
  Create = 'CREATE',
  /** An audited row was deleted. */
  Destroy = 'DESTROY',
  /** An audited column on an existing row was changed. */
  Update = 'UPDATE'
}

export enum GChannelEnum {
  /** Mobile Android app */
  MobileAndroid = 'mobile_android',
  /** Mobile iOS app */
  MobileIos = 'mobile_ios',
  /** Web browser */
  Web = 'web'
}

/** Chat Messages represents a message created by a user or a system */
export type GChatMessage = {
  __typename?: 'ChatMessage';
  /** Body represents the main body of the chat message */
  body: Scalars['String'];
  /** Created At represents the time the message was recorded by the system */
  createdAt: Scalars['Date'];
  /** ID of the chat message */
  id: Scalars['ID'];
  /** Metadata represents any metadata relevant to the chat message, this may be from the user perspective or system */
  metadata?: Maybe<Scalars['String']>;
  /** Role represents the initiator of the chat message, this will typically be `user`, 'ai' or `system` */
  role?: Maybe<Scalars['String']>;
};

/** A check-in entry */
export type GCheckInEntry = {
  __typename?: 'CheckInEntry';
  /** When the guest checked in */
  checkedInAt: Scalars['ISO8601DateTime'];
  /** Email address of the guest */
  email: Scalars['String'];
  /** Unique identifier for the entry */
  id: Scalars['ID'];
  /** Whether the guest won */
  won: Scalars['Boolean'];
};

export type GCheckInNotAllowed = GUserErrorInterface & {
  __typename?: 'CheckInNotAllowed';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** Statistics for check-in entries */
export type GCheckInStats = {
  __typename?: 'CheckInStats';
  /** Number of check-in entries today */
  dailyEntries: Scalars['Int'];
  /** Remaining winners available today (null if unlimited) */
  dailyRemaining?: Maybe<Scalars['Int']>;
  /** Number of winners today */
  dailyWinners: Scalars['Int'];
  /** Total number of check-in entries */
  totalEntries: Scalars['Int'];
  /** Remaining winners available overall (null if unlimited) */
  totalRemaining?: Maybe<Scalars['Int']>;
  /** Total number of winners */
  totalWinners: Scalars['Int'];
};

export type GCheckInStatus = {
  __typename?: 'CheckInStatus';
  /** Whether the daily winner limit has been reached */
  dailyLimitReached: Scalars['Boolean'];
  hasCheckedInToday: Scalars['Boolean'];
  /** When the user can next check in (only present if already checked in today) */
  nextCheckInAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Whether the total winner limit has been reached */
  totalLimitReached: Scalars['Boolean'];
};

export type GCheckinItemInput = {
  itemId: Scalars['ID'];
  receivedQty: Scalars['Float'];
  vendorPriceTotalCents: Scalars['Int'];
};

/** Autogenerated input type of CheckinOrderVendorReceiving */
export type GCheckinOrderVendorReceivingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  items: Array<GCheckinItemInput>;
  nightEnd: Scalars['ISO8601Date'];
  vendorId: Scalars['ID'];
  warehouseId: Scalars['ID'];
};

/** Autogenerated return type of CheckinOrderVendorReceiving. */
export type GCheckinOrderVendorReceivingPayload = {
  __typename?: 'CheckinOrderVendorReceivingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderVendorReceivings?: Maybe<Array<GOrderVendorReceiving>>;
  userErrors: Array<GUserError>;
};

/** Autogenerated input type of Checkout */
export type GCheckoutInput = {
  /**
   * Desired pickup time, expressed in absolute terms. Checkout will only proceed
   * if this is available pickup time according to the merchant's schedule and
   * respect's the merchant's minimum notice setting. Either this argument or the
   * relativePickupTime argument must be specified, but not both.
   */
  absolutePickupTime?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Curbside color. */
  curbsideColor?: InputMaybe<Scalars['String']>;
  /** Curbside make. */
  curbsideMake?: InputMaybe<Scalars['String']>;
  /** Curbside model. */
  curbsideModel?: InputMaybe<Scalars['String']>;
  /** Whether order is for curbside pickup. */
  curbsidePickup?: InputMaybe<Scalars['Boolean']>;
  /** Delivery detail. */
  deliveryDetail?: InputMaybe<GDeliveryDetailInput>;
  /** Email address to send receipt to. */
  email?: InputMaybe<Scalars['String']>;
  /** Opaque token identifying a specific version of the cart. */
  fingerprint: Scalars['String'];
  /** Customer name to attach to the order. */
  name: Scalars['String'];
  /**
   * Payment method. Checkout will only proceed if cart's calculated prices using
   * this payment method match the prices of the cart version identified by fingerprint.
   */
  paymentMethod: GPaymentMethod;
  /** Client app platform. */
  platform: GClientAppPlatform;
  /**
   * Desired pickup time, expressed relative to the current time. Checkout will
   * only proceed if this is available pickup time according to the merchant's
   * schedule and respect's the merchant's minimum notice setting. Either this
   * argument or the absolutePickupTime argument must be specified, but not both.
   */
  relativePickupTime?: InputMaybe<GRelativeTimeInput>;
  /** Square card id. Required if using the "square_card_id" payment method. */
  squareCardId?: InputMaybe<Scalars['String']>;
  /** Square card nonce. Required if using the "square_card_nonce" payment method. */
  squareCardNonce?: InputMaybe<Scalars['String']>;
  /** Whether order is "to go" (i.e. takeout/takeaway). */
  toGo: Scalars['Boolean'];
};

/** Autogenerated return type of Checkout */
export type GCheckoutPayload = {
  __typename?: 'CheckoutPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to process checkout. */
  result: GCheckoutResult;
};

/** Checkout mutation result. */
export type GCheckoutResult = GCheckoutSuccess | GErrorsResult;

/** Result of a successful checkout mutation. */
export type GCheckoutSuccess = {
  __typename?: 'CheckoutSuccess';
  /** Fresh cart info. */
  cart: GCart;
  /** Earned reward, applicable to a future order. */
  earnedReward?: Maybe<GReward>;
  /** Resulting consumer order. */
  order: GConsumerOrder;
};

/** Autogenerated input type of ClaimReward */
export type GClaimRewardInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Reward code. */
  code: Scalars['String'];
};

/** Autogenerated return type of ClaimReward */
export type GClaimRewardPayload = {
  __typename?: 'ClaimRewardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to claim reward. */
  result: GRewardResult;
};

/** Client app platform values. */
export enum GClientAppPlatform {
  /** Android. */
  Android = 'android',
  /** Apple (iOS). */
  Apple = 'apple',
  /** Web. */
  Web = 'web'
}

export type GCollection = {
  __typename?: 'Collection';
  aggregation?: Maybe<GCollectionAggregationType>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  /**
   * Fetch items in the collection. If the collection was queried within the scope
   * of a Location, items belonging to vendors that don't support the location will
   * be omitted.
   */
  items: GItemConnection;
  name?: Maybe<Scalars['String']>;
  promoName?: Maybe<Scalars['String']>;
  /**
   * Load warehouse-specific properties needed to display this collection's
   * promotion page.
   */
  promoPageDetails?: Maybe<GPromoPageDetails>;
  reference?: Maybe<GCollectionReference>;
  referenceId?: Maybe<Scalars['ID']>;
  slug?: Maybe<Scalars['String']>;
  type?: Maybe<GCollectionType>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  updatedBy?: Maybe<Scalars['ISO8601DateTime']>;
};


export type GCollectionItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<GItemsFiltersInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Array<InputMaybe<GItemsSortOrder>>>;
};


export type GCollectionPromoPageDetailsArgs = {
  warehouseId: Scalars['ID'];
};

export enum GCollectionAggregationType {
  Manual = 'MANUAL',
  Tag = 'TAG',
  Vendor = 'VENDOR'
}

export type GCollectionBanner = {
  __typename?: 'CollectionBanner';
  collection: GCollection;
  warehouseAttributes?: Maybe<GCollectionBannerWarehouseAttributes>;
};


export type GCollectionBannerWarehouseAttributesArgs = {
  warehouseId: Scalars['ID'];
};

export enum GCollectionBannerFontStyle {
  Dark = 'DARK',
  Light = 'LIGHT'
}

export type GCollectionBannerWarehouseAttributes = {
  __typename?: 'CollectionBannerWarehouseAttributes';
  desktopImageUrl: Scalars['String'];
  fontStyle: GCollectionBannerFontStyle;
  mobileImageUrl: Scalars['String'];
};

export type GCollectionCarousel = {
  __typename?: 'CollectionCarousel';
  collection: GCollection;
  enabledForWarehouse: Scalars['Boolean'];
};


export type GCollectionCarouselEnabledForWarehouseArgs = {
  warehouseId: Scalars['ID'];
};

export type GCollectionHighlightCarousel = {
  __typename?: 'CollectionHighlightCarousel';
  collection: GCollection;
  warehouseAttributes?: Maybe<GCollectionHighlightCarouselWarehouseAttributes>;
};


export type GCollectionHighlightCarouselWarehouseAttributesArgs = {
  warehouseId: Scalars['ID'];
};

export type GCollectionHighlightCarouselWarehouseAttributes = {
  __typename?: 'CollectionHighlightCarouselWarehouseAttributes';
  imageUrl: Scalars['String'];
};

export type GCollectionPromoSetupError = {
  __typename?: 'CollectionPromoSetupError';
  code?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

export enum GCollectionReference {
  Item = 'ITEM',
  Promotion = 'PROMOTION'
}

export type GCollectionSetupDisplayRule = {
  __typename?: 'CollectionSetupDisplayRule';
  componentId: Scalars['ID'];
  componentType: GHomepageCollectionComponentType;
  endDate: Scalars['ISO8601Date'];
  position: Scalars['String'];
  ruleId: Scalars['ID'];
  startDate: Scalars['ISO8601Date'];
  warehouseIds: Array<Scalars['ID']>;
  warehouses: Array<GCollectionsHomepageEntryWarehouse>;
};

export type GCollectionSetupForEdit = {
  __typename?: 'CollectionSetupForEdit';
  collection: GCollection;
  displayRules: Array<GCollectionSetupDisplayRule>;
  homepageComponents: Array<GCollectionSetupHomepageComponent>;
  itemIds: Array<Scalars['ID']>;
  promoPageId?: Maybe<Scalars['ID']>;
  promoPageWarehouses: Array<GCollectionSetupPromoPageWarehouseAttributes>;
};

export type GCollectionSetupHomepageComponent = {
  __typename?: 'CollectionSetupHomepageComponent';
  componentId: Scalars['ID'];
  componentType: GHomepageCollectionComponentType;
  warehouseAttributes: Array<GCollectionSetupHomepageComponentWarehouseAttributes>;
};

export type GCollectionSetupHomepageComponentWarehouseAttributes = {
  __typename?: 'CollectionSetupHomepageComponentWarehouseAttributes';
  desktopImage?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  fontStyle?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  mobileImage?: Maybe<Scalars['String']>;
  warehouse: GCollectionsHomepageEntryWarehouse;
};

export type GCollectionSetupPromoPageWarehouseAttributes = {
  __typename?: 'CollectionSetupPromoPageWarehouseAttributes';
  customDescription?: Maybe<Scalars['String']>;
  customName?: Maybe<Scalars['String']>;
  desktopHeroImage?: Maybe<Scalars['String']>;
  isVisibleMarket?: Maybe<Scalars['Boolean']>;
  mobileHeroImage?: Maybe<Scalars['String']>;
  shippingDesktopHeroImage?: Maybe<Scalars['String']>;
  shippingMobileHeroImage?: Maybe<Scalars['String']>;
  warehouse: GCollectionsHomepageEntryWarehouse;
};

export enum GCollectionType {
  Bundle = 'BUNDLE',
  OutOfStockRecommendation = 'OUT_OF_STOCK_RECOMMENDATION',
  Promotion = 'PROMOTION',
  SimilarItems = 'SIMILAR_ITEMS'
}

export type GCollectionsHomepageEntry = {
  __typename?: 'CollectionsHomepageEntry';
  collection: GCollection;
  configuredWarehouseCount: Scalars['Int'];
  enabledWarehouseCount: Scalars['Int'];
  endDate: Scalars['ISO8601Date'];
  ruleId: Scalars['ID'];
  startDate: Scalars['ISO8601Date'];
  warehouseIds: Array<Scalars['ID']>;
  warehouses: Array<GCollectionsHomepageEntryWarehouse>;
};

export type GCollectionsHomepageEntryWarehouse = {
  __typename?: 'CollectionsHomepageEntryWarehouse';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type GCollectionsHomepageRow = {
  __typename?: 'CollectionsHomepageRow';
  activeNow: Array<GCollectionsHomepageEntry>;
  position: Scalars['String'];
  scheduled: Array<GCollectionsHomepageEntry>;
};

export type GCollectionsPageEntry = {
  __typename?: 'CollectionsPageEntry';
  collection: GCollection;
  configuredWarehouseCount: Scalars['Int'];
  warehouseIds: Array<Scalars['ID']>;
  warehouses: Array<GCollectionsHomepageEntryWarehouse>;
};

export type GColor = {
  __typename?: 'Color';
  hexCode: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  position: Scalars['Int'];
};

export type GCompany = {
  __typename?: 'Company';
  /** ISO 3166-2 alpha-2 code. */
  countryCode?: Maybe<Scalars['String']>;
  /** Whether this company is an enterprise company or not. */
  enterprise?: Maybe<Scalars['Boolean']>;
  /**
   * How many of this company's kept locations are excluded from automatic
   * application of credit memos, overpayments and unapplied Odeko payments.
   */
  fundApplicationExcludedLocationsCount: Scalars['Int'];
  id: Scalars['ID'];
  /** List of locations (almost always, brick-and-mortar cafes for this company.) */
  locations: Array<GLocation>;
  /**
   * Number of locations in this company. Unlike `locations`, readable by viewers
   * who only hold a subset of the company's locations.
   */
  locationsCount: Scalars['Int'];
  name: Scalars['String'];
  /**
   * ISO 3166-2 subdivision code. For US based companies, this is the US State of
   * the first cafe location created in our systems for that company.
   */
  regionCode?: Maybe<Scalars['String']>;
  /** List of users associated to this company. */
  users: Array<GUser>;
};

/** The connection type for Company. */
export type GCompanyConnection = {
  __typename?: 'CompanyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GCompanyEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GCompany>>>;
  /** Information to aid in pagination. */
  pageInfo: GPageInfo;
  /** The total count of records in the connection. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type GCompanyEdge = {
  __typename?: 'CompanyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GCompany>;
};

/** Autogenerated input type of CompleteActionMutation */
export type GCompleteActionMutationInput = {
  action: GPlatformActions;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The UUID of the Odeko Location to try and match against the Google Business Profile */
  locationUuid?: InputMaybe<Scalars['ID']>;
  platformId: GPlatformIds;
  queryString: Scalars['String'];
  redirectUri: Scalars['String'];
  /** The URL slug of the microsite location to match against the Google Business Profile */
  urlSlug?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CompleteActionMutation. */
export type GCompleteActionMutationPayload = {
  __typename?: 'CompleteActionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  connection: GConnection;
};

/** Autogenerated input type of CompleteConsumerAppReferral */
export type GCompleteConsumerAppReferralInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Referral link URL */
  url: Scalars['String'];
};

/** Autogenerated return type of CompleteConsumerAppReferral */
export type GCompleteConsumerAppReferralPayload = {
  __typename?: 'CompleteConsumerAppReferralPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to complete the consumer app referral */
  result: GCompleteConsumerAppReferralResult;
};

/** Result of attempting to complete a consumer app referral. */
export type GCompleteConsumerAppReferralResult = GConsumerAppReferralSuccess | GErrorsResult;

/** Autogenerated input type of CompleteStripeCheckoutSessionMutation */
export type GCompleteStripeCheckoutSessionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Optional microsite location ID to associate and trigger signage order creation */
  micrositeLocationId?: InputMaybe<Scalars['ID']>;
  /** Stripe checkout session ID (cs_xxx) */
  stripeCheckoutSessionId: Scalars['String'];
};

/** Autogenerated return type of CompleteStripeCheckoutSessionMutation. */
export type GCompleteStripeCheckoutSessionMutationPayload = {
  __typename?: 'CompleteStripeCheckoutSessionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']>;
  /** Updated Stripe checkout session */
  stripeCheckoutSession?: Maybe<GStripeCheckoutSession>;
};

/** Autogenerated input type of CompleteSubscriptionSessionMutation */
export type GCompleteSubscriptionSessionMutationInput = {
  /** Auth0 ID of a newly created user to associate with microsite */
  auth0UserId?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the subscription session to complete */
  subscriptionSessionId: Scalars['ID'];
};

/** Autogenerated return type of CompleteSubscriptionSessionMutation. */
export type GCompleteSubscriptionSessionMutationPayload = {
  __typename?: 'CompleteSubscriptionSessionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']>;
  /** Completed subscription session */
  subscriptionSession?: Maybe<GSubscriptionSession>;
};

/** Autogenerated input type of CompleteSupplierInvoiceUpload */
export type GCompleteSupplierInvoiceUploadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  signedBlobId: Scalars['String'];
  supplierInvoiceId: Scalars['ID'];
};

/** Autogenerated return type of CompleteSupplierInvoiceUpload. */
export type GCompleteSupplierInvoiceUploadPayload = {
  __typename?: 'CompleteSupplierInvoiceUploadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  supplierInvoice?: Maybe<GSupplierInvoice>;
};

export type GCompletedCustomerPickupStop = GUserErrorInterface & {
  __typename?: 'CompletedCustomerPickupStop';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
  stopIds: Array<Scalars['ID']>;
};

/** One completed in-progress customer, as Ops reconciles it against their master list. */
export type GCompletedOnboardingRow = {
  __typename?: 'CompletedOnboardingRow';
  city?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyUuid?: Maybe<Scalars['ID']>;
  locationName?: Maybe<Scalars['String']>;
  /** The location onboarding produced, existing or newly created. */
  locationUuid?: Maybe<Scalars['ID']>;
  state?: Maybe<Scalars['String']>;
  /** The id generated at ingest; the key this row joins on. */
  uniqueId?: Maybe<Scalars['String']>;
  userEmail?: Maybe<Scalars['String']>;
  userFirstName?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
  userLastName?: Maybe<Scalars['String']>;
};

/** Configuration info */
export type GConfig = GNode & {
  __typename?: 'Config';
  /** Oldest supported consumer Android app */
  consumerAndroidForceVersion: Scalars['String'];
  /** Latest consumer Android app */
  consumerAndroidLatestVersion: Scalars['String'];
  /** Oldest supported consumer iOS app */
  consumerIosForceVersion: Scalars['String'];
  /** Latest consumer iOS app */
  consumerIosLatestVersion: Scalars['String'];
  /** When this edition of the config was added to the database */
  createdAt: Scalars['ISO8601DateTime'];
  /** Position in chronological sequence of configs */
  edition: Scalars['Int'];
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
  /** Oldest supported merchant Amazon app */
  merchantAmazonForceVersion: Scalars['String'];
  /** Latest merchant Amazon app */
  merchantAmazonLatestVersion: Scalars['String'];
  /** Oldest supported merchant Android app */
  merchantAndroidForceVersion: Scalars['String'];
  /** Latest merchant Android app */
  merchantAndroidLatestVersion: Scalars['String'];
  /** Oldest supported merchant iOS app */
  merchantIosForceVersion: Scalars['String'];
  /** Latest merchant iOS app */
  merchantIosLatestVersion: Scalars['String'];
  /** Upgrade message shown to merchants with an Odeko-provided tablet */
  merchantTabletUpgradeMessage?: Maybe<Scalars['String']>;
  /** Date when tablet upgrade message starts appearing */
  merchantTabletUpgradeStartDate?: Maybe<Scalars['ISO8601Date']>;
  /** @deprecated Each edition of the config is immutable, so an update generates a new edition */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Attributes for creating a config */
export type GConfigAttributes = {
  /** Oldest supported consumer Android app */
  consumerAndroidForceVersion: Scalars['String'];
  /** Latest consumer Android app */
  consumerAndroidLatestVersion: Scalars['String'];
  /** Oldest supported consumer iOS app */
  consumerIosForceVersion: Scalars['String'];
  /** Latest consumer iOS app */
  consumerIosLatestVersion: Scalars['String'];
  /** Oldest supported merchant Amazon app */
  merchantAmazonForceVersion: Scalars['String'];
  /** Latest merchant Amazon app */
  merchantAmazonLatestVersion: Scalars['String'];
  /** Oldest supported merchant Android app */
  merchantAndroidForceVersion: Scalars['String'];
  /** Latest merchant Android app */
  merchantAndroidLatestVersion: Scalars['String'];
  /** Oldest supported merchant iOS app */
  merchantIosForceVersion: Scalars['String'];
  /** Latest merchant iOS app */
  merchantIosLatestVersion: Scalars['String'];
  /** Upgrade message shown to merchants with an Odeko-provided tablet */
  merchantTabletUpgradeMessage?: InputMaybe<Scalars['String']>;
  /** Date when tablet upgrade message starts appearing */
  merchantTabletUpgradeStartDate?: InputMaybe<Scalars['String']>;
};

/** The connection type for Config. */
export type GConfigConnection = {
  __typename?: 'ConfigConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GConfigEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GConfig>>>;
  /** Information to aid in pagination. */
  pageInfo: GPageInfo;
};

/** An edge in a connection. */
export type GConfigEdge = {
  __typename?: 'ConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GConfig>;
};

/** Config sort criteria */
export type GConfigOrderBy = {
  /** Position in chronological sequence of configs */
  edition?: InputMaybe<GOrderByEnum>;
};

/** Config mutation result */
export type GConfigResult = GConfigSuccess | GInvalidConfigError | GStaleConfigError;

/** Result of a successful Config mutation */
export type GConfigSuccess = {
  __typename?: 'ConfigSuccess';
  /** Resulting config */
  config: GConfig;
};

export type GConfigureFulfillmentWarehouse = {
  __typename?: 'ConfigureFulfillmentWarehouse';
  /** The warehouse that is configured to fulfill the item. */
  warehouse: GWarehouse;
};

export type GConfigureFulfillmentWarehouseInput = {
  warehouseId: Scalars['ID'];
};

/** Autogenerated input type of ConfirmPutawayPallet */
export type GConfirmPutawayPalletInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Destination bin NetSuite internal id. Provide this or destinationBinName, not both. */
  destinationBinInternalId?: InputMaybe<Scalars['String']>;
  /** Destination bin display name, as printed on the bin label. Provide this or destinationBinInternalId, not both. */
  destinationBinName?: InputMaybe<Scalars['String']>;
  idempotencyKey: Scalars['ID'];
  /** Quantity to move, in the item's NetSuite stock unit, as a decimal string such as "15.0". Defaults to one full pallet. */
  stockUnitQuantity?: InputMaybe<Scalars['String']>;
  /** WarehouseTask id from the warehouseTasks query. */
  taskId: Scalars['ID'];
};

/** Autogenerated return type of ConfirmPutawayPallet. */
export type GConfirmPutawayPalletPayload = {
  __typename?: 'ConfirmPutawayPalletPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  command?: Maybe<GWarehouseBinTransferCommand>;
  userErrors: Array<GUserError>;
};

/** Autogenerated input type of ConfirmSquareOrderSuggestionMutation */
export type GConfirmSquareOrderSuggestionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The Square Terminal device ID for checkout */
  deviceId: Scalars['String'];
  /** The order suggestion ID to confirm */
  suggestionId: Scalars['ID'];
};

/** Autogenerated return type of ConfirmSquareOrderSuggestionMutation. */
export type GConfirmSquareOrderSuggestionMutationPayload = {
  __typename?: 'ConfirmSquareOrderSuggestionMutationPayload';
  /** The created Terminal checkout */
  checkout?: Maybe<GTerminalCheckout>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']>;
  /** The created Square order */
  order?: Maybe<GSquareOrder>;
};

/** Autogenerated input type of ConnectLocationCreditKeyAccountMutation */
export type GConnectLocationCreditKeyAccountMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** UUID for the Location */
  locationUuid: Scalars['String'];
};

/** Autogenerated return type of ConnectLocationCreditKeyAccountMutation. */
export type GConnectLocationCreditKeyAccountMutationPayload = {
  __typename?: 'ConnectLocationCreditKeyAccountMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GError>;
  paymentMethod?: Maybe<GBuyNowPayLater>;
};

export type GConnection = {
  __typename?: 'Connection';
  isConnected: Scalars['Boolean'];
  platformId: GPlatformIds;
  profiles: Array<GProfile>;
  selectedProfile?: Maybe<GProfile>;
  /** The email address the user used to connect this platform */
  userEmail?: Maybe<Scalars['String']>;
};

export type GConsumerAppReferral = {
  __typename?: 'ConsumerAppReferral';
  /** Reward granted to the referred user. */
  referredReward?: Maybe<GReward>;
};

/** Error indicating an invalid consumer app referral. */
export type GConsumerAppReferralInvalid = GError & {
  __typename?: 'ConsumerAppReferralInvalid';
  /** A description of the error. */
  message: Scalars['String'];
};

export type GConsumerAppReferralLink = {
  __typename?: 'ConsumerAppReferralLink';
  /** URL */
  url: Scalars['String'];
};

/** Error indicating invalid consumer app referral link. */
export type GConsumerAppReferralLinkInvalid = GError & {
  __typename?: 'ConsumerAppReferralLinkInvalid';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating that a consumer app referral link could not be found. */
export type GConsumerAppReferralLinkNotFound = GError & {
  __typename?: 'ConsumerAppReferralLinkNotFound';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating that a consumer app referral link mutation failed to save the consumer app referral link. */
export type GConsumerAppReferralLinkNotSaved = GError & {
  __typename?: 'ConsumerAppReferralLinkNotSaved';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Result of successfully mutating a consumer app referral link. */
export type GConsumerAppReferralLinkSuccess = {
  __typename?: 'ConsumerAppReferralLinkSuccess';
  /** Consumer app referral link. */
  consumerAppReferralLink: GConsumerAppReferralLink;
};

/** Error indicating that a consumer app referral mutation failed to save the referral. */
export type GConsumerAppReferralNotSaved = GError & {
  __typename?: 'ConsumerAppReferralNotSaved';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Result of successfully mutating a consumer app referral. */
export type GConsumerAppReferralSuccess = {
  __typename?: 'ConsumerAppReferralSuccess';
  /** Consumer app referral. */
  consumerAppReferral: GConsumerAppReferral;
};

/** Consumer app user. */
export type GConsumerAppUser = GNode & {
  __typename?: 'ConsumerAppUser';
  /** Accepts promotional emails. */
  acceptsPromotionalEmails: Scalars['Boolean'];
  /** The primary key from the database. */
  databaseId: Scalars['Int'];
  /** Email. */
  email?: Maybe<Scalars['String']>;
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
  /** Whether this is a guest account. */
  isGuestAccount: Scalars['Boolean'];
  /** Merchant can contact. */
  merchantCanContact?: Maybe<Scalars['Boolean']>;
  /** Phone number. */
  phoneNumber?: Maybe<Scalars['String']>;
  /** Total discount received on orders so far. */
  totalMoneySaved: GMoney;
  /** Username. */
  username?: Maybe<Scalars['String']>;
};

/** Consumer app user Firebase login result. */
export type GConsumerAppUserFirebaseLoginResult = GConsumerAppUserFirebaseLoginSuccess | GErrorsResult;

/** Result of a successful consumer app user login from Firebase. */
export type GConsumerAppUserFirebaseLoginSuccess = {
  __typename?: 'ConsumerAppUserFirebaseLoginSuccess';
  /** Logged in consumer app user. */
  consumerAppUser: GConsumerAppUser;
  /** Session info. */
  session: GJwtSession;
};

/** Error indicating invalid consumer app user attributes. */
export type GConsumerAppUserInvalid = GError & {
  __typename?: 'ConsumerAppUserInvalid';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating that a consumer app user mutation failed to save the consumer app user. */
export type GConsumerAppUserNotSaved = GError & {
  __typename?: 'ConsumerAppUserNotSaved';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Consumer app user mutation result. */
export type GConsumerAppUserResult = GConsumerAppUserSuccess | GErrorsResult;

/** Result of a successful consumer app user mutation. */
export type GConsumerAppUserSuccess = {
  __typename?: 'ConsumerAppUserSuccess';
  /** Resulting consumer app user. */
  consumerAppUser: GConsumerAppUser;
};

/** Consumer order. */
export type GConsumerOrder = GNode & {
  __typename?: 'ConsumerOrder';
  /** When the order was marked complete. */
  completedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Service fee paid by customer. */
  consumerAppUserServiceFee: GMoney;
  /** Created at datetime. */
  createdAt: Scalars['ISO8601DateTime'];
  /** Curbside arrived. */
  curbsideArrived: Scalars['Boolean'];
  /** When customer reported curbside arrival. */
  curbsideArrivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Curbside color. */
  curbsideColor?: Maybe<Scalars['String']>;
  /** Curbside make. */
  curbsideMake?: Maybe<Scalars['String']>;
  /** Curbside model. */
  curbsideModel?: Maybe<Scalars['String']>;
  /** Curbside pickup. */
  curbsidePickup: Scalars['Boolean'];
  /** Customer name. */
  customerName?: Maybe<Scalars['String']>;
  /** Customer phone number. Null if unset or if the customer has opted not to allow merchants to contact them. */
  customerPhone?: Maybe<Scalars['String']>;
  /** The primary key from the database. */
  databaseId: Scalars['Int'];
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
  /** Line-items. */
  lineItems: Array<GConsumerOrderLineItem>;
  /** Order's current lock version, providing concurrency control and protection against stale updates. */
  lockVersion: Scalars['Int'];
  /** Merchant. */
  merchant: GMerchant;
  /** When merchant acknowledged the order. */
  merchantAcknowledgedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** When the order was marked picked-up. */
  pickedUpAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Scheduled pickup datetime. */
  pickupTime: Scalars['ISO8601DateTime'];
  /** When the order was marked ready. */
  readiedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Refund info. */
  refundInfo: GConsumerRefundInfo;
  /** Discount applied by reward. */
  rewardValue: GMoney;
  /** Subtotal. */
  subtotal: GMoney;
  /** Tax. Based on subtotal - rewardValue. */
  tax: GMoney;
  /** Tip. */
  tip: GMoney;
  /** Total (subtotal - rewardValue + tax + tip + consumerAppUserServiceFee + deliveryFee). */
  total: GMoney;
};

/**
 * Result of attempting to create a full refund for a consumer order that
 * has already been refunded, either partially or fully. If the order has
 * only been partially refunded, clients desiring to refund the remaining
 * refundable amount should call createPartialConsumerRefund rather than
 * createFullConsumerRefund.
 */
export type GConsumerOrderAlreadyRefunded = GError & {
  __typename?: 'ConsumerOrderAlreadyRefunded';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Autogenerated input type of ConsumerOrderComplete */
export type GConsumerOrderCompleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Consumer order ID. */
  consumerOrderId: Scalars['ID'];
  /**
   * Order's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
};

/** Autogenerated return type of ConsumerOrderComplete */
export type GConsumerOrderCompletePayload = {
  __typename?: 'ConsumerOrderCompletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to mark the order complete. */
  result: GConsumerOrderResult;
};

/** The connection type for ConsumerOrder. */
export type GConsumerOrderConnection = {
  __typename?: 'ConsumerOrderConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GConsumerOrderEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GConsumerOrder>>>;
  /** Information to aid in pagination. */
  pageInfo: GPageInfo;
};

/** An edge in a connection. */
export type GConsumerOrderEdge = {
  __typename?: 'ConsumerOrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GConsumerOrder>;
};

/** Consumer order line-item. */
export type GConsumerOrderLineItem = GNode & {
  __typename?: 'ConsumerOrderLineItem';
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
  /** Item name. */
  itemName: Scalars['String'];
  /** Item quantity. */
  itemQuantity: Scalars['Int'];
  /** Item size. */
  itemSize: Scalars['String'];
  /** Modifiers. */
  modifiers: Array<GConsumerOrderLineItemModifier>;
  /** Note. */
  note?: Maybe<Scalars['String']>;
  /** Submenu name. */
  submenuName?: Maybe<Scalars['String']>;
  /** Subtotal. */
  subtotal: GMoney;
  /** Tax rate expressed as a percentage. */
  taxRate?: Maybe<Scalars['Float']>;
  /** Unit price, not including modifiers. */
  unitPrice: GMoney;
};

/** Consumer order line-item modifier. */
export type GConsumerOrderLineItemModifier = GNode & {
  __typename?: 'ConsumerOrderLineItemModifier';
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
  /** Modifier group name. */
  modifierGroupName: Scalars['String'];
  /** Modifier option name. */
  modifierOptionName: Scalars['String'];
  /** Quantity. */
  quantity: Scalars['Int'];
  /** Unit price. */
  unitPrice: GMoney;
};

/** Autogenerated input type of ConsumerOrderPickedUp */
export type GConsumerOrderPickedUpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Consumer order ID. */
  consumerOrderId: Scalars['ID'];
  /**
   * Order's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
};

/** Autogenerated return type of ConsumerOrderPickedUp */
export type GConsumerOrderPickedUpPayload = {
  __typename?: 'ConsumerOrderPickedUpPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to mark the order picked-up. */
  result: GConsumerOrderResult;
};

/** Autogenerated input type of ConsumerOrderReady */
export type GConsumerOrderReadyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Consumer order ID. */
  consumerOrderId: Scalars['ID'];
  /**
   * Order's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
};

/** Autogenerated return type of ConsumerOrderReady */
export type GConsumerOrderReadyPayload = {
  __typename?: 'ConsumerOrderReadyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to ready the order. */
  result: GConsumerOrderResult;
};

/** Consumer order mutation result. */
export type GConsumerOrderResult = GConsumerOrderSuccess | GErrorsResult;

/** Sort criteria for a collection of consumer orders. */
export type GConsumerOrderSortCriteria = {
  /** Direction to sort in. */
  direction: GSortDirection;
  /** Field to sort by. */
  field: GConsumerOrderSortField;
};

/** Fields by which consumer orders connection can be sorted. */
export enum GConsumerOrderSortField {
  /** Sort consumer orders by creation time. */
  CreatedAt = 'CREATED_AT',
  /** Sort consumer orders by pickup time. */
  PickupTime = 'PICKUP_TIME'
}

/** Result of a successful consumer order mutation. */
export type GConsumerOrderSuccess = {
  __typename?: 'ConsumerOrderSuccess';
  /** Resulting consumer order. */
  consumerOrder: GConsumerOrder;
};

export type GConsumerPostOrderSurvey = {
  __typename?: 'ConsumerPostOrderSurvey';
  /** Datetime after which the consumer post-order survey should be displayed. */
  displayAfter: Scalars['ISO8601DateTime'];
  /** The order for which the consumer post-order survey should be displayed. */
  order: GConsumerOrder;
};

/**
 * Refund Info. Due to partial refunds, it's possible to submit multiple refunds
 * for a given order. This refund info object describes the cumulative effect of
 * all the refunds that have been processed.
 */
export type GConsumerRefundInfo = {
  __typename?: 'ConsumerRefundInfo';
  /** Customer refunded fee. */
  customerRefundedFee: GMoney;
  /** Customer refunded subtotal. */
  customerRefundedSubtotal: GMoney;
  /** Customer refunded tax. */
  customerRefundedTax: GMoney;
  /** Customer refunded tip. */
  customerRefundedTip: GMoney;
  /** Customer refunded total. */
  customerRefundedTotal: GMoney;
  /** Customer refunded reward. */
  customerRewardValue: GMoney;
  /**
   * Collection describing which item units (and associated modifier units) have
   * been refunded, and which have not yet been refunded.
   */
  items: Array<GConsumerRefundInfoItem>;
};

/**
 * Refund information about a single item and its modifiers. Note that a
 * ConsumerOrderLineItem with itemQuantity N will have N distinct RefundInfoItems.
 */
export type GConsumerRefundInfoItem = {
  __typename?: 'ConsumerRefundInfoItem';
  /** Item name. */
  itemName: Scalars['String'];
  /** Item size. */
  itemSize: Scalars['String'];
  /** ID of the associated ConsumerOrderLineItem. */
  lineItemId: Scalars['ID'];
  /** Collection describing which of the item's associated modifiers have been refunded, and which have not yet been refunded. */
  modifiers: Array<GConsumerRefundInfoItemModifier>;
  /** Whether the item has been refunded. */
  refunded: Scalars['Boolean'];
  /** Unit price, not including modifiers. */
  unitPrice: GMoney;
};

/**
 * Refund information about a single item modifier. Note that a
 * ConsumerOrderLineItemModifier with quantity N will have N distinct
 * RefundInfoItemModifiers.
 */
export type GConsumerRefundInfoItemModifier = {
  __typename?: 'ConsumerRefundInfoItemModifier';
  /** ID of the associated ConsumerOrderLineItemModifier. */
  lineItemModifierId: Scalars['ID'];
  /** Modifier group name. */
  modifierGroupName: Scalars['String'];
  /** Modifier option name. */
  modifierOptionName: Scalars['String'];
  /** Whether the modifier has been refunded. */
  refunded: Scalars['Boolean'];
  /** Unit price. */
  unitPrice: GMoney;
};

/** Consumer refund calculation result. */
export type GConsumerRefundInfoResult = GConsumerRefundInfoSuccess | GErrorsResult;

/** Result of a successful consumer refund calculation. */
export type GConsumerRefundInfoSuccess = {
  __typename?: 'ConsumerRefundInfoSuccess';
  /** Resulting refund info. */
  refundInfo: GConsumerRefundInfo;
};

/** Input for refunding a single unit of a ConsumerOrderLineItem. */
export type GConsumerRefundItemInput = {
  /**
   * How many not-yet-refunded units of the line item exist prior to applying the
   * requested mutation. This must equal the number of ConsumerRefundInfoItem
   * elements that identify the line item and have refunded = false (see
   * ConsumerOrder.refundInfo.items). If the provided count is incorrect, the
   * server will assume the request was made based on outdated information and will
   * respond with an appropriate error.
   */
  currentCount: Scalars['Int'];
  /** ID of the associated ConsumerOrderLineItem. */
  lineItemId: Scalars['ID'];
};

/** Input for refunding a single unit of a ConsumerOrderLineItemModifier. */
export type GConsumerRefundModifierInput = {
  /**
   * How many not-yet-refunded units of the item modifier exist prior to applying
   * the requested mutation. This must equal the number of
   * ConsumerRefundInfoItemModifier elements that identify the item modifier and
   * have refunded = false (see ConsumerOrder.refundInfo.items.modifiers). If the
   * provided count is incorrect, the server will assume the request was made based
   * on outdated information and will respond with an appropriate error.
   */
  currentCount: Scalars['Int'];
  /** ID of the associated ConsumerOrderLineItemModifier. */
  lineItemModifierId: Scalars['ID'];
};

export type GContactDetailsRequired = GUserErrorInterface & {
  __typename?: 'ContactDetailsRequired';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GConversionBreakdown = {
  __typename?: 'ConversionBreakdown';
  /** Number of bookings made through booking links */
  bookings: Scalars['Int'];
  /** Number of conversions from phone calls */
  calls: Scalars['Int'];
  /** Number of conversions from direction requests */
  directions: Scalars['Int'];
  /** Number of conversions from menu clicks */
  menuClicks: Scalars['Int'];
  /** Number of conversions from website clicks */
  websiteClicks: Scalars['Int'];
};

export type GConversionMetrics = {
  __typename?: 'ConversionMetrics';
  /** Daily breakdown of conversion metrics */
  dailyBreakdown: Array<GDailyConversion>;
  /** Total breakdown of conversion metrics by type for a given date range */
  totalBreakdown: GConversionBreakdown;
  /** Total number of conversions across all types for a given date range */
  totalConversions: Scalars['Int'];
};

/** Autogenerated input type of CopyDeliveryOverrideRulesMutation */
export type GCopyDeliveryOverrideRulesMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Preview without saving by default. Set false to commit; a copied block cancels orders on the target date. */
  dryRun?: InputMaybe<Scalars['Boolean']>;
  /** Preview only: also list the orders a commit would cancel. A commit with this true is refused. */
  includeCancelledOrders?: InputMaybe<Scalars['Boolean']>;
  /** UUIDs of the delivery override rules to copy. A dry run is the default. */
  ruleIds: Array<Scalars['ID']>;
  /** The date for the copies. A committed copied block cancels orders on this date. */
  targetDate: Scalars['ISO8601Date'];
};

/** Autogenerated return type of CopyDeliveryOverrideRulesMutation. */
export type GCopyDeliveryOverrideRulesMutationPayload = {
  __typename?: 'CopyDeliveryOverrideRulesMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  committed: Scalars['Boolean'];
  errors?: Maybe<Array<GUserError>>;
  results: Array<GDeliveryOverrideCopyResult>;
};

export type GCountRatings = {
  __typename?: 'CountRatings';
  byRating: GByRating;
  total: Scalars['Int'];
};

/** PROTOTYPE input for how much was counted and where. */
export type GCountingEventInput = {
  /**
   * PROTOTYPE if counted using a location's custom counting unit, its id. If null,
   * the current Odeko sales unit will be recorded instead.
   */
  locationCountingUnitId?: InputMaybe<Scalars['ID']>;
  /** PROTOTYPE if present, the location storage area containing the quantity recorded. */
  locationStorageAreaId?: InputMaybe<Scalars['ID']>;
  /** PROTOTYPE how many units were counted */
  quantity?: InputMaybe<Scalars['Float']>;
};

export type GCouponStatus = {
  __typename?: 'CouponStatus';
  /** Discount applied from this coupon */
  discount?: Maybe<GMoney>;
  /** Reason why the coupon is invalid (or null). */
  reason?: Maybe<Scalars['String']>;
  /** The number of times the coupon can be redeemed (or null, if unlimited). */
  redemptionsAvailable?: Maybe<Scalars['Int']>;
  /** Whether the coupon is valid or not. */
  valid: Scalars['Boolean'];
};

/** Autogenerated input type of CreateBrandedItemDealMutation */
export type GCreateBrandedItemDealMutationInput = {
  /** Branded item deal attributes */
  brandedItemDeal: GBrandedItemDealInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  userEmail?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CreateBrandedItemDealMutation. */
export type GCreateBrandedItemDealMutationPayload = {
  __typename?: 'CreateBrandedItemDealMutationPayload';
  brandedItemDeal?: Maybe<GBrandedItemDeal>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GUserError>;
};

export type GCreateCollectionPromoSetupInput = {
  collectionId?: InputMaybe<Scalars['ID']>;
  description: Scalars['String'];
  desktopHeroImage: Scalars['String'];
  itemIds?: InputMaybe<Array<Scalars['ID']>>;
  mobileHeroImage: Scalars['String'];
  name: Scalars['String'];
  ordered?: InputMaybe<Scalars['Boolean']>;
  promoName: Scalars['String'];
  slug: Scalars['String'];
  warehouseIds: Array<Scalars['ID']>;
};

export type GCreateCollectionPromoSetupPayload = {
  __typename?: 'CreateCollectionPromoSetupPayload';
  collectionId?: Maybe<Scalars['ID']>;
  errors: Array<GCollectionPromoSetupError>;
  invalidItemIds: Array<Scalars['ID']>;
  promoPageId?: Maybe<Scalars['ID']>;
};

/** Autogenerated input type of CreateCountingEventMutation */
export type GCreateCountingEventMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** PROTOTYPE quantity counted */
  countingEventInput: GCountingEventInput;
  /** PROTOTYPE id of the inventory LocationItem being counted. */
  locationItemId: Scalars['ID'];
  /**
   * PROTOTYPE id of the LocationStockCount session. It is an error if there is a
   * current session and this argument is omitted. If there is no current session,
   * a new one is created.
   */
  stockCountId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of CreateCountingEventMutation. */
export type GCreateCountingEventMutationPayload = {
  __typename?: 'CreateCountingEventMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** PROTOTYPE the recorded count. */
  currentCount?: Maybe<GCurrentCount>;
  /** PROTOTYPE the location Stock Count session recorded by the count. */
  currentStockCount?: Maybe<GLocationStockCount>;
  errors: Array<Scalars['String']>;
};

/** Autogenerated input type of CreateCustomIngredientMutation */
export type GCreateCustomIngredientMutationInput = {
  /** Brand name of the ingredient */
  brand?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** UUID for the Location */
  locationId: Scalars['ID'];
  /** Name of the ingredient */
  name: Scalars['String'];
  /** Price purchased at */
  purchasePrice: GMoneyInput;
  /** Unit purchased at */
  purchaseUnit: Scalars['ID'];
  /** Purchased from */
  purchaseVendor?: InputMaybe<Scalars['String']>;
  /** Quantity portion of item size */
  sizeQuantity: Scalars['Float'];
  /** Unit portion of item size */
  sizeUnit: Scalars['ID'];
};

/** Autogenerated return type of CreateCustomIngredientMutation. */
export type GCreateCustomIngredientMutationPayload = {
  __typename?: 'CreateCustomIngredientMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  customIngredient?: Maybe<GCustomIngredient>;
  errors: Array<GUserError>;
};

/** Autogenerated input type of CreateCustomerTagImportMutation */
export type GCreateCustomerTagImportMutationInput = {
  /** Size of the file in bytes. At most 10485760. */
  byteSize: Scalars['Int'];
  /** Base64 MD5 of the file, as ActiveStorage's direct upload expects. */
  checksum: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  contentType: Scalars['String'];
  /** The name of the file being uploaded, as the browser reports it. */
  originalFilename: Scalars['String'];
};

/** Autogenerated return type of CreateCustomerTagImportMutation. */
export type GCreateCustomerTagImportMutationPayload = {
  __typename?: 'CreateCustomerTagImportMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  customerTagImport?: Maybe<GCustomerTagImport>;
  errors: Array<Scalars['String']>;
  /** Hand back to startCustomerTagImport once the PUT succeeds. */
  signedBlobId?: Maybe<Scalars['String']>;
  /** Send every one of these with the PUT, or storage refuses it. */
  uploadHeaders: Array<GCustomerTagImportUploadHeader>;
  /** PUT the file here. Expires, so upload promptly. */
  uploadUrl?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CreateCustomerTagMutation */
export type GCreateCustomerTagMutationInput = {
  /** What kind of audience the tag describes: when a location takes delivery, where it is, or what it sells. */
  category: GCustomerTagCategoryEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Display name for the new tag, e.g. "Brooklyn / Queens". Its slug is derived from this and cannot be changed later. */
  name: Scalars['String'];
};

/** Autogenerated return type of CreateCustomerTagMutation. */
export type GCreateCustomerTagMutationPayload = {
  __typename?: 'CreateCustomerTagMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  customerTag?: Maybe<GCustomerTag>;
  errors: Array<Scalars['String']>;
};

/** Autogenerated input type of CreateDeliveryOverrideRuleMutation */
export type GCreateDeliveryOverrideRuleMutationInput = {
  /** Which locations a `group` override reaches. Required for `group`, rejected otherwise. */
  audience?: InputMaybe<GDeliveryOverrideAudienceInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Block, substitute, or allow the day. Omit for an attribute-only override. */
  dayAction?: InputMaybe<GDeliveryOverrideDayActionEnum>;
  /** The date the override applies to. */
  deliveryDate: Scalars['ISO8601Date'];
  /** Override the order lead time (days) for this date only. */
  leadTime?: InputMaybe<Scalars['Int']>;
  /** Location UUID. Required for `lva` and `location` overrides; omitted for `group` and `vendor`; rejected for `market`. */
  locationId?: InputMaybe<Scalars['ID']>;
  /** Override the order cutoff ("HH:MM") for this date only. */
  orderDeadline?: InputMaybe<Scalars['String']>;
  /** Applies to a group or vendor rule that names a vendor. Defaults from the day action: block -> ALL, otherwise LVA_ONLY. */
  reachMode?: InputMaybe<GDeliveryOverrideReachModeEnum>;
  /** The grain the override targets. Defaults to a single location+vendor. */
  scope?: InputMaybe<GDeliveryOverrideScopeEnum>;
  /** The make-up delivery date. Required when dayAction is `substitute`. */
  substituteDeliveryDate?: InputMaybe<Scalars['ISO8601Date']>;
  /**
   * Vendor UUID. Required for `lva` and `vendor` overrides, omitted for a
   * `location` one. Optional for a `group`: omit it to reach every vendor serving
   * the audience. Rejected for `market`, which always reaches every vendor.
   */
  vendorId?: InputMaybe<Scalars['ID']>;
  /**
   * Warehouse UUID. The market the override applies in; omit to reach every
   * market. Must be the market its location sits in when the override names one.
   * Required for `market`.
   */
  warehouseId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of CreateDeliveryOverrideRuleMutation. */
export type GCreateDeliveryOverrideRuleMutationPayload = {
  __typename?: 'CreateDeliveryOverrideRuleMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  deliveryOverrideRule?: Maybe<GDeliveryOverrideRule>;
  errors?: Maybe<Array<GUserError>>;
};

/** Autogenerated input type of CreateDirectStripeCheckoutSessionMutation */
export type GCreateDirectStripeCheckoutSessionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Customer email (required if not authenticated) */
  email?: InputMaybe<Scalars['String']>;
  /** Human-readable integer ID of the pricing package (pricing_package_id field) */
  integerPricingPackageId: Scalars['Int'];
  /**
   * Complete URL for Stripe checkout return redirect. After checkout the user is
   * redirected back to this URL with a query param `stripe_checkout_session_id`.
   */
  returnPath: Scalars['String'];
  /** Sign color (required if material is not wood) */
  signColor?: InputMaybe<Scalars['String']>;
  /** Sign material (required if pricing package requires kit) */
  signMaterial?: InputMaybe<Scalars['String']>;
  /** Use Stripe Elements (custom ui_mode) instead of embedded checkout */
  useElements?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of CreateDirectStripeCheckoutSessionMutation. */
export type GCreateDirectStripeCheckoutSessionMutationPayload = {
  __typename?: 'CreateDirectStripeCheckoutSessionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Stripe client secret for checkout */
  clientSecret?: Maybe<Scalars['String']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']>;
  /** ID of the created StripeCheckoutSession */
  stripeCheckoutSessionId?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CreateExternalBaseBrandedItemMutation */
export type GCreateExternalBaseBrandedItemMutationInput = {
  /** Base item attributes */
  baseBrandedItem: GBaseBrandedItemInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  deliveryPrice: GMoneyInput;
  /** External item's procurement vendor */
  procurementVendor: Scalars['ID'];
  /** Variants of the item that are offered */
  variants: Array<GExternalBaseBrandedItemVariantInput>;
};

/** Autogenerated return type of CreateExternalBaseBrandedItemMutation. */
export type GCreateExternalBaseBrandedItemMutationPayload = {
  __typename?: 'CreateExternalBaseBrandedItemMutationPayload';
  baseBrandedItem?: Maybe<GBaseBrandedItem>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GUserError>;
};

/** Autogenerated input type of CreateExternalDeliveryMutation */
export type GCreateExternalDeliveryMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Order id denoting the order that should be delivered via the 3rd party delivery partner. */
  orderId: Scalars['ID'];
  /** The number of containers used to pack the order. */
  totalContainers: Scalars['Int'];
};

/** Autogenerated return type of CreateExternalDeliveryMutation. */
export type GCreateExternalDeliveryMutationPayload = {
  __typename?: 'CreateExternalDeliveryMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<GUserError>>;
  externalDelivery?: Maybe<GExternalDelivery>;
};

/** Autogenerated input type of CreateFieldServiceZipcodeMutation */
export type GCreateFieldServiceZipcodeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The warehouse uuid (the federated Warehouse.id) to serve this zip code from. */
  warehouseId: Scalars['ID'];
  /** A 5-digit zip code, e.g. "02134". Leading zeros are significant and preserved. */
  zipCode: Scalars['String'];
};

/** Autogenerated return type of CreateFieldServiceZipcodeMutation. */
export type GCreateFieldServiceZipcodeMutationPayload = {
  __typename?: 'CreateFieldServiceZipcodeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  fieldServiceZipcode?: Maybe<GFieldServiceZipcode>;
};

/** Autogenerated input type of CreateFullConsumerRefund */
export type GCreateFullConsumerRefundInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Consumer order ID. */
  consumerOrderId: Scalars['ID'];
  /**
   * Order's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
};

/** Autogenerated return type of CreateFullConsumerRefund */
export type GCreateFullConsumerRefundPayload = {
  __typename?: 'CreateFullConsumerRefundPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to create a full consumer refund. */
  result: GConsumerOrderResult;
};

/** Autogenerated input type of CreateGameMutation */
export type GCreateGameMutationInput = {
  /** Whether the game is active */
  active?: InputMaybe<Scalars['Boolean']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Description of the game */
  description?: InputMaybe<Scalars['String']>;
  /** Additional game metadata */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** Name of the game */
  name: Scalars['String'];
  /** URL-friendly identifier */
  slug: Scalars['String'];
};

/** Autogenerated return type of CreateGameMutation. */
export type GCreateGameMutationPayload = {
  __typename?: 'CreateGameMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']>;
  /** The created game */
  game?: Maybe<GGame>;
};

export type GCreateHomepageComponentInput = {
  collectionId: Scalars['ID'];
  componentId?: InputMaybe<Scalars['ID']>;
  desktopImage?: InputMaybe<Scalars['String']>;
  displayRule?: InputMaybe<GHomepageDisplayRuleUpsertInput>;
  fontStyle?: InputMaybe<Scalars['String']>;
  highlightImage?: InputMaybe<Scalars['String']>;
  mobileImage?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  rowId?: InputMaybe<Scalars['ID']>;
  warehouseIds: Array<Scalars['ID']>;
};

export type GCreateHomepageComponentPayload = {
  __typename?: 'CreateHomepageComponentPayload';
  componentId?: Maybe<Scalars['ID']>;
  componentType?: Maybe<GHomepageCollectionComponentType>;
  errors: Array<GHomepageComponentError>;
  ruleId?: Maybe<Scalars['ID']>;
};

export type GCreateHomepageDisplayRuleInput = {
  componentId: Scalars['ID'];
  endDate: Scalars['String'];
  position: Scalars['String'];
  startDate: Scalars['String'];
  warehouseIds: Array<Scalars['ID']>;
};

export type GCreateHomepageDisplayRulePayload = {
  __typename?: 'CreateHomepageDisplayRulePayload';
  errors: Array<GHomepageDisplayRuleError>;
  ruleId?: Maybe<Scalars['ID']>;
};

/** Autogenerated input type of CreateHubspotLead */
export type GCreateHubspotLeadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  hubspotOwnerId?: InputMaybe<Scalars['String']>;
  leadName?: InputMaybe<Scalars['String']>;
  leadType?: InputMaybe<Scalars['String']>;
  locationId: Scalars['ID'];
};

/** Autogenerated return type of CreateHubspotLead. */
export type GCreateHubspotLeadPayload = {
  __typename?: 'CreateHubspotLeadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errorCode?: Maybe<Scalars['String']>;
  leadId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of CreateInHouseBaseBrandedItemMutation */
export type GCreateInHouseBaseBrandedItemMutationInput = {
  /** Base item attributes */
  baseBrandedItem: GBaseBrandedItemInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** In-house item's associated supply item */
  supplyItem: Scalars['ID'];
  /** Variants of the item that are offered */
  variants: Array<GInHouseBaseBrandedItemVariantInput>;
};

/** Autogenerated return type of CreateInHouseBaseBrandedItemMutation. */
export type GCreateInHouseBaseBrandedItemMutationPayload = {
  __typename?: 'CreateInHouseBaseBrandedItemMutationPayload';
  baseBrandedItem?: Maybe<GBaseBrandedItem>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GUserError>;
};

/** Autogenerated input type of CreateLeaderboardMutation */
export type GCreateLeaderboardMutationInput = {
  /** Whether the leaderboard is active */
  active?: InputMaybe<Scalars['Boolean']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Slug of the game */
  gameSlug: Scalars['String'];
  /** Type of leaderboard */
  leaderboardType?: InputMaybe<GLeaderboardTypeEnum>;
  /** Additional leaderboard metadata */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** ID of the microsite location */
  micrositeLocationId: Scalars['ID'];
  /** Name of the leaderboard */
  name: Scalars['String'];
  /** When the leaderboard resets */
  resetSchedule?: InputMaybe<Scalars['String']>;
  /** How scores are aggregated */
  scoreOperator?: InputMaybe<GScoreOperatorEnum>;
  /** URL-friendly identifier */
  slug: Scalars['String'];
  /** How scores are sorted */
  sortOrder?: InputMaybe<GSortOrderEnum>;
};

/** Autogenerated return type of CreateLeaderboardMutation. */
export type GCreateLeaderboardMutationPayload = {
  __typename?: 'CreateLeaderboardMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']>;
  /** The created leaderboard */
  leaderboard?: Maybe<GLeaderboard>;
};

/** Autogenerated input type of CreateLocationMutation */
export type GCreateLocationMutationInput = {
  /** Street address line 1 */
  addressLine1: Scalars['String'];
  /** Street address line 2 (apt, suite, etc.) */
  addressLine2?: InputMaybe<Scalars['String']>;
  /** City / locality */
  city: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Required for admin actors; ignored for customer-role actors. */
  companyOdekoUuid?: InputMaybe<Scalars['ID']>;
  /** ISO 3166-1 alpha-2 country code (default US) */
  countryCode?: InputMaybe<Scalars['String']>;
  /** County / admin district level 2 */
  county?: InputMaybe<Scalars['String']>;
  /** Odeko display name for the location */
  displayName: Scalars['String'];
  /** Google Places place_id for the address */
  googlePlaceId?: InputMaybe<Scalars['String']>;
  /** Latitude in decimal degrees */
  latitude?: InputMaybe<Scalars['Float']>;
  /** Longitude in decimal degrees */
  longitude?: InputMaybe<Scalars['Float']>;
  /** Postal / ZIP code */
  postalCode: Scalars['String'];
  /** State / admin district (ISO 3166-2 subdivision code) */
  state: Scalars['String'];
  /** UTC offset in minutes from Google Places (used to derive Olson timezone) */
  utcOffsetMinutes?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of CreateLocationMutation. */
export type GCreateLocationMutationPayload = {
  __typename?: 'CreateLocationMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GUserError>;
  location?: Maybe<GLocation>;
};

/** Autogenerated input type of CreateLocationVendorAssociationMutation */
export type GCreateLocationVendorAssociationMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Location UUID */
  locationUuid: Scalars['ID'];
  /** Vendor UUID */
  vendorUuid: Scalars['ID'];
};

/** Autogenerated return type of CreateLocationVendorAssociationMutation. */
export type GCreateLocationVendorAssociationMutationPayload = {
  __typename?: 'CreateLocationVendorAssociationMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<GUserError>>;
  lvaExisted?: Maybe<Scalars['Boolean']>;
  succeeded: Scalars['Boolean'];
};

/** Autogenerated input type of CreateMarketingToolsManagerMutation */
export type GCreateMarketingToolsManagerMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The email address for the marketing tools manager */
  email: Scalars['String'];
  /** The first name of the marketing tools manager */
  firstName: Scalars['String'];
  /** The last name of the marketing tools manager */
  lastName: Scalars['String'];
  /** The password for the marketing tools manager (optional - will generate if not provided) */
  password?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CreateMarketingToolsManagerMutation. */
export type GCreateMarketingToolsManagerMutationPayload = {
  __typename?: 'CreateMarketingToolsManagerMutationPayload';
  /**
   * The Auth0 user ID of the created marketing tools manager. Useful in contexts
   * like a sign up flow where we may be prohibited from returning the full user object.
   */
  auth0UserId?: Maybe<Scalars['String']>;
  authorization?: Maybe<GSigninAuthorization>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  credentials?: Maybe<GSigninCredentials>;
  errors: Array<GUserError>;
  user?: Maybe<GUser>;
};

/** Autogenerated input type of CreateMenu */
export type GCreateMenuInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Odeko uuid for the merchant */
  merchantUuid: Scalars['ID'];
  /** Name of the menu */
  name: Scalars['String'];
  /** The order of the menu in the UI. If omitted, the menu will be appended to the end of the merchant's menus. */
  sortOrder?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of CreateMenuItem */
export type GCreateMenuItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Description. */
  description: Scalars['String'];
  /** Whether the menu item is hot. */
  isHot?: InputMaybe<Scalars['Boolean']>;
  /** Name of the menu item */
  name: Scalars['String'];
  /** Sizes of menu items. */
  sizes: Array<GMenuItemSizeInput>;
  /** The order of the menu item in the UI. If omitted, the menu item will be appended to the end of the submenu's items. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Submenu ID */
  submenuId: Scalars['ID'];
  /** Tax rate expressed as a percentage. If omitted, taxes will be calculated based on the rate set on the menu or merchant. */
  taxRate?: InputMaybe<Scalars['Float']>;
};

/** Autogenerated return type of CreateMenuItem */
export type GCreateMenuItemPayload = {
  __typename?: 'CreateMenuItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of creating menu */
  result: GMenuItemResult;
};

/** Autogenerated return type of CreateMenu */
export type GCreateMenuPayload = {
  __typename?: 'CreateMenuPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of creating menu */
  result: GMenuResult;
};

/** Autogenerated input type of CreateMicrositeLocationMutation */
export type GCreateMicrositeLocationMutationInput = {
  /** Business address (optional, used for geocoding timezone) */
  businessAddress?: InputMaybe<Scalars['String']>;
  /** Business name (required if google_place_id not provided) */
  businessName?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Google Places API place ID (mutually exclusive with business_name) */
  googlePlaceId?: InputMaybe<Scalars['String']>;
  /** Stripe checkout session ID to associate with the microsite */
  stripeCheckoutSessionId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CreateMicrositeLocationMutation. */
export type GCreateMicrositeLocationMutationPayload = {
  __typename?: 'CreateMicrositeLocationMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']>;
  /** The created microsite location */
  micrositeLocation?: Maybe<GMicrositeLocation>;
};

/** Autogenerated input type of CreateOrderReconciliationAttachmentUploadRequestMutation */
export type GCreateOrderReconciliationAttachmentUploadRequestMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CreateOrderReconciliationAttachmentUploadRequestMutation. */
export type GCreateOrderReconciliationAttachmentUploadRequestMutationPayload = {
  __typename?: 'CreateOrderReconciliationAttachmentUploadRequestMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GUserError>;
  objectKey?: Maybe<Scalars['String']>;
  presignedUrl?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CreateOrderReconciliationMutation */
export type GCreateOrderReconciliationMutationInput = {
  /**
   * Attachments keys related to the reconciliation (e.g images, videos, etc.).
   * Attachment ids must be generated via
   * CreateOrderReconciliationAttachmentUploadRequestMutation
   */
  attachmentsIds?: InputMaybe<Array<Scalars['String']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Additional description for the reconciliation */
  description?: InputMaybe<Scalars['String']>;
  /** ID of the item to reconcile */
  itemId: Scalars['ID'];
  /** ID of the order to reconcile */
  orderId: Scalars['ID'];
  /** UUID of the order line to reconcile. When provided with feature flag enabled, supersedes item_id lookup */
  orderLineId?: InputMaybe<Scalars['ID']>;
  /** Reasons for reconciliation (e.g., Missing Item, Wrong Item, etc.) */
  reasons: Array<GOrderReconciliationReasonEnum>;
  /** The reconciled quantity for the order */
  reconciledQuantity: Scalars['Int'];
};

/** Autogenerated return type of CreateOrderReconciliationMutation. */
export type GCreateOrderReconciliationMutationPayload = {
  __typename?: 'CreateOrderReconciliationMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<GUserError>>;
  reconciledOrderLine?: Maybe<GReconciledOrderLine>;
};

/** Autogenerated input type of CreatePartialConsumerRefund */
export type GCreatePartialConsumerRefundInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Consumer order ID. */
  consumerOrderId: Scalars['ID'];
  /**
   * Order's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
  /** Collection describing the item units to be refunded. */
  refundItemInputs: Array<GConsumerRefundItemInput>;
  /** Collection describing the modifier units to be refunded. */
  refundModifierInputs: Array<GConsumerRefundModifierInput>;
};

/** Autogenerated return type of CreatePartialConsumerRefund */
export type GCreatePartialConsumerRefundPayload = {
  __typename?: 'CreatePartialConsumerRefundPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to create a partial consumer refund. */
  result: GConsumerOrderResult;
};

/** Autogenerated input type of CreateReceivableNote */
export type GCreateReceivableNoteInput = {
  authorEmail: Scalars['String'];
  body: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  invoiceUuid?: InputMaybe<Scalars['String']>;
  locationUuid: Scalars['String'];
};

/** Autogenerated return type of CreateReceivableNote. */
export type GCreateReceivableNotePayload = {
  __typename?: 'CreateReceivableNotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  receivableNote?: Maybe<GReceivableNote>;
};

/** Autogenerated input type of CreateSalesTaxEstimateMutation */
export type GCreateSalesTaxEstimateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Date. Defaults to current date in vendor's time zone. */
  date?: InputMaybe<Scalars['ISO8601Date']>;
  /** Line items */
  lines: Array<GSalesTaxLineInput>;
  /** Location UUID */
  locationId: Scalars['ID'];
  /** Vendor UUID */
  vendorId: Scalars['ID'];
};

/** Autogenerated return type of CreateSalesTaxEstimateMutation. */
export type GCreateSalesTaxEstimateMutationPayload = {
  __typename?: 'CreateSalesTaxEstimateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<GUserError>>;
  salesTaxEstimate?: Maybe<GSalesTaxEstimate>;
};

/** Autogenerated input type of CreateSignPurchaseCheckoutSessionMutation */
export type GCreateSignPurchaseCheckoutSessionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the microsite location to associate with the sign purchase */
  micrositeLocationId: Scalars['ID'];
  /** Initial quantity of signs (minimum 1, default 1) */
  quantity?: InputMaybe<Scalars['Int']>;
  /** Complete URL for Stripe checkout return redirect */
  returnPath: Scalars['String'];
  /** Sign color (required if material is not wood) */
  signColor?: InputMaybe<Scalars['String']>;
  /** Sign material */
  signMaterial: Scalars['String'];
  /** Use Stripe Elements (custom ui_mode) instead of embedded checkout */
  useElements?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of CreateSignPurchaseCheckoutSessionMutation. */
export type GCreateSignPurchaseCheckoutSessionMutationPayload = {
  __typename?: 'CreateSignPurchaseCheckoutSessionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Stripe client secret for checkout */
  clientSecret?: Maybe<Scalars['String']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']>;
  /** ID of the created StripeCheckoutSession */
  stripeCheckoutSessionId?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CreateSquareOrderSuggestionFromTranscriptMutation */
export type GCreateSquareOrderSuggestionFromTranscriptMutationInput = {
  /** The external profile ID (entityId) for the Square connection */
  accountProfileId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The voice transcript containing the customer's order */
  transcript: Scalars['String'];
};

/** Autogenerated return type of CreateSquareOrderSuggestionFromTranscriptMutation. */
export type GCreateSquareOrderSuggestionFromTranscriptMutationPayload = {
  __typename?: 'CreateSquareOrderSuggestionFromTranscriptMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']>;
  /** The created order suggestion */
  orderSuggestion?: Maybe<GSquareOrderSuggestion>;
};

/** Autogenerated input type of CreateStorageAreaMutation */
export type GCreateStorageAreaMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** PROTOTYPE The Odeko UUID of the location. */
  locationId: Scalars['ID'];
  /** PROTOTYPE The name of the storage area in the location. */
  name: Scalars['String'];
};

/** Autogenerated return type of CreateStorageAreaMutation. */
export type GCreateStorageAreaMutationPayload = {
  __typename?: 'CreateStorageAreaMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  storageArea?: Maybe<GLocationStorageArea>;
};

/** Autogenerated input type of CreateStripeCheckoutSessionMutation */
export type GCreateStripeCheckoutSessionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Custom return URL for Stripe checkout (will append stripe_checkout_session_id parameter) */
  returnUrl?: InputMaybe<Scalars['String']>;
  /** ID of existing subscription session */
  subscriptionSessionId: Scalars['ID'];
  /** Use Stripe Elements (custom ui_mode) instead of embedded checkout */
  useElements?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of CreateStripeCheckoutSessionMutation. */
export type GCreateStripeCheckoutSessionMutationPayload = {
  __typename?: 'CreateStripeCheckoutSessionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Stripe client secret for embedded checkout */
  clientSecret?: Maybe<Scalars['String']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']>;
};

/** Autogenerated input type of CreateSubmenu */
export type GCreateSubmenuInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Menu ID */
  menuId: Scalars['ID'];
  /** Name of the menu */
  name: Scalars['String'];
  /** The order of the menu in the UI. If omitted, the menu will be appended to the end of the merchant's menus. */
  sortOrder?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of CreateSubmenu */
export type GCreateSubmenuPayload = {
  __typename?: 'CreateSubmenuPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of creating menu */
  result: GSubmenuResult;
};

/** Autogenerated input type of CreateSupplierInvoiceComparison */
export type GCreateSupplierInvoiceComparisonInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  prospectiveLocationAddress?: InputMaybe<Scalars['String']>;
  prospectiveLocationName?: InputMaybe<Scalars['String']>;
  warehouseId: Scalars['ID'];
};

/** Autogenerated return type of CreateSupplierInvoiceComparison. */
export type GCreateSupplierInvoiceComparisonPayload = {
  __typename?: 'CreateSupplierInvoiceComparisonPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  supplierInvoiceComparison?: Maybe<GSupplierInvoiceComparison>;
};

/** Autogenerated input type of CreateSupplierInvoice */
export type GCreateSupplierInvoiceInput = {
  byteSize: Scalars['Int'];
  checksum: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  contentType: Scalars['String'];
  externalSupplierId?: InputMaybe<Scalars['ID']>;
  externalSupplierName?: InputMaybe<Scalars['String']>;
  invoiceDate?: InputMaybe<Scalars['ISO8601Date']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  originalFilename: Scalars['String'];
  position?: InputMaybe<Scalars['Int']>;
  supplierInvoiceComparisonId: Scalars['ID'];
};

/** Autogenerated return type of CreateSupplierInvoice. */
export type GCreateSupplierInvoicePayload = {
  __typename?: 'CreateSupplierInvoicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  signedBlobId?: Maybe<Scalars['String']>;
  supplierInvoice?: Maybe<GSupplierInvoice>;
  supplierInvoiceComparison?: Maybe<GSupplierInvoiceComparison>;
  uploadHeaders: Array<GDirectUploadHeader>;
  uploadUrl?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CreateUserMicrositeLocation */
export type GCreateUserMicrositeLocationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Integer ID of the pricing package to associate with the user */
  integerPricingPackageId?: InputMaybe<Scalars['Int']>;
  /** ID of the microsite location to associate with the user */
  micrositeLocationId: Scalars['ID'];
  /** Auth0 ID of the user to associate with the microsite */
  userId: Scalars['ID'];
};

/** Autogenerated return type of CreateUserMicrositeLocation. */
export type GCreateUserMicrositeLocationPayload = {
  __typename?: 'CreateUserMicrositeLocationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userMicrositeLocation: GUserMicrositeLocation;
};

/** Autogenerated input type of CreateUserMutation */
export type GCreateUserMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Required for admin actors; ignored for customer-role actors. */
  companyOdekoUuid?: InputMaybe<Scalars['ID']>;
  /** The email address for the new user */
  email: Scalars['String'];
  /** The first name of the new user */
  firstName: Scalars['String'];
  /** The last name of the new user */
  lastName: Scalars['String'];
  /** Odeko UUIDs of the locations the new user should have access to */
  locationOdekoUuids: Array<Scalars['String']>;
  /** Optional phone number for the new user */
  phone?: InputMaybe<Scalars['String']>;
  /** The role to assign to the new user */
  role: Scalars['String'];
};

/** Autogenerated return type of CreateUserMutation. */
export type GCreateUserMutationPayload = {
  __typename?: 'CreateUserMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GUserError>;
  user?: Maybe<GUser>;
};

/** Autogenerated input type of CreateWorkThread */
export type GCreateWorkThreadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

/** Autogenerated return type of CreateWorkThread. */
export type GCreateWorkThreadPayload = {
  __typename?: 'CreateWorkThreadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  event?: Maybe<GWorkThreadEvent>;
  workThread?: Maybe<GWorkThread>;
};

/**
 * A group that refers to a credit application, i.e. a credit amount that was
 * partially or fully applied to an invoice from a given credit memo.
 */
export type GCreditApplication = GPaymentInvoiceGroup & {
  __typename?: 'CreditApplication';
  /**
   * Invoices in the group. This collection, although not paginated, is expressed
   * as a connection type in order to include the amount of payment associated with
   * each invoice via PaymentEarmark/PaymentUsage edge info.
   */
  invoices: GFinancialTransactionConnection;
  /** Credit amount applied to a given invoice. */
  paymentAmount: GMoney;
  /** Date on which the credit was applied. */
  paymentDate: Scalars['ISO8601Date'];
};

export type GCreditCard = {
  __typename?: 'CreditCard';
  billingDetails: GBillingDetails;
  brand: Scalars['String'];
  /**
   * Locations for which this payment method is currently the default. Lists every
   * such location, including ones the viewer is not individually assigned to, so a
   * caller can state the true scope of removing the method. Empty when the method
   * is nobody's default.
   */
  defaultForLocations: Array<GPaymentMethodDefaultLocation>;
  expMonth: Scalars['Int'];
  expYear: Scalars['Int'];
  /** Stripe card funding type: credit, debit, prepaid or unknown */
  funding?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  last4: Scalars['String'];
  lastPaymentError?: Maybe<GPaymentError>;
};

/** Edge connecting a credit-memo to the invoice from which credit was issued. */
export type GCreditIssuance = GFinancialTransactionEdgeInfo & {
  __typename?: 'CreditIssuance';
  _?: Maybe<Scalars['String']>;
};

/** Error indicating that a Credit Key account could not be found. */
export type GCreditKeyAccountNotFound = GError & {
  __typename?: 'CreditKeyAccountNotFound';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating that the Credit Key account is not usable. */
export type GCreditKeyAccountNotUsable = GError & {
  __typename?: 'CreditKeyAccountNotUsable';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Edge connecting a credit-memo to a transaction (e.g. invoice) on which credit was used. */
export type GCreditUsage = GFinancialTransactionEdgeInfo & {
  __typename?: 'CreditUsage';
  _?: Maybe<Scalars['String']>;
  /** Amount of credit used. */
  amount: GMoney;
  /** Date on which credit was used. */
  date: Scalars['ISO8601Date'];
};

/** Error indicating that curbside pickup cannot be requested because merchant has not enabled curbside pickup. */
export type GCurbsidePickupNotEnabled = GError & {
  __typename?: 'CurbsidePickupNotEnabled';
  /** A description of the error. */
  message: Scalars['String'];
};

export enum GCurrency {
  Usd = 'USD'
}

/** PROTOTYPE For a location item and stock count session, return the latest count. */
export type GCurrentCount = {
  __typename?: 'CurrentCount';
  /** PROTOTYPE when the quantity was recorded. */
  countedAt: Scalars['ISO8601DateTime'];
  /**
   * PROTOTYPE if counted using a custom LocationCountingUnit, that unit.null if an
   * Odeko sales unit was used instead. In that case, salesUnitId is present.
   */
  locationCountingUnit?: Maybe<GLocationCountingUnit>;
  /**
   * PROTOTYPE id of the stock count session. Included so that together with
   * stock_count_id, this is normalizeable by Apollo Client.
   */
  locationItemId: Scalars['ID'];
  /** PROTOTYPE the value entered for the count. May be null. */
  quantity?: Maybe<Scalars['Float']>;
  /**
   * PROTOTYPE if counted using the Odeko sales unit, the id of that unit.null if a
   * customer LocationCountingUnit was used instead. In that case,
   * locationCountingUnit is present.
   */
  salesUnitId?: Maybe<Scalars['ID']>;
  /**
   * PROTOTYPE id of the LocationStockCount session. Included so that together with
   * location_item_id, this type is normalizeable by Apollo Client.
   */
  stockCountId: Scalars['ID'];
};

export type GCustomBrandedItem = {
  __typename?: 'CustomBrandedItem';
  baseBrandedItem: GBaseBrandedItem;
  brandedItemArtwork?: Maybe<GBrandedItemArtwork>;
  color: GColor;
  /** Price that the color associated with the item was charged at per case */
  colorPricePerUnit: GMoney;
  id: Scalars['ID'];
  /** Price that we sold the item at */
  salesPrice: GMoney;
  /** One time cost to setup the item for the customer */
  setupFee: GMoney;
};

export type GCustomBrandedItemInput = {
  /** Base branded item id */
  baseBrandedItemId: Scalars['ID'];
  /** Branded item artwork id */
  brandedItemArtworkId?: InputMaybe<Scalars['ID']>;
  /** Color id */
  colorId: Scalars['ID'];
  /** Price that we charge for Color per sales unit */
  colorPricePerUnit: GMoneyInput;
  /** Price that we sold the item at */
  salesPrice: GMoneyInput;
  /** One time cost to setup the item for the customer */
  setupFee: GMoneyInput;
};

export type GCustomIngredient = {
  __typename?: 'CustomIngredient';
  brand: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  purchasePrice: GMoney;
  purchaseUnit: GUnit;
  purchaseVendor?: Maybe<Scalars['String']>;
  sizeQuantity: Scalars['Float'];
  sizeUnit: GUnit;
};

export type GCustomPrice = {
  __typename?: 'CustomPrice';
  customPrice: GMoney;
  item: GSupplyItem;
  location: GLocation;
};

/** Whether autopay is ready to be scheduled, shown separately from the enabled choice. */
export enum GCustomerAutopayActivationStateEnum {
  /** Autopay is on but this service's settings projection or billing marker has not caught up. */
  Activating = 'ACTIVATING',
  /** Autopay is off. */
  Off = 'OFF',
  /** Autopay is on and the daily run's prerequisites are present. Not a promise that a charge will succeed. */
  Ready = 'READY',
  /** Autopay is on but a supported default method or billing account prerequisite is missing. */
  SetupRequired = 'SETUP_REQUIRED',
  /** Authoritative billing settings could not be read. */
  Unavailable = 'UNAVAILABLE'
}

export type GCustomerAutopayError = {
  __typename?: 'CustomerAutopayError';
  code: GCustomerAutopayErrorCodeEnum;
  message: Scalars['String'];
};

/** Why a setLocationAutopay submission was refused. A refusal changed nothing. */
export enum GCustomerAutopayErrorCodeEnum {
  BillingUnavailable = 'BILLING_UNAVAILABLE',
  FeatureUnavailable = 'FEATURE_UNAVAILABLE',
  FinanceManaged = 'FINANCE_MANAGED',
  Forbidden = 'FORBIDDEN',
  LocationNotFound = 'LOCATION_NOT_FOUND',
  PaymentMethodRequired = 'PAYMENT_METHOD_REQUIRED',
  /**
   * The request ID belongs to a different submission. Only this submission is
   * refused; the earlier request keeps its own outcome.
   */
  RequestIdConflict = 'REQUEST_ID_CONFLICT',
  /** Another autopay change for this location is still being processed. */
  RequestPending = 'REQUEST_PENDING',
  SettingsChanged = 'SETTINGS_CHANGED',
  SetupIncomplete = 'SETUP_INCOMPLETE'
}

/** Why a customer autopay change is limited or unavailable. */
export enum GCustomerAutopayReasonEnum {
  /** Authoritative billing settings could not be read. */
  BillingUnavailable = 'BILLING_UNAVAILABLE',
  /** Customer autopay changes are not available to this caller yet. */
  FeatureUnavailable = 'FEATURE_UNAVAILABLE',
  /** Unlimited debt or a nonstandard grace period; support manages autopay here. */
  FinanceManaged = 'FINANCE_MANAGED',
  /** The caller may not change autopay for this location. */
  Forbidden = 'FORBIDDEN',
  /** No supported default payment method; blocks turning autopay on. */
  PaymentMethodRequired = 'PAYMENT_METHOD_REQUIRED',
  /** An earlier autopay change for this location is still being processed. */
  RequestPending = 'REQUEST_PENDING',
  /** The billing account is not ready to be scheduled; blocks turning autopay on. */
  SetupIncomplete = 'SETUP_INCOMPLETE'
}

/** The settings billing committed for an accepted request. Immutable; may be superseded by later changes. */
export type GCustomerAutopayReceipt = {
  __typename?: 'CustomerAutopayReceipt';
  enabled: Scalars['Boolean'];
  gracePeriodDays?: Maybe<Scalars['Int']>;
  revision: Scalars['String'];
};

export enum GCustomerAutopayReconciliationStateEnum {
  /** This service's settings projection and billing marker match the committed settings. */
  Converged = 'CONVERGED',
  /** The committed settings have not reached this service. */
  Divergent = 'DIVERGENT',
  /** The request was not accepted. */
  NotApplicable = 'NOT_APPLICABLE',
  /** Not checked yet. */
  Pending = 'PENDING',
  /** Settings changed again after this request; current settings win. */
  Superseded = 'SUPERSEDED'
}

/** One customer request to turn autopay on or off for a location. */
export type GCustomerAutopayRequest = {
  __typename?: 'CustomerAutopayRequest';
  /** Billing's change ID; set once accepted. */
  changeId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['ISO8601DateTime'];
  /** The requested state. */
  enabled: Scalars['Boolean'];
  /** Set once rejected. */
  errorCode?: Maybe<GCustomerAutopayErrorCodeEnum>;
  /** What billing committed; set once accepted. */
  receipt?: Maybe<GCustomerAutopayReceipt>;
  reconciliationState: GCustomerAutopayReconciliationStateEnum;
  requestId: Scalars['ID'];
  resolvedAt?: Maybe<Scalars['ISO8601DateTime']>;
  status: GCustomerAutopayRequestStatusEnum;
};

export enum GCustomerAutopayRequestStatusEnum {
  /** Billing committed the requested state. */
  Accepted = 'ACCEPTED',
  /** Admitted; the billing outcome is not known yet. Replay the identical input to check. */
  Pending = 'PENDING',
  /** Refused; nothing changed for this submission. */
  Rejected = 'REJECTED'
}

/** Autopay status and customer controls for one location. */
export type GCustomerAutopaySettings = {
  __typename?: 'CustomerAutopaySettings';
  activationState: GCustomerAutopayActivationStateEnum;
  billingMarkerPresent: Scalars['Boolean'];
  /** The location's policy lets customers change autopay. Independent of rolloutAvailable. */
  canManage: Scalars['Boolean'];
  /** Billing's authoritative autopay setting. Null exactly when activationState is UNAVAILABLE. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** Null means unlimited debt. */
  gracePeriodDays?: Maybe<Scalars['Int']>;
  /** The most recent request for this location. */
  latestRequest?: Maybe<GCustomerAutopayRequest>;
  locationUuid: Scalars['ID'];
  /** The unresolved request for this location, if any. */
  pendingRequest?: Maybe<GCustomerAutopayRequest>;
  reasons: Array<GCustomerAutopayReasonEnum>;
  /** Opaque; send back as expectedRevision. Null exactly when activationState is UNAVAILABLE. */
  revision?: Maybe<Scalars['String']>;
  rolloutAvailable: Scalars['Boolean'];
  setupComplete: Scalars['Boolean'];
};

/** Provide basic information about a raw CustomerCsvUpload. Each row of a CustomerCsvUpload generates an InProgressCustomer. */
export type GCustomerCsvUpload = {
  __typename?: 'CustomerCsvUpload';
  /** The filename (basename and extension) of the uploaded CSV. */
  filename: Scalars['String'];
  id: Scalars['ID'];
};

export type GCustomerDeliveryTracking = {
  __typename?: 'CustomerDeliveryTracking';
  /**
   * Computed order delivery status once this delivery attempt is complete; null
   * while tracking may still continue. Omitted on disabled tracking responses.
   */
  deliveryStatus?: Maybe<GOrderDeliveryStatus>;
  deliveryTimeZone?: Maybe<Scalars['String']>;
  destination?: Maybe<GCustomerTrackingPoint>;
  driverVisible: Scalars['Boolean'];
  enabled: Scalars['Boolean'];
  expiresAt?: Maybe<Scalars['ISO8601DateTime']>;
  generatedAt: Scalars['ISO8601DateTime'];
  isCancelled: Scalars['Boolean'];
  pageAvailable: Scalars['Boolean'];
  position?: Maybe<GCustomerTrackingPoint>;
  scheduledEnd?: Maybe<Scalars['ISO8601DateTime']>;
  scheduledStart?: Maybe<Scalars['ISO8601DateTime']>;
  /** Remaining customer stops before this delivery, only while tracking eligibility is valid. */
  stopsBeforeDelivery?: Maybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type GCustomerLocationEdge = {
  __typename?: 'CustomerLocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GLocation>;
};

/** The connection type for Location. */
export type GCustomerLocationsConnection = {
  __typename?: 'CustomerLocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GCustomerLocationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GLocation>>>;
  /** Information to aid in pagination. */
  pageInfo: GPageInfo;
  /** The total count of records in the connection. */
  totalCount: Scalars['Int'];
};

export type GCustomerLocationsInput = {
  warehouseId?: InputMaybe<Scalars['ID']>;
};

export type GCustomerTag = {
  __typename?: 'CustomerTag';
  /** How many locations currently carry this tag. */
  assignedLocationCount: Scalars['Int'];
  /** For an auto-generated tag, the rule that decides which locations carry it. */
  autoDefinition?: Maybe<Scalars['JSON']>;
  /** What kind of audience this tag describes: when a location takes delivery, where it is, or what it sells. */
  category: GCustomerTagCategoryEnum;
  /** When the tag was deleted, or null if it is still live. */
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  /** The tag's display name, e.g. "Brooklyn / Queens". */
  name: Scalars['String'];
  /** Governance namespace the tag belongs to (e.g. "operations"). */
  scope: Scalars['String'];
  /** Unique, stable identifier used when targeting the tag. */
  slug: Scalars['String'];
  /** Whether the tag is maintained manually or auto-generated. */
  source: GCustomerTagSourceEnum;
};

export type GCustomerTagAssignment = {
  __typename?: 'CustomerTagAssignment';
  /** When the tag was applied to this location. */
  assignedAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  /** The tag itself. */
  tag: GCustomerTag;
};

export enum GCustomerTagCategoryEnum {
  /** Location-based audiences (e.g. a city, state, or region). */
  Geography = 'GEOGRAPHY',
  /** Product-based audiences (e.g. fresh pastry). */
  Product = 'PRODUCT',
  /** Routing-cohort audiences (e.g. a delivery route or zone). */
  Routing = 'ROUTING',
  /** Time-of-delivery audiences (e.g. day vs. night). */
  Timing = 'TIMING'
}

/** The connection type for CustomerTag. */
export type GCustomerTagConnection = {
  __typename?: 'CustomerTagConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GCustomerTagEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GCustomerTag>>>;
  /** Information to aid in pagination. */
  pageInfo: GPageInfo;
  /** The total count of records in the connection. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type GCustomerTagEdge = {
  __typename?: 'CustomerTagEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GCustomerTag>;
};

/** Locations carrying a set of customer tags. */
export type GCustomerTagFilterInput = {
  /** Ids of the tags, as returned by CustomerTag.id. Deleted tags contribute no locations. */
  ids: Array<Scalars['ID']>;
  /** Whether a location must carry every one of these tags or just one of them. Defaults to carrying any. */
  matchMode?: InputMaybe<GCustomerTagMatchModeEnum>;
};

/** A bulk customer-tag CSV upload, and the record of what it did. */
export type GCustomerTagImport = {
  __typename?: 'CustomerTagImport';
  /** Rows that resulted in a tag being applied or withdrawn. */
  appliedRowCount: Scalars['Int'];
  /** Stores whose tags actually changed, which is fewer than appliedRowCount when a file names one store on several rows. */
  changedLocationCount: Scalars['Int'];
  /** One entry per refused row: row, odekoUuid, tagSlug, action, message. */
  errorRows: Array<Scalars['JSON']>;
  /** Rows refused. Matches the length of errorRows. */
  failedRowCount: Scalars['Int'];
  /**
   * Why the import stopped when no single row was to blame — an unreadable file, a
   * missing header, a missing upload. Row-level refusals leave this null and
   * appear in errorRows instead.
   */
  failureReason?: Maybe<Scalars['String']>;
  /** The name the file was uploaded under. */
  filename: Scalars['String'];
  /** Whether the import has stopped, and polling can stop with it. */
  finished: Scalars['Boolean'];
  finishedAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  /** Data rows read from the file, excluding the header. */
  rowCount: Scalars['Int'];
  startedAt?: Maybe<Scalars['ISO8601DateTime']>;
  status: GCustomerTagImportStatusEnum;
};

export enum GCustomerTagImportStatusEnum {
  /** Tag changes are being written. */
  Applying = 'APPLYING',
  /** Finished, though individual rows may still have been refused. */
  Completed = 'COMPLETED',
  /** Stopped without finishing. */
  Failed = 'FAILED',
  /** Created, but the file has not arrived yet. */
  Pending = 'PENDING',
  /** The file has arrived and is waiting to be picked up. */
  Uploaded = 'UPLOADED',
  /** The file is being checked; nothing has been written. */
  Validating = 'VALIDATING'
}

/** A header the browser must send with its upload request. */
export type GCustomerTagImportUploadHeader = {
  __typename?: 'CustomerTagImportUploadHeader';
  name: Scalars['String'];
  value: Scalars['String'];
};

export enum GCustomerTagMatchModeEnum {
  /** A location matches only if it carries every one of the tags. */
  All = 'ALL',
  /** A location matches if it carries at least one of the tags. */
  Any = 'ANY'
}

export enum GCustomerTagSortFieldEnum {
  /** How many locations currently carry the tag. */
  AssignedLocationCount = 'ASSIGNED_LOCATION_COUNT',
  /** The tag's category. */
  Category = 'CATEGORY',
  /** The tag's display name. */
  Name = 'NAME',
  /** The tag's slug. */
  Slug = 'SLUG',
  /** How the tag is maintained. */
  Source = 'SOURCE'
}

/** Orders the customer tag catalog. Ties fall back to name, then to creation order. */
export type GCustomerTagSortInput = {
  direction?: InputMaybe<GSortDirectionEnum>;
  field: GCustomerTagSortFieldEnum;
};

export enum GCustomerTagSourceEnum {
  /** Derived automatically from vendor/catalog data. */
  Auto = 'AUTO',
  /** Assigned by a person. */
  Manual = 'MANUAL'
}

export type GCustomerTrackingPoint = {
  __typename?: 'CustomerTrackingPoint';
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  observedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type GCustomerTrackingSettings = {
  __typename?: 'CustomerTrackingSettings';
  driverRadiusMiles: Scalars['Float'];
  driverStops: Scalars['Int'];
  endHour: Scalars['Int'];
  mode: Scalars['String'];
  pageRadiusMiles: Scalars['Float'];
  pageStops: Scalars['Int'];
  policy: Scalars['String'];
  revision: Scalars['Int'];
  startHour: Scalars['Int'];
  timeZone?: Maybe<Scalars['String']>;
};

export type GCustomerTrackingSettingsInput = {
  driverRadiusMiles: Scalars['Float'];
  driverStops: Scalars['Int'];
  endHour: Scalars['Int'];
  mode: Scalars['String'];
  pageRadiusMiles: Scalars['Float'];
  pageStops: Scalars['Int'];
  policy: Scalars['String'];
  startHour: Scalars['Int'];
};

/** A single vendor/LVA delivery rule, for eyeballing the cutoff baseline. */
export type GCutoffDeliveryRule = {
  __typename?: 'CutoffDeliveryRule';
  /** Delivery weekday, e.g. "Monday". */
  deliveryDay: Scalars['String'];
  /** Lead time in days from cutoff to delivery. */
  leadTimeDays?: Maybe<Scalars['Int']>;
  /** Order deadline (cutoff) time of day, e.g. "12:00". */
  orderDeadline?: Maybe<Scalars['String']>;
};

export type GCutoffDiscrepancyApproval = {
  __typename?: 'CutoffDiscrepancyApproval';
  /** The approved location's full address (line1, line2, city, state, ZIP). */
  address?: Maybe<Scalars['String']>;
  approvedAt: Scalars['ISO8601DateTime'];
  approvedBy?: Maybe<Scalars['String']>;
  /** The LVA's own delivery rules. */
  deliveryRules: Array<GCutoffDeliveryRule>;
  id: Scalars['ID'];
  locationId: Scalars['ID'];
  locationName?: Maybe<Scalars['String']>;
  /** The approved location-vendor association (LVA). */
  locationsVendorId: Scalars['ID'];
  lvaFingerprint: Scalars['String'];
  /** The vendor's standing delivery rules (LVA ignored) — the baseline. */
  vendorDeliveryRules: Array<GCutoffDeliveryRule>;
  /** The LVA's vendor id (links to the vendor admin page). */
  vendorId: Scalars['ID'];
  vendorName: Scalars['String'];
};

/** An order whose cutoff (due_at) has drifted from the vendor's delivery rules. */
export type GCutoffDiscrepancyOrder = {
  __typename?: 'CutoffDiscrepancyOrder';
  /** The order location's full address (line1, line2, city, state, ZIP). */
  address?: Maybe<Scalars['String']>;
  /** The order's stored cutoff (due_at). */
  dueAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The order's location id (nil when the order has no location) — keys the approve action. */
  locationId?: Maybe<Scalars['ID']>;
  locationName?: Maybe<Scalars['String']>;
  /** The location/vendor LVAs and their rules. */
  locationVendorAssociations: Array<GCutoffLocationVendorAssociation>;
  /**
   * The flagged order, as a federated reference. LDS resolves the route name +
   * stop number (Lobby bucket until routed) the stage-gate table displays.
   */
  order: GOrder;
  orderNumber: Scalars['ID'];
  /** Why the order was flagged. */
  reason: GCutoffDiscrepancyReasonEnum;
  /** The vendor's standing delivery rules (LVA ignored) — the baseline. */
  vendorDeliveryRules: Array<GCutoffDeliveryRule>;
  /** The order's vendor id (links to the vendor admin page). */
  vendorId: Scalars['ID'];
};

/** Why an order's cutoff (due_at) is flagged as drifted from the vendor baseline. */
export enum GCutoffDiscrepancyReasonEnum {
  /**
   * The vendor's ZIP-override config is ambiguous for this location (multiple
   * overrides apply), so a baseline cutoff could not be resolved.
   */
  AmbiguousDeliveryRule = 'AMBIGUOUS_DELIVERY_RULE',
  /** due_at falls on a different date than the vendor's standard cutoff. */
  CutoffDateShift = 'CUTOFF_DATE_SHIFT',
  /** due_at is earlier than the vendor's standard cutoff for this day. */
  CutoffEarlier = 'CUTOFF_EARLIER',
  /** due_at is later than the vendor's standard cutoff for this day. */
  CutoffLater = 'CUTOFF_LATER',
  /**
   * The order's location is missing (discarded or never set), so no cutoff
   * baseline can be resolved. Surfaced for data cleanup, not a cutoff drift.
   */
  MissingLocation = 'MISSING_LOCATION',
  /** The order lands on a weekday the vendor has no standing delivery rule for. */
  NoDeliveryRule = 'NO_DELIVERY_RULE'
}

/**
 * Cutoff stage-gate report for a warehouse + delivery date: the count of orders
 * whose due_at differs from the vendor delivery-rule baseline, plus those orders.
 */
export type GCutoffDiscrepancyReport = {
  __typename?: 'CutoffDiscrepancyReport';
  discrepancyCount: Scalars['Int'];
  orders: Array<GCutoffDiscrepancyOrder>;
  /**
   * Orders in the Cutoff gate population for the warehouse + delivery date:
   * local-fulfillment (parcel/pallet shipping excluded), non-canceled orders with
   * positive unit quantity.
   */
  totalOrderCount: Scalars['Int'];
};

/** A location-vendor association (LVA) and its delivery rules. */
export type GCutoffLocationVendorAssociation = {
  __typename?: 'CutoffLocationVendorAssociation';
  deliveryRules: Array<GCutoffDeliveryRule>;
  id: Scalars['ID'];
  vendorName: Scalars['String'];
};

export type GDailyConversion = {
  __typename?: 'DailyConversion';
  /** Number of booking conversions */
  bookings: Scalars['Int'];
  /** Number of phone call conversions */
  calls: Scalars['Int'];
  date: Scalars['ISO8601Date'];
  /** Number of direction request conversions */
  directions: Scalars['Int'];
  /** Number of menu click conversions */
  menuClicks: Scalars['Int'];
  /** Total number of conversions for the day */
  total: Scalars['Int'];
  /** Number of website click conversions */
  websiteClicks: Scalars['Int'];
};

export type GDailyDeliveryExists = GUserErrorInterface & {
  __typename?: 'DailyDeliveryExists';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GDailyImpression = {
  __typename?: 'DailyImpression';
  date: Scalars['ISO8601Date'];
  desktopMaps: Scalars['Int'];
  desktopSearch: Scalars['Int'];
  mobileMaps: Scalars['Int'];
  mobileSearch: Scalars['Int'];
  total: Scalars['Int'];
};

/** Range of dates */
export type GDateRangeInput = {
  /** Lower bound (inclusive) of the range */
  lowerBound?: InputMaybe<Scalars['ISO8601Date']>;
  /** Upper bound of the range */
  upperBound?: InputMaybe<Scalars['ISO8601Date']>;
  /** Whether upper bound is included in the range */
  upperInclusive: Scalars['Boolean'];
};

export enum GDayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

/** The values representing each day of the week. */
export enum GDayOfWeekEnum {
  /** Friday. */
  Fri = 'fri',
  /** Monday. */
  Mon = 'mon',
  /** Saturday. */
  Sat = 'sat',
  /** Sunday. */
  Sun = 'sun',
  /** Thursday. */
  Thu = 'thu',
  /** Tuesday. */
  Tue = 'tue',
  /** Wednesday. */
  Wed = 'wed'
}

export type GDayOfWeekQrScanCount = {
  __typename?: 'DayOfWeekQrScanCount';
  dayOfWeek: GDayOfWeek;
  /** Total number of scans that occurred on this day of week. */
  scanCount: Scalars['Int'];
};

/** Autogenerated input type of DeleteArAssignment */
export type GDeleteArAssignmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyUuid: Scalars['String'];
};

/** Autogenerated return type of DeleteArAssignment. */
export type GDeleteArAssignmentPayload = {
  __typename?: 'DeleteArAssignmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type GDeleteCategoryBannerInput = {
  categoryId: Scalars['ID'];
};

export type GDeleteCollectionPromoSetupInput = {
  collectionId: Scalars['ID'];
};

export type GDeleteCollectionPromoSetupPayload = {
  __typename?: 'DeleteCollectionPromoSetupPayload';
  errors: Array<GCollectionPromoSetupError>;
};

/** Autogenerated input type of DeleteCustomerTagMutation */
export type GDeleteCustomerTagMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Id of the tag to delete, as returned by CustomerTag.id. */
  id: Scalars['ID'];
};

/** Autogenerated return type of DeleteCustomerTagMutation. */
export type GDeleteCustomerTagMutationPayload = {
  __typename?: 'DeleteCustomerTagMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  customerTag?: Maybe<GCustomerTag>;
  errors: Array<Scalars['String']>;
};

/** Autogenerated input type of DeleteDeliveryOverrideRuleMutation */
export type GDeleteDeliveryOverrideRuleMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** UUID of the override to withdraw. */
  id: Scalars['ID'];
};

/** Autogenerated return type of DeleteDeliveryOverrideRuleMutation. */
export type GDeleteDeliveryOverrideRuleMutationPayload = {
  __typename?: 'DeleteDeliveryOverrideRuleMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  deliveryOverrideRule?: Maybe<GDeliveryOverrideRule>;
  errors?: Maybe<Array<GUserError>>;
};

/** Autogenerated input type of DeleteFieldServiceZipcodeMutation */
export type GDeleteFieldServiceZipcodeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Id of the field service zip code to delete, as returned by FieldServiceZipcode.id. */
  id: Scalars['ID'];
};

/** Autogenerated return type of DeleteFieldServiceZipcodeMutation. */
export type GDeleteFieldServiceZipcodeMutationPayload = {
  __typename?: 'DeleteFieldServiceZipcodeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  fieldServiceZipcode?: Maybe<GFieldServiceZipcode>;
};

/** Autogenerated input type of DeleteLocationAccountsReceivableCollectionsStatus */
export type GDeleteLocationAccountsReceivableCollectionsStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  locationUuid: Scalars['String'];
};

/** Autogenerated return type of DeleteLocationAccountsReceivableCollectionsStatus. */
export type GDeleteLocationAccountsReceivableCollectionsStatusPayload = {
  __typename?: 'DeleteLocationAccountsReceivableCollectionsStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of DeleteLocationPaymentMethodMutation */
export type GDeleteLocationPaymentMethodMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** UUID for the Location */
  locationUuid: Scalars['String'];
  /** Payment method id */
  paymentMethodId: Scalars['String'];
  /**
   * Payment method type. If omitted, we will attempt retrieve payment method info
   * from Stripe using the payment_method_id, and determine type by the response
   * data. If the payment method does not use Stripe, the paymentMethodType must be specified.
   */
  paymentMethodType?: InputMaybe<GPaymentMethodTypeEnum>;
};

/** Autogenerated return type of DeleteLocationPaymentMethodMutation. */
export type GDeleteLocationPaymentMethodMutationPayload = {
  __typename?: 'DeleteLocationPaymentMethodMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  paymentMethod?: Maybe<GLocationPaymentMethod>;
};

/** Autogenerated input type of DeleteLocationPhoneNumberMutation */
export type GDeleteLocationPhoneNumberMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** UUID for the Location */
  locationUuid: Scalars['String'];
  /** Type of the phone number */
  phoneType: GLocationPhoneTypeEnum;
};

/** Autogenerated return type of DeleteLocationPhoneNumberMutation. */
export type GDeleteLocationPhoneNumberMutationPayload = {
  __typename?: 'DeleteLocationPhoneNumberMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
};

export type GDeleteMasterHomepageInput = {
  id: Scalars['ID'];
};

export type GDeleteMasterHomepagePayload = {
  __typename?: 'DeleteMasterHomepagePayload';
  errors: Array<GMasterHomepageError>;
};

export type GDeleteMasterHomepageRowComponentInput = {
  componentId: Scalars['ID'];
  rowId: Scalars['ID'];
};

export type GDeleteMasterHomepageRowComponentPayload = {
  __typename?: 'DeleteMasterHomepageRowComponentPayload';
  errors: Array<GMasterHomepageError>;
};

/** Autogenerated input type of DeleteMicrositeMenuItem */
export type GDeleteMicrositeMenuItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the Menu Item to delete. */
  menuItemId: Scalars['ID'];
  /** ID of the Microsite Location to which the Menu Item belongs. */
  micrositeLocationId: Scalars['ID'];
};

/** Autogenerated return type of DeleteMicrositeMenuItem. */
export type GDeleteMicrositeMenuItemPayload = {
  __typename?: 'DeleteMicrositeMenuItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedMenuItem?: Maybe<GMicrositeMenuItem>;
};

/** Autogenerated input type of DeleteReceivableNote */
export type GDeleteReceivableNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DeleteReceivableNote. */
export type GDeleteReceivableNotePayload = {
  __typename?: 'DeleteReceivableNotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of DeleteRoutificScenario */
export type GDeleteRoutificScenarioInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Id of the scenario run to delete. */
  scenarioId: Scalars['ID'];
};

/** Autogenerated return type of DeleteRoutificScenario. */
export type GDeleteRoutificScenarioPayload = {
  __typename?: 'DeleteRoutificScenarioPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Id of the deleted scenario run. Null on error. */
  deletedScenarioId?: Maybe<Scalars['ID']>;
  userErrors: Array<GRoutingImportPlanError>;
};

/** Autogenerated input type of DeleteS3File */
export type GDeleteS3FileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  filePath: Scalars['String'];
  /** The ID of the microsite location this image belongs to */
  micrositeLocationId: Scalars['ID'];
};

/** Autogenerated return type of DeleteS3File. */
export type GDeleteS3FilePayload = {
  __typename?: 'DeleteS3FilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedFilePath?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of DeleteSquareCard */
export type GDeleteSquareCardInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Square card id. */
  squareCardId: Scalars['String'];
};

/** Autogenerated return type of DeleteSquareCard */
export type GDeleteSquareCardPayload = {
  __typename?: 'DeleteSquareCardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to delete Square card. */
  result: GWalletResult;
};

/** Autogenerated input type of DeleteUserMicrositeLocationMutation */
export type GDeleteUserMicrositeLocationMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the microsite location */
  micrositeLocationId: Scalars['ID'];
  /** Auth0 ID of the user */
  userId: Scalars['ID'];
};

/** Autogenerated return type of DeleteUserMicrositeLocationMutation. */
export type GDeleteUserMicrositeLocationMutationPayload = {
  __typename?: 'DeleteUserMicrositeLocationMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of DeleteZipcodeDeliveryRule */
export type GDeleteZipcodeDeliveryRuleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Delivery rule day, 0-6, 0 denotes Sunday */
  deliveryDay: Scalars['Int'];
  /** The Zipcode to upsert a delivery rule for */
  zipcode: Scalars['String'];
};

/** Autogenerated return type of DeleteZipcodeDeliveryRule. */
export type GDeleteZipcodeDeliveryRulePayload = {
  __typename?: 'DeleteZipcodeDeliveryRulePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GUserError>;
};

/** Autogenerated input type of DeleteZipcodeMutation */
export type GDeleteZipcodeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  warehouseId: Scalars['ID'];
  zipcodeIds: Array<Scalars['ID']>;
};

/** Autogenerated return type of DeleteZipcodeMutation. */
export type GDeleteZipcodeMutationPayload = {
  __typename?: 'DeleteZipcodeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GUserError>;
};

export type GDelivery = {
  __typename?: 'Delivery';
  /** The time the driver arrived at the stop */
  arrivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  attachments?: Maybe<Array<GAttachment>>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']>;
  compostCollectedAt?: Maybe<Scalars['ISO8601DateTime']>;
  compostCollectionRequired?: Maybe<Scalars['Boolean']>;
  /** Every geofence enter/exit crossing recorded for the stop, oldest first (admin only; empty list for other callers). */
  crossingEvents: Array<GStopCrossingEvent>;
  deliveryNote?: Maybe<Scalars['String']>;
  deliveryStatus: GDeliveryStatus;
  /** stop status used in the DMP */
  deliveryStatusDmp: GDeliveryStatusDmp;
  deliveryStatusDriver: GDeliveryStatusDriver;
  /** The time the driver departed from the stop */
  departedAt?: Maybe<Scalars['ISO8601DateTime']>;
  donationCollectedAt?: Maybe<Scalars['ISO8601DateTime']>;
  donationRequired?: Maybe<Scalars['Boolean']>;
  /** Seconds the driver was stopped (departed_at - arrived_at), or null if either is missing */
  dwellSeconds?: Maybe<Scalars['Int']>;
  hasRepeatedAccessIssues: Scalars['Boolean'];
  id: Scalars['ID'];
  isFirstDelivery: Scalars['Boolean'];
  issues?: Maybe<Array<GIssue>>;
  location?: Maybe<GLocation>;
  orders?: Maybe<Array<GOrder>>;
  /** Previous two deliveries */
  previousDeliveries: Array<GDelivery>;
  /** returns the date of their last delivery */
  previousDeliveryDate?: Maybe<Scalars['String']>;
  /**
   * This stop's order on a third-party provider, from the newest dispatch that has
   * a row for it. Null for a stop no provider has been given.
   */
  providerDelivery?: Maybe<GProviderDelivery>;
  /** Redelivery stop */
  redeliveryStop?: Maybe<GRedelivery>;
  reminderMessage?: Maybe<Scalars['String']>;
  /** Repeated access issue descriptions */
  repeatedAccessIssues: Array<Scalars['String']>;
  /** The latest time the driver was detected leaving the stop again after completion, if they returned */
  returnedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** How many times the driver returned to the stop after completing it */
  revisitCount: Scalars['Int'];
  route: GRoute;
  /** Represent stop predictive metrics based on route optimization. */
  routingEstimates?: Maybe<GStopEstimates>;
  sequenceNumber?: Maybe<Scalars['String']>;
  /** Additional tasks for the driver, authored by a GM or generated automatically, oldest first. */
  tasks?: Maybe<Array<GDeliveryRouteStopTask>>;
  /** Total volume of this stop */
  totalVolume?: Maybe<Scalars['Float']>;
  /** Total weight of this stop */
  totalWeight?: Maybe<Scalars['Float']>;
  upsellNote?: Maybe<Scalars['String']>;
  viewedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Enter/exit crossings paired into visits with per-visit dwell, oldest first (admin only; empty list for other callers). */
  visits: Array<GStopVisit>;
};

/** Autogenerated input type of DeliveryCompletedUpdate */
export type GDeliveryCompletedUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  completed: Scalars['Boolean'];
  /** Delivery route stop id. */
  deliveryRouteStopId: Scalars['ID'];
  redelivery?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of DeliveryCompletedUpdate. */
export type GDeliveryCompletedUpdatePayload = {
  __typename?: 'DeliveryCompletedUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  deliveryRouteStop?: Maybe<GDeliveryStop>;
  userErrors: Array<GDeliveryRouteStopError>;
};

export type GDeliveryDatePoNumber = {
  __typename?: 'DeliveryDatePoNumber';
  deliveryDate: Scalars['ISO8601Date'];
  poNumber: Scalars['String'];
};

export type GDeliveryDatePoNumberInput = {
  deliveryDate: Scalars['ISO8601Date'];
  poNumber: Scalars['String'];
};

/** Error indicating that the requested delivery date cannot take a delivery. */
export type GDeliveryDateUnavailableError = GError & {
  __typename?: 'DeliveryDateUnavailableError';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Input for specifying delivery details. */
export type GDeliveryDetailInput = {
  /** City. */
  city: Scalars['String'];
  /** Notes. */
  notes?: InputMaybe<Scalars['String']>;
  /** Postal code. */
  postalCode: Scalars['String'];
  /** State. */
  state: Scalars['String'];
  /** Street address. */
  streetAddress: Scalars['String'];
};

export type GDeliveryFee = GFeeInterface & {
  __typename?: 'DeliveryFee';
  /** The threshold amount in cents at which the fee is applied. */
  feeThresholds: Array<GFeeThreshold>;
  id: Scalars['ID'];
  /** Indicates if the fee is active or not. */
  isActive: Scalars['Boolean'];
  odekoUuid: Scalars['ID'];
  /** The amount of the delivery fee in cents. */
  warehouseFeeAmountCents: Scalars['Int'];
  /** Unique identifier of the warehouse associated with this delivery fee. */
  warehouseId: Scalars['ID'];
};

export type GDeliveryForAddress = {
  __typename?: 'DeliveryForAddress';
  type?: Maybe<GDeliveryForAddressEnum>;
  warehouse?: Maybe<GWarehouse>;
};

export enum GDeliveryForAddressEnum {
  LocalDelivery = 'local_delivery',
  Shipping = 'shipping',
  Unknown = 'unknown'
}

export type GDeliveryInstructionReview = {
  __typename?: 'DeliveryInstructionReview';
  acknowledgedAt?: Maybe<Scalars['ISO8601DateTime']>;
  deliveryDate: Scalars['ISO8601Date'];
  id: Scalars['ID'];
};

export type GDeliveryInstructionReviewStatus = {
  __typename?: 'DeliveryInstructionReviewStatus';
  deliveryDate: Scalars['ISO8601Date'];
  enabled: Scalars['Boolean'];
  review?: Maybe<GDeliveryInstructionReview>;
  timeZone: Scalars['String'];
};

export type GDeliveryInstructionTranslation = {
  __typename?: 'DeliveryInstructionTranslation';
  id: Scalars['ID'];
  sourceHash: Scalars['String'];
  targetLanguage: Scalars['String'];
  translatedText: Scalars['String'];
  translationId: Scalars['ID'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type GDeliveryInstructionTranslationError = {
  __typename?: 'DeliveryInstructionTranslationError';
  code: Scalars['String'];
  message: Scalars['String'];
};

/** Error indicating that delivery instructions are missing. */
export type GDeliveryInstructionsMissingError = GError & {
  __typename?: 'DeliveryInstructionsMissingError';
  /** A description of the error. */
  message: Scalars['String'];
};

export enum GDeliveryIssue {
  AccessIssueSafetyConcern = 'access_issue_safety_concern',
  AccessIssueSecurity = 'access_issue_security',
  AlarmIssueDifficultToFind = 'alarm_issue_difficult_to_find',
  AlarmIssueInaccurateInstructions = 'alarm_issue_inaccurate_instructions',
  AlarmTriggered = 'alarm_triggered',
  CafePartnerStoreHours = 'cafe_partner_store_hours',
  CompostNoRoomInVan = 'compost_no_room_in_van',
  DamagedInTransit = 'damaged_in_transit',
  DeliveryInstructionsInaccurate = 'delivery_instructions_inaccurate',
  DeliveryInstructionsInaccurateNonRefrigeratedItems = 'delivery_instructions_inaccurate_non_refrigerated_items',
  DeliveryInstructionsInaccurateRefrigeratedItems = 'delivery_instructions_inaccurate_refrigerated_items',
  DeliveryIssueNoRoomInFridge = 'delivery_issue_no_room_in_fridge',
  DeliveryIssueSafetyConcern = 'delivery_issue_safety_concern',
  DeliveryIssueSpillDamageToStore = 'delivery_issue_spill_damage_to_store',
  DeliveryIssueUnableToAccessFridge = 'delivery_issue_unable_to_access_fridge',
  /** @deprecated Deprecated - No longer supported */
  DeliveryNoteCompletedByAnotherDriver = 'delivery_note_completed_by_another_driver',
  /** @deprecated Deprecated - No longer supported */
  DeliveryNoteCustomerPutAwayProduct = 'delivery_note_customer_put_away_product',
  /** @deprecated Deprecated - No longer supported */
  DeliveryNoteOther = 'delivery_note_other',
  KegReturn = 'keg_return',
  KeyIssueBrokenKey = 'key_issue_broken_key',
  KeyIssueDoesNotWork = 'key_issue_does_not_work',
  KeyIssueLeftAtWarehouse = 'key_issue_left_at_warehouse',
  KeyIssueNotAtWarehouse = 'key_issue_not_at_warehouse',
  LockboxIssueInvalidCode = 'lockbox_issue_invalid_code',
  LockboxIssueKeyNotPresent = 'lockbox_issue_key_not_present',
  LockboxIssueNotFound = 'lockbox_issue_not_found',
  /** @deprecated Deprecated - No longer supported */
  MissingItemVendorSelectItem = 'missing_item_vendor_select_item',
  MissingItemWarehouseSelectItem = 'missing_item_warehouse_select_item',
  MissingItemWrongItem = 'missing_item_wrong_item',
  NoOrderAtVendor = 'no_order_at_vendor',
  NoPickUpAvailableCompost = 'no_pick_up_available_compost',
  NoPickUpAvailableDonation = 'no_pick_up_available_donation',
  NoPickUpAvailableReturn = 'no_pick_up_available_return',
  NoPickUpAvailableTransfer = 'no_pick_up_available_transfer',
  NoPickUpAvailableVendor = 'no_pick_up_available_vendor',
  /** @deprecated Deprecated - No longer supported */
  Other = 'other',
  /** @deprecated Deprecated - No longer supported */
  OtherCompost = 'other_compost',
  /** @deprecated Deprecated - No longer supported */
  OtherDonation = 'other_donation',
  PestOrRodents = 'pest_or_rodents',
  UnableToAccessLocation = 'unable_to_access_location',
  WeatherIssue = 'weather_issue'
}

/** Autogenerated input type of DeliveryIssueCreate */
export type GDeliveryIssueCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Delivery route stop id. */
  deliveryRouteStopId: Scalars['ID'];
  /** Additional details on the delivery issue */
  note: Scalars['String'];
  /** Order id. */
  orderId?: InputMaybe<Scalars['ID']>;
  redelivery?: InputMaybe<Scalars['Boolean']>;
  /** Type of the delivery issue. */
  type: GDeliveryIssue;
};

/** Autogenerated return type of DeliveryIssueCreate. */
export type GDeliveryIssueCreatePayload = {
  __typename?: 'DeliveryIssueCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  issue?: Maybe<GIssue>;
  userErrors: Array<GDeliveryIssueError>;
};

/** Autogenerated input type of DeliveryIssueDelete */
export type GDeliveryIssueDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Delivery issue id. */
  id: Scalars['ID'];
  redelivery?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of DeliveryIssueDelete. */
export type GDeliveryIssueDeletePayload = {
  __typename?: 'DeliveryIssueDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userErrors: Array<GDeliveryIssueError>;
};

export type GDeliveryIssueDuplicate = GUserErrorInterface & {
  __typename?: 'DeliveryIssueDuplicate';
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** Delivery issue possible errors */
export type GDeliveryIssueError = GDeliveryIssueDuplicate | GDeliveryIssueNotFound | GOrderNotFound;

export type GDeliveryIssueNotFound = GUserErrorInterface & {
  __typename?: 'DeliveryIssueNotFound';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of DeliveryIssueUpdate */
export type GDeliveryIssueUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Delivery issue id. */
  id: Scalars['ID'];
  /** Additional details on the delivery issue */
  note: Scalars['String'];
  /** Type of the delivery issue. */
  type: GDeliveryIssue;
};

/** Autogenerated return type of DeliveryIssueUpdate. */
export type GDeliveryIssueUpdatePayload = {
  __typename?: 'DeliveryIssueUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  issue: GIssue;
  userErrors: Array<GDeliveryIssueError>;
};

export type GDeliveryItemInput = {
  /** The uuid of the item. */
  itemId: Scalars['ID'];
  /** The unit cost of the item. */
  unitCost: GMoneyInput;
  /** The amount of items ordered. */
  unitQuantity: Scalars['Int'];
};

export enum GDeliveryMethodEnum {
  /** Local delivery */
  Delivery = 'delivery',
  /** Shipped via pallet (for heavier orders) */
  PalletShipping = 'pallet_shipping',
  /** Shipped via parcel (for lighter orders) */
  ParcelShipping = 'parcel_shipping',
  /** Local pick-up */
  PickUp = 'pick_up'
}

export type GDeliveryOverrideAffectedDeliveries = {
  __typename?: 'DeliveryOverrideAffectedDeliveries';
  /** Every delivery the block would affect. Null when the export could not be produced. */
  deliveries?: Maybe<Array<GDeliveryOverrideAffectedDelivery>>;
  /**
   * Why this export could not be produced (invalid draft, or over the size cap).
   * Empty when it could be. While it is non-empty, `deliveries` is null.
   */
  errors: Array<GUserError>;
};

export type GDeliveryOverrideAffectedDelivery = {
  __typename?: 'DeliveryOverrideAffectedDelivery';
  deliveryDate: Scalars['ISO8601Date'];
  kind: GDeliveryOverrideAffectedKindEnum;
  /** Non-zero lines only. ORDER: the order's lines. STANDING: the lines generation would still add. */
  lines: Array<GDeliveryOverrideAffectedLine>;
  /** Location business_name. */
  locationName: Scalars['String'];
  /** Location odeko_uuid. */
  locationUuid: Scalars['ID'];
  /** orders.netsuite_transaction_id. Null when unsynced, and always null for STANDING. */
  netsuiteOrderNumber?: Maybe<Scalars['String']>;
  /** orders.id. Null for STANDING (no order row yet). */
  orderNumber?: Maybe<Scalars['ID']>;
  /** Null for STANDING (no order row yet). */
  orderUuid?: Maybe<Scalars['ID']>;
  status: GDeliveryOverrideAffectedStatusEnum;
  /** Vendor uuid. */
  vendorId: Scalars['ID'];
  /** Vendor display name (Vendor#display_name). */
  vendorName: Scalars['String'];
  /**
   * The vendor's own warehouse name, when it is one of Odeko's warehouses
   * (Vendor#warehouse); null otherwise. Odeko's warehouse vendors share a display
   * name, so this is what tells them apart (mirrors Vendor#label).
   */
  vendorWarehouseName?: Maybe<Scalars['String']>;
};

export enum GDeliveryOverrideAffectedKindEnum {
  /** An order that already exists on this date. */
  Order = 'ORDER',
  /** A standing delivery the generator has not created yet. */
  Standing = 'STANDING'
}

export type GDeliveryOverrideAffectedLine = {
  __typename?: 'DeliveryOverrideAffectedLine';
  /** Sku display_name. */
  itemName: Scalars['String'];
  /** Sku item_uuid. */
  itemUuid?: Maybe<Scalars['ID']>;
  /** Unit quantity (cases/units as ordered), not the raw item count. */
  quantity: Scalars['Int'];
};

export enum GDeliveryOverrideAffectedStatusEnum {
  /** Currently being sent. Not cancelled by a block. */
  Sending = 'SENDING',
  /** Sending failed. Not cancelled by a block. */
  SendingFailed = 'SENDING_FAILED',
  /** Already sent to the vendor. Not cancelled by a block. */
  Sent = 'SENT',
  /** No order exists yet; generation would still create this. */
  Standing = 'STANDING',
  /** Not yet sent to the vendor. A block would cancel this. */
  Unsent = 'UNSENT'
}

export type GDeliveryOverrideAudienceInput = {
  /** Location UUIDs, naming the audience outright. */
  locationIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Customer tag ids. Reaches the locations carrying them. */
  tagIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Whether a location must carry any of the tags or all of them. */
  tagMatchMode?: InputMaybe<GDeliveryOverrideTagMatchModeEnum>;
};

export enum GDeliveryOverrideAudienceKindEnum {
  /** Every location in a market, described by the market alone. Older rules only; new ones use the market scope. */
  Market = 'MARKET',
  /** Hand-picked locations, named outright. */
  Named = 'NAMED',
  /** Every location carrying the audience's tags, within its market. */
  Tags = 'TAGS'
}

export type GDeliveryOverrideCopyResult = {
  __typename?: 'DeliveryOverrideCopyResult';
  /** Orders cancelled by this copy, or that would be cancelled in a dry run. Exact for a copy's results. */
  cancelledOrderCount: Scalars['Int'];
  /** The orders that would be cancelled. Only filled when includeCancelledOrders was set on a preview. */
  cancelledOrders: Array<GDeliveryOverrideAffectedDelivery>;
  /** The copied rule, or null unless the batch committed. */
  copiedRule?: Maybe<GDeliveryOverrideRule>;
  /** Reasons this rule could not be copied. Empty when it can be copied. */
  errors: Array<GUserError>;
  /** UUID of the source delivery override rule. */
  sourceRuleId: Scalars['ID'];
};

export type GDeliveryOverrideCutoffBuffer = {
  __typename?: 'DeliveryOverrideCutoffBuffer';
  /** How much earlier, in seconds. Always positive: a vendor with no buffer is not listed. */
  seconds: Scalars['Int'];
  /** The vendor whose cutoff is treated earlier. */
  vendor: GVendor;
};

export enum GDeliveryOverrideDayActionEnum {
  /** Add a one-off delivery on a date with no scheduled run (requires a lead time and order deadline). */
  Add = 'add',
  /** Re-open a day a less-specific rule closed. */
  Allow = 'allow',
  /** Close the delivery day for this location and vendor. */
  Block = 'block',
  /** Move the delivery to a make-up date (requires a substitute delivery date). */
  Substitute = 'substitute'
}

/** Which locations a delivery override should reach. */
export type GDeliveryOverrideLocationFiltersInput = {
  /**
   * Matches a location's businessName or its id, case-insensitively. The name is
   * matched whole, so a term spanning the company and location parts still finds it.
   */
  search?: InputMaybe<Scalars['String']>;
  /** Locations carrying these tags. */
  tags?: InputMaybe<GCustomerTagFilterInput>;
  /** Locations served by one of these warehouses (the federated Warehouse.id). */
  warehouseIds: Array<Scalars['ID']>;
};

export type GDeliveryOverrideOverlap = {
  __typename?: 'DeliveryOverrideOverlap';
  /** How many of the proposed audience's locations it covers. */
  locationCount: Scalars['Int'];
  /** The rule already covering these locations on this date. */
  rule: GDeliveryOverrideRule;
};

export type GDeliveryOverridePreview = {
  __typename?: 'DeliveryOverridePreview';
  /**
   * Unsent orders this would cancel. Zero for any action other than `block`, zero
   * while order cancellation is disabled, and excludes orders spared by a more
   * specific allow. Null when the override could not be created.
   */
  cancelledOrderCount?: Maybe<Scalars['Int']>;
  /**
   * Vendors whose order cutoff is treated earlier than the one this override sets,
   * and by how much (for example, manually sent orders close hours before it).
   * Only vendors with a buffer at one of these locations are listed, the largest
   * where a vendor's agreements differ. Empty when the override sets no cutoff.
   * Unlike the counts above it is still answered while `errors` is non-empty.
   */
  cutoffBuffers: Array<GDeliveryOverrideCutoffBuffer>;
  /**
   * Why this override could not be created as described, in the same shape
   * createDeliveryOverrideRule returns. Empty when it can be. While it is
   * non-empty the counts below are null, but not `cutoffBuffers`, which is still answered.
   */
  errors: Array<GUserError>;
  /**
   * Audience locations the reach mode excluded. N of M reached is locationCount
   * over locationCount + excludedLocationCount. Zero while reach limiting is
   * disabled. Null when the override could not be created, for vendor-less group
   * rules, vendor scope, other grains and warehouse vendors.
   */
  excludedLocationCount?: Maybe<Scalars['Int']>;
  /** How many locations are reached after the reach mode is applied. Null when the override could not be created. */
  locationCount?: Maybe<Scalars['Int']>;
  /**
   * The overlapping rule that would decide the day instead of this one, or null
   * when nothing does — including when the draft sets no day action and so is not
   * contesting the day. Decided per location, so this is non-null when any one of
   * them resolves away from the draft, even if the rest take it; the rule returned
   * is the most specific of those deciding. Always one of `overlaps`. Answered
   * here rather than left to the caller, so nobody has to re-derive the engine's
   * grain and severity ordering to know whether a draft will take effect. Null
   * when the override could not be created.
   */
  outrankedBy?: Maybe<GDeliveryOverrideOverlap>;
  /**
   * How many of the reached locations resolve away from the draft. Zero when it
   * takes effect everywhere. Not `outrankedBy.locationCount`, which counts every
   * location the winning rule covers whether the draft loses there or not. Null
   * when the override could not be created.
   */
  outrankedLocationCount?: Maybe<Scalars['Int']>;
  /**
   * Rules already covering some of these locations on this date, most specific
   * first. A snapshot — a location that joins an audience later can newly fall
   * under both. Null when the override could not be created.
   */
  overlaps?: Maybe<Array<GDeliveryOverrideOverlap>>;
  /**
   * Vendor-carrying rules that change one vendor's day apart from what the reached
   * locations' spanning rules alone would decide. Empty when the draft itself
   * names a vendor, or sets no day action. Null when the override could not be created.
   */
  vendorExceptions?: Maybe<Array<GDeliveryOverrideVendorException>>;
};

export enum GDeliveryOverrideReachModeEnum {
  /** Every location the audience reaches. */
  All = 'ALL',
  /** Only locations the vendor serves. */
  LvaOnly = 'LVA_ONLY'
}

/** A date-scoped delivery override for a location, and optionally a single vendor. */
export type GDeliveryOverrideRule = {
  __typename?: 'DeliveryOverrideRule';
  /** How a `group` override's audience was written: hand-picked locations, tags, or a whole market. Null for every other scope. */
  audienceKind?: Maybe<GDeliveryOverrideAudienceKindEnum>;
  /** The tags a `group` override's audience targets. Empty for every other audience. */
  audienceTags: Array<Maybe<GCustomerTag>>;
  /**
   * How many orders this override has already cancelled. Counted from the
   * cancellation records themselves, and recording one is best-effort, so this is
   * a floor rather than a settled total. Withdrawing the override does not restore these orders.
   */
  cancelledOrderCount: Scalars['Int'];
  /**
   * Vendors whose order cutoff is treated earlier than the one this rule sets, and
   * by how much. Empty when the rule sets no cutoff. The same answer
   * `deliveryOverridePreview` gives a draft.
   */
  cutoffBuffers: Array<GDeliveryOverrideCutoffBuffer>;
  /** The day-presence change, or null for an attribute-only override. */
  dayAction?: Maybe<GDeliveryOverrideDayActionEnum>;
  /** The date the override applies to. */
  deliveryDate: Scalars['ISO8601Date'];
  /** Stable public identifier for the override. */
  id: Scalars['ID'];
  /** Overridden order lead time in days. */
  leadTime?: Maybe<Scalars['Int']>;
  /** The location the override applies to. Null for a vendor-wide override, which spans every location the vendor delivers to. */
  location?: Maybe<GLocation>;
  /**
   * Location UUID the override applies to.
   * @deprecated Use `location { id }`. Reachable through the federated `location` field.
   */
  locationId?: Maybe<Scalars['ID']>;
  /** Overridden order cutoff as "HH:MM". */
  orderDeadline?: Maybe<Scalars['String']>;
  /**
   * The rule deciding the day instead of this one on at least one of its
   * locations, or null when this rule takes effect everywhere it reaches. Always
   * one of `overlaps`.
   */
  outrankedBy?: Maybe<GDeliveryOverrideOverlap>;
  /**
   * Other rules covering some of this rule's locations on its date, most specific
   * first. Each `locationCount` is how many of this rule's locations that rule
   * covers. The same answer `deliveryOverridePreview` gives a draft.
   */
  overlaps: Array<GDeliveryOverrideOverlap>;
  /**
   * Who a group or vendor rule naming a vendor reaches. Null for other rules and
   * for vendor rules saved before the mode existed; legacy group rules with a
   * vendor and no stored mode read ALL.
   */
  reachMode?: Maybe<GDeliveryOverrideReachModeEnum>;
  /**
   * How many locations this override currently reaches, inside the market it
   * applies in. Resolved when asked rather than stored, so a tag-described
   * audience reflects who carries the tag now.
   */
  reachedLocationCount: Scalars['Int'];
  /**
   * The locations this override currently reaches, inside the market it applies
   * in, ordered by business name. Set only for a `group` override -- every other
   * scope either names its one location directly or has none to enumerate. Its
   * total always matches `reachedLocationCount`.
   */
  reachedLocations?: Maybe<GReachedLocationsConnection>;
  /** The grain the override targets. */
  scope: GDeliveryOverrideRuleScopeEnum;
  /** The make-up delivery date for a substitute override. */
  substituteDeliveryDate?: Maybe<Scalars['ISO8601Date']>;
  /** Whether a location needs any or all of `audienceTags`. Null when there are none. */
  tagMatchMode?: Maybe<GDeliveryOverrideTagMatchModeEnum>;
  /**
   * The vendor the override applies to. Null when the override spans every vendor
   * — a location-wide one, or a group naming an audience but no vendor.
   */
  vendor?: Maybe<GVendor>;
  /**
   * Vendor-carrying rules that change one vendor's day apart from what this rule
   * decides for its locations. Empty when this rule itself names a vendor, or sets no day action.
   */
  vendorExceptions: Array<GDeliveryOverrideVendorException>;
  /**
   * Vendor UUID the override applies to. Null when the override spans every vendor
   * — a location-wide one, or a group naming an audience but no vendor.
   * @deprecated Use `vendor { id }`.
   */
  vendorId?: Maybe<Scalars['ID']>;
  /**
   * The market the override applies in. Null when it applies in every market — a
   * vendor-wide closure that is not confined to one.
   */
  warehouse?: Maybe<GWarehouse>;
};


/** A date-scoped delivery override for a location, and optionally a single vendor. */
export type GDeliveryOverrideRuleReachedLocationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** An edge in a connection. */
export type GDeliveryOverrideRuleEdge = {
  __typename?: 'DeliveryOverrideRuleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GDeliveryOverrideRule>;
};

export enum GDeliveryOverrideRuleScopeEnum {
  /** An audience of locations. */
  Group = 'group',
  /** One location, across all of its vendors. */
  Location = 'location',
  /** One location and vendor. */
  Lva = 'lva',
  /** Every location in one market, for every vendor. */
  Market = 'market',
  /** One vendor, across every location it delivers to. */
  Vendor = 'vendor'
}

/** The connection type for DeliveryOverrideRule. */
export type GDeliveryOverrideRulesConnection = {
  __typename?: 'DeliveryOverrideRulesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GDeliveryOverrideRuleEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GDeliveryOverrideRule>>>;
  /** Information to aid in pagination. */
  pageInfo: GPageInfo;
  /** The total count of records in the connection. */
  totalCount: Scalars['Int'];
};

export enum GDeliveryOverrideScopeEnum {
  /** An audience of locations for one vendor. */
  Group = 'group',
  /** One location, across all of its vendors. */
  Location = 'location',
  /** One location and vendor. */
  Lva = 'lva',
  /** Every location in one market, for every vendor. Ranks lowest of all; requires `warehouseId`. */
  Market = 'market',
  /** One vendor, across every store it delivers to. Narrow it with `warehouseId`. */
  Vendor = 'vendor'
}

export enum GDeliveryOverrideTagMatchModeEnum {
  /** A location matches only if it carries every one of the tags. */
  All = 'ALL',
  /** A location matches if it carries at least one of the tags. */
  Any = 'ANY'
}

export enum GDeliveryOverrideVendorEffectEnum {
  /** The draft would hold here on its own, but this vendor-specific rule decides the day for that vendor instead. */
  DecidesForVendor = 'decides_for_vendor',
  /** The draft would lose here on its own, but this vendor-specific rule restores the draft's action for that vendor. */
  RestoresForVendor = 'restores_for_vendor'
}

export type GDeliveryOverrideVendorException = {
  __typename?: 'DeliveryOverrideVendorException';
  /** Whether this rule decides the vendor's day away from the draft, or restores the draft's action for that vendor. */
  effect: GDeliveryOverrideVendorEffectEnum;
  /** How many of the proposed audience's locations this exception covers. */
  locationCount: Scalars['Int'];
  /** The vendor-carrying rule that decides or restores the day for this vendor. */
  rule: GDeliveryOverrideRule;
};

export type GDeliveryPriceError = GError & {
  __typename?: 'DeliveryPriceError';
  /** A description of the error. */
  message: Scalars['String'];
};

export type GDeliveryPriceInput = {
  /** The channel from which the order originated. */
  channel?: InputMaybe<GChannelEnum>;
  /** An optional coupon code to be applied on the delivery. */
  couponCode?: InputMaybe<Scalars['String']>;
  /** The delivery date. */
  deliveryDate: Scalars['ISO8601Date'];
  /** The method of delivery. */
  deliveryMethod?: InputMaybe<GDeliveryMethodEnum>;
  /** The weight of the order. */
  deliveryWeight?: InputMaybe<Scalars['Float']>;
  /** The items ordered in the delivery. */
  items?: InputMaybe<Array<GDeliveryItemInput>>;
  /** The location ID for the delivery. */
  locationId: Scalars['ID'];
  /** The cost to ship the delivery. This is not included in the subtotal. */
  shippingCost?: InputMaybe<GMoneyInput>;
  /** The delivery price before any discounts. */
  subtotal: GMoneyInput;
};

export type GDeliveryPriceResult = GDeliveryPriceSuccess | GErrorsResult;

export type GDeliveryPriceSuccess = {
  __typename?: 'DeliveryPriceSuccess';
  /** Any automatic discounts the delivery is applicable for */
  automaticDiscounts?: Maybe<Array<GAutomaticDiscount>>;
  /** The coupon status after validation. */
  couponStatus?: Maybe<GCouponStatus>;
  /** Indicates if promotions are unavailable due to Voucherify infrastructure failures */
  hasInfrastructureIssues: Scalars['Boolean'];
  /** Indicates if any promotion could not be applied (infrastructure failures or business rules) */
  hasPromotionIssues: Scalars['Boolean'];
  /** User-friendly message to display when promotions have issues */
  promotionIssueMessage?: Maybe<Scalars['String']>;
  /** The delivery price before any discounts. */
  subtotal: GMoney;
  /** The delivery price after discounts. */
  total: GMoney;
  /** The calculated total discount on a delivery. */
  totalDiscount: GMoney;
};

/** Autogenerated input type of DeliveryRouteCreate */
export type GDeliveryRouteCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Delivery route name. */
  name?: InputMaybe<Scalars['String']>;
  /** Delivery Route night end. */
  nightEnd: Scalars['ISO8601Date'];
  redelivery?: InputMaybe<Scalars['Boolean']>;
  /** Warehouse id. */
  warehouseId: Scalars['ID'];
};

/** Autogenerated return type of DeliveryRouteCreate. */
export type GDeliveryRouteCreatePayload = {
  __typename?: 'DeliveryRouteCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  route?: Maybe<GRoute>;
  userErrors: Array<GRouteError>;
};

/** Autogenerated input type of DeliveryRouteStopAttachmentCreate */
export type GDeliveryRouteStopAttachmentCreateInput = {
  attachmentCategory?: InputMaybe<Scalars['String']>;
  /** Device position when the photo was taken. */
  captureCoordinates?: InputMaybe<GGeoCoordinatesInput>;
  /** Device time when the photo was taken; can be well before the upload when the app queued it offline. */
  capturedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Delivery route stop id. */
  deliveryRouteStopId: Scalars['ID'];
  objectKey: Scalars['String'];
  redelivery?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of DeliveryRouteStopAttachmentCreate. */
export type GDeliveryRouteStopAttachmentCreatePayload = {
  __typename?: 'DeliveryRouteStopAttachmentCreatePayload';
  attachment?: Maybe<GAttachment>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userErrors: Array<GDeliveryRouteStopError>;
};

/** Autogenerated input type of DeliveryRouteStopAttachmentDelete */
export type GDeliveryRouteStopAttachmentDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Delivery route stop id. */
  deliveryRouteStopId: Scalars['ID'];
  objectKey: Scalars['String'];
  redelivery?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of DeliveryRouteStopAttachmentDelete. */
export type GDeliveryRouteStopAttachmentDeletePayload = {
  __typename?: 'DeliveryRouteStopAttachmentDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userErrors: Array<GDeliveryRouteStopError>;
};

/** Autogenerated input type of DeliveryRouteStopCompostCollectedUpdate */
export type GDeliveryRouteStopCompostCollectedUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  collected: Scalars['Boolean'];
  /** Delivery route stop id. */
  deliveryRouteStopId: Scalars['ID'];
  redelivery?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of DeliveryRouteStopCompostCollectedUpdate. */
export type GDeliveryRouteStopCompostCollectedUpdatePayload = {
  __typename?: 'DeliveryRouteStopCompostCollectedUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userErrors: Array<GDeliveryRouteStopError>;
};

/** Autogenerated input type of DeliveryRouteStopDeliveryNoteUpdate */
export type GDeliveryRouteStopDeliveryNoteUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Delivery note for the stop. */
  deliveryNote: Scalars['String'];
  redelivery?: InputMaybe<Scalars['Boolean']>;
  /** Delivery route stop id. */
  stopId: Scalars['ID'];
};

/** Autogenerated return type of DeliveryRouteStopDeliveryNoteUpdate. */
export type GDeliveryRouteStopDeliveryNoteUpdatePayload = {
  __typename?: 'DeliveryRouteStopDeliveryNoteUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userErrors: Array<GDeliveryRouteStopError>;
};

/** Autogenerated input type of DeliveryRouteStopDonationCollectedUpdate */
export type GDeliveryRouteStopDonationCollectedUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  collected: Scalars['Boolean'];
  /** Delivery route stop id. */
  deliveryRouteStopId: Scalars['ID'];
  redelivery?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of DeliveryRouteStopDonationCollectedUpdate. */
export type GDeliveryRouteStopDonationCollectedUpdatePayload = {
  __typename?: 'DeliveryRouteStopDonationCollectedUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userErrors: Array<GDeliveryRouteStopError>;
};

/** Delivery route stop possible error types */
export type GDeliveryRouteStopError = GCompletedCustomerPickupStop | GInvalidNightEnd | GMetrobiAssignmentBlocked | GNonCustomerPickupStops | GNonMovableStops | GPickupRoutingDisabled | GProviderRouteGuarded | GUncountedLineTrackedOrders | GUnresolvedTasks;

/** Autogenerated input type of DeliveryRouteStopReminderUpdate */
export type GDeliveryRouteStopReminderUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Driver reminder message for the stop. */
  message: Scalars['String'];
  /** Delivery route stop id. */
  stopId: Scalars['ID'];
};

/** Autogenerated return type of DeliveryRouteStopReminderUpdate. */
export type GDeliveryRouteStopReminderUpdatePayload = {
  __typename?: 'DeliveryRouteStopReminderUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  stop?: Maybe<GDeliveryStop>;
  userErrors: Array<GDeliveryRouteStopError>;
};

export type GDeliveryRouteStopTask = {
  __typename?: 'DeliveryRouteStopTask';
  createdAt: Scalars['ISO8601DateTime'];
  /** Task instructions for the driver (max 500 chars). */
  details: Scalars['String'];
  /** Driver's explanation, present when the task is incomplete. */
  driverNote?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** When the driver marked the task complete or incomplete. */
  resolvedAt?: Maybe<Scalars['ISO8601DateTime']>;
  status: GDeliveryRouteStopTaskStatus;
};

/** Autogenerated input type of DeliveryRouteStopTaskCreate */
export type GDeliveryRouteStopTaskCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Task text (max 500 chars). */
  details: Scalars['String'];
  /** Delivery route stop id. */
  stopId: Scalars['ID'];
};

/** Autogenerated return type of DeliveryRouteStopTaskCreate. */
export type GDeliveryRouteStopTaskCreatePayload = {
  __typename?: 'DeliveryRouteStopTaskCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  task?: Maybe<GDeliveryRouteStopTask>;
  userErrors: Array<GDeliveryRouteStopTaskError>;
};

/** Autogenerated input type of DeliveryRouteStopTaskDelete */
export type GDeliveryRouteStopTaskDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Task id. */
  id: Scalars['ID'];
};

/** Autogenerated return type of DeliveryRouteStopTaskDelete. */
export type GDeliveryRouteStopTaskDeletePayload = {
  __typename?: 'DeliveryRouteStopTaskDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userErrors: Array<GDeliveryRouteStopTaskError>;
};

/** Route stop task possible error types */
export type GDeliveryRouteStopTaskError = GInvalidNightEnd | GTaskAlreadyResolved | GTaskNotFound | GTaskNoteRequired;

export enum GDeliveryRouteStopTaskResolution {
  /** Driver marked the task done */
  Complete = 'complete',
  /** Driver marked the task not done; a driver note explains why */
  Incomplete = 'incomplete'
}

export type GDeliveryRouteStopTaskResolutionInput = {
  /** Driver's explanation for this task; required when status is incomplete. */
  note?: InputMaybe<Scalars['String']>;
  /** complete or incomplete. */
  status: GDeliveryRouteStopTaskResolution;
  /** The task being resolved. */
  taskId: Scalars['ID'];
};

export enum GDeliveryRouteStopTaskStatus {
  /** Driver marked the task done */
  Complete = 'complete',
  /** GM created the task; the driver has not resolved it yet */
  Created = 'created',
  /** Driver marked the task not done; a driver note explains why */
  Incomplete = 'incomplete'
}

/** Autogenerated input type of DeliveryRouteStopTaskUpdate */
export type GDeliveryRouteStopTaskUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Task text (max 500 chars). */
  details: Scalars['String'];
  /** Task id. */
  id: Scalars['ID'];
};

/** Autogenerated return type of DeliveryRouteStopTaskUpdate. */
export type GDeliveryRouteStopTaskUpdatePayload = {
  __typename?: 'DeliveryRouteStopTaskUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  task?: Maybe<GDeliveryRouteStopTask>;
  userErrors: Array<GDeliveryRouteStopTaskError>;
};

/** Autogenerated input type of DeliveryRouteStopTasksResolve */
export type GDeliveryRouteStopTasksResolveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** One entry per task on the stop, each carrying its own note. */
  resolutions: Array<GDeliveryRouteStopTaskResolutionInput>;
  /** Delivery route stop id. */
  stopId: Scalars['ID'];
};

/** Autogenerated return type of DeliveryRouteStopTasksResolve. */
export type GDeliveryRouteStopTasksResolvePayload = {
  __typename?: 'DeliveryRouteStopTasksResolvePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  tasks?: Maybe<Array<GDeliveryRouteStopTask>>;
  userErrors: Array<GDeliveryRouteStopTaskError>;
};

/** Autogenerated input type of DeliveryRouteStopUpsellNoteUpdate */
export type GDeliveryRouteStopUpsellNoteUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  redelivery?: InputMaybe<Scalars['Boolean']>;
  /** Delivery route stop id. */
  stopId: Scalars['ID'];
  /** Upsell note for the stop. */
  upsellNote: Scalars['String'];
};

/** Autogenerated return type of DeliveryRouteStopUpsellNoteUpdate. */
export type GDeliveryRouteStopUpsellNoteUpdatePayload = {
  __typename?: 'DeliveryRouteStopUpsellNoteUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userErrors: Array<GDeliveryRouteStopError>;
};

/** Autogenerated input type of DeliveryRouteStopViewedAtUpdate */
export type GDeliveryRouteStopViewedAtUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** delivery route stop id. */
  deliveryRouteStopId: Scalars['ID'];
  redelivery?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of DeliveryRouteStopViewedAtUpdate. */
export type GDeliveryRouteStopViewedAtUpdatePayload = {
  __typename?: 'DeliveryRouteStopViewedAtUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  deliveryRouteStop?: Maybe<GDeliveryStop>;
  userErrors: Array<GDeliveryRouteStopError>;
};

export type GDeliveryRule = {
  __typename?: 'DeliveryRule';
  deliveryDay: Scalars['Int'];
  id: Scalars['ID'];
  leadTime: Scalars['Int'];
  orderDeadline: Scalars['String'];
};

export enum GDeliveryStatus {
  /** delivery route stop is marked completed and has no issues and all orders delivered */
  Done = 'done',
  /**
   * delivery route stop has at least one delivery issue or at least one order is not marked
   * delivered.
   */
  Error = 'error',
  /** Delivery route stop has not been viewed by a driver */
  New = 'new'
}

export enum GDeliveryStatusDmp {
  /** Location stop is marked as completed and all orders have been delivered */
  Delivered = 'delivered',
  /** Vendor stop has not been collected. Location stop has not been delivered yet */
  InTransit = 'in_transit',
  /** only returned if a stop is not a vendor stop or a location stop. Should never happen */
  NotAvailable = 'not_available',
  /** Vendor stop is marked as collected but all orders are not collected */
  NotPickedUp = 'not_picked_up',
  /** Location stop is marked as completed and has at least one order partially delivered */
  PartiallyDelivered = 'partially_delivered',
  /** Vendor stop is marked as collected but all some orders are marked as collected and some not collected */
  PartiallyPickedUp = 'partially_picked_up',
  /** Vendor stop is marked as collected and all orders are marked as collected */
  PickedUp = 'picked_up',
  /** Location stop is marked as completed and has at least one order undelivered */
  Undelivered = 'undelivered'
}

export enum GDeliveryStatusDriver {
  /** delivery route stop is marked completed and has no issues and all orders delivered */
  Done = 'done',
  /**
   * stop has at least one delivery issue or at least one order is not marked
   * delivered or at least one order has less delivered quantities than fulfilled
   */
  Error = 'error',
  /** Delivery route stop has not been viewed by a driver */
  New = 'new'
}

/** Delivery stop */
export type GDeliveryStop = GDelivery | GPickUp;

/** Autogenerated input type of DeliveryStopsMoveToRoute */
export type GDeliveryStopsMoveToRouteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  redelivery?: InputMaybe<Scalars['Boolean']>;
  /** Delivery route id you would like to move the stops to. */
  routeId: Scalars['ID'];
  /** ID of the stop you would like to move. */
  stopIds: Array<Scalars['ID']>;
};

/** Autogenerated return type of DeliveryStopsMoveToRoute. */
export type GDeliveryStopsMoveToRoutePayload = {
  __typename?: 'DeliveryStopsMoveToRoutePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  updatedRoutes?: Maybe<Array<GRoute>>;
  userErrors: Array<GDeliveryRouteStopError>;
};

/** Autogenerated input type of DeliveryStopsReorder */
export type GDeliveryStopsReorderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The sequence number you would like to move your stop to on the specified route. */
  destinationSequenceNumber: Scalars['Int'];
  redelivery?: InputMaybe<Scalars['Boolean']>;
  /** Delivery route id. */
  routeId: Scalars['ID'];
  /** Stop id you would like to move. */
  stopId: Scalars['ID'];
};

/** Autogenerated return type of DeliveryStopsReorder. */
export type GDeliveryStopsReorderPayload = {
  __typename?: 'DeliveryStopsReorderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  route?: Maybe<GRoute>;
  userErrors: Array<GDeliveryRouteStopError>;
};

/** How a delivery is prioritized by the carrier. */
export enum GDeliveryType {
  /** Expedited delivery. */
  Expedited = 'EXPEDITED',
  /** Guaranteed delivery. */
  Guaranteed = 'GUARANTEED',
  /** Standard delivery. */
  StandardDelivery = 'STANDARD_DELIVERY'
}

export type GDepartNotAllowed = GUserErrorInterface & {
  __typename?: 'DepartNotAllowed';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of DeprioritizeLocation */
export type GDeprioritizeLocationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  locationId: Scalars['ID'];
  reason: Scalars['String'];
};

/** Autogenerated return type of DeprioritizeLocation. */
export type GDeprioritizeLocationPayload = {
  __typename?: 'DeprioritizeLocationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GUserError>;
  locationDeprioritization?: Maybe<GLocationDeprioritization>;
};

export type GDirectUploadHeader = {
  __typename?: 'DirectUploadHeader';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type GDiscontinueWarehouseInput = {
  discontinueItem: Scalars['Boolean'];
  discontinueSample: Scalars['Boolean'];
  replacementItemId?: InputMaybe<Scalars['ID']>;
  warehouseId: Scalars['ID'];
};

export type GDispatchNotAllowed = GUserErrorInterface & {
  __typename?: 'DispatchNotAllowed';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GDispatchProfileIncomplete = GUserErrorInterface & {
  __typename?: 'DispatchProfileIncomplete';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of DispatchProviderRoute */
export type GDispatchProviderRouteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The provider's id of the quote to dispatch against, from Route.providerDispatch.quotes. */
  quoteId: Scalars['String'];
  /** The marked route to dispatch. */
  routeId: Scalars['ID'];
};

/** Autogenerated return type of DispatchProviderRoute. */
export type GDispatchProviderRoutePayload = {
  __typename?: 'DispatchProviderRoutePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  route?: Maybe<GRoute>;
  userErrors: Array<GThirdPartyDispatchError>;
};

export type GDock = {
  __typename?: 'Dock';
  active: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  /** Booking windows, sorted, non-overlapping. */
  windows: Array<GDockWindow>;
};

export type GDockBooking = {
  __typename?: 'DockBooking';
  /**
   * When this booking's current slot/dock was last set — re-stamped on every
   * amend. Compare against created_at with a threshold, not strict equality — the
   * two are stamped separately and differ by a few microseconds even on a
   * never-amended booking.
   */
  bookedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Whether this is a purchase order, transfer order, or non-inventory vendor delivery. */
  bookingKind: GDockBookingKind;
  /**
   * Whether ops can add another PO to this booking's LTL truck now. One lookup per
   * booking, so read it from dockBooking rather than a list.
   */
  canAddPo: Scalars['Boolean'];
  carrierName?: Maybe<Scalars['String']>;
  /** Notes or special instructions for the delivery. */
  comments?: Maybe<Scalars['String']>;
  /** Email the booking confirmation is sent to. */
  confirmationEmail?: Maybe<Scalars['String']>;
  /** Appointment reference for confirmations. */
  confirmationNumber?: Maybe<Scalars['String']>;
  /** Contact email for the delivery. */
  contactEmail?: Maybe<Scalars['String']>;
  /** Contact person for the delivery. */
  contactName?: Maybe<Scalars['String']>;
  /** Contact phone for the delivery. */
  contactPhone?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  /** How the delivery is prioritized. */
  deliveryType?: Maybe<GDeliveryType>;
  dock?: Maybe<GDock>;
  expectedDate?: Maybe<Scalars['ISO8601Date']>;
  freightType?: Maybe<GFreightType>;
  id: Scalars['ID'];
  /** Source warehouse a transfer order is arriving from, matched by reference number; null for non-transfer bookings. */
  originName?: Maybe<Scalars['String']>;
  /** Number of pallets on the shipment. */
  palletCount?: Maybe<Scalars['Int']>;
  /** Carrier PRO (tracking) number. */
  proNumber?: Maybe<Scalars['String']>;
  referenceNumber: Scalars['String'];
  /** The prior booking this one recovered from after a no-show or cancellation, if any. */
  rescheduledFrom?: Maybe<GDockBooking>;
  /** The later booking that recovered this one after a no-show or cancellation, if any. */
  rescheduledTo?: Maybe<GDockBooking>;
  /** Standard Carrier Alpha Code. */
  scacCode?: Maybe<Scalars['String']>;
  /** Date the freight ships (distinct from the appointment date). */
  shipDate?: Maybe<Scalars['ISO8601Date']>;
  slotEndsAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Slot in warehouse-local time. */
  slotLabel?: Maybe<Scalars['String']>;
  slotStartsAt?: Maybe<Scalars['ISO8601DateTime']>;
  /**
   * Who created this booking — the carrier-facing flow, or ops (standing/ad-hoc).
   * Combine with booking_kind to tell a PO-known ad-hoc booking apart from an
   * ordinary carrier one, since both share booking_kind PURCHASE_ORDER.
   */
  source: GDockBookingSource;
  status: GDockBookingStatus;
  /**
   * Secret token embedded in the driver's booking link.
   * @deprecated Unused since inbound-appointment (PO-based lookup); slated for removal.
   */
  token: Scalars['String'];
  /** Truck or trailer number. */
  truckNumber?: Maybe<Scalars['String']>;
  /** Vendor/entity on the PO matched by reference number, if any. */
  vendorName?: Maybe<Scalars['String']>;
  /** Physical arrivals this booking's cargo turned up on, oldest first. */
  visits: Array<GDockVisit>;
  /** Shipment weight in pounds. */
  weightLbs?: Maybe<Scalars['Float']>;
  /** Slot length in minutes once booked (null until a freight type is set). */
  windowMinutes?: Maybe<Scalars['Int']>;
};

/** Autogenerated input type of DockBookingAddPo */
export type GDockBookingAddPoInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** A booking on the truck. */
  dockBookingId: Scalars['ID'];
  /** The PO to add. */
  referenceNumber: Scalars['String'];
};

/** Autogenerated return type of DockBookingAddPo. */
export type GDockBookingAddPoPayload = {
  __typename?: 'DockBookingAddPoPayload';
  /** The added PO's booking. */
  booking?: Maybe<GDockBooking>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userErrors: Array<GDockBookingError>;
};

export type GDockBookingAlreadyCompleted = GUserErrorInterface & {
  __typename?: 'DockBookingAlreadyCompleted';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GDockBookingAlreadyMissed = GUserErrorInterface & {
  __typename?: 'DockBookingAlreadyMissed';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of DockBookingCancel */
export type GDockBookingCancelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  dockBookingId: Scalars['ID'];
};

/** Autogenerated return type of DockBookingCancel. */
export type GDockBookingCancelPayload = {
  __typename?: 'DockBookingCancelPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  dockBooking?: Maybe<GDockBooking>;
  userErrors: Array<GDockBookingError>;
};

/** Dock booking possible error types */
export type GDockBookingError = GAdHocAppointmentsNotAllowed | GAppointmentInPast | GCarrierNameRequired | GCheckInNotAllowed | GContactDetailsRequired | GDailyDeliveryExists | GDepartNotAllowed | GDockBookingAlreadyCompleted | GDockBookingAlreadyMissed | GDockBookingNotBooked | GDockBookingNotFound | GDockBookingWarehouseNotFound | GDockCapacityInvalid | GDockInUse | GDockNotFound | GDockOverrideCodeInactive | GDockReassignNotAllowed | GDockRecoveryNotAllowed | GDockSlotUnavailable | GDockVisitNotFound | GOverrideCodeIssueConflict | GOverrideCodeNotFound | GOverrideVendorNotFound | GShipDateRequired | GWithinLeadTime;

export enum GDockBookingKind {
  /** An ops-created one-off appointment with no PO on file. */
  AdHoc = 'AD_HOC',
  /** A code-authorized non-inventory vendor delivery (no PO/TO). */
  NonInventory = 'NON_INVENTORY',
  /** A purchase-order delivery from a vendor. */
  PurchaseOrder = 'PURCHASE_ORDER',
  /** A recurring standing-appointment occurrence. */
  Standing = 'STANDING',
  /** An inbound transfer order from another warehouse. */
  TransferOrder = 'TRANSFER_ORDER'
}

/** Autogenerated input type of DockBookingMarkMissed */
export type GDockBookingMarkMissedInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  dockBookingId: Scalars['ID'];
};

/** Autogenerated return type of DockBookingMarkMissed. */
export type GDockBookingMarkMissedPayload = {
  __typename?: 'DockBookingMarkMissedPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  dockBooking?: Maybe<GDockBooking>;
  userErrors: Array<GDockBookingError>;
};

export type GDockBookingNotBooked = GUserErrorInterface & {
  __typename?: 'DockBookingNotBooked';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GDockBookingNotFound = GUserErrorInterface & {
  __typename?: 'DockBookingNotFound';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of DockBookingOpsCheckIn */
export type GDockBookingOpsCheckInInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  dockBookingId: Scalars['ID'];
  /** Trailer the driver actually arrived with. Optional; falls back to what's on file. */
  truckNumber?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of DockBookingOpsCheckIn. */
export type GDockBookingOpsCheckInPayload = {
  __typename?: 'DockBookingOpsCheckInPayload';
  booking?: Maybe<GDockBooking>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userErrors: Array<GDockBookingError>;
  visit?: Maybe<GDockVisit>;
};

export enum GDockBookingSource {
  /** Created through the public, carrier-facing booking flow. */
  Carrier = 'CARRIER',
  /** Created by ops — a standing appointment or an ad-hoc appointment. */
  Ops = 'OPS'
}

export enum GDockBookingStatus {
  Booked = 'BOOKED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Missed = 'MISSED',
  Pending = 'PENDING'
}

export type GDockBookingWarehouseNotFound = GUserErrorInterface & {
  __typename?: 'DockBookingWarehouseNotFound';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GDockCapacityInvalid = GUserErrorInterface & {
  __typename?: 'DockCapacityInvalid';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of DockCreate */
export type GDockCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  warehouseId: Scalars['ID'];
  windows: Array<GDockWindowInput>;
};

/** Autogenerated return type of DockCreate. */
export type GDockCreatePayload = {
  __typename?: 'DockCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  dock?: Maybe<GDock>;
  userErrors: Array<GDockBookingError>;
};

/** Autogenerated input type of DockDelete */
export type GDockDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  dockId: Scalars['ID'];
};

/** Autogenerated return type of DockDelete. */
export type GDockDeletePayload = {
  __typename?: 'DockDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedDockId?: Maybe<Scalars['ID']>;
  userErrors: Array<GDockBookingError>;
};

export type GDockInUse = GUserErrorInterface & {
  __typename?: 'DockInUse';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GDockNotFound = GUserErrorInterface & {
  __typename?: 'DockNotFound';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GDockOverrideCode = {
  __typename?: 'DockOverrideCode';
  active: Scalars['Boolean'];
  code: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  /** Identity of the admin who issued the code. */
  createdBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  netsuiteInternalId: Scalars['String'];
  vendorName?: Maybe<Scalars['String']>;
};

export type GDockOverrideCodeInactive = GUserErrorInterface & {
  __typename?: 'DockOverrideCodeInactive';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of DockOverrideCodeIssue */
export type GDockOverrideCodeIssueInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  netsuiteInternalId: Scalars['String'];
};

/** Autogenerated return type of DockOverrideCodeIssue. */
export type GDockOverrideCodeIssuePayload = {
  __typename?: 'DockOverrideCodeIssuePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  dockOverrideCode?: Maybe<GDockOverrideCode>;
  userErrors: Array<GDockBookingError>;
};

/** Autogenerated input type of DockOverrideCodeRevoke */
export type GDockOverrideCodeRevokeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of DockOverrideCodeRevoke. */
export type GDockOverrideCodeRevokePayload = {
  __typename?: 'DockOverrideCodeRevokePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  dockOverrideCode?: Maybe<GDockOverrideCode>;
  userErrors: Array<GDockBookingError>;
};

export type GDockReassignNotAllowed = GUserErrorInterface & {
  __typename?: 'DockReassignNotAllowed';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GDockRecoveryNotAllowed = GUserErrorInterface & {
  __typename?: 'DockRecoveryNotAllowed';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GDockSlotUnavailable = GUserErrorInterface & {
  __typename?: 'DockSlotUnavailable';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of DockUpdate */
export type GDockUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  dockId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  windows?: InputMaybe<Array<GDockWindowInput>>;
};

/** Autogenerated return type of DockUpdate. */
export type GDockUpdatePayload = {
  __typename?: 'DockUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  dock?: Maybe<GDock>;
  userErrors: Array<GDockBookingError>;
};

/** A truck's physical stay at the dock, as opposed to the appointment it was keeping. */
export type GDockVisit = {
  __typename?: 'DockVisit';
  /** The dock-approach buffer used to compute detentionSeconds, frozen alongside it. */
  approachBufferMinutesApplied?: Maybe<Scalars['Int']>;
  /** The delivery this visit was opened against. */
  booking?: Maybe<GDockBooking>;
  /** Every DockBooking currently linked to this visit's manifest, oldest-linked first. */
  bookings: Array<GDockBooking>;
  /** When the driver checked in. */
  checkedInAt: Scalars['ISO8601DateTime'];
  /** How the check-in was recorded. Null for visits recorded before this was tracked. */
  checkedInVia?: Maybe<GDockVisitCheckedInVia>;
  /** When ops marked the truck away. Null while it is still on site. */
  departedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** How the departure was recorded. Null while open, and for visits departed before this was tracked. */
  departedVia?: Maybe<GDockVisitDepartedVia>;
  /**
   * Time beyond the free allowance, measured from the later of check-in or the
   * appointment's own start (so an early arrival isn't charged for time before its
   * window opened), frozen at departure. Null while open, and permanently null for
   * freight_type "other" (no confirmed threshold).
   */
  detentionSeconds?: Maybe<Scalars['Int']>;
  /** Dock the truck was placed on. Null when none was free at check-in. */
  dock?: Maybe<GDock>;
  /** Time on site, set once both ends are observed and null until then. */
  dwellSeconds?: Maybe<Scalars['Int']>;
  /**
   * The LTL/FTL free-dwell threshold used to compute detentionSeconds, frozen
   * alongside it so a later policy change doesn't reclassify this visit.
   */
  freeDwellMinutesApplied?: Maybe<Scalars['Int']>;
  /** Snapshotted at check-in. */
  freightType?: Maybe<GFreightType>;
  id: Scalars['ID'];
  /**
   * Every DockBooking in this visit's same-truck group (same warehouse, expected
   * date, and SCAC, LTL only) — whether or not each one is linked to this visit
   * yet. Compare against `bookings` to see what's outstanding. Empty for FTL/OTHER
   * visits, which are always exactly one booking.
   */
  manifestGroupBookings: Array<GDockBooking>;
  /** Standard Carrier Alpha Code, snapshotted at check-in. */
  scacCode?: Maybe<Scalars['String']>;
  /** End of the frozen appointment window; see slotStartsAt. */
  slotEndsAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Appointment window this arrival was measured against, frozen at check-in so a later amendment cannot rewrite it. */
  slotStartsAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Trailer number given at check-in: what turned up, as against what the carrier declared when booking. */
  truckNumber?: Maybe<Scalars['String']>;
};

export enum GDockVisitCheckedInVia {
  /** A kiosk's own dockId. */
  Kiosk = 'KIOSK',
  /** Ops, directly from the admin board — no reference typed. */
  Ops = 'OPS',
  /** A warehouse placard's warehouseId. */
  Placard = 'PLACARD'
}

/** Autogenerated input type of DockVisitDepart */
export type GDockVisitDepartInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  dockVisitId: Scalars['ID'];
};

/** Autogenerated return type of DockVisitDepart. */
export type GDockVisitDepartPayload = {
  __typename?: 'DockVisitDepartPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  dockVisit?: Maybe<GDockVisit>;
  userErrors: Array<GDockBookingError>;
};

export enum GDockVisitDepartedVia {
  /** An ops kiosk/admin tap. */
  Ops = 'OPS',
  /** The overnight auto-close sweep. */
  Sweep = 'SWEEP'
}

export type GDockVisitNotFound = GUserErrorInterface & {
  __typename?: 'DockVisitNotFound';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of DockVisitReassignDock */
export type GDockVisitReassignDockInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  dockId: Scalars['ID'];
  dockVisitId: Scalars['ID'];
};

/** Autogenerated return type of DockVisitReassignDock. */
export type GDockVisitReassignDockPayload = {
  __typename?: 'DockVisitReassignDockPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  dockVisit?: Maybe<GDockVisit>;
  userErrors: Array<GDockBookingError>;
};

export type GDockWindow = {
  __typename?: 'DockWindow';
  /** Warehouse-local wall clock, e.g. "13:00". */
  closeTime: Scalars['String'];
  /** Max full trucks (FTL/other) this window takes; 0 = blocked. */
  ftlMax: Scalars['Int'];
  id: Scalars['ID'];
  /** Max LTL trucks (distinct carriers) this window takes; 0 = blocked. */
  ltlMax: Scalars['Int'];
  /** Warehouse-local wall clock, e.g. "10:00". */
  openTime: Scalars['String'];
};

export type GDockWindowInput = {
  /** e.g. "13:00" */
  closeTime: Scalars['String'];
  /** Max full trucks (FTL/other) this window takes; omitted/null = 0 (blocked). */
  ftlMax?: InputMaybe<Scalars['Int']>;
  /** Max LTL trucks (distinct carriers) this window takes; omitted/null = 0 (blocked). */
  ltlMax?: InputMaybe<Scalars['Int']>;
  /** e.g. "10:00" */
  openTime: Scalars['String'];
};

export type GDockWindowNotFound = GUserErrorInterface & {
  __typename?: 'DockWindowNotFound';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GDriver = {
  __typename?: 'Driver';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

/** A single timestamped driver location fix on a route's breadcrumb trail. */
export type GDriverLocationPing = {
  __typename?: 'DriverLocationPing';
  /** Horizontal accuracy in meters, when available. */
  accuracy?: Maybe<Scalars['Float']>;
  /** Heading in degrees (0-360), when available. */
  heading?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  /** WGS84 latitude of the fix. */
  latitude: Scalars['Float'];
  /** WGS84 longitude of the fix. */
  longitude: Scalars['Float'];
  /** Device fix time. */
  occurredAt: Scalars['ISO8601DateTime'];
  /** Speed in m/s, when available. */
  speed?: Maybe<Scalars['Float']>;
};

export type GDriverLocationPingInput = {
  /** Horizontal accuracy in meters, when available. */
  accuracy?: InputMaybe<Scalars['Float']>;
  /** Heading in degrees (0-360), when available. */
  heading?: InputMaybe<Scalars['Float']>;
  /** WGS84 latitude of the fix. */
  latitude: Scalars['Float'];
  /** WGS84 longitude of the fix. */
  longitude: Scalars['Float'];
  /** Device fix time; the ordering/dedupe key. */
  occurredAt: Scalars['ISO8601DateTime'];
  /** Speed in m/s, when available. */
  speed?: InputMaybe<Scalars['Float']>;
};

export type GDriverLocationTrailInput = {
  /** Window start (inclusive). */
  from?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Delivery route id. */
  routeId: Scalars['ID'];
  /** Window end (inclusive). */
  to?: InputMaybe<Scalars['ISO8601DateTime']>;
};

/** Driver safety acknowledgement metadata and content. */
export type GDriverSafetyAcknowledgement = {
  __typename?: 'DriverSafetyAcknowledgement';
  acknowledgementCopy: Scalars['String'];
  acknowledgementText: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  driverAcknowledgementsCount: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
  publishOn: Scalars['ISO8601Date'];
  status: GDriverSafetyAcknowledgementStatus;
};

/** Autogenerated input type of DriverSafetyAcknowledgementAcknowledge */
export type GDriverSafetyAcknowledgementAcknowledgeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Driver safety acknowledgement ID. */
  driverSafetyAcknowledgementId: Scalars['ID'];
};

/** Autogenerated return type of DriverSafetyAcknowledgementAcknowledge. */
export type GDriverSafetyAcknowledgementAcknowledgePayload = {
  __typename?: 'DriverSafetyAcknowledgementAcknowledgePayload';
  acknowledgement?: Maybe<GDriverSafetyAcknowledgement>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userErrors: Array<GUserError>;
};

/** Autogenerated input type of DriverSafetyAcknowledgementCreate */
export type GDriverSafetyAcknowledgementCreateInput = {
  acknowledgementCopy: Scalars['String'];
  acknowledgementText: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  publishOn: Scalars['ISO8601Date'];
};

/** Autogenerated return type of DriverSafetyAcknowledgementCreate. */
export type GDriverSafetyAcknowledgementCreatePayload = {
  __typename?: 'DriverSafetyAcknowledgementCreatePayload';
  acknowledgement?: Maybe<GDriverSafetyAcknowledgement>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userErrors: Array<GUserError>;
};

/** Autogenerated input type of DriverSafetyAcknowledgementDelete */
export type GDriverSafetyAcknowledgementDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Driver safety acknowledgement ID. */
  driverSafetyAcknowledgementId: Scalars['ID'];
};

/** Autogenerated return type of DriverSafetyAcknowledgementDelete. */
export type GDriverSafetyAcknowledgementDeletePayload = {
  __typename?: 'DriverSafetyAcknowledgementDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedId?: Maybe<Scalars['ID']>;
  userErrors: Array<GUserError>;
};

/** Driver safety acknowledgement status. */
export enum GDriverSafetyAcknowledgementStatus {
  Published = 'published',
  Scheduled = 'scheduled'
}

/** Autogenerated input type of DriverSafetyAcknowledgementUpdate */
export type GDriverSafetyAcknowledgementUpdateInput = {
  acknowledgementCopy: Scalars['String'];
  acknowledgementText: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Driver safety acknowledgement ID. */
  driverSafetyAcknowledgementId: Scalars['ID'];
  name: Scalars['String'];
  publishOn: Scalars['ISO8601Date'];
};

/** Autogenerated return type of DriverSafetyAcknowledgementUpdate. */
export type GDriverSafetyAcknowledgementUpdatePayload = {
  __typename?: 'DriverSafetyAcknowledgementUpdatePayload';
  acknowledgement?: Maybe<GDriverSafetyAcknowledgement>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userErrors: Array<GUserError>;
};

/**
 * Error indicating that a mutation whose input requires a collection of unique
 * elements failed because the provided collection contained duplicates.
 */
export type GDuplicateInputError = GError & {
  __typename?: 'DuplicateInputError';
  /** ID of duplicate element. */
  id: Scalars['ID'];
  /** A description of the error. */
  message: Scalars['String'];
};

export type GDuplicateMasterHomepageInput = {
  endDate: Scalars['ISO8601Date'];
  id: Scalars['ID'];
  name: Scalars['String'];
  startDate: Scalars['ISO8601Date'];
};

export type GDuplicateMasterHomepagePayload = {
  __typename?: 'DuplicateMasterHomepagePayload';
  errors: Array<GMasterHomepageError>;
  masterHomepage?: Maybe<GMasterHomepageListItem>;
};

export enum GEditPermissionForViewerEnum {
  /** Target's role is above what the viewer may edit */
  BlockedByRole = 'BLOCKED_BY_ROLE',
  /** Viewer may edit this user normally */
  Editable = 'EDITABLE',
  /** Target holds a location the viewer lacks */
  RestrictedLocation = 'RESTRICTED_LOCATION'
}

/** Error indicating the requested email address is already in use. */
export type GEmailAlreadyTaken = GError & {
  __typename?: 'EmailAlreadyTaken';
  /** A description of the error. */
  message: Scalars['String'];
};

export type GEmailValidationResult = {
  __typename?: 'EmailValidationResult';
  /** Error message if validation fails */
  errorMessage?: Maybe<Scalars['String']>;
  /** Whether the email is valid for signup */
  isValid: Scalars['Boolean'];
};

/** Error indicating an empty cart caused an operation to fail. */
export type GEmptyCartError = GError & {
  __typename?: 'EmptyCartError';
  /** A description of the error. */
  message: Scalars['String'];
};

export type GEquipmentOrderLineInput = {
  /** The brand of the equipment ordered. */
  brand: Scalars['String'];
  /** The model/name of the equipment ordered. */
  model: Scalars['String'];
  /** The cost of the base machine */
  modelPriceCents: Scalars['Int'];
  /** A list of model-specific option name, value pairs */
  options: Array<GEquipmentOrderLineOptionInput>;
  /** The quantity ordered. */
  quantity: Scalars['Int'];
  /** The subtotal cost of the quantity x machine with options */
  subtotalCents: Scalars['Int'];
};

export type GEquipmentOrderLineOptionInput = {
  /** The model-specific name of the option. */
  name: Scalars['String'];
  /** The price of the selected suboption. */
  priceCents: Scalars['Int'];
  /** The selected suboption for the option. */
  value: Scalars['String'];
};

/** The name of the ERP platform. Currently only NetSuite is supported. */
export enum GErpPlatform {
  Netsuite = 'NETSUITE'
}

/** The name of an ERP record type, as understood by the ERP. */
export enum GErpRecord {
  Item = 'ITEM',
  SalesOrder = 'SALES_ORDER'
}

/** Error. */
export type GError = {
  /** A description of the error. */
  message: Scalars['String'];
};

export type GErrorUpdatingItemPrices = GError & {
  __typename?: 'ErrorUpdatingItemPrices';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Collection of one or more errors. */
export type GErrors = {
  __typename?: 'Errors';
  /** First error. */
  head: GError;
  /** List (possibly empty) of additional errors. */
  tail: Array<GError>;
};

/** Result of an operation that failed due to one or more errors. */
export type GErrorsResult = {
  __typename?: 'ErrorsResult';
  /** Non-empty collection of errors that occurred. */
  errors: GErrors;
};

/** Autogenerated input type of EscalateStopsToProvider */
export type GEscalateStopsToProviderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The night the stops are on: any past night, today or tomorrow in the warehouse's zone. */
  nightEnd: Scalars['ISO8601Date'];
  /** When the courier should collect. Omitted or null means ASAP at push time. */
  pickupAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The provider to send the stops to. */
  provider: GThirdPartyProvider;
  /** The stops to escalate, 1 to 50. */
  stopIds: Array<Scalars['ID']>;
  /** The warehouse the stops belong to. */
  warehouseId: Scalars['ID'];
};

/** Autogenerated return type of EscalateStopsToProvider. */
export type GEscalateStopsToProviderPayload = {
  __typename?: 'EscalateStopsToProviderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  route?: Maybe<GRoute>;
  userErrors: Array<GThirdPartyDispatchError>;
};

export type GEtasStatus = {
  __typename?: 'EtasStatus';
  /** When the most recent usable ETA calculation ran. Null if none has run. */
  lastCalculatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The RoutificRun id of the most recent usable ETA calculation. Null if none has run. */
  lastCalculatedRunId?: Maybe<Scalars['ID']>;
  /** Why the ETAs are stale. Null when not stale. */
  reason?: Maybe<GEtasStatusReason>;
  /** True when the applied ETAs no longer reflect the current dispatched stop layout. */
  stale: Scalars['Boolean'];
};

/** Why the plan's ETAs are considered stale. Drives the timeline warning copy. */
export enum GEtasStatusReason {
  /** No usable etas_only run exists yet for this warehouse + night. */
  NeverCalculated = 'NEVER_CALCULATED',
  /** A reoptimize/re-sequence run happened after the last ETA calculation, so the applied ETAs predate it. */
  ReoptimizedSince = 'REOPTIMIZED_SINCE',
  /** Stops were moved (route reassignment or resequencing) after the last ETA calculation. */
  StopsMovedSince = 'STOPS_MOVED_SINCE'
}

export type GExpectedPurchaseOrder = {
  __typename?: 'ExpectedPurchaseOrder';
  /** PO due date, if any. */
  dueDate?: Maybe<Scalars['ISO8601Date']>;
  /** PO transaction (order) date, if any. */
  orderDate?: Maybe<Scalars['ISO8601Date']>;
  /** PO status from NetSuite. */
  status?: Maybe<Scalars['String']>;
  /** PO number. */
  tranId: Scalars['String'];
  /** Vendor/entity on the PO. */
  vendorName?: Maybe<Scalars['String']>;
  /** Receiving warehouse. */
  warehouseName?: Maybe<Scalars['String']>;
};

export type GExpectedTransferOrder = {
  __typename?: 'ExpectedTransferOrder';
  /** TO due date, if any. */
  dueDate?: Maybe<Scalars['ISO8601Date']>;
  /** TO transaction (order) date, if any. */
  orderDate?: Maybe<Scalars['ISO8601Date']>;
  /** Source ("From") warehouse the transfer ships from. */
  originName?: Maybe<Scalars['String']>;
  /** TO status from NetSuite. */
  status?: Maybe<Scalars['String']>;
  /** TO number. */
  tranId: Scalars['String'];
  /** Destination (receiving) warehouse. */
  warehouseName?: Maybe<Scalars['String']>;
};

export type GExternalBaseBrandedItem = GBaseBrandedItem & {
  __typename?: 'ExternalBaseBrandedItem';
  /** Colors that are available for the item */
  baseBrandedItemColors: Array<GBaseBrandedItemColor>;
  /** Quantity ranges that differentiate price breaks for the item */
  baseBrandedItemQuantityRanges: Array<GBaseBrandedItemQuantityRange>;
  baseColor?: Maybe<GColor>;
  bottomLayerColor?: Maybe<GColor>;
  /** Artwork options for the item */
  brandedItemArtworks: Array<GBrandedItemArtwork>;
  category: GCategory;
  /** Price that we charge for delivery of this item */
  deliveryPrice: GMoney;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrls: Array<Scalars['String']>;
  itemSizeLabel?: Maybe<Scalars['String']>;
  materialType?: Maybe<Scalars['String']>;
  maxOrderQty?: Maybe<Scalars['Int']>;
  minOrderQty: Scalars['Int'];
  name: Scalars['String'];
  printingMethod: GPrintingMethod;
  procurementVendor: GProcurementVendor;
  purchaseMultiple: Scalars['Int'];
  salesUnit: GUnit;
  shape?: Maybe<Scalars['String']>;
  subcategory: GCategory;
  variants: Array<GExternalBaseBrandedItemVariant>;
  wallType?: Maybe<Scalars['String']>;
  /** Warehouses the item is available in */
  warehouseBaseBrandedItems: Array<GWarehouseBaseBrandedItem>;
};

export type GExternalBaseBrandedItemVariant = {
  __typename?: 'ExternalBaseBrandedItemVariant';
  color?: Maybe<GColor>;
  endQuantity?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  /** Price that we sell this variant of the item at */
  salesPrice: GMoney;
  /** One time cost to setup the item for the customer */
  setupFee: GMoney;
  startQuantity: Scalars['Int'];
  warehouse: GWarehouse;
};

export type GExternalBaseBrandedItemVariantInput = {
  /** Color that differentiates this variant */
  color?: InputMaybe<Scalars['ID']>;
  /** Quantity range that differentiates price breaks for this variant */
  quantityRange: GBaseBrandedItemQuantityRangeInput;
  salesPrice: GMoneyInput;
  setupFee: GMoneyInput;
  /** Warehouse that differentiates this variant */
  warehouse: Scalars['ID'];
};

export type GExternalDelivery = {
  __typename?: 'ExternalDelivery';
  /** The number of containers used when packing the delivery */
  containerCount?: Maybe<Scalars['Int']>;
  /** If present, the estimated time the delivery is expected to be delivered */
  estimatedDeliveryTime?: Maybe<Scalars['ISO8601DateTime']>;
  /** If present, the estimated time the delivery will be picked up */
  estimatedPickupTime?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  status?: Maybe<Scalars['String']>;
  trackingUrl?: Maybe<Scalars['String']>;
};

export type GExternalSupplier = {
  __typename?: 'ExternalSupplier';
  id: Scalars['ID'];
  name: Scalars['String'];
  odekoUuid: Scalars['ID'];
};

/** The connection type for ExternalSupplier. */
export type GExternalSupplierConnection = {
  __typename?: 'ExternalSupplierConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GExternalSupplierEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GExternalSupplier>>>;
  /** Information to aid in pagination. */
  pageInfo: GPageInfo;
};

/** An edge in a connection. */
export type GExternalSupplierEdge = {
  __typename?: 'ExternalSupplierEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GExternalSupplier>;
};

/** Kind of free-floating facility shape. */
export enum GFacilityElementType {
  Arrow = 'ARROW',
  Dock = 'DOCK',
  Label = 'LABEL',
  Room = 'ROOM',
  Wall = 'WALL',
  Zone = 'ZONE'
}

/** Favorite consumer order. */
export type GFavoriteConsumerOrder = GNode & {
  __typename?: 'FavoriteConsumerOrder';
  /** Icon. */
  icon?: Maybe<Scalars['String']>;
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
  /** Name. */
  name?: Maybe<Scalars['String']>;
  /** Consumer order. */
  order: GConsumerOrder;
};

/** Favorite consumer order mutation result. */
export type GFavoriteConsumerOrderResult = GErrorsResult | GFavoriteConsumerOrderSuccess;

/** Result of a successful favorite consumer order mutation. */
export type GFavoriteConsumerOrderSuccess = {
  __typename?: 'FavoriteConsumerOrderSuccess';
  /** Resulting favorite consumer order. */
  favoriteConsumerOrder: GFavoriteConsumerOrder;
};

export type GFee = {
  __typename?: 'Fee';
  feeType: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  odekoUuid: Scalars['ID'];
  warehouseFeeAmountCents: Scalars['Int'];
  warehouseFeeAmountPercent?: Maybe<Scalars['Float']>;
  warehouseId: Scalars['ID'];
};

export type GFeeExemption = {
  __typename?: 'FeeExemption';
  fee: GFee;
  id: Scalars['ID'];
};

export type GFeeExemptionList = {
  __typename?: 'FeeExemptionList';
  fee: GFeeInterface;
  id: Scalars['ID'];
};

export type GFeeInterface = {
  /** The threshold amount in cents at which the fee is applied. */
  feeThresholds: Array<GFeeThreshold>;
  id: Scalars['ID'];
  /** Indicates if the fee is active or not. */
  isActive: Scalars['Boolean'];
  odekoUuid: Scalars['ID'];
};

export type GFeeThreshold = {
  __typename?: 'FeeThreshold';
  /** The amount of the fee in cents. */
  amountCents?: Maybe<Scalars['Int']>;
  /** The percentage amount of the fee if applicable. */
  amountPercent?: Maybe<Scalars['Float']>;
  /** The type of fee associated with this threshold. */
  feeType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** The maximum order amount in cents at which the fee is applied. */
  maxOrderAmountCents: Scalars['Int'];
  /** The minimum order amount in cents at which the fee is applied. */
  minOrderAmountCents: Scalars['Int'];
  /** The type of fee threshold. */
  thresholdType?: Maybe<Scalars['String']>;
};

export type GFieldServiceZipcode = {
  __typename?: 'FieldServiceZipcode';
  id: Scalars['ID'];
  /** The 5-digit zip code served for Field Service, e.g. "02134". */
  zipCode: Scalars['String'];
};

export type GFiltersArrayInput = {
  op: GFiltersArrayOps;
  value: Array<InputMaybe<Scalars['String']>>;
};

export enum GFiltersArrayOps {
  Contain = 'CONTAIN',
  Equal = 'EQUAL',
  NotContain = 'NOT_CONTAIN'
}

export type GFiltersBooleanInput = {
  op: GFiltersBooleanOps;
  value: Array<InputMaybe<Scalars['Boolean']>>;
};

export enum GFiltersBooleanOps {
  Equal = 'EQUAL',
  NotEqual = 'NOT_EQUAL'
}

export type GFiltersCatalogStatusInput = {
  op: GFiltersEnumOps;
  value: Array<InputMaybe<GCatalogStatus>>;
};

export type GFiltersDateInput = {
  op: GFiltersNumberOps;
  value: Array<InputMaybe<Scalars['ISO8601DateTime']>>;
};

export enum GFiltersEnumOps {
  Contain = 'CONTAIN',
  Equal = 'EQUAL',
  NotContain = 'NOT_CONTAIN',
  NotEqual = 'NOT_EQUAL'
}

export type GFiltersFloatInput = {
  op: GFiltersNumberOps;
  value: Array<InputMaybe<Scalars['Float']>>;
};

export type GFiltersIntInput = {
  op: GFiltersNumberOps;
  value: Array<InputMaybe<Scalars['Int']>>;
};

export type GFiltersInventoryCheckBehaviorInput = {
  op: GFiltersEnumOps;
  value: Array<InputMaybe<GInventoryCheckBehavior>>;
};

export type GFiltersItemTagDisplayAsInput = {
  op: GFiltersEnumOps;
  value: Array<InputMaybe<GItemTagDisplayAs>>;
};

export type GFiltersItemTypeInput = {
  op: GFiltersEnumOps;
  value: Array<InputMaybe<GItemType>>;
};

export type GFiltersMoneyInput = {
  currency: Scalars['String'];
  op: GFiltersNumberOps;
  value: Array<InputMaybe<Scalars['Float']>>;
};

export enum GFiltersNumberOps {
  Contain = 'CONTAIN',
  Equal = 'EQUAL',
  GreaterThan = 'GREATER_THAN',
  GreaterThanEqual = 'GREATER_THAN_EQUAL',
  LessThan = 'LESS_THAN',
  LessThanEqual = 'LESS_THAN_EQUAL',
  NotContain = 'NOT_CONTAIN',
  NotEqual = 'NOT_EQUAL',
  Range = 'RANGE'
}

export type GFiltersPerishabilityInput = {
  op: GFiltersEnumOps;
  value: Array<InputMaybe<GPerishability>>;
};

export type GFiltersRefrigerationStateInput = {
  op: GFiltersEnumOps;
  value: Array<InputMaybe<GRefrigerationState>>;
};

export type GFiltersStandingOrderBehaviorInput = {
  op: GFiltersEnumOps;
  value: Array<InputMaybe<GStandingOrderBehavior>>;
};

export type GFiltersStringInput = {
  op: GFiltersStringOps;
  value: Array<InputMaybe<Scalars['String']>>;
};

export enum GFiltersStringOps {
  Contain = 'CONTAIN',
  Equal = 'EQUAL',
  GreaterThan = 'GREATER_THAN',
  GreaterThanEqual = 'GREATER_THAN_EQUAL',
  Ilike = 'ILIKE',
  LessThan = 'LESS_THAN',
  LessThanEqual = 'LESS_THAN_EQUAL',
  Like = 'LIKE',
  NotContain = 'NOT_CONTAIN',
  NotEqual = 'NOT_EQUAL'
}

export type GFiltersTransitMethodInput = {
  op: GFiltersEnumOps;
  value: Array<InputMaybe<GTransitMethod>>;
};

export enum GFinancialStatementEmailFrequencyTypeEnum {
  /** On every other Monday at 5:30 AM EST */
  Biweekly = 'BIWEEKLY',
  /** On the 1st day of every month at 5:30 AM EST */
  Monthly = 'MONTHLY',
  /** Never */
  Never = 'NEVER',
  /** On every Monday at 5:30 AM EST */
  Weekly = 'WEEKLY'
}

export type GFinancialStatementPreferences = {
  __typename?: 'FinancialStatementPreferences';
  appliedToAllLocations: Scalars['Boolean'];
  billingContactEmails: Array<Scalars['String']>;
  emailFrequency: GFinancialStatementEmailFrequencyTypeEnum;
};

export type GFinancialTransaction = {
  id: Scalars['ID'];
  platformRecordId: Scalars['ID'];
  relatives: GFinancialTransactionConnection;
  transactionDate: Scalars['ISO8601Date'];
};

/** The connection type for FinancialTransaction. */
export type GFinancialTransactionConnection = {
  __typename?: 'FinancialTransactionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GFinancialTransactionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GFinancialTransaction>>>;
  /** Information to aid in pagination. */
  pageInfo: GPageInfo;
};

/** Date filter for FinancialTransactions using inclusive ranges. */
export type GFinancialTransactionDateRangeInput = {
  /** Results from this date, inclusive. (YYYY-MM-DD) */
  from: Scalars['ISO8601Date'];
  /** Results up to this date, inclusive. (YYYY-MM-DD) */
  to: Scalars['ISO8601Date'];
};

/** An edge in a connection. */
export type GFinancialTransactionEdge = {
  __typename?: 'FinancialTransactionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** Additional info about the meaning of this edge. */
  info: GFinancialTransactionEdgeInfo;
  /** The item at the end of the edge. */
  node?: Maybe<GFinancialTransaction>;
};

/** Info about a FinancialTransactionEdge. */
export type GFinancialTransactionEdgeInfo = {
  _?: Maybe<Scalars['String']>;
};

/** Set fleet composition possible errors */
export type GFleetCompositionError = GFleetCompositionNotEnabled | GFleetCompositionWarehouseNotFound | GInvalidFleetComposition;

export type GFleetCompositionNotEnabled = GUserErrorInterface & {
  __typename?: 'FleetCompositionNotEnabled';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GFleetCompositionWarehouseNotFound = GUserErrorInterface & {
  __typename?: 'FleetCompositionWarehouseNotFound';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GFleetVehicle = {
  __typename?: 'FleetVehicle';
  /** Percent of this type's full capacity to route against. An integer 1–100, defaulting to 100. */
  capacityPercent: Scalars['Int'];
  /** How many trucks of this type the warehouse routes with */
  count: Scalars['Int'];
  /** Per-truck volume capacity, in cubic inches */
  maxVolume: Scalars['Int'];
  /** Per-truck weight capacity, in pounds */
  maxWeight: Scalars['Int'];
  /** The vehicle type, e.g. "Box Truck" */
  vehicleType: Scalars['String'];
};

/**
 * One vehicle type in a warehouse's fleet: the type, how many trucks of it to
 * route with, and what percent of its capacity to fill.
 */
export type GFleetVehicleInput = {
  /** Percent of this type's full capacity to route against. An integer 1–100, defaulting to 100. */
  capacityPercent?: InputMaybe<Scalars['Int']>;
  /** How many trucks of this type the warehouse routes with. A non-negative integer. */
  count: Scalars['Int'];
  /** The vehicle type, e.g. "Box Truck". Must be one of the warehouse's vehicle types. */
  vehicleType: Scalars['String'];
};

export enum GFreightType {
  /** Full Truckload — a hard appointment; >15 min late is a work-in ($100 fee). */
  Ftl = 'FTL',
  /** Less Than Truckload — a 3-hour delivery window. */
  Ltl = 'LTL',
  /** Other — a fixed 2-hour delivery window. */
  Other = 'OTHER'
}

export type GFuelSurcharge = GFeeInterface & {
  __typename?: 'FuelSurcharge';
  /** The threshold amount in cents at which the fee is applied. */
  feeThresholds: Array<GFeeThreshold>;
  id: Scalars['ID'];
  /** Indicates if the fee is active or not. */
  isActive: Scalars['Boolean'];
  odekoUuid: Scalars['ID'];
  /** The amount of the fuel surcharge fee in cents. */
  warehouseFeeAmountCents: Scalars['Int'];
  /** Unique identifier of the warehouse associated with this fuel surcharge fee. */
  warehouseId: Scalars['ID'];
};

export type GFulfillmentWarehouse = {
  __typename?: 'FulfillmentWarehouse';
  distanceFromLocation?: Maybe<Scalars['Float']>;
  estimatedNextShippingDeliveryRange?: Maybe<GShippingEstimateDeliveryRange>;
  warehouse: GWarehouse;
};

/** The fund application exclusion state to set for one location. */
export type GFundApplicationExclusionInput = {
  /** Whether the location is excluded from automatic fund application. */
  excluded: Scalars['Boolean'];
  /** The location's odeko UUID, as federated on Location.id. */
  locationId: Scalars['ID'];
};

/** A game that can have leaderboards */
export type GGame = {
  __typename?: 'Game';
  /** Whether the game is active */
  active: Scalars['Boolean'];
  /** Active leaderboards for this game */
  activeLeaderboards: Array<GLeaderboard>;
  /** When the game was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** Description of the game */
  description?: Maybe<Scalars['String']>;
  /** Unique identifier for the game */
  id: Scalars['ID'];
  /** Leaderboards for this game */
  leaderboards: Array<GLeaderboard>;
  /** Additional game metadata */
  metadata: Scalars['JSON'];
  /** Name of the game */
  name: Scalars['String'];
  /** URL-friendly identifier */
  slug: Scalars['String'];
  /** When the game was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

export type GGenerateItemDescriptionInput = {
  brandName?: InputMaybe<Scalars['String']>;
  existingDescription?: InputMaybe<Scalars['String']>;
  itemName: Scalars['String'];
  upcCode?: InputMaybe<Scalars['String']>;
  userInstructions?: InputMaybe<Scalars['String']>;
};

export type GGenerateItemDescriptionResult = {
  __typename?: 'GenerateItemDescriptionResult';
  description?: Maybe<Scalars['String']>;
  /** When success=false: error description. When success=true: optional informational message. */
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of GenerateOrderQuantitiesMutation */
export type GGenerateOrderQuantitiesMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** PROTOTYPE for record keeping, a nominal delivery date to record. */
  minimalDeliveryDate?: InputMaybe<Scalars['ISO8601Date']>;
  /** PROTOTYPE id of the LocationStockCount session to use. */
  stockCountId: Scalars['ID'];
};

/** Autogenerated return type of GenerateOrderQuantitiesMutation. */
export type GGenerateOrderQuantitiesMutationPayload = {
  __typename?: 'GenerateOrderQuantitiesMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  /** PROTOTYPE the quantities generated. */
  generatedOrderQuantities: Array<GGeneratedOrderQuantity>;
};

/** Autogenerated input type of GeneratePresignedUrlMutation */
export type GGeneratePresignedUrlMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of GeneratePresignedUrlMutation. */
export type GGeneratePresignedUrlMutationPayload = {
  __typename?: 'GeneratePresignedUrlMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GUserError>;
  objectKey?: Maybe<Scalars['String']>;
  presignedReadUrl?: Maybe<Scalars['String']>;
  presignedUrl?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of GenerateUploadSignature */
export type GGenerateUploadSignatureInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the microsite location this media belongs to */
  micrositeLocationId: Scalars['ID'];
};

/** Autogenerated return type of GenerateUploadSignature. */
export type GGenerateUploadSignaturePayload = {
  __typename?: 'GenerateUploadSignaturePayload';
  /** Comma-separated list of allowed file formats */
  allowedFormats: Scalars['String'];
  /** Cloudinary API key */
  apiKey: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Cloudinary cloud name */
  cloudName: Scalars['String'];
  /** Target folder path in Cloudinary */
  folder: Scalars['String'];
  /** The signature for authenticated upload */
  signature: Scalars['String'];
  /** Unix timestamp used in signature */
  timestamp: Scalars['Int'];
};

/** PROTOTYPE GeneratedOrderQuantity representation */
export type GGeneratedOrderQuantity = {
  __typename?: 'GeneratedOrderQuantity';
  /** PROTOTYPE the counting event from which this generated order quantity was derived. */
  countingEvent: GCurrentCount;
  /** PROTOTYPE a user identifier for the user responsible for generating the order. Likely an Auth0 ID. */
  generatedBy?: Maybe<Scalars['String']>;
  /** PROTOTYPE id of the GeneratedOrderQuantity. */
  id: Scalars['ID'];
  /**
   * PROTOTYPE if supplied for record keeping at time of creation, the minimum
   * delivery date of the order in which the generated quantity may be used.
   */
  minimumDeliveryDate?: Maybe<Scalars['ISO8601Date']>;
  /** PROTOTYPE the Odeko UUID the reified order. */
  orderId?: Maybe<Scalars['ID']>;
  /** PROTOTYPE the Odeko UUID the reified order line. */
  orderLineId?: Maybe<Scalars['ID']>;
  /** PROTOTYPE the quantity of the reified order. */
  orderedQuantity?: Maybe<Scalars['Float']>;
  /** PROTOTYPE the the LocationItem's par value at the time this quantity was generated. */
  parValue: Scalars['Float'];
  /** PROTOTYPE the quantity to order in the sales unit recorded at the time of genreation. */
  quantity: Scalars['Float'];
  /** PROTOTYPE the sales unit for the quantity. */
  salesUnitId: Scalars['ID'];
  /** PROTOTYPE sku_id of the quantity was generated for. */
  skuId: Scalars['ID'];
};

/** A WGS84 point reported by a device. Latitude and longitude are always present together. */
export type GGeoCoordinates = {
  __typename?: 'GeoCoordinates';
  /** Horizontal accuracy in meters, as reported by the device. */
  accuracy?: Maybe<Scalars['Float']>;
  /** WGS84 latitude. */
  latitude: Scalars['Float'];
  /** WGS84 longitude. */
  longitude: Scalars['Float'];
};

/** A WGS84 point reported by a device. Latitude and longitude are required together. */
export type GGeoCoordinatesInput = {
  /** Horizontal accuracy in meters, when available. */
  accuracy?: InputMaybe<Scalars['Float']>;
  /** WGS84 latitude. */
  latitude: Scalars['Float'];
  /** WGS84 longitude. */
  longitude: Scalars['Float'];
};

/** Geographic coordinates */
export type GGeographicCoordinates = {
  /** Latitude */
  latitude: Scalars['Float'];
  /** Longitude */
  longitude: Scalars['Float'];
};

/** Circular geospatial region */
export type GGeospatialCircle = {
  /** Center point */
  center: GGeographicCoordinates;
  /** Radius, in miles */
  radius: Scalars['Int'];
};

/** Interface to information for a Google Place. The interface is based on business-portal's GooglePlaceDetails wrapper library. */
export type GGooglePlace = {
  __typename?: 'GooglePlace';
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  countryCode: Scalars['String'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  placeId: Scalars['String'];
  postalCode: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};

/** A guest player profile */
export type GGuestProfile = {
  __typename?: 'GuestProfile';
  /** When the profile was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** Unique identifier for the profile */
  id: Scalars['ID'];
  /** Leaderboard entries for this guest */
  leaderboardEntries: Array<GLeaderboardEntry>;
  /** When the profile was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
  /** Display name for the player */
  username: Scalars['String'];
};

export enum GHomepageCollectionComponentType {
  CollectionBanner = 'COLLECTION_BANNER',
  CollectionCarousel = 'COLLECTION_CAROUSEL',
  CollectionHighlightCarousel = 'COLLECTION_HIGHLIGHT_CAROUSEL',
  CollectionPromoPage = 'COLLECTION_PROMO_PAGE'
}

export type GHomepageComponentError = {
  __typename?: 'HomepageComponentError';
  code?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

export type GHomepageDisplayRuleError = {
  __typename?: 'HomepageDisplayRuleError';
  code?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

export type GHomepageDisplayRuleUpsertInput = {
  endDate?: InputMaybe<Scalars['String']>;
  ruleId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['String']>;
  warehouseIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type GHourOfDayQrScanCount = {
  __typename?: 'HourOfDayQrScanCount';
  /** Hour of day (0 to 23) */
  hourOfDay: Scalars['Int'];
  /** Total number of scans that occurred during this hour of day. */
  scanCount: Scalars['Int'];
};

export type GHubspotLead = {
  __typename?: 'HubspotLead';
  id: Scalars['ID'];
  isClosed?: Maybe<Scalars['Boolean']>;
  leadName?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['String']>;
  stage?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of ImportPriceRulesCsv */
export type GImportPriceRulesCsvInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Uploaded CSV parsed to a comma-separated string (with newlines) */
  csvContents: Scalars['String'];
};

/** Autogenerated return type of ImportPriceRulesCsv. */
export type GImportPriceRulesCsvPayload = {
  __typename?: 'ImportPriceRulesCsvPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any errors that occured during the CSV upload */
  errors?: Maybe<Array<Scalars['String']>>;
};

export type GImportProcurementInput = {
  itemId: Scalars['ID'];
  procurementVendorId: Scalars['ID'];
  purchasePrice?: InputMaybe<GMoneyInput>;
  warehouseId: Scalars['ID'];
};

export type GImpressionBreakdown = {
  __typename?: 'ImpressionBreakdown';
  desktopMaps: Scalars['Int'];
  desktopSearch: Scalars['Int'];
  mobileMaps: Scalars['Int'];
  mobileSearch: Scalars['Int'];
};

export type GInHouseBaseBrandedItem = GBaseBrandedItem & {
  __typename?: 'InHouseBaseBrandedItem';
  /** Colors that are available for the item */
  baseBrandedItemColors: Array<GBaseBrandedItemColor>;
  /** Quantity ranges that differentiate price breaks for the item */
  baseBrandedItemQuantityRanges: Array<GBaseBrandedItemQuantityRange>;
  baseColor?: Maybe<GColor>;
  bottomLayerColor?: Maybe<GColor>;
  /** Artwork options for the item */
  brandedItemArtworks: Array<GBrandedItemArtwork>;
  category: GCategory;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrls: Array<Scalars['String']>;
  itemSizeLabel?: Maybe<Scalars['String']>;
  materialType?: Maybe<Scalars['String']>;
  maxOrderQty?: Maybe<Scalars['Int']>;
  minOrderQty: Scalars['Int'];
  name: Scalars['String'];
  printingMethod: GPrintingMethod;
  purchaseMultiple: Scalars['Int'];
  salesUnit: GUnit;
  shape?: Maybe<Scalars['String']>;
  subcategory: GCategory;
  supplyItem: GSupplyItem;
  /** The enabled variants for this item */
  variants: Array<GInHouseBaseBrandedItemVariant>;
  wallType?: Maybe<Scalars['String']>;
  /** Warehouses the item is available in */
  warehouseBaseBrandedItems: Array<GWarehouseBaseBrandedItem>;
};

export type GInHouseBaseBrandedItemVariant = {
  __typename?: 'InHouseBaseBrandedItemVariant';
  id: Scalars['ID'];
  salesPrice: GMoney;
  warehouse: GWarehouse;
};

export type GInHouseBaseBrandedItemVariantInput = {
  salesPrice: GMoneyInput;
  /** Warehouse that differentiates this variant */
  warehouse: Scalars['ID'];
};

export type GInProgressCustomer = {
  __typename?: 'InProgressCustomer';
  acquisitionConversion: Scalars['String'];
  /** The foreign key to the customer in the system belonging to the Acquisiton Conversion, also known as the M&A Source. */
  acquisitionConversionId?: Maybe<Scalars['String']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  adminDistrictLevel1?: Maybe<Scalars['String']>;
  /** The run that last picked this record up, if any. */
  batchOnboardRun?: Maybe<GBatchOnboardRun>;
  companyName?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  /** reference to the file and row of the CustomerCsvUpload */
  customerCsvUpload: GCustomerCsvUpload;
  /** zero-based row number from which this record was generated. The first row after the csv header is row zero. */
  customerCsvUploadRow: Scalars['Int'];
  customerType?: Maybe<GInProgressCustomerCustomer>;
  duplicateLocations: Array<GLocation>;
  existingCompany?: Maybe<GCompany>;
  existingLocation?: Maybe<GLocation>;
  existingUser?: Maybe<GUser>;
  fullAddress?: Maybe<Scalars['String']>;
  googlePlace?: Maybe<GGooglePlace>;
  /** AUTOMATION when google_place was set by a job, or a user id if the google_place_id was set by an admin. */
  googlePlaceSetBy?: Maybe<Scalars['String']>;
  /**
   * A ready record carrying an error from its last attempt. An acquisition drain
   * skips it until it is fixed or explicitly re-selected.
   */
  hasOnboardingError: Scalars['Boolean'];
  id: Scalars['ID'];
  /** Onboarding for longer than the staleness window: its job died. Not retried automatically. */
  isStuck: Scalars['Boolean'];
  /**
   * If an error occurred during asynchronous onboarding, and the status of this
   * record is not COMPLETE, the object representing the latest reported error.
   */
  latestOnboardingError?: Maybe<GInProgressCustomerOnboardingError>;
  locality?: Maybe<Scalars['String']>;
  locationName?: Maybe<Scalars['String']>;
  /** When present, indicates one or more issues need addressing before the InProgressCustomer can start to be onboarded. */
  notReadyReasons?: Maybe<GInProgressCustomerNotReadyReasons>;
  /** The company and user information from the CSV (eg from the first paper_trail version of the record. */
  originalInfo?: Maybe<GInProgressCustomerOriginalInfo>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  shippingWarehouse?: Maybe<GWarehouse>;
  status: GInProgressCustomerStatus;
  terms?: Maybe<Scalars['Int']>;
  /** A unique identifier for the InProgressCustomer. */
  uniqueId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  userEmail?: Maybe<Scalars['String']>;
  userFirstName?: Maybe<Scalars['String']>;
  userFullName?: Maybe<Scalars['String']>;
  userLastName?: Maybe<Scalars['String']>;
  userRole?: Maybe<Scalars['String']>;
};

/**
 * Where one acquisition's in-progress customers stand right now, and the rows
 * behind the two CSVs Ops reconciles against their master list.
 */
export type GInProgressCustomerAcquisitionSummary = {
  __typename?: 'InProgressCustomerAcquisitionSummary';
  /** The run in progress, if any. */
  activeRun?: Maybe<GBatchOnboardRun>;
  completeCount: Scalars['Int'];
  /** Ready records an acquisition drain would pick up: no unresolved error. */
  eligibleCount: Scalars['Int'];
  /** Every completed record, unpaginated, for the CSV Ops reconciles against their master list. */
  exportCompleted: Array<GCompletedOnboardingRow>;
  /** Every record still ready, with its error where there is one. Unpaginated, for the companion CSV. */
  exportOutstanding: Array<GOutstandingOnboardingRow>;
  /** Ready records carrying an error from their last attempt. */
  failedCount: Scalars['Int'];
  /** Still in review; not yet ready. */
  inProgressCount: Scalars['Int'];
  /** The most recently finished run. */
  lastRun?: Maybe<GBatchOnboardRun>;
  /** Being worked right now. */
  onboardingCount: Scalars['Int'];
  /** Eligible records the active run has picked up but not yet worked. */
  queuedCount: Scalars['Int'];
  /** Onboarding past the staleness window: the job died. Needs a human. */
  stuckCount: Scalars['Int'];
};

/** The connection type for InProgressCustomer. */
export type GInProgressCustomerConnection = {
  __typename?: 'InProgressCustomerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GInProgressCustomerEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GInProgressCustomer>>>;
  /** Information to aid in pagination. */
  pageInfo: GPageInfo;
  /** The total count of records in the connection. */
  totalCount: Scalars['Int'];
};

export enum GInProgressCustomerCustomer {
  LocalDelivery = 'LOCAL_DELIVERY',
  PickUp = 'PICK_UP',
  Shipping = 'SHIPPING'
}

/** An edge in a connection. */
export type GInProgressCustomerEdge = {
  __typename?: 'InProgressCustomerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GInProgressCustomer>;
};

/** Set of available fields to update to help complete an InProgressCustomer. */
export type GInProgressCustomerInput = {
  companyName?: InputMaybe<Scalars['String']>;
  customerType?: InputMaybe<GInProgressCustomerCustomer>;
  existingCompanyUuid?: InputMaybe<Scalars['String']>;
  existingLocationUuid?: InputMaybe<Scalars['String']>;
  existingUserUuid?: InputMaybe<Scalars['String']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  locationName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  /** When customer_type is shipping, set the shipping warehouse. */
  shippingWarehouseId?: InputMaybe<Scalars['String']>;
  terms?: InputMaybe<Scalars['Int']>;
  userEmail?: InputMaybe<Scalars['String']>;
  userFirstName?: InputMaybe<Scalars['String']>;
  userFullName?: InputMaybe<Scalars['String']>;
  userLastName?: InputMaybe<Scalars['String']>;
  userRole?: InputMaybe<Scalars['String']>;
};

export type GInProgressCustomerNotReadyReasons = {
  __typename?: 'InProgressCustomerNotReadyReasons';
  company?: Maybe<Scalars['String']>;
  customerType?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['String']>;
  userEmail?: Maybe<Scalars['String']>;
  userFirstName?: Maybe<Scalars['String']>;
  userLastName?: Maybe<Scalars['String']>;
  userRole?: Maybe<Scalars['String']>;
};

/** The time (created_at) and reason that an attempt to (asynchronously) onboard an InProgressCustomer failed. */
export type GInProgressCustomerOnboardingError = {
  __typename?: 'InProgressCustomerOnboardingError';
  createdAt: Scalars['ISO8601DateTime'];
  reason: Scalars['String'];
};

export type GInProgressCustomerOriginalInfo = {
  __typename?: 'InProgressCustomerOriginalInfo';
  companyName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  userEmail?: Maybe<Scalars['String']>;
  userFirstName?: Maybe<Scalars['String']>;
  userLastName?: Maybe<Scalars['String']>;
  userRole?: Maybe<Scalars['String']>;
};

export enum GInProgressCustomerStatus {
  /** Onboarding is complete. */
  Complete = 'COMPLETE',
  /** More information is needed in order to start onboarding the InProgressCustomer. */
  InProgress = 'IN_PROGRESS',
  /** The InProgressCustomer is in the process of being onboarded (asynchronously, ususally). */
  Onboarding = 'ONBOARDING',
  /** All needed needed information is present to start onboarding the InProgressCustomer. */
  Ready = 'READY'
}

/** Filters for search for InProgressCustomers */
export type GInProgressCustomersSearchInput = {
  acquisitionConversion?: InputMaybe<Array<Scalars['String']>>;
  /** Search by company name, address, or unique_id */
  searchString?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<GInProgressCustomerStatus>>;
};

export enum GIngredientTypeEnum {
  CustomIngredient = 'CustomIngredient',
  ItemIngredient = 'ItemIngredient'
}

/** Autogenerated input type of InitializeMarketingToolsSignupMutation */
export type GInitializeMarketingToolsSignupMutationInput = {
  /** Business name from Google Places (optional) */
  businessName?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Context for the subscription session (defaults to 'signup') */
  context?: InputMaybe<Scalars['String']>;
  /** User email address (can be provided later via update) */
  email?: InputMaybe<Scalars['String']>;
  /** Google Location name for linking to existing GoogleLocation */
  googleLocationName?: InputMaybe<Scalars['String']>;
  /** Google Places API place ID */
  googlePlaceId: Scalars['String'];
  /** Optional pricing package ID (1, 2, 3, etc.) */
  pricingPackageId?: InputMaybe<Scalars['Int']>;
  /** Frontend origin URL for return navigation */
  returnOrigin: Scalars['String'];
  /** Physical sign color preference (optional) */
  signColor?: InputMaybe<Scalars['String']>;
  /** Physical sign material preference (optional if kit not purchased) */
  signMaterial?: InputMaybe<Scalars['String']>;
  /** URL-friendly slug for microsite */
  urlSlug: Scalars['String'];
};

/** Autogenerated return type of InitializeMarketingToolsSignupMutation. */
export type GInitializeMarketingToolsSignupMutationPayload = {
  __typename?: 'InitializeMarketingToolsSignupMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']>;
  /** Created subscription session */
  subscriptionSession?: Maybe<GSubscriptionSession>;
};

/** Autogenerated input type of InitiateTerminalPairingMutation */
export type GInitiateTerminalPairingMutationInput = {
  /** Account profile ID (external profile_id) */
  accountProfileId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Square location ID. If omitted, auto-selects when account has one active location */
  locationId?: InputMaybe<Scalars['ID']>;
  /** Optional name for the terminal */
  name?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of InitiateTerminalPairingMutation. */
export type GInitiateTerminalPairingMutationPayload = {
  __typename?: 'InitiateTerminalPairingMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The device code for pairing */
  deviceCode?: Maybe<GSquareDeviceCode>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']>;
};

/** Range of Ints */
export type GIntRangeInput = {
  /** Lower bound (inclusive) of the range */
  lowerBound?: InputMaybe<Scalars['Int']>;
  /** Upper bound of the range */
  upperBound?: InputMaybe<Scalars['Int']>;
  /** Whether upper bound is included in the range */
  upperInclusive: Scalars['Boolean'];
};

export type GInternalDeliveryInstructions = {
  __typename?: 'InternalDeliveryInstructions';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  imageKeys?: Maybe<Array<Scalars['String']>>;
  imageUrls?: Maybe<Array<Scalars['String']>>;
  location: GLocation;
  note?: Maybe<Scalars['String']>;
  /** Opaque ID for translating this instruction */
  translationId: Scalars['ID'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** A warehouse bin interpreted from its name plus the structured NetSuite columns. */
export type GInterpretedBin = {
  __typename?: 'InterpretedBin';
  aisle?: Maybe<Scalars['String']>;
  bay?: Maybe<Scalars['Int']>;
  bulkBin?: Maybe<Scalars['Boolean']>;
  family: GBinFamily;
  fullPalletPosition?: Maybe<Scalars['Boolean']>;
  level?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  netsuiteInternalId: Scalars['String'];
  section?: Maybe<Scalars['Int']>;
  /** From the temperature_name column, never parsed from the name. */
  temperature?: Maybe<Scalars['String']>;
};

/** Error indicating a provided cart input value was invalid. */
export type GInvalidCartInputError = GError & {
  __typename?: 'InvalidCartInputError';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating invalid config attributes */
export type GInvalidConfigError = {
  __typename?: 'InvalidConfigError';
  /** The specific errors */
  errors: Array<GUserError>;
};

export type GInvalidDeliveredQuantity = GUserErrorInterface & {
  __typename?: 'InvalidDeliveredQuantity';
  /** The delivered_quantity value the client tried to write. */
  attempted: Scalars['Int'];
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** The order line whose delivered_quantity write was rejected. */
  orderLineId: Scalars['ID'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GInvalidFleetComposition = GUserErrorInterface & {
  __typename?: 'InvalidFleetComposition';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GInvalidFulfillmentQuantity = GUserErrorInterface & {
  __typename?: 'InvalidFulfillmentQuantity';
  /** The fulfillment_quantity value the client tried to write. */
  attempted: Scalars['Int'];
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** The order line whose fulfillment_quantity write was rejected. */
  orderLineId: Scalars['ID'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GInvalidHeaderReasonCode = GUserErrorInterface & {
  __typename?: 'InvalidHeaderReasonCode';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GInvalidNightEnd = GUserErrorInterface & {
  __typename?: 'InvalidNightEnd';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GInvalidParameterOverrides = GUserErrorInterface & {
  __typename?: 'InvalidParameterOverrides';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GInvalidRules = GUserErrorInterface & {
  __typename?: 'InvalidRules';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GInvalidShift = GUserErrorInterface & {
  __typename?: 'InvalidShift';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GInvalidStopTypeForHeaderReason = GUserErrorInterface & {
  __typename?: 'InvalidStopTypeForHeaderReason';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GInvalidSubReasonForReasonCode = GUserErrorInterface & {
  __typename?: 'InvalidSubReasonForReasonCode';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export enum GInventoryCheckBehavior {
  Check = 'CHECK',
  Skip = 'SKIP'
}

/** PROTOTYPE describes a skus inventory information. */
export type GInventoryInfo = {
  __typename?: 'InventoryInfo';
  /**
   * PROTOTYPE If blank, the par value is counted in Odeko sales units. If present,
   * the par value is counted in this counting unit.
   */
  countingUnit?: Maybe<GLocationCountingUnit>;
  /** PROTOTYPE ideal stock level, in counting units or sales units, for the Cafe location after ordering. */
  parValue: Scalars['Float'];
  /** PROTOTYPE where the sku's stock is stored in the Cafe location. */
  storageArea?: Maybe<GLocationStorageArea>;
};

/** Extension of InventoryItem type to include associated ERP Reference fields */
export type GInventoryItem = GSupplyItem & {
  __typename?: 'InventoryItem';
  /**
   * The item's scannable barcodes from RF-SMART, each carrying the pack level it identifies.
   * A barcode with no unit is still scannable but cannot name a quantity unit.
   */
  barcodes: Array<GItemBarcode>;
  brand?: Maybe<GItemBrand>;
  /** @deprecated Use brand */
  brandName: Scalars['String'];
  /** (Package Height x Package Width x Package Length)/DIM factor */
  caseDimensionalWeightLbs?: Maybe<Scalars['Float']>;
  caseHeightInches?: Maybe<Scalars['Float']>;
  caseLengthInches?: Maybe<Scalars['Float']>;
  caseVolumeCuInches?: Maybe<Scalars['Float']>;
  caseWeightLbs?: Maybe<Scalars['Float']>;
  caseWidthInches?: Maybe<Scalars['Float']>;
  casesPerLayer?: Maybe<Scalars['Int']>;
  casesPerPallet?: Maybe<Scalars['Int']>;
  catalogStatus: GCatalogStatus;
  category: GCategory;
  createdAt: Scalars['ISO8601DateTime'];
  createdBy: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  /**
   * Drives pricing with carriers like FedEx.
   * This data is uploaded from Cubiscan dimensioning device to optimize shipping costs.
   */
  dimensionalFactor?: Maybe<Scalars['Float']>;
  dimensioned?: Maybe<Scalars['Boolean']>;
  /** (Package Height x Package Width x Package Length)/DIM factor */
  eachDimensionalWeightLbs?: Maybe<Scalars['Float']>;
  eachHeightInches?: Maybe<Scalars['Float']>;
  eachLengthInches?: Maybe<Scalars['Float']>;
  eachVolumeCuInches?: Maybe<Scalars['Float']>;
  eachWeightLbs?: Maybe<Scalars['Float']>;
  eachWidthInches?: Maybe<Scalars['Float']>;
  erpPlatform?: Maybe<GErpPlatform>;
  erpRecordId?: Maybe<Scalars['ID']>;
  erpRecordType?: Maybe<GErpRecord>;
  erpRecordUrl?: Maybe<Scalars['String']>;
  /** Denotes if the item should be included in the picking labels or not. */
  excludedFromPickingLabels: Scalars['Boolean'];
  /** True if the item has its own image. When false and imgUrl is present, the image is a fallback from the category icon. */
  hasOwnImage: Scalars['Boolean'];
  id: Scalars['ID'];
  imgUrl?: Maybe<Scalars['String']>;
  inactivatedOn?: Maybe<Scalars['ISO8601DateTime']>;
  /**
   * The product-level out-of-stock-check setting. Read `inventoryCheckBehavior` on the warehouse
   * association instead, at all times: this value is not market-scoped, so once any market is
   * given a setting of its own it stops answering for that market.
   */
  inventoryCheckBehavior?: Maybe<GInventoryCheckBehavior>;
  isSerialized: Scalars['Boolean'];
  /**
   * True when a shipping location can't order this item: it is refrigerated or frozen, or its
   * category or subcategory is Pastry or Baked Goods.
   */
  isShippingRestricted: Scalars['Boolean'];
  itemLocationsCustomPrice?: Maybe<Array<GItemLocationCustomPrice>>;
  /** @deprecated Use size */
  itemSize?: Maybe<Scalars['String']>;
  layersPerPallet?: Maybe<Scalars['Int']>;
  locationShelfLifeDays?: Maybe<Scalars['Int']>;
  manufacturedType?: Maybe<GManufacturedType>;
  /** Whether this item uses market pricing (price set at fulfillment time) */
  marketPrice: Scalars['Boolean'];
  /**
   * The most units, in the sale unit, that one location may order of this item across all its orders.
   * Null means no limit.
   */
  maxQuantityPerLocation?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  nmfc?: Maybe<Scalars['String']>;
  palletWeightLbs?: Maybe<Scalars['Float']>;
  perishability?: Maybe<GPerishability>;
  /**
   * True when this item is currently a leading New Items pin — i.e. it won its slot in the resolved
   * result set. Reflects what shoppers see: an item filtered out of the result reads as not pinned.
   * Flag-gated; false when the new-item-pinning flag is off or the item isn't pinned.
   */
  pinned: Scalars['Boolean'];
  /** The absolute carousel slot this item actually rendered at when pinned; null when not pinned. */
  pinnedPosition?: Maybe<Scalars['Int']>;
  procurementRecords: Array<GProcurement>;
  /**
   * Drives the storefront's "Sponsored" label. True for Algolia rule-promoted results and — behind the
   * new-item-pinning flag — for a sponsored New Items pin. A sponsored pin is distinguishable from an
   * Algolia promo by `pinned` (a sponsored pin is `promoted && pinned`).
   */
  promoted: Scalars['Boolean'];
  purchasePrice: GMoney;
  purchaseUnit: GUnit;
  refrigerationState?: Maybe<GRefrigerationState>;
  saleUnit: GUnit;
  /** The most of this item's sample one location may ever order. Null means no limit, or no sample. */
  sampleMaxQuantityPerLocation?: Maybe<Scalars['Int']>;
  sampleUnit?: Maybe<GUnit>;
  sampleUpcCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  shelfLifeDays?: Maybe<Scalars['Int']>;
  size?: Maybe<GItemSize>;
  /**
   * The product-level standing-order setting. Read `standingOrderBehavior` on the warehouse
   * association instead, at all times: this value is not market-scoped, so once any market is
   * given a setting of its own it stops answering for that market.
   */
  standingOrderBehavior: GStandingOrderBehavior;
  stockUnit?: Maybe<GUnit>;
  subcategory?: Maybe<GCategory>;
  /**
   * The item's curated substitution overrides (source-side), highest priority first. Procurement's
   * editable layer that ranks above the rule engine's dynamic recommendations.
   */
  substitutionOverrides: Array<GSubstitutionOverride>;
  /**
   * Procurement preview of ranked substitutes for this item. With no `warehouseId`, ranks by
   * attribute/dietary match quality only (availability ignored) — the "are these good substitutes?"
   * view. With a `warehouseId`, returns the in-stock list a customer in that market would actually get.
   * Curated overrides rank first. Procurement surface — the customer path uses `InventoryWarehouseAssociation.substitutionCandidates`.
   */
  substitutionPreview: Array<GSupplyItem>;
  tags: Array<GItemTag>;
  transitMethod?: Maybe<GTransitMethod>;
  upcCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  updatedAt: Scalars['ISO8601DateTime'];
  updatedBy: Scalars['String'];
  vendorCode?: Maybe<Scalars['String']>;
  warehouseAssociation?: Maybe<Array<Maybe<GInventoryWarehouseAssociation>>>;
};


/** Extension of InventoryItem type to include associated ERP Reference fields */
export type GInventoryItemSubstitutionPreviewArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  warehouseId?: InputMaybe<Scalars['ID']>;
};


/** Extension of InventoryItem type to include associated ERP Reference fields */
export type GInventoryItemTagsArgs = {
  withDiscardedAt?: InputMaybe<Scalars['Boolean']>;
};


/** Extension of InventoryItem type to include associated ERP Reference fields */
export type GInventoryItemWarehouseAssociationArgs = {
  filters?: InputMaybe<GInventoryWarehouseAssociationFiltersInput>;
  warehouseIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type GInventoryItemInput = {
  brand?: InputMaybe<Scalars['ID']>;
  brandName: Scalars['String'];
  caseHeightInches?: InputMaybe<Scalars['Float']>;
  caseLengthInches?: InputMaybe<Scalars['Float']>;
  caseWeightLbs?: InputMaybe<Scalars['Float']>;
  caseWidthInches?: InputMaybe<Scalars['Float']>;
  casesPerLayer?: InputMaybe<Scalars['Int']>;
  catalogStatus: GCatalogStatus;
  category: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
  dimensionalFactor?: InputMaybe<Scalars['Float']>;
  dimensioned?: InputMaybe<Scalars['Boolean']>;
  eachHeightInches?: InputMaybe<Scalars['Float']>;
  eachLengthInches?: InputMaybe<Scalars['Float']>;
  eachWeightLbs?: InputMaybe<Scalars['Float']>;
  eachWidthInches?: InputMaybe<Scalars['Float']>;
  imgUrl?: InputMaybe<Scalars['String']>;
  inventoryCheckBehavior?: InputMaybe<GInventoryCheckBehavior>;
  isSerialized?: InputMaybe<Scalars['Boolean']>;
  itemSize?: InputMaybe<Scalars['String']>;
  layersPerPallet?: InputMaybe<Scalars['Int']>;
  locationShelfLifeDays?: InputMaybe<Scalars['Int']>;
  marketPrice?: InputMaybe<Scalars['Boolean']>;
  /**
   * The most units, in the sale unit, that one location may order of this item across all its orders.
   * Omit to keep the current value; null removes the limit. At least 1.
   */
  maxQuantityPerLocation?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  nmfc?: InputMaybe<Scalars['String']>;
  palletWeightLbs?: InputMaybe<Scalars['Float']>;
  perishability?: InputMaybe<GPerishability>;
  procurementRecords?: InputMaybe<Array<GProcurementInput>>;
  purchasePrice: GMoneyInput;
  purchaseUnit: Scalars['ID'];
  refrigerationState?: InputMaybe<GRefrigerationState>;
  saleUnit: Scalars['ID'];
  /**
   * The most of this item's sample one location may ever order. Omit to keep the current value; null
   * removes the limit. At least 1, and only with a sampleUnit.
   */
  sampleMaxQuantityPerLocation?: InputMaybe<Scalars['Int']>;
  sampleUnit?: InputMaybe<Scalars['ID']>;
  sampleUpcCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  shelfLifeDays?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<GSizeInput>;
  standingOrderBehavior: GStandingOrderBehavior;
  stockUnit?: InputMaybe<Scalars['ID']>;
  subcategory?: InputMaybe<Scalars['ID']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  transitMethod?: InputMaybe<GTransitMethod>;
  upcCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  vendorCode?: InputMaybe<Scalars['String']>;
  warehouseAssociation?: InputMaybe<Array<InputMaybe<GInventoryWarehouseAssociationInput>>>;
};

/** PROTOTYPE Inventory Service 2's notion of a 'Location Item'. NOTE: unrelated to IMS location items. */
export type GInventoryLocationItem = {
  __typename?: 'InventoryLocationItem';
  /**
   * PROTOTYPE If blank, the par value is counted in Odeko sales units. If present,
   * the par value is counted in this counting unit.
   */
  countingUnit?: Maybe<GLocationCountingUnit>;
  /** PROTOTYPE id of this object in inventory-service-2. */
  id: Scalars['ID'];
  /** PROTOTYPE id of the item in inventory-service-2. */
  itemId: Scalars['ID'];
  /** PROTOTYPE Odeko UUID of the associated location. */
  locationId: Scalars['ID'];
  /** PROTOTYPE if the item is an Odeko Item, its IMS Item Id. */
  odekoItemId?: Maybe<Scalars['ID']>;
  /** PROTOTYPE ideal stock level, in counting units or sales units, for the Cafe location after ordering. */
  parValue: Scalars['Float'];
  /** PROTOTYPE if an Odeko Item, it's sku id from so-api. */
  skuId?: Maybe<Scalars['ID']>;
  /** PROTOTYPE where the sku's stock is stored in the Cafe location. */
  storageArea?: Maybe<GLocationStorageArea>;
};

/**
 * Inventory items are items we procure from some vendor and ship from our warehouse.
 * They are *stored* in the warehouse.
 */
export type GInventoryWarehouseAssociation = {
  __typename?: 'InventoryWarehouseAssociation';
  configuredFulfillmentWarehouses: Array<GConfigureFulfillmentWarehouse>;
  /**
   * Wording authored for this product in this market, or null when nothing was authored and the
   * message is derived from `orderability`. Exposed so an editor can show and change what was written;
   * clients rendering a catalog want `orderabilityMessage` instead.
   */
  customOrderabilityMessage?: Maybe<Scalars['String']>;
  /** True when the item has been continuously out of stock for 14+ days at this warehouse. */
  customerFacingOutOfStock: Scalars['Boolean'];
  /**
   * Days the item has left in the 60-day "new" window at this warehouse; null once it has aged out.
   * Mirrors `isNew` (both derive from the item's activation date).
   */
  daysRemainingAsNew?: Maybe<Scalars['Int']>;
  fulfillmentWarehouses: Array<GFulfillmentWarehouse>;
  hasSample?: Maybe<Scalars['Boolean']>;
  /**
   * Whether the out-of-stock check runs for this product in this market, or is skipped. A market that
   * has not been given a value of its own carries the item-level field of the same name. Inventory
   * items only — a non-inventory product has no stock to check.
   */
  inventoryCheckBehavior: GInventoryCheckBehavior;
  isNew: Scalars['Boolean'];
  item: GInventoryItem;
  landedCost?: Maybe<GMoney>;
  /**
   * Next available delivery date for this item from the location's own (home)
   * warehouse. Returns null when the association is for any other warehouse — e.g.
   * an item fulfilled from a different warehouse under global fulfillment — or
   * when the location is disabled.
   */
  nextDeliveryDate?: Maybe<Scalars['ISO8601Date']>;
  /**
   * Whether this product is ready to sell in this market. A product that is not orderable still appears
   * in the catalog — it simply cannot be added to an order.
   */
  orderability: GOrderability;
  /**
   * Wording to show in place of add-to-cart, or null when the product can be ordered. Taken from
   * `customOrderabilityMessage` when one is authored, and otherwise derived from `orderability`, so
   * both ordering apps say the same thing and changing it needs no client release.
   */
  orderabilityMessage?: Maybe<Scalars['String']>;
  /**
   * When the item first went out of stock at this warehouse.
   * Null if currently in stock or if OOS check is bypassed.
   */
  outOfStockSince?: Maybe<Scalars['ISO8601DateTime']>;
  procurementVendor?: Maybe<GProcurementVendor>;
  salePrice?: Maybe<GMoney>;
  sample?: Maybe<GSupplyItem>;
  /**
   * Whether this product can be ordered on a standing order in this market. A market that has not been
   * given a value of its own carries the item-level field of the same name.
   */
  standingOrderBehavior: GStandingOrderBehavior;
  /**
   * Ranked substitute items for this item when it is out of stock at this warehouse, computed by the
   * IMS rule engine from catalog attributes, dietary tags, curated overrides, and the local
   * availability snapshot. The warehouse is this association's warehouse, so no argument is needed.
   * Ships dark behind a per-warehouse flag — returns an empty list when the engine is disabled here.
   *
   * Pass `requestedQuantity` — the quantity the customer is ordering — to return only substitutes the
   * warehouse holds enough of to cover the whole order line. Availability alone only means at least
   * one unit exists, which is not the same as being able to fill the order. Omit it and no quantity
   * rule is applied.
   */
  substitutionCandidates: Array<GSupplyItem>;
  warehouse: GWarehouse;
};


/**
 * Inventory items are items we procure from some vendor and ship from our warehouse.
 * They are *stored* in the warehouse.
 */
export type GInventoryWarehouseAssociationFulfillmentWarehousesArgs = {
  locationUuid?: InputMaybe<Scalars['ID']>;
};


/**
 * Inventory items are items we procure from some vendor and ship from our warehouse.
 * They are *stored* in the warehouse.
 */
export type GInventoryWarehouseAssociationNextDeliveryDateArgs = {
  locationId: Scalars['ID'];
};


/**
 * Inventory items are items we procure from some vendor and ship from our warehouse.
 * They are *stored* in the warehouse.
 */
export type GInventoryWarehouseAssociationSalePriceArgs = {
  locationMembershipStatusTier?: InputMaybe<GPsLocationMembershipStatusTier>;
  locationMembershipTier?: InputMaybe<GLocationMembershipTier>;
};


/**
 * Inventory items are items we procure from some vendor and ship from our warehouse.
 * They are *stored* in the warehouse.
 */
export type GInventoryWarehouseAssociationSubstitutionCandidatesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  requestedQuantity?: InputMaybe<Scalars['Int']>;
};

export type GInventoryWarehouseAssociationFiltersInput = {
  procurementVendorId?: InputMaybe<GFiltersStringInput>;
  warehouseId?: InputMaybe<GFiltersStringInput>;
};

export type GInventoryWarehouseAssociationInput = {
  configuredFulfillmentWarehouses?: InputMaybe<Array<GConfigureFulfillmentWarehouseInput>>;
  /** Wording to show instead of what `orderability` implies. Omit to leave unchanged; null to clear. */
  customOrderabilityMessage?: InputMaybe<Scalars['String']>;
  hasSample?: InputMaybe<Scalars['Boolean']>;
  /** Omit to leave unchanged. A market the product was not in before starts off, except on a product being created, where it takes the item-level field of the same name. */
  inventoryCheckBehavior?: InputMaybe<GInventoryCheckBehavior>;
  /** Defaults to ORDERABLE when omitted; omit to leave an existing value unchanged. */
  orderability?: InputMaybe<GOrderability>;
  procurementVendorId?: InputMaybe<Scalars['ID']>;
  salePrice?: InputMaybe<GMoneyInput>;
  /** Omit to leave unchanged. A market the product was not in before starts off, except on a product being created, where it takes the item-level field of the same name. */
  standingOrderBehavior?: InputMaybe<GStandingOrderBehavior>;
  warehouseId: Scalars['ID'];
};

export type GInvoiceMatchCandidate = {
  __typename?: 'InvoiceMatchCandidate';
  item: GSupplyItem;
};

export type GInvoiceMatchCandidatesInput = {
  identifiers?: InputMaybe<Array<GInvoiceMatchIdentifierInput>>;
  limit?: InputMaybe<Scalars['Int']>;
  searchQuery: Scalars['String'];
  warehouseId: Scalars['ID'];
};

export type GInvoiceMatchCandidatesResult = {
  __typename?: 'InvoiceMatchCandidatesResult';
  candidates: Array<GInvoiceMatchCandidate>;
};

export type GInvoiceMatchIdentifierInput = {
  type?: InputMaybe<GInvoiceMatchIdentifierType>;
  value: Scalars['String'];
};

export enum GInvoiceMatchIdentifierType {
  Sku = 'SKU',
  Unknown = 'UNKNOWN',
  Upc = 'UPC'
}

export type GIsPastWarehouseCutOffTimeInput = {
  dateTime: Scalars['ISO8601DateTime'];
  warehouseId: Scalars['ID'];
};

export type GIsRoutesSyncEnabledInput = {
  nightEnd: Scalars['ISO8601Date'];
  warehouseId: Scalars['ID'];
};

export type GIssue = {
  __typename?: 'Issue';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type GItemBarcode = {
  __typename?: 'ItemBarcode';
  code: Scalars['String'];
  packLevel: GItemBarcodePackLevel;
  unit?: Maybe<GUnit>;
};

export type GItemBarcodeMatch = {
  __typename?: 'ItemBarcodeMatch';
  barcode: GItemBarcode;
  item: GInventoryItem;
};

export enum GItemBarcodePackLevel {
  Case = 'CASE',
  Each = 'EACH',
  Pallet = 'PALLET',
  Unknown = 'UNKNOWN'
}

export type GItemBrand = {
  __typename?: 'ItemBrand';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type GItemBrandConnection = {
  __typename?: 'ItemBrandConnection';
  edges: Array<Maybe<GItemBrandEdge>>;
  nodes: Array<Maybe<GItemBrand>>;
  pageInfo: GPageInfo;
};

export type GItemBrandCreateInput = {
  name: Scalars['String'];
};

export type GItemBrandCreatePayload = {
  __typename?: 'ItemBrandCreatePayload';
  created: Scalars['Boolean'];
  errors: Array<GItemBrandError>;
  itemBrand?: Maybe<GItemBrand>;
};

export type GItemBrandDeleteInput = {
  id: Scalars['ID'];
};

export type GItemBrandDeletePayload = {
  __typename?: 'ItemBrandDeletePayload';
  errors: Array<GItemBrandError>;
};

export type GItemBrandEdge = {
  __typename?: 'ItemBrandEdge';
  cursor: Scalars['String'];
  node: GItemBrand;
};

export type GItemBrandError = {
  __typename?: 'ItemBrandError';
  message: Scalars['String'];
};

export type GItemBrandUpdateInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type GItemBrandUpdatePayload = {
  __typename?: 'ItemBrandUpdatePayload';
  errors: Array<GItemBrandError>;
  itemBrand?: Maybe<GItemBrand>;
};

export type GItemBrandsFiltersInput = {
  id?: InputMaybe<GFiltersStringInput>;
  name?: InputMaybe<GFiltersStringInput>;
};

export enum GItemBrandsSortOrder {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

/** Relay-style cursor-based pagination structure for Categories */
export type GItemConnection = {
  __typename?: 'ItemConnection';
  edges: Array<Maybe<GItemEdge>>;
  nodes: Array<Maybe<GSupplyItem>>;
  pageInfo: GPageInfo;
  /**
   * Algolia query identifier for tracking search analytics.
   * Required for sending click and conversion events to Algolia Insights.
   * Null for non-Algolia searches.
   */
  queryID?: Maybe<Scalars['String']>;
  totalCount: Scalars['Int'];
};

export type GItemDeliveryInstructions = {
  __typename?: 'ItemDeliveryInstructions';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  imageKeys?: Maybe<Array<Scalars['String']>>;
  imageUrls?: Maybe<Array<Scalars['String']>>;
  location: GLocation;
  note?: Maybe<Scalars['String']>;
  /** Opaque ID for translating this instruction */
  translationId: Scalars['ID'];
  type?: Maybe<GItemDeliveryInstructionsType>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export enum GItemDeliveryInstructionsType {
  NonRefrigerated = 'non_refrigerated',
  Refrigerated = 'refrigerated'
}

export type GItemEdge = {
  __typename?: 'ItemEdge';
  cursor: Scalars['String'];
  node: GSupplyItem;
};

export type GItemLocationCustomPrice = {
  __typename?: 'ItemLocationCustomPrice';
  customPrice: GMoney;
  itemId: Scalars['ID'];
  location: GLocation;
  priceRuleId?: Maybe<Scalars['ID']>;
};

export type GItemPricesResult = GErrorsResult | GItemPricesSuccess;

export type GItemPricesSuccess = {
  __typename?: 'ItemPricesSuccess';
  itemLocationCustomPrices: Array<GItemLocationCustomPrice>;
  updatedItemsCount: Scalars['Int'];
  updatedLocationsCount: Scalars['Int'];
  updatedLocationsItemsCount: Scalars['Int'];
  updatedWarehouseCount: Scalars['Int'];
  updatedWarehouseItemsCount: Scalars['Int'];
};

export type GItemRecommendationConnection = {
  __typename?: 'ItemRecommendationConnection';
  edges: Array<Maybe<GItemEdge>>;
  nodes: Array<Maybe<GSupplyItem>>;
  pageInfo: GPageInfo;
};

export type GItemRecommendationFiltersInput = {
  categoryId?: InputMaybe<GFiltersStringInput>;
  /** When true, restricts to items a shipping location can order, as ItemsFiltersInput.isShipping does. */
  isShipping?: InputMaybe<Scalars['Boolean']>;
  parentCategoryId?: InputMaybe<GFiltersStringInput>;
  refrigerationState?: InputMaybe<GFiltersRefrigerationStateInput>;
  saleUnitWeightLbs?: InputMaybe<GFiltersFloatInput>;
};

export enum GItemRecommendationType {
  Complementary = 'COMPLEMENTARY',
  FrequentlyBoughtTogether = 'FREQUENTLY_BOUGHT_TOGETHER',
  TrendingItems = 'TRENDING_ITEMS'
}

/** Measure of a unit of the item, e.g. 12 oz, 0.5 gallon. Can be in weight, volume, or if none of those, then just "each" */
export type GItemSize = {
  __typename?: 'ItemSize';
  /** string format of the quantity + unit -- 12 ounce */
  label: Scalars['String'];
  /** 0.5 or 12 in the example */
  quantity: Scalars['Float'];
  /** gallon or ounce in the example */
  unit: GUnit;
};

/** Item lifecycle status used to filter items by their inactive state. */
export enum GItemStatusFilter {
  Active = 'ACTIVE',
  All = 'ALL',
  Inactive = 'INACTIVE'
}

export type GItemTag = {
  __typename?: 'ItemTag';
  badgeUrl?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  createdBy: Scalars['String'];
  discardedAt?: Maybe<Scalars['ISO8601DateTime']>;
  displayAs: Scalars['String'];
  id: Scalars['ID'];
  itemCount: Scalars['Int'];
  name: Scalars['String'];
  parentTag?: Maybe<GItemTag>;
  pivot?: Maybe<Array<GItemTagPivot>>;
  position: Scalars['Int'];
  slug: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
  updatedBy: Scalars['String'];
  visibleInCatalog: Scalars['Boolean'];
};

export type GItemTagConnection = {
  __typename?: 'ItemTagConnection';
  edges: Array<Maybe<GItemTagEdge>>;
  nodes: Array<Maybe<GItemTag>>;
  pageInfo: GPageInfo;
};

export enum GItemTagDisplayAs {
  Badge = 'BADGE',
  Text = 'TEXT'
}

export type GItemTagEdge = {
  __typename?: 'ItemTagEdge';
  cursor: Scalars['String'];
  node: GItemTag;
};

export type GItemTagFiltersInput = {
  createdAt?: InputMaybe<GFiltersDateInput>;
  createdBy?: InputMaybe<GFiltersStringInput>;
  discardedAt?: InputMaybe<GFiltersDateInput>;
  displayAs?: InputMaybe<GFiltersItemTagDisplayAsInput>;
  id?: InputMaybe<GFiltersStringInput>;
  name?: InputMaybe<GFiltersStringInput>;
  parentTagId?: InputMaybe<GFiltersStringInput>;
  parentTagName?: InputMaybe<GFiltersStringInput>;
  slug?: InputMaybe<GFiltersStringInput>;
  updatedAt?: InputMaybe<GFiltersDateInput>;
  updatedBy?: InputMaybe<GFiltersStringInput>;
  visibleInCatalog?: InputMaybe<GFiltersBooleanInput>;
};

export type GItemTagInput = {
  badgeUrl?: InputMaybe<Scalars['String']>;
  discardedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  name: Scalars['String'];
  parentTag?: InputMaybe<Scalars['ID']>;
  position: Scalars['Int'];
  slug?: InputMaybe<Scalars['String']>;
  visibleInCatalog: Scalars['Boolean'];
};

export type GItemTagPivot = {
  __typename?: 'ItemTagPivot';
  createdAt: Scalars['ISO8601DateTime'];
  discardedAt?: Maybe<Scalars['ISO8601DateTime']>;
  itemId: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export enum GItemTagSortOrder {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DisplayAsAsc = 'DISPLAY_AS_ASC',
  DisplayAsDesc = 'DISPLAY_AS_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  PositionAsc = 'POSITION_ASC',
  PositionDesc = 'POSITION_DESC',
  PositionTreeAsc = 'POSITION_TREE_ASC',
  PositionTreeDesc = 'POSITION_TREE_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum GItemType {
  Inventory = 'INVENTORY',
  NonInventory = 'NON_INVENTORY'
}

export type GItemsCategoryInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type GItemsFiltersInput = {
  brandName?: InputMaybe<GFiltersStringInput>;
  caseHeightInches?: InputMaybe<GFiltersFloatInput>;
  caseLengthInches?: InputMaybe<GFiltersFloatInput>;
  caseWeightLbs?: InputMaybe<GFiltersFloatInput>;
  caseWidthInches?: InputMaybe<GFiltersFloatInput>;
  catalogStatus?: InputMaybe<GFiltersCatalogStatusInput>;
  categoryId?: InputMaybe<GFiltersStringInput>;
  createdAt?: InputMaybe<GFiltersDateInput>;
  createdBy?: InputMaybe<GFiltersStringInput>;
  /**
   * When true, excludes items that have been out of stock for 14+ days at a fulfillment warehouse.
   * When false or omitted, all items are returned.
   */
  customerFacingOutOfStock?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<GFiltersStringInput>;
  dimensionalFactor?: InputMaybe<GFiltersFloatInput>;
  discontinuedOn?: InputMaybe<GFiltersDateInput>;
  eachHeightInches?: InputMaybe<GFiltersFloatInput>;
  eachLengthInches?: InputMaybe<GFiltersFloatInput>;
  eachWeightLbs?: InputMaybe<GFiltersFloatInput>;
  eachWidthInches?: InputMaybe<GFiltersFloatInput>;
  fulfillmentWarehouseIds?: InputMaybe<GFiltersArrayInput>;
  /** Whether the item has missing content (no description or no custom image). */
  hasMissingContent?: InputMaybe<GFiltersBooleanInput>;
  id?: InputMaybe<GFiltersStringInput>;
  imgUrl?: InputMaybe<GFiltersStringInput>;
  inventoryCheckBehavior?: InputMaybe<GFiltersInventoryCheckBehaviorInput>;
  /**
   * The item was activated within the last 90-days or otherwise age specified by
   * Item Management's WA_IS_NEW_WITHIN_DAYS.
   */
  isNew?: InputMaybe<GFiltersBooleanInput>;
  /**
   * When true, restricts to items a shipping location can order: a positive ship weight, not
   * refrigerated or frozen, and not in the Pastry or Baked Goods category or subcategory.
   */
  isShipping?: InputMaybe<Scalars['Boolean']>;
  itemSize?: InputMaybe<GFiltersStringInput>;
  itemSizeQuantity?: InputMaybe<GFiltersFloatInput>;
  itemSizeUnitId?: InputMaybe<GFiltersStringInput>;
  /** Filter by item lifecycle status: ACTIVE = active only, INACTIVE = inactive only, ALL = both. Omitted = both (no filter). */
  itemStatus?: InputMaybe<GItemStatusFilter>;
  locationShelfLifeDays?: InputMaybe<GFiltersIntInput>;
  minItemsPerOrder?: InputMaybe<GFiltersIntInput>;
  name?: InputMaybe<GFiltersStringInput>;
  /**
   * Filters items that have been out of stock across all fulfillment warehouses
   * for at least the specified number of days. Items with an OOS bypass reason
   * are not considered out of stock.
   * Use with GREATER_THAN_EQUAL to exclude items OOS for N+ days.
   */
  outOfStockForDays?: InputMaybe<GFiltersIntInput>;
  perishability?: InputMaybe<GFiltersPerishabilityInput>;
  procurementVendorId?: InputMaybe<GFiltersStringInput>;
  purchaseMultiple?: InputMaybe<GFiltersFloatInput>;
  purchasePrice?: InputMaybe<GFiltersMoneyInput>;
  purchaseUnitId?: InputMaybe<GFiltersStringInput>;
  refrigerationState?: InputMaybe<GFiltersRefrigerationStateInput>;
  saleUnitId?: InputMaybe<GFiltersStringInput>;
  saleUnitWeightLbs?: InputMaybe<GFiltersFloatInput>;
  shelfLifeDays?: InputMaybe<GFiltersIntInput>;
  standingOrderBehavior?: InputMaybe<GFiltersStandingOrderBehaviorInput>;
  stockUnitId?: InputMaybe<GFiltersStringInput>;
  subcategoryId?: InputMaybe<GFiltersStringInput>;
  tagId?: InputMaybe<GFiltersStringInput>;
  transitMethod?: InputMaybe<GFiltersTransitMethodInput>;
  type?: InputMaybe<GFiltersItemTypeInput>;
  upcCodes?: InputMaybe<GFiltersStringInput>;
  updatedAt?: InputMaybe<GFiltersDateInput>;
  updatedBy?: InputMaybe<GFiltersStringInput>;
  vendorCode?: InputMaybe<GFiltersStringInput>;
  vendorId?: InputMaybe<GFiltersStringInput>;
  warehouseId?: InputMaybe<GFiltersStringInput>;
};

export enum GItemsSortOrder {
  /**
   * Requires a filter that joins the warehouse association (e.g. isNew or warehouseId), which is
   * where the activation date lives; ordering by it without one errors.
   */
  ActivationDateAsc = 'ACTIVATION_DATE_ASC',
  /**
   * Requires a filter that joins the warehouse association (e.g. isNew or warehouseId), which is
   * where the activation date lives; ordering by it without one errors.
   */
  ActivationDateDesc = 'ACTIVATION_DATE_DESC',
  BrandAsc = 'BRAND_ASC',
  BrandDesc = 'BRAND_DESC',
  CategoryAsc = 'CATEGORY_ASC',
  CategoryDesc = 'CATEGORY_DESC',
  CategoryPositionAsc = 'CATEGORY_POSITION_ASC',
  CategoryPositionDesc = 'CATEGORY_POSITION_DESC',
  /** Requires a collection filter. */
  CollectionPositionAsc = 'COLLECTION_POSITION_ASC',
  /** Requires a collection filter. */
  CollectionPositionDesc = 'COLLECTION_POSITION_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  SubcategoryAsc = 'SUBCATEGORY_ASC',
  SubcategoryDesc = 'SUBCATEGORY_DESC',
  SubcategoryPositionAsc = 'SUBCATEGORY_POSITION_ASC',
  SubcategoryPositionDesc = 'SUBCATEGORY_POSITION_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type GItemsSubcategoryInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type GItemsVendorInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type GItemsWarehouseInput = {
  id?: InputMaybe<Scalars['ID']>;
};

/** JWT session. */
export type GJwtSession = {
  __typename?: 'JwtSession';
  /** Access token. */
  access: Scalars['String'];
  /** Access token expiration. */
  accessExpiresAt: Scalars['String'];
  /** CSRF token. */
  csrf: Scalars['String'];
  /** Refresh token. */
  refresh: Scalars['String'];
  /** Refresh token expiration. */
  refreshExpiresAt: Scalars['String'];
};

/** How a source-backed group's bins are arranged within the placement. */
export enum GLayoutArrangement {
  OddEven = 'ODD_EVEN',
  Sequential = 'SEQUENTIAL'
}

/** Direction a source-backed group's bays are numbered within the placement. */
export enum GLayoutBayOrder {
  HighLow = 'HIGH_LOW',
  LowHigh = 'LOW_HIGH'
}

/** Whether a placement is a source-backed bin group or a free-floating facility shape. */
export enum GLayoutPlacementKind {
  /** A free-floating shape (wall/dock/room/zone/arrow/label) with no source behind it. */
  Facility = 'FACILITY',
  /** A bin group placed by its interpretation key (family + groupKey). */
  SourceGroup = 'SOURCE_GROUP'
}

/** Machine-readable reason a layout save was rejected. */
export enum GLayoutSaveErrorCode {
  /** The submitted revision no longer matches the stored draft; reload and retry. */
  StaleRevision = 'STALE_REVISION'
}

/** A leaderboard for tracking scores in a game */
export type GLeaderboard = {
  __typename?: 'Leaderboard';
  /** Whether the leaderboard is active */
  active: Scalars['Boolean'];
  /** When the leaderboard was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** Total number of entries in this leaderboard */
  entryCount: Scalars['Int'];
  /** The game this leaderboard belongs to */
  game: GGame;
  /** Unique identifier for the leaderboard */
  id: Scalars['ID'];
  /** All entries in this leaderboard */
  leaderboardEntries: Array<GLeaderboardEntry>;
  /** Type of leaderboard */
  leaderboardType: GLeaderboardTypeEnum;
  /** Additional leaderboard metadata */
  metadata: Scalars['JSON'];
  /** The microsite location this leaderboard belongs to */
  micrositeLocation: GMicrositeLocation;
  /** Name of the leaderboard */
  name: Scalars['String'];
  /** When the leaderboard resets */
  resetSchedule?: Maybe<Scalars['String']>;
  /** How scores are aggregated */
  scoreOperator: GScoreOperatorEnum;
  /** URL-friendly identifier */
  slug: Scalars['String'];
  /** How scores are sorted */
  sortOrder: GSortOrderEnum;
  /** Top entries in this leaderboard */
  topEntries: Array<GLeaderboardEntry>;
  /** When the leaderboard was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};


/** A leaderboard for tracking scores in a game */
export type GLeaderboardTopEntriesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

/** An entry in a leaderboard */
export type GLeaderboardEntry = {
  __typename?: 'LeaderboardEntry';
  /** When the score was achieved */
  achievedAt: Scalars['ISO8601DateTime'];
  /** When the entry was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** Unique identifier for the entry */
  id: Scalars['ID'];
  /** Whether this is the player's best score */
  isBestForPlayer: Scalars['Boolean'];
  /** The leaderboard this entry belongs to */
  leaderboard: GLeaderboard;
  /** Additional entry metadata */
  metadata: Scalars['JSON'];
  /** Current rank in the leaderboard */
  rank?: Maybe<Scalars['Int']>;
  /** The player's score */
  score: Scalars['Int'];
  /** Secondary score for tiebreaking */
  subscore?: Maybe<Scalars['Int']>;
  /** When the entry was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
  /** Display name for the player */
  username: Scalars['String'];
};

/** Type of leaderboard */
export enum GLeaderboardTypeEnum {
  /** Challenge leaderboard (special events) */
  Challenge = 'CHALLENGE',
  /** Daily leaderboard (resets daily) */
  Daily = 'DAILY',
  /** Monthly leaderboard (resets monthly) */
  Monthly = 'MONTHLY',
  /** Overall leaderboard (no time restrictions) */
  Overall = 'OVERALL',
  /** Weekly leaderboard (resets weekly) */
  Weekly = 'WEEKLY'
}

export type GLineLevelDeliveryIssue = {
  __typename?: 'LineLevelDeliveryIssue';
  createdAt: Scalars['ISO8601DateTime'];
  deliveryRouteStopId?: Maybe<Scalars['ID']>;
  description: Scalars['String'];
  id: Scalars['ID'];
  isHeaderReason: Scalars['Boolean'];
  orderLineId: Scalars['ID'];
  quantity: Scalars['Int'];
  reasonCode: GLineLevelDeliveryIssueReasonCode;
  redeliveryStopId?: Maybe<Scalars['ID']>;
  subReasonCode?: Maybe<GDeliveryIssue>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Autogenerated input type of LineLevelDeliveryIssueApplyHeaderReason */
export type GLineLevelDeliveryIssueApplyHeaderReasonInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Must be one of access_issue or route_not_complete. */
  reasonCode: GLineLevelDeliveryIssueReasonCode;
  /** Delivery route stop id. */
  stopId: Scalars['ID'];
};

/** Autogenerated return type of LineLevelDeliveryIssueApplyHeaderReason. */
export type GLineLevelDeliveryIssueApplyHeaderReasonPayload = {
  __typename?: 'LineLevelDeliveryIssueApplyHeaderReasonPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  lineLevelIssues?: Maybe<Array<GLineLevelDeliveryIssue>>;
  userErrors: Array<GLineLevelDeliveryIssueError>;
};

/** Autogenerated input type of LineLevelDeliveryIssueDelete */
export type GLineLevelDeliveryIssueDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Line-level delivery issue id. */
  id: Scalars['ID'];
};

/** Autogenerated return type of LineLevelDeliveryIssueDelete. */
export type GLineLevelDeliveryIssueDeletePayload = {
  __typename?: 'LineLevelDeliveryIssueDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userErrors: Array<GLineLevelDeliveryIssueError>;
};

/** Line-level delivery issue possible errors */
export type GLineLevelDeliveryIssueError = GAlreadyReportedReason | GInvalidHeaderReasonCode | GInvalidStopTypeForHeaderReason | GInvalidSubReasonForReasonCode | GLineLevelDeliveryIssueNotFound | GLineLevelDeliveryIssueValidationError | GOrderLineNotFound | GOrderLineNotOnStop | GRouteEnded | GStopHasNoFulfilledLines | GStopHasNoOrderLines;

export type GLineLevelDeliveryIssueNotFound = GUserErrorInterface & {
  __typename?: 'LineLevelDeliveryIssueNotFound';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** NetSuite-aligned reason codes for line-level delivery issues (customlist_reason_code_deliver) */
export enum GLineLevelDeliveryIssueReasonCode {
  AccessIssue = 'access_issue',
  Damaged = 'damaged',
  LostMissing = 'lost_missing',
  Other = 'other',
  QaExpired = 'qa_expired',
  RejectedRefusal = 'rejected_refusal',
  RouteNotComplete = 'route_not_complete',
  WrongItem = 'wrong_item'
}

/** Autogenerated input type of LineLevelDeliveryIssueReport */
export type GLineLevelDeliveryIssueReportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** OrderLine id (UUID). */
  orderLineId: Scalars['ID'];
  /** Number of units attributed to this reason; must be > 0. */
  quantity: Scalars['Int'];
  /** High-level NS-aligned reason code. */
  reasonCode: GLineLevelDeliveryIssueReasonCode;
  redelivery?: InputMaybe<Scalars['Boolean']>;
  /** Delivery route stop id, or redelivery stop id when redelivery is true. */
  stopId: Scalars['ID'];
  /** Sub-reason code (must be in the whitelist for the reason_code). */
  subReasonCode?: InputMaybe<GDeliveryIssue>;
};

/** Autogenerated return type of LineLevelDeliveryIssueReport. */
export type GLineLevelDeliveryIssueReportPayload = {
  __typename?: 'LineLevelDeliveryIssueReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  lineLevelIssue?: Maybe<GLineLevelDeliveryIssue>;
  userErrors: Array<GLineLevelDeliveryIssueError>;
};

/** Autogenerated input type of LineLevelDeliveryIssueUpdate */
export type GLineLevelDeliveryIssueUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Line-level delivery issue id. */
  id: Scalars['ID'];
  quantity?: InputMaybe<Scalars['Int']>;
  reasonCode?: InputMaybe<GLineLevelDeliveryIssueReasonCode>;
  subReasonCode?: InputMaybe<GDeliveryIssue>;
};

/** Autogenerated return type of LineLevelDeliveryIssueUpdate. */
export type GLineLevelDeliveryIssueUpdatePayload = {
  __typename?: 'LineLevelDeliveryIssueUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  lineLevelIssue?: Maybe<GLineLevelDeliveryIssue>;
  userErrors: Array<GLineLevelDeliveryIssueError>;
};

export type GLineLevelDeliveryIssueValidationError = GUserErrorInterface & {
  __typename?: 'LineLevelDeliveryIssueValidationError';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GListingImpressions = {
  __typename?: 'ListingImpressions';
  dailyBreakdown: Array<GDailyImpression>;
  totalBreakdown: GImpressionBreakdown;
  totalImpressions: Scalars['Int'];
};

export type GLocation = {
  __typename?: 'Location';
  /** Get a list of fees active for a location. */
  activeFeesList: Array<GFeeInterface>;
  /** Returns the names of the location's active services as of the current date. */
  activeServices: Array<Scalars['String']>;
  address: GAddress;
  adequatelyPaid: Scalars['Boolean'];
  /**
   * Get a list of fees that could apply to a location's potential order.
   * @deprecated Replaced by applicable_fees_list to provide a more flexible interface-based approach.
   */
  applicableFees: Array<GFee>;
  /**
   * Get a list of fees that could apply to a location's potential order based on
   * delivery date, payment method and order total.
   */
  applicableFeesList: Array<GFeeInterface>;
  /** Whether our backend systems will charge invoices as they become due, using the location's default payment method. */
  automaticallyChargeInvoices: Scalars['Boolean'];
  autopayNeedsSetup: Scalars['Boolean'];
  /** @deprecated Use `automaticallyChargeInvoices` instead. */
  autopayRequired: Scalars['Boolean'];
  autopaySet: Scalars['Boolean'];
  /** Get available delivery days for this location based on vendor associations and delivery rules. */
  availableDeliveryDays: Array<GAvailableDeliveryDay>;
  businessName: Scalars['String'];
  /** Calculate shipping cost and estimated delivery dates for a potential order. */
  calculateShipping: GShippingEstimate;
  /**
   * Same as Query.catalogFilters, but doesn't include items from this location's
   * unsupported vendors in ItemTag.itemCount. Warehouse filter still must be
   * explicitly provided.
   */
  catalogFilters?: Maybe<GCatalogFilter>;
  /**
   * Returns categories for the location's warehouse. Note that items and item
   * counts for the returned categories will exclude items belonging to vendors
   * that don't support the location.
   */
  categories: Array<GCategory>;
  collection: GCollection;
  company?: Maybe<GCompany>;
  /** PROTOTYPE list of the location's custom counting units. */
  countingUnits: Array<GLocationCountingUnit>;
  countryCode: Scalars['String'];
  county: Scalars['String'];
  /** View credit memos for this location, sorted by transaction date in descending order. */
  creditMemos: GNetsuiteCreditMemoConnection;
  /** PROTOTYPE returns the current in-progress Stock Count, if any. */
  currentStockCount?: Maybe<GLocationStockCount>;
  customIngredients: Array<GCustomIngredient>;
  /** Get the location's items that have a custom price. */
  customPrices: Array<GCustomPrice>;
  /** One customer autopay request for this location, visible to its requester and support. */
  customerAutopayRequest?: Maybe<GCustomerAutopayRequest>;
  /** Autopay status and customer controls. Null when the caller may not manage this location's payments. */
  customerAutopaySettings?: Maybe<GCustomerAutopaySettings>;
  /** Whether this location's customer collects their order at the warehouse instead of receiving a delivery. */
  customerPickup: Scalars['Boolean'];
  /** Customer-segmentation tags currently assigned to this location. */
  customerTags: Array<GCustomerTagAssignment>;
  defaultPaymentMethod?: Maybe<GLocationPaymentMethod>;
  /**
   * boolean indicating if the location gets deliveries within store hours. Note
   * scheduled_delivery_time_source is the actual source of truth for how delivery
   * times are calculated.
   */
  deliverWithinStoreHours: Scalars['Boolean'];
  /** any delivery date PO Numbers requested for the location */
  deliveryDatePoNumbers: Array<GDeliveryDatePoNumber>;
  displayAddress: Scalars['String'];
  /** Whether this location or its company is excluded from third-party delivery. */
  effectivelyExcluded: Scalars['Boolean'];
  enabled: Scalars['Boolean'];
  encryptedLocationId?: Maybe<Scalars['String']>;
  /** Whether this location enforces item scanning for deliveries. */
  enforceItemScanning: Scalars['Boolean'];
  equipmentServicingAvailable: Scalars['Boolean'];
  /** Check if a feature flag is enabled for this location. */
  featureFlagEnabled: Scalars['Boolean'];
  /**
   * Get a list of fee exemptions for a location.
   * @deprecated Replaced by fee_exemptions_list to use the new FeeInterface type.
   */
  feeExemptions: Array<GFeeExemption>;
  /** Get a list of fee exemptions for a location. */
  feeExemptionsList: Array<GFeeExemptionList>;
  financialStatementPreferences?: Maybe<GFinancialStatementPreferences>;
  financialTransaction?: Maybe<GFinancialTransaction>;
  formattedAddress: Scalars['String'];
  /**
   * Whether this location is excluded from automatic application of credit memos,
   * overpayments and unapplied Odeko payments to its open invoices.
   */
  fundApplicationExcluded: Scalars['Boolean'];
  /** If a location is enabled for global fulfillment */
  globalFulfillmentEnabled: Scalars['Boolean'];
  globalFulfillmentMode: GLocationGlobalFulfillmentModeEnum;
  globalFulfillmentShippingWarehouse?: Maybe<GWarehouse>;
  /** Whether the location has credit memos. */
  hasCreditMemos: Scalars['Boolean'];
  hasDeliveries: Scalars['Boolean'];
  hasDeliveryInstructions: Scalars['Boolean'];
  hasOrders: Scalars['Boolean'];
  hasShippingInstructions: Scalars['Boolean'];
  hasSkus: Scalars['Boolean'];
  hubspotCompanyId?: Maybe<Scalars['String']>;
  hubspotLead?: Maybe<GHubspotLead>;
  id: Scalars['ID'];
  includeInAutomatedRouting?: Maybe<Scalars['Boolean']>;
  internalDeliveryInstructions?: Maybe<Array<GInternalDeliveryInstructions>>;
  /** View Odeko invoices for this location, sorted by transaction date in descending order. */
  invoices: GNetsuiteInvoiceConnection;
  isDoordash: Scalars['Boolean'];
  /** Check if survey is complete */
  isSurveyComplete: Scalars['Boolean'];
  itemBackups: Array<GLocationItemBackup>;
  itemDeliveryInstructions?: Maybe<Array<GItemDeliveryInstructions>>;
  /**
   * Similar to User.availableItemById, but returns a LocationItemDetails object
   * that provides more direct access to item attributes applicable to this
   * Location.
   */
  itemDetails?: Maybe<GLocationItemDetails>;
  itemRecommendations: GItemRecommendationConnection;
  items: GItemConnection;
  keyId: Scalars['String'];
  /**
   * Returns balance powered via legacy systems.
   * @deprecated Use totalUnpaidBalance, upcomingBalance or overdueBalance instead.
   */
  legacyBalanceCents: Scalars['Int'];
  /**
   * Returns pending cents powered via legacy systems.
   * @deprecated Use totalUnpaidBalance, upcomingBalance or overdueBalance instead.
   */
  legacyPendingCents: Scalars['Int'];
  locationAccessInstructions?: Maybe<Array<GLocationAccessInstructions>>;
  locationDeliveryWindow: GLocationDeliveryWindows;
  locationEntranceInstructions?: Maybe<Array<GLocationEntranceInstructions>>;
  /** Whether this location is explicitly excluded from third-party delivery. */
  locationExcluded: Scalars['Boolean'];
  membershipStatus: GLocationMembershipStatus;
  /** @deprecated Deprecated - use membership_status */
  membershipTier: GLocationMembershipTier;
  name: Scalars['String'];
  netsuiteInternalId?: Maybe<Scalars['ID']>;
  /** Get a Netsuite transactions filtered */
  netsuiteTransactions?: Maybe<Array<GNetsuiteTransaction>>;
  /**
   * The location's New Items, paginated. Behaves identically to
   * items(filters: { isNew: { op: EQUAL, value: [true] } }): the same 60-day
   * activation window, the same new-item priority ordering, and the same
   * updatedAt-descending fallback. This is the single shared entry point that the
   * storefront carousel and View All both read, so their ordering can never drift.
   * isNew is forced on by the resolver; callers may still pass other filters (e.g.
   * the shipping-customer filters saleUnitWeightLbs / refrigerationState).
   */
  newItems: GItemConnection;
  /** Get next available delivery dates for all vendors at this location */
  nextAvailableDeliveryDates: Array<GNextAvailableDeliveryDate>;
  /**
   * Details about the next payment that automatic billing would charge. Null if
   * there is no next charge (e.g. if there are no unpaid invoices, if the location
   * has automatic billing disabled, etc.).
   */
  nextCharge?: Maybe<GPaymentUpcoming>;
  nickname: Scalars['String'];
  onboardingStatus: Scalars['String'];
  /** The amount of Money that the location needs to pay eventually, not including the amounts past due. */
  openBalance?: Maybe<GMoney>;
  openingHours?: Maybe<Array<GOpeningHour>>;
  /**
   * Groups of paid or partially-paid invoices. The payment may have succeeded or
   * be pending; never failed. These invoices are grouped by payment. Due to
   * partial payments, a given invoice may be present in multiple groups. A null
   * value means that the feature is off; an empty array means that there is no data.
   */
  paidInvoiceGroups?: Maybe<GPaymentInvoiceGroupConnection>;
  /** The amount of Money that the location should have paid earlier. */
  pastDueBalance?: Maybe<GMoney>;
  paymentMethods: Array<GLocationPaymentMethod>;
  /** The location's current payment terms, in days. 0 means due on receipt. Null if braavos does not know this location yet. */
  paymentTermsDays?: Maybe<Scalars['Int']>;
  phoneNumbers: Array<GPhoneNumber>;
  postalCode?: Maybe<Scalars['String']>;
  /** Whether this location's printed delivery sheets show prices, fees, and totals. Effective value: the location's own setting, else its warehouse's default. */
  includeFinancialsOnDeliverySheet: Scalars['Boolean'];
  /** Whether this location opts in to printable delivery sheets when ops prints sheets for a night. */
  printDeliverySheetEnabled: Scalars['Boolean'];
  promotionPages: GPromotionPageConnection;
  punchoutCatalogEnabled: Scalars['Boolean'];
  purchaseHistoryRecommendations: GPurchaseHistoryRecommendationConnection;
  /** Whether or not the location is ready for terms. */
  readyForTerms?: Maybe<Scalars['Boolean']>;
  /** Error info if (and only if) last payment attempt failed. */
  recentPaymentError?: Maybe<GPaymentError>;
  recipes: Array<GRecipe>;
  recipientPhoneNumber: GRecipientPhoneNumber;
  /** The routing cohort this location belongs to. */
  routingCohort?: Maybe<GRoutingCohort>;
  scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum;
  /**
   * The service time for this location. This is the time it takes to perform a
   * delivery at this location. This is used to calculate the total time for a
   * delivery route.
   */
  serviceTime?: Maybe<Scalars['Int']>;
  /** Active customer-facing services for this location. */
  services: Array<Scalars['String']>;
  shippingInstructions?: Maybe<GShippingInstructions>;
  shippingMethods?: Maybe<Array<GLocationShippingMethodEnum>>;
  showOnboardingSurvey: Scalars['Boolean'];
  signedUpForEquipmentServicing: Scalars['Boolean'];
  signedUpForSupply: Scalars['Boolean'];
  skus: Array<GSku>;
  /** Standing order items for a specific day of the week, or all days if not specified */
  standingOrderItems: Array<GStandingOrderSku>;
  /** The PO number applied to every delivery date without a PO number of its own */
  standingPoNumber?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  /** PROTOTYPE returns the list of the location's Stock Counts. */
  stockCounts: Array<GLocationStockCount>;
  /** PROTOTYPE list of the location's storage or stock areas. */
  storageAreas: Array<GLocationStorageArea>;
  storeHoursConfirmed: Scalars['Boolean'];
  supplyReady: Scalars['Boolean'];
  /** Survey responses at Location or Company level */
  survey?: Maybe<GSurvey>;
  timeZone: Scalars['String'];
  /** This is a temporary value is for verification purposes only! */
  totalPendingTransactions?: Maybe<GMoney>;
  /**
   * The sum of all payments made towards this location's Odeko invoices that are
   * still processing. Does not include credit applications.
   */
  totalProcessingPayments: GMoney;
  /** The total spend from so-api orders in the given range, by delivery date */
  totalSpendCents: Scalars['Int'];
  /** The amount of money that the location has in credits and unapplied payments. */
  totalUnappliedFunds: GMoney;
  /** The amount of Money that the location owes us in total. Null means feature is off, $0 means no balance. */
  totalUnpaidBalance?: Maybe<GMoney>;
  /**
   * This location's transaction-sync situation, for the internal tool that
   * refreshes a location's records from NetSuite. Never null: a location with no
   * history reports that it has none.
   */
  transactionSync: GTransactionSync;
  /**
   * Groups of unpaid or partially-unpaid invoices. These invoices may be grouped
   * by payment due date. A null value means that the feature is off; an empty
   * collection means that there is no data.
   *
   * NOTE: Pagination arguments are currently ignored. We plan on addressing this in a future iteration.
   */
  unpaidInvoiceGroups?: Maybe<GPaymentInvoiceGroupConnection>;
  /** Returns vendors that will not deliver to this location. */
  unsupportedVendors: Array<GVendor>;
  /** Users who have access to this location (company owners and location-assigned users). */
  users: Array<GUser>;
  /** Number of users who have access to this location. */
  usersCount: Scalars['Int'];
  warehouse: GWarehouse;
  /** Warehouse delivery rules apply to this location. */
  warehouseDeliveryRules: Array<GDeliveryRule>;
};


export type GLocationApplicableFeesArgs = {
  deliveryDate: Scalars['ISO8601Date'];
  skus: Array<GApplicableFeesSkuInput>;
  warehouseUuid?: InputMaybe<Scalars['ID']>;
};


export type GLocationApplicableFeesListArgs = {
  deliveryDate: Scalars['ISO8601Date'];
  items?: InputMaybe<Array<GApplicableFeesItemInput>>;
  paymentMethodType?: InputMaybe<GPaymentMethodTypeEnum>;
  skus: Array<GApplicableFeesSkuInput>;
  warehouseUuid?: InputMaybe<Scalars['ID']>;
};


export type GLocationCalculateShippingArgs = {
  skus: Array<GCalculateShippingSkuInput>;
  warehouseUuid?: InputMaybe<Scalars['ID']>;
};


export type GLocationCatalogFiltersArgs = {
  itemCountFilters?: InputMaybe<GItemsFiltersInput>;
  selected?: InputMaybe<GCatalogFilterSelectedInput>;
};


export type GLocationCategoriesArgs = {
  filter?: InputMaybe<GCategoriesFilter>;
  forType?: InputMaybe<GCategoryType>;
  sortOrder?: InputMaybe<Array<InputMaybe<GCategoriesSortOrder>>>;
};


export type GLocationCollectionArgs = {
  referenceId?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<GCollectionType>;
};


export type GLocationCreditMemosArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  filter?: InputMaybe<GLocationCreditMemosFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
};


export type GLocationCustomerAutopayRequestArgs = {
  requestId: Scalars['ID'];
};


export type GLocationDeliveryDatePoNumbersArgs = {
  startingFrom?: InputMaybe<Scalars['ISO8601Date']>;
};


export type GLocationFeatureFlagEnabledArgs = {
  flagName: Scalars['String'];
};


export type GLocationFinancialTransactionArgs = {
  id: Scalars['ID'];
};


export type GLocationInvoicesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  filter?: InputMaybe<GLocationInvoicesFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
};


export type GLocationIsSurveyCompleteArgs = {
  surveyLevel: GSurveyLevelEnum;
  surveyName: Scalars['String'];
};


export type GLocationItemDetailsArgs = {
  itemId: Scalars['ID'];
};


export type GLocationItemRecommendationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  deliveryDate?: InputMaybe<Scalars['ISO8601Date']>;
  excludeItemIds?: InputMaybe<Array<Scalars['String']>>;
  filters?: InputMaybe<GItemRecommendationFiltersInput>;
  first?: InputMaybe<Scalars['Int']>;
  itemIds?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  maxRecommendations?: InputMaybe<Scalars['Int']>;
  type: GItemRecommendationType;
  warehouses: Array<Scalars['String']>;
};


export type GLocationItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  analyticsTags?: InputMaybe<GAlgoliaAnalyticsTagInput>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<GItemsFiltersInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Array<InputMaybe<GItemsSortOrder>>>;
};


export type GLocationNetsuiteTransactionsArgs = {
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
  transactionTypes?: InputMaybe<Array<Scalars['String']>>;
  vendorName?: InputMaybe<Scalars['String']>;
};


export type GLocationNewItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<GNewItemsFiltersInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type GLocationNextAvailableDeliveryDatesArgs = {
  daysAhead?: InputMaybe<Scalars['Int']>;
  vendorId?: InputMaybe<Scalars['ID']>;
};


export type GLocationNextChargeArgs = {
  paymentMethodId: Scalars['String'];
};


export type GLocationOpenBalanceArgs = {
  asOf?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type GLocationPaidInvoiceGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dateFilter?: InputMaybe<GFinancialTransactionDateRangeInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type GLocationPastDueBalanceArgs = {
  asOf?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type GLocationPromotionPagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<GPromotionPageFiltersInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Array<InputMaybe<GPromotionPageSortOrder>>>;
};


export type GLocationPurchaseHistoryRecommendationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  deliveryDate?: InputMaybe<Scalars['ISO8601Date']>;
  excludeItemIds?: InputMaybe<Array<Scalars['String']>>;
  first?: InputMaybe<Scalars['Int']>;
  isRefillDue?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  minDistinctMonthsOrdered?: InputMaybe<Scalars['Int']>;
  predictabilityLevels?: InputMaybe<Array<GPredictabilityLevel>>;
  warehouses: Array<Scalars['String']>;
};


export type GLocationRecentPaymentErrorArgs = {
  asOf?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type GLocationStandingOrderItemsArgs = {
  dayOfWeek?: InputMaybe<Scalars['Int']>;
  vendorId?: InputMaybe<Scalars['ID']>;
};


export type GLocationSurveyArgs = {
  surveyLevel: GSurveyLevelEnum;
  surveyName: Scalars['String'];
};


export type GLocationTotalSpendCentsArgs = {
  endDate: Scalars['ISO8601Date'];
  startDate: Scalars['ISO8601Date'];
};


export type GLocationUnpaidInvoiceGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dateFilter?: InputMaybe<GFinancialTransactionDateRangeInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type GLocationAccessInstructions = {
  __typename?: 'LocationAccessInstructions';
  code?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  imageKeys?: Maybe<Array<Scalars['String']>>;
  imageUrls?: Maybe<Array<Scalars['String']>>;
  installed?: Maybe<Scalars['Boolean']>;
  location: GLocation;
  note?: Maybe<Scalars['String']>;
  /** Opaque ID for translating this instruction */
  translationId: Scalars['ID'];
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/**
 * A run of location assignments or removals on one item by one user. Locations are assigned one per
 * request, so a run is every change that user made without pausing for more than two minutes.
 */
export type GLocationChangeGroup = {
  __typename?: 'LocationChangeGroup';
  /** `NEW` when the locations were added, `DELETE` when they were removed */
  changeType: GAuditLogChangeType;
  endedAt: Scalars['ISO8601DateTime'];
  /** The locations that were added or removed, oldest change first */
  locationIds: Array<Scalars['ID']>;
  startedAt: Scalars['ISO8601DateTime'];
  /** Who made the changes, or null when nobody did (a system write) */
  user?: Maybe<GUser>;
};

export type GLocationChangeGroupConnection = {
  __typename?: 'LocationChangeGroupConnection';
  edges: Array<Maybe<GLocationChangeGroupEdge>>;
  nodes: Array<Maybe<GLocationChangeGroup>>;
  pageInfo: GPageInfo;
};

export type GLocationChangeGroupEdge = {
  __typename?: 'LocationChangeGroupEdge';
  cursor: Scalars['String'];
  node: GLocationChangeGroup;
};

/** The connection type for Location. */
export type GLocationConnection = {
  __typename?: 'LocationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GLocationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GLocation>>>;
  /** Information to aid in pagination. */
  pageInfo: GPageInfo;
  /** The total count of records in the connection. */
  totalCount: Scalars['Int'];
};

/**
 * PROTOTYPE describes a custom location counting unit. Items may be counted in
 * units of these, or they may be counted using the item's associated Odeko sales unit.
 */
export type GLocationCountingUnit = {
  __typename?: 'LocationCountingUnit';
  /** PROTOTYPE The id of the base unit. */
  baseUnitId: Scalars['ID'];
  /** PROTOTYPE number of base units in this counting unit. */
  conversionRate: Scalars['Int'];
  /** PROTOTYPE id of the counting unit. */
  id: Scalars['ID'];
  /** PROTOTYPE Odeko UUID of the associated location. */
  locationId: Scalars['ID'];
  /** PROTOTYPE name of the counting unit. */
  name: Scalars['String'];
};

export enum GLocationCreditMemosFilter {
  /** Credit memos used in full. */
  Applied = 'APPLIED',
  /** Credit memos that have been used, but there is a remaining credit balance. */
  PartiallyApplied = 'PARTIALLY_APPLIED',
  /** Credit memos that haven't yet been used. */
  Unapplied = 'UNAPPLIED'
}

export type GLocationDeliveryWindows = {
  __typename?: 'LocationDeliveryWindows';
  /** End time in HH:MM format. */
  endTime: Scalars['String'];
  /** Start time in HH:MM format. */
  startTime: Scalars['String'];
};

export type GLocationDeprioritization = {
  __typename?: 'LocationDeprioritization';
  deprioritizedAt: Scalars['ISO8601DateTime'];
  deprioritizedBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  locationId: Scalars['ID'];
  reason: Scalars['String'];
};

/** An edge in a connection. */
export type GLocationEdge = {
  __typename?: 'LocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GLocation>;
};

export type GLocationEntranceInstructions = {
  __typename?: 'LocationEntranceInstructions';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  imageKeys?: Maybe<Array<Scalars['String']>>;
  imageUrls?: Maybe<Array<Scalars['String']>>;
  location: GLocation;
  note?: Maybe<Scalars['String']>;
  /** Opaque ID for translating this instruction */
  translationId: Scalars['ID'];
  updatedAt: Scalars['ISO8601DateTime'];
  videoKeys?: Maybe<Array<Scalars['String']>>;
  videoUrls?: Maybe<Array<Scalars['String']>>;
};

/** Location update error types */
export type GLocationError = GLocationsNotFound | GRecentDeliveriesPresent;

export enum GLocationGlobalFulfillmentModeEnum {
  NotEnabled = 'not_enabled',
  SingleShippingOrder = 'single_shipping_order',
  SplitOrder = 'split_order'
}

/** Autogenerated input type of LocationIncludeInAutomatedRoutingUpdate */
export type GLocationIncludeInAutomatedRoutingUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  includeInAutomatedRouting: Scalars['Boolean'];
  locationId: Scalars['ID'];
};

/** Autogenerated return type of LocationIncludeInAutomatedRoutingUpdate. */
export type GLocationIncludeInAutomatedRoutingUpdatePayload = {
  __typename?: 'LocationIncludeInAutomatedRoutingUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  includeInAutomatedRouting: Scalars['Boolean'];
};

export enum GLocationInvoicesFilter {
  /** Invoices that have had a credit applied towards their balance. */
  CreditApplied = 'CREDIT_APPLIED',
  /** Invoices that are paid in full or will be by pending payments. */
  Paid = 'PAID',
  /** Invoices that are not paid in full, excluding those that will be by pending payments. */
  Unpaid = 'UNPAID'
}

export type GLocationItem = {
  __typename?: 'LocationItem';
  itemId: Scalars['ID'];
  locationId: Scalars['ID'];
};

export type GLocationItemBackup = {
  __typename?: 'LocationItemBackup';
  backupItem?: Maybe<GSupplyItem>;
  backupItemId: Scalars['ID'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  item?: Maybe<GSupplyItem>;
  itemId: Scalars['ID'];
  /** Backup units sent per original unit, by pack contents; null when the pair cannot be converted */
  packRatio?: Maybe<Scalars['Float']>;
};

/**
 * A wrapper around a SupplyItem that provides more direct access to attributes of
 * the SupplyItem that are applicable to a specific Location, allowing for more
 * efficient queries and less client-side data processing.
 */
export type GLocationItemDetails = {
  __typename?: 'LocationItemDetails';
  /**
   * An InventoryItem's warehouse association for the Location's Warehouse. May be
   * null if the item is not sold at that warehouse or if it is a NonInventoryItem.
   */
  inventoryWarehouseAssociation?: Maybe<GInventoryWarehouseAssociation>;
  /** The full details of the SupplyItem. */
  item: GSupplyItem;
  /**
   * A NonInventoryItem's warehouse association for the Location's Warehouse. May
   * be null if the item is not sold at that warehouse, the vendor does not sell to
   * the Location, or the item is an InventoryItem.
   */
  nonInventoryWarehouseAssociation?: Maybe<GNonInventoryWarehouseAssociation>;
};

/** Input needed for allowing custom items to be enabled in the catalog, for a location */
export type GLocationItemInput = {
  /** The uuid of the catalog item */
  itemId: Scalars['ID'];
  /** The uuid of the location's odeko_uuid */
  locationId: Scalars['ID'];
};

export type GLocationMembershipStatus = {
  __typename?: 'LocationMembershipStatus';
  tier: GLocationMembershipStatusTier;
  /** Is today's date on or after the trial start date, and before the end date? */
  trialActive: Scalars['Boolean'];
  /** The number of days from the the first order until the trial ends. */
  trialDaysFromFirstOrder: Scalars['Int'];
  /** The date that the location's trial ends. When checking if a location is on a trial, this is an exclusive boundary. */
  trialEndDate?: Maybe<Scalars['ISO8601Date']>;
  /** The date that the location's trial begins. When checking if a location is on a trial, this is an inclusive boundary. */
  trialStartDate?: Maybe<Scalars['ISO8601Date']>;
};

export enum GLocationMembershipStatusTier {
  /** Required minimum spend, no discounts, standard order cut-off time */
  Basic = 'basic',
  /** No minimum spend, no discounts, standard order cut-off time */
  Bronze = 'bronze',
  /** Displays spend tracker. No minimum spend, no discounts, standarded cut-off time. */
  ConsideringMembership = 'considering_membership',
  /** Excluded from the Membership Tier rules */
  Exclude = 'exclude',
  /** No minimum spend, higher discount, later order cut-off time */
  Gold = 'gold',
  /** No minimum spend, lower discount, standard order cut-off time */
  Silver = 'silver'
}

export enum GLocationMembershipTier {
  /** Required minimum spend, no discounts, standard order cut-off time */
  Basic = 'basic',
  /** Displays spend tracker. No minimum spend, no discounts, standarded cut-off time. */
  ConsideringMembership = 'considering_membership',
  /** Excluded from the Membership Tier rules */
  Exclude = 'exclude',
  /** No minimum spend, higher discount, later order cut-off time */
  Gold = 'gold',
  /** No minimum spend, lower discount, standard order cut-off time */
  Silver = 'silver'
}

export type GLocationOrderDateInput = {
  deliveryDate: Scalars['ISO8601Date'];
  vendors: Array<GLocationOrderVendorInput>;
};

export type GLocationOrderError = {
  __typename?: 'LocationOrderError';
  message: Scalars['String'];
};

export type GLocationOrderFeeInput = {
  amountCents?: InputMaybe<Scalars['Int']>;
  amountPercent?: InputMaybe<Scalars['Float']>;
  uuid: Scalars['ID'];
};

export type GLocationOrderItemInput = {
  /** Item UUID (product.uuid / sku.item_uuid) — not the SKU's numeric database ID */
  id: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type GLocationOrderResult = {
  __typename?: 'LocationOrderResult';
  deliveryDate: Scalars['ISO8601Date'];
  errorMessage?: Maybe<Scalars['String']>;
  order?: Maybe<GOrder>;
  previousTotalCents: Scalars['Int'];
  reason?: Maybe<Scalars['String']>;
  vendor: GVendor;
};

export type GLocationOrderVendorInput = {
  couponCodes?: InputMaybe<Array<Scalars['String']>>;
  fees?: InputMaybe<Array<GLocationOrderFeeInput>>;
  items: Array<GLocationOrderItemInput>;
  salesTaxEstimateId?: InputMaybe<Scalars['ID']>;
  vendorId: Scalars['ID'];
};

/** Error indicating that the location is ineligible for ordering. */
export type GLocationOrderingIneligibleError = GError & {
  __typename?: 'LocationOrderingIneligibleError';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating that the location is not enabled for ordering. */
export type GLocationOrderingNotEnabledError = GError & {
  __typename?: 'LocationOrderingNotEnabledError';
  /** A description of the error. */
  message: Scalars['String'];
};

/** The connection type for Order. */
export type GLocationOrdersConnection = {
  __typename?: 'LocationOrdersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GOrderEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GOrder>>>;
  /** Information to aid in pagination. */
  pageInfo: GPageInfo;
  /** The total count of records in the connection. */
  totalCount: Scalars['Int'];
};

export type GLocationOrdersInput = {
  id: Scalars['ID'];
};

/** The connection type for Order. */
export type GLocationPastOrdersConnection = {
  __typename?: 'LocationPastOrdersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GOrderEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GOrder>>>;
  /** Information to aid in pagination. */
  pageInfo: GPageInfo;
  /** The total count of records in the connection. */
  totalCount: Scalars['Int'];
};

export type GLocationPastOrdersInput = {
  id: Scalars['ID'];
};

export type GLocationPaymentMethod = GBankAccount | GBuyNowPayLater | GCreditCard;

export enum GLocationPhoneTypeEnum {
  /** Location phone number that can be used to resolve order issues */
  OrderContact = 'order_contact'
}

/** Narrows the locations a viewer can see. The filters apply together, and with the name search alongside them. */
export type GLocationSearchFiltersInput = {
  /** Locations carrying these tags. An empty id list is a no-op. */
  tags?: InputMaybe<GCustomerTagFilterInput>;
  /**
   * Matches a location's businessName or its id, case-insensitively. Scoped to
   * this argument on purpose: `name` is shared with several other apps, and an id
   * is a substring of hex that collides with ordinary search terms.
   */
  term?: InputMaybe<Scalars['String']>;
  /** Locations served by one of these warehouses (the federated Warehouse.id). An empty list is a no-op. */
  warehouseIds?: InputMaybe<Array<Scalars['ID']>>;
};

export enum GLocationShippingMethodEnum {
  LocalDelivery = 'local_delivery',
  PalletShipping = 'pallet_shipping',
  ParcelShipping = 'parcel_shipping'
}

/**
 * PROTOTYPE delineates a 'Stock Count', which is an activity with a beginning time
 * and an ending time during which some inventory counts are entered for a
 * location. It's like a session.
 */
export type GLocationStockCount = {
  __typename?: 'LocationStockCount';
  /** PROTOTYPE number of LocationItems that were counted in this session. */
  countedItems: Scalars['Int'];
  /** PROTOTYPE when the session was started. */
  createdAt: Scalars['ISO8601DateTime'];
  /** PROTOTYPE an identifier for the user who started the session. */
  createdBy?: Maybe<Scalars['String']>;
  /** PROTOTYPE id of the LocationInventorySession. */
  id: Scalars['ID'];
  /** PROTOTYPE the latest count for each item counted in this Stock Count session. */
  latestItemCounts: Array<GCurrentCount>;
  /** PROTOTYPE Odeko UUID of the associated location. */
  locationId: Scalars['ID'];
  /** PROTOTYPE when the session was submitted. */
  submittedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** PROTOTYPE an identifier for the user who submitted the session. */
  submittedBy?: Maybe<Scalars['String']>;
  /** PROTOTYPE the number of LocationItems that may be counted in this session. */
  totalItems: Scalars['Int'];
  /** PROTOTYPE when the session or one of its counts was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** PROTOTYPE names an area withing a Cafe location where stock is kept. */
export type GLocationStorageArea = {
  __typename?: 'LocationStorageArea';
  /** PROTOTYPE id of a storage area withing a Cafe location. */
  id: Scalars['ID'];
  /** PROTOTYPE Odeko UUID of the associated location. */
  locationId: Scalars['ID'];
  /** PROTOTYPE name of a storage area within a Cafe location. */
  name: Scalars['String'];
};

export type GLocationUpcomingOrdersInput = {
  id: Scalars['ID'];
};

/** Autogenerated input type of LocationsCustomerPickupUpdate */
export type GLocationsCustomerPickupUpdateInput = {
  /**
   * Flag the locations even though some recently took a delivery on a driven
   * route. Without it such a request is rejected and nothing is written, so ops
   * sees the list first.
   */
  acknowledgeRecentDeliveries?: InputMaybe<Scalars['Boolean']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  customerPickup: Scalars['Boolean'];
  locationIds: Array<Scalars['ID']>;
};

/** Autogenerated return type of LocationsCustomerPickupUpdate. */
export type GLocationsCustomerPickupUpdatePayload = {
  __typename?: 'LocationsCustomerPickupUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  locations: Array<GLocation>;
  /**
   * Requested ids with no matching location in this service. Reported rather than
   * silently dropped: a location exists here only after the location sync, so an
   * id can be valid upstream and still be unknown to this service.
   */
  notFoundLocationIds: Array<Scalars['ID']>;
  userErrors: Array<GLocationError>;
};

/** Autogenerated input type of LocationsEnforceItemScanningUpdate */
export type GLocationsEnforceItemScanningUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  enforceItemScanning: Scalars['Boolean'];
  locationIds: Array<Scalars['ID']>;
};

/** Autogenerated return type of LocationsEnforceItemScanningUpdate. */
export type GLocationsEnforceItemScanningUpdatePayload = {
  __typename?: 'LocationsEnforceItemScanningUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  locations: Array<GLocation>;
};

export enum GLocationsFilter {
  HasFieldService = 'has_field_service',
  HasRetail = 'has_retail',
  HasSupply = 'has_supply'
}

/** Autogenerated input type of LocationsIncludeInAutomatedRoutingUpdate */
export type GLocationsIncludeInAutomatedRoutingUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  includeInAutomatedRouting: Scalars['Boolean'];
  locationIds: Array<Scalars['ID']>;
};

/** Autogenerated return type of LocationsIncludeInAutomatedRoutingUpdate. */
export type GLocationsIncludeInAutomatedRoutingUpdatePayload = {
  __typename?: 'LocationsIncludeInAutomatedRoutingUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  locations: Array<GLocation>;
};

export type GLocationsNotFound = GUserErrorInterface & {
  __typename?: 'LocationsNotFound';
  errorCode: Scalars['String'];
  locationIds: Array<Scalars['ID']>;
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of LocationsIncludeFinancialsOnDeliverySheetUpdate */
export type GLocationsIncludeFinancialsOnDeliverySheetUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  includeFinancialsOnDeliverySheet: Scalars['Boolean'];
  locationIds: Array<Scalars['ID']>;
};

/** Autogenerated return type of LocationsIncludeFinancialsOnDeliverySheetUpdate. */
export type GLocationsIncludeFinancialsOnDeliverySheetUpdatePayload = {
  __typename?: 'LocationsIncludeFinancialsOnDeliverySheetUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  locations: Array<GLocation>;
};

/** Autogenerated input type of LocationsPrintDeliverySheetEnabledUpdate */
export type GLocationsPrintDeliverySheetEnabledUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  locationIds: Array<Scalars['ID']>;
  printDeliverySheetEnabled: Scalars['Boolean'];
};

/** Autogenerated return type of LocationsPrintDeliverySheetEnabledUpdate. */
export type GLocationsPrintDeliverySheetEnabledUpdatePayload = {
  __typename?: 'LocationsPrintDeliverySheetEnabledUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  locations: Array<GLocation>;
};

/** Autogenerated input type of LocationsServiceTimeUpdate */
export type GLocationsServiceTimeUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  locationIds: Array<Scalars['ID']>;
  serviceTime: Scalars['Int'];
};

/** Autogenerated return type of LocationsServiceTimeUpdate. */
export type GLocationsServiceTimeUpdatePayload = {
  __typename?: 'LocationsServiceTimeUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  locations: Array<GLocation>;
};

/** Autogenerated input type of LocationsThirdPartyExclusionUpdate */
export type GLocationsThirdPartyExclusionUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  locationExcluded: Scalars['Boolean'];
  locationIds: Array<Scalars['ID']>;
};

/** Autogenerated return type of LocationsThirdPartyExclusionUpdate. */
export type GLocationsThirdPartyExclusionUpdatePayload = {
  __typename?: 'LocationsThirdPartyExclusionUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  locations: Array<GLocation>;
  userErrors: Array<GLocationError>;
};

/** Autogenerated input type of LogSalesOutreach */
export type GLogSalesOutreachInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  locationId: Scalars['ID'];
  notes?: InputMaybe<Scalars['String']>;
  outcome: Scalars['String'];
};

/** Autogenerated return type of LogSalesOutreach. */
export type GLogSalesOutreachPayload = {
  __typename?: 'LogSalesOutreachPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GUserError>;
  salesOutreachLog?: Maybe<GSalesOutreachLog>;
};

/** Autogenerated input type of LoginConsumerAppUserFromFirebase */
export type GLoginConsumerAppUserFromFirebaseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Email to assign if registering a new account. Must be non-null if registering a new account. */
  email?: InputMaybe<Scalars['String']>;
  /** Firebase ID (the "localId" received from www.googleapis.com/identitytoolkit/v3/relyingparty/getAccountInfo). */
  fbId: Scalars['String'];
  /** Firebase token to assign if registering a new account. */
  fbToken?: InputMaybe<Scalars['String']>;
  /** Whether this should be registered as a guest account, if registering a new account. Defaults to false. */
  isGuestAccount?: InputMaybe<Scalars['Boolean']>;
  /** Phone number to assign if registering a new account. */
  phoneNumber?: InputMaybe<Scalars['String']>;
  /** ID received when verifying phone number. Must be included if a non-null "phoneNumber" is specified. */
  phoneVerificationId?: InputMaybe<Scalars['ID']>;
  /** Username to assign if registering a new account. Must be non-null if registering a new account. */
  username?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of LoginConsumerAppUserFromFirebase */
export type GLoginConsumerAppUserFromFirebasePayload = {
  __typename?: 'LoginConsumerAppUserFromFirebasePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to login. */
  result: GConsumerAppUserFirebaseLoginResult;
};

/** A guest who has signed up for a mailing list */
export type GMailingListGuest = {
  __typename?: 'MailingListGuest';
  createdAt: Scalars['ISO8601DateTime'];
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  micrositeLocationId: Scalars['ID'];
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Autogenerated input type of MakeCreditKeyChargeMutation */
export type GMakeCreditKeyChargeMutationInput = {
  /** Total amount to be charged, in cents. */
  amountCents: Scalars['Int'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Optionally specify an idempotency key to prevent duplicate charges. */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** Location UUID */
  locationUuid: Scalars['String'];
  /**
   * Payment method ID. This should identify a Credit Key account the location has
   * already connected as an available payment method.
   */
  paymentMethodId: Scalars['String'];
};

/** Autogenerated return type of MakeCreditKeyChargeMutation. */
export type GMakeCreditKeyChargeMutationPayload = {
  __typename?: 'MakeCreditKeyChargeMutationPayload';
  charge?: Maybe<GOdekoPaymentIntent>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
};

/** A manual (GM-triggered) Routific run mode. */
export enum GManualRoutificRunMode {
  /** Recalculate ETAs/metrics for the current routes without changing assignment or order. */
  EtasOnly = 'etas_only',
  /** Re-optimize the stop order within each route, keeping each stop on its vehicle. */
  ReSequence = 're_sequence'
}

export enum GManufacturedType {
  CustomBrandedItem = 'CUSTOM_BRANDED_ITEM'
}

/** Autogenerated input type of MarkCustomerPickupStopsComplete */
export type GMarkCustomerPickupStopsCompleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** IDs of the customer-pickup bucket stops to mark picked up. */
  stopIds: Array<Scalars['ID']>;
};

/** Autogenerated return type of MarkCustomerPickupStopsComplete. */
export type GMarkCustomerPickupStopsCompletePayload = {
  __typename?: 'MarkCustomerPickupStopsCompletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The customer-pickup bucket routes the completed stops belong to, for refreshing the tab. */
  routes?: Maybe<Array<GRoute>>;
  userErrors: Array<GDeliveryRouteStopError>;
};

/** Autogenerated input type of MarkItemsAsBulkPickedMutation */
export type GMarkItemsAsBulkPickedMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** A boolean value to set the bulk status of the items */
  isBulkedPicked: Scalars['Boolean'];
  /** A list of item ids e.g uuids */
  itemIds: Array<Scalars['ID']>;
  /** Unique identifier for the warehouse e.g uuid */
  warehouseId: Scalars['ID'];
};

/** Autogenerated return type of MarkItemsAsBulkPickedMutation. */
export type GMarkItemsAsBulkPickedMutationPayload = {
  __typename?: 'MarkItemsAsBulkPickedMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  userErrors: Array<GBulkItemError>;
};

/** Autogenerated input type of MarkItemsAsEcomBulkMutation */
export type GMarkItemsAsEcomBulkMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** True to add the items to the ECOM bulk list, false to remove them */
  isEcomBulk: Scalars['Boolean'];
  /** A list of item ids e.g uuids */
  itemIds: Array<Scalars['ID']>;
  /** Unique identifier for the warehouse e.g uuid */
  warehouseId: Scalars['ID'];
};

/** Autogenerated return type of MarkItemsAsEcomBulkMutation. */
export type GMarkItemsAsEcomBulkMutationPayload = {
  __typename?: 'MarkItemsAsEcomBulkMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  userErrors: Array<GBulkItemError>;
};

/** Autogenerated input type of MarkRouteForProvider */
export type GMarkRouteForProviderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** When the courier should collect. Omitted or null means ASAP at push time. */
  pickupAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The provider to mark the route for. */
  provider: GThirdPartyProvider;
  /** The route to mark. */
  routeId: Scalars['ID'];
};

/** Autogenerated return type of MarkRouteForProvider. */
export type GMarkRouteForProviderPayload = {
  __typename?: 'MarkRouteForProviderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  route?: Maybe<GRoute>;
  userErrors: Array<GThirdPartyDispatchError>;
};

export type GMarketingQrCode = {
  __typename?: 'MarketingQrCode';
  /** SVG download URL for the QR code */
  downloadUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  micrositeLocation?: Maybe<GMicrositeLocation>;
  /** PNG download URL for the QR code (generated on first access) */
  pngDownloadUrl?: Maybe<Scalars['String']>;
  /** Final destination, without the utmMedium. */
  redirectUrl?: Maybe<Scalars['String']>;
  sequenceNumber: Scalars['ID'];
  staticUrl: Scalars['String'];
  /** E.g. sign, coaster, etc. */
  utmMedium?: Maybe<Scalars['String']>;
};

export type GMarketingQrCodeBulkUpdateResult = {
  __typename?: 'MarketingQrCodeBulkUpdateResult';
  /** Any errors that occured */
  errors: Array<Scalars['String']>;
  qrCode?: Maybe<GMarketingQrCode>;
  rowNumber: Scalars['Int'];
};

/** The connection type for MarketingQrCode. */
export type GMarketingQrCodeConnection = {
  __typename?: 'MarketingQrCodeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GMarketingQrCodeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GMarketingQrCode>>>;
  /** Information to aid in pagination. */
  pageInfo: GPageInfo;
  /** The total count of records in the connection. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type GMarketingQrCodeEdge = {
  __typename?: 'MarketingQrCodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GMarketingQrCode>;
};

export type GMarketingQrScan = {
  __typename?: 'MarketingQrScan';
  /** Final destination, without the utmMedium. */
  redirectUrl?: Maybe<Scalars['String']>;
  /** E.g. sign, coaster, etc. */
  utmMedium?: Maybe<Scalars['String']>;
};

export type GMasterHomepage = {
  __typename?: 'MasterHomepage';
  endDate: Scalars['ISO8601Date'];
  id: Scalars['ID'];
  name: Scalars['String'];
  rows: Array<GMasterHomepageRow>;
  startDate: Scalars['ISO8601Date'];
};

export type GMasterHomepageError = {
  __typename?: 'MasterHomepageError';
  field?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

export type GMasterHomepageFilterInput = {
  date?: InputMaybe<Scalars['ISO8601Date']>;
  warehouseId: Scalars['ID'];
};

export type GMasterHomepageListItem = {
  __typename?: 'MasterHomepageListItem';
  endDate: Scalars['ISO8601Date'];
  id: Scalars['ID'];
  name: Scalars['String'];
  startDate: Scalars['ISO8601Date'];
};

export type GMasterHomepageRow = {
  __typename?: 'MasterHomepageRow';
  components: Array<GMasterHomepageRowComponent>;
  id: Scalars['ID'];
  sortOrder: Scalars['Int'];
  structureType: GMasterHomepageRowStructureType;
};

export type GMasterHomepageRowComponent = {
  __typename?: 'MasterHomepageRowComponent';
  catalogComponentId: Scalars['ID'];
  collection?: Maybe<GCollection>;
  collectionId: Scalars['ID'];
  componentType: GMasterHomepageRowStructureType;
  desktopImage?: Maybe<Scalars['String']>;
  desktopImageUrl?: Maybe<Scalars['String']>;
  endDate: Scalars['ISO8601Date'];
  fontStyle?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  mobileImage?: Maybe<Scalars['String']>;
  mobileImageUrl?: Maybe<Scalars['String']>;
  sortOrder: Scalars['Int'];
  startDate: Scalars['ISO8601Date'];
  warehouseIds: Array<Scalars['ID']>;
};

export enum GMasterHomepageRowStructureType {
  CollectionBanner = 'collectionBanner',
  CollectionCarousel = 'collectionCarousel',
  CollectionHighlightCarousel = 'collectionHighlightCarousel',
  NewItemsCarousel = 'newItemsCarousel',
  TrendingItemsCarousel = 'trendingItemsCarousel'
}

/** Error indicating that the order would take the location past an item's lifetime limit. */
export type GMaxQuantityExceededError = GError & {
  __typename?: 'MaxQuantityExceededError';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Menu. */
export type GMenu = GNode & {
  __typename?: 'Menu';
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
  /** Menu's current lock version, providing concurrency control and protection against stale updates. */
  lockVersion: Scalars['Int'];
  /** Name. */
  name: Scalars['String'];
  /** The order of the menu in the UI. */
  sortOrder: Scalars['Int'];
  /** Submenus. */
  submenus: Array<GSubmenu>;
  /** Visibility. */
  visibility: GVisibility;
};

/** Menu item. */
export type GMenuItem = GNode & {
  __typename?: 'MenuItem';
  /** Description. */
  description: Scalars['String'];
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
  /** Menu item's current lock version, providing concurrency control and protection against stale updates. */
  lockVersion: Scalars['Int'];
  /** Modifier groups for the menu item. */
  menuItemModifierGroups: Array<GMenuItemModifierGroup>;
  /** Menu item sizes. */
  menuItemSizes: Array<GMenuItemSize>;
  /** Name. */
  name: Scalars['String'];
  /** The order of the menu item in the UI. */
  sortOrder: Scalars['Int'];
  /** UUID. */
  uuid: Scalars['ID'];
  /** Visibility. */
  visibility: GVisibility;
};

/** Menu item modifier group. */
export type GMenuItemModifierGroup = GNode & {
  __typename?: 'MenuItemModifierGroup';
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
  /** Maximum selections. */
  maximumSelections?: Maybe<Scalars['Int']>;
  /** Menu item modifier options for this group. */
  menuItemModifierOptions: Array<GMenuItemModifierOption>;
  /** Minimum selections. */
  minimumSelections: Scalars['Int'];
  /** Name. */
  name: Scalars['String'];
};

/** Menu item modifier option. */
export type GMenuItemModifierOption = GNode & {
  __typename?: 'MenuItemModifierOption';
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
  /** Name. */
  name: Scalars['String'];
  /** Price. */
  price: GMoney;
};

/** MenuItem mutation result. */
export type GMenuItemResult = GErrorsResult | GMenuItemSuccess;

/** Menu item size. */
export type GMenuItemSize = GNode & {
  __typename?: 'MenuItemSize';
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
  /** Name. */
  name: Scalars['String'];
  /** Unit price. */
  price: GMoney;
  /** UUID. */
  uuid: Scalars['ID'];
};

/** Input for a menu item size. */
export type GMenuItemSizeInput = {
  /** Name of the size */
  name: Scalars['String'];
  /** Price */
  price: GMoneyInput;
  /** UUID. Include this when updating an existing size. */
  uuid?: InputMaybe<Scalars['ID']>;
};

/** Result of a successful menu-item mutation. */
export type GMenuItemSuccess = {
  __typename?: 'MenuItemSuccess';
  /** Resulting menu-item. */
  menuItem: GMenuItem;
};

export type GMenuItemsForMerchant = {
  __typename?: 'MenuItemsForMerchant';
  /** List of relevant menu items belonging to merchant. */
  menuItems: Array<GMenuItem>;
  /** Merchant. */
  merchant: GMerchant;
};

/** Result of mutating a list of menu items. */
export type GMenuItemsResult = GErrorsResult | GMenuItemsSuccess;

/** Result of successfully mutating a list of menu items. */
export type GMenuItemsSuccess = {
  __typename?: 'MenuItemsSuccess';
  /** Resulting menu-items. */
  menuItems: Array<GMenuItem>;
};

/** Menu mutation result. */
export type GMenuResult = GErrorsResult | GMenuSuccess;

/** Result of a successful menu mutation. */
export type GMenuSuccess = {
  __typename?: 'MenuSuccess';
  /** Resulting menu. */
  menu: GMenu;
};

/** Result of mutating a list of menus. */
export type GMenusResult = GErrorsResult | GMenusSuccess;

/** Result of successfully mutating a list of menus. */
export type GMenusSuccess = {
  __typename?: 'MenusSuccess';
  /** Resulting menus. */
  menus: Array<GMenu>;
};

/** Merchant. */
export type GMerchant = GNode & {
  __typename?: 'Merchant';
  /** Top-level company the merchant belongs to. */
  business: GBusiness;
  /** Cover photo URLs. */
  coverPhotoUrls: Array<Scalars['String']>;
  /** Whether curbside pickup is offered. */
  curbsidePickup: Scalars['Boolean'];
  /** The primary key from the database. */
  databaseId: Scalars['Int'];
  /** Display address */
  displayAddress: Scalars['String'];
  /** Full address */
  fullAddress: Scalars['String'];
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
  /** Latitude. */
  latitude: Scalars['Float'];
  /** Merchant's current lock version, providing concurrency control and protection against stale updates. */
  lockVersion: Scalars['Int'];
  /** Logo URL. */
  logoUrl?: Maybe<Scalars['String']>;
  /** Longitude. */
  longitude: Scalars['Float'];
  /** Menus. */
  menus: Array<GMenu>;
  /** Minimum notice an order can be placed in advance of its pickup time. */
  minimumNotice: GRelativeTime;
  /** Modifier groups. */
  modifierGroups: Array<GModifierGroup>;
  /** Name */
  name: Scalars['String'];
  /** In-app notification sound */
  notificationSound: Scalars['String'];
  /** Hours of operation in merchant's time zone. Order pickup times cannot be outside the bounds described by these hours. */
  operatingHours: Array<GOperatingHoursForDayOfWeek>;
  /** Operating status info. */
  operatingStatus: GMerchantOperatingStatus;
  /** Maximum number of days an order can be placed in advance of its pickup time. */
  orderAheadNumDays: Scalars['Int'];
  /** Order queue. */
  orderQueue: GOrderQueue;
  /** Phone number. */
  phone?: Maybe<Scalars['String']>;
  /** @deprecated See the minimumNotice field instead. */
  pickupDelayMinutes: Scalars['Int'];
  /** Pickup text. */
  pickupText?: Maybe<Scalars['String']>;
  /** Street address */
  streetAddress: Scalars['String'];
  /** Time zone. */
  timezone: Scalars['String'];
  /** Whether tips are enabled. */
  tipsEnabled: Scalars['Boolean'];
};


/** Merchant. */
export type GMerchantMenusArgs = {
  includeEmpty?: InputMaybe<Scalars['Boolean']>;
  includeHidden?: InputMaybe<Scalars['Boolean']>;
};


/** Merchant. */
export type GMerchantOrderQueueArgs = {
  asOf?: InputMaybe<Scalars['ISO8601DateTime']>;
};

/** Merchant app viewer information. */
export type GMerchantAppUser = {
  __typename?: 'MerchantAppUser';
  /** Email. Null if client authenticated using Auth0. Such clients should get the email from the Auth0-issued ID token instead. */
  email?: Maybe<Scalars['String']>;
  /** Fetches a merchant given its ID */
  merchant?: Maybe<GMerchant>;
  /** Merchants the current user is authorized to access */
  merchants: GMerchantConnection;
};


/** Merchant app viewer information. */
export type GMerchantAppUserMerchantArgs = {
  id: Scalars['ID'];
};


/** Merchant app viewer information. */
export type GMerchantAppUserMerchantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Error indicating that a mutation failed because the merchant is closed at the requested time. */
export type GMerchantClosureError = GError & {
  __typename?: 'MerchantClosureError';
  /** A description of the error. */
  message: Scalars['String'];
};

export type GMerchantClosureInterval = GAvailabilityInterval & {
  __typename?: 'MerchantClosureInterval';
  /** Lower bound. */
  lowerBound: Scalars['ISO8601DateTime'];
  /** Upper bound. */
  upperBound: Scalars['ISO8601DateTime'];
};

/** The connection type for Merchant. */
export type GMerchantConnection = {
  __typename?: 'MerchantConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GMerchantEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GMerchant>>>;
  /** Information to aid in pagination. */
  pageInfo: GPageInfo;
};

/** An edge in a connection. */
export type GMerchantEdge = {
  __typename?: 'MerchantEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GMerchant>;
};

/** Error indicating that a mutation failed because the merchant is not active. */
export type GMerchantNotActive = GError & {
  __typename?: 'MerchantNotActive';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Input for updating a merchant's operating hours on day. */
export type GMerchantOperatingHoursForDayOfWeekInput = {
  /** Operating hours intervals. May spill over into the following day. */
  intervals: Array<GOperatingHoursIntervalInput>;
};

/** Merchant operating status info. */
export type GMerchantOperatingStatus = {
  __typename?: 'MerchantOperatingStatus';
  /** Most-recently saved status. */
  lastSavedStatus: GMerchantStatusEnum;
  /** Next closing time. */
  nextClose?: Maybe<Scalars['ISO8601DateTime']>;
  /** Next opening time. */
  nextOpen?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Merchant mutation result. */
export type GMerchantResult = GErrorsResult | GMerchantSuccess;

/** The possible states a merchant's status can return */
export enum GMerchantStatusEnum {
  /** Busy. */
  Busy = 'busy',
  /** Closed. */
  Closed = 'closed',
  /** Open. */
  Open = 'open'
}

/** Result of a successful merchant mutation. */
export type GMerchantSuccess = {
  __typename?: 'MerchantSuccess';
  /** Resulting merchant. */
  merchant: GMerchant;
};

/**
 * Meta advertising identifiers observed in the browser during signup, used to
 * attribute the signup to the ad click that produced it.
 */
export type GMetaTrackingInput = {
  /** Identifier shared with the browser's conversion event so Meta counts the two as one conversion rather than two. */
  eventId?: InputMaybe<Scalars['String']>;
  /** URL of the page the signup was completed on. */
  eventSourceUrl?: InputMaybe<Scalars['String']>;
  /** Value of the _fbc cookie, or one derived from the fbclid parameter on the landing URL, identifying the ad click. */
  fbc?: InputMaybe<Scalars['String']>;
  /** Value of the _fbp cookie, which the Meta Pixel sets to identify the browser. */
  fbp?: InputMaybe<Scalars['String']>;
};

export type GMetrobiAssignmentBlocked = GUserErrorInterface & {
  __typename?: 'MetrobiAssignmentBlocked';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  offenders: Array<GMetrobiExcludedStop>;
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** A selected stop whose location or company is excluded from Metrobi. */
export type GMetrobiExcludedStop = {
  __typename?: 'MetrobiExcludedStop';
  address?: Maybe<Scalars['String']>;
  businessName?: Maybe<Scalars['String']>;
  locationId: Scalars['ID'];
  stopId: Scalars['ID'];
};

/** Represents an action that can be performed on a microsite location. */
export type GMicrositeAction = {
  __typename?: 'MicrositeAction';
  /** URL of the background image */
  backgroundImageUrl?: Maybe<Scalars['String']>;
  /** Background color of the button for the action */
  buttonBackgroundColor?: Maybe<Scalars['String']>;
  /** Text color of the action button */
  buttonTextColor?: Maybe<Scalars['String']>;
  /** Content to be displayed in the modal or link, if applicable */
  content?: Maybe<Scalars['String']>;
  /** How the action should be displayed, e.g., 'modal', 'link' etc. */
  displayType?: Maybe<Scalars['String']>;
  /** Unique identifier for the action */
  id: Scalars['ID'];
  /** Name of the action */
  name?: Maybe<Scalars['String']>;
  /** Boolean to determine if the link should be opened in a new window */
  openInNewWindow?: Maybe<Scalars['Boolean']>;
  /** URL to perform the action, like a WiFi login page or review page */
  url?: Maybe<Scalars['String']>;
};

export type GMicrositeActionInput = {
  backgroundImageUrl?: InputMaybe<Scalars['String']>;
  buttonBackgroundColor?: InputMaybe<Scalars['String']>;
  buttonTextColor?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  displayType: Scalars['String'];
  name: Scalars['String'];
  openInNewWindow: Scalars['Boolean'];
  url?: InputMaybe<Scalars['String']>;
};

export type GMicrositeActionsInput = {
  actions?: InputMaybe<Array<GMicrositeActionInput>>;
  visible: Scalars['Boolean'];
};

export type GMicrositeAdInfoInput = {
  /** Image URL for the WiFi/Restroom ad */
  adImageUrl: Scalars['String'];
  /** Link to the WiFi/Restroom ad */
  adLink: Scalars['String'];
};

/** Represents a barista profile for a microsite location. */
export type GMicrositeBaristaProfile = {
  __typename?: 'MicrositeBaristaProfile';
  /** Barista link address: Link address for the barista */
  baristaLinkAddress?: Maybe<Scalars['String']>;
  /** Barista link title: Title for the barista's link */
  baristaLinkTitle?: Maybe<Scalars['String']>;
  /** Blurb or bio: Text about the barista */
  bio?: Maybe<Scalars['String']>;
  /** First name: name of the barista */
  firstName: Scalars['String'];
  /** Unique identifier for the barista profile */
  id: Scalars['ID'];
  /** Image url: Url of the image of the barista */
  imageUrl?: Maybe<Scalars['String']>;
  /** Pronouns: Pronouns of the barista */
  pronouns?: Maybe<Scalars['String']>;
};

export type GMicrositeBusinessProfileInput = {
  businessAddress?: InputMaybe<Scalars['String']>;
  businessName?: InputMaybe<Scalars['String']>;
  fridayHours?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  /** Logo URL. This can be any URL. */
  logoUrl?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['Float']>;
  mondayHours?: InputMaybe<Scalars['String']>;
  saturdayHours?: InputMaybe<Scalars['String']>;
  sundayHours?: InputMaybe<Scalars['String']>;
  thursdayHours?: InputMaybe<Scalars['String']>;
  tuesdayHours?: InputMaybe<Scalars['String']>;
  wednesdayHours?: InputMaybe<Scalars['String']>;
};

/** Represents a calendar event for a microsite location. */
export type GMicrositeCalendarEvent = {
  __typename?: 'MicrositeCalendarEvent';
  /** Copy for the action button associated with the event */
  actionButtonCopy?: Maybe<Scalars['String']>;
  /** Date of the calendar event */
  date: Scalars['ISO8601Date'];
  /** Description of the calendar event */
  description?: Maybe<Scalars['String']>;
  /** The address to display for the event */
  displayAddress: Scalars['String'];
  /** End time of the calendar event (HH:MM format) */
  endTime?: Maybe<Scalars['String']>;
  /** Unique identifier for the calendar event */
  id: Scalars['ID'];
  /** URL of the image associated with the calendar event */
  imageUrl?: Maybe<Scalars['String']>;
  /** Google Maps URL for the event location */
  locationUrl?: Maybe<Scalars['String']>;
  /** Link for RSVPing to the calendar event */
  rsvpLink?: Maybe<Scalars['String']>;
  /** Start time of the calendar event (HH:MM format) */
  time?: Maybe<Scalars['String']>;
  /** Title of the calendar event */
  title: Scalars['String'];
};

export type GMicrositeCalendarEventItemInput = {
  buttonCopy?: InputMaybe<Scalars['String']>;
  date: Scalars['ISO8601Date'];
  description: Scalars['String'];
  displayAddress: Scalars['String'];
  /** End time in HH:MM format (optional) */
  endTime?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  locationUrl?: InputMaybe<Scalars['String']>;
  rsvpLink?: InputMaybe<Scalars['String']>;
  /** Start time in HH:MM format */
  time?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type GMicrositeCalendarEventsInput = {
  events?: InputMaybe<Array<GMicrositeCalendarEventItemInput>>;
  visible: Scalars['Boolean'];
};

/** Check-in to win module configuration */
export type GMicrositeCheckInConfig = {
  __typename?: 'MicrositeCheckInConfig';
  /** Description of the prize/contest */
  description?: Maybe<Scalars['String']>;
  /** When the module was last disabled */
  disabledAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Whether the module is currently enabled */
  enabled: Scalars['Boolean'];
  /** When the module was last enabled */
  enabledAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** URL to view the check-in contacts in the unified contacts sheet */
  googleSheetUrl?: Maybe<Scalars['String']>;
  /** Unique identifier for the config */
  id: Scalars['ID'];
  /** URL of the prize image */
  imageUrl?: Maybe<Scalars['String']>;
  /** Maximum total winners allowed (nil = unlimited) */
  maxTotalWinners?: Maybe<Scalars['Int']>;
  /** Maximum winners allowed per day (nil = unlimited) */
  maxWinnersPerDay?: Maybe<Scalars['Int']>;
  /** The microsite location this config belongs to */
  micrositeLocationId: Scalars['ID'];
  /** Name of the prize */
  prizeName: Scalars['String'];
  /** When terms were accepted */
  termsAcceptedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Title of the check-in module */
  title: Scalars['String'];
  /** Probability of winning (0.0 to 1.0) */
  winProbability: Scalars['Float'];
};

export type GMicrositeCheckInInput = {
  /** Description of the prize/contest */
  description?: InputMaybe<Scalars['String']>;
  /** URL of the prize image */
  imageUrl?: InputMaybe<Scalars['String']>;
  /** Maximum total winners allowed (null = unlimited) */
  maxTotalWinners?: InputMaybe<Scalars['Int']>;
  /** Maximum winners allowed per day (null = unlimited) */
  maxWinnersPerDay?: InputMaybe<Scalars['Int']>;
  /** Name of the prize */
  prizeName: Scalars['String'];
  /** When terms were accepted */
  termsAcceptedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Title of the check-in module */
  title: Scalars['String'];
  /** Whether the check-in to win module is visible on the microsite */
  visible: Scalars['Boolean'];
  /** Probability of winning (0.0 to 1.0) */
  winProbability: Scalars['Float'];
};

export type GMicrositeCoffeeGrindInput = {
  visible: Scalars['Boolean'];
};

/** A guest contact for a microsite location */
export type GMicrositeContact = {
  __typename?: 'MicrositeContact';
  createdAt: Scalars['ISO8601DateTime'];
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  micrositeLocationId: Scalars['ID'];
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type GMicrositeContactInput = {
  /** Business contact email address */
  email?: InputMaybe<Scalars['String']>;
  /** Business contact phone number */
  phoneNumber?: InputMaybe<Scalars['String']>;
  /** Whether the contact module is visible on the microsite */
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type GMicrositeCuppyInput = {
  visible: Scalars['Boolean'];
};

export type GMicrositeLocation = {
  __typename?: 'MicrositeLocation';
  /** List of actions available for the microsite location. */
  actions: Array<GMicrositeAction>;
  /** List of barista profiles associated with the microsite location. */
  baristaProfiles: Array<GMicrositeBaristaProfile>;
  /** List of calendar events for the microsite location. */
  calendarEvents: Array<GMicrositeCalendarEvent>;
  /** Check-in configuration for the microsite location. */
  checkInConfig?: Maybe<GMicrositeCheckInConfig>;
  /** Business contact email for the microsite location. */
  contactEmail?: Maybe<Scalars['String']>;
  /** Business contact phone number for the microsite location. */
  contactPhone?: Maybe<Scalars['String']>;
  /** The current poll for the microsite location, if any. */
  currentPoll?: Maybe<GMicrositePoll>;
  /** All current active polls for the microsite location. */
  currentPolls: Array<GMicrositePoll>;
  /** List of enabled modules for the microsite location. */
  enabledModules: Array<GMicrositeModule>;
  /** Operating hours for Friday. */
  fridayHours?: Maybe<Scalars['String']>;
  /** Link to the Google reviews for the microsite location. */
  googleReviewLink?: Maybe<Scalars['String']>;
  /** URL to the unified contacts Google Sheet for this location. */
  googleSheetUrl?: Maybe<Scalars['String']>;
  /** The URL of the hero image for the microsite location. */
  heroImageUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  latitude?: Maybe<Scalars['Float']>;
  /** The URL of the logo for the microsite location. */
  logoUrl?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['Float']>;
  /** Mailing list configuration for the microsite location. */
  mailingList?: Maybe<GMicrositeMailingList>;
  /** Media sections for the microsite location. */
  mediaSections: Array<GMicrositeMediaSection>;
  /** List of menu items associated with the microsite location. */
  menuItems: Array<GMicrositeMenuItem>;
  /** List of messages associated with the microsite location. */
  messages: Array<GMicrositeMessage>;
  /** Operating hours for Monday. */
  mondayHours?: Maybe<Scalars['String']>;
  /** Photobooth configuration for the microsite location. */
  photoboothConfig?: Maybe<GMicrositePhotoboothConfig>;
  /** List of all polls associated with the microsite location. */
  polls: Array<GMicrositePoll>;
  /** List of posts associated with the microsite location. */
  posts: Array<GMicrositePost>;
  /** The QR code for this microsite location. */
  qrCode?: Maybe<GMarketingQrCode>;
  /** List of relevant reviews for the microsite location. */
  relevantReviews?: Maybe<Array<GMicrositeRelevantReview>>;
  /** Restroom code information for the microsite location. */
  restroomCode?: Maybe<GMicrositeRestroom>;
  /** Operating hours for Saturday. */
  saturdayHours?: Maybe<Scalars['String']>;
  /** The subtitle of the microsite location. */
  siteSubtitle?: Maybe<Scalars['String']>;
  /** The title of the microsite location. */
  siteTitle?: Maybe<Scalars['String']>;
  /** List of social media platforms associated with the microsite location. */
  socialPlatforms: Array<GMicrositeSocialPlatform>;
  /** Suggestion box configuration for the microsite location. */
  suggestionConfig?: Maybe<GMicrositeSuggestionConfig>;
  /** Operating hours for Sunday. */
  sundayHours?: Maybe<Scalars['String']>;
  /** The title for the team profile section if the module is enabled */
  teamProfileSectionTitle?: Maybe<Scalars['String']>;
  /** Theme information for the microsite location. */
  theme?: Maybe<GMicrositeTheme>;
  /** The theme color for the microsite location. */
  themeColor?: Maybe<Scalars['String']>;
  /** Operating hours for Thursday. */
  thursdayHours?: Maybe<Scalars['String']>;
  timeZone: GMicrositeTimeZone;
  /** Operating hours for Tuesday. */
  tuesdayHours?: Maybe<Scalars['String']>;
  urlId: Scalars['String'];
  /** Operating hours for Wednesday. */
  wednesdayHours?: Maybe<Scalars['String']>;
  /** WiFi information for the microsite location. */
  wifiInfo?: Maybe<GMicrositeWifi>;
};

/** An admin-only view of a microsite location */
export type GMicrositeLocationAdmin = {
  __typename?: 'MicrositeLocationAdmin';
  /** Stream for the config document of the microsite location */
  configDocStream?: Maybe<GStream>;
  createdAt: Scalars['ISO8601DateTime'];
  /** Google Doc ID for the microsite location */
  googleDocId?: Maybe<Scalars['String']>;
  /** Google Doc URL for the microsite location */
  googleDocUrl?: Maybe<Scalars['String']>;
  /** Unique identifier for the microsite location */
  id: Scalars['ID'];
  /** UUID of the onboarded location, if the microsite is for an onboarded location */
  locationUuid?: Maybe<Scalars['ID']>;
  updatedAt: Scalars['ISO8601DateTime'];
  /** URL parameter value for the microsite location, like 'birch-14th' in `/microsite/birch-14th` */
  urlId: Scalars['ID'];
};

/** The connection type for MicrositeLocationAdmin. */
export type GMicrositeLocationAdminConnection = {
  __typename?: 'MicrositeLocationAdminConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GMicrositeLocationAdminEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GMicrositeLocationAdmin>>>;
  /** Information to aid in pagination. */
  pageInfo: GPageInfo;
  /** The total count of records in the connection. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type GMicrositeLocationAdminEdge = {
  __typename?: 'MicrositeLocationAdminEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GMicrositeLocationAdmin>;
};

/** Configuration and metadata for a microsite mailing list */
export type GMicrositeMailingList = {
  __typename?: 'MicrositeMailingList';
  buttonText?: Maybe<Scalars['String']>;
  collectEmail?: Maybe<Scalars['Boolean']>;
  collectFirstName?: Maybe<Scalars['Boolean']>;
  collectLastName?: Maybe<Scalars['Boolean']>;
  collectPhoneNumber?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['ISO8601DateTime'];
  googleSheetId?: Maybe<Scalars['String']>;
  /** URL to view the mailing list Google Sheet */
  googleSheetUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  micrositeLocationId: Scalars['ID'];
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type GMicrositeMailingListInput = {
  /** Text displayed on the submit button */
  buttonText?: InputMaybe<Scalars['String']>;
  /** Whether to collect email address from guests */
  collectEmail: Scalars['Boolean'];
  /** Whether to collect first name from guests */
  collectFirstName: Scalars['Boolean'];
  /** Whether to collect last name from guests */
  collectLastName: Scalars['Boolean'];
  /** Whether to collect phone number from guests */
  collectPhoneNumber: Scalars['Boolean'];
  /** URL of the image displayed with the mailing list form */
  imageUrl?: InputMaybe<Scalars['String']>;
  /** Subtitle text displayed on the mailing list form */
  subtitle?: InputMaybe<Scalars['String']>;
  /** Title text displayed on the mailing list form */
  title: Scalars['String'];
  /** Whether the mailing list module is visible on the microsite */
  visible: Scalars['Boolean'];
};

/** Input for updating the media module */
export type GMicrositeMediaInput = {
  /** Media sections to create/update. Sections not included will be deleted. */
  sections?: InputMaybe<Array<GMicrositeMediaSectionInput>>;
  /** Whether the media module is visible */
  visible: Scalars['Boolean'];
};

/** Represents an individual media item (image or video) within a media section. */
export type GMicrositeMediaItem = {
  __typename?: 'MicrositeMediaItem';
  /** Alt text for accessibility */
  altText?: Maybe<Scalars['String']>;
  /** Unique identifier for the media item */
  id: Scalars['ID'];
  /** Type of media: 'image' or 'video' */
  mediaType: Scalars['String'];
  /** Display order within the section (0-indexed) */
  position: Scalars['Int'];
  /** URL to the media file */
  url: Scalars['String'];
};

/** Input for an individual media item (image or video) */
export type GMicrositeMediaItemInput = {
  /** Alt text for accessibility */
  altText?: InputMaybe<Scalars['String']>;
  /** ID of existing item to update. Omit for new items. */
  id?: InputMaybe<Scalars['ID']>;
  /** Type of media: 'image' or 'video' */
  mediaType: Scalars['String'];
  /** URL to the media file */
  url: Scalars['String'];
};

/** Represents a media section (block) containing images or videos for a microsite location. */
export type GMicrositeMediaSection = {
  __typename?: 'MicrositeMediaSection';
  /** Unique identifier for the media section */
  id: Scalars['ID'];
  /** Media items within this section, ordered by position */
  mediaItems: Array<GMicrositeMediaItem>;
  /** Title of the media section */
  title: Scalars['String'];
};

/** Input for a media section (block) */
export type GMicrositeMediaSectionInput = {
  /** ID of existing section to update. Omit for new sections. */
  id?: InputMaybe<Scalars['ID']>;
  /** Media items within this section. Items not included will be deleted. */
  items?: InputMaybe<Array<GMicrositeMediaItemInput>>;
  /** Title for the media section */
  title: Scalars['String'];
};

/** Represents a menu item for a microsite location. */
export type GMicrositeMenuItem = {
  __typename?: 'MicrositeMenuItem';
  /** Category of the menu item */
  category?: Maybe<Scalars['String']>;
  /** Description of the menu item */
  description?: Maybe<Scalars['String']>;
  /** Unique identifier for the menu item */
  id: Scalars['ID'];
  /** Image URL for the menu item */
  imageUrl?: Maybe<Scalars['String']>;
  /** Name of the menu item */
  name?: Maybe<Scalars['String']>;
  /** Indicates if the menu item is popular */
  popular?: Maybe<Scalars['Boolean']>;
  /** Price of the menu item in US cents */
  priceUsCents?: Maybe<Scalars['Int']>;
  /** Weather categories applicable to the menu item */
  weatherCategories: Array<Scalars['String']>;
};

export type GMicrositeMenuItemInput = {
  category?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  /** Required for updates, leave blank for creates. */
  id?: InputMaybe<Scalars['ID']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  popular?: InputMaybe<Scalars['Boolean']>;
  priceUsCents?: InputMaybe<Scalars['Int']>;
  weatherCategories?: InputMaybe<Array<Scalars['String']>>;
};

/** Represents a message that can be sent to a microsite location. */
export type GMicrositeMessage = {
  __typename?: 'MicrositeMessage';
  /** Unique identifier for the message */
  id: Scalars['ID'];
  ip?: Maybe<Scalars['String']>;
  /** Content of the message */
  message?: Maybe<Scalars['String']>;
  /** Timestamp of when the message was updated in MTS */
  timestamp?: Maybe<Scalars['ISO8601DateTime']>;
};

/** The type of module that can be enabled for a microsite location. */
export enum GMicrositeModule {
  Actions = 'ACTIONS',
  BaristaProfiles = 'BARISTA_PROFILES',
  CalendarEvents = 'CALENDAR_EVENTS',
  CheckInToWin = 'CHECK_IN_TO_WIN',
  CoffeeGrind = 'COFFEE_GRIND',
  Contact = 'CONTACT',
  Cuppy = 'CUPPY',
  MailingList = 'MAILING_LIST',
  Media = 'MEDIA',
  Photobooth = 'PHOTOBOOTH',
  PollOfTheDay = 'POLL_OF_THE_DAY',
  RelevantReviews = 'RELEVANT_REVIEWS',
  Restroom = 'RESTROOM',
  Socials = 'SOCIALS',
  SuggestedMenu = 'SUGGESTED_MENU',
  SuggestionBox = 'SUGGESTION_BOX',
  Wifi = 'WIFI'
}

/** Photobooth module configuration */
export type GMicrositePhotoboothConfig = {
  __typename?: 'MicrositePhotoboothConfig';
  /** Custom button text for the photobooth */
  buttonText?: Maybe<Scalars['String']>;
  /** Unique identifier for the config */
  id: Scalars['ID'];
  /** URL of the module header image */
  imageUrl?: Maybe<Scalars['String']>;
  /** URL of the prompt image for AI generation */
  promptImageUrl?: Maybe<Scalars['String']>;
  /** Custom prompt text for AI image generation */
  promptText?: Maybe<Scalars['String']>;
};

export type GMicrositePhotoboothInput = {
  /** Custom button text for the photobooth */
  buttonText?: InputMaybe<Scalars['String']>;
  /** URL of the module header image */
  imageUrl?: InputMaybe<Scalars['String']>;
  /** URL of the prompt image for AI generation */
  promptImageUrl?: InputMaybe<Scalars['String']>;
  /** Custom prompt text for AI image generation */
  promptText?: InputMaybe<Scalars['String']>;
  /** Whether the photobooth module is visible on the microsite */
  visible: Scalars['Boolean'];
};

export type GMicrositePoll = {
  __typename?: 'MicrositePoll';
  /** @deprecated Use 'answers' field instead */
  answer1: Scalars['String'];
  /** @deprecated Use 'answers' field instead */
  answer2: Scalars['String'];
  answers: Array<GMicrositePollAnswerObject>;
  endDate: Scalars['ISO8601Date'];
  id: Scalars['ID'];
  question: Scalars['String'];
  startDate: Scalars['ISO8601Date'];
  /** @deprecated Use 'answers' field instead */
  votes1: Scalars['Int'];
  /** @deprecated Use 'answers' field instead */
  votes2: Scalars['Int'];
};

export enum GMicrositePollAnswer {
  /** The first answer option for the poll */
  Answer1 = 'ANSWER1',
  /** The second answer option for the poll */
  Answer2 = 'ANSWER2'
}

export type GMicrositePollAnswerInput = {
  /** ID for existing answers (omit for new answers) */
  id?: InputMaybe<Scalars['ID']>;
  text: Scalars['String'];
};

export type GMicrositePollAnswerObject = {
  __typename?: 'MicrositePollAnswerObject';
  id: Scalars['ID'];
  position: Scalars['Int'];
  text: Scalars['String'];
  votes: Scalars['Int'];
};

export type GMicrositePollItemInput = {
  /** Array of poll answers (use this for new frontend) */
  answers?: InputMaybe<Array<GMicrositePollAnswerInput>>;
  endDate: Scalars['ISO8601Date'];
  id?: InputMaybe<Scalars['ID']>;
  question: Scalars['String'];
  startDate: Scalars['ISO8601Date'];
};

export type GMicrositePollsInput = {
  polls?: InputMaybe<Array<GMicrositePollItemInput>>;
  visible: Scalars['Boolean'];
};

/** Represents a post on a microsite location from the location's management, for instance about an upcoming event. */
export type GMicrositePost = {
  __typename?: 'MicrositePost';
  /** Body content of the post */
  body?: Maybe<Scalars['String']>;
  /** Date of the post */
  date?: Maybe<Scalars['ISO8601Date']>;
  /** Unique identifier for the post */
  id: Scalars['ID'];
  /** Title of the post */
  title?: Maybe<Scalars['String']>;
  /** URL for the CTA of the post */
  url?: Maybe<Scalars['String']>;
};

export type GMicrositeRelevantReview = {
  __typename?: 'MicrositeRelevantReview';
  /** Date when the review was written. */
  date?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['ID'];
  /** Name of the reviewer. */
  name?: Maybe<Scalars['String']>;
  /** URL of the reviewer's profile image. */
  profileImage?: Maybe<Scalars['String']>;
  /** Rating given by the reviewer. */
  rating?: Maybe<Scalars['Int']>;
  /** Content of the review. */
  review?: Maybe<Scalars['String']>;
  /** Subtitle or additional information about the reviewer. */
  subtitle?: Maybe<Scalars['String']>;
};

export type GMicrositeRelevantReviewInput = {
  googleReviewLink: Scalars['String'];
  reviews?: InputMaybe<Array<GMicrositeRelevantReviewItemInput>>;
};

export type GMicrositeRelevantReviewItemInput = {
  date?: InputMaybe<Scalars['ISO8601Date']>;
  name?: InputMaybe<Scalars['String']>;
  profileImageUrl?: InputMaybe<Scalars['String']>;
  rating?: InputMaybe<Scalars['Int']>;
  review?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
};

export type GMicrositeRelevantReviewsModuleInput = {
  visible: Scalars['Boolean'];
};

export type GMicrositeRestroom = {
  __typename?: 'MicrositeRestroom';
  adImage?: Maybe<Scalars['String']>;
  adLink?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type GMicrositeRestroomInput = {
  code?: InputMaybe<Scalars['String']>;
  visible: Scalars['Boolean'];
};

export type GMicrositeScansData = {
  __typename?: 'MicrositeScansData';
  businessName?: Maybe<Scalars['String']>;
  formattedAddress?: Maybe<Scalars['String']>;
  last7Days: GMicrositeScansTimePeriod;
  last14Days: GMicrositeScansTimePeriod;
  last30Days: GMicrositeScansTimePeriod;
};

export type GMicrositeScansTimePeriod = {
  __typename?: 'MicrositeScansTimePeriod';
  /** Percent change in scan count since the previous period. Null if the previous period had no scans. */
  percentChange?: Maybe<Scalars['Float']>;
  /** Total number of scans that occurred during the time period, summed across all QR codes tied to the microsite location. */
  scanCount: Scalars['Int'];
};

/** Represents a social platform associated with a microsite location. */
export type GMicrositeSocialPlatform = {
  __typename?: 'MicrositeSocialPlatform';
  /** Icon URL for the social platform */
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Name of the social platform */
  name?: Maybe<Scalars['String']>;
  /** URL of the social platform */
  url?: Maybe<Scalars['String']>;
};

export type GMicrositeSocialPlatformInput = {
  iconUrl?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  url: Scalars['String'];
};

export type GMicrositeSocialsInput = {
  socialPlatforms?: InputMaybe<Array<GMicrositeSocialPlatformInput>>;
  visible: Scalars['Boolean'];
};

export type GMicrositeSuggestedMenuInput = {
  visible: Scalars['Boolean'];
};

/** Suggestion box module configuration */
export type GMicrositeSuggestionConfig = {
  __typename?: 'MicrositeSuggestionConfig';
  /** Whether anonymous submissions are allowed */
  allowAnonymous: Scalars['Boolean'];
  /** Description of the suggestion box */
  description?: Maybe<Scalars['String']>;
  /** Google Sheet ID for submissions */
  googleSheetId?: Maybe<Scalars['String']>;
  /** URL to view the suggestion box contacts in the unified contacts sheet */
  googleSheetUrl?: Maybe<Scalars['String']>;
  /** Unique identifier for the config */
  id: Scalars['ID'];
  /** URL of the suggestion box image */
  imageUrl?: Maybe<Scalars['String']>;
  /** Subtitle of the suggestion box */
  subtitle?: Maybe<Scalars['String']>;
  /** Title of the suggestion box */
  title?: Maybe<Scalars['String']>;
};

export type GMicrositeSuggestionConfigInput = {
  /** Whether anonymous submissions are allowed */
  allowAnonymous: Scalars['Boolean'];
  /** Description of the suggestion box */
  description?: InputMaybe<Scalars['String']>;
  /** URL of the header image */
  imageUrl?: InputMaybe<Scalars['String']>;
  /** Subtitle of the suggestion box module */
  subtitle?: InputMaybe<Scalars['String']>;
  /** Title of the suggestion box module */
  title?: InputMaybe<Scalars['String']>;
  /** Whether the suggestion box module is visible on the microsite */
  visible: Scalars['Boolean'];
};

/** A suggestion box submission entry */
export type GMicrositeSuggestionEntry = {
  __typename?: 'MicrositeSuggestionEntry';
  /** Email of the submitter (if provided) */
  contactEmail?: Maybe<Scalars['String']>;
  /** Name of the submitter (if provided) */
  contactName?: Maybe<Scalars['String']>;
  /** When the suggestion was submitted */
  createdAt: Scalars['ISO8601DateTime'];
  /** The feedback text submitted */
  feedback: Scalars['String'];
  /** Unique identifier for the entry */
  id: Scalars['ID'];
  /** Whether the submission was anonymous */
  isAnonymous: Scalars['Boolean'];
  /** AI-classified sentiment (positive, negative, neutral) */
  sentiment: Scalars['String'];
  /** Confidence score from 0.0 to 1.0 */
  sentimentScore: Scalars['Float'];
};

export type GMicrositeTeamProfileItemInput = {
  bio?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<Scalars['String']>;
  linkTitle?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  pictureUrl?: InputMaybe<Scalars['String']>;
  pronouns?: InputMaybe<Scalars['String']>;
};

export type GMicrositeTeamProfilesInput = {
  profiles?: InputMaybe<Array<GMicrositeTeamProfileItemInput>>;
  /** Title for the team profile section */
  title?: InputMaybe<Scalars['String']>;
  visible: Scalars['Boolean'];
};

export type GMicrositeTheme = {
  __typename?: 'MicrositeTheme';
  backgroundColor?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  tertiaryColor?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
};

export type GMicrositeThemeInput = {
  backgroundColor?: InputMaybe<Scalars['String']>;
  primaryColor?: InputMaybe<Scalars['String']>;
  secondaryColor?: InputMaybe<Scalars['String']>;
  tertiaryColor?: InputMaybe<Scalars['String']>;
  textColor?: InputMaybe<Scalars['String']>;
};

/** Enum for our standard US zones. */
export enum GMicrositeTimeZone {
  AmericaAnchorage = 'AMERICA_ANCHORAGE',
  AmericaBoise = 'AMERICA_BOISE',
  AmericaChicago = 'AMERICA_CHICAGO',
  AmericaDenver = 'AMERICA_DENVER',
  AmericaLosAngeles = 'AMERICA_LOS_ANGELES',
  AmericaNewYork = 'AMERICA_NEW_YORK',
  AmericaPhoenix = 'AMERICA_PHOENIX',
  PacificHonolulu = 'PACIFIC_HONOLULU'
}

/** A Microsite Time Zone Option. Use to build select lists of time zones. */
export type GMicrositeTimeZoneOption = {
  __typename?: 'MicrositeTimeZoneOption';
  label: Scalars['String'];
  value: GMicrositeTimeZone;
};

export type GMicrositeUrlValidationResult = {
  __typename?: 'MicrositeUrlValidationResult';
  /** Error message if validation fails */
  errorMessage?: Maybe<Scalars['String']>;
  /** Whether the microsite URL is available */
  isValid: Scalars['Boolean'];
};

export type GMicrositeWifi = {
  __typename?: 'MicrositeWifi';
  adImage?: Maybe<Scalars['String']>;
  adLink?: Maybe<Scalars['String']>;
  disclaimerText?: Maybe<Scalars['String']>;
  emailFormHeaderText?: Maybe<Scalars['String']>;
  /** URL to view the WiFi contacts in the unified contacts sheet */
  googleSheetUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  networkName?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  requireEmailForAccess: Scalars['Boolean'];
};

export type GMicrositeWifiInput = {
  disclaimerText?: InputMaybe<Scalars['String']>;
  emailFormHeaderText?: InputMaybe<Scalars['String']>;
  networkName?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  requireEmailForAccess?: InputMaybe<Scalars['Boolean']>;
  visible: Scalars['Boolean'];
};

/** Sort direction for microsites */
export enum GMicrositesSortDirection {
  /** Ascending, nulls last. */
  Asc = 'ASC',
  /** Descending, nulls first. */
  Desc = 'DESC'
}

/** Sort key for microsites */
export enum GMicrositesSortKey {
  /** Sort by created_at */
  CreatedAt = 'CREATED_AT',
  /** Sort by url_id */
  UrlId = 'URL_ID'
}

export type GMismatchedOrderLine = {
  __typename?: 'MismatchedOrderLine';
  deliveredQuantity?: Maybe<Scalars['Int']>;
  fulfillmentQuantity?: Maybe<Scalars['Int']>;
  orderLineId: Scalars['ID'];
  recoveryQuantity?: Maybe<Scalars['Int']>;
};

export type GMissingQtyDelivered = GUserErrorInterface & {
  __typename?: 'MissingQtyDelivered';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** Error indicating that a modifier group's minimum/maximum selection bounds were violated. */
export type GModifierBoundsViolation = GError & {
  __typename?: 'ModifierBoundsViolation';
  /** MenuItemModifierGroup. */
  menuItemModifierGroup: GMenuItemModifierGroup;
  /** A description of the error. */
  message: Scalars['String'];
};

/** Modifier Group. */
export type GModifierGroup = {
  __typename?: 'ModifierGroup';
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
  /** Modifier Group's current lock version, providing concurrency control and protection against stale updates. */
  lockVersion: Scalars['Int'];
  modifierOptions: Array<GModifierOption>;
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
  /** Visibility. */
  visibility: GVisibility;
};

/** Modifier Group mutation result. */
export type GModifierGroupResult = GErrorsResult | GModifierGroupSuccess;

/** Result of a successful modifier group mutation. */
export type GModifierGroupSuccess = {
  __typename?: 'ModifierGroupSuccess';
  /** Resulting modifier group. */
  modifierGroup: GModifierGroup;
};

/** Result of mutating a list of modifier-groups. */
export type GModifierGroupsResult = GErrorsResult | GModifierGroupsSuccess;

/** Result of successfully mutating a list of modifier groups. */
export type GModifierGroupsSuccess = {
  __typename?: 'ModifierGroupsSuccess';
  /** Resulting modifier groups. */
  modifierGroups: Array<GModifierGroup>;
};

/** Modifier Group individual options. */
export type GModifierOption = {
  __typename?: 'ModifierOption';
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
  /** Modifier Option's current lock version, providing concurrency control and protection against stale updates. */
  lockVersion: Scalars['Int'];
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
  /** Visibility. */
  visibility: GVisibility;
};

/** Modifier Option mutation result. */
export type GModifierOptionResult = GErrorsResult | GModifierOptionSuccess;

/** Result of a successful modifier option mutation. */
export type GModifierOptionSuccess = {
  __typename?: 'ModifierOptionSuccess';
  /** Resulting modifier option. */
  modifierOption: GModifierOption;
};

/** Result of mutating a list of modifier-options. */
export type GModifierOptionsResult = GErrorsResult | GModifierOptionsSuccess;

/** Result of successfully mutating a list of modifier options. */
export type GModifierOptionsSuccess = {
  __typename?: 'ModifierOptionsSuccess';
  /** Resulting modifier options. */
  modifierOptions: Array<GModifierOption>;
};

/** Money. */
export type GMoney = {
  __typename?: 'Money';
  /** The monetary value, represented with two or four decimal digits of precision. */
  amount?: Maybe<Scalars['Decimal']>;
  /** Cents. */
  cents: Scalars['Int'];
  currency: GCurrency;
  /** International 3-letter currency code (e.g. "USD") as defined by the ISO 4217 standard. */
  currencyISO: Scalars['String'];
};

export type GMoneyInput = {
  /** The monetary value, represented with two or four decimal digits of precision. */
  amount?: InputMaybe<Scalars['Decimal']>;
  /** Cents. */
  cents: Scalars['Int'];
  /** International 3-letter currency code (e.g. "USD") as defined by the ISO 4217 standard. */
  currencyISO: Scalars['String'];
};

/** Autogenerated input type of MoveDeliveryStopsToCustomerPickup */
export type GMoveDeliveryStopsToCustomerPickupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** IDs of the delivery stops to move into the customer-pickup bucket. */
  stopIds: Array<Scalars['ID']>;
};

/** Autogenerated return type of MoveDeliveryStopsToCustomerPickup. */
export type GMoveDeliveryStopsToCustomerPickupPayload = {
  __typename?: 'MoveDeliveryStopsToCustomerPickupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  updatedRoutes?: Maybe<Array<GRoute>>;
  userErrors: Array<GDeliveryRouteStopError>;
};

/**
 * Error indicating that a mutation failed because cart prices need to be
 * recalculated. This can occur when attempting to checkout with a different
 * payment method than was used during the last price calculation (since payment
 * method can affect service fees), or if an item or modifier has changed price
 * since being added to the cart.
 */
export type GMustRecalculateCartPrices = GError & {
  __typename?: 'MustRecalculateCartPrices';
  /** A description of the error. */
  message: Scalars['String'];
};

export type GMutation = {
  __typename?: 'Mutation';
  /** Submit email to access WiFi credentials */
  accessWifi?: Maybe<GAccessWifiMutationPayload>;
  acknowledgeBackInStockNotification?: Maybe<GAcknowledgeBackInStockNotificationMutationPayload>;
  /** Acknowledge a consumer order */
  acknowledgeConsumerOrder?: Maybe<GAcknowledgeConsumerOrderPayload>;
  acknowledgeDeliveryInstructionReview?: Maybe<GAcknowledgeDeliveryInstructionReviewMutationPayload>;
  /** Marks the provided driver safety acknowledgement as acknowledged by the current driver. */
  acknowledgeDriverSafetyAcknowledgement?: Maybe<GDriverSafetyAcknowledgementAcknowledgePayload>;
  /**
   * Creates a one-off ops appointment — against a known PO (which moves that PO's
   * existing booking if it already has one elsewhere) or, with no PO on file, a
   * minimum-info walk-in booking.
   */
  adHocAppointmentCreate?: Maybe<GAdHocAppointmentCreatePayload>;
  /** Add a favorite consumer order. */
  addFavoriteConsumerOrder?: Maybe<GAddFavoriteConsumerOrderPayload>;
  /** Add items to cart. */
  addItemsToCart?: Maybe<GAddItemsToCartPayload>;
  /** Add a new microsite. */
  addMicrositeLocation?: Maybe<GAddMicrositeMutationPayload>;
  /**
   * Applies a stop-wide header reason to every order line on a delivery route
   * stop. Replaces all existing line-level reasons on the stop with one row per
   * line carrying is_header_reason=true and quantity=fulfillment_quantity, then
   * zeros delivered_quantity on every line. Header is delivery-only (no redelivery support).
   */
  applyHeaderReasonToStopLineLevelDeliveryIssue?: Maybe<GLineLevelDeliveryIssueApplyHeaderReasonPayload>;
  /** Apply a reward. */
  applyReward?: Maybe<GApplyRewardPayload>;
  /**
   * Persists a scenario's routing parameters as the warehouse's standing
   * configuration. Persist-only — no run is triggered; the next
   * scheduled/triggered run consumes the config. Admin-only and gated by a
   * per-warehouse pilot flag.
   */
  applyRoutingConfiguration?: Maybe<GApplyRoutingConfigurationPayload>;
  approveCutoffDiscrepancy?: Maybe<GApproveCutoffDiscrepancyPayload>;
  assignCustomerTag?: Maybe<GAssignCustomerTagMutationPayload>;
  attachmentUrlPresigner?: Maybe<GAttachmentUrlPresignerCreatePayload>;
  /** Starts a paced batch onboarding run over one acquisition's ready customers. */
  batchOnboardInProgressCustomers?: Maybe<GBatchOnboardInProgressCustomersMutationPayload>;
  bulkCreateSupplierInvoiceComparisonRows: GBulkCreateSupplierInvoiceComparisonRowsPayload;
  /** Bulk update delivery status for all orders in a delivery route */
  bulkUpdateRouteStopsDeliveryInfo?: Maybe<GBulkUpdateRouteStopsDeliveryInfoPayload>;
  bulkUpsertZipcodeDeliveryRules?: Maybe<GBulkUpsertZipcodeDeliveryRulesPayload>;
  /** Cancel an order */
  cancelOrderMutation?: Maybe<GCancelOrderMutationPayload>;
  /**
   * Asks the provider to cancel a dispatched third-party route that no courier
   * holds yet, to keep it with Odeko (sc-67290). Returns at once: the dispatch
   * keeps its status and providerDispatch.cancelRequestedAt is set until the
   * provider answers. On the provider's confirmation the dispatch is canceled and
   * the route is a generic route again, its orders back on their delivery method.
   * On a refusal cancelRequestedAt is cleared, the dispatch keeps its status, and
   * error carries the provider's reason; the GM may retry. Refused with a
   * userError, nothing sent, while the route is not confirmed running, already
   * canceled, or a cancel is in flight, and when any stop has a courier assigned
   * or an outcome already recorded (the error names the stop).
   */
  cancelProviderRoute?: Maybe<GCancelProviderRoutePayload>;
  cancelProvisionalOrder?: Maybe<GCancelProvisionalOrderMutationPayload>;
  /** Persists vendor receiving check-in data: received quantities and vendor prices per item */
  checkinOrderVendorReceiving?: Maybe<GCheckinOrderVendorReceivingPayload>;
  /** Process checkout */
  checkout?: Maybe<GCheckoutPayload>;
  /** Claim reward. */
  claimReward?: Maybe<GClaimRewardPayload>;
  /** Complete a consumer app referral. */
  completeConsumerAppReferral?: Maybe<GCompleteConsumerAppReferralPayload>;
  /** Complete a Stripe checkout session, optionally triggering signage order creation */
  completeStripeCheckoutSession?: Maybe<GCompleteStripeCheckoutSessionMutationPayload>;
  /** Complete subscription session by creating microsite and associations */
  completeSubscriptionSession?: Maybe<GCompleteSubscriptionSessionMutationPayload>;
  completeSupplierInvoiceUpload: GCompleteSupplierInvoiceUploadPayload;
  /** Confirm an order's delivery review and clear it for billing */
  confirmOrderReview?: Maybe<GOrderReviewConfirmPayload>;
  /** Accepts a putaway command for durable asynchronous processing. */
  confirmPutawayPallet?: Maybe<GConfirmPutawayPalletPayload>;
  /** Confirm an order suggestion, creating a Square order and Terminal checkout */
  confirmSquareOrderSuggestion?: Maybe<GConfirmSquareOrderSuggestionMutationPayload>;
  /** Connect a Credit Key account to the location */
  connectLocationCreditKeyAccount?: Maybe<GConnectLocationCreditKeyAccountMutationPayload>;
  /** Mark a consumer order complete */
  consumerOrderComplete?: Maybe<GConsumerOrderCompletePayload>;
  /** Mark a consumer order picked-up */
  consumerOrderPickedUp?: Maybe<GConsumerOrderPickedUpPayload>;
  /** Mark a consumer order ready */
  consumerOrderReady?: Maybe<GConsumerOrderReadyPayload>;
  /** Copy delivery overrides to another date. Dry run by default; committed blocks cancel orders on the target date. */
  copyDeliveryOverrideRules?: Maybe<GCopyDeliveryOverrideRulesMutationPayload>;
  createBrandedItemDeal?: Maybe<GCreateBrandedItemDealMutationPayload>;
  createCollectionPromoSetup?: Maybe<GCreateCollectionPromoSetupPayload>;
  /** PROTOTYPE mutation to store a current count and (possibly) start a new LocationStockCount session */
  createCountingEvent?: Maybe<GCreateCountingEventMutationPayload>;
  createCustomIngredient?: Maybe<GCreateCustomIngredientMutationPayload>;
  createCustomerTag?: Maybe<GCreateCustomerTagMutationPayload>;
  /** Reserves a customer-tag CSV import and returns where to upload the file. */
  createCustomerTagImport?: Maybe<GCreateCustomerTagImportMutationPayload>;
  /** Author an individual (location + vendor) date-scoped delivery override. */
  createDeliveryOverrideRule?: Maybe<GCreateDeliveryOverrideRuleMutationPayload>;
  /** Add attachment to a delivery route stop */
  createDeliveryRouteStopAttachment?: Maybe<GDeliveryRouteStopAttachmentCreatePayload>;
  /** Create Stripe checkout session directly (without subscription session) */
  createDirectStripeCheckoutSession?: Maybe<GCreateDirectStripeCheckoutSessionMutationPayload>;
  /** Create a driver safety acknowledgement */
  createDriverSafetyAcknowledgement?: Maybe<GDriverSafetyAcknowledgementCreatePayload>;
  createExternalBaseBrandedItem?: Maybe<GCreateExternalBaseBrandedItemMutationPayload>;
  /**
   * Schedules an external delivery with a 3rd party delivery partner.
   * @deprecated use upsertExternalDeliveryMutation instead
   */
  createExternalDeliveryMutation?: Maybe<GCreateExternalDeliveryMutationPayload>;
  createFieldServiceZipcode?: Maybe<GCreateFieldServiceZipcodeMutationPayload>;
  /** Create a full refund for a consumer order */
  createFullConsumerRefund?: Maybe<GCreateFullConsumerRefundPayload>;
  /** Create a new game */
  createGame?: Maybe<GCreateGameMutationPayload>;
  createHomepageComponent?: Maybe<GCreateHomepageComponentPayload>;
  createHomepageDisplayRule?: Maybe<GCreateHomepageDisplayRulePayload>;
  /** Create a HubSpot lead for a location in the New stage */
  createHubspotLead?: Maybe<GCreateHubspotLeadPayload>;
  createInHouseBaseBrandedItem?: Maybe<GCreateInHouseBaseBrandedItemMutationPayload>;
  createInventoryItem?: Maybe<GSupplyItem>;
  createItemBrand?: Maybe<GItemBrandCreatePayload>;
  createItemTag?: Maybe<GItemTag>;
  /** Create a new leaderboard for a game */
  createLeaderboard?: Maybe<GCreateLeaderboardMutationPayload>;
  /** Create a new location with Supply auto-enabled and publish upsert event */
  createLocation?: Maybe<GCreateLocationMutationPayload>;
  /** Create an lva for a location and vendor */
  createLocationVendorAssociation?: Maybe<GCreateLocationVendorAssociationMutationPayload>;
  createMarketingToolsManager?: Maybe<GCreateMarketingToolsManagerMutationPayload>;
  /** Create a menu for the merchant */
  createMenu?: Maybe<GCreateMenuPayload>;
  /** Create a menu item for the submenu */
  createMenuItem?: Maybe<GCreateMenuItemPayload>;
  /** Create a microsite location from Google Place ID or business name/address */
  createMicrositeLocation?: Maybe<GCreateMicrositeLocationMutationPayload>;
  createNonInventoryItem?: Maybe<GSupplyItem>;
  createOrderReconciliationAttachmentUploadRequestMutation?: Maybe<GCreateOrderReconciliationAttachmentUploadRequestMutationPayload>;
  createOrderReconciliationMutation?: Maybe<GCreateOrderReconciliationMutationPayload>;
  /** Create a partial refund for a consumer order */
  createPartialConsumerRefund?: Maybe<GCreatePartialConsumerRefundPayload>;
  createReceivableNote?: Maybe<GCreateReceivableNotePayload>;
  /** Creates redelivery stops */
  createRedeliveryStops?: Maybe<GRedeliveryStopCreatePayload>;
  /** Add an additional task for the driver to a delivery route stop */
  createRouteStopTask?: Maybe<GDeliveryRouteStopTaskCreatePayload>;
  createSalesTaxEstimate?: Maybe<GCreateSalesTaxEstimateMutationPayload>;
  /** Create a Stripe checkout session for purchasing additional signs */
  createSignPurchaseCheckoutSession?: Maybe<GCreateSignPurchaseCheckoutSessionMutationPayload>;
  /** Parse a voice transcript and create an order suggestion for review */
  createSquareOrderSuggestionFromTranscript?: Maybe<GCreateSquareOrderSuggestionFromTranscriptMutationPayload>;
  /** PROTOTYPE mutation to create a new storage area for a location. */
  createStorageArea?: Maybe<GCreateStorageAreaMutationPayload>;
  /** Create Stripe checkout session for existing subscription session */
  createStripeCheckoutSession?: Maybe<GCreateStripeCheckoutSessionMutationPayload>;
  /** Create a submenu under the menu */
  createSubmenu?: Maybe<GCreateSubmenuPayload>;
  createSupplierInvoice: GCreateSupplierInvoicePayload;
  createSupplierInvoiceComparison: GCreateSupplierInvoiceComparisonPayload;
  /** Create a new user with Auth0 identity and location access */
  createUser?: Maybe<GCreateUserMutationPayload>;
  /** Associate a user with a microsite location. This is used to check that a user has permission to edit a microsite. */
  createUserMicrositeLocation?: Maybe<GCreateUserMicrositeLocationPayload>;
  /** Stores a pre-trip or post-trip vehicle inspection report. */
  createVehicleInspectionReport?: Maybe<GVehicleInspectionReportCreatePayload>;
  /** Creates a delivery route for a warehouse */
  createWarehouseDeliveryRoute?: Maybe<GDeliveryRouteCreatePayload>;
  createWorkThread?: Maybe<GCreateWorkThreadPayload>;
  deleteArAssignment?: Maybe<GDeleteArAssignmentPayload>;
  deleteCategoryBanner?: Maybe<GCategoryBannerPayload>;
  deleteCollectionPromoSetup?: Maybe<GDeleteCollectionPromoSetupPayload>;
  deleteCustomerTag?: Maybe<GDeleteCustomerTagMutationPayload>;
  /** Removes a delivery issue for a delivery route stop */
  deleteDeliveryIssue?: Maybe<GDeliveryIssueDeletePayload>;
  /**
   * Withdraw a delivery override so it stops applying. Does not restore the orders
   * it already cancelled, and cancels no further orders.
   */
  deleteDeliveryOverrideRule?: Maybe<GDeleteDeliveryOverrideRuleMutationPayload>;
  /** Delete delivery route stop attachment */
  deleteDeliveryRouteStopAttachment?: Maybe<GDeliveryRouteStopAttachmentDeletePayload>;
  /** Delete a driver safety acknowledgement */
  deleteDriverSafetyAcknowledgement?: Maybe<GDriverSafetyAcknowledgementDeletePayload>;
  deleteFieldServiceZipcode?: Maybe<GDeleteFieldServiceZipcodeMutationPayload>;
  deleteItemBrand?: Maybe<GItemBrandDeletePayload>;
  /** Removes a line-level delivery reason */
  deleteLineLevelDeliveryIssue?: Maybe<GLineLevelDeliveryIssueDeletePayload>;
  deleteLocationAccountsReceivableCollectionsStatus?: Maybe<GDeleteLocationAccountsReceivableCollectionsStatusPayload>;
  /** Delete the payment method associated with the customer of this location */
  deleteLocationPaymentMethod?: Maybe<GDeleteLocationPaymentMethodMutationPayload>;
  deleteLocationPhoneNumber?: Maybe<GDeleteLocationPhoneNumberMutationPayload>;
  deleteMasterHomepage?: Maybe<GDeleteMasterHomepagePayload>;
  deleteMasterHomepageRowComponent?: Maybe<GDeleteMasterHomepageRowComponentPayload>;
  /** Delete a menu item from a microsite. */
  deleteMicrositeMenuItem?: Maybe<GDeleteMicrositeMenuItemPayload>;
  deleteReceivableNote?: Maybe<GDeleteReceivableNotePayload>;
  /** Delete a redelivery stop */
  deleteRedeliveryStop?: Maybe<GRedeliveryStopDeletePayload>;
  /** Remove an unresolved additional task from a delivery route stop */
  deleteRouteStopTask?: Maybe<GDeliveryRouteStopTaskDeletePayload>;
  /**
   * Hard-deletes a scenario run, the cleanup mechanism for the 50-run-per-plan
   * cap. Observe the result via RoutingImportPlan.scenarios.
   */
  deleteRoutificScenario?: Maybe<GDeleteRoutificScenarioPayload>;
  /** Delete a file from S3 storage. */
  deleteS3File?: Maybe<GDeleteS3FilePayload>;
  /** Delete Square card. */
  deleteSquareCard?: Maybe<GDeleteSquareCardPayload>;
  /** Remove a user's association with a microsite location */
  deleteUserMicrositeLocation?: Maybe<GDeleteUserMicrositeLocationMutationPayload>;
  deleteZipcode?: Maybe<GDeleteZipcodeMutationPayload>;
  deleteZipcodeDeliveryRule?: Maybe<GDeleteZipcodeDeliveryRulePayload>;
  /** Mark a delivery as completed for a delivery route stop */
  deliveryCompleted?: Maybe<GDeliveryCompletedUpdatePayload>;
  /**
   * Update the sequence numbers of a routes delivery stops. This is typically used
   * when users want to change the order of the stops on their delivey route.
   */
  deliveryStopsReorder?: Maybe<GDeliveryStopsReorderPayload>;
  deprioritizeLocation?: Maybe<GDeprioritizeLocationPayload>;
  discontinueWarehouseItem?: Maybe<GSupplyItem>;
  /**
   * Dispatches a quoted third-party route against one of its quotes (epic
   * sc-66318). The dispatch reads dispatched until the provider confirms, then
   * in_progress. An expired quote, or one the provider refuses, is returned as a
   * userError and the route stays quoted.
   */
  dispatchProviderRoute?: Maybe<GDispatchProviderRoutePayload>;
  /**
   * Internal: add a PO to an LTL booking's truck from the board. The PO takes the
   * truck's slot, dock and carrier, even after the slot started or the truck
   * checked in, until the truck departs. A PO already booked elsewhere moves onto this truck.
   */
  dockBookingAddPo?: Maybe<GDockBookingAddPoPayload>;
  /** Cancels a booking on the driver's behalf (internal). */
  dockBookingCancel?: Maybe<GDockBookingCancelPayload>;
  /** Marks a booked appointment as a no-show (internal). */
  dockBookingMarkMissed?: Maybe<GDockBookingMarkMissedPayload>;
  /**
   * Internal: record that a booking's truck has arrived, identified directly by
   * its booking id — no reference typed. Lets ops check in from the admin board
   * instead of depending on a driver receiving/relaying a confirmation number or
   * PO. Idempotent — calling it again for the same delivery returns the arrival
   * already recorded.
   */
  dockBookingOpsCheckIn?: Maybe<GDockBookingOpsCheckInPayload>;
  /** Creates a dock for a warehouse. */
  dockCreate?: Maybe<GDockCreatePayload>;
  /** Deletes a dock. Fails with DockInUse if it has upcoming bookings. */
  dockDelete?: Maybe<GDockDeletePayload>;
  /**
   * Issue a dock override code to a warehouse-only vendor. If the vendor already
   * has an active code, it is revoked and a fresh one minted — existing deliveries are preserved.
   */
  dockOverrideCodeIssue?: Maybe<GDockOverrideCodeIssuePayload>;
  /**
   * Revoke an active dock override code. The code can no longer authenticate or
   * create bookings; existing bookings are left untouched.
   */
  dockOverrideCodeRevoke?: Maybe<GDockOverrideCodeRevokePayload>;
  /** Renames a dock, replaces its booking windows, or enables/disables it. */
  dockUpdate?: Maybe<GDockUpdatePayload>;
  /**
   * Closes a checked-in truck's visit from an internal admin surface (e.g. the
   * Dock Manager board), identified directly by the visit's own id. Same effect as
   * the kiosk's Departed screen — measures how long the truck was on site.
   * Idempotent — an arrival already closed keeps the departure time first recorded.
   */
  dockVisitDepart?: Maybe<GDockVisitDepartPayload>;
  /**
   * Moves a checked-in truck to a different dock (internal) — e.g. its assigned
   * door is occupied when it arrives. The booking's own scheduled dock is
   * untouched; only where the truck physically is changes.
   */
  dockVisitReassignDock?: Maybe<GDockVisitReassignDockPayload>;
  duplicateMasterHomepage?: Maybe<GDuplicateMasterHomepagePayload>;
  /**
   * Sends stops with issues to a third-party provider as one-off deliveries (epic
   * sc-66318). Creates one new route for the warehouse and night holding a
   * redelivery stop per selected stop, marks it for the provider and queues the
   * push. Refuses, creating nothing, when any selected stop fails a rule; the
   * error names every such stop.
   */
  escalateStopsToProvider?: Maybe<GEscalateStopsToProviderPayload>;
  /**
   * Generate signed parameters for direct Cloudinary upload.
   * @deprecated Use 'requestS3Upload' instead. Microsite media uploads now go to S3; this mutation still returns valid signatures and will be removed by the Cloudinary teardown follow-up.
   */
  generateCloudinaryUploadSignature?: Maybe<GGenerateUploadSignaturePayload>;
  /**
   * Generate or refine AI description for item.
   * - No existingDescription: generates fresh description from item info + Google Search.
   * - existingDescription + userInstructions: refines the existing description.
   * - existingDescription without userInstructions: regenerates fresh.
   */
  generateItemDescription: GGenerateItemDescriptionResult;
  /** PROTOTYPE for a given Stock Count session, generate order quantities. */
  generateOrderQuantities?: Maybe<GGenerateOrderQuantitiesMutationPayload>;
  generatePresignedS3Url?: Maybe<GGeneratePresignedUrlMutationPayload>;
  importPriceRulesCsv: GImportPriceRulesCsvPayload;
  importProcurementRecords?: Maybe<Scalars['Boolean']>;
  /** Initialize marketing tools signup session */
  initializeMarketingToolsSignup?: Maybe<GInitializeMarketingToolsSignupMutationPayload>;
  /** Initiate pairing for a Square Terminal by creating a device code */
  initiateTerminalPairing?: Maybe<GInitiateTerminalPairingMutationPayload>;
  logSalesOutreach?: Maybe<GLogSalesOutreachPayload>;
  /** Login consumer app user using a Firebase ID. */
  loginConsumerAppUserFromFirebase?: Maybe<GLoginConsumerAppUserFromFirebasePayload>;
  /** Make a one-time charge to a location's Credit Key account */
  makeCreditKeyCharge?: Maybe<GMakeCreditKeyChargeMutationPayload>;
  /** Marks a delivery as having donation collected and sets a timestamp */
  markCompostCollected?: Maybe<GDeliveryRouteStopCompostCollectedUpdatePayload>;
  /**
   * Complete a selection of customer-pickup bucket stops (mark picked up). Each
   * stop's orders are delivered at fulfilled quantity and the stop is completed
   * and viewed, the same way whole-bucket bulk complete works. A stop that is not
   * on a customer-pickup route, or one whose collected vendor order is
   * line-tracked with no fulfillment quantities, is rejected and nothing is written.
   */
  markCustomerPickupStopsComplete?: Maybe<GMarkCustomerPickupStopsCompletePayload>;
  /** Marks a delivery as having donation collected and sets a timestamp */
  markDonationCollected?: Maybe<GDeliveryRouteStopDonationCollectedUpdatePayload>;
  /** Sets the bulk picking status warehouse items */
  markItemsAsBulkPicked?: Maybe<GMarkItemsAsBulkPickedMutationPayload>;
  /** Adds items to or removes them from a warehouse's ECOM bulk list. The bulk list is unaffected. */
  markItemsAsEcomBulk?: Maybe<GMarkItemsAsEcomBulkMutationPayload>;
  /** Marks an order as delivered */
  markOrderDelivered?: Maybe<GOrderDeliveredUpdatePayload>;
  /**
   * Marks a GM-built route as executed by a third-party provider (epic sc-66318).
   * Validates the provider is available to the warehouse and the route is
   * markable, then creates the dispatch record and queues the push, which creates
   * the provider's orders and route and requests quotes. The dispatch status
   * reports how far it got.
   */
  markRouteForProvider?: Maybe<GMarkRouteForProviderPayload>;
  /**
   * Move delivery stops into their night's customer-pickup bucket, creating the
   * bucket if that night does not have one yet. Enforces the same warehouse and
   * night-end-lock rules as DeliveryStopsMoveToRoute. Never writes an order's
   * deliveryMethod: bucket membership is the route, not the delivery method.
   */
  moveDeliveryStopsToCustomerPickup?: Maybe<GMoveDeliveryStopsToCustomerPickupPayload>;
  /** Move delivery stops from their current routes to specified route and update associated Vendor pick ups accordingly  */
  moveDeliveryStopsToRoute?: Maybe<GDeliveryStopsMoveToRoutePayload>;
  /** Marks an order as collected/fulfilled */
  orderCollected?: Maybe<GOrderCollectedUpdatePayload>;
  /** Performs out of stock checks for a list of items */
  performOutOfStockChecks?: Maybe<GPerformOutOfStockChecksMutationPayload>;
  /** Pin an item as the queue leader at a position across every market it's currently new in, in one all-or-nothing action. Studio-only. */
  pinItemAcrossMarkets: GPinItemAcrossMarketsPayload;
  pingifyBraavos: Scalars['String'];
  /** PROTOTYPE mutation to exchange a code for a token and store credentials and platform account & profile info */
  platformCompleteAction?: Maybe<GCompleteActionMutationPayload>;
  pricingServicePingify: GPricingServicePingifyPayload;
  /** Supervisor assigns an associate to a process path now. */
  processPathAssign?: Maybe<GProcessPathAssignPayload>;
  /** Admin provisions an agency (temp-staff) associate; returns their generated badge code. */
  processPathAssociateCreate?: Maybe<GProcessPathAssociateCreatePayload>;
  /**
   * Admin deactivates/reactivates an agency (temp-staff) associate. ARMHR-sourced
   * rows are refused. Deactivating removes the associate from the active roster,
   * closes any open time, and returns a held RF-SMART pool account to the
   * warehouse pool (password unrotated), but does NOT disable their badge at the kiosk.
   */
  processPathAssociateSetStatus?: Maybe<GProcessPathAssociateSetStatusPayload>;
  /**
   * Clears a coverage-target cell: reverts to the system suggestion when one
   * exists, otherwise empties the cell. Distinct from asserting an explicit zero.
   */
  processPathClearCoverageTarget?: Maybe<GProcessPathClearCoverageTargetPayload>;
  /** Supervisor clocks an associate in for their shift. */
  processPathClockIn?: Maybe<GProcessPathClockInPayload>;
  /** Supervisor clocks an associate out, ending their shift and any open segment. */
  processPathClockOut?: Maybe<GProcessPathClockOutPayload>;
  /** Adds a path to the global catalog, available at the creating warehouse only. */
  processPathCreate?: Maybe<GProcessPathCreatePayload>;
  /** Sets the global left-to-right order of catalog paths. */
  processPathReorder?: Maybe<GProcessPathReorderPayload>;
  /** Supervisor manual insert of a (typically back-dated) segment. */
  processPathSegmentCreate?: Maybe<GProcessPathSegmentCreatePayload>;
  /** Supervisor deletes a logged segment. */
  processPathSegmentDelete?: Maybe<GProcessPathSegmentDeletePayload>;
  /** Supervisor correction of a logged segment (path / start / end). */
  processPathSegmentEdit?: Maybe<GProcessPathSegmentEditPayload>;
  /** Associate self-assigns to a process path. */
  processPathSelfAssign?: Maybe<GProcessPathSelfAssignPayload>;
  /** Associate clocks themselves in for their shift. */
  processPathSelfClockIn?: Maybe<GProcessPathSelfClockInPayload>;
  /** Associate clocks themselves out, ending their shift and any open segment. */
  processPathSelfClockOut?: Maybe<GProcessPathSelfClockOutPayload>;
  /** Associate ends their current process-path segment. */
  processPathSelfUnassign?: Maybe<GProcessPathSelfUnassignPayload>;
  /** Toggles whether a catalog path is available at a given warehouse. */
  processPathSetAvailability?: Maybe<GProcessPathSetAvailabilityPayload>;
  /**
   * Sets the admin-entered target labour hours for a path on a day. 0 is stored as
   * an asserted zero; use ProcessPathClearCoverageTarget to clear the cell.
   */
  processPathSetCoverageTarget?: Maybe<GProcessPathSetCoverageTargetPayload>;
  /** Ends an associate's current process-path segment. */
  processPathUnassign?: Maybe<GProcessPathUnassignPayload>;
  /** Edits a catalog path's global attributes (label/category/colour/order). */
  processPathUpdate?: Maybe<GProcessPathUpdatePayload>;
  /**
   * Records a human verdict (approved/rejected) on an AI-generated output — e.g.
   * 👍/👎 on a suggested reply — attributed to the calling user. Upserts per
   * assessment + user + interaction, so re-voting replaces the prior verdict.
   */
  procurementAiFeedbackSubmit?: Maybe<GProcurementAiFeedbackSubmitPayload>;
  /**
   * Stores an AI status assessment for a PO tracking (append-only, with
   * provenance) and lets ApplyAssessment decide whether it moves tracking_status:
   * monotonic transitions at high/medium confidence apply; anything else is held
   * with needs_reply. Callers never write status directly.
   */
  procurementAssessmentSubmit?: Maybe<GProcurementAssessmentSubmitPayload>;
  procurementCorrespondenceCommand?: Maybe<GProcurementCorrespondenceCommandPayload>;
  /**
   * Idempotently ingests one mailbox thread with its messages and attachment
   * metadata, keyed on Gmail ids — whole threads are re-delivered on every pass,
   * so re-upserts are no-ops that report only genuinely new messages. Primary
   * ingestion calls Procurement::EmailIngestService in-process (LDS mailbox
   * poller); this mutation is the ops/manual entry point.
   */
  procurementEmailThreadUpsert?: Maybe<GProcurementEmailThreadUpsertPayload>;
  /**
   * Records the last processed Gmail historyId for a mailbox — the ingest poller's
   * resume point, advanced only after a full pass persists.
   */
  procurementMailboxCursorSet?: Maybe<GProcurementMailboxCursorSetPayload>;
  /** Audited human corrections to pickup criteria; all six are required for the scheduling gate. */
  procurementPickupCriteriaUpdate?: Maybe<GProcurementPickupCriteriaUpdatePayload>;
  /** Logs an offline conversation (phone / in person) into a PO's timeline, attributed to the calling user. */
  procurementPoNoteCreate?: Maybe<GProcurementPoNoteCreatePayload>;
  /** Assigns the calling user (Auth0 sub from the request JWT) to a PO tracking row. */
  procurementPoTrackingAssign?: Maybe<GProcurementPoTrackingAssignPayload>;
  /**
   * Idempotently creates the tool-owned tracking row for a NetSuite purchase order
   * (by PO number / tranId) and links its procurement vendor. Master data stays on
   * the NetSuite projection.
   */
  procurementPoTrackingEnsure?: Maybe<GProcurementPoTrackingEnsurePayload>;
  /**
   * Human corrections to a PO tracking row: delivery type, vendor link,
   * needs-reply flag. Deliberately cannot set tracking_status — status changes
   * only through the audited assessment/override paths.
   */
  procurementPoTrackingUpdate?: Maybe<GProcurementPoTrackingUpdatePayload>;
  /**
   * Human status override — any transition allowed (humans correct AI mistakes
   * backward), always recorded as an audited status event with the actor.
   */
  procurementStatusOverride?: Maybe<GProcurementStatusOverridePayload>;
  /**
   * Human assignment from the unmatched queue: creates a manual, confirmed link
   * between a thread and a PO tracking, recording the assigner.
   */
  procurementThreadAssignToPo?: Maybe<GProcurementThreadAssignToPoPayload>;
  /** Human confirmation of an AI-proposed link from the unmatched queue. */
  procurementThreadLinkConfirm?: Maybe<GProcurementThreadLinkConfirmPayload>;
  /**
   * Links an ingested thread to a PO tracking (both addressed by their
   * source-system ids — the AI matcher speaks Gmail thread ids and PO numbers).
   * subject_po_number/pdf_extract sources auto-confirm; ai_inference stays
   * proposed in the unmatched queue until a human confirms.
   */
  procurementThreadLinkCreate?: Maybe<GProcurementThreadLinkCreatePayload>;
  /**
   * Sets a thread's triage state: unmatched (PO-like, human queue), dismissed, or
   * ignored (non-PO noise, purged after retention). matched only ever happens
   * through link creation/confirmation. Accepts either the thread id (human queue)
   * or the Gmail thread id. Always recorded as a human triage against the caller's
   * Auth0 sub — the AI triages in-process, not through this mutation.
   */
  procurementThreadTriageSet?: Maybe<GProcurementThreadTriageSetPayload>;
  /**
   * Creates a procurement vendor, or updates one by id. Creation matches on
   * normalized name, so re-submitting an existing vendor's name updates that
   * vendor instead of duplicating it.
   */
  procurementTrackingVendorUpsert?: Maybe<GProcurementTrackingVendorUpsertPayload>;
  /** Public: cancel a delivery's booking, identified by its PO (reference number). */
  publicDockBookingCancel?: Maybe<GPublicDockBookingCancelPayload>;
  /**
   * Public: book (or amend) a delivery's dock time, identified by its PO
   * (reference number). The scheduler chooses the freight type (it drives slot
   * length) and must supply SCAC, weight, pallet count, contact name/phone/email
   * and ship date; carrier name and the remaining details are optional.
   */
  publicDockBookingSubmit?: Maybe<GPublicDockBookingSubmitPayload>;
  /**
   * Public: record that the driver for this delivery has arrived at the dock,
   * identified by the confirmation number on their email or by the PO. Idempotent
   * — calling it again for the same delivery returns the arrival already recorded.
   */
  publicDockCheckIn?: Maybe<GPublicDockCheckInPayload>;
  /**
   * Public: ops records that the truck for this delivery has left the dock,
   * identified by the confirmation number on its email or by the PO. Closes the
   * arrival and measures how long the truck was on site. Idempotent — an arrival
   * already closed keeps the departure time first recorded.
   */
  publicDockDepart?: Maybe<GPublicDockDepartPayload>;
  /** Change one of the code vendor's existing deliveries. */
  publicOverrideBookingAmend?: Maybe<GPublicOverrideBookingAmendPayload>;
  /** Cancel one of the code vendor's deliveries. */
  publicOverrideBookingCancel?: Maybe<GPublicOverrideBookingCancelPayload>;
  /** Book a new delivery for the code's vendor at a chosen warehouse. */
  publicOverrideBookingCreate?: Maybe<GPublicOverrideBookingCreatePayload>;
  /** Create or update a review response on Google Business Profile */
  publishReviewResponse?: Maybe<GReviewResponse>;
  /** Create or update a review response on Google Business Profile using Google location name */
  publishReviewResponseGbp?: Maybe<GReviewResponse>;
  /** Rebuild the cart from a past order. */
  rebuildCartFromPastOrder?: Maybe<GRebuildCartFromPastOrderPayload>;
  /**
   * Recalculate cart prices appropriately for a specific payment method (which can
   * affect fees), using up-to-date menu prices. Items and/or modifiers whose
   * prices have changed since being added to the cart will reflect latest price info.
   */
  recalculateCartPrices?: Maybe<GRecalculateCartPricesPayload>;
  /** Records a batch of timestamped driver location fixes for an active route's breadcrumb trail. */
  recordDriverLocationPings?: Maybe<GRecordDriverLocationPingsPayload>;
  /** Accepts a manual Bin Transfer of one lot, from any active bin, for durable asynchronous processing. */
  recordManualBinTransfer?: Maybe<GRecordManualBinTransferPayload>;
  /**
   * Records one trip of a replenishment task as a Bin Transfer, for durable
   * asynchronous processing. Call it again for the same taskId as the associate
   * pulls from successive bins.
   */
  recordReplenishmentPick?: Maybe<GRecordReplenishmentPickPayload>;
  /** Empty the cart. */
  removeAllFromCart?: Maybe<GRemoveAllFromCartPayload>;
  removeCustomerTag?: Maybe<GRemoveCustomerTagMutationPayload>;
  /** Remove a favorite consumer order. */
  removeFavoriteConsumerOrder?: Maybe<GRemoveFavoriteConsumerOrderPayload>;
  /** Remove items from cart. */
  removeItemsFromCart?: Maybe<GRemoveItemsFromCartPayload>;
  removeLocationItem?: Maybe<Scalars['Boolean']>;
  /** Remove a location's default backup item for an item it orders */
  removeLocationItemBackup?: Maybe<GRemoveLocationItemBackupMutationPayload>;
  /** Remove an item's New Items pin from a market. Studio-only. */
  removeNewItemPin: GNewItemPinPayload;
  /** Remove reward. */
  removeReward?: Maybe<GRemoveRewardPayload>;
  /** Remove a curated substitution override by id. Procurement-only. */
  removeSubstitutionOverride: GSubstitutionOverridePayload;
  /** Reopens a completed route by clearing its completion time, so its stops can be edited again. */
  reopenRoute?: Maybe<GRouteReopenPayload>;
  /** Replace a market's full set of New Items pins in one shot. Studio-only. */
  reorderNewItemPins: GNewItemPinsPayload;
  /** Reports a delivery issue for a delivery route stop */
  reportDeliveryIssue?: Maybe<GDeliveryIssueCreatePayload>;
  /** Reports a line-level delivery reason on an order line for a delivery or redelivery stop */
  reportLineLevelDeliveryIssue?: Maybe<GLineLevelDeliveryIssueReportPayload>;
  /** Report phone number verification code. */
  reportPhoneNumberVerification?: Maybe<GReportPhoneNumberVerificationPayload>;
  /**
   * Records why an associate couldn't put a task away. The reason is kept for
   * metrics and bin-data review; nothing about the task itself changes.
   */
  reportPutawayException?: Maybe<GReportPutawayExceptionPayload>;
  /**
   * Records that an associate reported the item master's pallet build as wrong.
   * The correction applied to their putaway session only; the record lets a
   * reviewer decide whether IMS should change.
   */
  reportPutawayPalletBuildCorrection?: Maybe<GReportPutawayPalletBuildCorrectionPayload>;
  /** Request an S3 upload URL for a file. The file must then be uploaded using a PUT request. */
  requestS3Upload?: Maybe<GRequestS3UploadPayload>;
  /** Order the free sample of an item for a location, delivered on the given date */
  requestSample?: Maybe<GRequestSampleMutationPayload>;
  requestSupplierInvoiceReadUrl: GRequestSupplierInvoiceReadUrlPayload;
  /**
   * Requests fresh quotes for a marked route that is not dispatched yet,
   * optionally at a new pickup time (epic sc-66318 D8). The dispatch returns to
   * quoting and its quotes are replaced when the provider answers; the provider's
   * orders are not changed.
   */
  requoteProviderRoute?: Maybe<GRequoteProviderRoutePayload>;
  resolveProvisionalOrderLine?: Maybe<GResolveProvisionalOrderLineMutationPayload>;
  /** Driver resolves every additional task on a stop (complete/incomplete), each with its own note */
  resolveRouteStopTasks?: Maybe<GDeliveryRouteStopTasksResolvePayload>;
  restoreLocation?: Maybe<GRestoreLocationPayload>;
  /** Admin assigns a pool RF-SMART account to an associate, optionally rotating its password; returns metadata only. */
  rfsmartCredentialAssign?: Maybe<GRfsmartCredentialAssignPayload>;
  /** Admin cancels a pending RF-SMART removal request. Provide exactly one of employeeId or credentialId. */
  rfsmartCredentialRemovalCancel?: Maybe<GRfsmartCredentialRemovalCancelPayload>;
  /**
   * Admin records a pending RF-SMART removal as done; erases the stored password,
   * keeps the row as history. Provide exactly one of employeeId or credentialId.
   */
  rfsmartCredentialRemovalComplete?: Maybe<GRfsmartCredentialRemovalCompletePayload>;
  /**
   * Admin flags an active RF-SMART credential for manual removal in RF-SMART.
   * Provide exactly one of employeeId or credentialId.
   */
  rfsmartCredentialRemovalRequest?: Maybe<GRfsmartCredentialRemovalRequestPayload>;
  /** Admin sets or rotates an associate's RF-SMART credential; returns metadata only. */
  rfsmartCredentialSet?: Maybe<GRfsmartCredentialSetPayload>;
  /** Admin adds a pool RF-SMART account to a warehouse, corrects its login, or rotates its password; returns metadata only. */
  rfsmartCredentialSetPool?: Maybe<GRfsmartCredentialSetPoolPayload>;
  /** Admin returns a pool RF-SMART account to the pool; pool credentials only. */
  rfsmartCredentialUnassign?: Maybe<GRfsmartCredentialUnassignPayload>;
  /** Assigns one of the warehouse's shifts to a routing cohort, or clears it (null). */
  routingCohortShiftAssign?: Maybe<GRoutingCohortShiftAssignPayload>;
  /**
   * Ask NetSuite to republish the records this location's retained comparison
   * flagged. Requires AR team access: any other caller gets a FORBIDDEN error and
   * no payload. A sync refreshes what a comparison found, so it needs one made
   * today that found something to fix and nothing else running; anything else is
   * refused with the reason in errors and location null, never queued. On success
   * the sync is in flight: read location.transactionSync to follow it.
   */
  runTransactionSync?: Maybe<GRunTransactionSyncPayload>;
  /**
   * Ask for a fresh comparison of one location's records against NetSuite.
   * Requires AR team access: any other caller gets a FORBIDDEN error and no
   * payload. Never queues — a location with an audit or a sync already in flight
   * is refused, with the reason in errors and location null. On success the audit
   * has been requested, not finished: read location.transactionSync to follow it.
   */
  runTransactionSyncAudit?: Maybe<GRunTransactionSyncAuditPayload>;
  /** Save referral link for the current consumer app user. */
  saveConsumerAppReferralLink?: Maybe<GSaveConsumerAppReferralLinkPayload>;
  saveMasterHomepageRows?: Maybe<GSaveMasterHomepageRowsPayload>;
  /**
   * Sets or updates the GM-facing display name on a scenario run. Idempotent — the
   * same mutation names a run at creation and renames it later. Observe the result
   * via RoutingImportPlan.scenarios.
   */
  saveRoutificScenario?: Maybe<GSaveRoutificScenarioPayload>;
  /** Batch marks orders as collected and updates fulfillment quantities for all orders from a vendor in one transaction */
  saveVendorAllocation?: Maybe<GSaveVendorAllocationPayload>;
  /** Scan a marketing QR code. */
  scanMarketingQrCode?: Maybe<GScanMarketingQrCodeMutationPayload>;
  sendAlignmentMessage?: Maybe<GSendAlignmentMessagePayload>;
  sendBrandedPaperQuestionEmail?: Maybe<GSendBrandedPaperQuestionEmailMutationPayload>;
  /** Send a chat message */
  sendChatMessage?: Maybe<Array<Maybe<GChatMessage>>>;
  sendEquipmentCheckoutEmail?: Maybe<GSendEquipmentCheckoutEmailMutationPayload>;
  sendEquipmentQuestionEmail?: Maybe<GSendEquipmentQuestionEmailMutationPayload>;
  /** Set a payment method as default across all eligible locations for the user */
  setDefaultPaymentMethodForLocations?: Maybe<GSetDefaultPaymentMethodForLocationsMutationPayload>;
  setFinancialStatementPreferences?: Maybe<GSetFinancialStatementPreferencesMutationPayload>;
  /**
   * Upserts a warehouse's fleet composition — per vehicle type, how many trucks it
   * routes with — onto its routing configuration, creating the configuration if
   * absent. Per-type counts are caller-set; per-truck capacities come from the
   * warehouse's vehicle types. Admin-only and gated by a per-warehouse pilot flag.
   */
  setFleetComposition?: Maybe<GSetFleetCompositionPayload>;
  /**
   * Set which locations are excluded from automatic fund application.
   * All-or-nothing: on success, locations contains every input location (excluded
   * and included alike) in input order; if any input location id is unknown,
   * nothing is written, locations is null, and errors says which ids were unknown.
   */
  setFundApplicationExclusions?: Maybe<GSetFundApplicationExclusionsPayload>;
  setInvoiceExternalSupplier: GSetInvoiceExternalSupplierPayload;
  /** Mark an item inactive or reactivate it; blocking reasons are returned in the payload's `errors`. */
  setItemInactive: GSetItemInactivePayload;
  /** Turn autopay on or off for one location */
  setLocationAutopay?: Maybe<GSetLocationAutopayMutationPayload>;
  /** Set or clear a location's standing PO number */
  setLocationStandingPoNumber?: Maybe<GSetLocationStandingPoNumberMutationPayload>;
  /** Set merchant operating hours */
  setMerchantOperatingHours?: Maybe<GSetMerchantOperatingHoursPayload>;
  /** Set tip. */
  setTip?: Maybe<GSetTipPayload>;
  signup?: Maybe<GSignupMutationPayload>;
  /** Creates a standing appointment rule and immediately materializes its full date range into bookings. */
  standingAppointmentCreate?: Maybe<GStandingAppointmentCreatePayload>;
  /**
   * Resolves one date that failed batch materialization by booking it into a
   * window ops is deliberately pushing over cap. Defaults to the least-over-cap
   * candidate window; pass dockWindowId (from standingAppointmentCandidateWindows)
   * to pick a specific one instead.
   */
  standingAppointmentResolveFailedDate?: Maybe<GStandingAppointmentResolveFailedDatePayload>;
  /**
   * Edits a standing appointment's effective_until — the only editable field.
   * Shortening it cancels every not-yet-arrived booking now outside the range;
   * extending it books the newly-covered dates (created_bookings/failed_dates),
   * the same success/failure split as creation.
   */
  standingAppointmentUpdateEffectiveUntil?: Maybe<GStandingAppointmentUpdateEffectiveUntilPayload>;
  /** Attaches an uploaded customer-tag CSV to its import and hands it off for processing. */
  startCustomerTagImport?: Maybe<GStartCustomerTagImportMutationPayload>;
  /** Start phone number verification. */
  startPhoneNumberVerification?: Maybe<GStartPhoneNumberVerificationPayload>;
  /** Retires a batch onboarding run. Nothing further is handed off; records already in flight complete on their own. */
  stopBatchOnboardRun?: Maybe<GStopBatchOnboardRunMutationPayload>;
  /** Submit a check-in entry for a chance to win */
  submitCheckIn?: Maybe<GSubmitCheckInMutationPayload>;
  /** Submit guest information to a microsite mailing list */
  submitMailingList?: Maybe<GSubmitMailingListMutationPayload>;
  submitPurchaseHistoryFeedback: GSubmitPurchaseHistoryFeedbackPayload;
  /** Submit a score to a leaderboard (public for game integration) */
  submitScore?: Maybe<GSubmitScoreMutationPayload>;
  /** PROTOTYPE mutation submit (eg finish/end) an in-progress LocationStockCount session. */
  submitStockCount?: Maybe<GSubmitStockCountMutationPayload>;
  /** Submit a suggestion or feedback with AI sentiment analysis */
  submitSuggestion?: Maybe<GSubmitSuggestionMutationPayload>;
  /** Delete all items in the user's supply cart at the given location. Idempotent. */
  supplyClearCart?: Maybe<GSupplyClearCartPayload>;
  /** Remove an item from the user's supply cart at the given location. Idempotent. */
  supplyRemoveCartItem?: Maybe<GSupplyRemoveCartItemPayload>;
  /** Add or update an item in the user's supply cart at the given location. Quantity is absolute. */
  supplyUpsertCartItem?: Maybe<GSupplyUpsertCartItemPayload>;
  /** Temporary scaffolding to help with initial rollout of microsites. */
  syncMicrositeConfig?: Maybe<GSyncMicrositeConfigMutationPayload>;
  /** Updates viewed_at time stamp for a delivery route stop */
  touchDeliveryRouteStop?: Maybe<GDeliveryRouteStopViewedAtUpdatePayload>;
  /**
   * Transform product image: remove background, standardize, enhance.
   * Accepts an S3 URL from signedUploadImageByKey (e.g., "https://s3.amazonaws.com/bucket/tmp/uuid.png").
   */
  transformProductImage: GTransformProductImageResult;
  /** Translate an instruction note into Spanish, reusing the saved translation while its source text is unchanged. */
  translateDeliveryInstruction?: Maybe<GTranslateDeliveryInstructionMutationPayload>;
  /** Enqueue the HubSpot rep assignment sync job on demand */
  triggerHubspotRepSync?: Maybe<GTriggerHubspotRepSyncPayload>;
  /**
   * Triggers a manual (GM) Routific run for a warehouse and night in the given
   * mode. The run is processed asynchronously; observe it via
   * RoutingImportPlan.manualRoutificRuns.
   */
  triggerManualRoutificRun?: Maybe<GTriggerManualRoutificRunPayload>;
  /** Initiates synchronization of routes and stops, triggering Kafka events. */
  triggerRoutesSync?: Maybe<GTriggerRoutesSyncPayload>;
  /**
   * Triggers a proposed (scenario) Routific run for a warehouse and night. The run
   * never touches dispatched routes; observe it via RoutingImportPlan.scenarios.
   */
  triggerRoutificScenarioRun?: Maybe<GTriggerRoutificScenarioRunPayload>;
  /** Turn off supply for a Location. Writes to NetSuite (custentity_supply_signed_up) and updates local caches. */
  turnOffLocationSupply?: Maybe<GTurnOffLocationSupplyMutationPayload>;
  unapproveCutoffDiscrepancy?: Maybe<GUnapproveCutoffDiscrepancyPayload>;
  /**
   * Undoes a recorded replenishment trip by dispatching a new opposite-direction
   * Bin Transfer. Any associate can undo a replenishment trip, however long ago it
   * was recorded, once it has been confirmed, so it is not instant.
   */
  undoReplenishmentPick?: Maybe<GUndoReplenishmentPickPayload>;
  /**
   * Reverts a route marked for a third-party provider back to a GM-built generic
   * route (epic sc-66318). Allowed after a failed push and from quoting until the
   * route is dispatched, and after the provider canceled a dispatched route when
   * nothing on it was recorded yet (sc-67290, where the warehouse allows canceling
   * dispatched routes). The call makes no request to the provider and never waits
   * on it: the route is reverted at once and a background sweep deletes the
   * provider's draft route and orders within minutes. A route marked as "Route NN
   * (Provider)" gets its "Route NN" name back. Refused while the push is running
   * ("push in progress, retry shortly").
   */
  unmarkRouteProvider?: Maybe<GUnmarkRouteProviderPayload>;
  /** Delete the user's incomplete subscription for this item at this location, if such a subscription exists. */
  unsubscribeFromBackInStockNotification?: Maybe<GUnsubscribeFromBackInStockNotificationMutationPayload>;
  /** Updates stop arrived_at time */
  updateArrivedAtStopTime?: Maybe<GUpdateArrivedAtStopTimePayload>;
  updateBrandedItemDeal?: Maybe<GUpdateBrandedItemDealMutationPayload>;
  /** Update the selected size/quantity/note/modifiers on specific cart items. */
  updateCartItems?: Maybe<GUpdateCartItemsPayload>;
  /** Update app config */
  updateConfig?: Maybe<GUpdateConfigPayload>;
  /** Update current consumer app user. */
  updateCurrentConsumerAppUser?: Maybe<GUpdateCurrentConsumerAppUserPayload>;
  /** Update current consumer app user phone number. */
  updateCurrentConsumerAppUserPhoneNumber?: Maybe<GUpdateCurrentConsumerAppUserPhoneNumberPayload>;
  updateCustomIngredient?: Maybe<GUpdateCustomIngredientMutationPayload>;
  updateCustomerTag?: Maybe<GUpdateCustomerTagMutationPayload>;
  updateCustomerTrackingSettings?: Maybe<GUpdateCustomerTrackingSettingsPayload>;
  /** Update a delivery issue for a delivery route stop */
  updateDeliveryIssue?: Maybe<GDeliveryIssueUpdatePayload>;
  /** Updates stop departed_at time */
  updateDepartedAtStopTime?: Maybe<GUpdateDepartedAtStopTimePayload>;
  /** Update a driver safety acknowledgement */
  updateDriverSafetyAcknowledgement?: Maybe<GDriverSafetyAcknowledgementUpdatePayload>;
  updateExternalBaseBrandedItem?: Maybe<GUpdateExternalBaseBrandedItemMutationPayload>;
  /** PROTOTYPE store reified order information for the orders created from GeneratedOrderQuantities. */
  updateGeneratedOrderQuantities?: Maybe<GUpdateGeneratedOrderQuantitiesMutationPayload>;
  /** Update a guest player's username */
  updateGuestUsername?: Maybe<GUpdateGuestUsernameMutationPayload>;
  updateHomepageDisplayRules?: Maybe<GUpdateHomepageDisplayRulesPayload>;
  updateInHouseBaseBrandedItem?: Maybe<GUpdateInHouseBaseBrandedItemMutationPayload>;
  updateInProgressCustomer?: Maybe<GUpdateInProgressCustomerMutationPayload>;
  updateInventoryItem?: Maybe<GSupplyItem>;
  updateItemBrand?: Maybe<GItemBrandUpdatePayload>;
  /**
   * Correct how an inventory item builds a pallet. `casesPerPallet` is derived as
   * `casesPerLayer * layersPerPallet` and so is not accepted here; read it back off the returned item.
   * Narrow on purpose: warehouse associates may fix a pallet build without the broader item write access
   * `updateInventoryItem` carries.
   */
  updateItemPalletConfiguration: GUpdateItemPalletConfigurationPayload;
  updateItemPrices: GUpdateItemPricesPayload;
  updateItemTag?: Maybe<GItemTag>;
  /** Updates a line-level delivery reason. Pass `subReasonCode: null` explicitly to clear the field; omit to leave unchanged. */
  updateLineLevelDeliveryIssue?: Maybe<GLineLevelDeliveryIssueUpdatePayload>;
  /**
   * Update the boolean that determines if a stop should be included in the
   * automated routing for that warehouse. True means the location will get routed.
   * False means the location will remain in the lobby.
   */
  updateLocationIncludeInAutomatedRouting?: Maybe<GLocationIncludeInAutomatedRoutingUpdatePayload>;
  updateLocationOpeningHours?: Maybe<GUpdateLocationOpeningHoursMutationPayload>;
  updateLocationOpeningHoursFromGoogle?: Maybe<GUpdateLocationOpeningHoursFromGooglePayload>;
  /** PROTOTYPE mutation to manually associate a platform's profile with a particular Odeko location */
  updateLocationPlatformProfile?: Maybe<GUpdateLocationPlatformProfileMutationPayload>;
  /**
   * Update the boolean marking locations as warehouse-pickup customers. True means
   * the customer collects their order at the warehouse instead of receiving a delivery.
   */
  updateLocationsCustomerPickup?: Maybe<GLocationsCustomerPickupUpdatePayload>;
  /** Update deliver_within_store_hours field for multiple locations */
  updateLocationsDeliverWithinStoreHours?: Maybe<GUpdateLocationsDeliverWithinStoreHoursMutationPayload>;
  /** Update the boolean that determines if a stop should enforce item scanning for an array of locations. */
  updateLocationsEnforceItemScanning?: Maybe<GLocationsEnforceItemScanningUpdatePayload>;
  /**
   * Update the boolean that determines if a stop should be included in the
   * automated routing for that warehouse for an array of locations. True means the
   * location will get routed. False means the location will remain in the lobby.
   */
  updateLocationsIncludeInAutomatedRouting?: Maybe<GLocationsIncludeInAutomatedRoutingUpdatePayload>;
  /** Update the boolean that determines if a location's printed delivery sheets show prices, fees, and totals for an array of locations. */
  updateLocationsIncludeFinancialsOnDeliverySheet?: Maybe<GLocationsIncludeFinancialsOnDeliverySheetUpdatePayload>;
  /** Update the boolean that determines if a location opts in to printable delivery sheets for an array of locations. */
  updateLocationsPrintDeliverySheetEnabled?: Maybe<GLocationsPrintDeliverySheetEnabledUpdatePayload>;
  /** Updates the associated routing cohort for a list of locations. */
  updateLocationsRoutingCohort?: Maybe<GUpdateLocationsRoutingCohortMutationPayload>;
  /**
   * Update the service time for an array of locations. The service time is the
   * time it takes to perform a delivery at a location. This is used to calculate
   * the total time for a delivery route.
   */
  updateLocationsServiceTime?: Maybe<GLocationsServiceTimeUpdatePayload>;
  /** Set the location-owned third-party delivery exclusion for one or more locations. */
  updateLocationsThirdPartyExclusion?: Maybe<GLocationsThirdPartyExclusionUpdatePayload>;
  /** Update a marketing QR code. */
  updateMarketingQrCode?: Maybe<GUpdateMarketingQrCodeMutationPayload>;
  /** Update marketing QR codes from CSV. */
  updateMarketingQrCodesFromCsv?: Maybe<GUpdateMarketingQrCodesFromCsvMutationPayload>;
  /** Update a menu-item's saved visibility */
  updateMenuItemSavedVisibility?: Maybe<GUpdateMenuItemSavedVisibilityPayload>;
  /** Update menu-items sort order */
  updateMenuItemsSortOrder?: Maybe<GUpdateMenuItemsSortOrderPayload>;
  /** Update a menu's saved visibility */
  updateMenuSavedVisibility?: Maybe<GUpdateMenuSavedVisibilityPayload>;
  /** Update menus sort order */
  updateMenusSortOrder?: Maybe<GUpdateMenusSortOrderPayload>;
  /** Update merchant curbsidePickup */
  updateMerchantCurbsidePickup?: Maybe<GUpdateMerchantCurbsidePickupPayload>;
  /** Update the notification sound used by merchant app */
  updateMerchantNotificationSound?: Maybe<GUpdateMerchantNotificationSoundPayload>;
  /** Update merchant pickupText */
  updateMerchantPickupText?: Maybe<GUpdateMerchantPickupTextPayload>;
  /** Update merchant status */
  updateMerchantStatus?: Maybe<GUpdateMerchantStatusPayload>;
  /** Update the ad information for a microsite location. */
  updateMicrositeAdInfo?: Maybe<GUpdateMicrositeAdInfoPayload>;
  /** Update the details of an existing microsite (eg its configuration). */
  updateMicrositeLocation?: Maybe<GUpdateMicrositeMutationPayload>;
  /** Specify a total ordering for the modules of a microsite location, regardless of visibility. */
  updateMicrositeModulesOrder?: Maybe<GUpdateMicrositeModulesOrderPayload>;
  /** Update a modifier group saved visibility */
  updateModifierGroupSavedVisibility?: Maybe<GUpdateModifierGroupSavedVisibilityPayload>;
  /** Update modifier-groups sort order */
  updateModifierGroupsSortOrder?: Maybe<GUpdateModifierGroupsSortOrderPayload>;
  /** Update a modifier option saved visibility */
  updateModifierOptionSavedVisibility?: Maybe<GUpdateModifierOptionSavedVisibilityPayload>;
  /** Update modifier-options sort order */
  updateModifierOptionsSortOrder?: Maybe<GUpdateModifierOptionsSortOrderPayload>;
  updateNonInventoryItem?: Maybe<GSupplyItem>;
  /** PROTOTYPE mutation to update an Odeko Items par value, storage area, or counting unit */
  updateOdekoItemInventory?: Maybe<GUpdateOdekoItemInventoryMutationPayload>;
  /** Update the delivery method for order(s). */
  updateOrderDeliveryMethod?: Maybe<GUpdateOrderDeliveryMethodMutationPayload>;
  /**
   * GM-only: set the delivered_quantity on an order line during DMP review. Must
   * be >= 0 (over-delivery is allowed). The note is required and flows into the
   * paper_trail version metadata. Distinct from the driver-path
   * updateOrderQuantityDelivered mutation, which bulk-updates an order's lines
   * with mark-delivered side effects.
   */
  updateOrderLineDeliveredQuantity?: Maybe<GOrderLineDeliveredQuantityUpdatePayload>;
  /**
   * GM-only: set the fulfillment_quantity on an order line during DMP review. Must
   * be >= 0 (over-fulfillment is allowed). The note is required and flows into the
   * paper_trail version metadata. For market-priced lines, the
   * purchase_price_cents and selling_price_cents are recalculated automatically
   * from the order_vendor_receiving record — same logic as the driver path. This
   * path is intentionally exempt from any future post-Route-End lock added to the
   * driver/sync paths.
   */
  updateOrderLineFulfillmentQuantity?: Maybe<GOrderLineFulfillmentQuantityUpdatePayload>;
  /**
   * GM-only: set the recovery_quantity on an order line during DMP review. Valid
   * range is [0, max(fulfillment_quantity - delivered_quantity, 0)] — the cap is
   * clamped at 0 so over-delivered lines can still record a no-recovery decision.
   * The note is required and flows into the paper_trail version metadata.
   */
  updateOrderLineRecoveryQuantity?: Maybe<GOrderLineRecoveryQuantityUpdatePayload>;
  /** Update the quantity delivered for each order line of an order */
  updateOrderQuantityDelivered?: Maybe<GOrderQuantityDeliveredUpdatePayload>;
  /** Add or update warehouse note for an order */
  updateOrderWarehouseNote?: Maybe<GOrderWarehouseNoteUpdatePayload>;
  /** Create association between a platform's profile and a microsite location */
  updatePlatformMicrositeLocation?: Maybe<GUpdatePlatformMicrositeLocationMutationPayload>;
  updateReceivableNote?: Maybe<GUpdateReceivableNotePayload>;
  /** Assigns driver to a route */
  updateRouteDetails?: Maybe<GRouteDetailsUpdatePayload>;
  /** Update a route origin */
  updateRouteOrigin?: Maybe<GRouteOriginUpdatePayload>;
  /** Add or update route stop delivery note */
  updateRouteStopDeliveryNote?: Maybe<GDeliveryRouteStopDeliveryNoteUpdatePayload>;
  /** Add or update route stop driver reminder message */
  updateRouteStopDriverReminder?: Maybe<GDeliveryRouteStopReminderUpdatePayload>;
  /** Edit an unresolved additional task on a delivery route stop */
  updateRouteStopTask?: Maybe<GDeliveryRouteStopTaskUpdatePayload>;
  /** Add or update route stop upsell note */
  updateRouteStopUpsellNote?: Maybe<GDeliveryRouteStopUpsellNoteUpdatePayload>;
  /** Updates delivery route assigned vehicle. */
  updateRouteTruck?: Maybe<GRouteTruckUpdatePayload>;
  /** Update truck count for a routing import plan */
  updateRoutingImportPlanTruckCount?: Maybe<GRoutingImportPlanTruckCountUpdatePayload>;
  updateSoApiRoutingImportPlanTruckCount?: Maybe<GUpdateSoApiRoutingImportPlanTruckCountMutationPayload>;
  /** Update an order suggestion's line items (replaces all existing line items) */
  updateSquareOrderSuggestion?: Maybe<GUpdateSquareOrderSuggestionMutationPayload>;
  /** Append transcript to an order suggestion and re-parse via GPT */
  updateSquareOrderSuggestionFromTranscript?: Maybe<GUpdateSquareOrderSuggestionFromTranscriptMutationPayload>;
  /** Updates route start time */
  updateStartRouteTime?: Maybe<GStartRouteTimeUpdatePayload>;
  /** Updates route completion time */
  updateStopRouteTime?: Maybe<GStopRouteTimeUpdatePayload>;
  /** Update a submenu's saved visibility */
  updateSubmenuSavedVisibility?: Maybe<GUpdateSubmenuSavedVisibilityPayload>;
  /** Update submenus sort order */
  updateSubmenusSortOrder?: Maybe<GUpdateSubmenusSortOrderPayload>;
  /** Update an existing subscription session with additional details (email, sign options, etc.) */
  updateSubscriptionSession?: Maybe<GUpdateSubscriptionSessionMutationPayload>;
  /** Update an existing user's profile, role, or location access */
  updateUser?: Maybe<GUpdateUserMutationPayload>;
  updateUserNotificationPreferences?: Maybe<GUpdateUserNotificationPreferencesMutationPayload>;
  /** Records the time the driver returned to the warehouse (geofence entry) */
  updateWarehouseArrivedAtRouteTime?: Maybe<GUpdateWarehouseArrivedAtRouteTimePayload>;
  /** Records the time the driver departed the warehouse (geofence exit) */
  updateWarehouseDepartedAtRouteTime?: Maybe<GUpdateWarehouseDepartedAtRouteTimePayload>;
  updateWarehousesLeadTime?: Maybe<GUpdateWarehousesLeadTimeMutationPayload>;
  uploadArtwork?: Maybe<GUploadArtworkMutationPayload>;
  uploadArtworkForItem?: Maybe<GUploadArtworkForItemMutationPayload>;
  /** Create or update an account creation session */
  upsertAccountCreationSession?: Maybe<GUpsertAccountCreationSessionPayload>;
  upsertAdminOrderItemMutation?: Maybe<GUpsertAdminOrderItemMutationPayload>;
  upsertArAssignment?: Maybe<GUpsertArAssignmentPayload>;
  upsertBackInStockSubscription?: Maybe<GUpsertBackInStockSubscriptionMutationPayload>;
  upsertCategoryBanner?: Maybe<GCategoryBannerPayload>;
  upsertDeliveryDatePoNumbers?: Maybe<GUpsertDeliveryDatePoNumbersMutationPayload>;
  /** Creates or updates an external delivery with a 3rd party delivery partner. */
  upsertExternalDeliveryMutation?: Maybe<GUpsertExternalDeliveryMutationPayload>;
  upsertExternalSupplier: GUpsertExternalSupplierPayload;
  upsertLocationAccountsReceivableCollectionsStatus?: Maybe<GUpsertLocationAccountsReceivableCollectionsStatusPayload>;
  upsertLocationItem?: Maybe<GLocationItem>;
  /** Set a location's default backup item for an item it orders */
  upsertLocationItemBackup?: Maybe<GUpsertLocationItemBackupMutationPayload>;
  /** Create or update orders for a location across one or more delivery dates */
  upsertLocationOrders?: Maybe<GUpsertLocationOrdersMutationPayload>;
  upsertLocationPhoneNumber?: Maybe<GUpsertLocationPhoneNumberMutationPayload>;
  upsertMasterHomepage?: Maybe<GUpsertMasterHomepagePayload>;
  /**
   * Create or update a guestbook message for a microsite location. This is a
   * public mutation that allows users to leave messages on the microsite.
   */
  upsertMicrositeGuestbookMessage?: Maybe<GUpsertMicrositeGuestbookMessageMutationPayload>;
  /** Create or update a menu item for a microsite location. */
  upsertMicrositeMenuItem?: Maybe<GUpsertMicrositeMenuItemPayload>;
  /** Pin an item to an absolute New Items slot for a market (re-pinning moves the item). Studio-only. */
  upsertNewItemPin: GNewItemPinPayload;
  /** Create or update an order for a location */
  upsertOrderMutation?: Maybe<GUpsertOrderMutationPayload>;
  upsertProvisionalOrder?: Maybe<GUpsertProvisionalOrderMutationPayload>;
  upsertRecipe?: Maybe<GUpsertRecipeMutationPayload>;
  upsertShippingInstructions?: Maybe<GUpsertShippingInstructionsMutationPayload>;
  /** Pin or re-pin a curated substitute for an item; idempotent on the (source, substitute) pair. Procurement-only. */
  upsertSubstitutionOverride: GSubstitutionOverridePayload;
  upsertSurvey?: Maybe<GUpsertSurveyMutationPayload>;
  upsertWarehouseZipcodes?: Maybe<GUpsertWarehouseZipcodesPayload>;
  upsertZipcodeDeliveryRule?: Maybe<GUpsertZipcodeDeliveryRulePayload>;
  upsertZipcodeDeliveryWindow?: Maybe<GUpsertZipcodeDeliveryWindowPayload>;
  /** Validate Stripe checkout session and complete subscription session for magic-portal flow */
  validateAndCompleteSubscriptionSession?: Maybe<GValidateAndCompleteSubscriptionSessionMutationPayload>;
  /** Validate Stripe checkout session status and update subscription session */
  validateSubscriptionSessionCheckout?: Maybe<GValidateSubscriptionSessionCheckoutMutationPayload>;
  voteMicrositePoll?: Maybe<GVoteMicrositePollMutationPayload>;
  /** Admin revokes an associate's current badge (advances badge_version); the badge must be reprinted. */
  warehouseAssociateBadgeRevoke?: Maybe<GWarehouseAssociateBadgeRevokePayload>;
  /** Save a warehouse's layout draft. Send the loaded revision back; a stale revision is rejected in userErrors. */
  warehouseLayoutSave?: Maybe<GWarehouseLayoutSavePayload>;
  /** Creates a shift (and its breaks) for a warehouse. */
  warehouseShiftCreate?: Maybe<GWarehouseShiftCreatePayload>;
  /** Deletes a warehouse shift and its breaks. */
  warehouseShiftDelete?: Maybe<GWarehouseShiftDeletePayload>;
  /** Updates a shift's type/times and, when breaks are given, replaces its breaks wholesale. */
  warehouseShiftUpdate?: Maybe<GWarehouseShiftUpdatePayload>;
  /** Sets the weekdays a warehouse is closed for dock booking, replacing the full set. */
  warehouseUpdateClosedDays?: Maybe<GWarehouseUpdateClosedDaysPayload>;
  /**
   * Sets the warehouse's declared daily truck ceiling per freight (can't go below
   * the admin min or the docks' current allocation).
   */
  warehouseUpdateDailyCapacity?: Maybe<GWarehouseUpdateDailyCapacityPayload>;
};


export type GMutationAccessWifiArgs = {
  input: GAccessWifiMutationInput;
};


export type GMutationAcknowledgeBackInStockNotificationArgs = {
  input: GAcknowledgeBackInStockNotificationMutationInput;
};


export type GMutationAcknowledgeConsumerOrderArgs = {
  input: GAcknowledgeConsumerOrderInput;
};


export type GMutationAcknowledgeDeliveryInstructionReviewArgs = {
  input: GAcknowledgeDeliveryInstructionReviewMutationInput;
};


export type GMutationAcknowledgeDriverSafetyAcknowledgementArgs = {
  input: GDriverSafetyAcknowledgementAcknowledgeInput;
};


export type GMutationAdHocAppointmentCreateArgs = {
  input: GAdHocAppointmentCreateInput;
};


export type GMutationAddFavoriteConsumerOrderArgs = {
  input: GAddFavoriteConsumerOrderInput;
};


export type GMutationAddItemsToCartArgs = {
  input: GAddItemsToCartInput;
};


export type GMutationAddMicrositeLocationArgs = {
  input: GAddMicrositeMutationInput;
};


export type GMutationApplyHeaderReasonToStopLineLevelDeliveryIssueArgs = {
  input: GLineLevelDeliveryIssueApplyHeaderReasonInput;
};


export type GMutationApplyRewardArgs = {
  input: GApplyRewardInput;
};


export type GMutationApplyRoutingConfigurationArgs = {
  input: GApplyRoutingConfigurationInput;
};


export type GMutationApproveCutoffDiscrepancyArgs = {
  input: GApproveCutoffDiscrepancyInput;
};


export type GMutationAssignCustomerTagArgs = {
  input: GAssignCustomerTagMutationInput;
};


export type GMutationAttachmentUrlPresignerArgs = {
  input: GAttachmentUrlPresignerCreateInput;
};


export type GMutationBatchOnboardInProgressCustomersArgs = {
  input: GBatchOnboardInProgressCustomersMutationInput;
};


export type GMutationBulkCreateSupplierInvoiceComparisonRowsArgs = {
  input: GBulkCreateSupplierInvoiceComparisonRowsInput;
};


export type GMutationBulkUpdateRouteStopsDeliveryInfoArgs = {
  input: GBulkUpdateRouteStopsDeliveryInfoInput;
};


export type GMutationBulkUpsertZipcodeDeliveryRulesArgs = {
  input: GBulkUpsertZipcodeDeliveryRulesInput;
};


export type GMutationCancelOrderMutationArgs = {
  input: GCancelOrderMutationInput;
};


export type GMutationCancelProviderRouteArgs = {
  input: GCancelProviderRouteInput;
};


export type GMutationCancelProvisionalOrderArgs = {
  input: GCancelProvisionalOrderMutationInput;
};


export type GMutationCheckinOrderVendorReceivingArgs = {
  input: GCheckinOrderVendorReceivingInput;
};


export type GMutationCheckoutArgs = {
  input: GCheckoutInput;
};


export type GMutationClaimRewardArgs = {
  input: GClaimRewardInput;
};


export type GMutationCompleteConsumerAppReferralArgs = {
  input: GCompleteConsumerAppReferralInput;
};


export type GMutationCompleteStripeCheckoutSessionArgs = {
  input: GCompleteStripeCheckoutSessionMutationInput;
};


export type GMutationCompleteSubscriptionSessionArgs = {
  input: GCompleteSubscriptionSessionMutationInput;
};


export type GMutationCompleteSupplierInvoiceUploadArgs = {
  input: GCompleteSupplierInvoiceUploadInput;
};


export type GMutationConfirmOrderReviewArgs = {
  input: GOrderReviewConfirmInput;
};


export type GMutationConfirmPutawayPalletArgs = {
  input: GConfirmPutawayPalletInput;
};


export type GMutationConfirmSquareOrderSuggestionArgs = {
  input: GConfirmSquareOrderSuggestionMutationInput;
};


export type GMutationConnectLocationCreditKeyAccountArgs = {
  input: GConnectLocationCreditKeyAccountMutationInput;
};


export type GMutationConsumerOrderCompleteArgs = {
  input: GConsumerOrderCompleteInput;
};


export type GMutationConsumerOrderPickedUpArgs = {
  input: GConsumerOrderPickedUpInput;
};


export type GMutationConsumerOrderReadyArgs = {
  input: GConsumerOrderReadyInput;
};


export type GMutationCopyDeliveryOverrideRulesArgs = {
  input: GCopyDeliveryOverrideRulesMutationInput;
};


export type GMutationCreateBrandedItemDealArgs = {
  input: GCreateBrandedItemDealMutationInput;
};


export type GMutationCreateCollectionPromoSetupArgs = {
  input: GCreateCollectionPromoSetupInput;
};


export type GMutationCreateCountingEventArgs = {
  input: GCreateCountingEventMutationInput;
};


export type GMutationCreateCustomIngredientArgs = {
  input: GCreateCustomIngredientMutationInput;
};


export type GMutationCreateCustomerTagArgs = {
  input: GCreateCustomerTagMutationInput;
};


export type GMutationCreateCustomerTagImportArgs = {
  input: GCreateCustomerTagImportMutationInput;
};


export type GMutationCreateDeliveryOverrideRuleArgs = {
  input: GCreateDeliveryOverrideRuleMutationInput;
};


export type GMutationCreateDeliveryRouteStopAttachmentArgs = {
  input: GDeliveryRouteStopAttachmentCreateInput;
};


export type GMutationCreateDirectStripeCheckoutSessionArgs = {
  input: GCreateDirectStripeCheckoutSessionMutationInput;
};


export type GMutationCreateDriverSafetyAcknowledgementArgs = {
  input: GDriverSafetyAcknowledgementCreateInput;
};


export type GMutationCreateExternalBaseBrandedItemArgs = {
  input: GCreateExternalBaseBrandedItemMutationInput;
};


export type GMutationCreateExternalDeliveryMutationArgs = {
  input: GCreateExternalDeliveryMutationInput;
};


export type GMutationCreateFieldServiceZipcodeArgs = {
  input: GCreateFieldServiceZipcodeMutationInput;
};


export type GMutationCreateFullConsumerRefundArgs = {
  input: GCreateFullConsumerRefundInput;
};


export type GMutationCreateGameArgs = {
  input: GCreateGameMutationInput;
};


export type GMutationCreateHomepageComponentArgs = {
  input: GCreateHomepageComponentInput;
};


export type GMutationCreateHomepageDisplayRuleArgs = {
  input: GCreateHomepageDisplayRuleInput;
};


export type GMutationCreateHubspotLeadArgs = {
  input: GCreateHubspotLeadInput;
};


export type GMutationCreateInHouseBaseBrandedItemArgs = {
  input: GCreateInHouseBaseBrandedItemMutationInput;
};


export type GMutationCreateInventoryItemArgs = {
  item: GInventoryItemInput;
};


export type GMutationCreateItemBrandArgs = {
  input: GItemBrandCreateInput;
};


export type GMutationCreateItemTagArgs = {
  tag: GItemTagInput;
};


export type GMutationCreateLeaderboardArgs = {
  input: GCreateLeaderboardMutationInput;
};


export type GMutationCreateLocationArgs = {
  input: GCreateLocationMutationInput;
};


export type GMutationCreateLocationVendorAssociationArgs = {
  input: GCreateLocationVendorAssociationMutationInput;
};


export type GMutationCreateMarketingToolsManagerArgs = {
  input: GCreateMarketingToolsManagerMutationInput;
};


export type GMutationCreateMenuArgs = {
  input: GCreateMenuInput;
};


export type GMutationCreateMenuItemArgs = {
  input: GCreateMenuItemInput;
};


export type GMutationCreateMicrositeLocationArgs = {
  input: GCreateMicrositeLocationMutationInput;
};


export type GMutationCreateNonInventoryItemArgs = {
  item: GNonInventoryItemInput;
};


export type GMutationCreateOrderReconciliationAttachmentUploadRequestMutationArgs = {
  input: GCreateOrderReconciliationAttachmentUploadRequestMutationInput;
};


export type GMutationCreateOrderReconciliationMutationArgs = {
  input: GCreateOrderReconciliationMutationInput;
};


export type GMutationCreatePartialConsumerRefundArgs = {
  input: GCreatePartialConsumerRefundInput;
};


export type GMutationCreateReceivableNoteArgs = {
  input: GCreateReceivableNoteInput;
};


export type GMutationCreateRedeliveryStopsArgs = {
  input: GRedeliveryStopCreateInput;
};


export type GMutationCreateRouteStopTaskArgs = {
  input: GDeliveryRouteStopTaskCreateInput;
};


export type GMutationCreateSalesTaxEstimateArgs = {
  input: GCreateSalesTaxEstimateMutationInput;
};


export type GMutationCreateSignPurchaseCheckoutSessionArgs = {
  input: GCreateSignPurchaseCheckoutSessionMutationInput;
};


export type GMutationCreateSquareOrderSuggestionFromTranscriptArgs = {
  input: GCreateSquareOrderSuggestionFromTranscriptMutationInput;
};


export type GMutationCreateStorageAreaArgs = {
  input: GCreateStorageAreaMutationInput;
};


export type GMutationCreateStripeCheckoutSessionArgs = {
  input: GCreateStripeCheckoutSessionMutationInput;
};


export type GMutationCreateSubmenuArgs = {
  input: GCreateSubmenuInput;
};


export type GMutationCreateSupplierInvoiceArgs = {
  input: GCreateSupplierInvoiceInput;
};


export type GMutationCreateSupplierInvoiceComparisonArgs = {
  input: GCreateSupplierInvoiceComparisonInput;
};


export type GMutationCreateUserArgs = {
  input: GCreateUserMutationInput;
};


export type GMutationCreateUserMicrositeLocationArgs = {
  input: GCreateUserMicrositeLocationInput;
};


export type GMutationCreateVehicleInspectionReportArgs = {
  input: GVehicleInspectionReportCreateInput;
};


export type GMutationCreateWarehouseDeliveryRouteArgs = {
  input: GDeliveryRouteCreateInput;
};


export type GMutationCreateWorkThreadArgs = {
  input: GCreateWorkThreadInput;
};


export type GMutationDeleteArAssignmentArgs = {
  input: GDeleteArAssignmentInput;
};


export type GMutationDeleteCategoryBannerArgs = {
  input: GDeleteCategoryBannerInput;
};


export type GMutationDeleteCollectionPromoSetupArgs = {
  input: GDeleteCollectionPromoSetupInput;
};


export type GMutationDeleteCustomerTagArgs = {
  input: GDeleteCustomerTagMutationInput;
};


export type GMutationDeleteDeliveryIssueArgs = {
  input: GDeliveryIssueDeleteInput;
};


export type GMutationDeleteDeliveryOverrideRuleArgs = {
  input: GDeleteDeliveryOverrideRuleMutationInput;
};


export type GMutationDeleteDeliveryRouteStopAttachmentArgs = {
  input: GDeliveryRouteStopAttachmentDeleteInput;
};


export type GMutationDeleteDriverSafetyAcknowledgementArgs = {
  input: GDriverSafetyAcknowledgementDeleteInput;
};


export type GMutationDeleteFieldServiceZipcodeArgs = {
  input: GDeleteFieldServiceZipcodeMutationInput;
};


export type GMutationDeleteItemBrandArgs = {
  input: GItemBrandDeleteInput;
};


export type GMutationDeleteLineLevelDeliveryIssueArgs = {
  input: GLineLevelDeliveryIssueDeleteInput;
};


export type GMutationDeleteLocationAccountsReceivableCollectionsStatusArgs = {
  input: GDeleteLocationAccountsReceivableCollectionsStatusInput;
};


export type GMutationDeleteLocationPaymentMethodArgs = {
  input: GDeleteLocationPaymentMethodMutationInput;
};


export type GMutationDeleteLocationPhoneNumberArgs = {
  input: GDeleteLocationPhoneNumberMutationInput;
};


export type GMutationDeleteMasterHomepageArgs = {
  input: GDeleteMasterHomepageInput;
};


export type GMutationDeleteMasterHomepageRowComponentArgs = {
  input: GDeleteMasterHomepageRowComponentInput;
};


export type GMutationDeleteMicrositeMenuItemArgs = {
  input: GDeleteMicrositeMenuItemInput;
};


export type GMutationDeleteReceivableNoteArgs = {
  input: GDeleteReceivableNoteInput;
};


export type GMutationDeleteRedeliveryStopArgs = {
  input: GRedeliveryStopDeleteInput;
};


export type GMutationDeleteRouteStopTaskArgs = {
  input: GDeliveryRouteStopTaskDeleteInput;
};


export type GMutationDeleteRoutificScenarioArgs = {
  input: GDeleteRoutificScenarioInput;
};


export type GMutationDeleteS3FileArgs = {
  input: GDeleteS3FileInput;
};


export type GMutationDeleteSquareCardArgs = {
  input: GDeleteSquareCardInput;
};


export type GMutationDeleteUserMicrositeLocationArgs = {
  input: GDeleteUserMicrositeLocationMutationInput;
};


export type GMutationDeleteZipcodeArgs = {
  input: GDeleteZipcodeMutationInput;
};


export type GMutationDeleteZipcodeDeliveryRuleArgs = {
  input: GDeleteZipcodeDeliveryRuleInput;
};


export type GMutationDeliveryCompletedArgs = {
  input: GDeliveryCompletedUpdateInput;
};


export type GMutationDeliveryStopsReorderArgs = {
  input: GDeliveryStopsReorderInput;
};


export type GMutationDeprioritizeLocationArgs = {
  input: GDeprioritizeLocationInput;
};


export type GMutationDiscontinueWarehouseItemArgs = {
  id: Scalars['ID'];
  input: Array<InputMaybe<GDiscontinueWarehouseInput>>;
};


export type GMutationDispatchProviderRouteArgs = {
  input: GDispatchProviderRouteInput;
};


export type GMutationDockBookingAddPoArgs = {
  input: GDockBookingAddPoInput;
};


export type GMutationDockBookingCancelArgs = {
  input: GDockBookingCancelInput;
};


export type GMutationDockBookingMarkMissedArgs = {
  input: GDockBookingMarkMissedInput;
};


export type GMutationDockBookingOpsCheckInArgs = {
  input: GDockBookingOpsCheckInInput;
};


export type GMutationDockCreateArgs = {
  input: GDockCreateInput;
};


export type GMutationDockDeleteArgs = {
  input: GDockDeleteInput;
};


export type GMutationDockOverrideCodeIssueArgs = {
  input: GDockOverrideCodeIssueInput;
};


export type GMutationDockOverrideCodeRevokeArgs = {
  input: GDockOverrideCodeRevokeInput;
};


export type GMutationDockUpdateArgs = {
  input: GDockUpdateInput;
};


export type GMutationDockVisitDepartArgs = {
  input: GDockVisitDepartInput;
};


export type GMutationDockVisitReassignDockArgs = {
  input: GDockVisitReassignDockInput;
};


export type GMutationDuplicateMasterHomepageArgs = {
  input: GDuplicateMasterHomepageInput;
};


export type GMutationEscalateStopsToProviderArgs = {
  input: GEscalateStopsToProviderInput;
};


export type GMutationGenerateCloudinaryUploadSignatureArgs = {
  input: GGenerateUploadSignatureInput;
};


export type GMutationGenerateItemDescriptionArgs = {
  input: GGenerateItemDescriptionInput;
};


export type GMutationGenerateOrderQuantitiesArgs = {
  input: GGenerateOrderQuantitiesMutationInput;
};


export type GMutationGeneratePresignedS3UrlArgs = {
  input: GGeneratePresignedUrlMutationInput;
};


export type GMutationImportPriceRulesCsvArgs = {
  input: GImportPriceRulesCsvInput;
};


export type GMutationImportProcurementRecordsArgs = {
  input: Array<GImportProcurementInput>;
};


export type GMutationInitializeMarketingToolsSignupArgs = {
  input: GInitializeMarketingToolsSignupMutationInput;
};


export type GMutationInitiateTerminalPairingArgs = {
  input: GInitiateTerminalPairingMutationInput;
};


export type GMutationLogSalesOutreachArgs = {
  input: GLogSalesOutreachInput;
};


export type GMutationLoginConsumerAppUserFromFirebaseArgs = {
  input: GLoginConsumerAppUserFromFirebaseInput;
};


export type GMutationMakeCreditKeyChargeArgs = {
  input: GMakeCreditKeyChargeMutationInput;
};


export type GMutationMarkCompostCollectedArgs = {
  input: GDeliveryRouteStopCompostCollectedUpdateInput;
};


export type GMutationMarkCustomerPickupStopsCompleteArgs = {
  input: GMarkCustomerPickupStopsCompleteInput;
};


export type GMutationMarkDonationCollectedArgs = {
  input: GDeliveryRouteStopDonationCollectedUpdateInput;
};


export type GMutationMarkItemsAsBulkPickedArgs = {
  input: GMarkItemsAsBulkPickedMutationInput;
};


export type GMutationMarkItemsAsEcomBulkArgs = {
  input: GMarkItemsAsEcomBulkMutationInput;
};


export type GMutationMarkOrderDeliveredArgs = {
  input: GOrderDeliveredUpdateInput;
};


export type GMutationMarkRouteForProviderArgs = {
  input: GMarkRouteForProviderInput;
};


export type GMutationMoveDeliveryStopsToCustomerPickupArgs = {
  input: GMoveDeliveryStopsToCustomerPickupInput;
};


export type GMutationMoveDeliveryStopsToRouteArgs = {
  input: GDeliveryStopsMoveToRouteInput;
};


export type GMutationOrderCollectedArgs = {
  input: GOrderCollectedUpdateInput;
};


export type GMutationPerformOutOfStockChecksArgs = {
  input: GPerformOutOfStockChecksMutationInput;
};


export type GMutationPinItemAcrossMarketsArgs = {
  input: GPinItemAcrossMarketsInput;
};


export type GMutationPlatformCompleteActionArgs = {
  input: GCompleteActionMutationInput;
};


export type GMutationPricingServicePingifyArgs = {
  input: GPricingServicePingifyInput;
};


export type GMutationProcessPathAssignArgs = {
  input: GProcessPathAssignInput;
};


export type GMutationProcessPathAssociateCreateArgs = {
  input: GProcessPathAssociateCreateInput;
};


export type GMutationProcessPathAssociateSetStatusArgs = {
  input: GProcessPathAssociateSetStatusInput;
};


export type GMutationProcessPathClearCoverageTargetArgs = {
  input: GProcessPathClearCoverageTargetInput;
};


export type GMutationProcessPathClockInArgs = {
  input: GProcessPathClockInInput;
};


export type GMutationProcessPathClockOutArgs = {
  input: GProcessPathClockOutInput;
};


export type GMutationProcessPathCreateArgs = {
  input: GProcessPathCreateInput;
};


export type GMutationProcessPathReorderArgs = {
  input: GProcessPathReorderInput;
};


export type GMutationProcessPathSegmentCreateArgs = {
  input: GProcessPathSegmentCreateInput;
};


export type GMutationProcessPathSegmentDeleteArgs = {
  input: GProcessPathSegmentDeleteInput;
};


export type GMutationProcessPathSegmentEditArgs = {
  input: GProcessPathSegmentEditInput;
};


export type GMutationProcessPathSelfAssignArgs = {
  input: GProcessPathSelfAssignInput;
};


export type GMutationProcessPathSelfClockInArgs = {
  input: GProcessPathSelfClockInInput;
};


export type GMutationProcessPathSelfClockOutArgs = {
  input: GProcessPathSelfClockOutInput;
};


export type GMutationProcessPathSelfUnassignArgs = {
  input: GProcessPathSelfUnassignInput;
};


export type GMutationProcessPathSetAvailabilityArgs = {
  input: GProcessPathSetAvailabilityInput;
};


export type GMutationProcessPathSetCoverageTargetArgs = {
  input: GProcessPathSetCoverageTargetInput;
};


export type GMutationProcessPathUnassignArgs = {
  input: GProcessPathUnassignInput;
};


export type GMutationProcessPathUpdateArgs = {
  input: GProcessPathUpdateInput;
};


export type GMutationProcurementAiFeedbackSubmitArgs = {
  input: GProcurementAiFeedbackSubmitInput;
};


export type GMutationProcurementAssessmentSubmitArgs = {
  input: GProcurementAssessmentSubmitInput;
};


export type GMutationProcurementCorrespondenceCommandArgs = {
  input: GProcurementCorrespondenceCommandInput;
};


export type GMutationProcurementEmailThreadUpsertArgs = {
  input: GProcurementEmailThreadUpsertInput;
};


export type GMutationProcurementMailboxCursorSetArgs = {
  input: GProcurementMailboxCursorSetInput;
};


export type GMutationProcurementPickupCriteriaUpdateArgs = {
  input: GProcurementPickupCriteriaUpdateInput;
};


export type GMutationProcurementPoNoteCreateArgs = {
  input: GProcurementPoNoteCreateInput;
};


export type GMutationProcurementPoTrackingAssignArgs = {
  input: GProcurementPoTrackingAssignInput;
};


export type GMutationProcurementPoTrackingEnsureArgs = {
  input: GProcurementPoTrackingEnsureInput;
};


export type GMutationProcurementPoTrackingUpdateArgs = {
  input: GProcurementPoTrackingUpdateInput;
};


export type GMutationProcurementStatusOverrideArgs = {
  input: GProcurementStatusOverrideInput;
};


export type GMutationProcurementThreadAssignToPoArgs = {
  input: GProcurementThreadAssignToPoInput;
};


export type GMutationProcurementThreadLinkConfirmArgs = {
  input: GProcurementThreadLinkConfirmInput;
};


export type GMutationProcurementThreadLinkCreateArgs = {
  input: GProcurementThreadLinkCreateInput;
};


export type GMutationProcurementThreadTriageSetArgs = {
  input: GProcurementThreadTriageSetInput;
};


export type GMutationProcurementTrackingVendorUpsertArgs = {
  input: GProcurementTrackingVendorUpsertInput;
};


export type GMutationPublicDockBookingCancelArgs = {
  input: GPublicDockBookingCancelInput;
};


export type GMutationPublicDockBookingSubmitArgs = {
  input: GPublicDockBookingSubmitInput;
};


export type GMutationPublicDockCheckInArgs = {
  input: GPublicDockCheckInInput;
};


export type GMutationPublicDockDepartArgs = {
  input: GPublicDockDepartInput;
};


export type GMutationPublicOverrideBookingAmendArgs = {
  input: GPublicOverrideBookingAmendInput;
};


export type GMutationPublicOverrideBookingCancelArgs = {
  input: GPublicOverrideBookingCancelInput;
};


export type GMutationPublicOverrideBookingCreateArgs = {
  input: GPublicOverrideBookingCreateInput;
};


export type GMutationPublishReviewResponseArgs = {
  input: GPublishReviewResponseMutationInput;
};


export type GMutationPublishReviewResponseGbpArgs = {
  input: GPublishReviewResponseGbpMutationInput;
};


export type GMutationRebuildCartFromPastOrderArgs = {
  input: GRebuildCartFromPastOrderInput;
};


export type GMutationRecalculateCartPricesArgs = {
  input: GRecalculateCartPricesInput;
};


export type GMutationRecordDriverLocationPingsArgs = {
  input: GRecordDriverLocationPingsInput;
};


export type GMutationRecordManualBinTransferArgs = {
  input: GRecordManualBinTransferInput;
};


export type GMutationRecordReplenishmentPickArgs = {
  input: GRecordReplenishmentPickInput;
};


export type GMutationRemoveAllFromCartArgs = {
  input: GRemoveAllFromCartInput;
};


export type GMutationRemoveCustomerTagArgs = {
  input: GRemoveCustomerTagMutationInput;
};


export type GMutationRemoveFavoriteConsumerOrderArgs = {
  input: GRemoveFavoriteConsumerOrderInput;
};


export type GMutationRemoveItemsFromCartArgs = {
  input: GRemoveItemsFromCartInput;
};


export type GMutationRemoveLocationItemArgs = {
  input: GLocationItemInput;
};


export type GMutationRemoveLocationItemBackupArgs = {
  input: GRemoveLocationItemBackupMutationInput;
};


export type GMutationRemoveNewItemPinArgs = {
  input: GRemoveNewItemPinInput;
};


export type GMutationRemoveRewardArgs = {
  input: GRemoveRewardInput;
};


export type GMutationRemoveSubstitutionOverrideArgs = {
  input: GRemoveSubstitutionOverrideInput;
};


export type GMutationReopenRouteArgs = {
  input: GRouteReopenInput;
};


export type GMutationReorderNewItemPinsArgs = {
  input: GReorderNewItemPinsInput;
};


export type GMutationReportDeliveryIssueArgs = {
  input: GDeliveryIssueCreateInput;
};


export type GMutationReportLineLevelDeliveryIssueArgs = {
  input: GLineLevelDeliveryIssueReportInput;
};


export type GMutationReportPhoneNumberVerificationArgs = {
  input: GReportPhoneNumberVerificationInput;
};


export type GMutationReportPutawayExceptionArgs = {
  input: GReportPutawayExceptionInput;
};


export type GMutationReportPutawayPalletBuildCorrectionArgs = {
  input: GReportPutawayPalletBuildCorrectionInput;
};


export type GMutationRequestS3UploadArgs = {
  input: GRequestS3UploadInput;
};


export type GMutationRequestSampleArgs = {
  input: GRequestSampleMutationInput;
};


export type GMutationRequestSupplierInvoiceReadUrlArgs = {
  input: GRequestSupplierInvoiceReadUrlInput;
};


export type GMutationRequoteProviderRouteArgs = {
  input: GRequoteProviderRouteInput;
};


export type GMutationResolveProvisionalOrderLineArgs = {
  input: GResolveProvisionalOrderLineMutationInput;
};


export type GMutationResolveRouteStopTasksArgs = {
  input: GDeliveryRouteStopTasksResolveInput;
};


export type GMutationRestoreLocationArgs = {
  input: GRestoreLocationInput;
};


export type GMutationRfsmartCredentialAssignArgs = {
  input: GRfsmartCredentialAssignInput;
};


export type GMutationRfsmartCredentialRemovalCancelArgs = {
  input: GRfsmartCredentialRemovalCancelInput;
};


export type GMutationRfsmartCredentialRemovalCompleteArgs = {
  input: GRfsmartCredentialRemovalCompleteInput;
};


export type GMutationRfsmartCredentialRemovalRequestArgs = {
  input: GRfsmartCredentialRemovalRequestInput;
};


export type GMutationRfsmartCredentialSetArgs = {
  input: GRfsmartCredentialSetInput;
};


export type GMutationRfsmartCredentialSetPoolArgs = {
  input: GRfsmartCredentialSetPoolInput;
};


export type GMutationRfsmartCredentialUnassignArgs = {
  input: GRfsmartCredentialUnassignInput;
};


export type GMutationRoutingCohortShiftAssignArgs = {
  input: GRoutingCohortShiftAssignInput;
};


export type GMutationRunTransactionSyncArgs = {
  input: GRunTransactionSyncInput;
};


export type GMutationRunTransactionSyncAuditArgs = {
  input: GRunTransactionSyncAuditInput;
};


export type GMutationSaveConsumerAppReferralLinkArgs = {
  input: GSaveConsumerAppReferralLinkInput;
};


export type GMutationSaveMasterHomepageRowsArgs = {
  input: GSaveMasterHomepageRowsInput;
};


export type GMutationSaveRoutificScenarioArgs = {
  input: GSaveRoutificScenarioInput;
};


export type GMutationSaveVendorAllocationArgs = {
  input: GSaveVendorAllocationInput;
};


export type GMutationScanMarketingQrCodeArgs = {
  input: GScanMarketingQrCodeMutationInput;
};


export type GMutationSendAlignmentMessageArgs = {
  input: GSendAlignmentMessageInput;
};


export type GMutationSendBrandedPaperQuestionEmailArgs = {
  input: GSendBrandedPaperQuestionEmailMutationInput;
};


export type GMutationSendChatMessageArgs = {
  input: GSendChatMessageInput;
};


export type GMutationSendEquipmentCheckoutEmailArgs = {
  input: GSendEquipmentCheckoutEmailMutationInput;
};


export type GMutationSendEquipmentQuestionEmailArgs = {
  input: GSendEquipmentQuestionEmailMutationInput;
};


export type GMutationSetDefaultPaymentMethodForLocationsArgs = {
  input: GSetDefaultPaymentMethodForLocationsMutationInput;
};


export type GMutationSetFinancialStatementPreferencesArgs = {
  input: GSetFinancialStatementPreferencesMutationInput;
};


export type GMutationSetFleetCompositionArgs = {
  input: GSetFleetCompositionInput;
};


export type GMutationSetFundApplicationExclusionsArgs = {
  input: GSetFundApplicationExclusionsInput;
};


export type GMutationSetInvoiceExternalSupplierArgs = {
  input: GSetInvoiceExternalSupplierInput;
};


export type GMutationSetItemInactiveArgs = {
  id: Scalars['ID'];
  inactive: Scalars['Boolean'];
};


export type GMutationSetLocationAutopayArgs = {
  input: GSetLocationAutopayMutationInput;
};


export type GMutationSetLocationStandingPoNumberArgs = {
  input: GSetLocationStandingPoNumberMutationInput;
};


export type GMutationSetMerchantOperatingHoursArgs = {
  input: GSetMerchantOperatingHoursInput;
};


export type GMutationSetTipArgs = {
  input: GSetTipInput;
};


export type GMutationSignupArgs = {
  input: GSignupMutationInput;
};


export type GMutationStandingAppointmentCreateArgs = {
  input: GStandingAppointmentCreateInput;
};


export type GMutationStandingAppointmentResolveFailedDateArgs = {
  input: GStandingAppointmentResolveFailedDateInput;
};


export type GMutationStandingAppointmentUpdateEffectiveUntilArgs = {
  input: GStandingAppointmentUpdateEffectiveUntilInput;
};


export type GMutationStartCustomerTagImportArgs = {
  input: GStartCustomerTagImportMutationInput;
};


export type GMutationStartPhoneNumberVerificationArgs = {
  input: GStartPhoneNumberVerificationInput;
};


export type GMutationStopBatchOnboardRunArgs = {
  input: GStopBatchOnboardRunMutationInput;
};


export type GMutationSubmitCheckInArgs = {
  input: GSubmitCheckInMutationInput;
};


export type GMutationSubmitMailingListArgs = {
  input: GSubmitMailingListMutationInput;
};


export type GMutationSubmitPurchaseHistoryFeedbackArgs = {
  input: GSubmitPurchaseHistoryFeedbackInput;
};


export type GMutationSubmitScoreArgs = {
  input: GSubmitScoreMutationInput;
};


export type GMutationSubmitStockCountArgs = {
  input: GSubmitStockCountMutationInput;
};


export type GMutationSubmitSuggestionArgs = {
  input: GSubmitSuggestionMutationInput;
};


export type GMutationSupplyClearCartArgs = {
  input: GSupplyClearCartInput;
};


export type GMutationSupplyRemoveCartItemArgs = {
  input: GSupplyRemoveCartItemInput;
};


export type GMutationSupplyUpsertCartItemArgs = {
  input: GSupplyUpsertCartItemInput;
};


export type GMutationSyncMicrositeConfigArgs = {
  input: GSyncMicrositeConfigMutationInput;
};


export type GMutationTouchDeliveryRouteStopArgs = {
  input: GDeliveryRouteStopViewedAtUpdateInput;
};


export type GMutationTransformProductImageArgs = {
  input: GTransformProductImageInput;
};


export type GMutationTranslateDeliveryInstructionArgs = {
  input: GTranslateDeliveryInstructionMutationInput;
};


export type GMutationTriggerHubspotRepSyncArgs = {
  input: GTriggerHubspotRepSyncInput;
};


export type GMutationTriggerManualRoutificRunArgs = {
  input: GTriggerManualRoutificRunInput;
};


export type GMutationTriggerRoutesSyncArgs = {
  input: GTriggerRoutesSyncInput;
};


export type GMutationTriggerRoutificScenarioRunArgs = {
  input: GTriggerRoutificScenarioRunInput;
};


export type GMutationTurnOffLocationSupplyArgs = {
  input: GTurnOffLocationSupplyMutationInput;
};


export type GMutationUnapproveCutoffDiscrepancyArgs = {
  input: GUnapproveCutoffDiscrepancyInput;
};


export type GMutationUndoReplenishmentPickArgs = {
  input: GUndoReplenishmentPickInput;
};


export type GMutationUnmarkRouteProviderArgs = {
  input: GUnmarkRouteProviderInput;
};


export type GMutationUnsubscribeFromBackInStockNotificationArgs = {
  input: GUnsubscribeFromBackInStockNotificationMutationInput;
};


export type GMutationUpdateArrivedAtStopTimeArgs = {
  input: GUpdateArrivedAtStopTimeInput;
};


export type GMutationUpdateBrandedItemDealArgs = {
  input: GUpdateBrandedItemDealMutationInput;
};


export type GMutationUpdateCartItemsArgs = {
  input: GUpdateCartItemsInput;
};


export type GMutationUpdateConfigArgs = {
  input: GUpdateConfigInput;
};


export type GMutationUpdateCurrentConsumerAppUserArgs = {
  input: GUpdateCurrentConsumerAppUserInput;
};


export type GMutationUpdateCurrentConsumerAppUserPhoneNumberArgs = {
  input: GUpdateCurrentConsumerAppUserPhoneNumberInput;
};


export type GMutationUpdateCustomIngredientArgs = {
  input: GUpdateCustomIngredientMutationInput;
};


export type GMutationUpdateCustomerTagArgs = {
  input: GUpdateCustomerTagMutationInput;
};


export type GMutationUpdateCustomerTrackingSettingsArgs = {
  input: GUpdateCustomerTrackingSettingsInput;
};


export type GMutationUpdateDeliveryIssueArgs = {
  input: GDeliveryIssueUpdateInput;
};


export type GMutationUpdateDepartedAtStopTimeArgs = {
  input: GUpdateDepartedAtStopTimeInput;
};


export type GMutationUpdateDriverSafetyAcknowledgementArgs = {
  input: GDriverSafetyAcknowledgementUpdateInput;
};


export type GMutationUpdateExternalBaseBrandedItemArgs = {
  input: GUpdateExternalBaseBrandedItemMutationInput;
};


export type GMutationUpdateGeneratedOrderQuantitiesArgs = {
  input: GUpdateGeneratedOrderQuantitiesMutationInput;
};


export type GMutationUpdateGuestUsernameArgs = {
  input: GUpdateGuestUsernameMutationInput;
};


export type GMutationUpdateHomepageDisplayRulesArgs = {
  input: GUpdateHomepageDisplayRulesInput;
};


export type GMutationUpdateInHouseBaseBrandedItemArgs = {
  input: GUpdateInHouseBaseBrandedItemMutationInput;
};


export type GMutationUpdateInProgressCustomerArgs = {
  input: GUpdateInProgressCustomerMutationInput;
};


export type GMutationUpdateInventoryItemArgs = {
  id: Scalars['ID'];
  item: GInventoryItemInput;
};


export type GMutationUpdateItemBrandArgs = {
  input: GItemBrandUpdateInput;
};


export type GMutationUpdateItemPalletConfigurationArgs = {
  casesPerLayer: Scalars['Int'];
  itemId: Scalars['ID'];
  layersPerPallet: Scalars['Int'];
};


export type GMutationUpdateItemPricesArgs = {
  input: GUpdateItemPricesInput;
};


export type GMutationUpdateItemTagArgs = {
  id: Scalars['ID'];
  tag: GItemTagInput;
};


export type GMutationUpdateLineLevelDeliveryIssueArgs = {
  input: GLineLevelDeliveryIssueUpdateInput;
};


export type GMutationUpdateLocationIncludeInAutomatedRoutingArgs = {
  input: GLocationIncludeInAutomatedRoutingUpdateInput;
};


export type GMutationUpdateLocationOpeningHoursArgs = {
  input: GUpdateLocationOpeningHoursMutationInput;
};


export type GMutationUpdateLocationOpeningHoursFromGoogleArgs = {
  input: GUpdateLocationOpeningHoursFromGoogleInput;
};


export type GMutationUpdateLocationPlatformProfileArgs = {
  input: GUpdateLocationPlatformProfileMutationInput;
};


export type GMutationUpdateLocationsCustomerPickupArgs = {
  input: GLocationsCustomerPickupUpdateInput;
};


export type GMutationUpdateLocationsDeliverWithinStoreHoursArgs = {
  input: GUpdateLocationsDeliverWithinStoreHoursMutationInput;
};


export type GMutationUpdateLocationsEnforceItemScanningArgs = {
  input: GLocationsEnforceItemScanningUpdateInput;
};


export type GMutationUpdateLocationsIncludeInAutomatedRoutingArgs = {
  input: GLocationsIncludeInAutomatedRoutingUpdateInput;
};


export type GMutationUpdateLocationsIncludeFinancialsOnDeliverySheetArgs = {
  input: GLocationsIncludeFinancialsOnDeliverySheetUpdateInput;
};


export type GMutationUpdateLocationsPrintDeliverySheetEnabledArgs = {
  input: GLocationsPrintDeliverySheetEnabledUpdateInput;
};


export type GMutationUpdateLocationsRoutingCohortArgs = {
  input: GUpdateLocationsRoutingCohortMutationInput;
};


export type GMutationUpdateLocationsServiceTimeArgs = {
  input: GLocationsServiceTimeUpdateInput;
};


export type GMutationUpdateLocationsThirdPartyExclusionArgs = {
  input: GLocationsThirdPartyExclusionUpdateInput;
};


export type GMutationUpdateMarketingQrCodeArgs = {
  input: GUpdateMarketingQrCodeMutationInput;
};


export type GMutationUpdateMarketingQrCodesFromCsvArgs = {
  input: GUpdateMarketingQrCodesFromCsvMutationInput;
};


export type GMutationUpdateMenuItemSavedVisibilityArgs = {
  input: GUpdateMenuItemSavedVisibilityInput;
};


export type GMutationUpdateMenuItemsSortOrderArgs = {
  input: GUpdateMenuItemsSortOrderInput;
};


export type GMutationUpdateMenuSavedVisibilityArgs = {
  input: GUpdateMenuSavedVisibilityInput;
};


export type GMutationUpdateMenusSortOrderArgs = {
  input: GUpdateMenusSortOrderInput;
};


export type GMutationUpdateMerchantCurbsidePickupArgs = {
  input: GUpdateMerchantCurbsidePickupInput;
};


export type GMutationUpdateMerchantNotificationSoundArgs = {
  input: GUpdateMerchantNotificationSoundInput;
};


export type GMutationUpdateMerchantPickupTextArgs = {
  input: GUpdateMerchantPickupTextInput;
};


export type GMutationUpdateMerchantStatusArgs = {
  input: GUpdateMerchantStatusInput;
};


export type GMutationUpdateMicrositeAdInfoArgs = {
  input: GUpdateMicrositeAdInfoInput;
};


export type GMutationUpdateMicrositeLocationArgs = {
  input: GUpdateMicrositeMutationInput;
};


export type GMutationUpdateMicrositeModulesOrderArgs = {
  input: GUpdateMicrositeModulesOrderInput;
};


export type GMutationUpdateModifierGroupSavedVisibilityArgs = {
  input: GUpdateModifierGroupSavedVisibilityInput;
};


export type GMutationUpdateModifierGroupsSortOrderArgs = {
  input: GUpdateModifierGroupsSortOrderInput;
};


export type GMutationUpdateModifierOptionSavedVisibilityArgs = {
  input: GUpdateModifierOptionSavedVisibilityInput;
};


export type GMutationUpdateModifierOptionsSortOrderArgs = {
  input: GUpdateModifierOptionsSortOrderInput;
};


export type GMutationUpdateNonInventoryItemArgs = {
  id: Scalars['ID'];
  item: GNonInventoryItemInput;
};


export type GMutationUpdateOdekoItemInventoryArgs = {
  input: GUpdateOdekoItemInventoryMutationInput;
};


export type GMutationUpdateOrderDeliveryMethodArgs = {
  input: GUpdateOrderDeliveryMethodMutationInput;
};


export type GMutationUpdateOrderLineDeliveredQuantityArgs = {
  input: GOrderLineDeliveredQuantityUpdateInput;
};


export type GMutationUpdateOrderLineFulfillmentQuantityArgs = {
  input: GOrderLineFulfillmentQuantityUpdateInput;
};


export type GMutationUpdateOrderLineRecoveryQuantityArgs = {
  input: GOrderLineRecoveryQuantityUpdateInput;
};


export type GMutationUpdateOrderQuantityDeliveredArgs = {
  input: GOrderQuantityDeliveredUpdateInput;
};


export type GMutationUpdateOrderWarehouseNoteArgs = {
  input: GOrderWarehouseNoteUpdateInput;
};


export type GMutationUpdatePlatformMicrositeLocationArgs = {
  input: GUpdatePlatformMicrositeLocationMutationInput;
};


export type GMutationUpdateReceivableNoteArgs = {
  input: GUpdateReceivableNoteInput;
};


export type GMutationUpdateRouteDetailsArgs = {
  input: GRouteDetailsUpdateInput;
};


export type GMutationUpdateRouteOriginArgs = {
  input: GRouteOriginUpdateInput;
};


export type GMutationUpdateRouteStopDeliveryNoteArgs = {
  input: GDeliveryRouteStopDeliveryNoteUpdateInput;
};


export type GMutationUpdateRouteStopDriverReminderArgs = {
  input: GDeliveryRouteStopReminderUpdateInput;
};


export type GMutationUpdateRouteStopTaskArgs = {
  input: GDeliveryRouteStopTaskUpdateInput;
};


export type GMutationUpdateRouteStopUpsellNoteArgs = {
  input: GDeliveryRouteStopUpsellNoteUpdateInput;
};


export type GMutationUpdateRouteTruckArgs = {
  input: GRouteTruckUpdateInput;
};


export type GMutationUpdateRoutingImportPlanTruckCountArgs = {
  input: GRoutingImportPlanTruckCountUpdateInput;
};


export type GMutationUpdateSoApiRoutingImportPlanTruckCountArgs = {
  input: GUpdateSoApiRoutingImportPlanTruckCountMutationInput;
};


export type GMutationUpdateSquareOrderSuggestionArgs = {
  input: GUpdateSquareOrderSuggestionMutationInput;
};


export type GMutationUpdateSquareOrderSuggestionFromTranscriptArgs = {
  input: GUpdateSquareOrderSuggestionFromTranscriptMutationInput;
};


export type GMutationUpdateStartRouteTimeArgs = {
  input: GStartRouteTimeUpdateInput;
};


export type GMutationUpdateStopRouteTimeArgs = {
  input: GStopRouteTimeUpdateInput;
};


export type GMutationUpdateSubmenuSavedVisibilityArgs = {
  input: GUpdateSubmenuSavedVisibilityInput;
};


export type GMutationUpdateSubmenusSortOrderArgs = {
  input: GUpdateSubmenusSortOrderInput;
};


export type GMutationUpdateSubscriptionSessionArgs = {
  input: GUpdateSubscriptionSessionMutationInput;
};


export type GMutationUpdateUserArgs = {
  input: GUpdateUserMutationInput;
};


export type GMutationUpdateUserNotificationPreferencesArgs = {
  input: GUpdateUserNotificationPreferencesMutationInput;
};


export type GMutationUpdateWarehouseArrivedAtRouteTimeArgs = {
  input: GUpdateWarehouseArrivedAtRouteTimeInput;
};


export type GMutationUpdateWarehouseDepartedAtRouteTimeArgs = {
  input: GUpdateWarehouseDepartedAtRouteTimeInput;
};


export type GMutationUpdateWarehousesLeadTimeArgs = {
  input: GUpdateWarehousesLeadTimeMutationInput;
};


export type GMutationUploadArtworkArgs = {
  input: GUploadArtworkMutationInput;
};


export type GMutationUploadArtworkForItemArgs = {
  input: GUploadArtworkForItemMutationInput;
};


export type GMutationUpsertAccountCreationSessionArgs = {
  input: GUpsertAccountCreationSessionInput;
};


export type GMutationUpsertAdminOrderItemMutationArgs = {
  input: GUpsertAdminOrderItemMutationInput;
};


export type GMutationUpsertArAssignmentArgs = {
  input: GUpsertArAssignmentInput;
};


export type GMutationUpsertBackInStockSubscriptionArgs = {
  input: GUpsertBackInStockSubscriptionMutationInput;
};


export type GMutationUpsertCategoryBannerArgs = {
  input: GUpsertCategoryBannerInput;
};


export type GMutationUpsertDeliveryDatePoNumbersArgs = {
  input: GUpsertDeliveryDatePoNumbersMutationInput;
};


export type GMutationUpsertExternalDeliveryMutationArgs = {
  input: GUpsertExternalDeliveryMutationInput;
};


export type GMutationUpsertExternalSupplierArgs = {
  input: GUpsertExternalSupplierInput;
};


export type GMutationUpsertLocationAccountsReceivableCollectionsStatusArgs = {
  input: GUpsertLocationAccountsReceivableCollectionsStatusInput;
};


export type GMutationUpsertLocationItemArgs = {
  input: GLocationItemInput;
};


export type GMutationUpsertLocationItemBackupArgs = {
  input: GUpsertLocationItemBackupMutationInput;
};


export type GMutationUpsertLocationOrdersArgs = {
  input: GUpsertLocationOrdersMutationInput;
};


export type GMutationUpsertLocationPhoneNumberArgs = {
  input: GUpsertLocationPhoneNumberMutationInput;
};


export type GMutationUpsertMasterHomepageArgs = {
  input: GUpsertMasterHomepageInput;
};


export type GMutationUpsertMicrositeGuestbookMessageArgs = {
  input: GUpsertMicrositeGuestbookMessageMutationInput;
};


export type GMutationUpsertMicrositeMenuItemArgs = {
  input: GUpsertMicrositeMenuItemInput;
};


export type GMutationUpsertNewItemPinArgs = {
  input: GUpsertNewItemPinInput;
};


export type GMutationUpsertOrderMutationArgs = {
  input: GUpsertOrderMutationInput;
};


export type GMutationUpsertProvisionalOrderArgs = {
  input: GUpsertProvisionalOrderMutationInput;
};


export type GMutationUpsertRecipeArgs = {
  input: GUpsertRecipeMutationInput;
};


export type GMutationUpsertShippingInstructionsArgs = {
  input: GUpsertShippingInstructionsMutationInput;
};


export type GMutationUpsertSubstitutionOverrideArgs = {
  input: GUpsertSubstitutionOverrideInput;
};


export type GMutationUpsertSurveyArgs = {
  input: GUpsertSurveyMutationInput;
};


export type GMutationUpsertWarehouseZipcodesArgs = {
  input: GUpsertWarehouseZipcodesInput;
};


export type GMutationUpsertZipcodeDeliveryRuleArgs = {
  input: GUpsertZipcodeDeliveryRuleInput;
};


export type GMutationUpsertZipcodeDeliveryWindowArgs = {
  input: GUpsertZipcodeDeliveryWindowInput;
};


export type GMutationValidateAndCompleteSubscriptionSessionArgs = {
  input: GValidateAndCompleteSubscriptionSessionMutationInput;
};


export type GMutationValidateSubscriptionSessionCheckoutArgs = {
  input: GValidateSubscriptionSessionCheckoutMutationInput;
};


export type GMutationVoteMicrositePollArgs = {
  input: GVoteMicrositePollMutationInput;
};


export type GMutationWarehouseAssociateBadgeRevokeArgs = {
  input: GWarehouseAssociateBadgeRevokeInput;
};


export type GMutationWarehouseLayoutSaveArgs = {
  input: GWarehouseLayoutSaveInput;
};


export type GMutationWarehouseShiftCreateArgs = {
  input: GWarehouseShiftCreateInput;
};


export type GMutationWarehouseShiftDeleteArgs = {
  input: GWarehouseShiftDeleteInput;
};


export type GMutationWarehouseShiftUpdateArgs = {
  input: GWarehouseShiftUpdateInput;
};


export type GMutationWarehouseUpdateClosedDaysArgs = {
  input: GWarehouseUpdateClosedDaysInput;
};


export type GMutationWarehouseUpdateDailyCapacityArgs = {
  input: GWarehouseUpdateDailyCapacityInput;
};

export type GNetsuiteCreditMemo = GFinancialTransaction & {
  __typename?: 'NetsuiteCreditMemo';
  /** The amount of credit used, excluding pending transactions. */
  amountPaid: GMoney;
  /** The amount of credit available for use, excluding pending transactions. */
  amountRemaining: GMoney;
  /** Invoices to which current credit was applied. */
  applicableInvoices: Array<GNetsuiteInvoice>;
  id: Scalars['ID'];
  issuedDate: Scalars['ISO8601Date'];
  netsuiteTransactionNumber: Scalars['String'];
  pdf?: Maybe<Scalars['String']>;
  platformRecordId: Scalars['ID'];
  relatives: GFinancialTransactionConnection;
  /** Total credits issued */
  total: GMoney;
  transactionDate: Scalars['ISO8601Date'];
};

/** The connection type for NetsuiteCreditMemo. */
export type GNetsuiteCreditMemoConnection = {
  __typename?: 'NetsuiteCreditMemoConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GNetsuiteCreditMemoEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GNetsuiteCreditMemo>>>;
  /** Information to aid in pagination. */
  pageInfo: GPageInfo;
};

/** An edge in a connection. */
export type GNetsuiteCreditMemoEdge = {
  __typename?: 'NetsuiteCreditMemoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** Additional info about the meaning of this edge. */
  info: GFinancialTransactionEdgeInfo;
  /** The item at the end of the edge. */
  node?: Maybe<GNetsuiteCreditMemo>;
};

export type GNetsuiteCustomerPayment = GFinancialTransaction & {
  __typename?: 'NetsuiteCustomerPayment';
  id: Scalars['ID'];
  platformRecordId: Scalars['ID'];
  relatives: GFinancialTransactionConnection;
  transactionDate: Scalars['ISO8601Date'];
};

export type GNetsuiteCustomerRefund = GFinancialTransaction & {
  __typename?: 'NetsuiteCustomerRefund';
  id: Scalars['ID'];
  platformRecordId: Scalars['ID'];
  relatives: GFinancialTransactionConnection;
  transactionDate: Scalars['ISO8601Date'];
};

export type GNetsuiteInvoice = GFinancialTransaction & {
  __typename?: 'NetsuiteInvoice';
  /** The sum of all completed payments and credit applications put towards this invoice. */
  completedAmountPaid: GMoney;
  /** True if a credit has been successfully applied to this invoice. */
  creditApplied: Scalars['Boolean'];
  discountTotal: GMoney;
  dueDate: Scalars['ISO8601Date'];
  fulfillmentDate: Scalars['ISO8601Date'];
  id: Scalars['ID'];
  netsuiteSalesOrderReference?: Maybe<GNetsuiteSalesOrderReference>;
  netsuiteTransactionNumber: Scalars['String'];
  order?: Maybe<GOrder>;
  /**
   * Payment terms, in days, for this invoice: the terms copied onto its Odeko
   * supply order when the order was placed. Null when no terms were copied,
   * including invoices from platforms other than Odeko.
   */
  paymentTermsDays?: Maybe<Scalars['Int']>;
  pdf?: Maybe<Scalars['String']>;
  platformRecordId: Scalars['ID'];
  relatives: GFinancialTransactionConnection;
  shippingCost: GMoney;
  subtotal: GMoney;
  tax: GMoney;
  total: GMoney;
  /** The sum of all payments and credit applications put towards this invoice, including those that are still pending. */
  totalAmountPaid: GMoney;
  totalAmountRemaining: GMoney;
  /** The sum of all credits successfully applied to this invoice. */
  totalCreditsApplied: GMoney;
  totalCreditsIssued: GMoney;
  transactionDate: Scalars['ISO8601Date'];
  vendorName?: Maybe<Scalars['String']>;
};

/** The connection type for NetsuiteInvoice. */
export type GNetsuiteInvoiceConnection = {
  __typename?: 'NetsuiteInvoiceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GNetsuiteInvoiceEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GNetsuiteInvoice>>>;
  /** Information to aid in pagination. */
  pageInfo: GPageInfo;
};

/** An edge in a connection. */
export type GNetsuiteInvoiceEdge = {
  __typename?: 'NetsuiteInvoiceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** Additional info about the meaning of this edge. */
  info: GFinancialTransactionEdgeInfo;
  /** The item at the end of the edge. */
  node?: Maybe<GNetsuiteInvoice>;
};

export type GNetsuiteJournalEntryLine = GFinancialTransaction & {
  __typename?: 'NetsuiteJournalEntryLine';
  id: Scalars['ID'];
  platformRecordId: Scalars['ID'];
  relatives: GFinancialTransactionConnection;
  transactionDate: Scalars['ISO8601Date'];
};

export type GNetsuiteSalesOrderReference = {
  __typename?: 'NetsuiteSalesOrderReference';
  externalOrder?: Maybe<GOrderReference>;
  netsuiteInternalId: Scalars['ID'];
  transactionNumber: Scalars['String'];
};

export type GNetsuiteTransaction = {
  __typename?: 'NetsuiteTransaction';
  createdAt: Scalars['ISO8601Date'];
  date: Scalars['ISO8601Date'];
  id: Scalars['ID'];
  location: GLocation;
  order?: Maybe<GOrder>;
  pdfS3Key?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  totalPriceCents: Scalars['String'];
  transactionType: Scalars['String'];
  updatedAt: Scalars['ISO8601Date'];
  vendor?: Maybe<GVendor>;
};

export type GNetsuiteVendor = {
  __typename?: 'NetsuiteVendor';
  /** Customer-facing name; may differ from the legal name and is also matched by search. */
  displayName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  netsuiteInternalId: Scalars['String'];
};

/** One market's New Items pin state for an item being considered for cross-market pinning. */
export type GNewItemMarketEligibility = {
  __typename?: 'NewItemMarketEligibility';
  /** The slot this item currently occupies in this market's New Items queue, or null if it isn't pinned here. Compared to the target position, this shows whether a cross-market pin would add it (null), move it (a different slot), or leave it in place (the same slot). */
  currentPosition?: Maybe<Scalars['Int']>;
  /** The current queue leader at the target position in this market, if any — what a cross-market pin would demote to a fallback candidate. Null if the position is unoccupied there, or this item already leads it. */
  existingPin?: Maybe<GNewItemPin>;
  warehouse: GWarehouse;
};

/**
 * A merchandising pin elevating an item to an absolute slot in a market's New Items carousel. Backed by
 * the surface-agnostic `merchandisepin` store (surface = NEW_ITEMS).
 */
export type GNewItemPin = {
  __typename?: 'NewItemPin';
  /** Days the item has left as new; null once it has aged out of the 60-day window. */
  daysRemainingAsNew?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  /** True when the item is still new (within the 60-day window) AND in stock — i.e. currently surfacing. */
  isActive: Scalars['Boolean'];
  item: GSupplyItem;
  /** Absolute carousel slot (ascending). */
  position: Scalars['Int'];
  /** True when this pin is a sponsored (paid) placement; false for internal merchandising/seasonal pins. */
  sponsored: Scalars['Boolean'];
  /** Succession order within a position (auto-sequenced); the first eligible member leads the slot. */
  subrank: Scalars['Int'];
};

export type GNewItemPinError = {
  __typename?: 'NewItemPinError';
  field?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

export type GNewItemPinPayload = {
  __typename?: 'NewItemPinPayload';
  errors: Array<GNewItemPinError>;
  newItemPin?: Maybe<GNewItemPin>;
};

export type GNewItemPinsPayload = {
  __typename?: 'NewItemPinsPayload';
  errors: Array<GNewItemPinError>;
  newItemPins: Array<GNewItemPin>;
};

/**
 * Filters accepted by Location.newItems (and, later, User.newItems). A deliberately
 * curated, intent-based input — not a raw subset of ItemsFiltersInput. Two facts that
 * *define* the New Items set are forced by the resolver and so are absent here: `isNew`
 * (the 60-day activation window) and `catalogStatus` (always in-catalog). Callers express
 * shipping eligibility as a single `isShipping` flag rather than hand-building the
 * underlying weight/refrigeration filters; the resolver expands it.
 */
export type GNewItemsFiltersInput = {
  /** When true, excludes items out of stock for 14+ days at a fulfillment warehouse. */
  customerFacingOutOfStock?: InputMaybe<Scalars['Boolean']>;
  /** Non-global-fulfillment locations scope to their assigned fulfillment warehouse. */
  fulfillmentWarehouseIds?: InputMaybe<GFiltersArrayInput>;
  /**
   * When true, restricts to items shippable to a shipping customer, as
   * ItemsFiltersInput.isShipping does.
   */
  isShipping?: InputMaybe<Scalars['Boolean']>;
  /** Punchout catalogs restrict to inventory items. */
  type?: InputMaybe<GFiltersItemTypeInput>;
  /** The market the New Items are scoped to. */
  warehouseId?: InputMaybe<GFiltersStringInput>;
};

/** A specific delivery date available for a vendor at a location */
export type GNextAvailableDeliveryDate = {
  __typename?: 'NextAvailableDeliveryDate';
  /** The delivery date */
  date: Scalars['ISO8601Date'];
  /** The exact datetime orders must be placed by */
  orderByDate: Scalars['ISO8601DateTime'];
  /** Order deadline time (e.g., '10:00') */
  orderDeadline: Scalars['String'];
  /** The vendor for this delivery date */
  vendor: GVendor;
};

/** An object with an ID. */
export type GNode = {
  /** ID of the object. */
  id: Scalars['ID'];
};

export type GNonCustomerPickupStops = GUserErrorInterface & {
  __typename?: 'NonCustomerPickupStops';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
  stopIds: Array<Scalars['ID']>;
};

/** Extension of NonInventoryItem type to include associated ERP Reference fields */
export type GNonInventoryItem = GSupplyItem & {
  __typename?: 'NonInventoryItem';
  brand?: Maybe<GItemBrand>;
  /** @deprecated Use brand */
  brandName: Scalars['String'];
  /** (Package Height x Package Width x Package Length)/DIM factor */
  caseDimensionalWeightLbs?: Maybe<Scalars['Float']>;
  caseHeightInches?: Maybe<Scalars['Float']>;
  caseLengthInches?: Maybe<Scalars['Float']>;
  caseVolumeCuInches?: Maybe<Scalars['Float']>;
  caseWeightLbs?: Maybe<Scalars['Float']>;
  caseWidthInches?: Maybe<Scalars['Float']>;
  casesPerLayer?: Maybe<Scalars['Int']>;
  casesPerPallet?: Maybe<Scalars['Int']>;
  catalogStatus: GCatalogStatus;
  category: GCategory;
  createdAt: Scalars['ISO8601DateTime'];
  createdBy: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  /**
   * Drives pricing with carriers like FedEx.
   * This data is uploaded from Cubiscan dimensioning device to optimize shipping costs.
   */
  dimensionalFactor?: Maybe<Scalars['Float']>;
  dimensioned?: Maybe<Scalars['Boolean']>;
  discontinuedOn?: Maybe<Scalars['ISO8601DateTime']>;
  /** (Package Height x Package Width x Package Length)/DIM factor */
  eachDimensionalWeightLbs?: Maybe<Scalars['Float']>;
  eachHeightInches?: Maybe<Scalars['Float']>;
  eachLengthInches?: Maybe<Scalars['Float']>;
  eachVolumeCuInches?: Maybe<Scalars['Float']>;
  eachWeightLbs?: Maybe<Scalars['Float']>;
  eachWidthInches?: Maybe<Scalars['Float']>;
  erpPlatform?: Maybe<GErpPlatform>;
  erpRecordId?: Maybe<Scalars['ID']>;
  erpRecordType?: Maybe<GErpRecord>;
  erpRecordUrl?: Maybe<Scalars['String']>;
  /** Denotes if the item should be included in the picking labels or not. */
  excludedFromPickingLabels: Scalars['Boolean'];
  /** True if the item has its own image. When false and imgUrl is present, the image is a fallback from the category icon. */
  hasOwnImage: Scalars['Boolean'];
  id: Scalars['ID'];
  imgUrl?: Maybe<Scalars['String']>;
  inactivatedOn?: Maybe<Scalars['ISO8601DateTime']>;
  /**
   * True when a shipping location can't order this item: it is refrigerated or frozen, or its
   * category or subcategory is Pastry or Baked Goods.
   */
  isShippingRestricted: Scalars['Boolean'];
  itemLocationsCustomPrice?: Maybe<Array<GItemLocationCustomPrice>>;
  /** @deprecated Use size */
  itemSize?: Maybe<Scalars['String']>;
  layersPerPallet?: Maybe<Scalars['Int']>;
  /** Whether this item uses market pricing (price set at fulfillment time) */
  marketPrice: Scalars['Boolean'];
  /** The markup percentage applied to vendor cost to compute selling price for market-priced items */
  markupPercentage?: Maybe<Scalars['Float']>;
  /**
   * The most units, in the sale unit, that one location may order of this item across all its orders.
   * Null means no limit.
   */
  maxQuantityPerLocation?: Maybe<Scalars['Int']>;
  minItemsPerOrder?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  nmfc?: Maybe<Scalars['String']>;
  palletWeightLbs?: Maybe<Scalars['Float']>;
  /**
   * True when this item is currently a leading New Items pin — i.e. it won its slot in the resolved
   * result set. Reflects what shoppers see: an item filtered out of the result reads as not pinned.
   * Flag-gated; false when the new-item-pinning flag is off or the item isn't pinned.
   */
  pinned: Scalars['Boolean'];
  /** The absolute carousel slot this item actually rendered at when pinned; null when not pinned. */
  pinnedPosition?: Maybe<Scalars['Int']>;
  /**
   * Drives the storefront's "Sponsored" label. True for Algolia rule-promoted results and — behind the
   * new-item-pinning flag — for a sponsored New Items pin. A sponsored pin is distinguishable from an
   * Algolia promo by `pinned` (a sponsored pin is `promoted && pinned`).
   */
  promoted: Scalars['Boolean'];
  purchaseMultiple: Scalars['Int'];
  purchasePrice: GMoney;
  refrigerationState?: Maybe<GRefrigerationState>;
  saleUnit: GUnit;
  /** The most of this item's sample one location may ever order. Null means no limit, or no sample. */
  sampleMaxQuantityPerLocation?: Maybe<Scalars['Int']>;
  sampleUnit?: Maybe<GUnit>;
  size?: Maybe<GItemSize>;
  /**
   * The product-level standing-order setting. Read `standingOrderBehavior` on the warehouse
   * association instead, at all times: this value is not market-scoped, so once any market is
   * given a setting of its own it stops answering for that market.
   */
  standingOrderBehavior: GStandingOrderBehavior;
  subcategory?: Maybe<GCategory>;
  /**
   * The item's curated substitution overrides (source-side), highest priority first. Procurement's
   * editable layer that ranks above the rule engine's dynamic recommendations.
   */
  substitutionOverrides: Array<GSubstitutionOverride>;
  /**
   * Procurement preview of ranked substitutes for this item. With no `warehouseId`, ranks by
   * attribute/dietary match quality only (availability ignored) — the "are these good substitutes?"
   * view. With a `warehouseId`, returns the in-stock list a customer in that market would actually get.
   * Curated overrides rank first. Procurement surface — the customer path uses `InventoryWarehouseAssociation.substitutionCandidates`.
   */
  substitutionPreview: Array<GSupplyItem>;
  tags: Array<GItemTag>;
  transitMethod?: Maybe<GTransitMethod>;
  updatedAt: Scalars['ISO8601DateTime'];
  updatedBy: Scalars['String'];
  vendorCode?: Maybe<Scalars['String']>;
  warehouseAssociation?: Maybe<Array<Maybe<GNonInventoryWarehouseAssociation>>>;
};


/** Extension of NonInventoryItem type to include associated ERP Reference fields */
export type GNonInventoryItemSubstitutionPreviewArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  warehouseId?: InputMaybe<Scalars['ID']>;
};


/** Extension of NonInventoryItem type to include associated ERP Reference fields */
export type GNonInventoryItemTagsArgs = {
  withDiscardedAt?: InputMaybe<Scalars['Boolean']>;
};


/** Extension of NonInventoryItem type to include associated ERP Reference fields */
export type GNonInventoryItemWarehouseAssociationArgs = {
  filters?: InputMaybe<GNonInventoryWarehouseAssociationFiltersInput>;
  warehouseIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type GNonInventoryItemInput = {
  brand?: InputMaybe<Scalars['ID']>;
  brandName: Scalars['String'];
  caseHeightInches?: InputMaybe<Scalars['Float']>;
  caseLengthInches?: InputMaybe<Scalars['Float']>;
  caseWeightLbs?: InputMaybe<Scalars['Float']>;
  caseWidthInches?: InputMaybe<Scalars['Float']>;
  casesPerLayer?: InputMaybe<Scalars['Int']>;
  catalogStatus: GCatalogStatus;
  category: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
  dimensionalFactor?: InputMaybe<Scalars['Float']>;
  dimensioned?: InputMaybe<Scalars['Boolean']>;
  eachHeightInches?: InputMaybe<Scalars['Float']>;
  eachLengthInches?: InputMaybe<Scalars['Float']>;
  eachWeightLbs?: InputMaybe<Scalars['Float']>;
  eachWidthInches?: InputMaybe<Scalars['Float']>;
  imgUrl?: InputMaybe<Scalars['String']>;
  itemSize?: InputMaybe<Scalars['String']>;
  layersPerPallet?: InputMaybe<Scalars['Int']>;
  marketPrice?: InputMaybe<Scalars['Boolean']>;
  markupPercentage?: InputMaybe<Scalars['Float']>;
  /**
   * The most units, in the sale unit, that one location may order of this item across all its orders.
   * Omit to keep the current value; null removes the limit. At least 1.
   */
  maxQuantityPerLocation?: InputMaybe<Scalars['Int']>;
  minItemsPerOrder?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  nmfc?: InputMaybe<Scalars['String']>;
  palletWeightLbs?: InputMaybe<Scalars['Float']>;
  purchaseMultiple: Scalars['Int'];
  purchasePrice: GMoneyInput;
  refrigerationState?: InputMaybe<GRefrigerationState>;
  saleUnit: Scalars['ID'];
  /**
   * The most of this item's sample one location may ever order. Omit to keep the current value; null
   * removes the limit. At least 1, and only with a sampleUnit.
   */
  sampleMaxQuantityPerLocation?: InputMaybe<Scalars['Int']>;
  sampleUnit?: InputMaybe<Scalars['ID']>;
  size?: InputMaybe<GSizeInput>;
  standingOrderBehavior: GStandingOrderBehavior;
  subcategory?: InputMaybe<Scalars['ID']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  transitMethod?: InputMaybe<GTransitMethod>;
  vendorCode?: InputMaybe<Scalars['String']>;
  warehouseAssociation?: InputMaybe<Array<InputMaybe<GNonInventoryWarehouseAssociationInput>>>;
};

export type GNonInventoryVendor = {
  __typename?: 'NonInventoryVendor';
  /** The vendor's current active override code, or null if none is active. */
  activeOverrideCode?: Maybe<GDockOverrideCode>;
  /** Customer-facing name; may differ from the legal name and is also matched by search. */
  displayName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  netsuiteInternalId: Scalars['String'];
};

/**
 * NonInventory items are picked up from vendors while out on delivery.
 * A driver is *dispatched* from a warehouse to pick up and deliver the item.
 */
export type GNonInventoryWarehouseAssociation = {
  __typename?: 'NonInventoryWarehouseAssociation';
  configuredFulfillmentWarehouses: Array<GConfigureFulfillmentWarehouse>;
  /**
   * Wording authored for this product in this market, or null when nothing was authored and the
   * message is derived from `orderability`. Exposed so an editor can show and change what was written;
   * clients rendering a catalog want `orderabilityMessage` instead.
   */
  customOrderabilityMessage?: Maybe<Scalars['String']>;
  /** True when the item has been continuously out of stock for 14+ days at this warehouse. */
  customerFacingOutOfStock: Scalars['Boolean'];
  /**
   * Days the item has left in the 60-day "new" window at this warehouse; null once it has aged out.
   * Mirrors `isNew` (both derive from the item's activation date).
   */
  daysRemainingAsNew?: Maybe<Scalars['Int']>;
  fulfillmentWarehouses: Array<GFulfillmentWarehouse>;
  hasSample?: Maybe<Scalars['Boolean']>;
  isNew: Scalars['Boolean'];
  item: GNonInventoryItem;
  landedCost?: Maybe<GMoney>;
  /**
   * Next available delivery date for this item from the location's own (home)
   * warehouse. Returns null when the association is for any other warehouse — e.g.
   * an item fulfilled from a different warehouse under global fulfillment — or
   * when the location is disabled.
   */
  nextDeliveryDate?: Maybe<Scalars['ISO8601Date']>;
  /**
   * Whether this product is ready to sell in this market. A product that is not orderable still appears
   * in the catalog — it simply cannot be added to an order.
   */
  orderability: GOrderability;
  /**
   * Wording to show in place of add-to-cart, or null when the product can be ordered. Taken from
   * `customOrderabilityMessage` when one is authored, and otherwise derived from `orderability`, so
   * both ordering apps say the same thing and changing it needs no client release.
   */
  orderabilityMessage?: Maybe<Scalars['String']>;
  /**
   * When the item first went out of stock at this warehouse.
   * Null if currently in stock or if OOS check is bypassed.
   */
  outOfStockSince?: Maybe<Scalars['ISO8601DateTime']>;
  salePrice?: Maybe<GMoney>;
  sample?: Maybe<GSupplyItem>;
  /**
   * Whether this product can be ordered on a standing order in this market. A market that has not been
   * given a value of its own carries the item-level field of the same name.
   */
  standingOrderBehavior: GStandingOrderBehavior;
  vendor?: Maybe<GVendor>;
  warehouse: GWarehouse;
};


/**
 * NonInventory items are picked up from vendors while out on delivery.
 * A driver is *dispatched* from a warehouse to pick up and deliver the item.
 */
export type GNonInventoryWarehouseAssociationFulfillmentWarehousesArgs = {
  locationUuid?: InputMaybe<Scalars['ID']>;
};


/**
 * NonInventory items are picked up from vendors while out on delivery.
 * A driver is *dispatched* from a warehouse to pick up and deliver the item.
 */
export type GNonInventoryWarehouseAssociationNextDeliveryDateArgs = {
  locationId: Scalars['ID'];
};


/**
 * NonInventory items are picked up from vendors while out on delivery.
 * A driver is *dispatched* from a warehouse to pick up and deliver the item.
 */
export type GNonInventoryWarehouseAssociationSalePriceArgs = {
  locationMembershipStatusTier?: InputMaybe<GPsLocationMembershipStatusTier>;
  locationMembershipTier?: InputMaybe<GLocationMembershipTier>;
};

export type GNonInventoryWarehouseAssociationFiltersInput = {
  vendorId?: InputMaybe<GFiltersStringInput>;
  warehouseId?: InputMaybe<GFiltersStringInput>;
};

export type GNonInventoryWarehouseAssociationInput = {
  configuredFulfillmentWarehouses?: InputMaybe<Array<GConfigureFulfillmentWarehouseInput>>;
  /** Wording to show instead of what `orderability` implies. Omit to leave unchanged; null to clear. */
  customOrderabilityMessage?: InputMaybe<Scalars['String']>;
  hasSample?: InputMaybe<Scalars['Boolean']>;
  /** Defaults to ORDERABLE when omitted; omit to leave an existing value unchanged. */
  orderability?: InputMaybe<GOrderability>;
  salePrice?: InputMaybe<GMoneyInput>;
  /** Omit to leave unchanged. A market the product was not in before starts off, except on a product being created, where it takes the item-level field of the same name. */
  standingOrderBehavior?: InputMaybe<GStandingOrderBehavior>;
  vendorId: Scalars['ID'];
  warehouseId: Scalars['ID'];
};

/** A selected stop that cannot be moved into the customer-pickup bucket, and why. */
export type GNonMovableStop = {
  __typename?: 'NonMovableStop';
  reason: Scalars['String'];
  stopId: Scalars['ID'];
};

export type GNonMovableStops = GUserErrorInterface & {
  __typename?: 'NonMovableStops';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  offenders: Array<GNonMovableStop>;
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** Error indicating that a mutation failed because the requested pickup time did not satisfy merchant's minimum notice. */
export type GNotEnoughNotice = GError & {
  __typename?: 'NotEnoughNotice';
  /** A description of the error. */
  message: Scalars['String'];
  /** Minimum notice an order can be placed in advance of its pickup time. */
  minimumNotice: GRelativeTime;
};

/** Error indicating a partial refund was attempted without specifying any items or modifiers to refund. */
export type GNothingToRefund = GError & {
  __typename?: 'NothingToRefund';
  /** A description of the error. */
  message: Scalars['String'];
};

/**
 * Error indicating that a mutation failed because its inputs included an object
 * from a collection other than the expected collection.
 */
export type GObjectFromOutsideCollection = GError & {
  __typename?: 'ObjectFromOutsideCollection';
  /** ID of the object. */
  id: Scalars['ID'];
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating that an object could not be found with the ID provided by an input argument. */
export type GObjectNotFound = GError & {
  __typename?: 'ObjectNotFound';
  /** ID that caused the error. */
  id: Scalars['ID'];
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating that mutation failed to save an object. */
export type GObjectNotSaved = GError & {
  __typename?: 'ObjectNotSaved';
  /** ID of the object that failed to save. */
  id?: Maybe<Scalars['ID']>;
  /** A description of the error. */
  message: Scalars['String'];
};

/**
 * Error indicating that a mutation whose input requires a complete collection
 * failed because an object was omitted from the collection.
 */
export type GObjectOmittedFromCollection = GError & {
  __typename?: 'ObjectOmittedFromCollection';
  /** ID of the omitted object. */
  id: Scalars['ID'];
  /** A description of the error. */
  message: Scalars['String'];
};

/** PROTOTYPE Inventory Info for Odeko Items for a Location. */
export type GOdekoItemInventoryInput = {
  /**
   * PROTOTYPE the id of the base unit of Odeko item's sale unit. This must be
   * included even if location_counting_unit_id is present.
   */
  baseUnitId: Scalars['ID'];
  /**
   * PROTOTYPE The number of base units contained in the Odeko item's sale unit.
   * This must be included even if location_counting_unit_id is present.
   */
  conversionRate: Scalars['Float'];
  /**
   * PROTOTYPE When provided, the location will count using this custom counting
   * unit. When empty, the location will count using the Odeko sales unit.
   */
  locationCountingUnitId?: InputMaybe<Scalars['ID']>;
  /** PROTOTYPE Where in the Cafe the location is stored */
  locationStorageAreaId?: InputMaybe<Scalars['ID']>;
  /** PROTOTYPE the par value to set for this iten in this Cafe location. */
  parValue: Scalars['Float'];
  /** PROTOTYPE the id of the Odeko item's sale unit. This must be included even if location_counting_unit_id is present. */
  salesUnitId: Scalars['ID'];
  skuId: Scalars['ID'];
};

export type GOdekoPaymentIntent = GFinancialTransaction & {
  __typename?: 'OdekoPaymentIntent';
  id: Scalars['ID'];
  platformRecordId: Scalars['ID'];
  relatives: GFinancialTransactionConnection;
  transactionDate: Scalars['ISO8601Date'];
};

export type GOpeningHour = {
  __typename?: 'OpeningHour';
  /** Opening time in HH:MM:SS format and in the timezone of the location */
  closeTime: Scalars['String'];
  /** Day of the week in text format i.e Sunday, Monday, etc. */
  dayName: Scalars['String'];
  /** Day of the week (0-6), where 0 is Sunday and 6 is Saturday */
  dayOfWeek: Scalars['Int'];
  id: Scalars['ID'];
  /** Opening time in HH:MM:SS format and in the timezone of the location */
  openTime: Scalars['String'];
};

export type GOpeningHoursDayInput = {
  /** Closing time in HH:MM:SS format expressed in the timezone of the location */
  closeTime: Scalars['String'];
  /** Day of the week (0-6), where 0 is Sunday and 6 is Saturday */
  dayOfWeek: Scalars['Int'];
  /** Opening time in HH:MM:SS format expressed in the timezone of the location */
  openTime: Scalars['String'];
};

export type GOperatingHoursBound = {
  __typename?: 'OperatingHoursBound';
  /** Day of week. */
  dayOfWeek: GDayOfWeekEnum;
  /** Time of day in HH:MM:SS format. */
  timeOfDay: Scalars['String'];
};

/** Input for an operating hours bound. */
export type GOperatingHoursBoundInput = {
  /** Day of week. */
  dayOfWeek: GDayOfWeekEnum;
  /** Time of day in HH:MM:SS format. */
  timeOfDay: Scalars['String'];
};

export type GOperatingHoursForDayOfWeek = {
  __typename?: 'OperatingHoursForDayOfWeek';
  /** Operating hours intervals. May spill over into a subsequent day. */
  intervals: Array<GOperatingHoursInterval>;
  /** Operating day of week. */
  operatingDay: GDayOfWeekEnum;
};

export type GOperatingHoursInterval = {
  __typename?: 'OperatingHoursInterval';
  /** Lower bound. */
  lowerBound: GOperatingHoursBound;
  /** Upper bound. */
  upperBound: GOperatingHoursBound;
};

/** Input for an operating hours interval. */
export type GOperatingHoursIntervalInput = {
  /** Lower bound. */
  lowerBound: GOperatingHoursBoundInput;
  /** Upper bound. */
  upperBound: GOperatingHoursBoundInput;
};

/** Extension of a Supply Order to include associated ERP Reference fields */
export type GOrder = {
  __typename?: 'Order';
  /** Fees applied to an order. */
  appliedFees: Array<GOrderFee>;
  autoGenerated: Scalars['Boolean'];
  /** The automatic discount codes applied to the order. */
  automaticDiscountCodes?: Maybe<Array<Scalars['String']>>;
  canCancel: Scalars['Boolean'];
  canReportIssue: Scalars['Boolean'];
  collectedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The coupon codes applied to the order. */
  couponCodes?: Maybe<Array<Scalars['String']>>;
  deliveredAt?: Maybe<Scalars['ISO8601DateTime']>;
  deliveryDate: Scalars['ISO8601Date'];
  deliveryMethod: GOrderDeliveryMethodEnum;
  deliveryStatus: GOrderDeliveryStatus;
  dueAt: Scalars['ISO8601DateTime'];
  erpPlatform?: Maybe<GErpPlatform>;
  erpRecordId?: Maybe<Scalars['ID']>;
  erpRecordType?: Maybe<GErpRecord>;
  erpRecordUrl?: Maybe<Scalars['String']>;
  erpTransactionId?: Maybe<Scalars['String']>;
  estimatedShippingDeliveryDateRange?: Maybe<GShippingEstimateDeliveryRange>;
  /** Provides external delivery information when an order is actively being delivered by a third party. */
  externalDelivery?: Maybe<GExternalDelivery>;
  /**
   * True while the order is held for delivery review (a delivered vs fulfilled
   * line delta). Set when a delta appears and cleared at route completion or
   * review confirmation once no delta remains — keeps the order in the DMP review
   * queue until then.
   */
  flaggedForReview: Scalars['Boolean'];
  fulfillmentStatus: Scalars['String'];
  hasStandingOrderForDay: Scalars['Boolean'];
  id: Scalars['ID'];
  invoice?: Maybe<GFinancialTransaction>;
  isCancelled: Scalars['Boolean'];
  issues?: Maybe<Array<GIssue>>;
  itemLevelTracking: Scalars['Boolean'];
  location: GLocation;
  orderDate: Scalars['ISO8601Date'];
  orderEvents: Array<GOrderEvent>;
  orderLines: Array<GOrderLine>;
  orderNumber: Scalars['ID'];
  partiallyDelivered: Scalars['Boolean'];
  poNumber?: Maybe<Scalars['String']>;
  /** Server-derived recovery state for DMP queue rendering. See OrderRecoveryStatus for value semantics. */
  recoveryStatus: GOrderRecoveryStatus;
  /**
   * True once a redelivery has been completed for the order. The DMP uses it to
   * re-open a completed-but-short redelivery as a plain, reviewable order (no
   * missed-deadline state).
   */
  redeliveryAttempted: Scalars['Boolean'];
  /**
   * Server-derived review-by deadline: when the order auto-confirms if no GM
   * reviews it, in the warehouse's local time. Anchored on route completion. Null
   * when no deadline applies. DMP renders only.
   */
  reviewBy?: Maybe<Scalars['ISO8601DateTime']>;
  reviewConfirmedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Server-derived review state for DMP queue rendering. See OrderReviewStatus for value semantics. */
  reviewStatus: GOrderReviewStatus;
  /**
   * The completion instant of the order's delivery route, mirroring the anchor
   * review_by is built on. Route-grain: every order sharing a completed bucket
   * carries the same instant, not a per-order delivery time. Null unless
   * routeCompletionState is complete.
   */
  routeCompletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /**
   * Server-derived delivery-route completion state. See OrderRouteCompletionState
   * for value semantics, including why it is route-grain and not monotonic.
   */
  routeCompletionState: GOrderRouteCompletionState;
  /**
   * Name of the route the order is on for its warehouse + delivery date (the Lobby
   * bucket until it's routed; nil when it has no stop).
   */
  routeName?: Maybe<Scalars['String']>;
  scheduledDeliveryTime?: Maybe<GScheduledDeliveryTime>;
  /** Cost of shipping only; does not include the cost of items. */
  shippingCostCents: Scalars['Int'];
  /** The order's 1-indexed stop position on that route (sequence_number + 1; nil when it has no stop). */
  stopNumber?: Maybe<Scalars['Int']>;
  stops?: Maybe<Array<GDeliveryStop>>;
  substitutionCount: Scalars['Int'];
  /** Current cost of goods sold for active order lines, expressed in cents and potentially fractional after unit conversion. */
  totalCogsCents: Scalars['Float'];
  /** Sum of total_cost_cents across all active order lines. */
  totalCostCents: Scalars['Int'];
  /** Sum of applied fee amounts. */
  totalFeesCents: Scalars['Int'];
  totalItemQuantity: Scalars['Int'];
  /** Sum of billed weight for market-priced lines and ordered weight for other active lines. */
  totalWeightLb: Scalars['Float'];
  /** @deprecated Use external delivery field instead. */
  trackingUrl?: Maybe<Scalars['String']>;
  vendor: GVendor;
  warehouseNote?: Maybe<Scalars['String']>;
};

export enum GOrderActorTypeEnum {
  /** Action taken by an automated process or background job */
  System = 'system',
  /** Action taken by a human user */
  User = 'user'
}

export type GOrderAllocationInput = {
  collected: Scalars['Boolean'];
  orderId: Scalars['ID'];
  orderLines?: InputMaybe<Array<GOrderLineAllocationInput>>;
};

/** Accepted orderBy values */
export enum GOrderByEnum {
  /** Ascending, nulls last */
  Asc = 'asc',
  /** Descending, nulls first */
  Desc = 'desc'
}

export enum GOrderChannelEnum {
  /** Order created or updated via Android mobile app */
  MobileAndroid = 'MOBILE_ANDROID',
  /** Order created or updated via iOS mobile app */
  MobileIos = 'MOBILE_IOS',
  /** Order created via web admin tools */
  WebAdminTools = 'WEB_ADMIN_TOOLS',
  /** Order created or updated via web portal */
  WebPortal = 'WEB_PORTAL',
  /** Order created via internal management interface */
  WebSoApi = 'WEB_SO_API',
  /** Order auto-generated from standing order */
  WebStandingOrders = 'WEB_STANDING_ORDERS'
}

/** Autogenerated input type of OrderCollectedUpdate */
export type GOrderCollectedUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Denotes if the order was collected */
  collected: Scalars['Boolean'];
  /** Order id. */
  orderId: Scalars['ID'];
  /** Order lines containing the fulfillment quantity */
  orderLines?: InputMaybe<Array<GOrderLinesFulfillmentInput>>;
};

/** Autogenerated return type of OrderCollectedUpdate. */
export type GOrderCollectedUpdatePayload = {
  __typename?: 'OrderCollectedUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderLines?: Maybe<Array<GOrderLine>>;
  userErrors: Array<GOrderError>;
};

/** Autogenerated input type of OrderDeliveredUpdate */
export type GOrderDeliveredUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Denotes if the order was delivered */
  delivered: Scalars['Boolean'];
  /** Order id. */
  orderId: Scalars['ID'];
  redelivery?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of OrderDeliveredUpdate. */
export type GOrderDeliveredUpdatePayload = {
  __typename?: 'OrderDeliveredUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userErrors: Array<GOrderError>;
};

export enum GOrderDeliveryMethodEnum {
  /** Delivered via Burq (for external deliveries) */
  BurqDelivery = 'burq_delivery',
  /** Local delivery */
  Delivery = 'delivery',
  /** Delivered via DoorDash (for external deliveries) */
  DoordashDelivery = 'doordash_delivery',
  /** Delivered via Metrobi (for external deliveries) */
  MetrobiDelivery = 'metrobi_delivery',
  /** Shipped via pallet (for heavier orders) */
  PalletShipping = 'pallet_shipping',
  /** Shipped via parcel (for lighter orders) */
  ParcelShipping = 'parcel_shipping',
  /** Local pick-up */
  PickUp = 'pick_up',
  /** Delivered via Roadie using a Roadie crossdock (for external deliveries) */
  RoadieCrossdock = 'roadie_crossdock',
  /** Delivered via Roadie (for external deliveries) */
  RoadieDelivery = 'roadie_delivery'
}

export enum GOrderDeliveryStatus {
  /** order has a delivered_at value and all order line deliveried quantities equal the ordered quantity */
  Delivered = 'delivered',
  /** order has been fulfilled or collected and will be delivered soon */
  InTransit = 'in_transit',
  /** order has order lines and the order lines quanitities are greater than 0 but do not equal the order quantity */
  PartiallyDelivered = 'partially_delivered',
  /**
   * for orders with order lines: order has a delivered_at value but the quantity
   * of all order lines are zero. For orders with no order lines the stop has been
   * completed but the order does not have a delivered_at timestamp
   */
  Undelivered = 'undelivered',
  /** order has not been fulfilled or collected yet */
  Unfulfilled = 'unfulfilled'
}

/** An edge in a connection. */
export type GOrderEdge = {
  __typename?: 'OrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GOrder>;
};

/** Order possible error types */
export type GOrderError = GBlankNote | GInvalidDeliveredQuantity | GInvalidFulfillmentQuantity | GMissingQtyDelivered | GOrderLineNotFound | GOrderNotEligibleForReview | GOrderNotFound | GRecoveryQuantityOutOfRange | GReviewConfirmationMismatch | GRouteEnded;

export type GOrderEvent = {
  __typename?: 'OrderEvent';
  actor?: Maybe<GOrderEventActor>;
  actorType: GOrderActorTypeEnum;
  changes: Array<GOrderEventLine>;
  createdAt: Scalars['ISO8601DateTime'];
  eventContext?: Maybe<Scalars['String']>;
  eventType: GOrderEventKindEnum;
  id: Scalars['ID'];
  metadata?: Maybe<Scalars['JSON']>;
  substitutions: Array<GOrderLineSubstitution>;
};

export type GOrderEventActor = {
  __typename?: 'OrderEventActor';
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isOdekoEmployee: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  user?: Maybe<GUser>;
};

export enum GOrderEventKindEnum {
  /** Order activated */
  Activated = 'activated',
  /** Order cancelled or discarded */
  Cancelled = 'cancelled',
  /** Order confirmed */
  Confirmed = 'confirmed',
  /** Cancelled order restored */
  Reinstated = 'reinstated',
  /** Order modified */
  Updated = 'updated',
  /** Order voided */
  Void = 'void'
}

export type GOrderEventLine = {
  __typename?: 'OrderEventLine';
  afterQty?: Maybe<Scalars['Int']>;
  beforeQty?: Maybe<Scalars['Int']>;
  changed: Scalars['Boolean'];
  itemsPerLot?: Maybe<Scalars['Int']>;
  quantityType?: Maybe<Scalars['String']>;
  skuName: Scalars['String'];
  unitCostCents?: Maybe<Scalars['Int']>;
};

export type GOrderFee = {
  __typename?: 'OrderFee';
  /** The amount of the fee in cents applied to the order. */
  feeAmountCents: Scalars['Int'];
  /** Unique identifier of the fee associated with the order. */
  feeId: Scalars['ID'];
  /** The type of fee applied to the order. */
  feeType: Scalars['String'];
};

export type GOrderLine = {
  __typename?: 'OrderLine';
  backupItem?: Maybe<GSupplyItem>;
  basePriceCents: Scalars['Int'];
  /** Denotes if the item is picked in bulk item at the warehouse. */
  bulkPickedItem: Scalars['Boolean'];
  /**
   * Per-line audit log for the DMP review-detail page (admin role only; empty list
   * for other callers). Events are sorted chronologically (oldest first).
   */
  changeHistory: Array<GOrderLineChangeEvent>;
  deliveredQuantity?: Maybe<Scalars['Int']>;
  fractional: Scalars['Boolean'];
  fulfillmentQuantity?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isMarketPriced: Scalars['Boolean'];
  isPounds: Scalars['Boolean'];
  itemsPerLot: Scalars['Int'];
  /** Line-level delivery issues recorded for this order line on the given stop. */
  lineLevelDeliveryIssues: Array<GLineLevelDeliveryIssue>;
  newestReconciledOrderLine?: Maybe<GReconciledOrderLine>;
  odekoPerksDiscountCents?: Maybe<Scalars['Int']>;
  order: GOrder;
  orderUnitQuantity: Scalars['Int'];
  orderedWeightLb?: Maybe<Scalars['Float']>;
  originalOrderUnitQuantity: Scalars['Int'];
  priceDiscountCents?: Maybe<Scalars['Int']>;
  purchasePriceCents?: Maybe<Scalars['Int']>;
  quantityType: Scalars['String'];
  /**
   * Units the GM scheduled for re-delivery during DMP review. NULL = not yet
   * decided; 0 = decided no recovery; N>0 = recover N.
   */
  recoveryQuantity?: Maybe<Scalars['Int']>;
  sellingPriceCents?: Maybe<Scalars['Int']>;
  sku: GSku;
  substitutions: Array<GOrderLineSubstitution>;
  totalQuantity: Scalars['Int'];
  totalWeightLb?: Maybe<Scalars['Float']>;
  unitCostCents: Scalars['Float'];
  unitPriceCents?: Maybe<Scalars['Float']>;
  unitWeightLb?: Maybe<Scalars['Float']>;
};


export type GOrderLineLineLevelDeliveryIssuesArgs = {
  redelivery?: InputMaybe<Scalars['Boolean']>;
  stopId: Scalars['ID'];
};

export type GOrderLineAllocationInput = {
  fulfillmentQuantity: Scalars['Int'];
  id: Scalars['ID'];
};

/**
 * A single audited event on an OrderLine or one of its line-level delivery
 * issues. Flattened so UPDATEs that touch multiple columns surface as one
 * event per column (each with its own field/before/after); CREATE and
 * DESTROY events have field=null and the resource's audited row state
 * serialized into before_value or after_value.
 *
 * OrderLine CREATE events aren't surfaced (paper_trail records a no-op
 * version for every Kafka-sync OrderLine ingest). Whole-row CREATE/DESTROY
 * shapes therefore in practice only originate from LineLevelDeliveryIssue
 * events.
 */
export type GOrderLineChangeEvent = {
  __typename?: 'OrderLineChangeEvent';
  /**
   * JWT subject for human actors (e.g. `auth0|abc`) or `system:<name>` for sync
   * paths. Null only when no whodunnit was set (legacy versions).
   */
  actor?: Maybe<Scalars['String']>;
  /** Highest-precedence JWT role at write time, or 'system' for sync-path writes. Null when no role could be derived. */
  actorRole?: Maybe<Scalars['String']>;
  /**
   * JSON-encoded value. For UPDATE: the new scalar. For CREATE: the audited row
   * state (all columns of the audited model). Null for DESTROY.
   */
  afterValue?: Maybe<Scalars['String']>;
  /**
   * JSON-encoded value. For UPDATE: the prior scalar. For DESTROY: the audited row
   * state (all columns of the audited model). Null for CREATE.
   */
  beforeValue?: Maybe<Scalars['String']>;
  event: GChangeEventKind;
  /** Audited column name for UPDATE events. Null for CREATE/DESTROY (which carry the row state instead). */
  field?: Maybe<Scalars['String']>;
  /** GM rationale captured at write time (BaseMutation forwards the GraphQL `note:` arg into paper_trail metadata). */
  note?: Maybe<Scalars['String']>;
  resource: GAuditResourceKind;
  /**
   * Primary key of the audited row. For DESTROY events this row no longer exists;
   * use it to group events about the same underlying row.
   */
  resourceId: Scalars['ID'];
  timestamp: Scalars['ISO8601DateTime'];
};

/** Autogenerated input type of OrderLineDeliveredQuantityUpdate */
export type GOrderLineDeliveredQuantityUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Units actually delivered. Must be >= 0. */
  deliveredQuantity: Scalars['Int'];
  /** GM note describing the adjustment. */
  note: Scalars['String'];
  /** Order line id (UUID). */
  orderLineId: Scalars['ID'];
};

/** Autogenerated return type of OrderLineDeliveredQuantityUpdate. */
export type GOrderLineDeliveredQuantityUpdatePayload = {
  __typename?: 'OrderLineDeliveredQuantityUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderLine?: Maybe<GOrderLine>;
  userErrors: Array<GOrderError>;
};

/** Autogenerated input type of OrderLineFulfillmentQuantityUpdate */
export type GOrderLineFulfillmentQuantityUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Units the warehouse picked. Must be >= 0. */
  fulfillmentQuantity: Scalars['Int'];
  /** GM note describing the adjustment. */
  note: Scalars['String'];
  /** Order line id (UUID). */
  orderLineId: Scalars['ID'];
};

/** Autogenerated return type of OrderLineFulfillmentQuantityUpdate. */
export type GOrderLineFulfillmentQuantityUpdatePayload = {
  __typename?: 'OrderLineFulfillmentQuantityUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderLine?: Maybe<GOrderLine>;
  userErrors: Array<GOrderError>;
};

export type GOrderLineNotFound = GUserErrorInterface & {
  __typename?: 'OrderLineNotFound';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GOrderLineNotOnStop = GUserErrorInterface & {
  __typename?: 'OrderLineNotOnStop';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of OrderLineRecoveryQuantityUpdate */
export type GOrderLineRecoveryQuantityUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** GM note describing the recovery decision. */
  note: Scalars['String'];
  /** Order line id (UUID). */
  orderLineId: Scalars['ID'];
  /** Units to schedule for re-delivery. 0 = decided no recovery; > 0 = recover N. */
  recoveryQuantity: Scalars['Int'];
};

/** Autogenerated return type of OrderLineRecoveryQuantityUpdate. */
export type GOrderLineRecoveryQuantityUpdatePayload = {
  __typename?: 'OrderLineRecoveryQuantityUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderLine?: Maybe<GOrderLine>;
  userErrors: Array<GOrderError>;
};

export type GOrderLineSubstitution = {
  __typename?: 'OrderLineSubstitution';
  originalItem?: Maybe<GSupplyItem>;
  outcome: Scalars['String'];
  quantity: Scalars['Int'];
  reason: Scalars['String'];
  substituteItem?: Maybe<GSupplyItem>;
  substituteQuantity?: Maybe<Scalars['Int']>;
  swappedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type GOrderLinesFulfillmentInput = {
  fulfillmentQuantity: Scalars['Int'];
  id: Scalars['ID'];
};

export type GOrderLinesInput = {
  deliveredQuantity: Scalars['Int'];
  id: Scalars['ID'];
};

/** Error indicating that the order cannot be cancelled, typically because it is past the cutoff time. */
export type GOrderNotCancellableError = GError & {
  __typename?: 'OrderNotCancellableError';
  /** A description of the error. */
  message: Scalars['String'];
};

export type GOrderNotEligibleForReview = GUserErrorInterface & {
  __typename?: 'OrderNotEligibleForReview';
  /**
   * The rejected order's delivery_method, surfaced so the UI can distinguish a
   * third-party order (doordash / roadie / metrobi / burq / shipping / vendor)
   * from a vendor-style order (warehouse_id nil with delivery_method
   * delivery/pick_up). Not necessarily the *cause* of rejection — the gate
   * requires both an Odeko warehouse and a local-delivery method, and either
   * missing one excludes the order.
   */
  deliveryMethod?: Maybe<Scalars['String']>;
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** The order whose review-time mutation was rejected. */
  orderId: Scalars['ID'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GOrderNotFound = GUserErrorInterface & {
  __typename?: 'OrderNotFound';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** Error indicating that a mutation failed because a free order cannot be created with a non-zero total. */
export type GOrderNotFree = GError & {
  __typename?: 'OrderNotFree';
  /** A description of the error. */
  message: Scalars['String'];
};

export enum GOrderPlatform {
  BaristaProShop = 'BARISTA_PRO_SHOP',
  BaristaUnderground = 'BARISTA_UNDERGROUND',
  Odeko = 'ODEKO',
  OdekoBulk = 'ODEKO_BULK'
}

/** Autogenerated input type of OrderQuantityDeliveredUpdate */
export type GOrderQuantityDeliveredUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Order id. */
  orderId: Scalars['ID'];
  /** Order lines containing the quantity delivered */
  orderLines: Array<GOrderLinesInput>;
  redelivery?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of OrderQuantityDeliveredUpdate. */
export type GOrderQuantityDeliveredUpdatePayload = {
  __typename?: 'OrderQuantityDeliveredUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  orderLines?: Maybe<Array<GOrderLine>>;
  userErrors: Array<GOrderError>;
};

export type GOrderQueue = {
  __typename?: 'OrderQueue';
  /** Orders that need to be prepared for imminent pickup. */
  current: GConsumerOrderConnection;
  /** Order history. */
  history: GConsumerOrderConnection;
  /** Orders that need to be prepared, but not immediately. */
  scheduled: GConsumerOrderConnection;
};


export type GOrderQueueCurrentArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GConsumerOrderSortCriteria>;
};


export type GOrderQueueHistoryArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GConsumerOrderSortCriteria>;
};


export type GOrderQueueScheduledArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GConsumerOrderSortCriteria>;
};

export enum GOrderReconciliationReasonEnum {
  /** The item was damaged */
  Damaged = 'DAMAGED',
  /** The item is missing from the order */
  MissingItem = 'MISSING_ITEM',
  /** There is a quality issue with the item */
  QualityIssue = 'QUALITY_ISSUE',
  /** The wrong item was delivered */
  WrongItem = 'WRONG_ITEM'
}

/** Server-derived recovery state for an order surfaced on Order.recoveryStatus. DMP renders only; never writes. */
export enum GOrderRecoveryStatus {
  /**
   * Order is not subject to the DMP review flow (non-Odeko-warehouse,
   * non-local-delivery, or 3rd-party), or has no unrecovered shortfall to redeliver.
   */
  NotApplicable = 'not_applicable',
  /** A redelivery completed and the shortfall caught up (delivered_quantity >= fulfillment_quantity on every line). */
  Recovered = 'recovered',
  /** A redelivery stop exists on one of the order's Location delivery_route_stops and has not yet been completed. */
  Scheduled = 'scheduled',
  /**
   * A fulfilled≠delivered shortfall remains after the review is confirmed, with no
   * redelivery pending — either none scheduled, or a prior redelivery completed still short.
   */
  Unscheduled = 'unscheduled'
}

export type GOrderReference = {
  __typename?: 'OrderReference';
  id: Scalars['ID'];
  platform: GOrderPlatform;
};

/** Autogenerated input type of OrderReviewConfirm */
export type GOrderReviewConfirmInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** GM note describing the confirmation rationale. */
  note: Scalars['String'];
  /** Order id. */
  orderId: Scalars['ID'];
};

/** Autogenerated return type of OrderReviewConfirm. */
export type GOrderReviewConfirmPayload = {
  __typename?: 'OrderReviewConfirmPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  order?: Maybe<GOrder>;
  userErrors: Array<GOrderError>;
};

/** Server-derived review state for an order surfaced on Order.reviewStatus. DMP renders only; never writes. */
export enum GOrderReviewStatus {
  /**
   * review_confirmed_at was set by the SLA sweep job (paper_trail version's
   * actor_role == 'system'). The sweep itself ships in a separate PR; this value
   * is defined-but-unreachable today and will start appearing once the sweep runs.
   */
  AutoBilled = 'auto_billed',
  /** review_confirmed_at is set and the confirmation came from a human GM via confirmOrderReview. */
  Confirmed = 'confirmed',
  /**
   * delivered_at + REVIEW_SLA_DURATION has elapsed but no confirmation has
   * happened (neither manual nor auto). Surfaces orders the SLA sweep will pick up next.
   */
  PassedDeadline = 'passed_deadline',
  /**
   * Order has not been review-confirmed and the SLA deadline has not yet passed.
   * Default state for pre-delivery orders and for orders not subject to the review
   * flow (non-Odeko-warehouse, non-local-delivery).
   */
  ReadyForReview = 'ready_for_review'
}

/**
 * Server-derived delivery-route completion state for an order surfaced on
 * Order.routeCompletionState. A pure mirror of the anchor Order#route_completed_at
 * computes for the review-by deadline, so the two can never disagree. Route-grain,
 * not order-grain, and NOT monotonic: an admin reopening a route (clearing its
 * stop_time) moves its orders back out of complete. DMP renders only; never writes.
 */
export enum GOrderRouteCompletionState {
  /**
   * The order's delivery route has finished, so routeCompletedAt carries a time. A
   * route finishes at its explicit stop_time when one is set, otherwise once every
   * one of its stops is completed. An order sitting on more than one anchoring
   * route reads complete as soon as ANY of them finishes, so an order whose
   * generic route is still out reads complete once its customer-pickup bucket closes.
   */
  Complete = 'complete',
  /**
   * The order has at least one Location stop on an anchoring route (generic,
   * customer-pickup, or a third-party route a provider runs), but none of those
   * routes has finished, so nothing anchors its review deadline yet. Any
   * uncompleted stop holds the route here, including a Vendor pickup stop
   * belonging to another order.
   */
  InProgress = 'in_progress',
  /**
   * The order has no Location stop on an anchoring route (generic,
   * customer-pickup, or a third-party route a provider runs), so route completion
   * cannot anchor anything for it. Covers an order not yet scheduled onto a route,
   * an order not yet synced from Kafka, and an order whose only stops sit on a
   * provider's staging pen or a redelivery route, neither of which anchors review:
   * a pen is a queue that gets drained, not a route that completes.
   */
  NotRouteAnchored = 'not_route_anchored'
}

/** Vendor receiving record for a market-priced item */
export type GOrderVendorReceiving = {
  __typename?: 'OrderVendorReceiving';
  id: Scalars['ID'];
  itemId: Scalars['ID'];
  nightEnd: Scalars['ISO8601Date'];
  receivedQty: Scalars['Float'];
  sellingPricePerUnitCents?: Maybe<Scalars['Int']>;
  vendorId: Scalars['ID'];
  vendorPricePerUnitCents?: Maybe<Scalars['Int']>;
  vendorPriceTotalCents: Scalars['Int'];
  warehouseId: Scalars['ID'];
  windowClosesAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Autogenerated input type of OrderWarehouseNoteUpdate */
export type GOrderWarehouseNoteUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Warehouse note for the order */
  note: Scalars['String'];
  /** order id. */
  orderId: Scalars['ID'];
};

/** Autogenerated return type of OrderWarehouseNoteUpdate. */
export type GOrderWarehouseNoteUpdatePayload = {
  __typename?: 'OrderWarehouseNoteUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  order?: Maybe<GOrder>;
  userErrors: Array<GOrderError>;
};

/**
 * Whether a product is ready to sell in a market, and when it is not, why. Members name the reason a
 * product is withheld; ORDERABLE is the absence of one.
 *
 * Unrelated to stock: COMING_SOON means not released in this market yet, where out of stock means
 * released and temporarily unavailable. They read differently to a customer and must not be conflated.
 */
export enum GOrderability {
  ComingSoon = 'COMING_SOON',
  Orderable = 'ORDERABLE'
}

/** Error indicating that the caller's role does not permit ordering the requested item(s). */
export type GOrderingNotPermittedError = GError & {
  __typename?: 'OrderingNotPermittedError';
  /** A description of the error. */
  message: Scalars['String'];
};

export type GOrderingRule = {
  __typename?: 'OrderingRule';
  itemId: Scalars['ID'];
  /**
   * Lifetime limit on how much of this item the location can order across all its
   * orders, in order units (cases for an item sold by the case); null when there is none
   */
  itemMaxQuantity?: Maybe<Scalars['Int']>;
  /** Minimum quantity per order for this item */
  itemMinimumQuantity?: Maybe<Scalars['Int']>;
  /** Purchase multiple for the item */
  itemPurchaseMultiple?: Maybe<Scalars['Int']>;
  /** Quantity per unit for the item */
  itemQtyPerUnit?: Maybe<Scalars['Int']>;
  /**
   * How much more of this item the location can order under its lifetime limit, in
   * the same units. It's one number for the item, shared by all its lines on every
   * date, so capping each line at it separately can still go over in total. It
   * already counts every order of the location, including one being edited, so a
   * line on an existing order can go up to its current quantity plus this. Null
   * when there is no limit, or the user is an admin, who can go over it
   */
  itemRemainingQuantity?: Maybe<Scalars['Int']>;
  vendor: GVendor;
  /** Vendor minimum order amount in cents for this item */
  vendorMinimumAmountCents?: Maybe<Scalars['Int']>;
  /** Vendor minimum items per order for this item */
  vendorMinimumItems?: Maybe<Scalars['Int']>;
};

export type GOrderingRuleItemInput = {
  /** Item ID */
  id: Scalars['ID'];
};

/** Error indicating that the caller's role may only order items already saved to the location. */
export type GOrderingSavedItemsOnlyError = GError & {
  __typename?: 'OrderingSavedItemsOnlyError';
  /** A description of the error. */
  message: Scalars['String'];
};

/** The connection type for Order. */
export type GOrdersConnection = {
  __typename?: 'OrdersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GOrderEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GOrder>>>;
  /** Information to aid in pagination. */
  pageInfo: GPageInfo;
  /** The total count of records in the connection. */
  totalCount: Scalars['Int'];
};

export type GOrdersInput = {
  /** Filters orders by delivery date, from_delivery_date and to_delivery_date take precedence over this filter. */
  deliveryDate?: InputMaybe<Scalars['ISO8601Date']>;
  /** Filters orders by delivery method. */
  deliveryMethods?: InputMaybe<Array<GOrderDeliveryMethodEnum>>;
  /** Filters orders that have a delivery date on or after a specific date. */
  fromDeliveryDate?: InputMaybe<Scalars['ISO8601Date']>;
  /** Filters orders by the location, otherwise includes orders applicable to the user. */
  locationId?: InputMaybe<Scalars['ID']>;
  /** Filters orders that have a delivery date on or before a specific date. */
  toDeliveryDate?: InputMaybe<Scalars['ISO8601Date']>;
  /** Filters orders by warehouse. */
  warehouseId?: InputMaybe<Scalars['ID']>;
};

/** Input for checking for out of stock items */
export type GOutOfStockCheckInputItem = {
  /** Delivery date for the product check */
  deliveryDate: Scalars['ISO8601Date'];
  /** Warehouse ID for the item check */
  fulfillmentWarehouseId?: InputMaybe<Scalars['ID']>;
  /** Item UUID to check for out of stock */
  itemId: Scalars['ID'];
  /** Quantity of the item to check */
  requestedQty: Scalars['Int'];
};

/** Result of checking for out of stock items */
export type GOutOfStockCheckResult = {
  __typename?: 'OutOfStockCheckResult';
  /** Available quantity of the product */
  availableQty: Scalars['Int'];
  /**
   * Delivery date this result answers for. The same item can be checked for
   * several delivery dates in one request, and a result is only attributable to
   * its line by this date.
   */
  deliveryDate: Scalars['ISO8601Date'];
  /** Item details */
  item: GSupplyItem;
  /** Recommendation based on the out of stock check */
  recommendations?: Maybe<Array<GSupplyItem>>;
};

/** One gate in the outbound pipeline, reduced to a traffic-light state. */
export type GOutboundGate = {
  __typename?: 'OutboundGate';
  state: GOutboundGateState;
};

export enum GOutboundGateState {
  /** A deficiency was acknowledged but not fixed. */
  Acknowledged = 'ACKNOWLEDGED',
  /** All clear. */
  Clear = 'CLEAR',
  /** A deficiency was identified. */
  NeedsReview = 'NEEDS_REVIEW',
  /** Nothing to report at this gate yet. */
  Waiting = 'WAITING'
}

/** Outbound pipeline gates evaluated over a scope of orders. */
export type GOutboundGates = {
  __typename?: 'OutboundGates';
  /**
   * How far the orders in scope are past their own due_at, measured against the
   * most common one. Distinct from the warehouse's recurring daily cut-off time.
   */
  orderCutoff: GOutboundGate;
};

/** One in-progress customer still ready after a batch, with the error that stopped it if there was one. */
export type GOutstandingOnboardingRow = {
  __typename?: 'OutstandingOnboardingRow';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyUuid?: Maybe<Scalars['ID']>;
  /** Empty when the record was simply left behind rather than failed. */
  errorReason?: Maybe<Scalars['String']>;
  /** The company it was matched to, where one was matched. */
  existingCompanyName?: Maybe<Scalars['String']>;
  locationUuid?: Maybe<Scalars['ID']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  /** The id generated at ingest; the key this row joins on. */
  uniqueId?: Maybe<Scalars['String']>;
  userEmail?: Maybe<Scalars['String']>;
  userFirstName?: Maybe<Scalars['String']>;
  userLastName?: Maybe<Scalars['String']>;
};

export type GOverrideCodeIssueConflict = GUserErrorInterface & {
  __typename?: 'OverrideCodeIssueConflict';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GOverrideCodeNotFound = GUserErrorInterface & {
  __typename?: 'OverrideCodeNotFound';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GOverrideVendorNotFound = GUserErrorInterface & {
  __typename?: 'OverrideVendorNotFound';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** Information about pagination in a connection. */
export type GPageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type GPastHomepageCollectionEntry = {
  __typename?: 'PastHomepageCollectionEntry';
  collection: GCollection;
  componentType: GHomepageCollectionComponentType;
  configuredWarehouseCount: Scalars['Int'];
  enabledWarehouseCount: Scalars['Int'];
  endDate: Scalars['ISO8601Date'];
  ruleId: Scalars['ID'];
  startDate: Scalars['ISO8601Date'];
  warehouseIds: Array<Scalars['ID']>;
  warehouses: Array<GCollectionsHomepageEntryWarehouse>;
};

/** Edge connecting an OdekoPaymentIntent to the resulting NetsuiteCustomerPayment. */
export type GPaymentCompletion = GFinancialTransactionEdgeInfo & {
  __typename?: 'PaymentCompletion';
  _?: Maybe<Scalars['String']>;
};

/** Edge connecting an OdekoPaymentIntent to a specific transaction (e.g. invoice) for which some amount has been earmarked. */
export type GPaymentEarmark = GFinancialTransactionEdgeInfo & {
  __typename?: 'PaymentEarmark';
  _?: Maybe<Scalars['String']>;
  /** Amount earmarked for use towards paying the specific transaction (e.g. invoice). */
  amount: GMoney;
};

export type GPaymentError = {
  __typename?: 'PaymentError';
  amount: GMoney;
  date: Scalars['ISO8601Date'];
  message?: Maybe<Scalars['String']>;
  obfuscatedEmail?: Maybe<Scalars['String']>;
  paymentMethodBrand?: Maybe<Scalars['String']>;
  paymentMethodLast4?: Maybe<Scalars['String']>;
};

/** A group that refers to a failed payment, i.e. a payment that was submitted to a payment processor (e.g. Stripe) but failed. */
export type GPaymentFailed = GPaymentInvoiceGroup & {
  __typename?: 'PaymentFailed';
  /**
   * Invoices in the group. This collection, although not paginated, is expressed
   * as a connection type in order to include the amount of payment associated with
   * each invoice via PaymentEarmark/PaymentUsage edge info.
   */
  invoices: GFinancialTransactionConnection;
  paymentAmount: GMoney;
  paymentDate: Scalars['ISO8601Date'];
};

/**
 * A group that refers to an upcoming, pending, successful, or failed payment. Note
 * that `upcoming` payments are a completely virtual type; these are not stored in the database.
 */
export type GPaymentInvoiceGroup = {
  /**
   * Invoices in the group. This collection, although not paginated, is expressed
   * as a connection type in order to include the amount of payment associated with
   * each invoice via PaymentEarmark/PaymentUsage edge info.
   */
  invoices: GFinancialTransactionConnection;
  paymentAmount: GMoney;
  paymentDate: Scalars['ISO8601Date'];
};

/** The connection type for PaymentInvoiceGroup. */
export type GPaymentInvoiceGroupConnection = {
  __typename?: 'PaymentInvoiceGroupConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GPaymentInvoiceGroupEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GPaymentInvoiceGroup>>>;
  /** Information to aid in pagination. */
  pageInfo: GPageInfo;
};

/** An edge in a connection. */
export type GPaymentInvoiceGroupEdge = {
  __typename?: 'PaymentInvoiceGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GPaymentInvoiceGroup>;
};

/** Payment method values. */
export enum GPaymentMethod {
  /** Free. */
  Free = 'free',
  /** Square card ID. */
  SquareCardId = 'square_card_id',
  /** Square card nonce. */
  SquareCardNonce = 'square_card_nonce',
  /** Wallet balance. */
  WalletBalance = 'wallet_balance'
}

export type GPaymentMethodDefaultLocation = {
  __typename?: 'PaymentMethodDefaultLocation';
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** Error indicating that the payment method type does not match the default payment type for the location. */
export type GPaymentMethodMismatchError = GError & {
  __typename?: 'PaymentMethodMismatchError';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating that the payment method is missing. */
export type GPaymentMethodMissingError = GError & {
  __typename?: 'PaymentMethodMissingError';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Payment method types that can be used for orders */
export enum GPaymentMethodTypeEnum {
  /** Direct funds transfer from bank account (ACH) */
  BankAccount = 'BANK_ACCOUNT',
  /** A "buy now pay later" installment lender, e.g. Credit Key */
  BuyNowPayLater = 'BUY_NOW_PAY_LATER',
  /** Credit card */
  CreditCard = 'CREDIT_CARD'
}

/**
 * A group that refers to a pending payment, i.e. a payment that was submitted to a
 * payment processor (e.g. Stripe) and has not yet succeeded or failed.
 */
export type GPaymentPending = GPaymentInvoiceGroup & {
  __typename?: 'PaymentPending';
  /**
   * Invoices in the group. This collection, although not paginated, is expressed
   * as a connection type in order to include the amount of payment associated with
   * each invoice via PaymentEarmark/PaymentUsage edge info.
   */
  invoices: GFinancialTransactionConnection;
  paymentAmount: GMoney;
  /** Date on which payment was submitted. */
  paymentDate: Scalars['ISO8601Date'];
};

export type GPaymentProcessing = GFeeInterface & {
  __typename?: 'PaymentProcessing';
  /** The threshold amount in cents at which the fee is applied. */
  feeThresholds: Array<GFeeThreshold>;
  id: Scalars['ID'];
  /** Indicates if the fee is active or not. */
  isActive: Scalars['Boolean'];
  odekoUuid: Scalars['ID'];
  /** The percentage of the payment processing fee. */
  warehouseFeePercent: Scalars['Float'];
  /** Unique identifier of the warehouse associated with this payment processing fee. */
  warehouseId: Scalars['ID'];
};

/** Error indicating that a mutation failed due to a payment processor error whose cause is unknown. */
export type GPaymentProcessorGenericError = GError & {
  __typename?: 'PaymentProcessorGenericError';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating that payment settings are missing. */
export type GPaymentSettingsMissingError = GError & {
  __typename?: 'PaymentSettingsMissingError';
  /** A description of the error. */
  message: Scalars['String'];
};

/**
 * A group that refers to a successful payment, i.e. a payment that was submitted
 * to a payment processor (e.g. Stripe) and succeeded.
 */
export type GPaymentSuccessful = GPaymentInvoiceGroup & {
  __typename?: 'PaymentSuccessful';
  /**
   * Invoices in the group. This collection, although not paginated, is expressed
   * as a connection type in order to include the amount of payment associated with
   * each invoice via PaymentEarmark/PaymentUsage edge info.
   */
  invoices: GFinancialTransactionConnection;
  paymentAmount: GMoney;
  /** Date on which payment was submitted. */
  paymentDate: Scalars['ISO8601Date'];
};

/**
 * A group that refers to an upcoming payment, i.e. a payment that has not yet been
 * submitted to a payment processor (e.g. Stripe). Note that upcoming payments are
 * calculated on demand, i.e. they reflect the payments that would eventually be
 * submitted for processing given the current invoices, payment terms, etc.
 */
export type GPaymentUpcoming = GPaymentInvoiceGroup & {
  __typename?: 'PaymentUpcoming';
  billingStatus?: Maybe<GBillingStatus>;
  /**
   * Invoices in the group. This collection, although not paginated, is expressed
   * as a connection type in order to include the amount of payment associated with
   * each invoice via PaymentEarmark/PaymentUsage edge info.
   */
  invoices: GFinancialTransactionConnection;
  paymentAmount: GMoney;
  /** Date on which payment submission is due. */
  paymentDate: Scalars['ISO8601Date'];
};

/** Edge connecting a payment-record to a transaction (e.g. invoice) on which payment was used. */
export type GPaymentUsage = GFinancialTransactionEdgeInfo & {
  __typename?: 'PaymentUsage';
  _?: Maybe<Scalars['String']>;
  /** Amount of payment used. */
  amount: GMoney;
  /** Date on which payment was used. */
  date: Scalars['ISO8601Date'];
};

/** Autogenerated input type of PerformOutOfStockChecksMutation */
export type GPerformOutOfStockChecksMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** If true, excludes recommendations from the result */
  excludeRecommendations?: InputMaybe<Scalars['Boolean']>;
  /** Location UUID */
  locationId: Scalars['ID'];
  /** List of items to check if are out of stock */
  requestedItems: Array<GOutOfStockCheckInputItem>;
};

/** Autogenerated return type of PerformOutOfStockChecksMutation. */
export type GPerformOutOfStockChecksMutationPayload = {
  __typename?: 'PerformOutOfStockChecksMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GUserError>;
  results?: Maybe<Array<GOutOfStockCheckResult>>;
};

export enum GPerishability {
  NonPerishable = 'NON_PERISHABLE',
  Perishable = 'PERISHABLE',
  SemiPerishable = 'SEMI_PERISHABLE'
}

export type GPhoneNumber = {
  __typename?: 'PhoneNumber';
  afterHoursContactAllowed: Scalars['Boolean'];
  number: Scalars['String'];
  phoneType: GPhoneTypeEnum;
};

/** Error indicating the requested phone number is already in use. */
export type GPhoneNumberAlreadyTaken = GError & {
  __typename?: 'PhoneNumberAlreadyTaken';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating that a mutation failed because the provided phone number was not formatted correctly. */
export type GPhoneNumberNotFormatted = GError & {
  __typename?: 'PhoneNumberNotFormatted';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating that a mutation failed because the provided phone number was not successfully verified. */
export type GPhoneNumberNotVerified = GError & {
  __typename?: 'PhoneNumberNotVerified';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating a failure to start phone number verification. */
export type GPhoneNumberVerificationNotStarted = GError & {
  __typename?: 'PhoneNumberVerificationNotStarted';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Result of successfully starting phone number verification. */
export type GPhoneNumberVerificationStarted = {
  __typename?: 'PhoneNumberVerificationStarted';
  /** Success message. */
  message: Scalars['String'];
};

/** Result of successfully reporting phone number verification. */
export type GPhoneNumberVerified = {
  __typename?: 'PhoneNumberVerified';
  /**
   * ID of successful phone number verification. This should be included as an
   * argument to mutations that require proof of successful phone number verification.
   */
  phoneVerificationId: Scalars['ID'];
};

export enum GPhoneTypeEnum {
  /** Location phone number that can be used to resolve order issues */
  OrderContact = 'order_contact'
}

/** Where and when the driver app took a stop photo. */
export type GPhotoCaptureDetails = {
  __typename?: 'PhotoCaptureDetails';
  /** Device time when the photo was taken; can be well before the upload when the app queued it offline. */
  capturedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Device position when the photo was taken. Null when the app had no valid fix. */
  coordinates?: Maybe<GGeoCoordinates>;
};

/**
 * One past warehouse-day grading the nightly pick-hours suggestion against the
 * measured actual. Grading runs on the measured-active-hours scale (overhead
 * cancels): errorRatio = suggestedActiveHours / measuredActiveHours = forecastMiss
 * × conversionDrift × paceDrift. Each row is graded on its own demandBasis — rows
 * on different bases are not comparable. Ungradeable pieces are null, never fabricated.
 */
export type GPickHoursScorecardDay = {
  __typename?: 'PickHoursScorecardDay';
  /**
   * Realized pick lines: countable RF-SMART pick events in the path's channels on
   * the local floor day — the fulfillment_date_lines grading denominator.
   */
  actualLines?: Maybe<Scalars['Int']>;
  /** measuredActiveHours × overheadSnapshot: the actual on the staffing scale the admin saw. */
  actualStaffingHours?: Maybe<Scalars['Float']>;
  /** Realized sale units (ld-scoped orders + ecom actuals) — the delivery_date_units grading denominator. */
  actualUnits?: Maybe<Scalars['Float']>;
  benchmarkErrorHours?: Maybe<Scalars['Float']>;
  /** Weekday median of measured active hours over the trailing window — the naive benchmark. */
  benchmarkHours?: Maybe<Scalars['Float']>;
  /** Kiosk-clocked pick-path hours — corroboration only, in no calculation. */
  clockedPickHours?: Maybe<Scalars['Float']>;
  computedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /**
   * Fitted scans-per-forecast-line ÷ realizedConversion. The fit is per FORECAST
   * quantity (so a constant forecast bias cancels out of the suggestion), which
   * makes this move inversely with forecastMiss at a biased site: only their
   * product and paceDrift are separately meaningful.
   */
  conversionDrift?: Maybe<Scalars['Float']>;
  date: Scalars['ISO8601Date'];
  /**
   * Demand basis the suggestion was computed and graded on:
   * 'fulfillment_date_lines' (forecast pick lines keyed on the picking day, graded
   * vs actualLines) or 'delivery_date_units' (forecast sale units keyed on
   * delivery/order date, graded vs actualUnits). Never pool rows across bases.
   * Null when the day has no suggestion.
   */
  demandBasis?: Maybe<Scalars['String']>;
  /** Forecast demand at each candidate offset (on demandBasis's quantity), frozen at compute time. */
  demandSnapshots?: Maybe<Scalars['JSON']>;
  /** suggestedActiveHours ÷ measuredActiveHours. */
  errorRatio?: Maybe<Scalars['Float']>;
  /**
   * Forecast demand at the offset ÷ realized demand, both on the row's
   * demandBasis. Anti-correlated with conversionDrift — see that field.
   */
  forecastMiss?: Maybe<Scalars['Float']>;
  /** Measured active picking hours from the scan stream — the actual on the suggestion's own scale. */
  measuredActiveHours?: Maybe<Scalars['Float']>;
  measuredScans?: Maybe<Scalars['Int']>;
  /** Forecast day offset the suggestion was computed at (0 on the fulfillment-date basis: nothing left to guess). */
  offsetDays?: Maybe<Scalars['Int']>;
  overheadSnapshot?: Maybe<Scalars['Float']>;
  /** True when the admin took the cell over; false means the suggestion stood. */
  overridden?: Maybe<Scalars['Boolean']>;
  /** True when the admin's number landed at least as close to the actual as the naive weekday-median benchmark. */
  overrideBeatsBenchmark?: Maybe<Scalars['Boolean']>;
  /**
   * True when the admin's number landed at least as close to the actual as the
   * system's. Ranked with the row's frozen overhead on one scale, so the verdict
   * is scale-invariant.
   */
  overrideBeatsSuggestion?: Maybe<Scalars['Boolean']>;
  /**
   * |targetHours − actualStaffingHours| on the staffing scale the admin typed on.
   * Null unless overridden and the row carries a frozen overheadSnapshot (no
   * snapshot, no grade — never a fallback).
   */
  overrideErrorHours?: Maybe<Scalars['Float']>;
  /**
   * targetHours ÷ measuredActiveHours, shipped ONLY on overridden rows that cannot
   * be graded (no overheadSnapshot). A plausibility check against the normal
   * overhead band, not a grade.
   */
  overrideImpliedOverhead?: Maybe<Scalars['Float']>;
  /** Realized pace ÷ fitted pace. */
  paceDrift?: Maybe<Scalars['Float']>;
  paceSnapshot?: Maybe<Scalars['Float']>;
  /**
   * Measured scans ÷ the realized demand on the row's demandBasis (actualLines or
   * actualUnits) — the realized counterpart of scansPerForecastLineSnapshot.
   */
  realizedConversion?: Maybe<Scalars['Float']>;
  /** Realized scans per active picking hour. */
  realizedPace?: Maybe<Scalars['Float']>;
  /**
   * The fitted conversion factor: covered scans per FORECAST line — fitted per
   * forecast quantity, never a physical warehouse constant (per forecast sale unit
   * on delivery_date_units rows).
   */
  scansPerForecastLineSnapshot?: Maybe<Scalars['Float']>;
  source?: Maybe<GProcessPathCoverageTargetSource>;
  /** The suggestion on the measured-active-hours scale, recomputed from its own snapshots (before overhead). */
  suggestedActiveHours?: Maybe<Scalars['Float']>;
  /** The nightly suggestion in staffing hours (baselineRequiredHours). Null when no suggestion was computed. */
  suggestedHours?: Maybe<Scalars['Float']>;
  /** True when the suggestion's absolute error is no larger than the benchmark's. */
  suggestionBeatsBenchmark?: Maybe<Scalars['Boolean']>;
  suggestionErrorHours?: Maybe<Scalars['Float']>;
  /** What the planning grid held for the day (the admin's number under an override). */
  targetHours?: Maybe<Scalars['Float']>;
};

export type GPickUp = {
  __typename?: 'PickUp';
  /** The time the driver arrived at the stop */
  arrivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  attachments?: Maybe<Array<GAttachment>>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']>;
  deliveryStatus: GDeliveryStatus;
  /** stop status used in the DMP */
  deliveryStatusDmp: GDeliveryStatusDmp;
  deliveryStatusDriver: GDeliveryStatusDriver;
  /** The time the driver departed from the stop */
  departedAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  issues?: Maybe<Array<GIssue>>;
  orders?: Maybe<Array<GOrder>>;
  reminderMessage?: Maybe<Scalars['String']>;
  route: GRoute;
  sequenceNumber?: Maybe<Scalars['String']>;
  vendor: GVendor;
};

export type GPickupRoutingDisabled = GUserErrorInterface & {
  __typename?: 'PickupRoutingDisabled';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
  warehouseIds: Array<Scalars['ID']>;
};

export type GPickupSchedule = {
  __typename?: 'PickupSchedule';
  /** Time treated as current during schedule calculation. */
  asOf: Scalars['ISO8601DateTime'];
  /** Pickup schedules by date. */
  byDate: Array<GPickupScheduleOnDate>;
  /** Server time when schedule was calculated. */
  calculatedAt: Scalars['ISO8601DateTime'];
  /** Default pickup time. This is the earliest available pickup time, or null if no available time was found. */
  defaultPickupTime?: Maybe<GPickupTime>;
  /** Minimum notice required for pickup. */
  minimumNotice: GRelativeTime;
  /** Time zone of date boundaries. */
  timezone: Scalars['String'];
};

export type GPickupScheduleOnDate = {
  __typename?: 'PickupScheduleOnDate';
  /** Time intervals describing availability or reasons for unavailability. */
  allIntervals: Array<GAvailabilityInterval>;
  /** Time intervals during which pickup is available. */
  availableIntervals: Array<GAvailableInterval>;
  /** Calendar date in schedule's time zone. */
  date: Scalars['ISO8601Date'];
};

/** Pickup time. */
export type GPickupTime = GAbsoluteTime | GRelativeTime;

export type GPinItemAcrossMarketsInput = {
  itemId: Scalars['ID'];
  /** Absolute carousel slot to pin to in every eligible market — the item becomes that slot's queue leader in each. */
  position: Scalars['Int'];
  /** Mark every resulting pin as a paid (sponsored) placement; defaults off. */
  sponsored?: InputMaybe<Scalars['Boolean']>;
  /** Restrict the pin to this subset of markets, intersected with the item's currently-new markets. Omit to pin every eligible market. */
  warehouseIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type GPinItemAcrossMarketsPayload = {
  __typename?: 'PinItemAcrossMarketsPayload';
  errors: Array<GNewItemPinError>;
  pins: Array<GNewItemPin>;
  /** Number of those markets where an existing pin was demoted to a fallback candidate. */
  warehousesBumped: Scalars['Int'];
  /** Number of markets the item was pinned in. */
  warehousesPinned: Scalars['Int'];
};

export type GPlannedVehicle = {
  __typename?: 'PlannedVehicle';
  /** Planned maximum volume in in³ the routing run modeled for this route's vehicle */
  maxVolume?: Maybe<Scalars['Int']>;
  /** Planned maximum weight in lbs the routing run modeled for this route's vehicle */
  maxWeight?: Maybe<Scalars['Int']>;
  /** Planned vehicle type the routing run assigned (e.g. van, box truck) */
  vehicleType?: Maybe<Scalars['String']>;
};

export enum GPlatformActions {
  Connect = 'CONNECT',
  Login = 'LOGIN',
  Signup = 'SIGNUP'
}

/** Platform entity types */
export enum GPlatformEntity {
  /** Platform Account entity */
  Account = 'ACCOUNT',
  /** Account Profile entity */
  Profile = 'PROFILE'
}

/** Supported platform identifiers */
export enum GPlatformIds {
  GoogleBusinessProfile = 'GOOGLE_BUSINESS_PROFILE',
  MondayBoard = 'MONDAY_BOARD',
  SquareMarketingTools = 'SQUARE_MARKETING_TOOLS',
  SquareV2 = 'SQUARE_V2'
}

/** Platform entity with microsite association */
export type GPlatformMicrosite = {
  __typename?: 'PlatformMicrosite';
  /** Account ID or Profile ID of the platform entity */
  entityId: Scalars['ID'];
  /** Name of the platform entity */
  entityName: Scalars['String'];
  /** Type of the platform entity (ACCOUNT or PROFILE) */
  entityType: GPlatformEntity;
  /** Google Place ID associated with this platform entity */
  googlePlaceId?: Maybe<Scalars['String']>;
  /** Whether this is the default microsite for analytics */
  isDefault: Scalars['Boolean'];
  /** Associated microsite location, if any */
  micrositeLocation?: Maybe<GMicrositeLocation>;
};

export enum GPlatformType {
  Mobile = 'MOBILE',
  Web = 'WEB'
}

export enum GPredictabilityLevel {
  Erratic = 'ERRATIC',
  Moderate = 'MODERATE',
  NoVariation = 'NO_VARIATION',
  Predictable = 'PREDICTABLE',
  SingleOrder = 'SINGLE_ORDER'
}

/** AWS S3 service possible errors */
export type GPresignerError = GServiceError;

/** Price correction indicating that a price expectation was out of date or otherwise inaccurate. */
export type GPriceCorrection = GError & {
  __typename?: 'PriceCorrection';
  /** Correct price. */
  correctPrice: GMoney;
  /** ID of object associated with this price correction. */
  id: Scalars['ID'];
  /** A description of the error. */
  message: Scalars['String'];
};

/** A pricing package configuration for marketing tools subscriptions */
export type GPricingPackage = {
  __typename?: 'PricingPackage';
  /** Whether to display kit option */
  displayKit: Scalars['Boolean'];
  /** Whether to display subscription option */
  displaySubscription: Scalars['Boolean'];
  /** UUID identifier */
  id: Scalars['ID'];
  /** Human-readable kit description */
  kitDescription?: Maybe<Scalars['String']>;
  /** Whether physical signage kit purchase is optional */
  kitOptional: Scalars['Boolean'];
  /** Kit price in cents */
  kitPriceCents: Scalars['Int'];
  /** Stripe Price ID for kit */
  kitStripePriceId: Scalars['String'];
  /** Integer ID for easy reference */
  pricingPackageId: Scalars['Int'];
  /** Human-readable subscription description */
  subscriptionDescription?: Maybe<Scalars['String']>;
  /** Subscription period (month, year) */
  subscriptionPeriod?: Maybe<Scalars['String']>;
  /** Subscription price in cents */
  subscriptionPriceCents?: Maybe<Scalars['Int']>;
  /** Stripe Price ID for subscription */
  subscriptionStripePriceId?: Maybe<Scalars['String']>;
  /** Package summary description */
  summary?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of PricingServicePingify */
export type GPricingServicePingifyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of PricingServicePingify. */
export type GPricingServicePingifyPayload = {
  __typename?: 'PricingServicePingifyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  result: Scalars['String'];
};

export enum GPrintingMethod {
  /** Printed by a third party vendor */
  External = 'external',
  /** Printed by our own team */
  InHouse = 'in_house'
}

export type GProcessPath = {
  __typename?: 'ProcessPath';
  /** Whether this catalog path is available at the given warehouse. */
  availableHere: Scalars['Boolean'];
  category: GProcessPathCategory;
  /** Stable short code, e.g. PICK. */
  code: Scalars['String'];
  /** Hex colour used for chips/bars in the UI. */
  color: Scalars['String'];
  id: Scalars['ID'];
  label: Scalars['String'];
  sortOrder: Scalars['Int'];
};


export type GProcessPathAvailableHereArgs = {
  warehouseId: Scalars['ID'];
};

export enum GProcessPathAgency {
  /** ProLogistix. */
  Prologistix = 'PROLOGISTIX',
  /** Wonolo. */
  Wonolo = 'WONOLO'
}

/** Autogenerated input type of ProcessPathAssign */
export type GProcessPathAssignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['ID'];
  pathId: Scalars['ID'];
  warehouseId: Scalars['ID'];
};

/** Autogenerated return type of ProcessPathAssign. */
export type GProcessPathAssignPayload = {
  __typename?: 'ProcessPathAssignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  employeeDay?: Maybe<GProcessPathEmployeeDay>;
  userErrors: Array<GProcessPathError>;
};

/** Autogenerated input type of ProcessPathAssociateCreate */
export type GProcessPathAssociateCreateInput = {
  agency: GProcessPathAgency;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  warehouseId: Scalars['ID'];
};

/** Autogenerated return type of ProcessPathAssociateCreate. */
export type GProcessPathAssociateCreatePayload = {
  __typename?: 'ProcessPathAssociateCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  employee?: Maybe<GProcessPathEmployee>;
  userErrors: Array<GProcessPathError>;
};

/** Autogenerated input type of ProcessPathAssociateSetStatus */
export type GProcessPathAssociateSetStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['ID'];
  status: GWarehouseAssociateStatus;
};

/** Autogenerated return type of ProcessPathAssociateSetStatus. */
export type GProcessPathAssociateSetStatusPayload = {
  __typename?: 'ProcessPathAssociateSetStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  employee?: Maybe<GProcessPathEmployee>;
  userErrors: Array<GProcessPathError>;
};

export enum GProcessPathCategory {
  /** Direct (hands-on the work) time. */
  Direct = 'DIRECT',
  /** Indirect time (break, cleanup, meeting, other). */
  Indirect = 'INDIRECT'
}

/** Autogenerated input type of ProcessPathClearCoverageTarget */
export type GProcessPathClearCoverageTargetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  date: Scalars['ISO8601Date'];
  pathId: Scalars['ID'];
  warehouseId: Scalars['ID'];
};

/** Autogenerated return type of ProcessPathClearCoverageTarget. */
export type GProcessPathClearCoverageTargetPayload = {
  __typename?: 'ProcessPathClearCoverageTargetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The reverted system row, or null when the cell is now empty. */
  coverageTarget?: Maybe<GProcessPathCoverageTarget>;
  userErrors: Array<GProcessPathError>;
};

/** Autogenerated input type of ProcessPathClockIn */
export type GProcessPathClockInInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['ID'];
  warehouseId: Scalars['ID'];
};

/** Autogenerated return type of ProcessPathClockIn. */
export type GProcessPathClockInPayload = {
  __typename?: 'ProcessPathClockInPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  employeeDay?: Maybe<GProcessPathEmployeeDay>;
  userErrors: Array<GProcessPathError>;
};

/** Autogenerated input type of ProcessPathClockOut */
export type GProcessPathClockOutInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['ID'];
  warehouseId: Scalars['ID'];
};

/** Autogenerated return type of ProcessPathClockOut. */
export type GProcessPathClockOutPayload = {
  __typename?: 'ProcessPathClockOutPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  employeeDay?: Maybe<GProcessPathEmployeeDay>;
  userErrors: Array<GProcessPathError>;
};

export type GProcessPathCompliance = {
  __typename?: 'ProcessPathCompliance';
  /**
   * Agency temp staff's (Wonolo/ProLogistix) kiosk self-clock
   * (ProcessPathTimecard) minutes. No payroll source exists for temps, so this is
   * self-reported, not ARMHR-grade — do not compare directly to clocked_minutes above.
   */
  agencyClockedMinutes: Scalars['Int'];
  /**
   * agency_self_reported ÷ agency_clocked, %. Self-reported kiosk time versus
   * self-reported segments — both sides are self-reported, never payroll-grade.
   * Null when nothing is agency-clocked (undefined).
   */
  agencyCoveragePct?: Maybe<Scalars['Float']>;
  /** agency_clocked − agency_self_reported. Positive = under-reported temp labour, by the self-reported kiosk yardstick. */
  agencyGapMinutes: Scalars['Int'];
  /**
   * Person-minutes reported into process paths by agency temp staff
   * (Wonolo/ProLogistix), broken out of the coverage math since ARMHR clocked
   * minutes never include them.
   */
  agencySelfReportedMinutes: Scalars['Int'];
  /** ARMHR physical clocked minutes. Partial for today (open/missed-clock-out punches have no worked minutes yet). */
  clockedMinutes: Scalars['Int'];
  /** self_reported ÷ clocked, %. Null when nothing is clocked (undefined). */
  coveragePct?: Maybe<Scalars['Float']>;
  endDate: Scalars['ISO8601Date'];
  /** clocked − self_reported. Positive = under-reported labour. */
  gapMinutes: Scalars['Int'];
  /**
   * ARMHR-sourced associates whose reported segment minutes exceed their clocked
   * punch minutes over the window — the people who can push coverage_pct above
   * 100%. Largest excess first.
   */
  overReporters: Array<GProcessPathOverReporter>;
  /**
   * Person-minutes reported into process paths (segments) by ARMHR-sourced
   * associates only. Agency temps' minutes are reported separately in
   * agency_self_reported_minutes (their sum plus this one is the same total as the By-hour tab).
   */
  selfReportedMinutes: Scalars['Int'];
  startDate: Scalars['ISO8601Date'];
  warehouseId: Scalars['ID'];
};

export type GProcessPathCoverageTarget = {
  __typename?: 'ProcessPathCoverageTarget';
  /** The system suggestion a cleared override reverts to. */
  baselineRequiredHours?: Maybe<Scalars['Float']>;
  date: Scalars['ISO8601Date'];
  path: GProcessPath;
  /** Whether the value is admin-entered or system-computed. */
  source: GProcessPathCoverageTargetSource;
  /** Planned labour hours (allows half-hours). 0 is an asserted zero. */
  targetHours: Scalars['Float'];
  warehouseId: Scalars['ID'];
};

export enum GProcessPathCoverageTargetSource {
  /** Hand-entered by an admin; system writes never touch it. */
  Admin = 'ADMIN',
  /** Computed by the nightly baseline job. */
  System = 'SYSTEM'
}

/** Autogenerated input type of ProcessPathCreate */
export type GProcessPathCreateInput = {
  category: GProcessPathCategory;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  code: Scalars['String'];
  color?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  warehouseId: Scalars['ID'];
};

/** Autogenerated return type of ProcessPathCreate. */
export type GProcessPathCreatePayload = {
  __typename?: 'ProcessPathCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  processPath?: Maybe<GProcessPath>;
  userErrors: Array<GProcessPathError>;
};

/**
 * Warehouse-level forecasted demand for one day, in SALES UNITS (as ordered — a
 * case counts as 1; the same basis as pick throughput units). Not broken down by process path.
 */
export type GProcessPathDayForecast = {
  __typename?: 'ProcessPathDayForecast';
  date: Scalars['ISO8601Date'];
  /** How this day's demand is dated. Always fulfillment_date_lines (picking-day feed, same basis as the pick-hours suggestion). */
  demandBasis: Scalars['String'];
  /** Forecasted ecommerce order units. */
  ecomUnits?: Maybe<Scalars['Float']>;
  /** Forecasted local-delivery units picked. */
  localDeliveryUnits?: Maybe<Scalars['Float']>;
  /** Forecast pick lines (LD + ecom) for the day — what the pick-hours suggestion computes from. */
  pickLines?: Maybe<Scalars['Float']>;
  /** Sum of the available unit forecasts for the day. */
  totalUnits: Scalars['Float'];
};

export type GProcessPathDayTotal = {
  __typename?: 'ProcessPathDayTotal';
  minutes: Scalars['Int'];
  path: GProcessPath;
};

export type GProcessPathEmployee = {
  __typename?: 'ProcessPathEmployee';
  /** Staffing agency for source=agency associates (e.g. wonolo, prologistix). */
  agency?: Maybe<Scalars['String']>;
  /** ARMHR employee code (identity-spine join key). */
  associateId: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  /** ARMHR job title (homePosition), e.g. "Warehouse Associate". */
  position?: Maybe<Scalars['String']>;
  positionId?: Maybe<Scalars['String']>;
  shiftLabel?: Maybe<Scalars['String']>;
  /** armhr (WorkforceHub-synced) or agency (manually provisioned temp staff). */
  source: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  warehouseId?: Maybe<Scalars['ID']>;
};

/**
 * An associate's labour for one date. clockInAt/clockedMinutes come from the kiosk
 * self-clock; punchedInAt/untrackedMinutes/pathSelectionFlagged come from the
 * ARMHR time clock and lag it by up to ~30 min.
 */
export type GProcessPathEmployeeDay = {
  __typename?: 'ProcessPathEmployeeDay';
  accountedMinutes: Scalars['Int'];
  clockInAt?: Maybe<Scalars['ISO8601DateTime']>;
  clockOutAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** How the shift ended: 'system' = auto-closed by reconciliation. */
  clockOutSource?: Maybe<GProcessPathSource>;
  clockedMinutes: Scalars['Int'];
  /** Open segment for today, if any (drives the live board). */
  currentSegment?: Maybe<GProcessPathSegment>;
  date: Scalars['ISO8601Date'];
  employee: GProcessPathEmployee;
  /**
   * untrackedMinutes >= 30 — the supervisor's chase list. The threshold matches
   * the punch sync cadence, so polling lag alone cannot trip it.
   */
  pathSelectionFlagged: Scalars['Boolean'];
  /** ARMHR punch-in for the shift in progress. Null when off shift, or for agency temps, who never have punches. */
  punchedInAt?: Maybe<Scalars['ISO8601DateTime']>;
  segments: Array<GProcessPathSegment>;
  totals: Array<GProcessPathDayTotal>;
  /** max(clocked - accounted, 0). */
  unaccountedMinutes: Scalars['Int'];
  /**
   * Minutes since labour was last attributed to a path, measured from the later of
   * punch-in and the last closed segment. Null when on a path or not punched in.
   */
  untrackedMinutes?: Maybe<Scalars['Int']>;
};

export type GProcessPathEmployeeNotFound = GUserErrorInterface & {
  __typename?: 'ProcessPathEmployeeNotFound';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GProcessPathEmployeeThroughput = {
  __typename?: 'ProcessPathEmployeeThroughput';
  accuracy: GProcessPathThroughputAccuracy;
  /** What units/orphanUnits/ratePerHour count. Always "units"; kept for clients that read it while pick paths counted lines. */
  basis: Scalars['String'];
  date: Scalars['ISO8601Date'];
  /**
   * The hours `ratePerHour` divided by. clocked_hours: kiosk-clocked person-hours
   * by this employee on this path (`laborHours`).
   */
  denominator: Scalars['String'];
  employee: GProcessPathEmployee;
  laborHours: Scalars['Float'];
  /**
   * Output by this employee on this path with no matching same-path segment (a
   * capture-discipline signal: the work happened but was never clocked).
   */
  orphanUnits: Scalars['Float'];
  path: GProcessPath;
  /** `units` per hour of `denominator`. Null (not zero) when no labour was logged. */
  ratePerHour?: Maybe<Scalars['Float']>;
  sourceLabel: Scalars['String'];
  /**
   * What one of `units` is: sales_units on pick paths (as ordered — a case counts
   * as 1, the demand forecast's basis); handling_units on receive (the receipt
   * line's ordering unit — a case of any size counts as 1; named from the rows'
   * frozen handling_basis); operations on putaway and count.
   */
  unit: Scalars['String'];
  /**
   * Output attributed to this employee on the day, counted in `unit` — the same
   * basis the warehouse day total sums on this path.
   */
  units: Scalars['Float'];
};

/** Process path possible error types */
export type GProcessPathError = GProcessPathEmployeeNotFound | GProcessPathNotFound | GProcessPathValidationError;

export type GProcessPathHourlyTotal = {
  __typename?: 'ProcessPathHourlyTotal';
  /** Person-minutes per hour of the day, index 0 = 00:00 .. 23. */
  hourlyMinutes: Array<Scalars['Int']>;
  path: GProcessPath;
  totalMinutes: Scalars['Int'];
};

/**
 * Units and lines picked at a warehouse on one local day, from the materialized
 * measured-pace rows (PickChannelDayMeasure), summed over the pick path's own
 * channels. The COVERED POPULATION — the pickers the confirm stream sees — which
 * measured 93.4% of total picked units across 34 days at EWR1 (86.4-98.7, stddev
 * 3.4). Read this for a fast daily series; read processPathThroughput's units for
 * the whole floor's output.
 */
export type GProcessPathMeasuredPickDay = {
  __typename?: 'ProcessPathMeasuredPickDay';
  /** Warehouse-local day. */
  date: Scalars['ISO8601Date'];
  /** Pick lines (scan actions) on the day. */
  measuredLines: Scalars['Int'];
  /** Idle-capped active-picking minutes behind those units. */
  measuredMinutes: Scalars['Int'];
  /** Scanned sales units (as ordered — a case counts as 1), the same basis as the demand forecast. */
  measuredUnits: Scalars['Float'];
};

export type GProcessPathNotFound = GUserErrorInterface & {
  __typename?: 'ProcessPathNotFound';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GProcessPathOverReporter = {
  __typename?: 'ProcessPathOverReporter';
  accountedMinutes: Scalars['Int'];
  clockedMinutes: Scalars['Int'];
  employee: GProcessPathEmployee;
  /** accounted − clocked. */
  excessMinutes: Scalars['Int'];
};

/** Autogenerated input type of ProcessPathReorder */
export type GProcessPathReorderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Catalog path ids in the desired left-to-right order (global). */
  pathIds: Array<Scalars['ID']>;
};

/** Autogenerated return type of ProcessPathReorder. */
export type GProcessPathReorderPayload = {
  __typename?: 'ProcessPathReorderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  processPaths: Array<GProcessPath>;
  userErrors: Array<GProcessPathError>;
};

/**
 * One warehouse-local day's whole-floor output and clocked labour for one process
 * path. The Throughput grid's basis: units here match processPathThroughput's
 * daily units for the same path; rate = units over clocked hours. The pick path
 * reads its materialized day rows; any other path reads its registered output
 * source. Days with neither scans nor clocked time are absent.
 */
export type GProcessPathScanDay = {
  __typename?: 'ProcessPathScanDay';
  /** Minutes clocked onto this path that day (kiosk/supervisor segments). */
  clockedMinutes: Scalars['Int'];
  /** Warehouse-local day. */
  date: Scalars['ISO8601Date'];
  /** The process path this day answers for (the request's processPathCode, or the LD/Ecomm pick path when none was named). */
  processPathCode: Scalars['String'];
  /**
   * All scanned units for the day (whole floor, regardless of confirm coverage),
   * counted the way the path's output source counts them.
   */
  totalUnits: Scalars['Float'];
};

export type GProcessPathSegment = {
  __typename?: 'ProcessPathSegment';
  createdAt: Scalars['ISO8601DateTime'];
  employee: GProcessPathEmployee;
  endsAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  /** Whole minutes elapsed (to now if still active). */
  minutes: Scalars['Int'];
  path: GProcessPath;
  source: GProcessPathSource;
  startsAt: Scalars['ISO8601DateTime'];
  unitsProcessed?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
  warehouseId: Scalars['ID'];
};

/** Autogenerated input type of ProcessPathSegmentCreate */
export type GProcessPathSegmentCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['ID'];
  endsAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  pathId: Scalars['ID'];
  source?: InputMaybe<GProcessPathSource>;
  startsAt: Scalars['ISO8601DateTime'];
  unitsProcessed?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of ProcessPathSegmentCreate. */
export type GProcessPathSegmentCreatePayload = {
  __typename?: 'ProcessPathSegmentCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  employeeDay?: Maybe<GProcessPathEmployeeDay>;
  segment?: Maybe<GProcessPathSegment>;
  userErrors: Array<GProcessPathError>;
};

/** Autogenerated input type of ProcessPathSegmentDelete */
export type GProcessPathSegmentDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  segmentId: Scalars['ID'];
};

/** Autogenerated return type of ProcessPathSegmentDelete. */
export type GProcessPathSegmentDeletePayload = {
  __typename?: 'ProcessPathSegmentDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedSegmentId?: Maybe<Scalars['ID']>;
  userErrors: Array<GProcessPathError>;
};

/** Autogenerated input type of ProcessPathSegmentEdit */
export type GProcessPathSegmentEditInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  endsAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  pathId?: InputMaybe<Scalars['ID']>;
  segmentId: Scalars['ID'];
  startsAt?: InputMaybe<Scalars['ISO8601DateTime']>;
};

/** Autogenerated return type of ProcessPathSegmentEdit. */
export type GProcessPathSegmentEditPayload = {
  __typename?: 'ProcessPathSegmentEditPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  employeeDay?: Maybe<GProcessPathEmployeeDay>;
  segment?: Maybe<GProcessPathSegment>;
  userErrors: Array<GProcessPathError>;
};

/** Autogenerated input type of ProcessPathSelfAssign */
export type GProcessPathSelfAssignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  pathId: Scalars['ID'];
  userId: Scalars['ID'];
};

/** Autogenerated return type of ProcessPathSelfAssign. */
export type GProcessPathSelfAssignPayload = {
  __typename?: 'ProcessPathSelfAssignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  employeeDay?: Maybe<GProcessPathEmployeeDay>;
  userErrors: Array<GProcessPathError>;
};

/** Autogenerated input type of ProcessPathSelfClockIn */
export type GProcessPathSelfClockInInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};

/** Autogenerated return type of ProcessPathSelfClockIn. */
export type GProcessPathSelfClockInPayload = {
  __typename?: 'ProcessPathSelfClockInPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  employeeDay?: Maybe<GProcessPathEmployeeDay>;
  userErrors: Array<GProcessPathError>;
};

/** Autogenerated input type of ProcessPathSelfClockOut */
export type GProcessPathSelfClockOutInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};

/** Autogenerated return type of ProcessPathSelfClockOut. */
export type GProcessPathSelfClockOutPayload = {
  __typename?: 'ProcessPathSelfClockOutPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  employeeDay?: Maybe<GProcessPathEmployeeDay>;
  userErrors: Array<GProcessPathError>;
};

/** Autogenerated input type of ProcessPathSelfUnassign */
export type GProcessPathSelfUnassignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};

/** Autogenerated return type of ProcessPathSelfUnassign. */
export type GProcessPathSelfUnassignPayload = {
  __typename?: 'ProcessPathSelfUnassignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  employeeDay?: Maybe<GProcessPathEmployeeDay>;
  userErrors: Array<GProcessPathError>;
};

/** Autogenerated input type of ProcessPathSetAvailability */
export type GProcessPathSetAvailabilityInput = {
  available: Scalars['Boolean'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  pathId: Scalars['ID'];
  warehouseId: Scalars['ID'];
};

/** Autogenerated return type of ProcessPathSetAvailability. */
export type GProcessPathSetAvailabilityPayload = {
  __typename?: 'ProcessPathSetAvailabilityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  processPath?: Maybe<GProcessPath>;
  userErrors: Array<GProcessPathError>;
};

/** Autogenerated input type of ProcessPathSetCoverageTarget */
export type GProcessPathSetCoverageTargetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  date: Scalars['ISO8601Date'];
  pathId: Scalars['ID'];
  /** Target labour hours; 0 asserts an explicit zero. */
  targetHours: Scalars['Float'];
  warehouseId: Scalars['ID'];
};

/** Autogenerated return type of ProcessPathSetCoverageTarget. */
export type GProcessPathSetCoverageTargetPayload = {
  __typename?: 'ProcessPathSetCoverageTargetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  coverageTarget?: Maybe<GProcessPathCoverageTarget>;
  userErrors: Array<GProcessPathError>;
};

export enum GProcessPathSource {
  /** Self-reported by the associate. */
  Self = 'SELF',
  /** Recorded by a supervisor. */
  Supervisor = 'SUPERVISOR',
  /** From a system signal (scan/WMS). */
  System = 'SYSTEM'
}

export type GProcessPathThroughput = {
  __typename?: 'ProcessPathThroughput';
  accuracy: GProcessPathThroughputAccuracy;
  date: Scalars['ISO8601Date'];
  /** The hours `ratePerHour` divided by. clocked_hours: kiosk-clocked person-hours on this path (`laborHours`). */
  denominator: Scalars['String'];
  /** Person-hours logged on this path. */
  laborHours: Scalars['Float'];
  path: GProcessPath;
  /** `units` per hour of `denominator`. Null when no hours were logged (undefined, not zero). */
  ratePerHour?: Maybe<Scalars['Float']>;
  /** Human label for where the units came from. */
  sourceLabel: Scalars['String'];
  /** Channel split of this row (LD / Ecomm Pick only; empty elsewhere). Sub-row units sum to the parent's. */
  subRows: Array<GProcessPathThroughputSubRow>;
  /**
   * What one of `units` is: sales_units on pick paths (as ordered — a case counts
   * as 1, the demand forecast's basis); handling_units on receive (the receipt
   * line's ordering unit — a case of any size counts as 1; named from the rows'
   * frozen handling_basis); operations on putaway and count.
   */
  unit: Scalars['String'];
  /** Output processed on the day, counted in `unit`. */
  units: Scalars['Float'];
};

export enum GProcessPathThroughputAccuracy {
  /** Derived from an upstream end-state signal. */
  Approximate = 'APPROXIMATE',
  /** Counted from floor-recorded data. */
  Exact = 'EXACT'
}

export type GProcessPathThroughputSubRow = {
  __typename?: 'ProcessPathThroughputSubRow';
  /** Parent labour minutes allocated by line share — an estimate. */
  allocatedLaborMinutes: Scalars['Int'];
  /** How the labour figure was derived: ALLOCATED (estimate); MEASURED arrives later. */
  basis: Scalars['String'];
  /** ld | ecom (labor-lens channel of the pick scans). */
  channel: Scalars['String'];
  /** Equal to units on the sales-unit basis; retained for compatibility. */
  handlingUnits: Scalars['Float'];
  /** Pick lines (scan actions) on the day. */
  lines: Scalars['Int'];
  /** MEASURED active-picking minutes from the confirm stream. Null for a day with no measured signal. */
  measuredLaborMinutes?: Maybe<Scalars['Int']>;
  /**
   * Pick lines of the covered population — same population and window as
   * measuredUnits. Lines/hour measures pick actions; units/hour measures sales units moved.
   */
  measuredLines?: Maybe<Scalars['Int']>;
  /**
   * Sales units of the covered population only (pickers present in the confirm
   * stream that day) — the ONLY valid numerator over measured minutes; some pick
   * flows write no audit rows, so dividing total units by measured minutes
   * overstates pace.
   */
  measuredUnits?: Maybe<Scalars['Float']>;
  /** Sales units (as ordered — a case counts as 1), same basis as the parent row's units and the demand forecast. */
  units: Scalars['Float'];
};

/** Autogenerated input type of ProcessPathUnassign */
export type GProcessPathUnassignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['ID'];
  warehouseId: Scalars['ID'];
};

/** Autogenerated return type of ProcessPathUnassign. */
export type GProcessPathUnassignPayload = {
  __typename?: 'ProcessPathUnassignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  employeeDay?: Maybe<GProcessPathEmployeeDay>;
  userErrors: Array<GProcessPathError>;
};

/** Autogenerated input type of ProcessPathUpdate */
export type GProcessPathUpdateInput = {
  category?: InputMaybe<GProcessPathCategory>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  label?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of ProcessPathUpdate. */
export type GProcessPathUpdatePayload = {
  __typename?: 'ProcessPathUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  processPath?: Maybe<GProcessPath>;
  userErrors: Array<GProcessPathError>;
};

export type GProcessPathValidationError = GUserErrorInterface & {
  __typename?: 'ProcessPathValidationError';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GProcurement = {
  __typename?: 'Procurement';
  procurementVendor: GProcurementVendor;
  purchasePrice: GMoney;
  warehouse: GWarehouse;
};

export type GProcurementAiApprovalByType = {
  __typename?: 'ProcurementAiApprovalByType';
  approvedCount: Scalars['Int'];
  interactionType: Scalars['String'];
  /** approved / total * 100; null when there is no feedback yet. */
  ratePercent?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};

export type GProcurementAiApprovalStats = {
  __typename?: 'ProcurementAiApprovalStats';
  approvedCount: Scalars['Int'];
  byInteractionType: Array<GProcurementAiApprovalByType>;
  /** Overall percent of AI interactions approved; null when there is no feedback yet. */
  ratePercent?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
};

export type GProcurementAiFeedback = {
  __typename?: 'ProcurementAiFeedback';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  /** suggested_reply. */
  interactionType: Scalars['String'];
  modelVersion?: Maybe<Scalars['String']>;
  promptVersion?: Maybe<Scalars['String']>;
  /** approved | rejected. */
  verdict: Scalars['String'];
};

/** Autogenerated input type of ProcurementAiFeedbackSubmit */
export type GProcurementAiFeedbackSubmitInput = {
  /** The assessment whose output is being rated (e.g. the current assessment's suggested reply). */
  assessmentId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** suggested_reply. */
  interactionType?: InputMaybe<Scalars['String']>;
  trackingId: Scalars['ID'];
  /** approved | rejected. */
  verdict: Scalars['String'];
};

/** Autogenerated return type of ProcurementAiFeedbackSubmit. */
export type GProcurementAiFeedbackSubmitPayload = {
  __typename?: 'ProcurementAiFeedbackSubmitPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  feedback?: Maybe<GProcurementAiFeedback>;
  userErrors: Array<GUserError>;
};

/** Autogenerated input type of ProcurementAssessmentSubmit */
export type GProcurementAssessmentSubmitInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** high | medium | low. */
  confidence: Scalars['String'];
  derivedStatus: Scalars['String'];
  exception?: InputMaybe<Scalars['String']>;
  modelVersion?: InputMaybe<Scalars['String']>;
  needsReply: Scalars['Boolean'];
  /** Extracted snake_case pickup fields and supporting_message_ids; null/absent facts do not erase saved values. */
  pickupCriteria?: InputMaybe<Scalars['JSON']>;
  promptVersion?: InputMaybe<Scalars['String']>;
  statusRevision?: InputMaybe<Scalars['Int']>;
  suggestedReply?: InputMaybe<Scalars['String']>;
  summary?: InputMaybe<Scalars['String']>;
  supportingMessageIds?: InputMaybe<Array<Scalars['ID']>>;
  trackingId: Scalars['ID'];
  triggeredByGmailMessageId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of ProcurementAssessmentSubmit. */
export type GProcurementAssessmentSubmitPayload = {
  __typename?: 'ProcurementAssessmentSubmitPayload';
  assessment?: Maybe<GProcurementPoStatusAssessment>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  poTracking?: Maybe<GProcurementPoTracking>;
  userErrors: Array<GUserError>;
};

/** Autogenerated input type of ProcurementCorrespondenceCommand */
export type GProcurementCorrespondenceCommandInput = {
  action: Scalars['String'];
  base64?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
  ccAddresses?: InputMaybe<Array<Scalars['String']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  draftId?: InputMaybe<Scalars['ID']>;
  explanation?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  idempotencyKey?: InputMaybe<Scalars['String']>;
  mimeType?: InputMaybe<Scalars['String']>;
  poNumber?: InputMaybe<Scalars['String']>;
  profileVersion?: InputMaybe<Scalars['String']>;
  replyAll?: InputMaybe<Scalars['Boolean']>;
  replyMessageId?: InputMaybe<Scalars['ID']>;
  reviewedRevision?: InputMaybe<Scalars['Int']>;
  revision?: InputMaybe<Scalars['Int']>;
  sendId?: InputMaybe<Scalars['ID']>;
  session?: InputMaybe<Scalars['String']>;
  signature?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  takeover?: InputMaybe<Scalars['Boolean']>;
  threadId?: InputMaybe<Scalars['ID']>;
  toAddresses?: InputMaybe<Array<Scalars['String']>>;
  uploadIds?: InputMaybe<Array<Scalars['ID']>>;
  version?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of ProcurementCorrespondenceCommand. */
export type GProcurementCorrespondenceCommandPayload = {
  __typename?: 'ProcurementCorrespondenceCommandPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  draft?: Maybe<GProcurementMailDraft>;
  errors: Array<GProcurementCorrespondenceError>;
  profile?: Maybe<GProcurementSenderProfile>;
  reference?: Maybe<GProcurementMailReference>;
  sendRecord?: Maybe<GProcurementMailSend>;
  thread?: Maybe<GProcurementEmailThread>;
  upload?: Maybe<GProcurementMailUpload>;
};

export type GProcurementCorrespondenceError = {
  __typename?: 'ProcurementCorrespondenceError';
  code: Scalars['String'];
  current?: Maybe<Scalars['JSON']>;
  message: Scalars['String'];
};

export type GProcurementEmailAttachment = {
  __typename?: 'ProcurementEmailAttachment';
  contentId?: Maybe<Scalars['String']>;
  disposition?: Maybe<Scalars['String']>;
  filename: Scalars['String'];
  gmailAttachmentId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** po_pdf | bol | order_confirmation | other. */
  kind: Scalars['String'];
  mimeType?: Maybe<Scalars['String']>;
  sizeBytes?: Maybe<Scalars['BigInt']>;
  storageError?: Maybe<Scalars['String']>;
};

export type GProcurementEmailAttachmentInput = {
  filename: Scalars['String'];
  gmailAttachmentId?: InputMaybe<Scalars['String']>;
  /** po_pdf | bol | order_confirmation | other; the AI parser classifies at ingest. Defaults to other. */
  kind?: InputMaybe<Scalars['String']>;
  mimeType?: InputMaybe<Scalars['String']>;
  s3ObjectKey?: InputMaybe<Scalars['String']>;
  sizeBytes?: InputMaybe<Scalars['BigInt']>;
};

export type GProcurementEmailMessage = {
  __typename?: 'ProcurementEmailMessage';
  attachments: Array<GProcurementEmailAttachment>;
  bodyHtml?: Maybe<Scalars['String']>;
  bodyText?: Maybe<Scalars['String']>;
  ccAddresses: Array<Scalars['String']>;
  /** inbound | outbound. */
  direction: Scalars['String'];
  fromAddress?: Maybe<Scalars['String']>;
  gmailMessageId: Scalars['String'];
  id: Scalars['ID'];
  provenance: Scalars['String'];
  replyToAddresses: Array<Scalars['String']>;
  securityWarnings: Array<Scalars['String']>;
  sentAt?: Maybe<Scalars['ISO8601DateTime']>;
  sentByAuth0Id?: Maybe<Scalars['String']>;
  snippet?: Maybe<Scalars['String']>;
  toAddresses: Array<Scalars['String']>;
};

export type GProcurementEmailMessageInput = {
  attachments?: InputMaybe<Array<GProcurementEmailAttachmentInput>>;
  bodyHtml?: InputMaybe<Scalars['String']>;
  bodyText?: InputMaybe<Scalars['String']>;
  ccAddresses?: InputMaybe<Array<Scalars['String']>>;
  /** inbound | outbound. */
  direction: Scalars['String'];
  fromAddress?: InputMaybe<Scalars['String']>;
  gmailMessageId: Scalars['String'];
  inReplyTo?: InputMaybe<Scalars['String']>;
  rfcMessageId?: InputMaybe<Scalars['String']>;
  sentAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  snippet?: InputMaybe<Scalars['String']>;
  toAddresses?: InputMaybe<Array<Scalars['String']>>;
};

export type GProcurementEmailThread = {
  __typename?: 'ProcurementEmailThread';
  correspondenceRevision: Scalars['Int'];
  draft?: Maybe<GProcurementMailDraft>;
  firstMessageAt?: Maybe<Scalars['ISO8601DateTime']>;
  gmailThreadId: Scalars['String'];
  /**
   * True when at least one message on the thread came from a non-Odeko sender that
   * is not a bounce notice — the per-thread form of the inbound-coverage metric. A
   * vendor autoresponder counts.
   */
  hasVendorReply: Scalars['Boolean'];
  id: Scalars['ID'];
  ingestionError?: Maybe<Scalars['String']>;
  lastMessageAt?: Maybe<Scalars['ISO8601DateTime']>;
  mailbox: Scalars['String'];
  /** pending | matched | unmatched | dismissed | ignored. */
  matchState: Scalars['String'];
  messagePage: GProcurementMailMessagePage;
  messages: Array<GProcurementEmailMessage>;
  /** Links to trackings, including AI-proposed ones awaiting confirmation. */
  poLinks: Array<GProcurementPoThreadLink>;
  processingError?: Maybe<Scalars['String']>;
  reference?: Maybe<GProcurementMailReference>;
  sends: Array<GProcurementMailSend>;
  subject?: Maybe<Scalars['String']>;
  /**
   * human | ai — what caused the last triage. Null on threads not yet triaged, on
   * threads matched through a link (matching is not a triage decision), and on
   * threads predating attribution.
   */
  triageCause?: Maybe<Scalars['String']>;
  /**
   * When triage last set matchState. Null on threads not yet triaged, on threads
   * matched through a link, and on threads predating attribution.
   */
  triagedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /**
   * Auth0 sub of the human who last triaged the thread. Null on the AI path, on
   * threads not yet triaged, on threads matched through a link, and on threads
   * predating attribution.
   */
  triagedByAuth0Id?: Maybe<Scalars['String']>;
  /** Display name of that human, or null when there is none or the sub can't be resolved to a user. */
  triagedByName?: Maybe<Scalars['String']>;
  unread: Scalars['Boolean'];
  workflowHistory: Scalars['JSON'];
  workflowRevision: Scalars['Int'];
  workflowState: Scalars['String'];
};


export type GProcurementEmailThreadMessagePageArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of ProcurementEmailThreadUpsert */
export type GProcurementEmailThreadUpsertInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  firstMessageAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  gmailThreadId: Scalars['String'];
  lastMessageAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  mailbox: Scalars['String'];
  messages?: InputMaybe<Array<GProcurementEmailMessageInput>>;
  participants?: InputMaybe<Array<Scalars['String']>>;
  subject?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of ProcurementEmailThreadUpsert. */
export type GProcurementEmailThreadUpsertPayload = {
  __typename?: 'ProcurementEmailThreadUpsertPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Gmail ids of messages genuinely new to this upsert (empty on pure redelivery). */
  newGmailMessageIds: Array<Scalars['String']>;
  thread?: Maybe<GProcurementEmailThread>;
  userErrors: Array<GUserError>;
};

export type GProcurementInboundCoverageByVendor = {
  __typename?: 'ProcurementInboundCoverageByVendor';
  coveredCount: Scalars['Int'];
  /** covered / total * 100; null when this vendor has no confirmed-linked threads. */
  ratePercent?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
  vendorId: Scalars['ID'];
  vendorName: Scalars['String'];
};

export type GProcurementInboundCoverageByWeek = {
  __typename?: 'ProcurementInboundCoverageByWeek';
  /**
   * False for the week still in progress: its threads have had days rather than a
   * week to collect a reply, so the bucket reads low for a reason that is not
   * about vendors. Chart it as provisional, never as a decline.
   */
  complete: Scalars['Boolean'];
  coveredCount: Scalars['Int'];
  /** covered / total * 100; null when no confirmed-linked thread opened that week. */
  ratePercent?: Maybe<Scalars['Float']>;
  totalCount: Scalars['Int'];
  /** Monday of the week the thread's first message landed. */
  weekStart: Scalars['ISO8601Date'];
};

export type GProcurementInboundCoverageStats = {
  __typename?: 'ProcurementInboundCoverageStats';
  /**
   * Per-vendor coverage, counted per (vendor, thread). Does not sum to
   * coveredCount/totalCount: a tracking with no vendor matched yet is excluded,
   * and a thread spanning two vendors' POs counts for both.
   */
  byVendor: Array<GProcurementInboundCoverageByVendor>;
  /**
   * Coverage trend over the shadow period, bucketed on the week each thread
   * opened. The newest bucket is still filling: read its complete flag before quoting it.
   */
  byWeek: Array<GProcurementInboundCoverageByWeek>;
  /**
   * Confirmed-linked threads carrying at least one message from a non-Odeko sender
   * that is not a bounce notice. Settled threads only: those whose first message
   * is at least 8 days old.
   */
  coveredCount: Scalars['Int'];
  /**
   * Overall percent of settled PO threads (first message at least 8 days old) that
   * ever heard back from outside Odeko; null when nothing is linked yet.
   */
  ratePercent?: Maybe<Scalars['Float']>;
  /**
   * Confirmed-linked threads in the window — the coverage denominator. Settled
   * threads only: a thread whose first message is under 8 days old is left out of
   * every count here, because it has not had time to hear back and the Phase-1
   * baseline measured settled threads.
   */
  totalCount: Scalars['Int'];
};

export type GProcurementInboxPage = {
  __typename?: 'ProcurementInboxPage';
  drafts: Array<GProcurementMailDraft>;
  nextCursor?: Maybe<Scalars['String']>;
  senderProfile?: Maybe<GProcurementSenderProfile>;
  sendingEnabled: Scalars['Boolean'];
  sends: Array<GProcurementMailSend>;
  threads: Array<GProcurementEmailThread>;
};

export type GProcurementInput = {
  procurementVendorId: Scalars['ID'];
  purchasePrice: GMoneyInput;
  warehouseId: Scalars['ID'];
};

export type GProcurementMailDraft = {
  __typename?: 'ProcurementMailDraft';
  body: Scalars['String'];
  ccAddresses: Array<Scalars['String']>;
  creatorAuth0Id: Scalars['String'];
  editorAuth0Id?: Maybe<Scalars['String']>;
  editorName?: Maybe<Scalars['String']>;
  editorSession?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  leaseExpiresAt?: Maybe<Scalars['ISO8601DateTime']>;
  lockVersion: Scalars['Int'];
  replyMessageId?: Maybe<Scalars['ID']>;
  reviewedRevision: Scalars['Int'];
  subject: Scalars['String'];
  submittedAt?: Maybe<Scalars['ISO8601DateTime']>;
  threadId?: Maybe<Scalars['ID']>;
  toAddresses: Array<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  uploadIds: Array<Scalars['ID']>;
  uploads: Array<GProcurementMailUpload>;
};

export type GProcurementMailMessagePage = {
  __typename?: 'ProcurementMailMessagePage';
  items: Array<GProcurementEmailMessage>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type GProcurementMailReference = {
  __typename?: 'ProcurementMailReference';
  body?: Maybe<Scalars['String']>;
  failureCode?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  revision: Scalars['Int'];
  state: Scalars['String'];
};

export type GProcurementMailSend = {
  __typename?: 'ProcurementMailSend';
  acceptedAt?: Maybe<Scalars['ISO8601DateTime']>;
  actorAuth0Id: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  draftId: Scalars['ID'];
  failureCode?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  snapshot: Scalars['JSON'];
  state: Scalars['String'];
  threadId?: Maybe<Scalars['ID']>;
};

export type GProcurementMailUpload = {
  __typename?: 'ProcurementMailUpload';
  filename: Scalars['String'];
  id: Scalars['ID'];
  mimeType: Scalars['String'];
  sha256: Scalars['String'];
  sizeBytes: Scalars['Int'];
};

/** Autogenerated input type of ProcurementMailboxCursorSet */
export type GProcurementMailboxCursorSetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  historyId: Scalars['String'];
  mailbox: Scalars['String'];
};

/** Autogenerated return type of ProcurementMailboxCursorSet. */
export type GProcurementMailboxCursorSetPayload = {
  __typename?: 'ProcurementMailboxCursorSetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  lastHistoryId?: Maybe<Scalars['String']>;
  mailbox?: Maybe<Scalars['String']>;
  userErrors: Array<GUserError>;
};

/**
 * Partial pickup criteria update. Omitted fields stay unchanged; null explicitly
 * clears a field. Weight and dimensions retain the supplied units.
 */
export type GProcurementPickupCriteriaInput = {
  dimensions?: InputMaybe<Scalars['String']>;
  palletCount?: InputMaybe<Scalars['Int']>;
  pickupAddress?: InputMaybe<Scalars['String']>;
  pickupContact?: InputMaybe<Scalars['String']>;
  readyForPickupDate?: InputMaybe<Scalars['ISO8601Date']>;
  weight?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of ProcurementPickupCriteriaUpdate */
export type GProcurementPickupCriteriaUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  criteria: GProcurementPickupCriteriaInput;
  statusRevision: Scalars['Int'];
  trackingId: Scalars['ID'];
};

/** Autogenerated return type of ProcurementPickupCriteriaUpdate. */
export type GProcurementPickupCriteriaUpdatePayload = {
  __typename?: 'ProcurementPickupCriteriaUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  poTracking?: Maybe<GProcurementPoTracking>;
  userErrors: Array<GUserError>;
};

export type GProcurementPoNote = {
  __typename?: 'ProcurementPoNote';
  /** Auth0 sub of the author. */
  author: Scalars['String'];
  /** Display name of the author, or null when the sub can't be resolved to a user. */
  authorName?: Maybe<Scalars['String']>;
  body: Scalars['String'];
  id: Scalars['ID'];
  /** phone_call | in_person | other. */
  noteType: Scalars['String'];
  occurredAt: Scalars['ISO8601DateTime'];
};

/** Autogenerated input type of ProcurementPoNoteCreate */
export type GProcurementPoNoteCreateInput = {
  body: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** phone_call | in_person | other. */
  noteType: Scalars['String'];
  occurredAt: Scalars['ISO8601DateTime'];
  trackingId: Scalars['ID'];
};

/** Autogenerated return type of ProcurementPoNoteCreate. */
export type GProcurementPoNoteCreatePayload = {
  __typename?: 'ProcurementPoNoteCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  note?: Maybe<GProcurementPoNote>;
  userErrors: Array<GUserError>;
};

export type GProcurementPoStatusAssessment = {
  __typename?: 'ProcurementPoStatusAssessment';
  /** Whether this assessment moved tracking_status. */
  applied: Scalars['Boolean'];
  /** high | medium | low. */
  confidence: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  derivedStatus: Scalars['String'];
  exception?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  modelVersion?: Maybe<Scalars['String']>;
  needsReply: Scalars['Boolean'];
  /**
   * Raw extracted pickup facts and supporting message IDs; the assessment retains
   * model/prompt provenance even when values are held.
   */
  pickupCriteria: Scalars['JSON'];
  promptVersion?: Maybe<Scalars['String']>;
  suggestedReply?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
};

export type GProcurementPoThreadLink = {
  __typename?: 'ProcurementPoThreadLink';
  confidence?: Maybe<Scalars['Float']>;
  /** Auth0 sub of the confirming human; null for auto-confirmed sources. */
  confirmedBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** subject_po_number | pdf_extract | ai_inference | manual. */
  matchSource: Scalars['String'];
  /** PO number (tranId) of the linked tracking's projection row. */
  poNumber?: Maybe<Scalars['String']>;
  /** proposed | confirmed | rejected. */
  status: Scalars['String'];
  thread: GProcurementEmailThread;
};

export type GProcurementPoTracking = {
  __typename?: 'ProcurementPoTracking';
  assignedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Auth0 sub of the assignee. */
  assignee?: Maybe<Scalars['String']>;
  /** When the PO was created in NetSuite. */
  createdDate?: Maybe<Scalars['ISO8601DateTime']>;
  currency?: Maybe<Scalars['String']>;
  /** Latest assessment (applied or not). */
  currentAssessment?: Maybe<GProcurementPoStatusAssessment>;
  /** pickup (Odeko-routed) | delivery (vendor-routed) | unknown. Picks the lifecycle branch. */
  deliveryType: Scalars['String'];
  /** unset | vendor_default | ai | human — what set deliveryType. Precedence: human > ai > vendor_default > unset. */
  deliveryTypeSource: Scalars['String'];
  /** Pickup dimensions, including supplied units. */
  dimensions?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['ISO8601Date']>;
  /** partial | oos | delayed | canceled; null when none. */
  exception?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  memo?: Maybe<Scalars['String']>;
  /** Missing field names; all six pickup criteria are required. */
  missingPickupCriteria: Array<Scalars['String']>;
  needsReply: Scalars['Boolean'];
  /** NetSuite internal id of the projected PO, for deep links. */
  netsuiteInternalId?: Maybe<Scalars['String']>;
  /** NetSuite status label (e.g. "Pending Receipt"). */
  netsuiteStatus?: Maybe<Scalars['String']>;
  /** Link that opens the PO in the NetSuite UI; null when this environment has no NetSuite account configured. */
  netsuiteUrl?: Maybe<Scalars['String']>;
  orderDate?: Maybe<Scalars['ISO8601Date']>;
  palletCount?: Maybe<Scalars['Int']>;
  pickupAddress?: Maybe<Scalars['String']>;
  pickupContact?: Maybe<Scalars['String']>;
  pickupCriteriaComplete: Scalars['Boolean'];
  pickupCriteriaGateEnabled: Scalars['Boolean'];
  pickupCriteriaProvenance: Scalars['JSON'];
  /** NetSuite tranId. */
  poNumber?: Maybe<Scalars['String']>;
  readyForPickupDate?: Maybe<Scalars['ISO8601Date']>;
  /** When the PO was first sent to the vendor: the earliest awaiting_response transition, not the thread's first message. */
  sentAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Capture before assessment work and submit unchanged so later corrections invalidate stale results. */
  statusRevision: Scalars['Int'];
  /** ai | human | system. */
  statusSource: Scalars['String'];
  statusUpdatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  threadLinks: Array<GProcurementPoThreadLink>;
  /** Messages across confirmed-linked threads + offline notes + status transitions, time-sorted. */
  timeline: Array<GProcurementTimelineEntry>;
  total?: Maybe<Scalars['Float']>;
  /**
   * pending_vendor_comms | awaiting_response | order_processed |
   * transportation_criteria_pending | transportation_scheduling |
   * vendor_scheduled_to_ship | in_transit | partially_received | received.
   * Tool-owned and monotonic; branched by deliveryType (order_processed is
   * vendor-routed, the two transportation stages are Odeko-routed).
   * partially_received is set only by NetSuite reconciliation. "Exception Review"
   * is not a status — it is a display label for needsReply/exception over whatever
   * stage the PO is actually at.
   */
  trackingStatus: Scalars['String'];
  vendor?: Maybe<GProcurementTrackingVendor>;
  /** Vendor/entity name on the NetSuite PO. */
  vendorName?: Maybe<Scalars['String']>;
  /**
   * Which side owes the next move. ODEKO when needsReply is set, VENDOR when we
   * reached them last and nothing has come back, NONE when closed (and needsReply
   * is false) or no vendor-facing mail has happened yet. Derived from the
   * confirmed threads; internal-only mail moves it neither way.
   */
  waitingOn: GProcurementWaitingOn;
  warehouseName?: Maybe<Scalars['String']>;
  /** Pickup weight, including supplied units. */
  weight?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of ProcurementPoTrackingAssign */
export type GProcurementPoTrackingAssignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of ProcurementPoTrackingAssign. */
export type GProcurementPoTrackingAssignPayload = {
  __typename?: 'ProcurementPoTrackingAssignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  poTracking?: Maybe<GProcurementPoTracking>;
  userErrors: Array<GUserError>;
};

/** Autogenerated input type of ProcurementPoTrackingEnsure */
export type GProcurementPoTrackingEnsureInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  poNumber: Scalars['String'];
};

/** Autogenerated return type of ProcurementPoTrackingEnsure. */
export type GProcurementPoTrackingEnsurePayload = {
  __typename?: 'ProcurementPoTrackingEnsurePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  poTracking?: Maybe<GProcurementPoTracking>;
  userErrors: Array<GUserError>;
};

/** Autogenerated input type of ProcurementPoTrackingUpdate */
export type GProcurementPoTrackingUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  deliveryType?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  needsReply?: InputMaybe<Scalars['Boolean']>;
  vendorId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of ProcurementPoTrackingUpdate. */
export type GProcurementPoTrackingUpdatePayload = {
  __typename?: 'ProcurementPoTrackingUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  poTracking?: Maybe<GProcurementPoTracking>;
  userErrors: Array<GUserError>;
};

export type GProcurementSenderProfile = {
  __typename?: 'ProcurementSenderProfile';
  displayName: Scalars['String'];
  signature: Scalars['String'];
  version: Scalars['String'];
};

export type GProcurementStatusEvent = {
  __typename?: 'ProcurementStatusEvent';
  /** Auth0 sub when cause is human_override. */
  actor?: Maybe<Scalars['String']>;
  /** ai_assessment | human_override | system. */
  cause: Scalars['String'];
  fromStatus: Scalars['String'];
  id: Scalars['ID'];
  occurredAt: Scalars['ISO8601DateTime'];
  toStatus: Scalars['String'];
};

/** Autogenerated input type of ProcurementStatusOverride */
export type GProcurementStatusOverrideInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
  trackingId: Scalars['ID'];
};

/** Autogenerated return type of ProcurementStatusOverride. */
export type GProcurementStatusOverridePayload = {
  __typename?: 'ProcurementStatusOverridePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  poTracking?: Maybe<GProcurementPoTracking>;
  userErrors: Array<GUserError>;
};

/** Autogenerated input type of ProcurementThreadAssignToPo */
export type GProcurementThreadAssignToPoInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  threadId: Scalars['ID'];
  trackingId: Scalars['ID'];
};

/** Autogenerated return type of ProcurementThreadAssignToPo. */
export type GProcurementThreadAssignToPoPayload = {
  __typename?: 'ProcurementThreadAssignToPoPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  link?: Maybe<GProcurementPoThreadLink>;
  userErrors: Array<GUserError>;
};

/** Autogenerated input type of ProcurementThreadLinkConfirm */
export type GProcurementThreadLinkConfirmInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  linkId: Scalars['ID'];
};

/** Autogenerated return type of ProcurementThreadLinkConfirm. */
export type GProcurementThreadLinkConfirmPayload = {
  __typename?: 'ProcurementThreadLinkConfirmPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  link?: Maybe<GProcurementPoThreadLink>;
  userErrors: Array<GUserError>;
};

/** Autogenerated input type of ProcurementThreadLinkCreate */
export type GProcurementThreadLinkCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  confidence?: InputMaybe<Scalars['Float']>;
  evidenceGmailMessageId?: InputMaybe<Scalars['String']>;
  gmailThreadId: Scalars['String'];
  /** subject_po_number | pdf_extract | ai_inference. */
  matchSource: Scalars['String'];
  poNumber: Scalars['String'];
};

/** Autogenerated return type of ProcurementThreadLinkCreate. */
export type GProcurementThreadLinkCreatePayload = {
  __typename?: 'ProcurementThreadLinkCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  link?: Maybe<GProcurementPoThreadLink>;
  userErrors: Array<GUserError>;
};

/** Autogenerated input type of ProcurementThreadTriageSet */
export type GProcurementThreadTriageSetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  gmailThreadId?: InputMaybe<Scalars['String']>;
  /** unmatched | dismissed | ignored. */
  state: Scalars['String'];
  threadId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of ProcurementThreadTriageSet. */
export type GProcurementThreadTriageSetPayload = {
  __typename?: 'ProcurementThreadTriageSetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  thread?: Maybe<GProcurementEmailThread>;
  userErrors: Array<GUserError>;
};

export type GProcurementTimelineEntry = GProcurementEmailMessage | GProcurementPoNote | GProcurementStatusEvent;

export type GProcurementTrackingVendor = {
  __typename?: 'ProcurementTrackingVendor';
  address?: Maybe<Scalars['String']>;
  aiInstructions?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  communicationStyle?: Maybe<Scalars['String']>;
  contacts: Array<GProcurementVendorContact>;
  deliveryMode: Scalars['String'];
  followUpSensitivity?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  leadTimeDays?: Maybe<Scalars['Int']>;
  minOrderCents?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  netsuiteEntityInternalId?: Maybe<Scalars['String']>;
  norms: Array<GProcurementVendorNorm>;
  notes?: Maybe<Scalars['String']>;
  portalVendor: Scalars['Boolean'];
  preferredChannel?: Maybe<Scalars['String']>;
  responseTimeExpectation?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of ProcurementTrackingVendorUpsert */
export type GProcurementTrackingVendorUpsertInput = {
  address?: InputMaybe<Scalars['String']>;
  aiInstructions?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  communicationStyle?: InputMaybe<Scalars['String']>;
  contacts?: InputMaybe<Array<GProcurementVendorContactInput>>;
  deliveryMode?: InputMaybe<Scalars['String']>;
  followUpSensitivity?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  leadTimeDays?: InputMaybe<Scalars['Int']>;
  minOrderCents?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  norms?: InputMaybe<Array<GProcurementVendorNormInput>>;
  notes?: InputMaybe<Scalars['String']>;
  portalVendor?: InputMaybe<Scalars['Boolean']>;
  preferredChannel?: InputMaybe<Scalars['String']>;
  responseTimeExpectation?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of ProcurementTrackingVendorUpsert. */
export type GProcurementTrackingVendorUpsertPayload = {
  __typename?: 'ProcurementTrackingVendorUpsertPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userErrors: Array<GUserError>;
  vendor?: Maybe<GProcurementTrackingVendor>;
};

export type GProcurementVendor = {
  __typename?: 'ProcurementVendor';
  /** The procurement vendor UUID */
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type GProcurementVendorContact = {
  __typename?: 'ProcurementVendorContact';
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isPrimary: Scalars['Boolean'];
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

export type GProcurementVendorContactInput = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
};

export type GProcurementVendorNorm = {
  __typename?: 'ProcurementVendorNorm';
  id: Scalars['ID'];
  /** norm (human-authored rule) or quirk (learned behavior). */
  kind: Scalars['String'];
  position?: Maybe<Scalars['Int']>;
  rule: Scalars['String'];
};

export type GProcurementVendorNormInput = {
  id?: InputMaybe<Scalars['ID']>;
  /** norm (human-authored rule) or quirk (learned behavior). */
  kind: Scalars['String'];
  position?: InputMaybe<Scalars['Int']>;
  rule: Scalars['String'];
};

export enum GProcurementWaitingOn {
  /** Nothing outstanding on either side. */
  None = 'NONE',
  /** The vendor is owed a reply from us. */
  Odeko = 'ODEKO',
  /** We reached the vendor last and nothing has come back. */
  Vendor = 'VENDOR'
}

export type GProductInventory = {
  __typename?: 'ProductInventory';
  /**
   * on hand count = amount physically on our shelves in the warehouse
   *
   * available count = on hand count - amount already committed to orders in netsuite = amount available for ordering
   */
  availableCount?: Maybe<Scalars['Int']>;
  warehouse: GWarehouse;
};

export type GProfile = {
  __typename?: 'Profile';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type GPromoPageDetails = {
  __typename?: 'PromoPageDetails';
  customDescription?: Maybe<Scalars['String']>;
  customName?: Maybe<Scalars['String']>;
  desktopHeroImageUrl: Scalars['String'];
  mobileHeroImageUrl: Scalars['String'];
  shippingDesktopHeroImageUrl?: Maybe<Scalars['String']>;
  shippingMobileHeroImageUrl?: Maybe<Scalars['String']>;
};

export type GPromotionPage = {
  __typename?: 'PromotionPage';
  collection: GCollection;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  sections?: Maybe<Array<Maybe<GPromotionPageSection>>>;
  slug: Scalars['String'];
};

/** Relay-style cursor-based pagination structure for Categories */
export type GPromotionPageConnection = {
  __typename?: 'PromotionPageConnection';
  edges: Array<Maybe<GPromotionPageEdge>>;
  nodes: Array<Maybe<GPromotionPage>>;
  pageInfo: GPageInfo;
};

export type GPromotionPageEdge = {
  __typename?: 'PromotionPageEdge';
  cursor: Scalars['String'];
  node: GPromotionPage;
};

export type GPromotionPageFiltersInput = {
  isActive?: InputMaybe<GFiltersBooleanInput>;
  name?: InputMaybe<GFiltersStringInput>;
  slug?: InputMaybe<GFiltersStringInput>;
  warehouseId?: InputMaybe<GFiltersStringInput>;
};

export type GPromotionPageSection = {
  __typename?: 'PromotionPageSection';
  component: GPromotionPageSectionComponent;
  content?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  section: GPromotionPageSectionSection;
};

export enum GPromotionPageSectionComponent {
  Description = 'DESCRIPTION',
  Headline = 'HEADLINE',
  Image = 'IMAGE',
  MobileImage = 'MOBILE_IMAGE'
}

export enum GPromotionPageSectionSection {
  Hero = 'HERO'
}

export enum GPromotionPageSortOrder {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

export type GProspectiveLocation = {
  __typename?: 'ProspectiveLocation';
  address?: Maybe<Scalars['String']>;
  createdBy: Scalars['String'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  odekoUuid: Scalars['ID'];
  warehouseId: Scalars['ID'];
};

/** The provider's order for one delivery stop on a marked route. */
export type GProviderDelivery = {
  __typename?: 'ProviderDelivery';
  /** Whether a courier is on this delivery: a courier name is known, or the provider's status is at or past driver_assigned. */
  courierAssigned: Scalars['Boolean'];
  /** The assigned courier's name, when the provider has given one. */
  courierName?: Maybe<Scalars['String']>;
  /** The number the provider gives the store for reaching the courier. The customer-facing number is never exposed. */
  courierPhone?: Maybe<Scalars['String']>;
  /** The provider's estimate for the courier reaching the stop. */
  dropoffEta?: Maybe<Scalars['ISO8601DateTime']>;
  /** The provider's order id for this stop. Null while the order is still being created. */
  externalOrderId?: Maybe<Scalars['String']>;
  /** Whether something only a person can resolve, in the provider's dashboard, happened to this stop. */
  needsAttention: Scalars['Boolean'];
  /** Why needsAttention is set. Null when it is not. */
  needsAttentionReason?: Maybe<Scalars['String']>;
  /** The provider's estimate for the courier reaching the warehouse. */
  pickupEta?: Maybe<Scalars['ISO8601DateTime']>;
  /** Photo and signature urls from the provider's proof of pickup and delivery. Empty until the provider sends any. */
  proofUrls: Array<Scalars['String']>;
  /** The provider's delivery status for this stop, verbatim. Null until the provider has started a delivery. */
  status?: Maybe<Scalars['String']>;
  /** The provider's tracking page for this delivery. */
  trackingUrl?: Maybe<Scalars['String']>;
};

/**
 * A route's dispatch to a third-party provider (epic sc-66318). The DMP keys
 * presence of this field on Route.thirdPartyRoute, not on any particular status: a
 * canceled or push_failed row is still returned, with error set.
 */
export type GProviderDispatch = {
  __typename?: 'ProviderDispatch';
  /**
   * When a GM asked the provider to cancel the dispatched route. Set while the
   * provider has not answered: the route reads as canceling. Null again once the
   * provider confirms (status canceled) or refuses (error set, status unchanged),
   * or once the provider's route read finds the route still running after the
   * request went unanswered (error set), or once the provider canceled a route
   * that cannot go back to Odeko (status unchanged, error set, stops flagged). A
   * new cancel replaces an unanswered one.
   */
  cancelRequestedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /**
   * Whether cancelProviderRoute would send the cancel now: the dispatch is
   * confirmed running, the warehouse has the provider's flag on, the provider has
   * not canceled it already, no cancel is pending, and no stop has a courier, was
   * picked up, is final or has a recorded outcome. Read without locks, so a cancel
   * can still be refused; its userError names why.
   */
  cancelable: Scalars['Boolean'];
  /**
   * The quote the route was dispatched against, while the dispatch is dispatched,
   * in_progress or completed. Null before dispatch and after a refused dispatch.
   * For a dispatch made outside the DMP, only id is known.
   */
  chosenQuote?: Maybe<GProviderQuote>;
  /**
   * When the status poll sent the no-courier alert for this route. Set as the
   * alert is posted and cleared if no channel took it, so a value read during a
   * failed post can be gone on the next read. Null again after a rerouted delivery
   * re-arms the alert. A courier being assigned does not clear it.
   */
  courierAlertSentAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Why the last push, quote or dispatch failed, or that the provider canceled the route. Null when nothing went wrong. */
  error?: Maybe<Scalars['String']>;
  /** The provider's own id for the route created there. Null until the push has created it. */
  externalRouteId?: Maybe<Scalars['String']>;
  /** When the courier was asked to collect, in the route's warehouse time zone. Null means ASAP. */
  pickupAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The quotes the provider returned for the route. Empty until the dispatch is quoted. */
  quotes: Array<GProviderQuote>;
  status: GProviderDispatchStatus;
  /**
   * Whether unmarkRouteProvider would return the route to Odeko now: the dispatch
   * is quoting, quoted or failed before dispatch, or the provider canceled it, the
   * warehouse has the provider's flag on, and no stop has a courier, was picked up
   * or had its outcome recorded. Read without locks, so an unmark can still be
   * refused; its error names why.
   */
  unmarkable: Scalars['Boolean'];
};

/** Lifecycle status of a third_party_route_dispatches row (epic sc-66318). */
export enum GProviderDispatchStatus {
  /** Unmarked, or canceled upstream. */
  Canceled = 'canceled',
  /** Every stop on the dispatch reached a final outcome that LDS acted on: delivered, or failed with a delivery issue raised. */
  Completed = 'completed',
  /** A GM dispatched against a chosen quote and the provider has not confirmed yet; locked from further edits. */
  Dispatched = 'dispatched',
  /** The provider confirmed the dispatch: its route is underway. */
  InProgress = 'in_progress',
  /** The push failed and was compensated; the route is editable again. */
  PushFailed = 'push_failed',
  /** The push worker is creating the provider's orders and route. */
  Pushing = 'pushing',
  /** Quoting failed. */
  QuoteFailed = 'quote_failed',
  /** Quotes are in; waiting on a GM to dispatch against one. */
  Quoted = 'quoted',
  /** The provider's route exists; waiting on its quotes. */
  Quoting = 'quoting'
}

export type GProviderNotAvailable = GUserErrorInterface & {
  __typename?: 'ProviderNotAvailable';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** One provider's price for a whole marked route, as the provider returned it. */
export type GProviderQuote = {
  __typename?: 'ProviderQuote';
  /** The courier's price in cents, excluding the provider's own fee. */
  cost?: Maybe<Scalars['Int']>;
  /** When the quote stops being dispatchable. Null means the provider states no expiry. */
  expiresAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The provider's own fee in cents. */
  fee?: Maybe<Scalars['Int']>;
  /** The provider's own id for this quote; dispatching names it. */
  id: Scalars['String'];
  /** Which courier network quoted, as the provider names it. */
  provider?: Maybe<Scalars['String']>;
};

export type GProviderRejected = GUserErrorInterface & {
  __typename?: 'ProviderRejected';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GProviderRouteGuarded = GUserErrorInterface & {
  __typename?: 'ProviderRouteGuarded';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GProvisionalOrder = {
  __typename?: 'ProvisionalOrder';
  channel: GProvisionalOrderChannelEnum;
  deliveryDate?: Maybe<Scalars['ISO8601Date']>;
  expiresAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  intent: GProvisionalOrderIntentEnum;
  lines: Array<GProvisionalOrderLine>;
  location?: Maybe<GLocation>;
  questions: Array<GProvisionalOrderQuestion>;
  status: GProvisionalOrderStatusEnum;
  version: Scalars['Int'];
};

/** The source channel of a provisional order. */
export enum GProvisionalOrderChannelEnum {
  /** The order came from an email integration. */
  IntegrationEmail = 'INTEGRATION_EMAIL'
}

/** An edge in a connection. */
export type GProvisionalOrderEdge = {
  __typename?: 'ProvisionalOrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GProvisionalOrder>;
};

/** An input or authorization failure of a provisional order operation; a domain outcome is on the order itself. */
export type GProvisionalOrderError = {
  __typename?: 'ProvisionalOrderError';
  code: GProvisionalOrderErrorCodeEnum;
  message: Scalars['String'];
  /** The input fields the failure concerns. */
  path?: Maybe<Array<Scalars['String']>>;
};

/** An error code for a provisional order operation. */
export enum GProvisionalOrderErrorCodeEnum {
  /** The operation is forbidden. */
  Forbidden = 'FORBIDDEN',
  /** The enrolled sender has no active grantor. */
  GrantorInactive = 'GRANTOR_INACTIVE',
  /** The idempotency key conflicts with an earlier request. */
  IdempotencyConflict = 'IDEMPOTENCY_CONFLICT',
  /** This client may not act for an enrolled sender. */
  IntegrationContextNotAllowed = 'INTEGRATION_CONTEXT_NOT_ALLOWED',
  /** The request is invalid. */
  Invalid = 'INVALID',
  /** The location is outside the caller's scope. */
  LocationNotAllowed = 'LOCATION_NOT_ALLOWED',
  /** The operation is not available. */
  NotAvailable = 'NOT_AVAILABLE',
  /** The requested resource was not found. */
  NotFound = 'NOT_FOUND',
  /** The token does not belong to the enrolled sender's grantor. */
  NotGrantor = 'NOT_GRANTOR',
  /** The order version is stale. */
  Stale = 'STALE'
}

/** The requested action for a provisional order. */
export enum GProvisionalOrderIntentEnum {
  /** Add to an order. */
  Add = 'ADD',
  /** Cancel an order. */
  Cancel = 'CANCEL',
  /** Change an order. */
  Change = 'CHANGE',
  /** Place an order. */
  Place = 'PLACE',
  /** Replace an order. */
  Replace = 'REPLACE'
}

export type GProvisionalOrderLine = {
  __typename?: 'ProvisionalOrderLine';
  customerItemCode?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** The item, once the line is resolved to one. */
  item?: Maybe<GSupplyItem>;
  quantity: Scalars['Int'];
  status: GProvisionalOrderLineStatusEnum;
  textAsWritten?: Maybe<Scalars['String']>;
  unitAsWritten?: Maybe<Scalars['String']>;
};

/** One line of a provisional order patch. Omit lineId to add a line. */
export type GProvisionalOrderLineInput = {
  customerItemCode?: InputMaybe<Scalars['String']>;
  /** The line to change. */
  lineId?: InputMaybe<Scalars['ID']>;
  /** The item's product UUID, once resolved. */
  productUuid?: InputMaybe<Scalars['ID']>;
  quantity?: InputMaybe<Scalars['Int']>;
  /** Remove the line. */
  remove?: InputMaybe<Scalars['Boolean']>;
  /** The item as the customer wrote it. */
  textAsWritten?: InputMaybe<Scalars['String']>;
  unitAsWritten?: InputMaybe<Scalars['String']>;
};

/** The status of a provisional order line. */
export enum GProvisionalOrderLineStatusEnum {
  /** The line was removed. */
  Removed = 'REMOVED',
  /** The line is resolved. */
  Resolved = 'RESOLVED',
  /** The line is unresolved. */
  Unresolved = 'UNRESOLVED'
}

/** The customer's own purchase order as the door read it. */
export type GProvisionalOrderPurchaseOrderInput = {
  contentHash: Scalars['String'];
  number: Scalars['String'];
  revision: Scalars['Int'];
};

export type GProvisionalOrderQuestion = {
  __typename?: 'ProvisionalOrderQuestion';
  reason: GProvisionalOrderReasonEnum;
};

/** A reason associated with a provisional order. */
export enum GProvisionalOrderReasonEnum {
  /** An order intake reason code. */
  AlreadySent = 'ALREADY_SENT',
  /** An order intake reason code. */
  BelowMinimum = 'BELOW_MINIMUM',
  /** An order intake reason code. */
  DailyLimitReached = 'DAILY_LIMIT_REACHED',
  /** An order intake reason code. */
  DateBlocked = 'DATE_BLOCKED',
  /** An order intake reason code. */
  GrantorInactive = 'GRANTOR_INACTIVE',
  /** An order intake reason code. */
  HeldForReview = 'HELD_FOR_REVIEW',
  /** The order is held for staff review. */
  HeldForStaff = 'HELD_FOR_STAFF',
  /** An order intake reason code. */
  InvalidQuantity = 'INVALID_QUANTITY',
  /** An order intake reason code. */
  LocationHoliday = 'LOCATION_HOLIDAY',
  /** An order intake reason code. */
  LocationNotEnabled = 'LOCATION_NOT_ENABLED',
  /** An order intake reason code. */
  LocationNotInGoodStanding = 'LOCATION_NOT_IN_GOOD_STANDING',
  /** An order intake reason code. */
  MessageFromFuture = 'MESSAGE_FROM_FUTURE',
  /** An order intake reason code. */
  MessageTooOld = 'MESSAGE_TOO_OLD',
  /** An order intake reason code. */
  NewAtLocation = 'NEW_AT_LOCATION',
  /** An order intake reason code. */
  NotAvailable = 'NOT_AVAILABLE',
  /** An order intake reason code. */
  NotAMultiple = 'NOT_A_MULTIPLE',
  /** An order intake reason code. */
  NotCancellable = 'NOT_CANCELLABLE',
  /** An order intake reason code. */
  NotExclusiveOrder = 'NOT_EXCLUSIVE_ORDER',
  /** An order intake reason code. */
  NotInCatalog = 'NOT_IN_CATALOG',
  /** An order intake reason code. */
  NotOrderable = 'NOT_ORDERABLE',
  /** An order intake reason code. */
  NoDeliveryThatDay = 'NO_DELIVERY_THAT_DAY',
  /** An order intake reason code. */
  OrderFailed = 'ORDER_FAILED',
  /** An order intake reason code. */
  OverCeiling = 'OVER_CEILING',
  /** An order intake reason code. */
  PastCutoff = 'PAST_CUTOFF',
  /** An order intake reason code. */
  PolicyChanged = 'POLICY_CHANGED',
  /** An order intake reason code. */
  PolicyDateOutOfRange = 'POLICY_DATE_OUT_OF_RANGE',
  /** An order intake reason code. */
  PolicyIntentNotAllowed = 'POLICY_INTENT_NOT_ALLOWED',
  /** An order intake reason code. */
  PolicyNotConfigured = 'POLICY_NOT_CONFIGURED',
  /** An order intake reason code. */
  PolicyOverValueCap = 'POLICY_OVER_VALUE_CAP',
  /** An order intake reason code. */
  PolicyUnpriced = 'POLICY_UNPRICED',
  /** An order intake reason code. */
  PoNumberConflict = 'PO_NUMBER_CONFLICT',
  /** An order intake reason code. */
  PoNumberInUse = 'PO_NUMBER_IN_USE',
  /** An order intake reason code. */
  PoOutOfOrder = 'PO_OUT_OF_ORDER',
  /** An order intake reason code. */
  PoRevisionAfterPlacement = 'PO_REVISION_AFTER_PLACEMENT',
  /** An order intake reason code. */
  PoRevisionConflict = 'PO_REVISION_CONFLICT',
  /** The order was repriced. */
  Repriced = 'REPRICED',
  /** An order intake reason code. */
  RoleNotPermitted = 'ROLE_NOT_PERMITTED',
  /** An order intake reason code. */
  ShortStock = 'SHORT_STOCK',
  /** An order intake reason code. */
  Stale = 'STALE',
  /** An order intake reason code. */
  UnknownItem = 'UNKNOWN_ITEM',
  /** The sender has not been verified. */
  UnverifiedSender = 'UNVERIFIED_SENDER',
  /** An order intake reason code. */
  VendorHoliday = 'VENDOR_HOLIDAY'
}

/** The status of a provisional order. */
export enum GProvisionalOrderStatusEnum {
  /** The order is awaiting confirmation. */
  AwaitingConfirmation = 'AWAITING_CONFIRMATION',
  /** The order was cancelled. */
  Cancelled = 'CANCELLED',
  /** The order is being confirmed. */
  Confirming = 'CONFIRMING',
  /** The order expired. */
  Expired = 'EXPIRED',
  /** The order is held for staff review. */
  HeldForStaff = 'HELD_FOR_STAFF',
  /** The order is open. */
  Open = 'OPEN',
  /** The order was placed. */
  Placed = 'PLACED',
  /** Part of the order was placed. */
  PlacedPartly = 'PLACED_PARTLY',
  /** The order was placed with shortages. */
  PlacedShort = 'PLACED_SHORT',
  /** The order was rejected. */
  Rejected = 'REJECTED'
}

/** The connection type for ProvisionalOrder. */
export type GProvisionalOrdersConnection = {
  __typename?: 'ProvisionalOrdersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GProvisionalOrderEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GProvisionalOrder>>>;
  /** Information to aid in pagination. */
  pageInfo: GPageInfo;
  /** The total count of records in the connection. */
  totalCount: Scalars['Int'];
};

export enum GPsLocationMembershipStatusTier {
  /** Required minimum spend, no discounts, standard order cut-off time */
  Basic = 'basic',
  /** No minimum spend, no discounts, standard order cut-off time */
  Bronze = 'bronze',
  /** Displays spend tracker. No minimum spend, no discounts, standarded cut-off time. */
  ConsideringMembership = 'considering_membership',
  /** Excluded from the Membership Tier rules */
  Exclude = 'exclude',
  /** No minimum spend, higher discount, later order cut-off time */
  Gold = 'gold',
  /** No minimum spend, lower discount, standard order cut-off time */
  Silver = 'silver'
}

export type GPublicDockArrival = {
  __typename?: 'PublicDockArrival';
  carrierName?: Maybe<Scalars['String']>;
  /** When the truck currently on site for this appointment checked in. Null if nothing is currently checked in against it. */
  checkedInAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Appointment reference for confirmations. */
  confirmationNumber?: Maybe<Scalars['String']>;
  /** Contact person for the delivery. */
  contactName?: Maybe<Scalars['String']>;
  freightType: GFreightType;
  /** Source warehouse a transfer order is arriving from, matched by reference number; null for non-transfer bookings. */
  originName?: Maybe<Scalars['String']>;
  /** Number of pallets on the shipment. */
  palletCount?: Maybe<Scalars['Int']>;
  referenceNumber: Scalars['String'];
  /** Standard Carrier Alpha Code. */
  scacCode?: Maybe<Scalars['String']>;
  slotEndsAt: Scalars['ISO8601DateTime'];
  /** Slot start in warehouse-local time. */
  slotLabel: Scalars['String'];
  slotStartsAt: Scalars['ISO8601DateTime'];
  /** Truck or trailer number. */
  truckNumber?: Maybe<Scalars['String']>;
  /** Vendor/entity on the PO matched by reference number, if any. */
  vendorName?: Maybe<Scalars['String']>;
  /** Shipment weight in pounds. */
  weightLbs?: Maybe<Scalars['Float']>;
};

export type GPublicDockBooking = {
  __typename?: 'PublicDockBooking';
  /** Open slots on `date` for the chosen `freightType`. */
  availableSlots: Array<GPublicDockSlot>;
  /** Weekdays the warehouse takes no bookings (Ruby wday: 0=Sunday..6=Saturday, warehouse-local); empty means open every day. */
  blockedBookingWeekdays: Array<Scalars['Int']>;
  /** Whether this PO may be added to an existing LTL appointment by its confirmation number. */
  canJoinAppointment?: Maybe<Scalars['Boolean']>;
  carrierName?: Maybe<Scalars['String']>;
  /** Notes or special instructions for the delivery. */
  comments?: Maybe<Scalars['String']>;
  /** Email the booking confirmation is sent to. */
  confirmationEmail?: Maybe<Scalars['String']>;
  /** Appointment reference for confirmations. */
  confirmationNumber?: Maybe<Scalars['String']>;
  /** Contact email for the delivery. */
  contactEmail?: Maybe<Scalars['String']>;
  /** Contact person for the delivery. */
  contactName?: Maybe<Scalars['String']>;
  /** Contact phone for the delivery. */
  contactPhone?: Maybe<Scalars['String']>;
  /** How the delivery is prioritized. */
  deliveryType?: Maybe<GDeliveryType>;
  /** Assigned dock door, set once booked. */
  dockName?: Maybe<Scalars['String']>;
  expectedDate?: Maybe<Scalars['ISO8601Date']>;
  freightType?: Maybe<GFreightType>;
  /** Source warehouse a transfer order is arriving from; null for non-transfer bookings. */
  originName?: Maybe<Scalars['String']>;
  /** Number of pallets on the shipment. */
  palletCount?: Maybe<Scalars['Int']>;
  /** Carrier PRO (tracking) number. */
  proNumber?: Maybe<Scalars['String']>;
  referenceNumber: Scalars['String'];
  /**
   * Reference of the booking that already rebooked this missed/cancelled delivery;
   * set once recovered so the portal can hide the rebook action. Null when not yet recovered.
   */
  rescheduledToReference?: Maybe<Scalars['String']>;
  /** Standard Carrier Alpha Code. */
  scacCode?: Maybe<Scalars['String']>;
  /** Date the freight ships (distinct from the appointment date). */
  shipDate?: Maybe<Scalars['ISO8601Date']>;
  slotEndsAt?: Maybe<Scalars['ISO8601DateTime']>;
  slotLabel?: Maybe<Scalars['String']>;
  slotStartsAt?: Maybe<Scalars['ISO8601DateTime']>;
  status: GDockBookingStatus;
  /** Truck or trailer number. */
  truckNumber?: Maybe<Scalars['String']>;
  /**
   * Id of the warehouse the delivery is going to; set for override bookings so the
   * vendor portal can show the delivery's fixed warehouse when amending.
   */
  warehouseId?: Maybe<Scalars['ID']>;
  warehouseName: Scalars['String'];
  /** IANA zone; all labels are in this zone. */
  warehouseTimeZone: Scalars['String'];
  /** Shipment weight in pounds. */
  weightLbs?: Maybe<Scalars['Float']>;
  /** Slot length in minutes once booked (null until a freight type is set). */
  windowMinutes?: Maybe<Scalars['Int']>;
};


export type GPublicDockBookingAvailableSlotsArgs = {
  date: Scalars['ISO8601Date'];
  freightType: GFreightType;
  joinConfirmationNumber?: InputMaybe<Scalars['String']>;
  scacCode?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of PublicDockBookingCancel */
export type GPublicDockBookingCancelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  referenceNumber: Scalars['String'];
};

/** Autogenerated return type of PublicDockBookingCancel. */
export type GPublicDockBookingCancelPayload = {
  __typename?: 'PublicDockBookingCancelPayload';
  booking?: Maybe<GPublicDockBooking>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userErrors: Array<GDockBookingError>;
};

/** Autogenerated input type of PublicDockBookingSubmit */
export type GPublicDockBookingSubmitInput = {
  /** Carrier name (display). */
  carrierName?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Notes or special instructions for the delivery. */
  comments?: InputMaybe<Scalars['String']>;
  /** Email the booking confirmation is sent to. */
  confirmationEmail?: InputMaybe<Scalars['String']>;
  /** Contact email for the delivery. */
  contactEmail?: InputMaybe<Scalars['String']>;
  /** Contact person for the delivery. */
  contactName?: InputMaybe<Scalars['String']>;
  /** Contact phone for the delivery. */
  contactPhone?: InputMaybe<Scalars['String']>;
  /** How the delivery is prioritized. */
  deliveryType?: InputMaybe<GDeliveryType>;
  /** Chosen by the scheduler; drives the slot length. */
  freightType: GFreightType;
  /** An existing LTL appointment to add this PO to, on that appointment's slot and dock. Ignored where joining is off. */
  joinConfirmationNumber?: InputMaybe<Scalars['String']>;
  /** Number of pallets on the shipment. */
  palletCount: Scalars['Int'];
  /** Carrier PRO (tracking) number. */
  proNumber?: InputMaybe<Scalars['String']>;
  referenceNumber: Scalars['String'];
  /** Standard Carrier Alpha Code (carrier/vendor id). */
  scacCode: Scalars['String'];
  /** Date the freight ships (distinct from the appointment date). */
  shipDate?: InputMaybe<Scalars['ISO8601Date']>;
  slotStartsAt: Scalars['ISO8601DateTime'];
  /** Truck or trailer number. */
  truckNumber?: InputMaybe<Scalars['String']>;
  /** Shipment weight in pounds. */
  weightLbs: Scalars['Float'];
};

/** Autogenerated return type of PublicDockBookingSubmit. */
export type GPublicDockBookingSubmitPayload = {
  __typename?: 'PublicDockBookingSubmitPayload';
  booking?: Maybe<GPublicDockBooking>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userErrors: Array<GDockBookingError>;
};

/** Autogenerated input type of PublicDockCheckIn */
export type GPublicDockCheckInInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The kiosk's own dock, from its URL. Mutually exclusive with warehouseId. */
  dockId?: InputMaybe<Scalars['ID']>;
  /** Confirmation number from the driver's email, or the delivery's PO number. */
  reference: Scalars['String'];
  /** Trailer the driver actually arrived with. Optional; falls back to what the carrier declared. */
  truckNumber?: InputMaybe<Scalars['String']>;
  /** The warehouse placard's own warehouse, from its URL. Mutually exclusive with dockId. */
  warehouseId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of PublicDockCheckIn. */
export type GPublicDockCheckInPayload = {
  __typename?: 'PublicDockCheckInPayload';
  booking?: Maybe<GPublicDockBooking>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userErrors: Array<GDockBookingError>;
  visit?: Maybe<GPublicDockVisit>;
};

/** Autogenerated input type of PublicDockDepart */
export type GPublicDockDepartInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The kiosk's own dock, from its URL. Mutually exclusive with warehouseId. */
  dockId?: InputMaybe<Scalars['ID']>;
  /** Confirmation number from the delivery's email, or its PO number. */
  reference: Scalars['String'];
  /** The warehouse placard's own warehouse, from its URL. Mutually exclusive with dockId. */
  warehouseId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of PublicDockDepart. */
export type GPublicDockDepartPayload = {
  __typename?: 'PublicDockDepartPayload';
  booking?: Maybe<GPublicDockBooking>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userErrors: Array<GDockBookingError>;
  visit?: Maybe<GPublicDockVisit>;
};

export type GPublicDockDisplay = {
  __typename?: 'PublicDockDisplay';
  dockName: Scalars['String'];
  /** Next upcoming booked arrivals for this dock, soonest first. */
  upcomingArrivals: Array<GPublicDockArrival>;
  warehouseName: Scalars['String'];
  warehouseTimeZone: Scalars['String'];
};

export type GPublicDockSlot = {
  __typename?: 'PublicDockSlot';
  endsAt: Scalars['ISO8601DateTime'];
  /** Start time in warehouse-local time. */
  label: Scalars['String'];
  startsAt: Scalars['ISO8601DateTime'];
};

export type GPublicDockVisit = {
  __typename?: 'PublicDockVisit';
  /** The delivery this visit was opened against. */
  booking?: Maybe<GPublicDockVisitBooking>;
  /** When the driver checked in. */
  checkedInAt: Scalars['ISO8601DateTime'];
  /** When ops marked the truck away. Null while it is still on site. */
  departedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /**
   * The dock the truck is physically at, deliberately decoupled from the booking's
   * own (live, schedule-facing) dock — today an amend can drift the booking's dock
   * without this one moving, and this is also the right field for a future
   * ops-directed reassignment (e.g. redirecting a driver by text) to update,
   * without touching what was originally scheduled.
   */
  dockName?: Maybe<Scalars['String']>;
  /** Time on site. Null until both ends are observed — never estimated. */
  dwellSeconds?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  /** Trailer number recorded at check-in. */
  truckNumber?: Maybe<Scalars['String']>;
};

export type GPublicDockVisitBooking = {
  __typename?: 'PublicDockVisitBooking';
  carrierName?: Maybe<Scalars['String']>;
  /** Appointment reference for confirmations. */
  confirmationNumber?: Maybe<Scalars['String']>;
  referenceNumber: Scalars['String'];
};

export type GPublicDockWarehouse = {
  __typename?: 'PublicDockWarehouse';
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** Autogenerated input type of PublicOverrideBookingAmend */
export type GPublicOverrideBookingAmendInput = {
  carrierName?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The vendor's override code (soft-login credential). */
  code: Scalars['String'];
  comments?: InputMaybe<Scalars['String']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<Scalars['String']>;
  contactPhone?: InputMaybe<Scalars['String']>;
  deliveryType?: InputMaybe<GDeliveryType>;
  /** Drives the slot length. */
  freightType: GFreightType;
  /** Number of pallets on the shipment. */
  palletCount: Scalars['Int'];
  proNumber?: InputMaybe<Scalars['String']>;
  /** The generated reference of the delivery being changed. */
  referenceNumber: Scalars['String'];
  /** Standard Carrier Alpha Code (carrier/vendor id). */
  scacCode: Scalars['String'];
  shipDate?: InputMaybe<Scalars['ISO8601Date']>;
  slotStartsAt: Scalars['ISO8601DateTime'];
  truckNumber?: InputMaybe<Scalars['String']>;
  /** Shipment weight in pounds. */
  weightLbs: Scalars['Float'];
};

/** Autogenerated return type of PublicOverrideBookingAmend. */
export type GPublicOverrideBookingAmendPayload = {
  __typename?: 'PublicOverrideBookingAmendPayload';
  booking?: Maybe<GPublicDockBooking>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userErrors: Array<GDockBookingError>;
};

/** Autogenerated input type of PublicOverrideBookingCancel */
export type GPublicOverrideBookingCancelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The vendor's override code (soft-login credential). */
  code: Scalars['String'];
  /** The generated reference of the delivery being cancelled. */
  referenceNumber: Scalars['String'];
};

/** Autogenerated return type of PublicOverrideBookingCancel. */
export type GPublicOverrideBookingCancelPayload = {
  __typename?: 'PublicOverrideBookingCancelPayload';
  booking?: Maybe<GPublicDockBooking>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userErrors: Array<GDockBookingError>;
};

/** Autogenerated input type of PublicOverrideBookingCreate */
export type GPublicOverrideBookingCreateInput = {
  carrierName?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The vendor's override code (soft-login credential). */
  code: Scalars['String'];
  comments?: InputMaybe<Scalars['String']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<Scalars['String']>;
  contactPhone?: InputMaybe<Scalars['String']>;
  deliveryType?: InputMaybe<GDeliveryType>;
  /** Drives the slot length. */
  freightType: GFreightType;
  /** Number of pallets on the shipment. */
  palletCount: Scalars['Int'];
  proNumber?: InputMaybe<Scalars['String']>;
  /**
   * Reference number of a missed or cancelled delivery this booking rebooks;
   * grants the 12-hour recovery lead-time instead of the 24-hour new-booking rule.
   * Must be the vendor's own booking at the same warehouse and not already rebooked.
   */
  recoveringFrom?: InputMaybe<Scalars['String']>;
  /** Standard Carrier Alpha Code (carrier/vendor id). */
  scacCode: Scalars['String'];
  shipDate?: InputMaybe<Scalars['ISO8601Date']>;
  slotStartsAt: Scalars['ISO8601DateTime'];
  truckNumber?: InputMaybe<Scalars['String']>;
  /** The warehouse the delivery is going to. */
  warehouseId: Scalars['ID'];
  /** Shipment weight in pounds. */
  weightLbs: Scalars['Float'];
};

/** Autogenerated return type of PublicOverrideBookingCreate. */
export type GPublicOverrideBookingCreatePayload = {
  __typename?: 'PublicOverrideBookingCreatePayload';
  booking?: Maybe<GPublicDockBooking>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userErrors: Array<GDockBookingError>;
};

export type GPublicOverrideVendor = {
  __typename?: 'PublicOverrideVendor';
  /**
   * This vendor's dock deliveries across all warehouses, newest first. Upcoming
   * deliveries are always returned; `historyDays` bounds how many days of
   * already-past deliveries come back (0 = today and future only).
   */
  bookings: Array<GPublicDockBooking>;
  vendorName: Scalars['String'];
};


export type GPublicOverrideVendorBookingsArgs = {
  historyDays?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of PublishReviewResponseGbpMutation */
export type GPublishReviewResponseGbpMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  googleLocationName: Scalars['String'];
  responseText: Scalars['String'];
  reviewId: Scalars['String'];
};

/** Autogenerated input type of PublishReviewResponseMutation */
export type GPublishReviewResponseMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  locationUuid: Scalars['ID'];
  responseText: Scalars['String'];
  reviewId: Scalars['String'];
};

export type GPunchOutCartItemInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
  price: Scalars['Decimal'];
  quantity: Scalars['Int'];
};

export type GPunchOutOrderMessage = {
  __typename?: 'PunchOutOrderMessage';
  /** URL to which the cXML document must be POSTed */
  browserFormPostUrl?: Maybe<Scalars['String']>;
  /** String containing the cXML-encoded PunchOutOrderMessage */
  cxmlDocument?: Maybe<Scalars['String']>;
};

export type GPurchaseHistoryFeedbackError = {
  __typename?: 'PurchaseHistoryFeedbackError';
  message: Scalars['String'];
};

export type GPurchaseHistoryRecommendation = {
  __typename?: 'PurchaseHistoryRecommendation';
  avgDaysBetweenOrders?: Maybe<Scalars['Float']>;
  avgQtyPerOrder: Scalars['Float'];
  coefficientOfVariation: Scalars['Float'];
  daysSinceLastOrder: Scalars['Int'];
  distinctMonthsOrdered: Scalars['Int'];
  firstOrderDate: Scalars['ISO8601DateTime'];
  isRefillDue: Scalars['Boolean'];
  item: GSupplyItem;
  lastOrderDate: Scalars['ISO8601DateTime'];
  medianQtyPerOrder: Scalars['Float'];
  predictabilityLevel: GPredictabilityLevel;
  stddevQtyPerOrder?: Maybe<Scalars['Float']>;
  totalOrders: Scalars['Int'];
};

export type GPurchaseHistoryRecommendationConnection = {
  __typename?: 'PurchaseHistoryRecommendationConnection';
  edges: Array<Maybe<GPurchaseHistoryRecommendationEdge>>;
  nodes: Array<Maybe<GPurchaseHistoryRecommendation>>;
  pageInfo: GPageInfo;
};

export type GPurchaseHistoryRecommendationEdge = {
  __typename?: 'PurchaseHistoryRecommendationEdge';
  cursor: Scalars['String'];
  node: GPurchaseHistoryRecommendation;
};

export type GPutawayAction = {
  __typename?: 'PutawayAction';
  destination: Scalars['String'];
  id: Scalars['ID'];
  movedAt: Scalars['ISO8601DateTime'];
  movedBaseQuantity: Scalars['Float'];
  movedOn: Scalars['ISO8601Date'];
};

/** Why an associate couldn't put a task away, as picked in the putaway companion. */
export enum GPutawayExceptionReason {
  /** Bin doesn't physically exist; its record should be deactivated. */
  BinDoesNotExist = 'bin_does_not_exist',
  /** Bin is at capacity. */
  BinFull = 'bin_full',
  /** Inventory cannot be reached. */
  BinInaccessible = 'bin_inaccessible',
  /** Item is not present. */
  ItemNotFound = 'item_not_found',
  /** Free form; the note carries the description. */
  Other = 'other',
  /** The destination is not the expected bin type. */
  WrongBinType = 'wrong_bin_type'
}

/** Feedback an associate sent when a putaway task couldn't be completed, kept for review. */
export type GPutawayExceptionReport = {
  __typename?: 'PutawayExceptionReport';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
};

export type GPutawayExpiration = {
  __typename?: 'PutawayExpiration';
  conflict: Scalars['Boolean'];
  effectiveDate?: Maybe<Scalars['ISO8601Date']>;
  lotDerivedDate?: Maybe<Scalars['ISO8601Date']>;
  recordedDate?: Maybe<Scalars['ISO8601Date']>;
  /** recorded, lot_number, or unknown. */
  source: Scalars['String'];
};

export type GPutawayItem = {
  __typename?: 'PutawayItem';
  displayName?: Maybe<Scalars['String']>;
  netsuiteInternalId?: Maybe<Scalars['String']>;
};

export enum GPutawayMovementClassification {
  FullPallet = 'FULL_PALLET',
  HalfPalletOrLess = 'HALF_PALLET_OR_LESS',
  MoreThanHalfPallet = 'MORE_THAN_HALF_PALLET'
}

export type GPutawayObservedMovement = {
  __typename?: 'PutawayObservedMovement';
  destination: Scalars['String'];
  movedOn: Scalars['ISO8601Date'];
};

export type GPutawayPalletBreakdown = {
  __typename?: 'PutawayPalletBreakdown';
  caseQuantity: Scalars['Float'];
  configuration: GPutawayPalletConfiguration;
  fullPalletCaseQuantity: Scalars['Float'];
  fullPalletCount: Scalars['Int'];
  remainderCaseQuantity: Scalars['Float'];
};

export type GPutawayPalletBreakdownError = {
  __typename?: 'PutawayPalletBreakdownError';
  code: GPutawayPalletBreakdownErrorCode;
  message: Scalars['String'];
};

export enum GPutawayPalletBreakdownErrorCode {
  CasesPerPalletInvalid = 'cases_per_pallet_invalid',
  InvalidReceiptQuantity = 'invalid_receipt_quantity',
  InvalidStockUnitConversion = 'invalid_stock_unit_conversion',
  InventoryItemMissing = 'inventory_item_missing',
  NonInventoryItem = 'non_inventory_item',
  PalletConfigurationMissing = 'pallet_configuration_missing',
  ReceiptQuantityMissing = 'receipt_quantity_missing',
  StockUnitConversionMissing = 'stock_unit_conversion_missing'
}

export type GPutawayPalletBreakdownResult = GPutawayPalletBreakdown | GPutawayPalletBreakdownError;

/** A pallet build correction reported in the putaway companion but not written to IMS, kept for review. */
export type GPutawayPalletBuildReport = {
  __typename?: 'PutawayPalletBuildReport';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
};

export type GPutawayPalletConfiguration = {
  __typename?: 'PutawayPalletConfiguration';
  casesPerLayer?: Maybe<Scalars['Int']>;
  casesPerPallet: Scalars['Int'];
  layersPerPallet?: Maybe<Scalars['Int']>;
  stockUnitConversion: Scalars['Float'];
};

export enum GPutawayPickZoneGroup {
  Ambient = 'AMBIENT',
  ChilledFrozen = 'CHILLED_FROZEN'
}

/** The connection type for PutawayReportRow. */
export type GPutawayPriorityConnection = {
  __typename?: 'PutawayPriorityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GPutawayReportRowEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GPutawayReportRow>>>;
  /** Information to aid in pagination. */
  pageInfo: GPageInfo;
  /** The total count of records in the connection. */
  totalCount: Scalars['Int'];
};

export type GPutawayProgress = {
  __typename?: 'PutawayProgress';
  actions: Array<GPutawayAction>;
  availableBaseQuantity?: Maybe<Scalars['Float']>;
  blockingCommands: Array<GWarehouseBinTransferCommand>;
  commands: Array<GWarehouseBinTransferCommand>;
  issues: Array<GPutawayProgressIssue>;
  movedBaseQuantity: Scalars['Float'];
  receivedBaseQuantity?: Maybe<Scalars['Float']>;
  remainingBaseQuantity?: Maybe<Scalars['Float']>;
  reservedBaseQuantity: Scalars['Float'];
  status: GPutawayProgressStatus;
};

export type GPutawayProgressIssue = {
  __typename?: 'PutawayProgressIssue';
  code: GPutawayProgressIssueCode;
  message: Scalars['String'];
};

export enum GPutawayProgressIssueCode {
  AmbiguousReceiptAssignment = 'AMBIGUOUS_RECEIPT_ASSIGNMENT',
  InvalidMovementQuantity = 'INVALID_MOVEMENT_QUANTITY',
  InvalidReceivedQuantity = 'INVALID_RECEIVED_QUANTITY',
  MovementQuantityExceedsRemaining = 'MOVEMENT_QUANTITY_EXCEEDS_REMAINING',
  SourceIdentityMissing = 'SOURCE_IDENTITY_MISSING'
}

export enum GPutawayProgressStatus {
  Complete = 'COMPLETE',
  NeedsReview = 'NEEDS_REVIEW',
  NotStarted = 'NOT_STARTED',
  Partial = 'PARTIAL'
}

export enum GPutawayQuantityUnit {
  Cases = 'CASES',
  Eaches = 'EACHES'
}

export enum GPutawayRefrigerationState {
  Frozen = 'FROZEN',
  Refrigerated = 'REFRIGERATED',
  RoomTemperature = 'ROOM_TEMPERATURE',
  Unknown = 'UNKNOWN'
}

export type GPutawayReport = {
  __typename?: 'PutawayReport';
  assignmentCount: Scalars['Int'];
  endDate: Scalars['ISO8601Date'];
  latestSyncedAt?: Maybe<Scalars['ISO8601DateTime']>;
  receiptCount: Scalars['Int'];
  rows: GPutawayReportRowConnection;
  startDate: Scalars['ISO8601Date'];
  warehouseId: Scalars['ID'];
  warehouseName: Scalars['String'];
  /** @deprecated Use independent feature results on each report row. */
  warnings: Array<Scalars['String']>;
};


export type GPutawayReportRowsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type GPutawayReportRow = {
  __typename?: 'PutawayReportRow';
  /**
   * Movement date of the latest active staging-origin putaway action.
   * @deprecated Use putawayProgress.actions.
   */
  actualMovedAt?: Maybe<Scalars['ISO8601Date']>;
  /**
   * Destination of the latest active staging-origin putaway action.
   * @deprecated Use putawayProgress.actions.
   */
  actualToBinName?: Maybe<Scalars['String']>;
  caseQuantity?: Maybe<Scalars['Float']>;
  casesPerLayer?: Maybe<Scalars['Int']>;
  casesPerPallet?: Maybe<Scalars['Int']>;
  expiration: GPutawayExpiration;
  expirationConflict: Scalars['Boolean'];
  expirationDate?: Maybe<Scalars['ISO8601Date']>;
  expirationSource: Scalars['String'];
  fullPalletCaseQuantity?: Maybe<Scalars['Float']>;
  fullPalletCount?: Maybe<Scalars['Int']>;
  /** Unique receipt line assignment row id. */
  id: Scalars['ID'];
  inventoryItem?: Maybe<GInventoryItem>;
  /** @deprecated Use inventoryItem and itemName. */
  item: GPutawayItem;
  /** NetSuite item internal id. */
  itemInternalId?: Maybe<Scalars['String']>;
  /** Item display name recorded on the receipt. */
  itemName?: Maybe<Scalars['String']>;
  layersPerPallet?: Maybe<Scalars['Int']>;
  lotExpirationDate?: Maybe<Scalars['ISO8601Date']>;
  /** Lot/serial display value. */
  lotNumber?: Maybe<Scalars['String']>;
  /** @deprecated Use putawayProgress.actions. */
  observedMovement?: Maybe<GPutawayObservedMovement>;
  palletBreakdown: GPutawayPalletBreakdownResult;
  /** Source purchase order NetSuite internal id, when known. */
  purchaseOrderInternalId?: Maybe<Scalars['String']>;
  /** Source purchase order transaction id, when known. */
  purchaseOrderTranId?: Maybe<Scalars['String']>;
  putawayProgress: GPutawayProgress;
  /** NetSuite base-unit quantity received for this assignment. */
  quantity?: Maybe<Scalars['Float']>;
  /** Receipt/staging bin recorded on the Item Receipt. */
  receiptBinName?: Maybe<Scalars['String']>;
  /** NetSuite transactionLine id on the Item Receipt. */
  receiptLineId?: Maybe<Scalars['String']>;
  /** NetSuite transactionLine unique key for rejoining decisions. */
  receiptLineUniqueKey?: Maybe<Scalars['String']>;
  /** NetSuite internal id for the Item Receipt. */
  receiptNetsuiteInternalId: Scalars['String'];
  /** Item Receipt transaction id, e.g. IR17. */
  receiptTranId?: Maybe<Scalars['String']>;
  /** Persisted recommendation reason, or why no recommendation was made. */
  recommendationReason?: Maybe<Scalars['String']>;
  /** Persisted point-in-time recommended destination bin. */
  recommendedBinName?: Maybe<Scalars['String']>;
  recordedExpirationDate?: Maybe<Scalars['ISO8601Date']>;
  refrigerationState: Scalars['String'];
  remainderCaseQuantity?: Maybe<Scalars['Float']>;
  stockUnitConversion?: Maybe<Scalars['Float']>;
  suggestedBin?: Maybe<GPutawaySuggestedBin>;
  /** When this receipt last synced from Kafka. */
  syncedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Item Receipt transaction date. */
  tranDate?: Maybe<Scalars['ISO8601Date']>;
};

/** The connection type for PutawayReportRow. */
export type GPutawayReportRowConnection = {
  __typename?: 'PutawayReportRowConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GPutawayReportRowEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GPutawayReportRow>>>;
  /** Information to aid in pagination. */
  pageInfo: GPageInfo;
  /** The total count of records in the connection. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type GPutawayReportRowEdge = {
  __typename?: 'PutawayReportRowEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GPutawayReportRow>;
};

export type GPutawaySuggestedBin = {
  __typename?: 'PutawaySuggestedBin';
  destination?: Maybe<Scalars['String']>;
  generatedAt: Scalars['ISO8601DateTime'];
  message?: Maybe<Scalars['String']>;
};

export type GPutawayTask = GWarehouseTask & {
  __typename?: 'PutawayTask';
  /** Current NetSuite base-unit balance less submitted moves. */
  currentQuantity: Scalars['Float'];
  expiration: GPutawayExpiration;
  id: Scalars['ID'];
  inventoryItem?: Maybe<GInventoryItem>;
  inventoryNumber?: Maybe<GWarehouseTaskInventoryNumber>;
  item: GWarehouseTaskItem;
  movement?: Maybe<GPutawayTaskMovement>;
  palletBreakdown: GPutawayTaskPalletBreakdownResult;
  priority: GPutawayTaskPriority;
  quantityDetails?: Maybe<GPutawayTaskQuantityDetails>;
  /** Oldest compatible Item Receipt time, used only as FIFO context. */
  receivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  sourceBin: GWarehouseTaskBin;
  state: GWarehouseTaskState;
  statusReason?: Maybe<GWarehouseTaskStatusReason>;
  /** Latest persisted destination-planning result; missing results are reported as updating. */
  suggestion: GPutawayTaskSuggestion;
  taskType: GWarehouseTaskType;
  /** Distinct purchase and stock units resolved against their shared base unit. */
  unitConfiguration?: Maybe<GPutawayTaskUnitConfiguration>;
  workstream: GWarehouseTaskWorkstream;
};

export type GPutawayTaskAllocation = {
  __typename?: 'PutawayTaskAllocation';
  destinationBin: GWarehouseTaskBin;
  /** Human-readable planning evidence for this allocation. */
  explanation?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  movement: GPutawayTaskMovement;
  palletConfiguration?: Maybe<GPutawayTaskPalletConfiguration>;
  palletFootprint?: Maybe<GPutawayTaskPalletFootprint>;
  quantityDetails: GPutawayTaskQuantityDetails;
  unitConfiguration?: Maybe<GPutawayTaskUnitConfiguration>;
};

export type GPutawayTaskConfigurationReview = {
  __typename?: 'PutawayTaskConfigurationReview';
  code: GWarehouseTaskStatusReasonCode;
  message: Scalars['String'];
};

export type GPutawayTaskMovement = {
  __typename?: 'PutawayTaskMovement';
  classification: GPutawayMovementClassification;
  /** Base-unit quantity for the next movement. */
  quantity: Scalars['Float'];
  quantityDetails: GPutawayTaskQuantityDetails;
  refrigerationState: GPutawayRefrigerationState;
  stockUnit?: Maybe<GPutawayTaskUnit>;
  /** Exact movement quantity in the NetSuite stock unit. */
  stockUnitQuantity?: Maybe<Scalars['String']>;
};

export type GPutawayTaskPalletBreakdown = {
  __typename?: 'PutawayTaskPalletBreakdown';
  configuration?: Maybe<GPutawayTaskPalletConfiguration>;
  /** One pallet expressed in purchase, base, and stock units. */
  footprint?: Maybe<GPutawayTaskPalletFootprint>;
  fullPalletCaseQuantity?: Maybe<Scalars['String']>;
  fullPalletCount: Scalars['Int'];
  quantityDetails: GPutawayTaskQuantityDetails;
  remainderQuantityDetails: GPutawayTaskQuantityDetails;
};

export type GPutawayTaskPalletBreakdownResult = GPutawayTaskConfigurationReview | GPutawayTaskPalletBreakdown;

export type GPutawayTaskPalletConfiguration = {
  __typename?: 'PutawayTaskPalletConfiguration';
  casesPerLayer?: Maybe<Scalars['Int']>;
  casesPerPallet: Scalars['Int'];
  eachesPerCase: Scalars['String'];
  layersPerPallet?: Maybe<Scalars['Int']>;
};

export type GPutawayTaskPalletFootprint = {
  __typename?: 'PutawayTaskPalletFootprint';
  baseUnitQuantity: Scalars['String'];
  casesPerLayer?: Maybe<Scalars['Int']>;
  layersPerPallet?: Maybe<Scalars['Int']>;
  purchaseUnit: GPutawayTaskUnit;
  purchaseUnitsPerPallet: Scalars['Int'];
  stockUnit: GPutawayTaskUnit;
  stockUnitQuantity: Scalars['String'];
};

export enum GPutawayTaskPriority {
  Blocked = 'BLOCKED',
  FullPallet = 'FULL_PALLET',
  HalfPalletOrLess = 'HALF_PALLET_OR_LESS',
  MoreThanHalfPallet = 'MORE_THAN_HALF_PALLET',
  NeedsReview = 'NEEDS_REVIEW'
}

export type GPutawayTaskPurchaseUnitGrouping = {
  __typename?: 'PutawayTaskPurchaseUnitGrouping';
  looseBaseUnitQuantity: Scalars['String'];
  quantity: Scalars['String'];
  unit: GPutawayTaskUnit;
  wholeUnitQuantity: Scalars['String'];
};

export type GPutawayTaskQuantityDetails = {
  __typename?: 'PutawayTaskQuantityDetails';
  baseUnitQuantity: Scalars['String'];
  /** Server-computed case quantity rounded to six decimal places. */
  caseQuantity?: Maybe<Scalars['String']>;
  eachQuantity: Scalars['String'];
  eachesPerCase?: Maybe<Scalars['String']>;
  looseEachQuantity?: Maybe<Scalars['String']>;
  /** Purchase-unit grouping when stock is kept in base units and purchase units contain several base units. */
  purchaseUnitGrouping?: Maybe<GPutawayTaskPurchaseUnitGrouping>;
  stockUnit?: Maybe<GPutawayTaskUnit>;
  /** Exact quantity in the NetSuite stock unit for the same base-unit quantity. */
  stockUnitQuantity?: Maybe<Scalars['String']>;
  unit: GPutawayQuantityUnit;
  wholeCaseQuantity?: Maybe<Scalars['String']>;
};

export type GPutawayTaskSuggestion = {
  __typename?: 'PutawayTaskSuggestion';
  /** The singular current movement directive; retained while an existing result is updating. */
  allocation?: Maybe<GPutawayTaskAllocation>;
  /** When the current or retained result was calculated. */
  generatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Whether the retained movement directive is being refreshed. */
  outOfDate: Scalars['Boolean'];
  state: GPutawayTaskSuggestionState;
  /** Why planning is updating or no safe destination is available. */
  statusReason?: Maybe<GWarehouseTaskStatusReason>;
};

export enum GPutawayTaskSuggestionState {
  Suggested = 'SUGGESTED',
  Unavailable = 'UNAVAILABLE',
  Updating = 'UPDATING'
}

export type GPutawayTaskUnit = {
  __typename?: 'PutawayTaskUnit';
  baseUnitId: Scalars['ID'];
  baseUnitName?: Maybe<Scalars['String']>;
  conversionToBaseUnit: Scalars['String'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type GPutawayTaskUnitConfiguration = {
  __typename?: 'PutawayTaskUnitConfiguration';
  purchaseUnit: GPutawayTaskUnit;
  stockUnit: GPutawayTaskUnit;
};

export type GQrScanAnalyticsData = {
  __typename?: 'QrScanAnalyticsData';
  byDayOfWeek: Array<GDayOfWeekQrScanCount>;
  byHourOfDay: Array<GHourOfDayQrScanCount>;
  totalScanCount: Scalars['Int'];
};

export type GQuery = {
  __typename?: 'Query';
  /** Fetch an account creation session by ID or email */
  accountCreationSession?: Maybe<GAccountCreationSession>;
  /** Valid collections status values for the AR dashboard */
  accountsReceivableCollectionsStatuses: Array<Scalars['String']>;
  /** AR collections dashboard grouped by company */
  accountsReceivableCompanyDashboard: GAccountsReceivableCompanyDashboard;
  /** @deprecated Use accountsReceivableLocationDashboard or accountsReceivableCompanyDashboard instead */
  accountsReceivableDashboard: GAccountsReceivableDashboard;
  /** AR collections dashboard grouped by location */
  accountsReceivableLocationDashboard: GAccountsReceivableLocationDashboard;
  /** The names of distributor companies Odeko has merged/acquired. The source of truth for these is NetSuite. */
  acquisitionConversions: Array<GAcquisitionConversion>;
  activeMasterHomepage?: Maybe<GActiveMasterHomepage>;
  /** Returns a list of active zipcodes matches the passed zipcodes */
  activeZipcodes?: Maybe<Array<GZipcode>>;
  /** List allowance recipients */
  allowanceRecipients: GAllowanceRecipientConnection;
  /** List rewards applicable at checkout. */
  applicableRewards: Array<GReward>;
  approvedCutoffDiscrepancies: Array<GCutoffDiscrepancyApproval>;
  arAssignableUsers: Array<GArAssignableUser>;
  /** Returns a presigned url to upload artwork to */
  artworkUploadUrl: GArtworkUpload;
  /**
   * Locations the current user may grant when creating or editing a user.
   * Owner/Admin actors: all company locations. Other roles: only the actor's own locations.
   */
  assignableLocations: Array<GLocation>;
  /**
   * Roles the current user may assign (equal-or-below rank, customer-facing only,
   * Owner omitted for Owner actors), ordered by rank, highest assignable first.
   */
  assignableRoles: Array<GRole>;
  associateBadgePayloads: Array<GAssociateBadgePayload>;
  auditReputation: GAuditReputation;
  auditReputationGbp: GAuditReputation;
  /** Authorized version of micrositeLocation query requiring proper roles and microsite access */
  authorizedMicrositeLocation: GMicrositeLocation;
  /** Matches a scanned barcode against the NetSuite item-barcode mirror. */
  availableItemBarcodeMatch?: Maybe<GItemBarcodeMatch>;
  /** Looks up an inventory item by a legacy item UPC code. */
  availableItemByUpcCode?: Maybe<GSupplyItem>;
  /** Returns a single base branded item */
  baseBrandedItem: GBaseBrandedItem;
  /** Returns base branded items for given filters */
  baseBrandedItems: Array<GBaseBrandedItem>;
  /** List batched deposits */
  batchedDeposits: GBatchedDepositConnection;
  /** Returns a single branded item deal */
  brandedItemDeal: GBrandedItemDeal;
  /** Returns all branded item deals for a location */
  brandedItemDeals: Array<GBrandedItemDeal>;
  /**
   * Calculate a full consumer refund. This provides a preview of the refund
   * info that would result from executing the createFullConsumerRefund
   * mutation.
   */
  calculateFullConsumerRefund: GConsumerRefundInfoResult;
  /**
   * Calculate a partial consumer refund. This provides a preview of the refund
   * info that would result from executing the createPartialConsumerRefund
   * mutation.
   */
  calculatePartialConsumerRefund: GConsumerRefundInfoResult;
  /** Shopping cart */
  cart: GCart;
  catalogFilters?: Maybe<GCatalogFilter>;
  catalogHomepageContent: Array<GCatalogHomepageEntry>;
  catalogHomepageRows: Array<GCollectionsHomepageRow>;
  categories: Array<GCategory>;
  categoryBannerForEdit?: Maybe<GCategoryBannerForEdit>;
  categoryById?: Maybe<GCategory>;
  categoryByName?: Maybe<GCategory>;
  /** Download check-in entries as CSV */
  checkInEntriesCsv: Scalars['String'];
  /** Get statistics for check-in entries */
  checkInStats: GCheckInStats;
  /** Check if an email has already checked in today */
  checkInStatus: GCheckInStatus;
  collection?: Maybe<GCollection>;
  collectionBySlug?: Maybe<GCollection>;
  collectionSetupForEdit?: Maybe<GCollectionSetupForEdit>;
  collectionsPage: Array<GCollectionsPageEntry>;
  /** Returns all color options */
  colors: Array<GColor>;
  /**
   * If a value for name is provided, Returns a list of existing companies,
   * filtered by that value. PLEASE NOTE: This query returns no results if an empty
   * or blank argument for name.
   */
  companies: GCompanyConnection;
  /** Returns a single top-level company, identified by ID. */
  company: GCompany;
  /** Get the config that's current as of a given datetime */
  config: GConfig;
  /** List configs in reverse chronological order */
  configs: GConfigConnection;
  /** Consumer app referral link. */
  consumerAppReferralLink?: Maybe<GConsumerAppReferralLink>;
  /** Fetches a consumer order by ID */
  consumerOrder?: Maybe<GConsumerOrder>;
  /** Info about consumer post-order survey. */
  consumerPostOrderSurvey?: Maybe<GConsumerPostOrderSurvey>;
  conversionMetrics: GConversionMetrics;
  conversionMetricsGbp: GConversionMetrics;
  /** Current ConsumerAppUser. Null unless logged into a consumer account. */
  currentConsumerAppUser?: Maybe<GConsumerAppUser>;
  /** An authorized customer's current delivery position; unavailable outside warehouse display hours. */
  customerDeliveryTracking?: Maybe<GCustomerDeliveryTracking>;
  /**
   * Returns locations with pagination. This query is meant for ops use cases and is only available admins.
   *     At least one of the arguments 'first' or 'last' is required.
   *     Raises an error if either 'first' or 'last' argument is not provided.
   *     Additionally, an error is raised if the value provided for 'first' or 'last' argument is greater than 100.
   */
  customerLocations: GCustomerLocationsConnection;
  /** A bulk customer-tag CSV upload and how far it has got. Polled while one runs. */
  customerTagImport?: Maybe<GCustomerTagImport>;
  /** The customer tag vocabulary, independent of any location. */
  customerTags: GCustomerTagConnection;
  customerTrackingSettings: GCustomerTrackingSettings;
  /** Returns delivery type for a google address */
  deliveryForAddress: GDeliveryForAddress;
  deliveryInstructionReviewStatus?: Maybe<GDeliveryInstructionReviewStatus>;
  /** Every order (and standing delivery) a delivery-override block on this date would affect. */
  deliveryOverrideAffectedDeliveries: GDeliveryOverrideAffectedDeliveries;
  /** The locations a delivery override described this way would currently reach. */
  deliveryOverrideLocations: GLocationConnection;
  /** What a delivery override would reach if it were created as described. */
  deliveryOverridePreview: GDeliveryOverridePreview;
  /**
   * Delivery overrides, soonest delivery date first, optionally narrowed to one
   * market. Upcoming ones unless `from` asks for a date already past. Paginated:
   * either `first` or `last` is required, and neither may exceed 100.
   */
  deliveryOverrideRules: GDeliveryOverrideRulesConnection;
  /** Calculate prices and discounts on a delivery. */
  deliveryPrice: GDeliveryPriceResult;
  dockBooking?: Maybe<GDockBooking>;
  dockBookingByReference?: Maybe<GDockBooking>;
  dockBookings: Array<GDockBooking>;
  dockBookingsRange: Array<GDockBooking>;
  dockOpenVisits?: Maybe<Array<GDockVisit>>;
  dockOverrideCodes: Array<GDockOverrideCode>;
  dockWarehouseCapacity?: Maybe<GWarehouseDockCapacity>;
  dockWarehouseClosedDays: Array<Scalars['Int']>;
  docks: Array<GDock>;
  /** Returns a route's ordered driver location breadcrumb trail, optionally bounded to a time window. */
  driverLocationTrail: Array<GDriverLocationPing>;
  /** Returns all driver safety acknowledgements */
  driverSafetyAcknowledgements: Array<GDriverSafetyAcknowledgement>;
  expectedPurchaseOrders: Array<GExpectedPurchaseOrder>;
  expectedTransferOrders: Array<GExpectedTransferOrder>;
  externalSupplier?: Maybe<GExternalSupplier>;
  externalSuppliers: GExternalSupplierConnection;
  /** Lists favorite consumer orders */
  favoriteConsumerOrders: Array<GFavoriteConsumerOrder>;
  /** Whether a Flipper flag is on for the signed-in user. What the admin tool reads to decide which experience to render. */
  featureFlagEnabled: Scalars['Boolean'];
  /** Field Service zipcodes served by the given warehouse. */
  fieldServiceZipcodes: Array<GFieldServiceZipcode>;
  /** Find games */
  games: Array<GGame>;
  generatePunchOutOrderMessage?: Maybe<GPunchOutOrderMessage>;
  /** Gets a list of chat messages for the current user ordered by most recent first */
  getChatHistory?: Maybe<Array<Maybe<GChatMessage>>>;
  getChatMessage?: Maybe<GChatMessage>;
  /** Fetch a pricing package by its integer ID */
  getPricingPackage?: Maybe<GPricingPackage>;
  /**
   * Orders held for staff, least recently updated first. Paginated: either `first`
   * or `last` is required, and neither may exceed 100.
   */
  heldProvisionalOrders: GProvisionalOrdersConnection;
  /** Returns a single InProgressCustomer, by id. */
  inProgressCustomer: GInProgressCustomer;
  /**
   * Where one acquisition's in-progress customers stand right now: counts by
   * state, and the active and most recently finished batch runs.
   */
  inProgressCustomerAcquisitionSummary: GInProgressCustomerAcquisitionSummary;
  /**
   * Returns a list of InProgressCustomer, according to the specified filters.
   *       NOTE: business-portal's implementation of connection types for pagination is not fully compliant with ADR 28,
   *       so currently you can make queries without including 'first' or 'last' arguments. You should not do this however,
   *       and always include 'first' or 'last' arguments in your queries. In the
   * future we can they make these required as per ADR 28.
   */
  inProgressCustomers: GInProgressCustomerConnection;
  /** PROTOTYPE inventory-service-2 - for a given LocationStockCount session LocationItem, return the current count. */
  inventoryCurrentCount?: Maybe<GCurrentCount>;
  /** PROTOTYPE inventory-service-2 LocationItem (different than IMS LocationItem). */
  inventoryLocationItem?: Maybe<GInventoryLocationItem>;
  /** PROTOTYPE inventory-service-2 - obtain a LocationStockCount by id. */
  inventoryStockCountById?: Maybe<GLocationStockCount>;
  /** Purpose-built candidate search for invoice line matching. */
  invoiceMatchCandidates: GInvoiceMatchCandidatesResult;
  /** Returns a true if the specified input time is past the cutoff time */
  isPastWarehouseCutOffTime: Scalars['Boolean'];
  /** Determines if route synchronization is allowed for the given warehouse and night end */
  isRoutesSyncEnabled: Scalars['Boolean'];
  itemBrands: GItemBrandConnection;
  items: GItemConnection;
  /** The task's most recent replenishment trip that has not been undone, or null when there is none. */
  lastReplenishmentTrip?: Maybe<GReplenishmentTrip>;
  /** Find leaderboard entries */
  leaderboardEntries: Array<GLeaderboardEntry>;
  /** Get leaderboard rankings for a specified time period */
  leaderboardRankings: Array<GLeaderboardEntry>;
  /** Find leaderboards */
  leaderboards: Array<GLeaderboard>;
  listingImpressions: GListingImpressions;
  listingImpressionsGbp: GListingImpressions;
  /** Get a location by id, odeko UUID, or encrypted id. */
  location?: Maybe<GLocation>;
  /** query's location-item associations for catalog whitelisting by location (`locationitem` Table) */
  locationItemsByItemId?: Maybe<Array<Maybe<GLocationItem>>>;
  /**
   * Returns all orders with quantities for a given location with pagination.
   *     At least one of the arguments 'first' or 'last' is required.
   *     Raises an error if either 'first' or 'last' argument is not provided.
   *     Additionally, an error is raised if the value provided for 'first' or 'last' argument is greater than 100.
   */
  locationOrders: GLocationOrdersConnection;
  /**
   * Returns past orders for a given location with pagination.
   *     At least one of the arguments 'first' or 'last' is required.
   *     Raises an error if either 'first' or 'last' argument is not provided.
   *     Additionally, an error is raised if the value provided for 'first' or 'last' argument is greater than 100.
   */
  locationPastOrders: GLocationPastOrdersConnection;
  locationPrices: Array<GItemLocationCustomPrice>;
  /** Returns upcoming orders for a given location */
  locationUpcomingOrders: Array<GOrder>;
  /** Download mailing list submissions as CSV */
  mailingListSubmissionsCsv: Scalars['String'];
  marketingQrCodes: GMarketingQrCodeConnection;
  marketingQrCodesAvailable: Scalars['Int'];
  /** Get marketing tools users associated with a microsite location */
  marketingToolsUsers: Array<GUser>;
  masterHomepageForEdit?: Maybe<GMasterHomepage>;
  masterHomepages: Array<GMasterHomepageListItem>;
  /** Returns the current authenticated user */
  me: GUser;
  /** Fetches a merchant given its ID */
  merchant?: Maybe<GMerchant>;
  /** Information about the currently logged-in merchant app viewer. */
  merchantAppViewer: GMerchantAppUser;
  /** Fetches a merchant given its databaseId */
  merchantByDatabaseId?: Maybe<GMerchant>;
  /** Fetches a merchant given its uuid */
  merchantByUuid?: Maybe<GMerchant>;
  /** List merchants */
  merchants: GMerchantConnection;
  micrositeAdminLocations: GMicrositeLocationAdminConnection;
  /**
   * PROTOTYPE (marketing-tools-service) Return the data for the MicrositeLocation.
   * Note, this is separate from a traditional Odeko (supply) Location.
   */
  micrositeLocation: GMicrositeLocation;
  micrositeScans: GMicrositeScansData;
  /**
   * PROTOTYPE (marketing-tools-service) Return the list of avaliable time zones,
   * as a list of options suitable for use in select list/dropdown.
   */
  micrositeTimeZones: Array<GMicrositeTimeZoneOption>;
  /**
   * Every market where an item is currently eligible as new, alongside that market's current queue
   * leader at `position` (if any) — a preview for cross-market pinning.
   */
  newItemMarketsForItem: Array<GNewItemMarketEligibility>;
  /**
   * All New Items pins for a market, ordered by (position, subrank). Includes stale pins (item out of
   * stock or aged out of the 60-day new window) that the shopper-facing carousel excludes, so the
   * merchandising studio can surface and clean them up.
   */
  newItemPins: Array<GNewItemPin>;
  /** Fetches an object given its ID. */
  node?: Maybe<GNode>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<GNode>>;
  nonInventoryVendors: Array<GNonInventoryVendor>;
  /** Get an order by ID */
  order?: Maybe<GOrder>;
  /** Get ordering rules for a list of items at a location */
  orderingRules: Array<GOrderingRule>;
  /** Returns a list of orders based on the provided filters. */
  orders: GOrdersConnection;
  outboundGates: GOutboundGates;
  pastHomepageCollections: Array<GPastHomepageCollectionEntry>;
  /** Returns pending published driver safety acknowledgements for the current driver */
  pendingDriverSafetyAcknowledgements: Array<GDriverSafetyAcknowledgement>;
  pickHoursScorecard: Array<GPickHoursScorecardDay>;
  /** Pickup schedule for specified merchant and menu items. */
  pickupSchedule: GPickupSchedule;
  pingBraavos: Scalars['String'];
  /**
   * PROTOTYPE (marketing-tools-service) Obtain an "authorize" url. Directing a
   * user's client to this url initiates an OAuth flow.
   */
  platformAuthorizeUrl: GAuthorizeUrl;
  /**
   * PROTOTYPE (marketing-tools-service) Return the platform connection for the
   * given platform. In the initial version we return the full connection for the
   * user. We'll update this to return location specific locations pretty soon.
   */
  platformConnection: GConnection;
  /** List account profiles for the current user's platform connection */
  platformProfiles: Array<GAccountProfile>;
  pricingServicePing: Scalars['String'];
  processPathCatalog: Array<GProcessPath>;
  processPathCompliance: GProcessPathCompliance;
  processPathCoverageTargets: Array<GProcessPathCoverageTarget>;
  processPathEmployeeDay?: Maybe<GProcessPathEmployeeDay>;
  processPathEmployeeThroughput: Array<GProcessPathEmployeeThroughput>;
  processPathFloor: Array<GProcessPathEmployeeDay>;
  processPathHourlyTotals: Array<GProcessPathHourlyTotal>;
  processPathMeasuredPickDays: Array<GProcessPathMeasuredPickDay>;
  processPathRoster: Array<GProcessPathEmployee>;
  /**
   * Whole-floor daily units + clocked minutes for one process path — the
   * Throughput grid's fast basis. Answers for the LD/Ecomm pick path unless
   * processPathCode names another.
   */
  processPathScanDays: Array<GProcessPathScanDay>;
  /**
   * First day processPathScanDays can answer for at a warehouse, for the path
   * processPathCode names (the LD/Ecomm pick path by default); earlier days are
   * unmeasured, not empty. Null if never measured.
   */
  processPathScanHistoryStart?: Maybe<Scalars['ISO8601Date']>;
  processPathSelfContext?: Maybe<GProcessPathEmployeeDay>;
  processPathThroughput: Array<GProcessPathThroughput>;
  processPathWeeklyActuals: Array<GProcessPathEmployeeDay>;
  processPathWeeklyForecast: Array<GProcessPathDayForecast>;
  processPaths: Array<GProcessPath>;
  /**
   * Aggregate human approval of AI outputs — overall and by interaction type. The
   * initiative's 'percent of AI interactions approved' metric.
   */
  procurementAiApprovalRate: GProcurementAiApprovalStats;
  procurementCorrespondence?: Maybe<GProcurementEmailThread>;
  /**
   * Inbound coverage — the share of settled (8+ days old) confirmed-linked PO
   * threads that ever heard back from outside Odeko (bounce notices excluded).
   * Read next to procurementAiApprovalRate: the approval rate is not interpretable
   * while coverage is unknown.
   */
  procurementInboundCoverage: GProcurementInboundCoverageStats;
  procurementInbox: GProcurementInboxPage;
  procurementMailDownload: Scalars['JSON'];
  /** Last processed Gmail historyId for a mailbox; null before the first ingest pass (the poller then backfills). */
  procurementMailboxCursor?: Maybe<Scalars['String']>;
  /** One PO tracking row, by id or by PO number (NetSuite tranId). */
  procurementPoTracking?: Maybe<GProcurementPoTracking>;
  /** PO tracking rows (tool-owned correspondence state joined to the NetSuite PO projection), newest first. */
  procurementPoTrackings: Array<GProcurementPoTracking>;
  /** One procurement vendor by id. */
  procurementTrackingVendor?: Maybe<GProcurementTrackingVendor>;
  /** Procurement vendors (PO counterparties with AI context), name-ordered. */
  procurementTrackingVendors: Array<GProcurementTrackingVendor>;
  /**
   * Threads triaged as PO-like but not confidently linked — the human queue
   * (includes any AI-proposed links awaiting confirmation), oldest first.
   */
  procurementUnmatchedThreads: Array<GProcurementEmailThread>;
  /** Returns all procurement vendors */
  procurementVendors: Array<GProcurementVendor>;
  /** Returns the current inventory for a product */
  productInventory: Array<GProductInventory>;
  /** A provisional order, readable by staff and by the actor that created it */
  provisionalOrder?: Maybe<GProvisionalOrder>;
  publicDockBooking?: Maybe<GPublicDockBooking>;
  publicDockCheckInLookup?: Maybe<GPublicDockBooking>;
  publicDockDisplay?: Maybe<GPublicDockDisplay>;
  publicDockOpenVisits?: Maybe<Array<GPublicDockVisit>>;
  publicDockWarehouses: Array<GPublicDockWarehouse>;
  publicOverrideSlots: Array<GPublicDockSlot>;
  publicOverrideVendor?: Maybe<GPublicOverrideVendor>;
  putawayPriority: GPutawayPriorityConnection;
  putawayReport: GPutawayReport;
  qrScanAnalytics: GQrScanAnalyticsData;
  receivableNotes: Array<GReceivableNote>;
  /**
   * The most recent manual transaction syncs across all locations, newest first,
   * including syncs still in flight. Bounded and unpaginated: manual syncs are
   * rare and this answers a recent-activity list, not a browsable history.
   */
  recentTransactionSyncs: Array<GTransactionSyncAttempt>;
  /** Returns a single redelivery stop */
  redeliveryStop: GRedelivery;
  rfsmartCredentials: Array<GRfsmartCredential>;
  rfsmartPendingRemovals: Array<GRfsmartCredential>;
  rfsmartPooledCredentials: Array<GRfsmartCredential>;
  /** Returns a single route */
  route: GRoute;
  /** Returns all routes for a warehouse */
  routes: Array<GRoute>;
  /** Returns the routing import plan */
  routingImportPlan: GRoutingImportPlan;
  salesPriorityList: Array<GSalesPriorityLocation>;
  salesRepAdmins: Array<GAdmin>;
  scoringKey: Scalars['JSON'];
  searchTermImpressions: Array<GSearchTermImpression>;
  searchTermImpressionsGbp: Array<GSearchTermImpression>;
  /** Fetch the current sign product and its price */
  signProduct?: Maybe<GSignProduct>;
  /** Get signage orders with optional filtering */
  signageOrders: GSignageOrderConnection;
  /** Check if the current user has any signage orders */
  signageOrdersExist: Scalars['Boolean'];
  signedUploadImageByKey?: Maybe<GUploadItemImageByKey>;
  signedUploadImageUrl?: Maybe<GUploadItemImage>;
  /** Get Square location details for a profile */
  squareLocation?: Maybe<GSquareLocation>;
  /** List paired Square terminals for a location */
  squareTerminals: Array<GSquareTerminal>;
  standaloneVehicleInspectionDrives: Array<GStandaloneVehicleInspectionDrive>;
  standaloneVehicleInspectionReport: GStandaloneVehicleInspectionReport;
  standingAppointmentCandidateWindows: Array<GCandidateDockWindow>;
  standingAppointmentDirectory: Array<GStandingAppointmentDirectoryEntry>;
  standingAppointmentGapDates: Array<Scalars['ISO8601Date']>;
  standingAppointmentHistory: Array<GStandingAppointment>;
  standingAppointmentVendors: Array<GNetsuiteVendor>;
  /** Returns a single stop */
  stop: GDeliveryStop;
  /** Return the in-progress SubscriptionSession during the Sign Up flow. */
  subscriptionSession: GSubscriptionSession;
  supplierInvoiceComparison?: Maybe<GSupplierInvoiceComparison>;
  supplierInvoiceComparisons: Array<GSupplierInvoiceComparison>;
  /** Returns the authenticated user's supply cart at the given location, or null if none exists. */
  supplyCart?: Maybe<GSupplyCart>;
  topSubcategoriesPerWarehouse: Array<GWarehouseTopSubcategory>;
  /**
   * Locations matching a transaction-sync search term. Bounded and unpaginated: it
   * answers a type-ahead picker, so it returns a short best-effort list rather
   * than every match.
   */
  transactionSyncLocationSearch: Array<GLocation>;
  unitById?: Maybe<GUnit>;
  unitByName?: Maybe<GUnit>;
  units: Array<GUnit>;
  /** Get all microsite locations associated with the current user */
  userMicrositeLocations: Array<GUserMicrositeLocation>;
  /** Returns platform connection status and associated microsites for the user */
  userPlatformConnection: GUserPlatformConnection;
  /** Get the current user's pricing package */
  userPricingPackage?: Maybe<GPricingPackage>;
  /** The list of users. */
  users?: Maybe<Array<Maybe<GUser>>>;
  /** Validate email availability for marketing tools signup */
  validateEmailForSignup: GEmailValidationResult;
  /** Validate microsite URL availability for signup */
  validateMicrositeUrl: GMicrositeUrlValidationResult;
  vehicleInspectionReport: GVehicleInspectionReport;
  vehicleInspectionReports: Array<GVehicleInspectionReport>;
  vehicleInspectionRouteStatuses: Array<GVehicleInspectionRouteStatus>;
  vehicleInspectionStatus: GVehicleInspectionStatus;
  vehicleInspectionTruckStatuses: Array<GVehicleInspectionTruckStatus>;
  /** Get a vendor by ID */
  vendor?: Maybe<GVendor>;
  /** Returns all Vendor Orders for a given warehouse and night end */
  vendorOrders: Array<GOrder>;
  /** Returns the consolidated check-in view for a vendor: items aggregated across all customer orders */
  vendorReceivingCheckin: Array<GVendorReceivingCheckinItem>;
  /** Returns vendors with open market-priced orders for a given warehouse and night end */
  vendorReceivingList: Array<GVendorReceivingSummary>;
  /** Returns all vendors */
  vendors: Array<GVendor>;
  /** The currently authenticated user. */
  viewer?: Maybe<GUser>;
  /** Find warehouse by id */
  warehouse: GWarehouse;
  warehouseBinLayout: GWarehouseBinLayout;
  warehouseBinTransferCommand?: Maybe<GWarehouseBinTransferCommand>;
  /** Get all items designated as bulk picked for a given warehouse */
  warehouseBulkPickedItems: GWarehouseBulkPickedItemsConnection;
  warehouseCategoryMedians: Array<GWarehouseCategoryMedian>;
  warehouseCommitmentDiscrepancies: GWarehouseCommitmentDiscrepancyReport;
  warehouseCommitmentDiscrepancyLines: GWarehouseCommitmentDiscrepancyLinesReport;
  warehouseCommitmentSummary: GWarehouseCommitmentSummary;
  warehouseCutoffDiscrepancies: GCutoffDiscrepancyReport;
  /** Get all items on a warehouse's ECOM bulk list */
  warehouseEcomBulkItems: GWarehouseBulkPickedItemsConnection;
  warehouseFulfillmentDiscrepancyLines: GWarehouseFulfillmentDiscrepancyLinesReport;
  warehouseFulfillmentSummary: GWarehouseFulfillmentSummary;
  warehouseItemTask?: Maybe<GWarehouseItemTask>;
  warehouseItemTasks: GWarehouseItemTaskConnection;
  warehouseLayoutBuilder: GWarehouseLayoutBuilder;
  /** When 'Sync routes' last completed for the given warehouse and night end. */
  warehouseRoutesSyncStatus: GWarehouseRoutesSyncStatus;
  /** Finds the source bin for a manual transfer. Null when no active bin in the warehouse has this label. */
  warehouseSourceBin?: Maybe<GWarehouseSourceBin>;
  warehouseStageGateOrderLines: GStageGateOrderLinesReport;
  warehouseSubcategoryThresholds: Array<GWarehouseSubcategoryThreshold>;
  warehouseTasks: GWarehouseTaskConnection;
  warehouseTrends: Array<GWarehouseTrendDay>;
  /** Returns all warehouses */
  warehouses: Array<GWarehouse>;
  workThread?: Maybe<GWorkThread>;
  workThreads: Array<GWorkThread>;
};


export type GQueryAccountCreationSessionArgs = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};


export type GQueryAccountsReceivableCompanyDashboardArgs = {
  arAssigneeUuid?: InputMaybe<Scalars['String']>;
  asOf?: InputMaybe<Scalars['ISO8601Date']>;
  companyUuid?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['String']>;
};


export type GQueryAccountsReceivableDashboardArgs = {
  arAssigneeUuid?: InputMaybe<Scalars['String']>;
  asOf?: InputMaybe<Scalars['ISO8601Date']>;
  companyUuid?: InputMaybe<Scalars['String']>;
  groupBy?: InputMaybe<GAccountsReceivableGroupBy>;
  search?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['String']>;
};


export type GQueryAccountsReceivableLocationDashboardArgs = {
  arAssigneeUuid?: InputMaybe<Scalars['String']>;
  asOf?: InputMaybe<Scalars['ISO8601Date']>;
  companyUuid?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['String']>;
};


export type GQueryActiveMasterHomepageArgs = {
  filter: GMasterHomepageFilterInput;
};


export type GQueryActiveZipcodesArgs = {
  zipcodes: Array<Scalars['String']>;
};


export type GQueryAllowanceRecipientsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GAllowanceRecipientOrderBy>;
};


export type GQueryApplicableRewardsArgs = {
  onDate: Scalars['ISO8601Date'];
};


export type GQueryApprovedCutoffDiscrepanciesArgs = {
  deliveryDate?: InputMaybe<Scalars['ISO8601Date']>;
  warehouseId: Scalars['ID'];
};


export type GQueryArtworkUploadUrlArgs = {
  filename: Scalars['String'];
};


export type GQueryAssignableLocationsArgs = {
  companyOdekoUuid?: InputMaybe<Scalars['ID']>;
};


export type GQueryAssociateBadgePayloadsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['ID']>>;
  warehouseId: Scalars['ID'];
};


export type GQueryAuditReputationArgs = {
  locationUuid: Scalars['ID'];
};


export type GQueryAuditReputationGbpArgs = {
  googleLocationName: Scalars['String'];
};


export type GQueryAuthorizedMicrositeLocationArgs = {
  urlId: Scalars['ID'];
};


export type GQueryAvailableItemBarcodeMatchArgs = {
  code: Scalars['String'];
};


export type GQueryAvailableItemByUpcCodeArgs = {
  upcCode: Scalars['String'];
};


export type GQueryBaseBrandedItemArgs = {
  id: Scalars['ID'];
};


export type GQueryBaseBrandedItemsArgs = {
  category?: InputMaybe<Scalars['ID']>;
  printingMethod?: InputMaybe<GPrintingMethod>;
  searchQuery?: InputMaybe<Scalars['String']>;
  subcategory?: InputMaybe<Scalars['ID']>;
  warehouseId?: InputMaybe<Scalars['ID']>;
};


export type GQueryBatchedDepositsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forDateRange?: InputMaybe<GDateRangeInput>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GBatchedDepositOrderBy>;
  totalCentsRange?: InputMaybe<GIntRangeInput>;
};


export type GQueryBrandedItemDealArgs = {
  id: Scalars['ID'];
};


export type GQueryBrandedItemDealsArgs = {
  locationUuid: Scalars['ID'];
};


export type GQueryCalculateFullConsumerRefundArgs = {
  consumerOrderId: Scalars['ID'];
  lockVersion: Scalars['Int'];
};


export type GQueryCalculatePartialConsumerRefundArgs = {
  consumerOrderId: Scalars['ID'];
  lockVersion: Scalars['Int'];
  refundItemInputs: Array<GConsumerRefundItemInput>;
  refundModifierInputs: Array<GConsumerRefundModifierInput>;
};


export type GQueryCatalogFiltersArgs = {
  itemCountFilters?: InputMaybe<GItemsFiltersInput>;
  selected?: InputMaybe<GCatalogFilterSelectedInput>;
};


export type GQueryCatalogHomepageContentArgs = {
  date?: InputMaybe<Scalars['ISO8601Date']>;
  warehouseId: Scalars['ID'];
};


export type GQueryCatalogHomepageRowsArgs = {
  date?: InputMaybe<Scalars['ISO8601Date']>;
};


export type GQueryCategoriesArgs = {
  filter?: InputMaybe<GCategoriesFilter>;
  forType?: InputMaybe<GCategoryType>;
  sortOrder?: InputMaybe<Array<InputMaybe<GCategoriesSortOrder>>>;
  warehouses?: InputMaybe<Array<GItemsWarehouseInput>>;
};


export type GQueryCategoryBannerForEditArgs = {
  categoryId: Scalars['ID'];
};


export type GQueryCategoryByIdArgs = {
  id: Scalars['ID'];
};


export type GQueryCategoryByNameArgs = {
  name: Scalars['String'];
};


export type GQueryCheckInEntriesCsvArgs = {
  endDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  limit?: InputMaybe<Scalars['Int']>;
  micrositeLocationId: Scalars['ID'];
  startDate?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type GQueryCheckInStatsArgs = {
  micrositeLocationId: Scalars['ID'];
};


export type GQueryCheckInStatusArgs = {
  email: Scalars['String'];
  micrositeLocationId: Scalars['ID'];
};


export type GQueryCollectionArgs = {
  id?: InputMaybe<Scalars['ID']>;
  referenceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};


export type GQueryCollectionBySlugArgs = {
  slug: Scalars['String'];
};


export type GQueryCollectionSetupForEditArgs = {
  collectionId: Scalars['ID'];
};


export type GQueryCompaniesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};


export type GQueryCompanyArgs = {
  id: Scalars['ID'];
};


export type GQueryConfigArgs = {
  asOf?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type GQueryConfigsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GConfigOrderBy>;
};


export type GQueryConsumerOrderArgs = {
  id: Scalars['ID'];
};


export type GQueryConversionMetricsArgs = {
  endDate: Scalars['ISO8601Date'];
  locationUuid: Scalars['ID'];
  startDate: Scalars['ISO8601Date'];
};


export type GQueryConversionMetricsGbpArgs = {
  endDate: Scalars['ISO8601Date'];
  googleLocationName: Scalars['String'];
  startDate: Scalars['ISO8601Date'];
};


export type GQueryCustomerDeliveryTrackingArgs = {
  locationId: Scalars['ID'];
  orderId: Scalars['ID'];
};


export type GQueryCustomerLocationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  input: GCustomerLocationsInput;
  last?: InputMaybe<Scalars['Int']>;
};


export type GQueryCustomerTagImportArgs = {
  id: Scalars['ID'];
};


export type GQueryCustomerTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<GCustomerTagCategoryEnum>;
  first?: InputMaybe<Scalars['Int']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<GCustomerTagSortInput>;
  source?: InputMaybe<GCustomerTagSourceEnum>;
};


export type GQueryCustomerTrackingSettingsArgs = {
  warehouseId: Scalars['ID'];
};


export type GQueryDeliveryForAddressArgs = {
  address: Scalars['String'];
};


export type GQueryDeliveryInstructionReviewStatusArgs = {
  instructionRevision: Scalars['String'];
  redelivery?: InputMaybe<Scalars['Boolean']>;
  stopId: Scalars['ID'];
};


export type GQueryDeliveryOverrideAffectedDeliveriesArgs = {
  audience?: InputMaybe<GDeliveryOverrideAudienceInput>;
  deliveryDate: Scalars['ISO8601Date'];
  locationId?: InputMaybe<Scalars['ID']>;
  reachMode?: InputMaybe<GDeliveryOverrideReachModeEnum>;
  scope?: InputMaybe<GDeliveryOverrideScopeEnum>;
  vendorId?: InputMaybe<Scalars['ID']>;
  warehouseId?: InputMaybe<Scalars['ID']>;
};


export type GQueryDeliveryOverrideLocationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters: GDeliveryOverrideLocationFiltersInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type GQueryDeliveryOverridePreviewArgs = {
  audience?: InputMaybe<GDeliveryOverrideAudienceInput>;
  dayAction?: InputMaybe<GDeliveryOverrideDayActionEnum>;
  deliveryDate: Scalars['ISO8601Date'];
  leadTime?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['ID']>;
  orderDeadline?: InputMaybe<Scalars['String']>;
  reachMode?: InputMaybe<GDeliveryOverrideReachModeEnum>;
  scope?: InputMaybe<GDeliveryOverrideScopeEnum>;
  substituteDeliveryDate?: InputMaybe<Scalars['ISO8601Date']>;
  vendorId?: InputMaybe<Scalars['ID']>;
  warehouseId?: InputMaybe<Scalars['ID']>;
};


export type GQueryDeliveryOverrideRulesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['ISO8601Date']>;
  last?: InputMaybe<Scalars['Int']>;
  to?: InputMaybe<Scalars['ISO8601Date']>;
  warehouseId?: InputMaybe<Scalars['ID']>;
};


export type GQueryDeliveryPriceArgs = {
  deliveryPriceInput: GDeliveryPriceInput;
};


export type GQueryDockBookingArgs = {
  id: Scalars['ID'];
};


export type GQueryDockBookingByReferenceArgs = {
  referenceNumber: Scalars['String'];
};


export type GQueryDockBookingsArgs = {
  date: Scalars['ISO8601Date'];
  warehouseId: Scalars['ID'];
};


export type GQueryDockBookingsRangeArgs = {
  endDate: Scalars['ISO8601Date'];
  startDate: Scalars['ISO8601Date'];
  warehouseId: Scalars['ID'];
};


export type GQueryDockOpenVisitsArgs = {
  dockId?: InputMaybe<Scalars['ID']>;
  warehouseId?: InputMaybe<Scalars['ID']>;
};


export type GQueryDockWarehouseCapacityArgs = {
  warehouseId: Scalars['ID'];
};


export type GQueryDockWarehouseClosedDaysArgs = {
  warehouseId: Scalars['ID'];
};


export type GQueryDocksArgs = {
  warehouseId: Scalars['ID'];
};


export type GQueryDriverLocationTrailArgs = {
  input: GDriverLocationTrailInput;
};


export type GQueryExpectedPurchaseOrdersArgs = {
  warehouseId: Scalars['ID'];
};


export type GQueryExpectedTransferOrdersArgs = {
  warehouseId: Scalars['ID'];
};


export type GQueryExternalSupplierArgs = {
  odekoUuid: Scalars['ID'];
};


export type GQueryExternalSuppliersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type GQueryFeatureFlagEnabledArgs = {
  flagName: Scalars['String'];
};


export type GQueryFieldServiceZipcodesArgs = {
  warehouseId: Scalars['ID'];
};


export type GQueryGamesArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  slugs?: InputMaybe<Array<Scalars['String']>>;
};


export type GQueryGeneratePunchOutOrderMessageArgs = {
  cart: Array<GPunchOutCartItemInput>;
};


export type GQueryGetChatMessageArgs = {
  id: Scalars['ID'];
};


export type GQueryGetPricingPackageArgs = {
  integerPricingPackageId: Scalars['Int'];
};


export type GQueryHeldProvisionalOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type GQueryInProgressCustomerArgs = {
  id: Scalars['ID'];
};


export type GQueryInProgressCustomerAcquisitionSummaryArgs = {
  acquisitionConversionId: Scalars['ID'];
};


export type GQueryInProgressCustomersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<GInProgressCustomersSearchInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type GQueryInventoryCurrentCountArgs = {
  locationItemId: Scalars['ID'];
  stockCountId: Scalars['ID'];
};


export type GQueryInventoryLocationItemArgs = {
  locationId: Scalars['ID'];
  odekoItemId?: InputMaybe<Scalars['ID']>;
};


export type GQueryInventoryStockCountByIdArgs = {
  stockCountId: Scalars['ID'];
};


export type GQueryInvoiceMatchCandidatesArgs = {
  input: GInvoiceMatchCandidatesInput;
};


export type GQueryIsPastWarehouseCutOffTimeArgs = {
  input: GIsPastWarehouseCutOffTimeInput;
};


export type GQueryIsRoutesSyncEnabledArgs = {
  input: GIsRoutesSyncEnabledInput;
};


export type GQueryItemBrandsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<GItemBrandsFiltersInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Array<InputMaybe<GItemBrandsSortOrder>>>;
};


export type GQueryItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  analyticsTags?: InputMaybe<GAlgoliaAnalyticsTagInput>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<GItemsFiltersInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Array<InputMaybe<GItemsSortOrder>>>;
};


export type GQueryLastReplenishmentTripArgs = {
  taskId: Scalars['ID'];
  windowDays?: InputMaybe<Scalars['Int']>;
};


export type GQueryLeaderboardEntriesArgs = {
  leaderboardId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  ranked?: InputMaybe<Scalars['Boolean']>;
  recent?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
};


export type GQueryLeaderboardRankingsArgs = {
  gameSlug?: InputMaybe<Scalars['String']>;
  leaderboardId?: InputMaybe<Scalars['ID']>;
  leaderboardSlug?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  micrositeLocationId?: InputMaybe<Scalars['ID']>;
  period: GRankingPeriodEnum;
};


export type GQueryLeaderboardsArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']>;
  gameId?: InputMaybe<Scalars['ID']>;
  gameSlug?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  leaderboardType?: InputMaybe<GLeaderboardTypeEnum>;
};


export type GQueryListingImpressionsArgs = {
  endDate: Scalars['ISO8601Date'];
  locationUuid: Scalars['ID'];
  startDate: Scalars['ISO8601Date'];
};


export type GQueryListingImpressionsGbpArgs = {
  endDate: Scalars['ISO8601Date'];
  googleLocationName: Scalars['String'];
  startDate: Scalars['ISO8601Date'];
};


export type GQueryLocationArgs = {
  encryptedLocationId?: InputMaybe<Scalars['ID']>;
  locationId?: InputMaybe<Scalars['ID']>;
  odekoUuid?: InputMaybe<Scalars['ID']>;
};


export type GQueryLocationItemsByItemIdArgs = {
  id: Scalars['ID'];
};


export type GQueryLocationOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  input: GLocationOrdersInput;
  last?: InputMaybe<Scalars['Int']>;
};


export type GQueryLocationPastOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  input: GLocationPastOrdersInput;
  last?: InputMaybe<Scalars['Int']>;
};


export type GQueryLocationPricesArgs = {
  locationId: Scalars['ID'];
};


export type GQueryLocationUpcomingOrdersArgs = {
  input: GLocationUpcomingOrdersInput;
};


export type GQueryMailingListSubmissionsCsvArgs = {
  endDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  micrositeLocationId: Scalars['ID'];
  startDate?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type GQueryMarketingQrCodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  assigned?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchString?: InputMaybe<Scalars['String']>;
};


export type GQueryMarketingToolsUsersArgs = {
  micrositeLocationId: Scalars['ID'];
};


export type GQueryMasterHomepageForEditArgs = {
  id: Scalars['ID'];
};


export type GQueryMerchantArgs = {
  id: Scalars['ID'];
};


export type GQueryMerchantByDatabaseIdArgs = {
  databaseId: Scalars['Int'];
};


export type GQueryMerchantByUuidArgs = {
  uuid: Scalars['ID'];
};


export type GQueryMerchantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  business?: InputMaybe<GBusinessSearchInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  near?: InputMaybe<GGeospatialCircle>;
};


export type GQueryMicrositeAdminLocationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  hasSignageOrder?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  searchString?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<GMicrositesSortDirection>;
  sortKey?: InputMaybe<GMicrositesSortKey>;
};


export type GQueryMicrositeLocationArgs = {
  urlId: Scalars['ID'];
};


export type GQueryMicrositeScansArgs = {
  googleLocationName?: InputMaybe<Scalars['String']>;
  urlSlug?: InputMaybe<Scalars['String']>;
};


export type GQueryNewItemMarketsForItemArgs = {
  itemId: Scalars['ID'];
  position: Scalars['Int'];
};


export type GQueryNewItemPinsArgs = {
  warehouseId: Scalars['ID'];
};


export type GQueryNodeArgs = {
  id: Scalars['ID'];
};


export type GQueryNodesArgs = {
  ids: Array<Scalars['ID']>;
};


export type GQueryNonInventoryVendorsArgs = {
  search: Scalars['String'];
};


export type GQueryOrderArgs = {
  orderId: Scalars['ID'];
};


export type GQueryOrderingRulesArgs = {
  items: Array<GOrderingRuleItemInput>;
  locationId: Scalars['ID'];
};


export type GQueryOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  input: GOrdersInput;
  last?: InputMaybe<Scalars['Int']>;
};


export type GQueryOutboundGatesArgs = {
  deliveryDate: Scalars['ISO8601Date'];
  warehouseId: Scalars['ID'];
};


export type GQueryPastHomepageCollectionsArgs = {
  date?: InputMaybe<Scalars['ISO8601Date']>;
};


export type GQueryPickHoursScorecardArgs = {
  endDate: Scalars['ISO8601Date'];
  startDate: Scalars['ISO8601Date'];
  warehouseId: Scalars['ID'];
};


export type GQueryPickupScheduleArgs = {
  asOf?: InputMaybe<Scalars['ISO8601DateTime']>;
  menuItemIds: Array<Scalars['ID']>;
  merchantId: Scalars['ID'];
};


export type GQueryPlatformAuthorizeUrlArgs = {
  action: GPlatformActions;
  platformId: GPlatformIds;
  redirectUri: Scalars['String'];
};


export type GQueryPlatformConnectionArgs = {
  locationUuid: Scalars['ID'];
  platformId: GPlatformIds;
};


export type GQueryPlatformProfilesArgs = {
  platformId: Scalars['String'];
};


export type GQueryProcessPathCatalogArgs = {
  warehouseId: Scalars['ID'];
};


export type GQueryProcessPathComplianceArgs = {
  endDate: Scalars['ISO8601Date'];
  startDate: Scalars['ISO8601Date'];
  warehouseId: Scalars['ID'];
};


export type GQueryProcessPathCoverageTargetsArgs = {
  warehouseId: Scalars['ID'];
  weekStart: Scalars['ISO8601Date'];
};


export type GQueryProcessPathEmployeeDayArgs = {
  date: Scalars['ISO8601Date'];
  employeeId: Scalars['ID'];
  warehouseId: Scalars['ID'];
};


export type GQueryProcessPathEmployeeThroughputArgs = {
  employeeId?: InputMaybe<Scalars['ID']>;
  endDate: Scalars['ISO8601Date'];
  startDate: Scalars['ISO8601Date'];
  warehouseId: Scalars['ID'];
};


export type GQueryProcessPathFloorArgs = {
  warehouseId: Scalars['ID'];
};


export type GQueryProcessPathHourlyTotalsArgs = {
  date: Scalars['ISO8601Date'];
  warehouseId: Scalars['ID'];
};


export type GQueryProcessPathMeasuredPickDaysArgs = {
  endDate: Scalars['ISO8601Date'];
  startDate: Scalars['ISO8601Date'];
  warehouseId: Scalars['ID'];
};


export type GQueryProcessPathRosterArgs = {
  statuses?: InputMaybe<Array<GWarehouseAssociateStatus>>;
  warehouseId: Scalars['ID'];
};


export type GQueryProcessPathScanDaysArgs = {
  endDate: Scalars['ISO8601Date'];
  processPathCode?: InputMaybe<Scalars['String']>;
  startDate: Scalars['ISO8601Date'];
  warehouseId: Scalars['ID'];
};


export type GQueryProcessPathScanHistoryStartArgs = {
  processPathCode?: InputMaybe<Scalars['String']>;
  warehouseId: Scalars['ID'];
};


export type GQueryProcessPathSelfContextArgs = {
  userId: Scalars['ID'];
};


export type GQueryProcessPathThroughputArgs = {
  endDate: Scalars['ISO8601Date'];
  startDate: Scalars['ISO8601Date'];
  warehouseId: Scalars['ID'];
};


export type GQueryProcessPathWeeklyActualsArgs = {
  warehouseId: Scalars['ID'];
  weekStart: Scalars['ISO8601Date'];
};


export type GQueryProcessPathWeeklyForecastArgs = {
  warehouseId: Scalars['ID'];
  weekStart: Scalars['ISO8601Date'];
};


export type GQueryProcessPathsArgs = {
  warehouseId: Scalars['ID'];
};


export type GQueryProcurementCorrespondenceArgs = {
  id: Scalars['ID'];
};


export type GQueryProcurementInboundCoverageArgs = {
  since?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type GQueryProcurementInboxArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  view?: InputMaybe<Scalars['String']>;
};


export type GQueryProcurementMailDownloadArgs = {
  id: Scalars['ID'];
  kind: Scalars['String'];
};


export type GQueryProcurementMailboxCursorArgs = {
  mailbox: Scalars['String'];
};


export type GQueryProcurementPoTrackingArgs = {
  id?: InputMaybe<Scalars['ID']>;
  poNumber?: InputMaybe<Scalars['String']>;
};


export type GQueryProcurementPoTrackingsArgs = {
  needsReply?: InputMaybe<Scalars['Boolean']>;
  trackingStatus?: InputMaybe<Scalars['String']>;
  warehouseId?: InputMaybe<Scalars['ID']>;
};


export type GQueryProcurementTrackingVendorArgs = {
  id: Scalars['ID'];
};


export type GQueryProcurementTrackingVendorsArgs = {
  search?: InputMaybe<Scalars['String']>;
};


export type GQueryProductInventoryArgs = {
  productId: Scalars['ID'];
};


export type GQueryProvisionalOrderArgs = {
  id: Scalars['ID'];
};


export type GQueryPublicDockBookingArgs = {
  referenceNumber: Scalars['String'];
};


export type GQueryPublicDockCheckInLookupArgs = {
  reference: Scalars['String'];
};


export type GQueryPublicDockDisplayArgs = {
  dockId: Scalars['ID'];
};


export type GQueryPublicDockOpenVisitsArgs = {
  dockId?: InputMaybe<Scalars['ID']>;
  warehouseId?: InputMaybe<Scalars['ID']>;
};


export type GQueryPublicDockWarehousesArgs = {
  code: Scalars['String'];
};


export type GQueryPublicOverrideSlotsArgs = {
  code: Scalars['String'];
  date: Scalars['ISO8601Date'];
  freightType: GFreightType;
  scacCode?: InputMaybe<Scalars['String']>;
  warehouseId: Scalars['ID'];
};


export type GQueryPublicOverrideVendorArgs = {
  code: Scalars['String'];
};


export type GQueryPutawayPriorityArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sourcePickZoneGroup?: InputMaybe<GPutawayPickZoneGroup>;
  warehouseId: Scalars['ID'];
};


export type GQueryPutawayReportArgs = {
  endDate: Scalars['ISO8601Date'];
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['String']>;
  startDate: Scalars['ISO8601Date'];
  warehouseId: Scalars['ID'];
};


export type GQueryQrScanAnalyticsArgs = {
  qrCodeId: Scalars['ID'];
};


export type GQueryReceivableNotesArgs = {
  locationUuid: Scalars['String'];
};


export type GQueryRecentTransactionSyncsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


export type GQueryRedeliveryStopArgs = {
  input: GRedeliveryStopInput;
};


export type GQueryRfsmartCredentialsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['ID']>>;
  warehouseId: Scalars['ID'];
};


export type GQueryRfsmartPendingRemovalsArgs = {
  warehouseId: Scalars['ID'];
};


export type GQueryRfsmartPooledCredentialsArgs = {
  assigned?: InputMaybe<Scalars['Boolean']>;
  warehouseId: Scalars['ID'];
};


export type GQueryRouteArgs = {
  input: GRouteInput;
};


export type GQueryRoutesArgs = {
  input: GRoutesInput;
};


export type GQueryRoutingImportPlanArgs = {
  input: GRoutingImportPlanInput;
};


export type GQuerySalesPriorityListArgs = {
  categoryId?: InputMaybe<Scalars['ID']>;
  includeSuppressed?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  maxSpendCents?: InputMaybe<Scalars['Int']>;
  minCompositeScore?: InputMaybe<Scalars['Int']>;
  onlyDeprioritized?: InputMaybe<Scalars['Boolean']>;
  repId?: InputMaybe<Scalars['ID']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<GSalesPrioritySortByEnum>;
  suggestedActions?: InputMaybe<Array<GSuggestedActionEnum>>;
  warehouseId?: InputMaybe<Scalars['ID']>;
};


export type GQuerySearchTermImpressionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locationUuid: Scalars['ID'];
};


export type GQuerySearchTermImpressionsGbpArgs = {
  googleLocationName: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
};


export type GQuerySignageOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  subscriptionSessionId?: InputMaybe<Scalars['ID']>;
};


export type GQuerySignedUploadImageByKeyArgs = {
  key: Scalars['String'];
};


export type GQuerySignedUploadImageUrlArgs = {
  extension: Scalars['String'];
};


export type GQuerySquareLocationArgs = {
  profileId: Scalars['String'];
};


export type GQuerySquareTerminalsArgs = {
  accountProfileId: Scalars['ID'];
  squareLocationId?: InputMaybe<Scalars['ID']>;
};


export type GQueryStandaloneVehicleInspectionDrivesArgs = {
  from: Scalars['ISO8601DateTime'];
  to: Scalars['ISO8601DateTime'];
  truckId: Scalars['ID'];
  warehouseId?: InputMaybe<Scalars['ID']>;
};


export type GQueryStandaloneVehicleInspectionReportArgs = {
  id: Scalars['ID'];
};


export type GQueryStandingAppointmentCandidateWindowsArgs = {
  date: Scalars['ISO8601Date'];
  standingAppointmentId: Scalars['ID'];
};


export type GQueryStandingAppointmentDirectoryArgs = {
  warehouseId: Scalars['ID'];
};


export type GQueryStandingAppointmentGapDatesArgs = {
  standingAppointmentId: Scalars['ID'];
};


export type GQueryStandingAppointmentHistoryArgs = {
  netsuiteInternalId: Scalars['String'];
  warehouseId: Scalars['ID'];
};


export type GQueryStandingAppointmentVendorsArgs = {
  search: Scalars['String'];
};


export type GQueryStopArgs = {
  input: GStopInput;
};


export type GQuerySubscriptionSessionArgs = {
  id: Scalars['ID'];
};


export type GQuerySupplierInvoiceComparisonArgs = {
  odekoUuid: Scalars['ID'];
};


export type GQuerySupplyCartArgs = {
  locationId: Scalars['ID'];
};


export type GQueryTopSubcategoriesPerWarehouseArgs = {
  warehouseId?: InputMaybe<Scalars['ID']>;
};


export type GQueryTransactionSyncLocationSearchArgs = {
  term: Scalars['String'];
};


export type GQueryUnitByIdArgs = {
  id: Scalars['ID'];
};


export type GQueryUnitByNameArgs = {
  name: Scalars['String'];
};


export type GQueryUnitsArgs = {
  sortOrder?: InputMaybe<Array<InputMaybe<GUnitSortOrder>>>;
  unitType?: InputMaybe<GUnitType>;
};


export type GQueryUserPlatformConnectionArgs = {
  platformId: GPlatformIds;
};


export type GQueryUsersArgs = {
  role: Scalars['String'];
};


export type GQueryValidateEmailForSignupArgs = {
  email: Scalars['String'];
};


export type GQueryValidateMicrositeUrlArgs = {
  url: Scalars['String'];
};


export type GQueryVehicleInspectionReportArgs = {
  id: Scalars['ID'];
};


export type GQueryVehicleInspectionReportsArgs = {
  from: Scalars['ISO8601DateTime'];
  to: Scalars['ISO8601DateTime'];
  truckId: Scalars['ID'];
  warehouseId?: InputMaybe<Scalars['ID']>;
};


export type GQueryVehicleInspectionRouteStatusesArgs = {
  from: Scalars['ISO8601DateTime'];
  to: Scalars['ISO8601DateTime'];
  truckId: Scalars['ID'];
  warehouseId?: InputMaybe<Scalars['ID']>;
};


export type GQueryVehicleInspectionStatusArgs = {
  deliveryRouteId: Scalars['ID'];
};


export type GQueryVehicleInspectionTruckStatusesArgs = {
  from: Scalars['ISO8601DateTime'];
  to: Scalars['ISO8601DateTime'];
  warehouseId: Scalars['ID'];
};


export type GQueryVendorArgs = {
  vendorId: Scalars['ID'];
};


export type GQueryVendorOrdersArgs = {
  input: GVendorOrdersInput;
};


export type GQueryVendorReceivingCheckinArgs = {
  input: GVendorReceivingCheckinInput;
};


export type GQueryVendorReceivingListArgs = {
  input: GVendorReceivingListInput;
};


export type GQueryWarehouseArgs = {
  warehouseId: Scalars['ID'];
};


export type GQueryWarehouseBinLayoutArgs = {
  warehouseId: Scalars['ID'];
};


export type GQueryWarehouseBinTransferCommandArgs = {
  id: Scalars['ID'];
};


export type GQueryWarehouseBulkPickedItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  input: GWarehouseBulkPickedItemsInput;
  last?: InputMaybe<Scalars['Int']>;
};


export type GQueryWarehouseCategoryMediansArgs = {
  warehouseId?: InputMaybe<Scalars['ID']>;
};


export type GQueryWarehouseCommitmentDiscrepanciesArgs = {
  deliveryDate: Scalars['ISO8601Date'];
  warehouseId: Scalars['ID'];
};


export type GQueryWarehouseCommitmentDiscrepancyLinesArgs = {
  deliveryDate: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  warehouseId: Scalars['ID'];
};


export type GQueryWarehouseCommitmentSummaryArgs = {
  deliveryDate: Scalars['ISO8601Date'];
  warehouseId: Scalars['ID'];
};


export type GQueryWarehouseCutoffDiscrepanciesArgs = {
  deliveryDate: Scalars['ISO8601Date'];
  warehouseId: Scalars['ID'];
};


export type GQueryWarehouseEcomBulkItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  input: GWarehouseEcomBulkItemsInput;
  last?: InputMaybe<Scalars['Int']>;
};


export type GQueryWarehouseFulfillmentDiscrepancyLinesArgs = {
  deliveryDate: Scalars['ISO8601Date'];
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  warehouseId: Scalars['ID'];
};


export type GQueryWarehouseFulfillmentSummaryArgs = {
  deliveryDate: Scalars['ISO8601Date'];
  warehouseId: Scalars['ID'];
};


export type GQueryWarehouseItemTaskArgs = {
  itemNetsuiteId: Scalars['String'];
  taskTypes: Array<GWarehouseTaskType>;
  warehouseId: Scalars['ID'];
  workstreams?: InputMaybe<Array<GWarehouseTaskWorkstream>>;
};


export type GQueryWarehouseItemTasksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<GWarehouseItemTaskFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  taskTypes: Array<GWarehouseTaskType>;
  warehouseId: Scalars['ID'];
};


export type GQueryWarehouseLayoutBuilderArgs = {
  warehouseId: Scalars['ID'];
};


export type GQueryWarehouseRoutesSyncStatusArgs = {
  nightEnd: Scalars['ISO8601Date'];
  warehouseId: Scalars['ID'];
};


export type GQueryWarehouseSourceBinArgs = {
  binName: Scalars['String'];
  warehouseId: Scalars['ID'];
};


export type GQueryWarehouseStageGateOrderLinesArgs = {
  deliveryDate: Scalars['ISO8601Date'];
  step: GStageGateStep;
  warehouseId: Scalars['ID'];
};


export type GQueryWarehouseSubcategoryThresholdsArgs = {
  warehouseId?: InputMaybe<Scalars['ID']>;
};


export type GQueryWarehouseTasksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<GWarehouseTaskFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  taskTypes: Array<GWarehouseTaskType>;
  warehouseId: Scalars['ID'];
};


export type GQueryWarehouseTrendsArgs = {
  endDate: Scalars['ISO8601Date'];
  startDate: Scalars['ISO8601Date'];
  warehouseId: Scalars['ID'];
};


export type GQueryWorkThreadArgs = {
  id: Scalars['ID'];
};


export type GQueryWorkThreadsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

/** Different time periods for leaderboard rankings */
export enum GRankingPeriodEnum {
  /** All-time rankings */
  AllTime = 'ALL_TIME',
  /** Current day rankings */
  Daily = 'DAILY',
  /** Current month rankings */
  Monthly = 'MONTHLY',
  /** Current week rankings */
  Weekly = 'WEEKLY'
}

export type GRating = {
  __typename?: 'Rating';
  allTime?: Maybe<Scalars['Float']>;
  current?: Maybe<Scalars['Float']>;
};

/** An edge in a connection. */
export type GReachedLocationEdge = {
  __typename?: 'ReachedLocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GLocation>;
};

/** The connection type for Location. */
export type GReachedLocationsConnection = {
  __typename?: 'ReachedLocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GReachedLocationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GLocation>>>;
  /** Information to aid in pagination. */
  pageInfo: GPageInfo;
  /** The total count of records in the connection. */
  totalCount: Scalars['Int'];
};

/** Autogenerated input type of RebuildCartFromPastOrder */
export type GRebuildCartFromPastOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Opaque token identifying a specific version of the cart. */
  fingerprint: Scalars['String'];
  /** The order's primary key from the database. */
  orderDatabaseId: Scalars['Int'];
};

/** Autogenerated return type of RebuildCartFromPastOrder */
export type GRebuildCartFromPastOrderPayload = {
  __typename?: 'RebuildCartFromPastOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to rebuild cart from past order. */
  result: GCartResult;
};

/** Autogenerated input type of RecalculateCartPrices */
export type GRecalculateCartPricesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Opaque token identifying a specific version of the cart. */
  fingerprint: Scalars['String'];
  /** Intended payment method. This affects service fee. */
  paymentMethod: GPaymentMethod;
};

/** Autogenerated return type of RecalculateCartPrices */
export type GRecalculateCartPricesPayload = {
  __typename?: 'RecalculateCartPricesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to set tip. */
  result: GCartResult;
};

export type GReceivableNote = {
  __typename?: 'ReceivableNote';
  authorEmail: Scalars['String'];
  authorId: Scalars['String'];
  body: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  invoiceUuid?: Maybe<Scalars['String']>;
  locationUuid: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type GRecentDeliveriesPresent = GUserErrorInterface & {
  __typename?: 'RecentDeliveriesPresent';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  offenders: Array<GRecentDeliveryLocation>;
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** A location that recently took a delivery on a driven route, and the evidence. */
export type GRecentDeliveryLocation = {
  __typename?: 'RecentDeliveryLocation';
  lastNightEnd?: Maybe<Scalars['ISO8601Date']>;
  locationId: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  stopCount: Scalars['Int'];
};

export type GRecipe = {
  __typename?: 'Recipe';
  id: Scalars['ID'];
  ingredients: Array<GRecipeIngredient>;
  menuItemSizeUuid: Scalars['ID'];
  menuItemUuid: Scalars['ID'];
};

export type GRecipeIngredient = {
  __typename?: 'RecipeIngredient';
  id: Scalars['ID'];
  ingredientId: Scalars['ID'];
  ingredientType: GIngredientTypeEnum;
  quantity: Scalars['Float'];
  unit: GUnit;
};

export type GRecipeIngredientInput = {
  /** ID of ingredient */
  ingredientId: Scalars['ID'];
  /** Type of ingredient */
  ingredientType: GIngredientTypeEnum;
  /** Quantity portion of how much was used of ingredient */
  quantity: Scalars['Float'];
  /** ID of unit portion of how much was used of ingredient */
  unit: Scalars['ID'];
};

export enum GRecipientPhoneAvailability {
  /** The recipient number is available to contact. */
  Available = 'AVAILABLE',
  /** The recipient has not allowed after-hours contact. */
  HiddenAfterHours = 'HIDDEN_AFTER_HOURS',
  /** No recipient number has been provided. */
  NotProvided = 'NOT_PROVIDED'
}

export type GRecipientPhoneNumber = {
  __typename?: 'RecipientPhoneNumber';
  availability: GRecipientPhoneAvailability;
  number?: Maybe<Scalars['String']>;
};

export enum GRecommendationFeedbackReason {
  DifferentSupplier = 'DIFFERENT_SUPPLIER',
  DontCarry = 'DONT_CARRY',
  NotRunningLow = 'NOT_RUNNING_LOW',
  Other = 'OTHER',
  PriceTooHigh = 'PRICE_TOO_HIGH'
}

export enum GRecommendationFeedbackType {
  Permanent = 'PERMANENT',
  Temporary = 'TEMPORARY'
}

export type GReconciledOrderLine = {
  __typename?: 'ReconciledOrderLine';
  id: Scalars['ID'];
  imageUrls?: Maybe<Array<Scalars['String']>>;
  oosOrderUnitQuantity?: Maybe<Scalars['Int']>;
  reasons?: Maybe<Array<Scalars['String']>>;
  updatedOrderUnitQuantity?: Maybe<Scalars['Int']>;
};

/** Autogenerated input type of RecordDriverLocationPings */
export type GRecordDriverLocationPingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Route the fixes were recorded on. */
  deliveryRouteId: Scalars['ID'];
  /** Batch of location fixes drained from the device's offline queue. */
  pings: Array<GDriverLocationPingInput>;
};

/** Autogenerated return type of RecordDriverLocationPings. */
export type GRecordDriverLocationPingsPayload = {
  __typename?: 'RecordDriverLocationPingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Number of new pings persisted (duplicates from offline-queue replay are skipped). */
  recordedCount: Scalars['Int'];
  userErrors: Array<GUserError>;
};

/** Autogenerated input type of RecordManualBinTransfer */
export type GRecordManualBinTransferInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Destination bin display name, as printed on the bin label. */
  destinationBinName: Scalars['String'];
  idempotencyKey: Scalars['ID'];
  /** InventoryItem id the lot was listed for, as passed to warehouseSourceBin.lots. */
  inventoryItemId: Scalars['ID'];
  /** Lot id from warehouseSourceBin.lots. */
  lotId: Scalars['ID'];
  /** Quantity to move, in the item's NetSuite stock unit, as a decimal string such as "15.0". */
  stockUnitQuantity: Scalars['String'];
};

/** Autogenerated return type of RecordManualBinTransfer. */
export type GRecordManualBinTransferPayload = {
  __typename?: 'RecordManualBinTransferPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  command?: Maybe<GWarehouseBinTransferCommand>;
  userErrors: Array<GUserError>;
};

/** Autogenerated input type of RecordReplenishmentPick */
export type GRecordReplenishmentPickInput = {
  /**
   * Move more than the task still needs, including onto a covered task. The
   * quantity is still capped by what the source bin holds.
   */
  allowExtra?: InputMaybe<Scalars['Boolean']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Destination bin NetSuite internal id. Provide this or destinationBinName, not both. */
  destinationBinInternalId?: InputMaybe<Scalars['String']>;
  /** Destination bin display name, as printed on the bin label. Provide this or destinationBinInternalId, not both. */
  destinationBinName?: InputMaybe<Scalars['String']>;
  idempotencyKey: Scalars['ID'];
  /** Lot of the chosen source option. Required when the bin holds more than one lot of the item. */
  inventoryNumberNetsuiteId?: InputMaybe<Scalars['String']>;
  /** NetSuite id of the reserve bin the stock is pulled from, one of the task's source options. */
  sourceBinNetsuiteId: Scalars['String'];
  /** Quantity to move, in the item's NetSuite stock unit (not purchase cases or eaches), as a decimal string such as "15.0". */
  stockUnitQuantity: Scalars['String'];
  /** ReplenTask id from the warehouseTasks query. */
  taskId: Scalars['ID'];
  /** The windowDays the task was listed with, so it is checked against the same demand. Defaults to 3 when omitted. */
  windowDays?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of RecordReplenishmentPick. */
export type GRecordReplenishmentPickPayload = {
  __typename?: 'RecordReplenishmentPickPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  command?: Maybe<GWarehouseBinTransferCommand>;
  userErrors: Array<GUserError>;
};

export type GRecoveryQuantityOutOfRange = GUserErrorInterface & {
  __typename?: 'RecoveryQuantityOutOfRange';
  /** The recovery_quantity value the client tried to write. */
  attempted: Scalars['Int'];
  errorCode: Scalars['String'];
  /** Inclusive upper bound of the valid range. The valid range for recovery_quantity is [0, maxAllowed]. */
  maxAllowed: Scalars['Int'];
  /** A description of the error */
  message: Scalars['String'];
  /** The order line whose recovery_quantity write was rejected. */
  orderLineId: Scalars['ID'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GRedelivery = {
  __typename?: 'Redelivery';
  /** The time the driver arrived at the stop */
  arrivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  attachments?: Maybe<Array<GAttachment>>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']>;
  compostCollectedAt?: Maybe<Scalars['ISO8601DateTime']>;
  compostCollectionRequired?: Maybe<Scalars['Boolean']>;
  /** Every geofence enter/exit crossing recorded for the stop, oldest first (admin only; empty list for other callers). */
  crossingEvents: Array<GStopCrossingEvent>;
  deliveryNote?: Maybe<Scalars['String']>;
  /** Redelivery stop status used in the driver app. Compares delivered quantity to ordered quantity. */
  deliveryStatus: GDeliveryStatus;
  /** stop status used in the DMP */
  deliveryStatusDmp: GDeliveryStatusDmp;
  /** Redelivery stop status used in the driver app. Compares delivered quantity to fulfilled quantity. */
  deliveryStatusDriver: GDeliveryStatusDriver;
  deliveryStop: GDelivery;
  /** The time the driver departed from the stop */
  departedAt?: Maybe<Scalars['ISO8601DateTime']>;
  donationCollectedAt?: Maybe<Scalars['ISO8601DateTime']>;
  donationRequired?: Maybe<Scalars['Boolean']>;
  /** Seconds the driver was stopped (departed_at - arrived_at), or null if either is missing */
  dwellSeconds?: Maybe<Scalars['Int']>;
  hasRepeatedAccessIssues: Scalars['Boolean'];
  id: Scalars['ID'];
  issues?: Maybe<Array<GIssue>>;
  location?: Maybe<GLocation>;
  orders?: Maybe<Array<GOrder>>;
  /**
   * This redelivery stop's order on a third-party provider, from the newest
   * dispatch that has a row for it. Null for a stop no provider has been given.
   */
  providerDelivery?: Maybe<GProviderDelivery>;
  reminderMessage?: Maybe<Scalars['String']>;
  /** Repeated access issue descriptions */
  repeatedAccessIssues: Array<Scalars['String']>;
  /** The latest time the driver was detected leaving the stop again after completion, if they returned */
  returnedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** How many times the driver returned to the stop after completing it */
  revisitCount: Scalars['Int'];
  route: GRoute;
  sequenceNumber?: Maybe<Scalars['String']>;
  upsellNote?: Maybe<Scalars['String']>;
  viewedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Enter/exit crossings paired into visits with per-visit dwell, oldest first (admin only; empty list for other callers). */
  visits: Array<GStopVisit>;
};

/** Autogenerated input type of RedeliveryStopCreate */
export type GRedeliveryStopCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Redelivery night end. */
  nightEnd: Scalars['ISO8601Date'];
  /** ID of the stops to create redeliveries. */
  stopIds: Array<Scalars['ID']>;
  /** Warehouse id. */
  warehouseId: Scalars['ID'];
};

/** Autogenerated return type of RedeliveryStopCreate. */
export type GRedeliveryStopCreatePayload = {
  __typename?: 'RedeliveryStopCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  redeliveryStops?: Maybe<Array<GRedelivery>>;
  userErrors: Array<GRedeliveryStopError>;
};

/** Autogenerated input type of RedeliveryStopDelete */
export type GRedeliveryStopDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Redelivery stop id. */
  id: Scalars['ID'];
};

/** Autogenerated return type of RedeliveryStopDelete. */
export type GRedeliveryStopDeletePayload = {
  __typename?: 'RedeliveryStopDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userErrors: Array<GDeliveryRouteStopError>;
};

/** Redelivery stop possible error types */
export type GRedeliveryStopError = GInvalidNightEnd | GStopWithProvider | GStopsBusy;

export type GRedeliveryStopInput = {
  id: Scalars['ID'];
};

export enum GRefrigerationState {
  Frozen = 'FROZEN',
  Refrigerated = 'REFRIGERATED',
  RoomTemp = 'ROOM_TEMP'
}

/** Error indicating a request attempted to refund too many items. */
export type GRefundingTooManyItems = GError & {
  __typename?: 'RefundingTooManyItems';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating a request attempted to refund too many modifiers. */
export type GRefundingTooManyModifiers = GError & {
  __typename?: 'RefundingTooManyModifiers';
  /** A description of the error. */
  message: Scalars['String'];
};

export type GRelativeTime = {
  __typename?: 'RelativeTime';
  /** Seconds. */
  seconds: Scalars['Int'];
};

export type GRelativeTimeInput = {
  /** Seconds. */
  seconds: Scalars['Int'];
};

/** Autogenerated input type of RemoveAllFromCart */
export type GRemoveAllFromCartInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Opaque token identifying a specific version of the cart. */
  fingerprint: Scalars['String'];
};

/** Autogenerated return type of RemoveAllFromCart */
export type GRemoveAllFromCartPayload = {
  __typename?: 'RemoveAllFromCartPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to remove items from the cart. */
  result: GCartResult;
};

/** Input for removing an item from the cart. */
export type GRemoveCartItemInput = {
  /** CartItem ID */
  cartItemId: Scalars['ID'];
};

/** Autogenerated input type of RemoveCustomerTagMutation */
export type GRemoveCustomerTagMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Odeko UUID of the location to remove the tag from. */
  locationId: Scalars['ID'];
  /** Id of the tag to remove, as returned by CustomerTag.id. */
  tagId: Scalars['ID'];
};

/** Autogenerated return type of RemoveCustomerTagMutation. */
export type GRemoveCustomerTagMutationPayload = {
  __typename?: 'RemoveCustomerTagMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  location?: Maybe<GLocation>;
};

/** Autogenerated input type of RemoveFavoriteConsumerOrder */
export type GRemoveFavoriteConsumerOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Favorite consumer order ID. */
  favoriteConsumerOrderId: Scalars['ID'];
};

/** Autogenerated return type of RemoveFavoriteConsumerOrder */
export type GRemoveFavoriteConsumerOrderPayload = {
  __typename?: 'RemoveFavoriteConsumerOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to remove the favorite. */
  result: GFavoriteConsumerOrderResult;
};

/** Autogenerated input type of RemoveItemsFromCart */
export type GRemoveItemsFromCartInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Opaque token identifying a specific version of the cart. */
  fingerprint: Scalars['String'];
  /** Input describing which items to remove. */
  removals: Array<GRemoveCartItemInput>;
};

/** Autogenerated return type of RemoveItemsFromCart */
export type GRemoveItemsFromCartPayload = {
  __typename?: 'RemoveItemsFromCartPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to remove items from the cart. */
  result: GCartResult;
};

/** Autogenerated input type of RemoveLocationItemBackupMutation */
export type GRemoveLocationItemBackupMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** UUID of the item the location orders */
  itemId: Scalars['ID'];
  /** Location UUID */
  locationId: Scalars['ID'];
};

/** Autogenerated return type of RemoveLocationItemBackupMutation. */
export type GRemoveLocationItemBackupMutationPayload = {
  __typename?: 'RemoveLocationItemBackupMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<GUserError>>;
  succeeded: Scalars['Boolean'];
};

export type GRemoveNewItemPinInput = {
  itemId: Scalars['ID'];
  warehouseId: Scalars['ID'];
};

/** Autogenerated input type of RemoveReward */
export type GRemoveRewardInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Opaque token identifying a specific version of the cart. */
  fingerprint: Scalars['String'];
};

/** Autogenerated return type of RemoveReward */
export type GRemoveRewardPayload = {
  __typename?: 'RemoveRewardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to remove reward. */
  result: GCartResult;
};

export type GRemoveSubstitutionOverrideInput = {
  id: Scalars['ID'];
};

export type GReorderNewItemPinInput = {
  itemId: Scalars['ID'];
  position: Scalars['Int'];
};

export type GReorderNewItemPinsInput = {
  /** The full replacement set; subrank is auto-sequenced by order within each position. */
  pins: Array<GReorderNewItemPinInput>;
  warehouseId: Scalars['ID'];
};

/** Task counts for one cohort over the whole cover-days window, before any cohort, zone or task filter. */
export type GReplenCohortCount = {
  __typename?: 'ReplenCohortCount';
  /** Tasks in the cohort that replenCategory CASES_AND_EACHES returns. */
  casesAndEachesCount: Scalars['Int'];
  cohort: GReplenTaskCohort;
  /** Actionable tasks with nothing still short. A blocked task is never counted as covered. */
  coveredCount: Scalars['Int'];
  /**
   * Tasks in the cohort whose item has no usable cases per pallet. Blocked tasks
   * are never counted. A covered task with missing pallet info is counted in both
   * coveredCount and missingInfoCount.
   */
  missingInfoCount: Scalars['Int'];
  /** Blocked tasks in the cohort. */
  needsReviewCount: Scalars['Int'];
  /** Tasks in the cohort that replenCategory PALLETS returns. */
  palletsCount: Scalars['Int'];
  /** Tasks in the cohort that replenCategory RECENTLY_MOVED returns, covered ones included. */
  recentlyMovedCount: Scalars['Int'];
  /** Every task in the cohort, covered or blocked included. */
  totalCount: Scalars['Int'];
};

export type GReplenTask = GWarehouseTask & {
  __typename?: 'ReplenTask';
  cohort: GReplenTaskCohort;
  destinationBinNames: Array<Scalars['String']>;
  destinationBins: Array<GReplenTaskDestinationBin>;
  /**
   * Eaches in one purchase case, as a decimal string; 1 for an each-only item.
   * Null when the item's unit configuration is missing or invalid. Present on
   * every task, including blocked ones.
   */
  eachesPerCase?: Maybe<Scalars['String']>;
  /**
   * A replenishment trip was recorded for this task today, in warehouse-local
   * time, and not undone, whether or not NetSuite has confirmed it yet. False on a
   * task covered only by another task's trip.
   */
  hasTripToday: Scalars['Boolean'];
  id: Scalars['ID'];
  /** Federated entity reference; name, UPC codes and refrigeration state resolve in the owning subgraph. */
  inventoryItem?: Maybe<GInventoryItem>;
  isBulk: Scalars['Boolean'];
  item?: Maybe<GWarehouseTaskItem>;
  /**
   * Null when the footprint could not be computed. See statusReason, which may
   * name a different blocker first. Present, with casesPerPallet null, when only
   * the item's pallet setup is missing.
   */
  palletFootprint?: Maybe<GReplenTaskPalletFootprint>;
  /**
   * The item has no usable cases per pallet. Informational: the task stays
   * actionable, since a move never needs pallets. False for a blocked task, whose
   * statusReason is what needs review.
   */
  palletInfoMissing: Scalars['Boolean'];
  /** Already covered by bin transfers in progress. In the item's stock unit, as a decimal string. */
  quantityInFlight: Scalars['String'];
  /** On-hand in the routed zones. In the item's stock unit, as a decimal string. */
  quantityOnhand: Scalars['String'];
  /** Demand still to be met. In the item's stock unit, as a decimal string. */
  quantityRemaining: Scalars['String'];
  /** Quantity to replenish. In the item's stock unit, as a decimal string. */
  quantityReplen: Scalars['String'];
  /**
   * Quantity to replenish. In NetSuite base units (the stock-unit figure times the
   * item's stock-unit conversion), as a decimal string. Null when the item has no
   * valid stock-unit conversion.
   */
  quantityReplenBaseUnits?: Maybe<Scalars['String']>;
  /** Quantity to replenish less what is in flight, never below zero. In the item's stock unit, as a decimal string. */
  quantityStillShort: Scalars['String'];
  /**
   * Quantity still short. In NetSuite base units (the stock-unit figure times the
   * item's stock-unit conversion), as a decimal string. Null when the item has no
   * valid stock-unit conversion.
   */
  quantityStillShortBaseUnits?: Maybe<Scalars['String']>;
  routedZoneNetsuiteIds: Array<Scalars['String']>;
  /** Reserve bins to pick from, in the calculation's FEFO order. */
  sourceOptions: Array<GReplenTaskSourceOption>;
  state: GWarehouseTaskState;
  statusReason?: Maybe<GWarehouseTaskStatusReason>;
  /**
   * Base units in one stock unit, as a decimal string. Null when the item has no
   * valid conversion. Present on every task, including blocked ones, unlike
   * palletFootprint.
   */
  stockUnitConversion?: Maybe<Scalars['String']>;
  taskType: GWarehouseTaskType;
  workstream: GWarehouseTaskWorkstream;
};

/** The Replenishment worklist's second filter row. Missing info is its own filter, replenMissingInfo. */
export enum GReplenTaskCategory {
  /**
   * Something still short, but less than a full pallet, or an item with no case.
   * Never a task that needs review or is missing pallet info.
   */
  CasesAndEaches = 'CASES_AND_EACHES',
  /** At least one full pallet still short. Never a task that needs review or is missing pallet info. */
  Pallets = 'PALLETS',
  /**
   * A replenishment trip today, in warehouse-local time, accepted by NetSuite and
   * not undone. A task the trip fully covered stays, covered, for the rest of the
   * day while its item still has open orders in the window.
   */
  RecentlyMoved = 'RECENTLY_MOVED'
}

export enum GReplenTaskCohort {
  Bulk = 'BULK',
  EcomBulk = 'ECOM_BULK',
  Pallet = 'PALLET',
  Standard = 'STANDARD'
}

export type GReplenTaskDestinationBin = {
  __typename?: 'ReplenTaskDestinationBin';
  /**
   * On-hand of this item in the bin, in stock units, as a decimal string. Null
   * when the bin did not resolve, so the on-hand is unknown.
   */
  currentQuantity?: Maybe<Scalars['String']>;
  /**
   * True when the bin holds no on-hand of this item. Also true when the bin did
   * not resolve and its on-hand is unknown, so check netsuiteInternalId to tell the two apart.
   */
  empty: Scalars['Boolean'];
  /**
   * True when the bin has stock of other items. Says nothing about room. False
   * when the bin did not resolve, so its contents are unknown.
   */
  holdsOtherItems: Scalars['Boolean'];
  name: Scalars['String'];
  /** Null when the destination name did not resolve to an active bin; the destination is still listed. */
  netsuiteInternalId?: Maybe<Scalars['String']>;
};

/**
 * Informational only: how the task's full shortage (quantityReplen) breaks into
 * pallets. It is not part of the shortage arithmetic, and it ignores what is
 * already in flight: the connection's remainingPalletCount counts pallets of
 * quantityStillShort, so the two differ for a partly covered task. A case is the
 * item's purchase unit, as in putaway.
 */
export type GReplenTaskPalletFootprint = {
  __typename?: 'ReplenTaskPalletFootprint';
  /** The full shortage (quantityReplen), in base units. */
  baseUnitQuantity: Scalars['String'];
  /** The full shortage (quantityReplen), in purchase cases. */
  caseQuantity: Scalars['String'];
  /** Purchase cases per layer. Null when not configured. */
  casesPerLayer?: Maybe<Scalars['Int']>;
  /**
   * Purchase cases per pallet. Null for an each-only item, which has no pallet
   * configuration, and when the item's pallet setup is missing.
   */
  casesPerPallet?: Maybe<Scalars['Int']>;
  /** Eaches in one purchase case; 1 for an each-only item. */
  eachesPerCase: Scalars['String'];
  /** Purchase cases on the whole pallets. */
  fullPalletCaseQuantity: Scalars['String'];
  /** Whole pallets in the quantity; 0 for an each-only item or when the pallet setup is missing. */
  fullPalletCount: Scalars['Int'];
  /** Layers per pallet. Null when not configured. */
  layersPerPallet?: Maybe<Scalars['Int']>;
  /** Purchase cases left after the whole pallets; the whole quantity for an each-only item or when the pallet setup is missing. */
  remainderCaseQuantity: Scalars['String'];
  /** Base units in one stock unit. */
  stockUnitConversion: Scalars['String'];
};

export type GReplenTaskSourceOption = {
  __typename?: 'ReplenTaskSourceOption';
  binName?: Maybe<Scalars['String']>;
  binNetsuiteId: Scalars['String'];
  expirationDate?: Maybe<Scalars['ISO8601Date']>;
  inventoryNumberNetsuiteId?: Maybe<Scalars['String']>;
  lotNumber?: Maybe<Scalars['String']>;
  /** Stock units in this bin and lot, as a decimal string. */
  quantity: Scalars['String'];
};

/** A replenishment trip that can be shown on a task's Edit sheet. */
export type GReplenishmentTrip = {
  __typename?: 'ReplenishmentTrip';
  /**
   * False while the trip is still being confirmed or replenishment transfers are
   * off for the warehouse. True does not guarantee the undo: it can still be
   * refused, for example when the stock has already left the destination bin.
   */
  canUndo: Scalars['Boolean'];
  command: GWarehouseBinTransferCommand;
};

/** Autogenerated input type of ReportPhoneNumberVerification */
export type GReportPhoneNumberVerificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Phone number in E.164 format, but without the "+" prefix. E.g. "15551231234". */
  phoneNumber: Scalars['String'];
  /** Phone verification code. */
  phoneVerificationCode: Scalars['String'];
};

/** Autogenerated return type of ReportPhoneNumberVerification */
export type GReportPhoneNumberVerificationPayload = {
  __typename?: 'ReportPhoneNumberVerificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to report phone number verification. */
  result: GReportPhoneNumberVerificationResult;
};

/** Result of attempting to report phone number verification. */
export type GReportPhoneNumberVerificationResult = GErrorsResult | GPhoneNumberVerified;

/** Autogenerated input type of ReportPutawayException */
export type GReportPutawayExceptionInput = {
  /** Recommended destination bin name, recorded verbatim. */
  binName?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** NetSuite item internal id, recorded verbatim for reviewers. */
  itemInternalId?: InputMaybe<Scalars['String']>;
  /** Item display title, recorded verbatim. */
  itemTitle?: InputMaybe<Scalars['String']>;
  /** Lot number, recorded verbatim. */
  lotNumber?: InputMaybe<Scalars['String']>;
  /** Free-form description; required when the reason is other. */
  note?: InputMaybe<Scalars['String']>;
  /** Why the putaway failed. */
  reasonCode: GPutawayExceptionReason;
  /** WarehouseTask id from the warehouseTasks query, recorded verbatim. */
  taskId: Scalars['ID'];
  /** Warehouse where the exception was reported. */
  warehouseId: Scalars['ID'];
};

/** Autogenerated return type of ReportPutawayException. */
export type GReportPutawayExceptionPayload = {
  __typename?: 'ReportPutawayExceptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  report?: Maybe<GPutawayExceptionReport>;
  userErrors: Array<GUserError>;
};

/** Autogenerated input type of ReportPutawayPalletBuildCorrection */
export type GReportPutawayPalletBuildCorrectionInput = {
  /** Corrected cases per pallet layer. */
  casesPerLayer: Scalars['Int'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Inventory item id (IMS item uuid). */
  itemId: Scalars['ID'];
  /** NetSuite item internal id, recorded verbatim for reviewers. */
  itemInternalId?: InputMaybe<Scalars['String']>;
  /** Corrected layers per pallet. */
  layersPerPallet: Scalars['Int'];
  /** Warehouse where the correction was reported. */
  warehouseId: Scalars['ID'];
};

/** Autogenerated return type of ReportPutawayPalletBuildCorrection. */
export type GReportPutawayPalletBuildCorrectionPayload = {
  __typename?: 'ReportPutawayPalletBuildCorrectionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  report?: Maybe<GPutawayPalletBuildReport>;
  userErrors: Array<GUserError>;
};

/** Autogenerated input type of RequestS3Upload */
export type GRequestS3UploadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The full path of the file to be uploaded to S3, like 'path/to/file.jpg'. It should not start with a slash. */
  filePath: Scalars['String'];
  /** The ID of the microsite location this image belongs to */
  micrositeLocationId: Scalars['ID'];
};

/** Autogenerated return type of RequestS3Upload. */
export type GRequestS3UploadPayload = {
  __typename?: 'RequestS3UploadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  fileUrl: Scalars['String'];
  uploadUrl: Scalars['String'];
};

/** Autogenerated input type of RequestSampleMutation */
export type GRequestSampleMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The requested delivery date for the sample */
  deliveryDate: Scalars['ISO8601Date'];
  /** UUID of the catalog item whose sample is requested */
  itemId: Scalars['ID'];
  /** UUID of the location requesting the sample */
  locationId: Scalars['ID'];
};

/** Autogenerated return type of RequestSampleMutation. */
export type GRequestSampleMutationPayload = {
  __typename?: 'RequestSampleMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GError>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of RequestSupplierInvoiceReadUrl */
export type GRequestSupplierInvoiceReadUrlInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  supplierInvoiceId: Scalars['ID'];
};

/** Autogenerated return type of RequestSupplierInvoiceReadUrl. */
export type GRequestSupplierInvoiceReadUrlPayload = {
  __typename?: 'RequestSupplierInvoiceReadUrlPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  file?: Maybe<GSupplierInvoiceFile>;
  readUrl?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of RequoteProviderRoute */
export type GRequoteProviderRouteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /**
   * When the courier should collect, on the route's night; for an escalation, from
   * today through the route's night. Omitted or null means ASAP.
   */
  pickupAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The marked route to re-quote. */
  routeId: Scalars['ID'];
};

/** Autogenerated return type of RequoteProviderRoute. */
export type GRequoteProviderRoutePayload = {
  __typename?: 'RequoteProviderRoutePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  route?: Maybe<GRoute>;
  userErrors: Array<GThirdPartyDispatchError>;
};

/** Autogenerated input type of ResolveProvisionalOrderLineMutation */
export type GResolveProvisionalOrderLineMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  expectedVersion: Scalars['Int'];
  /** The item uuid. */
  itemId: Scalars['ID'];
  lineId: Scalars['ID'];
  provisionalOrderId: Scalars['ID'];
  remember?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of ResolveProvisionalOrderLineMutation. */
export type GResolveProvisionalOrderLineMutationPayload = {
  __typename?: 'ResolveProvisionalOrderLineMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GProvisionalOrderError>;
  provisionalOrder?: Maybe<GProvisionalOrder>;
};

/** Autogenerated input type of RestoreLocation */
export type GRestoreLocationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  locationId: Scalars['ID'];
};

/** Autogenerated return type of RestoreLocation. */
export type GRestoreLocationPayload = {
  __typename?: 'RestoreLocationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GUserError>;
  success: Scalars['Boolean'];
};

export type GReview = {
  __typename?: 'Review';
  author?: Maybe<Scalars['String']>;
  authorReviewsUrl?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  /** Google Reviews API resource id (e.g. 'ABCdefGHIjkl') */
  id: Scalars['ID'];
  profilePhotoUrl?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
  response?: Maybe<Scalars['String']>;
  /** suggested vs. published, depending on which response is shown */
  responseType: Scalars['String'];
  review?: Maybe<Scalars['String']>;
  sentiment?: Maybe<Scalars['String']>;
};

export type GReviewConfirmationMismatch = GUserErrorInterface & {
  __typename?: 'ReviewConfirmationMismatch';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /**
   * Lines whose recovery_quantity exceeds the recoverable shortfall (more marked
   * for recovery than was left undelivered). Caller should highlight these in the DMP UI.
   */
  mismatchedLines: Array<GMismatchedOrderLine>;
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GReviewResponse = {
  __typename?: 'ReviewResponse';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  replyId: Scalars['String'];
  responseText: Scalars['String'];
  reviewId: Scalars['String'];
  /** Google's update time for the review response */
  updateTime: Scalars['ISO8601DateTime'];
  updatedAt: Scalars['ISO8601DateTime'];
  userId: Scalars['String'];
};

export type GReviewSentiments = {
  __typename?: 'ReviewSentiments';
  negative: Array<Scalars['String']>;
  positive: Array<Scalars['String']>;
};

/** Reward. */
export type GReward = GNode & {
  __typename?: 'Reward';
  /** Whether reward should be applied automatically upon visiting checkout. */
  autoApply: Scalars['Boolean'];
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
  /** Scope the reward applies to. */
  scope: GRewardScope;
  /** Title. */
  title: Scalars['String'];
};

/** Error indicating a reward could not be claimed because the user has already claimed it. */
export type GRewardAlreadyClaimed = GError & {
  __typename?: 'RewardAlreadyClaimed';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating a reward could not be applied because the user has already used it. */
export type GRewardAlreadyUsed = GError & {
  __typename?: 'RewardAlreadyUsed';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating that no reward was found with the provided reward code. */
export type GRewardCodeNotFound = GError & {
  __typename?: 'RewardCodeNotFound';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating the a reward is not applicable. */
export type GRewardNotApplicable = GError & {
  __typename?: 'RewardNotApplicable';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Reward mutation result. */
export type GRewardResult = GErrorsResult | GRewardSuccess;

/** The possible reward scopes. */
export enum GRewardScope {
  /** Reward can be applied to the entire cart. */
  Cart = 'cart',
  /** Reward can be applied to a single item. */
  Item = 'item',
  /** Reward, when claimed, increases wallet balance. */
  Wallet = 'wallet'
}

/** Result of a successful reward mutation. */
export type GRewardSuccess = {
  __typename?: 'RewardSuccess';
  /** Reward. */
  reward: GReward;
};

export type GRfsmartCredential = {
  __typename?: 'RfsmartCredential';
  /** Holder's ARMHR employee code (identity-spine join key). */
  associateId?: Maybe<Scalars['String']>;
  /** Current holder (WarehouseAssociate id); null for an unassigned pool account. */
  employeeId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  kind: GRfsmartCredentialKind;
  /** RF-SMART login; today the employee's NetSuite email. */
  login: Scalars['String'];
  /** Holder's full name. */
  name?: Maybe<Scalars['String']>;
  /** Optional reason recorded with the removal request or completion. */
  removalNote?: Maybe<Scalars['String']>;
  /** When an admin flagged this credential for manual removal in RF-SMART; null when not pending. */
  removalRequestedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Auth0 sub of the admin who flagged it. */
  removalRequestedBy?: Maybe<Scalars['String']>;
  /** When the password was last set or changed. */
  rotatedAt: Scalars['ISO8601DateTime'];
  /** Auth0 sub of the last admin to change the row. */
  updatedBy?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of RfsmartCredentialAssign */
export type GRfsmartCredentialAssignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  credentialId: Scalars['ID'];
  employeeId: Scalars['ID'];
  /**
   * Rotates the account's password with the assignment. Without one, every badge
   * previously printed for this account stays valid.
   */
  password?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of RfsmartCredentialAssign. */
export type GRfsmartCredentialAssignPayload = {
  __typename?: 'RfsmartCredentialAssignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  credential?: Maybe<GRfsmartCredential>;
  userErrors: Array<GProcessPathError>;
};

export enum GRfsmartCredentialKind {
  /** One employee's own account, never reassigned. */
  Individual = 'individual',
  /** A warehouse account reassigned between agency temps — the only kind that can be unassigned. */
  Pool = 'pool'
}

/** Autogenerated input type of RfsmartCredentialRemovalCancel */
export type GRfsmartCredentialRemovalCancelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The credential itself. Required when the account has no holder. Provide exactly one of employeeId or credentialId. */
  credentialId?: InputMaybe<Scalars['ID']>;
  /** The associate holding the credential. Provide exactly one of employeeId or credentialId. */
  employeeId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of RfsmartCredentialRemovalCancel. */
export type GRfsmartCredentialRemovalCancelPayload = {
  __typename?: 'RfsmartCredentialRemovalCancelPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  credential?: Maybe<GRfsmartCredential>;
  userErrors: Array<GProcessPathError>;
};

/** Autogenerated input type of RfsmartCredentialRemovalComplete */
export type GRfsmartCredentialRemovalCompleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The credential itself. Required when the account has no holder. Provide exactly one of employeeId or credentialId. */
  credentialId?: InputMaybe<Scalars['ID']>;
  /** The associate holding the credential. Provide exactly one of employeeId or credentialId. */
  employeeId?: InputMaybe<Scalars['ID']>;
  /** Optional completion note; replaces the request's note when given. */
  note?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of RfsmartCredentialRemovalComplete. */
export type GRfsmartCredentialRemovalCompletePayload = {
  __typename?: 'RfsmartCredentialRemovalCompletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  credential?: Maybe<GRfsmartCredential>;
  userErrors: Array<GProcessPathError>;
};

/** Autogenerated input type of RfsmartCredentialRemovalRequest */
export type GRfsmartCredentialRemovalRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The credential itself. Required when the account has no holder. Provide exactly one of employeeId or credentialId. */
  credentialId?: InputMaybe<Scalars['ID']>;
  /** The associate holding the credential. Provide exactly one of employeeId or credentialId. */
  employeeId?: InputMaybe<Scalars['ID']>;
  /** Optional reason; shown on the pending queue and recorded on the audit version. */
  note?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of RfsmartCredentialRemovalRequest. */
export type GRfsmartCredentialRemovalRequestPayload = {
  __typename?: 'RfsmartCredentialRemovalRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  credential?: Maybe<GRfsmartCredential>;
  userErrors: Array<GProcessPathError>;
};

/** Autogenerated input type of RfsmartCredentialSet */
export type GRfsmartCredentialSetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['ID'];
  login: Scalars['String'];
  /** Required when creating; optional on update, so a login correction is not a rotation. */
  password?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of RfsmartCredentialSet. */
export type GRfsmartCredentialSetPayload = {
  __typename?: 'RfsmartCredentialSetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  credential?: Maybe<GRfsmartCredential>;
  userErrors: Array<GProcessPathError>;
};

/** Autogenerated input type of RfsmartCredentialSetPool */
export type GRfsmartCredentialSetPoolInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The pool account to edit. Required when correcting a login. */
  credentialId?: InputMaybe<Scalars['ID']>;
  /** The RF-SMART login. Required when adding an account; omitting it leaves the stored login unchanged. */
  login?: InputMaybe<Scalars['String']>;
  /** The RF-SMART password. Required when adding an account; omitting it leaves the stored password unchanged. */
  password?: InputMaybe<Scalars['String']>;
  warehouseId: Scalars['ID'];
};

/** Autogenerated return type of RfsmartCredentialSetPool. */
export type GRfsmartCredentialSetPoolPayload = {
  __typename?: 'RfsmartCredentialSetPoolPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  credential?: Maybe<GRfsmartCredential>;
  userErrors: Array<GProcessPathError>;
};

/** Autogenerated input type of RfsmartCredentialUnassign */
export type GRfsmartCredentialUnassignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  credentialId: Scalars['ID'];
};

/** Autogenerated return type of RfsmartCredentialUnassign. */
export type GRfsmartCredentialUnassignPayload = {
  __typename?: 'RfsmartCredentialUnassignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  credential?: Maybe<GRfsmartCredential>;
  userErrors: Array<GProcessPathError>;
};

export type GRole = {
  __typename?: 'Role';
  /** Design-sourced one-line role summary */
  descriptionSummary?: Maybe<Scalars['String']>;
  /** Human-readable role name */
  displayName: Scalars['String'];
  /** The role identifier (e.g. 'store-owner') */
  key: Scalars['String'];
  /** Discrete permission items for this role */
  permissions: Array<Scalars['String']>;
};

export type GRoute = {
  __typename?: 'Route';
  /**
   * Boolean to indicate whether this is a system-created holding pen rather than a
   * route anyone drives: the Lobby, the customer-pickup bucket, or a provider's
   * staging pen. Per-route totals are reported as 0 for these.
   */
  bucketRoute: Scalars['Boolean'];
  color?: Maybe<Scalars['String']>;
  /**
   * Boolean to indicate whether this is the never-optimized customer-pickup bucket
   * route, holding orders the customer collects at the warehouse. True indicates a
   * customer-pickup route.
   */
  customerPickupRoute: Scalars['Boolean'];
  /** The driver associated with this route */
  driver?: Maybe<GDriver>;
  /** The driver associated with this route */
  driverUser?: Maybe<GUser>;
  /** The helper driver associated with this route */
  helperDriver?: Maybe<GDriver>;
  /** The helper driver user associated with this route */
  helperDriverUser?: Maybe<GUser>;
  id: Scalars['ID'];
  /** Boolean to indicate whether this is a lobby route. True indicates a lobby route. */
  isLobby: Scalars['Boolean'];
  /**
   * Actual miles driven along the driver's location breadcrumb trail. Null until
   * the route is completed and metrics are computed, or when the trail is too sparse.
   */
  milesDriven?: Maybe<Scalars['Float']>;
  /** Delivery route name */
  name: Scalars['String'];
  nightEnd: Scalars['ISO8601Date'];
  /**
   * True when this route's night_end has passed (in the route's own warehouse time
   * zone, falling back to the app's default time zone for a route with no
   * warehouse) and route_night_end_lock is on, meaning
   * DeliveryRouteAssignmentService will reject moving stops off this route. False
   * for a route with no night_end.
   */
  nightEndLocked: Scalars['Boolean'];
  /** Percent of volume data available for this route */
  percentItemsWithVolume?: Maybe<Scalars['Float']>;
  /** Percent of weight data available for this route */
  percentItemsWithWeight?: Maybe<Scalars['Float']>;
  /**
   * Planned road distance in miles for the dispatched stop sequence, computed via
   * Google Maps Directions API. Null until computed.
   */
  plannedDistanceMiles?: Maybe<Scalars['Float']>;
  /**
   * The vehicle + capacity the routing plan modeled for this route, from its
   * routing run. Null for buckets/Lobby or a route with no renderable run. Use
   * this for capacity utilization rather than truck, which is the scanned/default
   * physical vehicle.
   */
  plannedVehicle?: Maybe<GPlannedVehicle>;
  /**
   * The route's newest dispatch to a third-party provider, by creation time,
   * regardless of status. Present after a mark even once canceled or failed; the
   * DMP keys on thirdPartyRoute for presence, not on this field's status.
   */
  providerDispatch?: Maybe<GProviderDispatch>;
  /** Boolean to indicate whether this is a redelivery route. True indicates a redelivery route. */
  redeliveryRoute: Scalars['Boolean'];
  /** Redelivery route stops */
  redeliveryStops: Array<GRedelivery>;
  /** Delivery route cohort name, set by automated routing. Temporary field to support routing cohorts */
  routeCohort?: Maybe<Scalars['String']>;
  /** Delivery route origin. Temporary field to support routing cohorts */
  routeOrigin?: Maybe<Scalars['String']>;
  /** Day/night label ('day_time'/'night_time') from the majority of this route's stops' delivery shift, recomputed when stops are moved. Null for non-driven routes and routes with no classifiable stop. */
  shiftType?: Maybe<Scalars['String']>;
  /** Represent route predictive metrics based on route optimization. */
  routingEstimates?: Maybe<GRouteEstimates>;
  /** The time the route was started. Set by Drivers. Returned in the warehouse time zone. */
  startTime?: Maybe<Scalars['ISO8601DateTime']>;
  /** The time the route was completed. Set by Drivers. Returned in the warehouse time zone. */
  stopTime?: Maybe<Scalars['ISO8601DateTime']>;
  /** Delivery route stops, a stop denotes the action of either picking up item(s) or delivering items. */
  stops?: Maybe<Array<GDeliveryStop>>;
  /** Which external provider delivers this route. Null unless thirdPartyRoute is true. */
  thirdPartyProvider?: Maybe<GThirdPartyProvider>;
  /**
   * Boolean to indicate whether an external provider delivers this route rather
   * than an Odeko truck. True for both a route a provider runs and a provider's
   * staging pen; read thirdPartyProvider for which provider and bucketRoute to
   * tell the two apart.
   */
  thirdPartyRoute: Scalars['Boolean'];
  /**
   * Actual time on the road in seconds, derived from the driver's location
   * breadcrumb trail. Null until the route is completed and metrics are computed,
   * or when unknowable.
   */
  timeOnRoad?: Maybe<Scalars['Int']>;
  /** Total volume of this route */
  totalVolume?: Maybe<Scalars['Float']>;
  /** Total weight of this route */
  totalWeight?: Maybe<Scalars['Float']>;
  /**
   * Truck associated with this route (the driver-scanned vehicle, or the warehouse
   * default). Reflects the physical truck, not the routing plan's modeled vehicle
   * — see plannedVehicle.
   */
  truck?: Maybe<GTruck>;
  warehouse: GWarehouse;
  /**
   * The time the driver returned to the warehouse, set automatically when the
   * phone re-enters the warehouse geofence. Returned in the warehouse time zone.
   */
  warehouseArrivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /**
   * The time the driver departed the warehouse, set automatically when the phone
   * first exits the warehouse geofence after the vehicle scan. Returned in the
   * warehouse time zone.
   */
  warehouseDepartedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Autogenerated input type of RouteDetailsUpdate */
export type GRouteDetailsUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Delivery route id. */
  deliveryRouteId: Scalars['ID'];
  /** Driver id. */
  driverId?: InputMaybe<Scalars['String']>;
  /** Driver name. */
  driverName?: InputMaybe<Scalars['String']>;
  /** Helper driver id. */
  helperDriverId?: InputMaybe<Scalars['String']>;
  /** Helper driver name. */
  helperDriverName?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of RouteDetailsUpdate. */
export type GRouteDetailsUpdatePayload = {
  __typename?: 'RouteDetailsUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  route?: Maybe<GRoute>;
  userErrors: Array<GRouteError>;
};

export type GRouteEnded = GUserErrorInterface & {
  __typename?: 'RouteEnded';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** Route possible error types */
export type GRouteError = GAutomatedRoutingPending | GBulkUpdateDeprecated | GInvalidNightEnd | GProviderRouteGuarded | GRouteEnded;

export type GRouteEstimates = {
  __typename?: 'RouteEstimates';
  /** Estimated time in minutes spent at breaks. */
  breakTime?: Maybe<Scalars['Int']>;
  /** Total estimated distance in miles for the route. */
  distance?: Maybe<Scalars['Float']>;
  /** Raw HH:MM string for the estimated finish time in 24 hour rolling windows (may exceed '23:59'). */
  finish?: Maybe<Scalars['String']>;
  /** Date/time representing the estimated finish using delivery date as reference point. */
  finishDatetime?: Maybe<Scalars['ISO8601DateTime']>;
  /** Estimated time in minutes spent at stops based on each location's configured service time. */
  serviceTime?: Maybe<Scalars['Int']>;
  /** Raw HH:MM string for the estimated start time in 24 hour rolling windows (may exceed '23:59'). */
  start?: Maybe<Scalars['String']>;
  /** Date/time representing the estimated start using delivery date as reference point. */
  startDatetime?: Maybe<Scalars['ISO8601DateTime']>;
  /** Estimated number of stops optimized for the route. */
  stopsCount?: Maybe<Scalars['Int']>;
  /**
   * Total estimated travel time in minutes, calculated as: total working time -
   * service time - break times. This represents the actual time spent driving between stops.
   */
  travelTime?: Maybe<Scalars['Int']>;
};

export type GRouteInput = {
  id: Scalars['ID'];
};

export type GRouteNotFound = GUserErrorInterface & {
  __typename?: 'RouteNotFound';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GRouteNotMarkable = GUserErrorInterface & {
  __typename?: 'RouteNotMarkable';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of RouteOriginUpdate */
export type GRouteOriginUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Delivery route id. */
  deliveryRouteId: Scalars['ID'];
  /** Route origin identifier. */
  routeOrigin?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of RouteOriginUpdate. */
export type GRouteOriginUpdatePayload = {
  __typename?: 'RouteOriginUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  route?: Maybe<GRoute>;
  userErrors: Array<GRouteError>;
};

/** Autogenerated input type of RouteReopen */
export type GRouteReopenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Delivery route id. */
  deliveryRouteId: Scalars['ID'];
};

/** Autogenerated return type of RouteReopen. */
export type GRouteReopenPayload = {
  __typename?: 'RouteReopenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  route?: Maybe<GRoute>;
  userErrors: Array<GRouteError>;
};

export type GRouteSummary = {
  __typename?: 'RouteSummary';
  /** Cubic utilization percentage for this vehicle */
  cubicUtilizationPercent?: Maybe<Scalars['Float']>;
  /** Estimated driver hours for this vehicle */
  estimatedHours?: Maybe<Scalars['Float']>;
  /** Total distance for this route in miles */
  miles: Scalars['Float'];
  /** Stop count for this route, excluding depot markers */
  stops: Scalars['Int'];
};

/** Autogenerated input type of RouteTruckUpdate */
export type GRouteTruckUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Delivery route id. */
  deliveryRouteId: Scalars['ID'];
  /** Vehicle tag assigned by the warehouse. */
  vehicleTag: Scalars['String'];
  /** Unique 17-character code that identifies a vehicle. */
  vehicleVin: Scalars['String'];
};

/** Autogenerated return type of RouteTruckUpdate. */
export type GRouteTruckUpdatePayload = {
  __typename?: 'RouteTruckUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  route?: Maybe<GRoute>;
  userErrors: Array<GRouteError>;
};

export type GRoutesInput = {
  nightEnd?: InputMaybe<Scalars['ISO8601Date']>;
  warehouseId?: InputMaybe<Scalars['ID']>;
};

export enum GRoutificRunFailureDimension {
  /**
   * The selected trucks cannot cover the stop count (count * per-truck max_stops <
   * stops): a pinned cohort's reserved trucks, or the vehicle-count pool.
   */
  StopCap = 'stop_cap',
  /**
   * The selected trucks cannot carry the weight/volume demand even using the
   * largest available types: a pinned cohort's reserved trucks, or the
   * vehicle-count pool.
   */
  WeightVolume = 'weight_volume'
}

export type GRoutificRunFailureReason = {
  __typename?: 'RoutificRunFailureReason';
  /** The offending cohort (route type), when the failure is cohort-specific. */
  cohortName?: Maybe<Scalars['String']>;
  /** Which capacity dimension was exceeded — stop_cap or weight_volume — when known. */
  dimension?: Maybe<GRoutificRunFailureDimension>;
  /** The failure class: PinnedFleetInfeasible or VehicleCountInfeasible. */
  type: Scalars['String'];
};

export enum GRoutificRunStatus {
  Error = 'error',
  Finished = 'finished',
  Pending = 'pending',
  Processing = 'processing',
  Reoptimize = 'reoptimize',
  /**
   * The run never reached a terminal Routific status and was given up on. Distinct
   * from error: nothing failed, it simply never finished. No solution is available
   * and it will not resume.
   */
  Timeout = 'timeout'
}

export type GRoutificRunSummary = {
  __typename?: 'RoutificRunSummary';
  /**
   * Stops omitted because automated routing was disabled at input-build time.
   * Empty means eligibility was evaluated with no exclusions; null means this run
   * has no recorded evidence.
   */
  automatedRoutingExclusions?: Maybe<Array<GAutomatedRoutingExclusion>>;
  /** Average volume utilization per truck as a percentage */
  avgCubicUtilizationPercent?: Maybe<Scalars['Float']>;
  createdAt: Scalars['ISO8601DateTime'];
  /** Deliveries per route hour (total stops / driver hours) */
  dprh?: Maybe<Scalars['Float']>;
  /** Sum of driver working time across all vehicles in hours */
  estimatedDriverHours?: Maybe<Scalars['Float']>;
  /** Sum of driver working time across all vehicles in minutes */
  estimatedTotalMinutes?: Maybe<Scalars['Float']>;
  /**
   * Why this run failed, when the failure is a structured fleet infeasibility.
   * PinnedFleetInfeasible carries the offending cohort and the capacity dimension
   * it exceeded (sc-66091); VehicleCountInfeasible carries the dimension the
   * vehicle-count cap could not cover, with no cohort (sc-66269). Null for runs
   * that succeeded or failed without a recorded structured reason.
   */
  failureReason?: Maybe<GRoutificRunFailureReason>;
  id: Scalars['ID'];
  /** Fleet mode and cohort parameters used to generate this run */
  inputSnapshot?: Maybe<Scalars['JSON']>;
  label?: Maybe<Scalars['String']>;
  /** GM-supplied, editable display name for a scenario run. Null until named. */
  name?: Maybe<Scalars['String']>;
  /** Encoded polyline strings keyed by vehicle ID */
  polylines?: Maybe<Scalars['JSON']>;
  /** Vehicles with at least one stop (excludes idle vehicles in ceiling mode) */
  routeCount?: Maybe<Scalars['Int']>;
  /**
   * Per-vehicle stop and distance summary, excluding idle vehicles; a
   * fully-Metrobi vehicle's miles are zero (third-party delivered)
   */
  routes?: Maybe<Array<GRouteSummary>>;
  /**
   * How this run was produced: an auto run (standard / reoptimization), a
   * GM-triggered manual run (etas_only recalculates estimates without moving
   * stops; re_sequence reorders stops), or a scenario. Drives mode-specific
   * labeling on the optimization timeline.
   */
  runType: Scalars['String'];
  status: GRoutificRunStatus;
  /** Number of stops in this run's 3PD Marked group, or null when the run did not separate 3PD. */
  thirdPartyMarkedStopCount?: Maybe<Scalars['Int']>;
  /**
   * The 3PD (Metrobi) "Marked" group (sc-67116): the location stops already parked
   * in the Metrobi staging pen — actually marked Metrobi in production — when this
   * scenario run was built, returned as delivery stops so callers reuse the same
   * location/geo shape as routed stops. These are displayed but not routed on
   * Odeko trucks. Null when the run did not separate 3PD (Auto-Mark override off);
   * an empty list means it did but the pen was empty. Snapshotted per run —
   * distinct from the plan-level live bucket.
   */
  thirdPartyMarkedStops?: Maybe<Array<GDeliveryStop>>;
  /** Number of stops in this run's 3PD separation preview group, or null when the run did not preview it. */
  thirdPartyPreviewStopCount?: Maybe<Scalars['Int']>;
  /**
   * The 3PD (Metrobi) separation preview (sc-65971): the location stops this
   * scenario run computed as 3PD-eligible and held out of the native routes,
   * returned as delivery stops so callers reuse the same location/geo shape as
   * routed stops. Null when the run did not preview 3PD separation
   * (third_party_enabled override off); an empty list means it did but found none
   * eligible. Nothing is marked or bucketed — this is a non-destructive preview,
   * distinct from the native routes.
   */
  thirdPartyPreviewStops?: Maybe<Array<GDeliveryStop>>;
  /** Total road distance across all vehicles in miles, excluding vehicles whose every delivery stop is Metrobi (third-party) */
  totalDistanceMiles?: Maybe<Scalars['Float']>;
  /** Total stops across all vehicles, excluding depot markers */
  totalStops?: Maybe<Scalars['Int']>;
  truckCount: Scalars['Int'];
  /** Number of stops Routific could not assign to a vehicle */
  unservedCount?: Maybe<Scalars['Int']>;
  /**
   * The stops Routific could not assign to any vehicle, each with the raw reason
   * string it returned. Null when no solution was computed (matching
   * unservedCount); an empty list means the run stranded nothing. Admin-only; the
   * client maps each raw reason to human-readable copy.
   */
  unservedStops?: Maybe<Array<GUnservedStop>>;
  /**
   * Maps each vehicle key to the warehouseShiftId it ran on, keyed identically to
   * vehicleStopIds. Null for runs not built from a fleet shift assignment. Join
   * against warehouse.warehouseShifts to label each route with its shift.
   */
  vehicleShifts?: Maybe<Scalars['JSON']>;
  /** Maps each vehicle key to its ordered stop IDs for client-side route matching */
  vehicleStopIds?: Maybe<Scalars['JSON']>;
  /**
   * Maps each vehicle key to the fleet vehicle type that served it (e.g. van, box
   * truck), keyed identically to vehicleStopIds. Null for runs built without a
   * fleet composition.
   */
  vehicleTypes?: Maybe<Scalars['JSON']>;
};

export type GRoutingCohort = {
  __typename?: 'RoutingCohort';
  /** A deterministic color based on the cohort name */
  color?: Maybe<Scalars['String']>;
  /** The unique identifier for the routing cohort */
  id: Scalars['ID'];
  /** The per-cohort stop cap, or null when none is set (the cohort falls back to the default). */
  maxStops?: Maybe<Scalars['Int']>;
  /** The name of the routing cohort */
  name: Scalars['String'];
  /**
   * The warehouse shift assigned to this cohort, or null (the cohort then defaults
   * to the warehouse's first shift by start time).
   */
  warehouseShift?: Maybe<GWarehouseShift>;
};

/** Input type for defining routing truck cohort information */
export type GRoutingCohortInput = {
  /** When false, pool this cohort's stops into the shared fleet instead of routing it on its own trucks. */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Routing cohort identifier */
  id: Scalars['ID'];
  /** Per-cohort stop cap. Positive integer to cap, null to clear back to the default. */
  maxStops?: InputMaybe<Scalars['Int']>;
  /** Desired truck count for the cohort. Omit to leave it unchanged. */
  truckCount?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of RoutingCohortShiftAssign */
export type GRoutingCohortShiftAssignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  cohortId: Scalars['ID'];
  /**
   * A warehouse shift id to assign, or null to clear (the cohort then falls back
   * to the warehouse's first shift by start time).
   */
  warehouseShiftId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of RoutingCohortShiftAssign. */
export type GRoutingCohortShiftAssignPayload = {
  __typename?: 'RoutingCohortShiftAssignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  routingCohort?: Maybe<GRoutingCohort>;
};

export type GRoutingConfiguration = {
  __typename?: 'RoutingConfiguration';
  /** Whether Routific routes around toll roads. The warehouse's persisted value, defaulting to false. */
  avoidTolls: Scalars['Boolean'];
  /** Whether Routific balances workload across vehicles. The warehouse's persisted value, defaulting to false. */
  balance: Scalars['Boolean'];
  /**
   * Length of each placed break in minutes. Null when the current breaks do not
   * share one length, or when the placed lunch break is ambiguous — no single
   * value reproduces them.
   */
  breakDurationMinutes?: Maybe<Scalars['Int']>;
  /** How much of each truck's max capacity the plan routes against. The warehouse's persisted value, defaulting to 100. */
  capacityPercent: Scalars['Int'];
  /**
   * Shift length in hours on the rolling >24:00 axis. Null when the plan's cohorts
   * run shifts of differing length: an override sets every vehicle's shift, so no
   * single value could be reset to without flattening the others.
   */
  driverShiftHours?: Maybe<Scalars['Float']>;
  /**
   * Whether a cohort with no per-cohort stop cap falls back to 25 stops per
   * vehicle. The warehouse's persisted value, defaulting to true. False routes
   * uncapped cohorts without a stop limit.
   */
  maxStopsPerVehicle: Scalars['Boolean'];
  /** Whether Routific minimizes the number of vehicles used. The warehouse's persisted value, defaulting to false. */
  minVehicles: Scalars['Boolean'];
  /** Allowed overtime in minutes. The warehouse's persisted value, defaulting to 0. */
  overtimeMinutes: Scalars['Int'];
  /** Whether Routific optimizes for shortest distance rather than time. The warehouse's persisted value. */
  shortestDistance: Scalars['Boolean'];
  /**
   * Whether the nightly 3PD (Metrobi) auto-marking sweep runs for this warehouse.
   * The warehouse's persisted value, defaulting to the
   * sc_65483_third_party_auto_marking flag.
   */
  thirdPartyEnabled: Scalars['Boolean'];
  /** Total trucks across the plan's cohorts. Null when no cohort has a count set. */
  truckCount?: Maybe<Scalars['Int']>;
  /** Routific visit-balance coefficient. The warehouse's persisted value. */
  visitBalanceCoefficient: Scalars['Float'];
};

/** Apply routing configuration possible errors */
export type GRoutingConfigurationError = GInvalidFleetComposition | GInvalidParameterOverrides | GInvalidRules | GRoutingConfigurationNotEnabled | GRoutingConfigurationNotFound;

export type GRoutingConfigurationNotEnabled = GUserErrorInterface & {
  __typename?: 'RoutingConfigurationNotEnabled';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GRoutingConfigurationNotFound = GUserErrorInterface & {
  __typename?: 'RoutingConfigurationNotFound';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GRoutingImportPlan = {
  __typename?: 'RoutingImportPlan';
  /** Aggregate metrics for the manually edited dispatched plan */
  actualRoutesSummary?: Maybe<GActualRoutesSummary>;
  /** The applied (non-scenario) Routific run for this plan */
  appliedRoutificRun?: Maybe<GRoutificRunSummary>;
  /** The number of cohorts & trucks for the routing import plan */
  cohorts?: Maybe<Array<GRoutingPlanCohort>>;
  /**
   * The current value of the routing parameters and engine options — the baseline
   * the Configure Scenario UI resets to and diffs proposed runs against.
   */
  currentRoutingConfiguration: GRoutingConfiguration;
  /**
   * The currently dispatched plan: the latest finished etas_only run, which holds
   * the live dispatched stop layout with freshly calculated ETAs and its route
   * geometry. Null when ETAs have never been calculated for this plan — see
   * etasStatus. This is the run the etas_status staleness check measures against,
   * so the two always agree.
   */
  dispatchedRoutificRun?: Maybe<GRoutificRunSummary>;
  /**
   * Whether the applied ETAs are stale relative to the current dispatched stop
   * layout, and why — drives the Plan vs. Dispatch stale-ETA warning.
   */
  etasStatus: GEtasStatus;
  fileFound: Scalars['Boolean'];
  /**
   * The warehouse's persisted fleet composition — the vehicle types it routes
   * with, how many of each, and each type's per-truck capacity. Empty when no
   * fleet is configured.
   */
  fleetConfig: Array<GFleetVehicle>;
  id: Scalars['ID'];
  /** GM-triggered manual runs (etas_only / re_sequence) for this plan, newest first */
  manualRoutificRuns: Array<GRoutificRunSummary>;
  /**
   * Why the most recent Routific optimization attempt failed to build its input,
   * or null when it built successfully (or none has run). A non-null value means
   * the night produced no routes for a pinned-fleet reason the operator can fix in Optimization.
   */
  optimizationFailureReason?: Maybe<GRoutingImportPlanOptimizationFailureReason>;
  /**
   * The routing rules in effect for this plan, keyed by rule id, with each rule's
   * options resolved from the warehouse's configuration over the rule's defaults.
   * A scenario run's rules argument layers over this.
   */
  rulesConfig: Scalars['JSON'];
  /** Scenario runs for this routing import plan, newest first */
  scenarios: Array<GRoutificRunSummary>;
  /**
   * The warehouse's persisted per-shift fleet assignment — how many trucks route
   * on each shift (sc-66834). Empty when no assignment is configured. The
   * deliveries Edit Truck Count card seeds its per-shift pool inputs from this.
   */
  shiftAssignment: Array<GShiftAssignmentEntry>;
  status: GRoutingImportPlanStatus;
  /**
   * The location stops parked in the Metrobi staging pen for this plan's warehouse
   * and night, the never-routed 3PD holding route. Returned as delivery stops so
   * callers reuse the same location/geo shape as routed stops. Excludes routes a
   * provider is already running.
   */
  thirdPartyBucketStops: Array<GDeliveryStop>;
  /**
   * Number of location stops parked in the Metrobi staging pen for this plan's
   * warehouse and night. These stops are delivered by a third-party carrier, are
   * never routed on Odeko trucks, and so are excluded from the fleet metrics.
   * Stops on a route a provider is already running are not counted.
   */
  thirdPartyStopCount: Scalars['Int'];
  truckCount?: Maybe<Scalars['Int']>;
  /**
   * The warehouse's LDS-owned shift definitions, ordered by start time. The
   * scenario builder lists these to let a GM assign a truck count per shift
   * (sc-66833). Empty when the warehouse has no shifts defined.
   */
  warehouseShifts: Array<GWarehouseShift>;
};

/** Routing import plan possible errors */
export type GRoutingImportPlanError = GInvalidNightEnd | GInvalidParameterOverrides | GInvalidRules | GRoutingImportPlanNotConfigured | GRoutingImportPlanNotFound | GScenarioLimitReached | GScenarioNotFound | GScenarioRunsNotEnabled | GTruckCountInvalid;

export type GRoutingImportPlanInput = {
  nightEnd: Scalars['ISO8601Date'];
  warehouseId: Scalars['ID'];
};

export type GRoutingImportPlanNotConfigured = GUserErrorInterface & {
  __typename?: 'RoutingImportPlanNotConfigured';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GRoutingImportPlanNotFound = GUserErrorInterface & {
  __typename?: 'RoutingImportPlanNotFound';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** Machine-readable reason the most recent Routific optimization attempt failed to build its input. */
export enum GRoutingImportPlanOptimizationFailureReason {
  /** The pinned cohorts reserve more trucks than the fleet holds. Reduce a cohort's truck count. */
  PinnedFleetContention = 'PINNED_FLEET_CONTENTION',
  /**
   * A pinned cohort's demand can't fit its reserved trucks (stop cap or
   * weight/volume). Adjust the cohort's truck count or max stops.
   */
  PinnedFleetInfeasible = 'PINNED_FLEET_INFEASIBLE',
  /** The plan's total truck count can't carry the pooled demand (stop cap or weight/volume). Increase the truck count. */
  VehicleCountInfeasible = 'VEHICLE_COUNT_INFEASIBLE'
}

export enum GRoutingImportPlanStatus {
  Completed = 'completed',
  InProgress = 'in_progress',
  Pending = 'pending',
  Unstarted = 'unstarted'
}

/** Autogenerated input type of RoutingImportPlanTruckCountUpdate */
export type GRoutingImportPlanTruckCountUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** List of cohorts with their associated truck count. */
  cohorts?: InputMaybe<Array<GRoutingCohortInput>>;
  /** Routing import plan night end. */
  nightEnd: Scalars['ISO8601Date'];
  /**
   * Per-shift truck counts to persist as the warehouse's standing shift
   * assignment. Omit to leave it unchanged; an empty list clears it.
   */
  shifts?: InputMaybe<Array<GRoutingShiftAssignmentInput>>;
  /** Warehouse id. */
  warehouseId: Scalars['ID'];
};

/** Autogenerated return type of RoutingImportPlanTruckCountUpdate. */
export type GRoutingImportPlanTruckCountUpdatePayload = {
  __typename?: 'RoutingImportPlanTruckCountUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  routingImportPlan?: Maybe<GRoutingImportPlan>;
  userErrors: Array<GRoutingImportPlanError>;
};

export type GRoutingPlanCohort = {
  __typename?: 'RoutingPlanCohort';
  /** A deterministic color based on the cohort id */
  color?: Maybe<Scalars['String']>;
  /**
   * True when the cohort has no member locations and a null or 0 truck count.
   * Routing ignores a dormant cohort: it needs no count and does not make the plan
   * a plan with cohorts.
   */
  dormant: Scalars['Boolean'];
  /** When false, this cohort's stops are pooled into the shared fleet instead of routed on its own trucks. */
  enabled: Scalars['Boolean'];
  /** An identifier for the routing plan cohort entry */
  id: Scalars['ID'];
  /** The per-cohort stop cap, or null when none is set (the cohort falls back to the default). */
  maxStops?: Maybe<Scalars['Int']>;
  /** The name of the routing cohort */
  name: Scalars['String'];
  /** The number of trucks in the routing cohort */
  truckCount?: Maybe<Scalars['Int']>;
};

/** Input type for assigning a truck count to a warehouse shift in a scenario run. */
export type GRoutingShiftAssignmentInput = {
  /** How many trucks route on this shift. 0 keeps the shift in the assignment but routes no trucks on it. */
  truckCount: Scalars['Int'];
  /** Id of an existing WarehouseShift on this warehouse. */
  warehouseShiftId: Scalars['Int'];
};

/** Autogenerated input type of RunTransactionSyncAudit */
export type GRunTransactionSyncAuditInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The location's odeko UUID, as federated on Location.id. */
  locationId: Scalars['ID'];
};

/** Autogenerated return type of RunTransactionSyncAudit. */
export type GRunTransactionSyncAuditPayload = {
  __typename?: 'RunTransactionSyncAuditPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  /**
   * The location the audit was requested for, so its transactionSync can be
   * re-read in the same round trip. Null when nothing was requested.
   */
  location?: Maybe<GLocation>;
};

/** Autogenerated input type of RunTransactionSync */
export type GRunTransactionSyncInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The location's odeko UUID, as federated on Location.id. */
  locationId: Scalars['ID'];
};

/** Autogenerated return type of RunTransactionSync. */
export type GRunTransactionSyncPayload = {
  __typename?: 'RunTransactionSyncPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  /**
   * The location the sync was started for, so its transactionSync can be re-read
   * in the same round trip. Null when nothing was started.
   */
  location?: Maybe<GLocation>;
};

export type GSalesOutreachLog = {
  __typename?: 'SalesOutreachLog';
  adminId: Scalars['ID'];
  id: Scalars['ID'];
  locationId: Scalars['ID'];
  loggedAt: Scalars['ISO8601DateTime'];
  notes?: Maybe<Scalars['String']>;
  outcome: Scalars['String'];
};

export type GSalesPriorityLocation = {
  __typename?: 'SalesPriorityLocation';
  assignedRep?: Maybe<GAdmin>;
  avgOrderCadenceDays?: Maybe<Scalars['Float']>;
  categoriesPurchasedCount?: Maybe<Scalars['Int']>;
  categorySpendDetails?: Maybe<Array<GCategorySpendDetail>>;
  churnRiskCents?: Maybe<Scalars['Int']>;
  churnScore: Scalars['Int'];
  city?: Maybe<Scalars['String']>;
  compositeScore: Scalars['Int'];
  daysSinceLastOrder?: Maybe<Scalars['Int']>;
  deprioritizeReason?: Maybe<Scalars['String']>;
  deprioritizedAt?: Maybe<Scalars['ISO8601DateTime']>;
  deprioritizedBy?: Maybe<Scalars['String']>;
  dollarOpportunityCents?: Maybe<Scalars['Int']>;
  expansionOpportunityCents?: Maybe<Scalars['Int']>;
  expansionScore: Scalars['Int'];
  hubspotCompanyId?: Maybe<Scalars['String']>;
  hubspotLead?: Maybe<GHubspotLead>;
  /** Mirrored from HubSpot Company.Industry. HubSpot is source of truth; values refresh nightly. */
  industry?: Maybe<Scalars['String']>;
  /**
   * The Location entity for this row. Federated — use to query fields owned by
   * other services (e.g. `signedUpForSupply` from business_portal).
   */
  location?: Maybe<GLocation>;
  /** @deprecated Use `location { keyId }`. Reachable through the federated `location` field. */
  locationId: Scalars['ID'];
  /** @deprecated Use `location { businessName }`. Reachable through the federated `location` field. */
  locationName: Scalars['String'];
  /** @deprecated Use `location { id }`. Reachable through the federated `location` field. */
  locationUuid?: Maybe<Scalars['ID']>;
  mostRecentOutcome?: Maybe<Scalars['String']>;
  mostRecentOutcomeAt?: Maybe<Scalars['ISO8601DateTime']>;
  scoreSignals?: Maybe<Scalars['JSON']>;
  scoredAt: Scalars['ISO8601DateTime'];
  /**
   * 13 weekly spend totals (cents) for the prior ~90 days, oldest → newest. Drives
   * the comparison line on the spend trend chart.
   */
  spendPrevWeeklyCents?: Maybe<Array<Scalars['Int']>>;
  /**
   * 13 weekly spend totals (cents) for the recent ~90 days, oldest → newest.
   * Bucketed by delivery_date. Drives the spend trend chart on the Sales Priority detail view.
   */
  spendWeeklyCents?: Maybe<Array<Scalars['Int']>>;
  suggestedAction?: Maybe<Scalars['String']>;
  /**
   * Action types currently suppressed for this location. Recent_contact /
   * not_interested suppress all three. Recent or upcoming orders only suppress
   * churn_risk and winback (expansion never appears here from order rules). Churn
   * override: churn_risk is dropped from this list when 90d spend is down ≥20% vs prior 90d.
   */
  suppressedActions: Array<GSuggestedActionEnum>;
  /** Timestamp when the strongest suppression window blocking this row's `suggestedAction` expires. */
  suppressedUntil?: Maybe<Scalars['ISO8601DateTime']>;
  /**
   * Strongest reason this row's `suggestedAction` is currently suppressed. Null
   * when the row's action isn't blocked. Priority: NOT_INTERESTED > RECENT_CONTACT
   * > RECENT_ORDER. See `suppressedActions` for per-action membership.
   */
  suppressionReason?: Maybe<GSuppressionReasonEnum>;
  /** Timestamp of the triggering record (outreach log or order) for the strongest reason blocking this row's `suggestedAction`. */
  suppressionTriggeredAt?: Maybe<Scalars['ISO8601DateTime']>;
  /**
   * Top 4 subcategory opportunities for this location, ranked by dollar gap,
   * regardless of parent category. Null when no warehouse subcategory medians
   * exist; empty array when the location already meets or exceeds expected for
   * every subcategory.
   */
  topSubcategorySpendDetails?: Maybe<Array<GSubcategorySpendDetail>>;
  warehouseId?: Maybe<Scalars['ID']>;
  warehouseName?: Maybe<Scalars['String']>;
  weightedOpportunityCents?: Maybe<Scalars['Int']>;
  winbackOpportunityCents?: Maybe<Scalars['Int']>;
  winbackScore: Scalars['Int'];
};

export enum GSalesPrioritySortByEnum {
  /** Sort by composite behavioral score */
  CompositeScore = 'COMPOSITE_SCORE',
  /** Sort by dollar opportunity (highest revenue impact first) */
  DollarOpportunity = 'DOLLAR_OPPORTUNITY'
}

export type GSalesTaxEstimate = {
  __typename?: 'SalesTaxEstimate';
  date: Scalars['ISO8601Date'];
  id: Scalars['ID'];
  locationUuid: Scalars['ID'];
  totalTax: GMoney;
  vendorUuid: Scalars['ID'];
};

export type GSalesTaxEstimateInput = {
  /** Sales tax estimate ID */
  id: Scalars['ID'];
  /** Vendor UUID for the sales tax estimate */
  vendorUuid: Scalars['ID'];
};

export type GSalesTaxLineInput = {
  /** Total amount (in cents) for this line. */
  amountCents: Scalars['Int'];
  description: Scalars['String'];
  /**
   * Code identifying the item. Currently, this will be a product UUID in all
   * cases. Adding support for other types of line-items (e.g. discounts, fees,
   * shipping charges) would involve assigning codes to identify them.
   */
  itemCode: Scalars['String'];
  quantity: Scalars['Int'];
};

/** Autogenerated input type of SaveConsumerAppReferralLink */
export type GSaveConsumerAppReferralLinkInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Referral link URL */
  url: Scalars['String'];
};

/** Autogenerated return type of SaveConsumerAppReferralLink */
export type GSaveConsumerAppReferralLinkPayload = {
  __typename?: 'SaveConsumerAppReferralLinkPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to save consumer app referral link */
  result: GSaveConsumerAppReferralLinkResult;
};

/** Result of attempting to save consumer app referral link. */
export type GSaveConsumerAppReferralLinkResult = GConsumerAppReferralLinkSuccess | GErrorsResult;

export type GSaveMasterHomepageRowInput = {
  id?: InputMaybe<Scalars['ID']>;
  structureType: GMasterHomepageRowStructureType;
};

export type GSaveMasterHomepageRowsInput = {
  id: Scalars['ID'];
  rows: Array<GSaveMasterHomepageRowInput>;
};

export type GSaveMasterHomepageRowsPayload = {
  __typename?: 'SaveMasterHomepageRowsPayload';
  errors: Array<GMasterHomepageError>;
};

/** Autogenerated input type of SaveRoutificScenario */
export type GSaveRoutificScenarioInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** GM-supplied display name to set on the scenario. */
  name: Scalars['String'];
  /** Id of the scenario run to name. */
  scenarioId: Scalars['ID'];
};

/** Autogenerated return type of SaveRoutificScenario. */
export type GSaveRoutificScenarioPayload = {
  __typename?: 'SaveRoutificScenarioPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The named scenario run. Null on error. */
  scenario?: Maybe<GRoutificRunSummary>;
  userErrors: Array<GRoutingImportPlanError>;
};

/** Autogenerated input type of SaveVendorAllocation */
export type GSaveVendorAllocationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nightEnd: Scalars['ISO8601Date'];
  orders: Array<GOrderAllocationInput>;
  vendorId: Scalars['ID'];
  warehouseId: Scalars['ID'];
};

/** Autogenerated return type of SaveVendorAllocation. */
export type GSaveVendorAllocationPayload = {
  __typename?: 'SaveVendorAllocationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  userErrors: Array<GUserError>;
};

/** Autogenerated input type of ScanMarketingQrCodeMutation */
export type GScanMarketingQrCodeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID (UUID) of the QR code being scanned */
  id: Scalars['ID'];
};

/** Autogenerated return type of ScanMarketingQrCodeMutation. */
export type GScanMarketingQrCodeMutationPayload = {
  __typename?: 'ScanMarketingQrCodeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  qrScan: GMarketingQrScan;
};

export type GScenarioLimitReached = GUserErrorInterface & {
  __typename?: 'ScenarioLimitReached';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GScenarioNotFound = GUserErrorInterface & {
  __typename?: 'ScenarioNotFound';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GScenarioRunsNotEnabled = GUserErrorInterface & {
  __typename?: 'ScenarioRunsNotEnabled';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GScheduledDeliveryTime = {
  __typename?: 'ScheduledDeliveryTime';
  /**
   * The earliest time the order is expected to be delivered, represented as a
   * local date and time without a time zone offset (e.g., "2025-07-01T08:00:00").
   * This time should be interpreted in the context of the delivery location's time zone.
   */
  earliest: Scalars['String'];
  /**
   * The latest time the order is expected to be delivered, represented as a local
   * date and time without a time zone offset (e.g., "2025-07-01T20:00:00"). This
   * time should be interpreted in the context of the delivery location's time zone.
   */
  latest: Scalars['String'];
  /**
   * The IANA time zone identifier (e.g., "America/New_York") specifying the time
   * zone in which the scheduled delivery times should be interpreted.
   */
  timeZone: Scalars['String'];
};

export enum GScheduledDeliveryTimeSourceEnum {
  /** Delivery time based on delivery window */
  DeliveryWindow = 'DELIVERY_WINDOW',
  /** Delivery time based on store hours */
  StoreHours = 'STORE_HOURS'
}

/** Error indicating that a mutation failed because the requested pickup time is too far in the future. */
export type GScheduledTooFarOut = GError & {
  __typename?: 'ScheduledTooFarOut';
  /** A description of the error. */
  message: Scalars['String'];
};

/** How scores are aggregated in leaderboards */
export enum GScoreOperatorEnum {
  /** Keep the latest score */
  Latest = 'LATEST',
  /** Keep the maximum score */
  Maximum = 'MAXIMUM',
  /** Keep the minimum score */
  Minimum = 'MINIMUM',
  /** Sum all scores */
  Sum = 'SUM'
}

export type GSearchTermImpression = {
  __typename?: 'SearchTermImpression';
  /** Number of impressions for this search term, nullable if threshold is set */
  impressions?: Maybe<Scalars['Int']>;
  /** Indicates if the search term is an exact match or threshold term */
  isExact: Scalars['Boolean'];
  /** Inclusive start date of the aggregration period */
  startDate: Scalars['ISO8601Date'];
  /** The search keyword that triggered the impression */
  term: Scalars['String'];
  /** Threshold for the search term. Nullable if impressions are present */
  threshold?: Maybe<Scalars['Int']>;
};

/** Autogenerated input type of SendAlignmentMessage */
export type GSendAlignmentMessageInput = {
  body: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  triggerAgent?: InputMaybe<Scalars['Boolean']>;
  waitForEvents?: InputMaybe<Scalars['Boolean']>;
  workThreadId: Scalars['ID'];
};

/** Autogenerated return type of SendAlignmentMessage. */
export type GSendAlignmentMessagePayload = {
  __typename?: 'SendAlignmentMessagePayload';
  agentRun?: Maybe<GAgentRun>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  commandId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  event?: Maybe<GWorkThreadEvent>;
};

/** Autogenerated input type of SendBrandedPaperQuestionEmailMutation */
export type GSendBrandedPaperQuestionEmailMutationInput = {
  /** The Auth0 User id of the user posing the question. */
  auth0UserId: Scalars['String'];
  /** The body of the email. */
  body: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /**
   * The email given by the user when posing the question. May be different than
   * the user's recorded email address. The from header of the email.
   */
  email: Scalars['String'];
  /** The subject of the email. */
  subject: Scalars['String'];
};

/** Autogenerated return type of SendBrandedPaperQuestionEmailMutation. */
export type GSendBrandedPaperQuestionEmailMutationPayload = {
  __typename?: 'SendBrandedPaperQuestionEmailMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  emailScheduled: Scalars['Boolean'];
  errors: Array<Scalars['String']>;
};

/** Input for sending a chat message */
export type GSendChatMessageInput = {
  /** The message body for a chat message, this will typically be from a user `What is my name?` */
  body: Scalars['String'];
  /**
   * The metadata for a chat message, this may be system relevant information you
   * believed to be relevant to the conversation at a given point in time. i.e during sending the message.
   *
   * This may be along the lines of "The user is current viewing the item Oat Milk with uuid 123"
   */
  metadata?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of SendEquipmentCheckoutEmailMutation */
export type GSendEquipmentCheckoutEmailMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The user's email. */
  email: Scalars['String'];
  /** True if the user requested financing for the order. */
  financingRequested: Scalars['Boolean'];
  /** The location selected by the user when ordering. */
  locationUuid: Scalars['String'];
  /** The list of equipment ordered. */
  orderLines: Array<GEquipmentOrderLineInput>;
};

/** Autogenerated return type of SendEquipmentCheckoutEmailMutation. */
export type GSendEquipmentCheckoutEmailMutationPayload = {
  __typename?: 'SendEquipmentCheckoutEmailMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  emailScheduled: Scalars['Boolean'];
  errors: Array<Scalars['String']>;
};

/** Autogenerated input type of SendEquipmentQuestionEmailMutation */
export type GSendEquipmentQuestionEmailMutationInput = {
  /** The Auth0 User id of the user posing the question. */
  auth0UserId: Scalars['String'];
  /** The body of the email. */
  body: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /**
   * The email given by the user when posing the question. May be different than
   * the user's recorded email address. The from header of the email.
   */
  email: Scalars['String'];
  /** The subject of the email. */
  subject: Scalars['String'];
};

/** Autogenerated return type of SendEquipmentQuestionEmailMutation. */
export type GSendEquipmentQuestionEmailMutationPayload = {
  __typename?: 'SendEquipmentQuestionEmailMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  emailScheduled: Scalars['Boolean'];
  errors: Array<Scalars['String']>;
};

export type GServiceError = GUserErrorInterface & {
  __typename?: 'ServiceError';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GServiceFee = GFeeInterface & {
  __typename?: 'ServiceFee';
  /** The threshold amount in cents at which the fee is applied. */
  feeThresholds: Array<GFeeThreshold>;
  id: Scalars['ID'];
  /** Indicates if the fee is active or not. */
  isActive: Scalars['Boolean'];
  odekoUuid: Scalars['ID'];
  /** The amount of the service fee in cents. */
  warehouseFeeAmountCents: Scalars['Int'];
  /** Unique identifier of the warehouse associated with this service fee. */
  warehouseId: Scalars['ID'];
};

/** Autogenerated input type of SetDefaultPaymentMethodForLocationsMutation */
export type GSetDefaultPaymentMethodForLocationsMutationInput = {
  /** If true, also sets default payment method for all other eligible locations the user has access to */
  applyToEligibleLocations?: InputMaybe<Scalars['Boolean']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** UUID for the location to set default payment method */
  locationUuid: Scalars['String'];
  /** Stripe payment method ID */
  paymentMethodId: Scalars['String'];
  /** Payment method type (CREDIT_CARD or BANK_ACCOUNT). If omitted, will be determined from Stripe. */
  paymentMethodType?: InputMaybe<GPaymentMethodTypeEnum>;
};

/** Autogenerated return type of SetDefaultPaymentMethodForLocationsMutation. */
export type GSetDefaultPaymentMethodForLocationsMutationPayload = {
  __typename?: 'SetDefaultPaymentMethodForLocationsMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  /** List of locations that were set */
  locations: Array<GLocation>;
};

/** Autogenerated input type of SetFinancialStatementPreferencesMutation */
export type GSetFinancialStatementPreferencesMutationInput = {
  /** Whether or not to apply these preferences to all user locations */
  applyToAllLocations?: InputMaybe<Scalars['Boolean']>;
  /** The list of billing contact emails (up to 10 are allowed) */
  billingContactEmails: Array<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The frequency at which statements must be emailed */
  emailFrequency: GFinancialStatementEmailFrequencyTypeEnum;
  /** The current location UUID */
  locationUuid: Scalars['String'];
};

/** Autogenerated return type of SetFinancialStatementPreferencesMutation. */
export type GSetFinancialStatementPreferencesMutationPayload = {
  __typename?: 'SetFinancialStatementPreferencesMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  locations?: Maybe<Array<GLocation>>;
};

/** Autogenerated input type of SetFleetComposition */
export type GSetFleetCompositionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /**
   * The fleet: one entry per vehicle type with its truck count. An empty list
   * clears the composition. Capacities are not caller-set — they come from the
   * warehouse's vehicle types.
   */
  vehicles: Array<GFleetVehicleInput>;
  /** Warehouse whose fleet composition to write. */
  warehouseId: Scalars['ID'];
};

/** Autogenerated return type of SetFleetComposition. */
export type GSetFleetCompositionPayload = {
  __typename?: 'SetFleetCompositionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** True when the fleet composition was persisted. */
  saved: Scalars['Boolean'];
  userErrors: Array<GFleetCompositionError>;
};

/** Autogenerated input type of SetFundApplicationExclusions */
export type GSetFundApplicationExclusionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  exclusions: Array<GFundApplicationExclusionInput>;
};

/** Autogenerated return type of SetFundApplicationExclusions. */
export type GSetFundApplicationExclusionsPayload = {
  __typename?: 'SetFundApplicationExclusionsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  locations?: Maybe<Array<GLocation>>;
};

/** Autogenerated input type of SetInvoiceExternalSupplier */
export type GSetInvoiceExternalSupplierInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  externalSupplierId?: InputMaybe<Scalars['ID']>;
  externalSupplierName?: InputMaybe<Scalars['String']>;
  supplierInvoiceId: Scalars['ID'];
};

/** Autogenerated return type of SetInvoiceExternalSupplier. */
export type GSetInvoiceExternalSupplierPayload = {
  __typename?: 'SetInvoiceExternalSupplierPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  externalSupplier?: Maybe<GExternalSupplier>;
  supplierInvoice?: Maybe<GSupplierInvoice>;
};

export type GSetItemInactiveError = {
  __typename?: 'SetItemInactiveError';
  message: Scalars['String'];
};

export type GSetItemInactivePayload = {
  __typename?: 'SetItemInactivePayload';
  errors: Array<GSetItemInactiveError>;
  item?: Maybe<GSupplyItem>;
};

/** Autogenerated input type of SetLocationAutopayMutation */
export type GSetLocationAutopayMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  /** The revision of the settings the customer saw. */
  expectedRevision: Scalars['String'];
  locationUuid: Scalars['ID'];
  /** Client-generated UUID for this confirmed action. */
  requestId: Scalars['ID'];
};

/** Autogenerated return type of SetLocationAutopayMutation. */
export type GSetLocationAutopayMutationPayload = {
  __typename?: 'SetLocationAutopayMutationPayload';
  changeId?: Maybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GCustomerAutopayError>;
  /** The stored request, including what billing committed. Null when the submission was refused before admission. */
  request?: Maybe<GCustomerAutopayRequest>;
  requestId: Scalars['ID'];
  /** Current settings read after the command; null if billing could not be read. */
  settings?: Maybe<GCustomerAutopaySettings>;
  status: GCustomerAutopayRequestStatusEnum;
};

/** Autogenerated input type of SetLocationStandingPoNumberMutation */
export type GSetLocationStandingPoNumberMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** UUID for the Location */
  locationId: Scalars['ID'];
  /** The PO number for every delivery date without one of its own. Send null or an empty string to clear it. */
  standingPoNumber?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of SetLocationStandingPoNumberMutation. */
export type GSetLocationStandingPoNumberMutationPayload = {
  __typename?: 'SetLocationStandingPoNumberMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GUserError>;
  standingPoNumber?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of SetMerchantOperatingHours */
export type GSetMerchantOperatingHoursInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Hours of operation in merchant's time zone. */
  friday: GMerchantOperatingHoursForDayOfWeekInput;
  /** Merchant ID. */
  merchantId: Scalars['ID'];
  /** Hours of operation in merchant's time zone. */
  monday: GMerchantOperatingHoursForDayOfWeekInput;
  /** Hours of operation in merchant's time zone. */
  saturday: GMerchantOperatingHoursForDayOfWeekInput;
  /** Hours of operation in merchant's time zone. */
  sunday: GMerchantOperatingHoursForDayOfWeekInput;
  /** Hours of operation in merchant's time zone. */
  thursday: GMerchantOperatingHoursForDayOfWeekInput;
  /** Hours of operation in merchant's time zone. */
  tuesday: GMerchantOperatingHoursForDayOfWeekInput;
  /** Hours of operation in merchant's time zone. */
  wednesday: GMerchantOperatingHoursForDayOfWeekInput;
};

/** Autogenerated return type of SetMerchantOperatingHours */
export type GSetMerchantOperatingHoursPayload = {
  __typename?: 'SetMerchantOperatingHoursPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to set the merchant's schedule. */
  result: GMerchantResult;
};

/** Autogenerated input type of SetTip */
export type GSetTipInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Opaque token identifying a specific version of the cart. */
  fingerprint: Scalars['String'];
  /** Tip expressed as a percent of subtotal. */
  tipPercent?: InputMaybe<Scalars['Int']>;
  /** Tip expressed as a fixed value. */
  tipValue?: InputMaybe<GMoneyInput>;
};

/** Autogenerated return type of SetTip */
export type GSetTipPayload = {
  __typename?: 'SetTipPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to set tip. */
  result: GCartResult;
};

export type GShiftAssignmentEntry = {
  __typename?: 'ShiftAssignmentEntry';
  /** How many trucks route on this shift. 0 keeps the shift in the assignment but routes no trucks on it. */
  truckCount: Scalars['Int'];
  /** Id of the WarehouseShift this entry assigns trucks to. */
  warehouseShiftId: Scalars['Int'];
};

export type GShiftNotFound = GUserErrorInterface & {
  __typename?: 'ShiftNotFound';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GShipDateRequired = GUserErrorInterface & {
  __typename?: 'ShipDateRequired';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GShippingEstimate = {
  __typename?: 'ShippingEstimate';
  /** Cost of shipping only; does not include the cost of items. */
  costCents: Scalars['Int'];
  deliveryRange: GShippingEstimateDeliveryRange;
  shippingMethod: GShippingMethodEnum;
  weight: Scalars['Float'];
};


export type GShippingEstimateDeliveryRangeArgs = {
  orderDate: Scalars['ISO8601Date'];
};

export type GShippingEstimateDeliveryRange = {
  __typename?: 'ShippingEstimateDeliveryRange';
  earliest: Scalars['ISO8601Date'];
  latest: Scalars['ISO8601Date'];
};

export type GShippingInstructions = {
  __typename?: 'ShippingInstructions';
  appointmentNeeded: Scalars['Boolean'];
  deliveryNotes?: Maybe<Scalars['String']>;
  hoursOfOperation: Scalars['String'];
  id: Scalars['ID'];
  liftgateNeeded: Scalars['Boolean'];
  /** @deprecated Deprecated - use phone_numbers on Location */
  phoneNumber: Scalars['String'];
  rearDockDelivery: Scalars['Boolean'];
  residentialAddress: Scalars['Boolean'];
};

export type GShippingInstructionsInput = {
  appointmentNeeded?: InputMaybe<Scalars['Boolean']>;
  deliveryNotes?: InputMaybe<Scalars['String']>;
  hoursOfOperation?: InputMaybe<Scalars['String']>;
  liftgateNeeded?: InputMaybe<Scalars['Boolean']>;
  rearDockDelivery?: InputMaybe<Scalars['Boolean']>;
  residentialAddress?: InputMaybe<Scalars['Boolean']>;
};

export enum GShippingMethodEnum {
  /** Shipped via pallet (for heavier orders) */
  Pallet = 'pallet',
  /** Shipped via parcel (for lighter orders) */
  Parcel = 'parcel'
}

/** A purchasable sign product */
export type GSignProduct = {
  __typename?: 'SignProduct';
  /** Human-readable description */
  description?: Maybe<Scalars['String']>;
  /** Unique identifier for the sign product */
  id: Scalars['ID'];
  /** Sign price in cents */
  priceCents: Scalars['Int'];
};

/** A signage order tracking Monday.com production tickets */
export type GSignageOrder = {
  __typename?: 'SignageOrder';
  /** Business name associated with this signage order */
  businessName: Scalars['String'];
  /** Timestamp when SignageOrder was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** Customer-visible production status */
  currentStatus?: Maybe<Scalars['String']>;
  /** Unique identifier for the SignageOrder */
  id: Scalars['ID'];
  /** Last time status was synced from Monday.com */
  lastStatusCheck?: Maybe<Scalars['ISO8601DateTime']>;
  /** Physical location address for signage installation */
  locationAddress?: Maybe<Scalars['String']>;
  /** Timestamp when Monday.com production ticket was created */
  mondayCreatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Monday.com ticket ID for tracking production */
  mondayTicketId?: Maybe<Scalars['String']>;
  /** Customer-facing order number */
  orderNumber: Scalars['Int'];
  /** QR codes associated with this signage order */
  qrCodes: Array<GMarketingQrCode>;
  /** Description of signage quantities ordered */
  quantityText: Scalars['String'];
  /** Color of the signage requested */
  signColor: Scalars['String'];
  /** Type of signage material requested */
  signMaterial: Scalars['String'];
  /** SubscriptionSession that generated this signage order (deprecated: use sourceable) */
  subscriptionSession?: Maybe<GSubscriptionSession>;
  /** Shipping tracking number for order delivery */
  trackingNumber?: Maybe<Scalars['String']>;
  /** Timestamp when SignageOrder was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for SignageOrder. */
export type GSignageOrderConnection = {
  __typename?: 'SignageOrderConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GSignageOrderEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GSignageOrder>>>;
  /** Information to aid in pagination. */
  pageInfo: GPageInfo;
  /** The total count of records in the connection. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type GSignageOrderEdge = {
  __typename?: 'SignageOrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GSignageOrder>;
};

export type GSigninAuthorization = {
  __typename?: 'SigninAuthorization';
  clientID: Scalars['String'];
  domain: Scalars['String'];
  redirectUri: Scalars['String'];
  responseType: Scalars['String'];
};

export type GSigninCredentials = {
  __typename?: 'SigninCredentials';
  email: Scalars['String'];
  realm: Scalars['String'];
};

export type GSignupAnalytics = {
  __typename?: 'SignupAnalytics';
  anonymousId?: Maybe<Scalars['String']>;
  event: Scalars['String'];
  properties: Scalars['String'];
  propertires?: Maybe<Scalars['JSON']>;
  userId?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of SignupMutation */
export type GSignupMutationInput = {
  /** The type of account e.g. distributor */
  accountType?: InputMaybe<Scalars['String']>;
  /** The address provided from google places api */
  address: Scalars['String'];
  /** The anonymous id used for tracking */
  anonymousId?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The company name provided the customer */
  companyName: Scalars['String'];
  /** The email provided by the customer */
  email: Scalars['String'];
  /** The first name provided by the customer */
  firstName: Scalars['String'];
  /** How the customer heard about us */
  howDidYouHearAboutUs: Scalars['String'];
  /** The last name provided by the customer */
  lastName: Scalars['String'];
  /** The size of the location provided by the customer */
  locationSize: Scalars['String'];
  /** Meta advertising identifiers from the browser. Signup succeeds without them. */
  metaTracking?: InputMaybe<GMetaTrackingInput>;
  /** The ordering size (pallet etc) by the customer */
  orderingSize?: InputMaybe<Scalars['String']>;
  /** The password supplied by the customer */
  password: Scalars['String'];
  /** The phone number supplied by the customer */
  phone: Scalars['String'];
  /** The truck size supplied by the customer */
  truckSize?: InputMaybe<Scalars['String']>;
  /** Indicates the vendor's name when "How did you hear about us?" is answered with "Vendor Referral". */
  vendorReferral?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of SignupMutation. */
export type GSignupMutationPayload = {
  __typename?: 'SignupMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  signupResponse: GSignupResponse;
};

export type GSignupResponse = {
  __typename?: 'SignupResponse';
  accountCreated: Scalars['Boolean'];
  analytics: Array<GSignupAnalytics>;
  authorization?: Maybe<GSigninAuthorization>;
  credentials?: Maybe<GSigninCredentials>;
  nextUrl?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  traceId?: Maybe<Scalars['String']>;
};

export type GSizeInput = {
  quantity: Scalars['Float'];
  unit: Scalars['ID'];
};

export type GSku = {
  __typename?: 'Sku';
  categoryName: Scalars['String'];
  displayName: Scalars['String'];
  id: Scalars['ID'];
  /**
   * PROTOTYPE The skus' inventory information.
   * @deprecated Prefer 'inventoryLocationItem' instead, since it includes an id field, while this does not.
   */
  inventoryInfo?: Maybe<GInventoryInfo>;
  /** PROTOTYPE The inventory LocationItem for corresponding to this sku. */
  inventoryLocationItem?: Maybe<GInventoryLocationItem>;
  /** Item if not a sample */
  item?: Maybe<GSupplyItem>;
  name: Scalars['String'];
  priceCents: Scalars['Int'];
  /** @deprecated legacy, use refrigeration_state instead */
  refrigerationRequired: Scalars['Boolean'];
  refrigerationState: Scalars['String'];
  /** @deprecated legacy, use categoryName instead */
  skuCategory?: Maybe<GSkuCategory>;
  subcategoryName: Scalars['String'];
};

export type GSkuCategory = {
  __typename?: 'SkuCategory';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

/** Sort direction values. */
export enum GSortDirection {
  /** Ascending, nulls last. */
  Asc = 'ASC',
  /** Descending, nulls first. */
  Desc = 'DESC'
}

export enum GSortDirectionEnum {
  /** Smallest or earliest first. */
  Asc = 'ASC',
  /** Largest or latest first. */
  Desc = 'DESC'
}

/** Sort order for leaderboards */
export enum GSortOrderEnum {
  /** Sort in ascending order (lowest to highest) */
  Ascending = 'ASCENDING',
  /** Sort in descending order (highest to lowest) */
  Descending = 'DESCENDING'
}

/** A device code for pairing a Square Terminal */
export type GSquareDeviceCode = {
  __typename?: 'SquareDeviceCode';
  /** The pairing code to enter on the terminal */
  code: Scalars['String'];
  /** Creation timestamp */
  createdAt: Scalars['ISO8601DateTime'];
  /** Device code ID */
  id: Scalars['ID'];
  /** Square location ID */
  locationId: Scalars['String'];
  /** Code expiration time */
  pairBy?: Maybe<Scalars['ISO8601DateTime']>;
  /** Code status (UNPAIRED, PAIRED, EXPIRED) */
  status: Scalars['String'];
};

/** A Square location (storefront) synced from the merchant's account */
export type GSquareLocation = {
  __typename?: 'SquareLocation';
  /** Street address line 1 */
  addressLine1?: Maybe<Scalars['String']>;
  /** Street address line 2 */
  addressLine2?: Maybe<Scalars['String']>;
  /** State/Province */
  administrativeDistrictLevel1?: Maybe<Scalars['String']>;
  /** Business name */
  businessName?: Maybe<Scalars['String']>;
  /** ISO 3166-1 alpha-2 country code */
  country?: Maybe<Scalars['String']>;
  /** ISO 4217 currency code */
  currency?: Maybe<Scalars['String']>;
  /** Internal location record ID */
  id: Scalars['ID'];
  /** City */
  locality?: Maybe<Scalars['String']>;
  /** Location display name */
  name?: Maybe<Scalars['String']>;
  /** Contact phone number */
  phoneNumber?: Maybe<Scalars['String']>;
  /** Postal code */
  postalCode?: Maybe<Scalars['String']>;
  /** Square's location ID */
  squareId: Scalars['String'];
  /** Location type (PHYSICAL, MOBILE, WAREHOUSE) */
  squareType?: Maybe<Scalars['String']>;
  /** Location status (ACTIVE, INACTIVE) */
  status?: Maybe<Scalars['String']>;
  /** Terminals paired to this location */
  terminals: Array<GSquareTerminal>;
  /** IANA timezone identifier */
  timezone?: Maybe<Scalars['String']>;
};

/** A Square order */
export type GSquareOrder = {
  __typename?: 'SquareOrder';
  /** Order creation timestamp */
  createdAt?: Maybe<Scalars['String']>;
  /** Square order ID */
  id: Scalars['String'];
  /** Order line items */
  lineItems: Array<Scalars['JSON']>;
  /** Square location ID */
  locationId: Scalars['String'];
  /** Customer note */
  note?: Maybe<Scalars['String']>;
  /** Order state (OPEN, COMPLETED, CANCELED) */
  state: Scalars['String'];
  /** Total amount with currency */
  totalMoney?: Maybe<Scalars['JSON']>;
};

/** A suggested order parsed from voice transcript */
export type GSquareOrderSuggestion = {
  __typename?: 'SquareOrderSuggestion';
  /** Terminal checkout attempts */
  checkouts: Array<GSquareTerminalCheckout>;
  /** Creation timestamp */
  createdAt: Scalars['ISO8601DateTime'];
  /** Currency code */
  currency: Scalars['String'];
  /** Suggestion ID */
  id: Scalars['ID'];
  /** Suggested line items */
  lineItems: Array<GSquareOrderSuggestionLineItem>;
  /** Special requests extracted from transcript */
  note?: Maybe<Scalars['String']>;
  /** Suggestion status (pending, confirmed, canceled) */
  status: Scalars['String'];
  /** Total amount in cents */
  totalCents: Scalars['Int'];
  /** Original voice transcript */
  transcript: Scalars['String'];
  /** Items mentioned but not found in menu */
  unmatchedLineItems: Array<GUnmatchedItem>;
};

/** A line item in a Square order suggestion */
export type GSquareOrderSuggestionLineItem = {
  __typename?: 'SquareOrderSuggestionLineItem';
  /** Currency code (e.g., USD) */
  currency: Scalars['String'];
  /** POS modifiers applied to this item (e.g., Oat Milk, Half Vanilla) */
  modifiers?: Maybe<Array<GSquareOrderSuggestionLineItemModifier>>;
  /** Item name */
  name: Scalars['String'];
  /** Item-specific customization not in POS (e.g., 'extra hot') */
  note?: Maybe<Scalars['String']>;
  /** Unit price in cents */
  priceCents: Scalars['Int'];
  /** Item quantity */
  quantity: Scalars['Int'];
  /** Square catalog variation ID */
  variationId: Scalars['String'];
  /** Variation name (e.g., Large, Small) */
  variationName?: Maybe<Scalars['String']>;
};

/** Input for a line item in an order suggestion */
export type GSquareOrderSuggestionLineItemInput = {
  /** Currency code (defaults to USD) */
  currency?: InputMaybe<Scalars['String']>;
  /** Modifiers applied to this line item (omit to preserve existing) */
  modifiers?: InputMaybe<Array<GSquareOrderSuggestionLineItemModifierInput>>;
  /** Item name for display (resolved from catalog if omitted) */
  name?: InputMaybe<Scalars['String']>;
  /** Item-specific modifier or request (e.g., 'no foam', 'extra hot') */
  note?: InputMaybe<Scalars['String']>;
  /** Unit price in cents (resolved from catalog if omitted) */
  priceCents?: InputMaybe<Scalars['Int']>;
  /** Item quantity (must be positive) */
  quantity: Scalars['Int'];
  /** Square catalog variation ID */
  variationId: Scalars['String'];
  /** Variation name (resolved from catalog if omitted) */
  variationName?: InputMaybe<Scalars['String']>;
};

/** A modifier applied to a line item in a Square order suggestion */
export type GSquareOrderSuggestionLineItemModifier = {
  __typename?: 'SquareOrderSuggestionLineItemModifier';
  /** Square catalog modifier ID */
  id: Scalars['String'];
  /** Modifier name (e.g., 'Oat Milk', 'Half Vanilla') */
  name: Scalars['String'];
  /** Price adjustment in cents */
  priceCents: Scalars['Int'];
};

/** Input for a modifier on a line item in an order suggestion */
export type GSquareOrderSuggestionLineItemModifierInput = {
  /** Square catalog modifier ID */
  id: Scalars['String'];
  /** Modifier name (e.g., 'Oat Milk', 'Half Vanilla') */
  name?: InputMaybe<Scalars['String']>;
  /** Price adjustment in cents */
  priceCents?: InputMaybe<Scalars['Int']>;
};

/** A paired Square Terminal device */
export type GSquareTerminal = {
  __typename?: 'SquareTerminal';
  /** Creation timestamp */
  createdAt: Scalars['ISO8601DateTime'];
  /** Square device ID (manufacturers_id) */
  deviceId: Scalars['String'];
  /** Device type (e.g., TERMINAL) */
  deviceType?: Maybe<Scalars['String']>;
  /** Terminal record ID */
  id: Scalars['ID'];
  /** Device manufacturer */
  manufacturer?: Maybe<Scalars['String']>;
  /** Device model */
  model?: Maybe<Scalars['String']>;
  /** Terminal display name */
  name?: Maybe<Scalars['String']>;
  /** Associated Square location ID */
  squareLocationId: Scalars['ID'];
  /** Pairing status (PAIRED, UNPAIRED) */
  status: Scalars['String'];
  /** Device status category from Square (e.g., AVAILABLE, NEEDS_ATTENTION) */
  statusCategory?: Maybe<Scalars['String']>;
  /** Last sync timestamp from Square API */
  syncedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Last update timestamp */
  updatedAt: Scalars['ISO8601DateTime'];
  /** Device software version */
  version?: Maybe<Scalars['String']>;
};

/** A Square Terminal checkout tracking record */
export type GSquareTerminalCheckout = {
  __typename?: 'SquareTerminalCheckout';
  /** Total amount in cents */
  amountCents?: Maybe<Scalars['Int']>;
  /** When checkout was canceled */
  canceledAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Square checkout ID */
  checkoutId: Scalars['String'];
  /** When checkout was completed */
  completedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Creation timestamp */
  createdAt: Scalars['ISO8601DateTime'];
  /** Currency code */
  currency?: Maybe<Scalars['String']>;
  /** Checkout record ID */
  id: Scalars['ID'];
  /** Payment IDs from completed checkout */
  paymentIds: Array<Scalars['String']>;
  /** Checkout status (PENDING, IN_PROGRESS, COMPLETED, CANCELED) */
  status: Scalars['String'];
  /** Last updated timestamp */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** One order line in the Stage Gate drill-down: item plus its four stage quantities. */
export type GStageGateOrderLineDetail = {
  __typename?: 'StageGateOrderLineDetail';
  /** Units NetSuite committed (order_lines.committed_quantity; null committed = 0). */
  committedUnits: Scalars['Int'];
  /** Units delivered (order_lines.delivered_quantity; null until delivered). */
  deliveredUnits?: Maybe<Scalars['Int']>;
  /** Units fulfilled (order_lines.fulfillment_quantity; null until fulfilled). */
  fulfillmentUnits?: Maybe<Scalars['Int']>;
  /** The line item's name (nil when the item is unknown). */
  itemName?: Maybe<Scalars['String']>;
  /** Units ordered (order_lines.unit_quantity). */
  orderedUnits: Scalars['Int'];
};

/**
 * Route-grouped, per-order-line detail for a warehouse + delivery date + Stage
 * Gate step. See Resolvers::WarehouseStageGateOrderLines.
 */
export type GStageGateOrderLinesReport = {
  __typename?: 'StageGateOrderLinesReport';
  /** Routes with at least one stop with order lines after step filtering, in route order. */
  routes: Array<GStageGateRoute>;
  /**
   * Orders for the warehouse + delivery date that are not on any route, with order
   * lines after step filtering. Empty ones are omitted.
   */
  unroutedOrders: Array<GStageGateUnroutedOrder>;
};

/** A delivery route in the Stage Gate drill-down, holding its non-empty stops. */
export type GStageGateRoute = {
  __typename?: 'StageGateRoute';
  /** The delivery route's id. */
  routeId: Scalars['ID'];
  /** The delivery route's name (nil when unnamed). */
  routeName?: Maybe<Scalars['String']>;
  /** The route's stops that have order lines after step filtering, in stop sequence. */
  stops: Array<GStageGateStop>;
};

/** A Stage Gate step whose per-order-line drill-down is being requested. */
export enum GStageGateStep {
  /** Commitment step. Returns only lines where committed units differ from ordered units. */
  Commitment = 'COMMITMENT',
  /** Delivered step. Not yet filtered — returns all order lines. */
  Delivered = 'DELIVERED',
  /** Fulfilled step. Returns only lines where fulfilled units differ from committed units. */
  Fulfilled = 'FULFILLED',
  /** Picked step. Not yet filtered — returns all order lines. */
  Picked = 'PICKED',
  /** Sync step. Not yet filtered — returns all order lines. */
  Sync = 'SYNC'
}

/**
 * One order at a stop in the Stage Gate drill-down. A stop with several orders
 * yields one entry per order, all sharing the same stopNumber.
 */
export type GStageGateStop = {
  __typename?: 'StageGateStop';
  /** The order location's business name (nil when the order has no location). */
  locationName?: Maybe<Scalars['String']>;
  /** The order's lines relevant to the requested step. */
  orderLines: Array<GStageGateOrderLineDetail>;
  /** The order's id. */
  orderNumber: Scalars['ID'];
  /** The stop's 1-indexed sequence position (sequence_number + 1). */
  stopNumber: Scalars['Int'];
};

/**
 * An order for the warehouse + delivery date that is not on any route, so it has
 * no stop. Surfaced alongside routes so the drill-down covers the same orders the
 * gate card counts.
 */
export type GStageGateUnroutedOrder = {
  __typename?: 'StageGateUnroutedOrder';
  /** The order location's business name (nil when the order has no location). */
  locationName?: Maybe<Scalars['String']>;
  /** The order's lines relevant to the requested step. */
  orderLines: Array<GStageGateOrderLineDetail>;
  /** The order's id. */
  orderNumber: Scalars['ID'];
};

/** Error indicating a cart fingerprint mismatch. */
export type GStaleCartError = GError & {
  __typename?: 'StaleCartError';
  /** Current cart info. */
  currentCart: GCart;
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating a config edition mismatch */
export type GStaleConfigError = {
  __typename?: 'StaleConfigError';
  /** Current config info */
  currentConfig: GConfig;
  /** A description of the error */
  message: Scalars['String'];
};

/** Error indicating a request was made using outdated refund info. */
export type GStaleConsumerRefundInfoError = GError & {
  __typename?: 'StaleConsumerRefundInfoError';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Error indicating an object lock version mismatch. */
export type GStaleObjectError = GError & {
  __typename?: 'StaleObjectError';
  /** Object ID. */
  id: Scalars['ID'];
  /** A description of the error. */
  message: Scalars['String'];
};

export type GStandaloneVehicleInspectionDrive = {
  __typename?: 'StandaloneVehicleInspectionDrive';
  /** Warehouse-local date the drive's first report was submitted. */
  driveDate: Scalars['ISO8601Date'];
  /** Name of the driver who submitted the first report. */
  driverName?: Maybe<Scalars['String']>;
  /** True when any issue was reported across the drive's pre/post inspections. */
  hasIssues: Scalars['Boolean'];
  /** Total issues reported across the drive's pre/post inspections; the authoritative issue total. */
  issueCount: Scalars['Int'];
  /** Labels of the flagged questions across the drive's pre/post inspections, de-duplicated. May be fewer than issueCount; use issueCount for the total. */
  issueLabels: Array<Scalars['String']>;
  /** Post-trip inspection status; submitted is false until the drive is completed. */
  post: GVehicleInspectionPhaseStatus;
  /** Pre-trip inspection status. */
  pre: GVehicleInspectionPhaseStatus;
  standaloneDriveId: Scalars['ID'];
  /** The truck that was driven. */
  truck: GTruck;
};

export type GStandaloneVehicleInspectionReport = {
  __typename?: 'StandaloneVehicleInspectionReport';
  driver?: Maybe<GDriver>;
  hasIssues: Scalars['Boolean'];
  id: Scalars['ID'];
  inspectionType: Scalars['String'];
  issueCount: Scalars['Int'];
  photos: Array<GVehicleInspectionPhoto>;
  responses: Scalars['JSON'];
  schemaVersion: Scalars['Int'];
  /** Client-generated id pairing the pre and post report of one routeless drive. */
  standaloneDriveId: Scalars['ID'];
  submittedAt: Scalars['ISO8601DateTime'];
  /** Display name captured at submission; legacy reports fall back to responses or the associated driver. */
  submittedByName?: Maybe<Scalars['String']>;
  /** Authenticated user id captured at submission; legacy reports fall back to the associated driver. */
  submittedByUserId?: Maybe<Scalars['String']>;
  truck: GTruck;
  warehouse: GWarehouse;
};


/** Catch-all error type. */
export type GStandardError = GError & {
  __typename?: 'StandardError';
  /** A description of the error. */
  message: Scalars['String'];
};

export type GStandingAppointment = {
  __typename?: 'StandingAppointment';
  createdAt: Scalars['ISO8601DateTime'];
  /** Warehouse-local wall clock, e.g. "10:00". */
  earliestTime: Scalars['String'];
  effectiveFrom: Scalars['ISO8601Date'];
  effectiveUntil: Scalars['ISO8601Date'];
  freightType: GFreightType;
  id: Scalars['ID'];
  /** Warehouse-local wall clock, e.g. "13:00". */
  latestTime: Scalars['String'];
  netsuiteInternalId: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
  vendorName: Scalars['String'];
  warehouse: GWarehouse;
  /** Ruby Date#wday values (0=Sunday..6=Saturday). */
  weekdays: Array<Scalars['Int']>;
};

export type GStandingAppointmentAlreadyResolved = GUserErrorInterface & {
  __typename?: 'StandingAppointmentAlreadyResolved';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of StandingAppointmentCreate */
export type GStandingAppointmentCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Warehouse-local wall clock, e.g. "10:00". */
  earliestTime: Scalars['String'];
  effectiveFrom: Scalars['ISO8601Date'];
  effectiveUntil: Scalars['ISO8601Date'];
  freightType: GFreightType;
  /** Warehouse-local wall clock, e.g. "13:00". */
  latestTime: Scalars['String'];
  netsuiteInternalId: Scalars['String'];
  vendorName: Scalars['String'];
  warehouseId: Scalars['ID'];
  weekdays: Array<Scalars['Int']>;
};

/** Autogenerated return type of StandingAppointmentCreate. */
export type GStandingAppointmentCreatePayload = {
  __typename?: 'StandingAppointmentCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  createdBookings: Array<GDockBooking>;
  failedDates: Array<Scalars['ISO8601Date']>;
  standingAppointment?: Maybe<GStandingAppointment>;
  userErrors: Array<GStandingAppointmentError>;
};

export type GStandingAppointmentDirectoryEntry = {
  __typename?: 'StandingAppointmentDirectoryEntry';
  standingAppointment: GStandingAppointment;
  status: GStandingAppointmentDirectoryStatus;
};

export enum GStandingAppointmentDirectoryStatus {
  /** Currently effective, no unresolved gaps, not expiring soon. */
  Active = 'ACTIVE',
  /** effectiveUntil has already passed. */
  Ended = 'ENDED',
  /** effectiveUntil falls within the next 14 days. */
  Expiring = 'EXPIRING',
  /** At least one of the rule's own occurrence dates has no booking at all — a materialization failure ops hasn't resolved yet. */
  Gaps = 'GAPS'
}

/** Standing appointment possible error types */
export type GStandingAppointmentError = GDockBookingWarehouseNotFound | GDockWindowNotFound | GStandingAppointmentAlreadyResolved | GStandingAppointmentIdNotFound | GStandingAppointmentInvalidDate | GStandingAppointmentNotAllowed | GStandingAppointmentNotFound | GStandingAppointmentUnresolvable;

export type GStandingAppointmentIdNotFound = GUserErrorInterface & {
  __typename?: 'StandingAppointmentIdNotFound';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GStandingAppointmentInvalidDate = GUserErrorInterface & {
  __typename?: 'StandingAppointmentInvalidDate';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GStandingAppointmentNotAllowed = GUserErrorInterface & {
  __typename?: 'StandingAppointmentNotAllowed';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GStandingAppointmentNotFound = GUserErrorInterface & {
  __typename?: 'StandingAppointmentNotFound';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of StandingAppointmentResolveFailedDate */
export type GStandingAppointmentResolveFailedDateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  date: Scalars['ISO8601Date'];
  /** Pick a specific candidate window instead of the least-over-cap default. */
  dockWindowId?: InputMaybe<Scalars['ID']>;
  standingAppointmentId: Scalars['ID'];
};

/** Autogenerated return type of StandingAppointmentResolveFailedDate. */
export type GStandingAppointmentResolveFailedDatePayload = {
  __typename?: 'StandingAppointmentResolveFailedDatePayload';
  booking?: Maybe<GDockBooking>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userErrors: Array<GStandingAppointmentError>;
};

export type GStandingAppointmentUnresolvable = GUserErrorInterface & {
  __typename?: 'StandingAppointmentUnresolvable';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of StandingAppointmentUpdateEffectiveUntil */
export type GStandingAppointmentUpdateEffectiveUntilInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  effectiveUntil: Scalars['ISO8601Date'];
  id: Scalars['ID'];
};

/** Autogenerated return type of StandingAppointmentUpdateEffectiveUntil. */
export type GStandingAppointmentUpdateEffectiveUntilPayload = {
  __typename?: 'StandingAppointmentUpdateEffectiveUntilPayload';
  cancelledBookings: Array<GDockBooking>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  createdBookings: Array<GDockBooking>;
  failedDates: Array<Scalars['ISO8601Date']>;
  standingAppointment?: Maybe<GStandingAppointment>;
  userErrors: Array<GStandingAppointmentError>;
};

export enum GStandingOrderBehavior {
  Available = 'AVAILABLE',
  NotAvailable = 'NOT_AVAILABLE'
}

/** A SKU with its standing order information for a specific day */
export type GStandingOrderSku = {
  __typename?: 'StandingOrderSku';
  /** The day name (e.g., "Monday", "Tuesday") */
  dayName: Scalars['String'];
  /** The day of the week as an integer (0=Sunday, 1=Monday, ..., 6=Saturday) */
  dayOfWeek: Scalars['Int'];
  /** Standing order quantity (unit quantity) */
  quantity: Scalars['Int'];
  /** The SKU that has a standing order amount */
  sku: GSku;
};

/** Autogenerated input type of StartCustomerTagImportMutation */
export type GStartCustomerTagImportMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  customerTagImportId: Scalars['ID'];
  /** The value createCustomerTagImport returned, after the PUT succeeded. */
  signedBlobId: Scalars['String'];
};

/** Autogenerated return type of StartCustomerTagImportMutation. */
export type GStartCustomerTagImportMutationPayload = {
  __typename?: 'StartCustomerTagImportMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  customerTagImport?: Maybe<GCustomerTagImport>;
  errors: Array<Scalars['String']>;
};

/** Autogenerated input type of StartPhoneNumberVerification */
export type GStartPhoneNumberVerificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Phone number in E.164 format, but without the "+" prefix. E.g. "15551231234". */
  phoneNumber: Scalars['String'];
  /** Phone verification application key. */
  phoneVerificationKey?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of StartPhoneNumberVerification */
export type GStartPhoneNumberVerificationPayload = {
  __typename?: 'StartPhoneNumberVerificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to start phone number verification. */
  result: GStartPhoneNumberVerificationResult;
};

/** Result of attempting to start phone number verification. */
export type GStartPhoneNumberVerificationResult = GErrorsResult | GPhoneNumberVerificationStarted;

/** Autogenerated input type of StartRouteTimeUpdate */
export type GStartRouteTimeUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Delivery route id. */
  deliveryRouteId: Scalars['ID'];
};

/** Autogenerated return type of StartRouteTimeUpdate. */
export type GStartRouteTimeUpdatePayload = {
  __typename?: 'StartRouteTimeUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  route?: Maybe<GRoute>;
  userErrors: Array<GRouteError>;
};

/** Autogenerated input type of StopBatchOnboardRunMutation */
export type GStopBatchOnboardRunMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  runId: Scalars['ID'];
};

/** Autogenerated return type of StopBatchOnboardRunMutation. */
export type GStopBatchOnboardRunMutationPayload = {
  __typename?: 'StopBatchOnboardRunMutationPayload';
  batchOnboardRun?: Maybe<GBatchOnboardRun>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
};

export type GStopCrossingEvent = {
  __typename?: 'StopCrossingEvent';
  /** Whether the driver entered or exited the stop geofence. */
  kind: GStopCrossingKind;
  /** Client-reported time of the crossing (the driver-app occurredAt). */
  occurredAt: Scalars['ISO8601DateTime'];
  /** True when the stop was already completed as this crossing fired — a post-completion revisit. */
  postCompletion: Scalars['Boolean'];
};

/** Direction of a geofence stop crossing. */
export enum GStopCrossingKind {
  /** The driver crossed into the stop geofence (an arrival). */
  Enter = 'ENTER',
  /** The driver crossed out of the stop geofence (a departure). */
  Exit = 'EXIT'
}

export type GStopEstimates = {
  __typename?: 'StopEstimates';
  /** Estimated distance in miles for the stop from previous way point. */
  distance?: Maybe<Scalars['Float']>;
  /** Raw HH:MM string for the estimated finish time in 24 hour rolling windows (may exceed '23:59'). */
  finish?: Maybe<Scalars['String']>;
  /** Date/time representing the estimated finish using delivery date as reference point. */
  finishDatetime?: Maybe<Scalars['ISO8601DateTime']>;
  /** Route number the stop is assigned to. */
  routeNumber?: Maybe<Scalars['Int']>;
  /** Sequence number of the stop in the route. */
  sequenceNumber?: Maybe<Scalars['Int']>;
  /** Raw HH:MM string for the estimated start time in 24 hour rolling windows (may exceed '23:59'). */
  start?: Maybe<Scalars['String']>;
  /** Date/time representing the estimated start using delivery date as reference point. */
  startDatetime?: Maybe<Scalars['ISO8601DateTime']>;
};

export type GStopHasNoFulfilledLines = GUserErrorInterface & {
  __typename?: 'StopHasNoFulfilledLines';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GStopHasNoOrderLines = GUserErrorInterface & {
  __typename?: 'StopHasNoOrderLines';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GStopInput = {
  id: Scalars['ID'];
};

/** Autogenerated input type of StopRouteTimeUpdate */
export type GStopRouteTimeUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Delivery route id. */
  deliveryRouteId: Scalars['ID'];
};

/** Autogenerated return type of StopRouteTimeUpdate. */
export type GStopRouteTimeUpdatePayload = {
  __typename?: 'StopRouteTimeUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  route?: Maybe<GRoute>;
  userErrors: Array<GRouteError>;
};

export type GStopVisit = {
  __typename?: 'StopVisit';
  /** Seconds on site for this visit (exited_at - entered_at), or null if either end is missing. */
  dwellSeconds?: Maybe<Scalars['Int']>;
  /** When the driver entered the geofence for this visit; null if the ENTER crossing was never recorded. */
  enteredAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** When the driver left the geofence for this visit; null if still on site or the EXIT crossing was never recorded. */
  exitedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** True when this visit occurred after the stop was completed — a revisit. */
  postCompletion: Scalars['Boolean'];
};

export type GStopWithProvider = GUserErrorInterface & {
  __typename?: 'StopWithProvider';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GStopsBusy = GUserErrorInterface & {
  __typename?: 'StopsBusy';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GStopsNotEscalatable = GUserErrorInterface & {
  __typename?: 'StopsNotEscalatable';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** Represents a stream of messages for a specific account or account-profile on a platform. */
export type GStream = {
  __typename?: 'Stream';
  /** Timestamp of when the stream was created */
  createdAt: Scalars['ISO8601DateTime'];
  /**
   * Cursor used by the sync system to determine the approxiamte starting point for
   * the data to sync in the next synchronization attempt
   */
  dataStartingAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Identifier for the entity (e.g., account ID or profile ID) */
  entityId: Scalars['String'];
  /** Type of entity the stream is associated with (e.g., 'account', 'profile') */
  entityType: Scalars['String'];
  /** Reason for halting the stream, if applicable */
  haltedReason?: Maybe<Scalars['String']>;
  /** Unique identifier for the stream */
  id: Scalars['ID'];
  /** Timestamp of the last successful synchronization */
  lastSucceededAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Timestamp for the next synchronization attempt */
  nextSyncOn: Scalars['ISO8601DateTime'];
  /** Current status of the stream (e.g., 'ready', 'halted') */
  status: Scalars['String'];
  /** Timestamp of when the stream was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** A Stripe checkout session for subscription payments */
export type GStripeCheckoutSession = {
  __typename?: 'StripeCheckoutSession';
  /** Creation timestamp */
  createdAt: Scalars['ISO8601DateTime'];
  /** Customer email from Stripe checkout session */
  customerEmail?: Maybe<Scalars['String']>;
  /** Customer first name from Stripe checkout session */
  customerFirstName?: Maybe<Scalars['String']>;
  /** Customer last name from Stripe checkout session */
  customerLastName?: Maybe<Scalars['String']>;
  /** Unique identifier */
  id: Scalars['ID'];
  /** Local status tracking */
  status: Scalars['String'];
  /** Stripe checkout session ID */
  stripeSessionId: Scalars['String'];
  /** Status from Stripe webhook/API */
  stripeStatus?: Maybe<Scalars['String']>;
  /** Last update timestamp */
  updatedAt: Scalars['ISO8601DateTime'];
};

export type GSubcategorySpendDetail = {
  __typename?: 'SubcategorySpendDetail';
  /** Projected subcategory spend for this location (= location.spend_90d × warehouse subcategory_share_pct / 100). */
  expectedSpendCents: Scalars['Int'];
  /** Opportunity dollars: max(expected_spend_cents - location_spend_cents, 0). */
  gapCents: Scalars['Int'];
  locationSpendCents: Scalars['Int'];
  parentCategoryId?: Maybe<Scalars['ID']>;
  parentCategoryName?: Maybe<Scalars['String']>;
  subcategoryId: Scalars['ID'];
  subcategoryName?: Maybe<Scalars['String']>;
  /**
   * 90-day median location spend for this subcategory across the warehouse.
   * Retained for sales context alongside expected_spend_cents.
   */
  warehouseMedianCents: Scalars['Int'];
};

/** Submenu. */
export type GSubmenu = GNode & {
  __typename?: 'Submenu';
  /** Globally unique object ID (not to be confused with a database-assigned id unique within a single type) */
  id: Scalars['ID'];
  /** Submenu's current lock version, providing concurrency control and protection against stale updates. */
  lockVersion: Scalars['Int'];
  /** Menu items. */
  menuItems: Array<GMenuItem>;
  /** Name. */
  name: Scalars['String'];
  /**
   * Hours the submenu is available, in merchant's time zone. Order pickup times
   * cannot be outside the bounds described by these hours when ordering from this submenu.
   */
  operatingHours: Array<GOperatingHoursForDayOfWeek>;
  /** The order of the submenu in the UI. */
  sortOrder: Scalars['Int'];
  /** Visibility. */
  visibility: GVisibility;
};

/** Submenu mutation result. */
export type GSubmenuResult = GErrorsResult | GSubmenuSuccess;

/** Result of a successful submenu mutation. */
export type GSubmenuSuccess = {
  __typename?: 'SubmenuSuccess';
  /** Resulting submenu. */
  submenu: GSubmenu;
};

/** Result of mutating a list of submenus. */
export type GSubmenusResult = GErrorsResult | GSubmenusSuccess;

/** Result of successfully mutating a list of submenus. */
export type GSubmenusSuccess = {
  __typename?: 'SubmenusSuccess';
  /** Resulting submenus. */
  submenus: Array<GSubmenu>;
};

/** Autogenerated input type of SubmitCheckInMutation */
export type GSubmitCheckInMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Email address of the guest */
  email: Scalars['String'];
  /** ID of the microsite location */
  micrositeLocationId: Scalars['ID'];
};

/** Autogenerated return type of SubmitCheckInMutation. */
export type GSubmitCheckInMutationPayload = {
  __typename?: 'SubmitCheckInMutationPayload';
  /** The created check-in entry */
  checkInEntry?: Maybe<GCheckInEntry>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']>;
  /** When the user can next check in (returned when already checked in today) */
  nextCheckInAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Autogenerated input type of SubmitMailingListMutation */
export type GSubmitMailingListMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Guest's email address */
  email: Scalars['String'];
  /** Guest's first name */
  firstName?: InputMaybe<Scalars['String']>;
  /** Guest's last name */
  lastName?: InputMaybe<Scalars['String']>;
  /** ID of the microsite location */
  micrositeLocationId: Scalars['ID'];
  /** Guest's phone number (optional) */
  phoneNumber?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of SubmitMailingListMutation. */
export type GSubmitMailingListMutationPayload = {
  __typename?: 'SubmitMailingListMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The newly added guest with their contact information */
  guest?: Maybe<GMailingListGuest>;
  /** Mailing list metadata including Google Sheet URL */
  mailingList?: Maybe<GMicrositeMailingList>;
};

export type GSubmitPurchaseHistoryFeedbackInput = {
  itemId: Scalars['ID'];
  locationId: Scalars['ID'];
  reason: GRecommendationFeedbackReason;
};

export type GSubmitPurchaseHistoryFeedbackPayload = {
  __typename?: 'SubmitPurchaseHistoryFeedbackPayload';
  errors: Array<GPurchaseHistoryFeedbackError>;
  responseType?: Maybe<GRecommendationFeedbackType>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of SubmitScoreMutation */
export type GSubmitScoreMutationInput = {
  /** When the score was achieved (defaults to now) */
  achievedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Email address for the player (optional, private) */
  email?: InputMaybe<Scalars['String']>;
  /** Slug of the game */
  gameSlug: Scalars['String'];
  /** Slug of the leaderboard within the game */
  leaderboardSlug: Scalars['String'];
  /** Additional entry metadata */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** ID of the microsite location */
  micrositeLocationId?: InputMaybe<Scalars['ID']>;
  /** The player's score */
  score: Scalars['Int'];
  /** Secondary score for tiebreaking */
  subscore?: InputMaybe<Scalars['Int']>;
  /** Display name for the player */
  username: Scalars['String'];
};

/** Autogenerated return type of SubmitScoreMutation. */
export type GSubmitScoreMutationPayload = {
  __typename?: 'SubmitScoreMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']>;
  /** The created leaderboard entry */
  leaderboardEntry?: Maybe<GLeaderboardEntry>;
};

/** Autogenerated input type of SubmitStockCountMutation */
export type GSubmitStockCountMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** PROTOTYPE id of the LocationStockCount session to submit. */
  stockCountId: Scalars['ID'];
};

/** Autogenerated return type of SubmitStockCountMutation. */
export type GSubmitStockCountMutationPayload = {
  __typename?: 'SubmitStockCountMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  /** PROTOTYPE the location Stock Count submitted by this mutation. */
  submittedStockCount?: Maybe<GLocationStockCount>;
};

/** Autogenerated input type of SubmitSuggestionMutation */
export type GSubmitSuggestionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Email of the submitter (optional) */
  contactEmail?: InputMaybe<Scalars['String']>;
  /** Name of the submitter (optional) */
  contactName?: InputMaybe<Scalars['String']>;
  /** The feedback text (max 1000 characters) */
  feedback: Scalars['String'];
  /** ID of the microsite location */
  micrositeLocationId: Scalars['ID'];
};

/** Autogenerated return type of SubmitSuggestionMutation. */
export type GSubmitSuggestionMutationPayload = {
  __typename?: 'SubmitSuggestionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']>;
  /** Whether to prompt for Google review (true for positive sentiment) */
  showGoogleReviewPrompt: Scalars['Boolean'];
  /** The created suggestion entry */
  suggestionEntry?: Maybe<GMicrositeSuggestionEntry>;
};

/** A subscription session for marketing tools signup */
export type GSubscriptionSession = {
  __typename?: 'SubscriptionSession';
  /** Business name from Google Places */
  businessName?: Maybe<Scalars['String']>;
  /** Creation timestamp */
  createdAt: Scalars['ISO8601DateTime'];
  /** Customer first name from Stripe checkout session */
  customerFirstName?: Maybe<Scalars['String']>;
  /** Customer last name from Stripe checkout session */
  customerLastName?: Maybe<Scalars['String']>;
  /** User email address (may be null in multi-step flows) */
  email?: Maybe<Scalars['String']>;
  /** Auth0 user ID if existing user */
  existingAuth0UserId?: Maybe<Scalars['String']>;
  /** Google Places API place ID */
  googlePlaceId: Scalars['String'];
  /** Unique identifier */
  id: Scalars['ID'];
  /** Whether this is a new user signup */
  newUser: Scalars['Boolean'];
  /** Associated pricing package for this subscription */
  pricingPackage?: Maybe<GPricingPackage>;
  /** Frontend origin URL for return navigation */
  returnOrigin: Scalars['String'];
  /** Context of session creation */
  sessionContext: Scalars['String'];
  /** Physical sign color preference */
  signColor?: Maybe<Scalars['String']>;
  /** Physical sign material preference (optional if kit not purchased) */
  signMaterial?: Maybe<Scalars['String']>;
  /** Associated signage order for sign production tracking */
  signageOrder?: Maybe<GSignageOrder>;
  /** Session status */
  status: Scalars['String'];
  /** Associated Stripe checkout session */
  stripeCheckoutSession?: Maybe<GStripeCheckoutSession>;
  /** Last update timestamp */
  updatedAt: Scalars['ISO8601DateTime'];
  /** URL-friendly slug for microsite */
  urlSlug: Scalars['String'];
};

/**
 * A curated substitution override — a human-picked substitute for a source item that ranks above the
 * rule engine's dynamic recommendations. Managed by Procurement.
 */
export type GSubstitutionOverride = {
  __typename?: 'SubstitutionOverride';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  /** Higher sorts first; ties break by creation order. */
  priority: Scalars['Int'];
  /** Optional free-text note on why this override exists (e.g. audit-preserve). */
  reason?: Maybe<Scalars['String']>;
  /**
   * Where this override came from. Read-only — set when the row is created and never rewritten, so a
   * bulk-imported pair stays distinguishable from a deliberate one.
   */
  source: GSubstitutionOverrideSource;
  /** The substitute item this override points to. */
  substituteItem: GSupplyItem;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** A validation error on a substitution override mutation. */
export type GSubstitutionOverrideError = {
  __typename?: 'SubstitutionOverrideError';
  field?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** Result of an override mutation: the affected override (null on validation failure) plus any errors. */
export type GSubstitutionOverridePayload = {
  __typename?: 'SubstitutionOverridePayload';
  errors: Array<GSubstitutionOverrideError>;
  override?: Maybe<GSubstitutionOverride>;
};

/**
 * Provenance of a substitution override. `LEGACY_HASH_IMPORT` pairs were carried over wholesale from
 * the retired hardcoded OOS substitution list and were never individually reviewed, so they may not
 * satisfy the dietary or refrigeration constraints the rule engine enforces on its own candidates.
 */
export enum GSubstitutionOverrideSource {
  Human = 'HUMAN',
  LegacyHashImport = 'LEGACY_HASH_IMPORT'
}

export enum GSuggestedActionEnum {
  /** Location at risk of churning */
  ChurnRisk = 'CHURN_RISK',
  /** Location with expansion opportunity */
  Expansion = 'EXPANSION',
  /** Location eligible for win-back */
  Winback = 'WINBACK'
}

export type GSupplierInvoice = {
  __typename?: 'SupplierInvoice';
  externalSupplier?: Maybe<GExternalSupplier>;
  file?: Maybe<GSupplierInvoiceFile>;
  id: Scalars['ID'];
  invoiceDate?: Maybe<Scalars['ISO8601Date']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  odekoUuid: Scalars['ID'];
  prospectiveLocation: GProspectiveLocation;
  status: Scalars['String'];
  uploadedBy: Scalars['String'];
  warehouseId: Scalars['ID'];
};

export type GSupplierInvoiceComparison = {
  __typename?: 'SupplierInvoiceComparison';
  createdAt: Scalars['ISO8601DateTime'];
  createdBy: Scalars['String'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  odekoUuid: Scalars['ID'];
  prospectiveLocation: GProspectiveLocation;
  status: Scalars['String'];
  supplierInvoiceComparisonInvoices: Array<GSupplierInvoiceComparisonInvoice>;
  supplierInvoiceComparisonRows: GSupplierInvoiceComparisonRowConnection;
  supplierInvoices: Array<GSupplierInvoice>;
  warehouseId: Scalars['ID'];
};


export type GSupplierInvoiceComparisonSupplierInvoiceComparisonRowsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type GSupplierInvoiceComparisonInvoice = {
  __typename?: 'SupplierInvoiceComparisonInvoice';
  position?: Maybe<Scalars['Int']>;
  supplierInvoice: GSupplierInvoice;
};

export type GSupplierInvoiceComparisonParsedRowInput = {
  clientRowId: Scalars['String'];
  invoicePackItemSizeUnit?: InputMaybe<Scalars['String']>;
  invoicePackItemSizeValue?: InputMaybe<Scalars['Decimal']>;
  invoicePackSaleUnit?: InputMaybe<Scalars['String']>;
  invoicePackUnitsPerSale?: InputMaybe<Scalars['Decimal']>;
  invoiceQty: Scalars['Decimal'];
  invoiceUnitPriceCents: Scalars['Int'];
  rawName: Scalars['String'];
  rawSku?: InputMaybe<Scalars['String']>;
  supplierInvoiceId?: InputMaybe<Scalars['ID']>;
  vendorName?: InputMaybe<Scalars['String']>;
};

export type GSupplierInvoiceComparisonRow = {
  __typename?: 'SupplierInvoiceComparisonRow';
  clientRowId: Scalars['String'];
  id: Scalars['ID'];
  invoicePackItemSizeUnit?: Maybe<Scalars['String']>;
  invoicePackItemSizeValue?: Maybe<Scalars['QuantityDecimal']>;
  invoicePackSaleUnit: Scalars['String'];
  invoicePackUnitsPerSale: Scalars['QuantityDecimal'];
  invoiceQty: Scalars['QuantityDecimal'];
  invoiceUnitPriceCents: Scalars['Int'];
  odekoUuid: Scalars['ID'];
  position: Scalars['Int'];
  rawName: Scalars['String'];
  rawSku: Scalars['String'];
  supplierInvoice?: Maybe<GSupplierInvoice>;
  vendorName: Scalars['String'];
};

/** The connection type for SupplierInvoiceComparisonRow. */
export type GSupplierInvoiceComparisonRowConnection = {
  __typename?: 'SupplierInvoiceComparisonRowConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GSupplierInvoiceComparisonRowEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GSupplierInvoiceComparisonRow>>>;
  /** Information to aid in pagination. */
  pageInfo: GPageInfo;
};

/** An edge in a connection. */
export type GSupplierInvoiceComparisonRowEdge = {
  __typename?: 'SupplierInvoiceComparisonRowEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GSupplierInvoiceComparisonRow>;
};

export type GSupplierInvoiceComparisonRowMapping = {
  __typename?: 'SupplierInvoiceComparisonRowMapping';
  clientRowId: Scalars['String'];
  supplierInvoiceComparisonRow: GSupplierInvoiceComparisonRow;
};

export type GSupplierInvoiceFile = {
  __typename?: 'SupplierInvoiceFile';
  byteSize: Scalars['Int'];
  contentType?: Maybe<Scalars['String']>;
  filename: Scalars['String'];
};

/** User's supply cart at a specific location */
export type GSupplyCart = {
  __typename?: 'SupplyCart';
  cartItems: Array<GSupplyCartItem>;
  /** Cart UUID */
  id: Scalars['ID'];
  /** Number of distinct (itemUuid, deliveryDate) rows on the cart */
  itemCount: Scalars['Int'];
  location: GLocation;
};

/** An item in a supply cart; identity is (itemUuid, deliveryDate, vendor) within parent SupplyCart */
export type GSupplyCartItem = {
  __typename?: 'SupplyCartItem';
  createdAt: Scalars['ISO8601DateTime'];
  deliveryDate: Scalars['ISO8601Date'];
  /** Item identifier from IMS */
  itemUuid: Scalars['ID'];
  /** Next available delivery date for this row's vendor. Null when the saved deliveryDate is today or later. */
  nextAvailableDeliveryDate?: Maybe<Scalars['ISO8601Date']>;
  quantity: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
  /** Vendor that owns this cart row. Null for legacy rows written before vendor scoping. */
  vendor?: Maybe<GVendor>;
};

/** Platform that last modified the supply cart */
export enum GSupplyCartPlatformEnum {
  /** Cart modified via Android mobile app */
  MobileAndroid = 'MOBILE_ANDROID',
  /** Cart modified via iOS mobile app */
  MobileIos = 'MOBILE_IOS',
  /** Cart modified via web portal */
  WebPortal = 'WEB_PORTAL'
}

/** Autogenerated input type of SupplyClearCart */
export type GSupplyClearCartInput = {
  channel?: InputMaybe<GSupplyCartPlatformEnum>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  locationId: Scalars['ID'];
};

/** Autogenerated return type of SupplyClearCart. */
export type GSupplyClearCartPayload = {
  __typename?: 'SupplyClearCartPayload';
  cart?: Maybe<GSupplyCart>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GUserError>;
};

/**
 * An interface is used to represent items to mandate what fields are needed for
 * items. Having a single object with all fields was rejected because that would
 * remove the ability to ensure a type of item has all of its required fields.
 */
export type GSupplyItem = {
  brand?: Maybe<GItemBrand>;
  /** @deprecated Use brand */
  brandName: Scalars['String'];
  /** (Package Height x Package Width x Package Length)/DIM factor */
  caseDimensionalWeightLbs?: Maybe<Scalars['Float']>;
  caseHeightInches?: Maybe<Scalars['Float']>;
  caseLengthInches?: Maybe<Scalars['Float']>;
  caseVolumeCuInches?: Maybe<Scalars['Float']>;
  caseWeightLbs?: Maybe<Scalars['Float']>;
  caseWidthInches?: Maybe<Scalars['Float']>;
  casesPerLayer?: Maybe<Scalars['Int']>;
  casesPerPallet?: Maybe<Scalars['Int']>;
  catalogStatus: GCatalogStatus;
  category: GCategory;
  createdAt: Scalars['ISO8601DateTime'];
  createdBy: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  /**
   * Drives pricing with carriers like FedEx.
   * This data is uploaded from Cubiscan dimensioning device to optimize shipping costs.
   */
  dimensionalFactor?: Maybe<Scalars['Float']>;
  dimensioned?: Maybe<Scalars['Boolean']>;
  /** (Package Height x Package Width x Package Length)/DIM factor */
  eachDimensionalWeightLbs?: Maybe<Scalars['Float']>;
  eachHeightInches?: Maybe<Scalars['Float']>;
  eachLengthInches?: Maybe<Scalars['Float']>;
  eachVolumeCuInches?: Maybe<Scalars['Float']>;
  eachWeightLbs?: Maybe<Scalars['Float']>;
  eachWidthInches?: Maybe<Scalars['Float']>;
  /** True if the item has its own image. When false and imgUrl is present, the image is a fallback from the category icon. */
  hasOwnImage: Scalars['Boolean'];
  id: Scalars['ID'];
  imgUrl?: Maybe<Scalars['String']>;
  /** When the item was marked inactive; null when active. An inactive item is a deliberately retired SKU — hidden by default from customer-facing and admin catalog/search surfaces (and inactive in NetSuite). */
  inactivatedOn?: Maybe<Scalars['ISO8601DateTime']>;
  /**
   * True when a shipping location can't order this item: it is refrigerated or frozen, or its
   * category or subcategory is Pastry or Baked Goods.
   */
  isShippingRestricted: Scalars['Boolean'];
  /** @deprecated Use size */
  itemSize?: Maybe<Scalars['String']>;
  layersPerPallet?: Maybe<Scalars['Int']>;
  /**
   * The most units, in the sale unit, that one location may order of this item across all its orders.
   * Null means no limit.
   */
  maxQuantityPerLocation?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  nmfc?: Maybe<Scalars['String']>;
  palletWeightLbs?: Maybe<Scalars['Float']>;
  /**
   * True when this item is currently a leading New Items pin — i.e. it won its slot in the resolved
   * result set. Reflects what shoppers see: an item filtered out of the result reads as not pinned.
   * Flag-gated; false when the new-item-pinning flag is off or the item isn't pinned.
   */
  pinned: Scalars['Boolean'];
  /** The absolute carousel slot this item actually rendered at when pinned; null when not pinned. */
  pinnedPosition?: Maybe<Scalars['Int']>;
  /**
   * Drives the storefront's "Sponsored" label. True for Algolia rule-promoted results and — behind the
   * new-item-pinning flag — for a sponsored New Items pin. A sponsored pin is distinguishable from an
   * Algolia promo by `pinned` (a sponsored pin is `promoted && pinned`).
   */
  promoted: Scalars['Boolean'];
  purchasePrice: GMoney;
  refrigerationState?: Maybe<GRefrigerationState>;
  saleUnit: GUnit;
  /** The most of this item's sample one location may ever order. Null means no limit, or no sample. */
  sampleMaxQuantityPerLocation?: Maybe<Scalars['Int']>;
  sampleUnit?: Maybe<GUnit>;
  size?: Maybe<GItemSize>;
  /**
   * The product-level standing-order setting. Read `standingOrderBehavior` on the warehouse
   * association instead, at all times: this value is not market-scoped, so once any market is
   * given a setting of its own it stops answering for that market.
   */
  standingOrderBehavior: GStandingOrderBehavior;
  subcategory?: Maybe<GCategory>;
  /**
   * The item's curated substitution overrides (source-side), highest priority first. Procurement's
   * editable layer that ranks above the rule engine's dynamic recommendations.
   */
  substitutionOverrides: Array<GSubstitutionOverride>;
  /**
   * Procurement preview of ranked substitutes for this item. With no `warehouseId`, ranks by
   * attribute/dietary match quality only (availability ignored) — the "are these good substitutes?"
   * view. With a `warehouseId`, returns the in-stock list a customer in that market would actually get.
   * Curated overrides rank first. Procurement surface — the customer path uses `InventoryWarehouseAssociation.substitutionCandidates`.
   */
  substitutionPreview: Array<GSupplyItem>;
  tags: Array<GItemTag>;
  transitMethod?: Maybe<GTransitMethod>;
  updatedAt: Scalars['ISO8601DateTime'];
  updatedBy: Scalars['String'];
  vendorCode?: Maybe<Scalars['String']>;
};


/**
 * An interface is used to represent items to mandate what fields are needed for
 * items. Having a single object with all fields was rejected because that would
 * remove the ability to ensure a type of item has all of its required fields.
 */
export type GSupplyItemSubstitutionPreviewArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  warehouseId?: InputMaybe<Scalars['ID']>;
};


/**
 * An interface is used to represent items to mandate what fields are needed for
 * items. Having a single object with all fields was rejected because that would
 * remove the ability to ensure a type of item has all of its required fields.
 */
export type GSupplyItemTagsArgs = {
  withDiscardedAt?: InputMaybe<Scalars['Boolean']>;
};

/** An edge in a connection. */
export type GSupplyItemEdge = {
  __typename?: 'SupplyItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GSupplyItem>;
};

/** Autogenerated input type of SupplyRemoveCartItem */
export type GSupplyRemoveCartItemInput = {
  channel?: InputMaybe<GSupplyCartPlatformEnum>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  deliveryDate: Scalars['ISO8601Date'];
  itemUuid: Scalars['ID'];
  locationId: Scalars['ID'];
  /**
   * Scopes the delete to the vendor's row. When omitted, removes all rows matching
   * (itemUuid, deliveryDate) regardless of vendor.
   */
  vendorUuid?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of SupplyRemoveCartItem. */
export type GSupplyRemoveCartItemPayload = {
  __typename?: 'SupplyRemoveCartItemPayload';
  cart?: Maybe<GSupplyCart>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GUserError>;
};

/** Autogenerated input type of SupplyUpsertCartItem */
export type GSupplyUpsertCartItemInput = {
  channel?: InputMaybe<GSupplyCartPlatformEnum>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  deliveryDate: Scalars['ISO8601Date'];
  itemUuid: Scalars['ID'];
  locationId: Scalars['ID'];
  quantity: Scalars['Int'];
  /** Vendor that owns this cart row. When omitted, the server resolves the vendor from the location's SKU for this item. */
  vendorUuid?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of SupplyUpsertCartItem. */
export type GSupplyUpsertCartItemPayload = {
  __typename?: 'SupplyUpsertCartItemPayload';
  cart?: Maybe<GSupplyCart>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GUserError>;
  /** Machine-readable reason when an ordering role refusal is why the item was not written */
  reason?: Maybe<Scalars['String']>;
};

export enum GSuppressionReasonEnum {
  /** Not-interested outreach within the last 30 days */
  NotInterested = 'NOT_INTERESTED',
  /** Reached or order_placed outreach within the last 7 days */
  RecentContact = 'RECENT_CONTACT',
  /** Order created within the last 3 days */
  RecentOrder = 'RECENT_ORDER'
}

export type GSurvey = {
  __typename?: 'Survey';
  completed: Scalars['Boolean'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  responses: Array<GSurveyResponse>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export enum GSurveyLevelEnum {
  /** Survey belongs to Company */
  Company = 'company',
  /** Survey belongs to Location */
  Location = 'location'
}

export type GSurveyResponse = {
  __typename?: 'SurveyResponse';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  question: Scalars['String'];
  response: Scalars['JSON'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type GSurveyResponseInput = {
  /** Survey question */
  question?: InputMaybe<Scalars['String']>;
  /** User answer */
  response: Scalars['JSON'];
};

/** Autogenerated input type of SyncMicrositeConfigMutation */
export type GSyncMicrositeConfigMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the GoogleDocsStream */
  streamId: Scalars['ID'];
};

/** Autogenerated return type of SyncMicrositeConfigMutation. */
export type GSyncMicrositeConfigMutationPayload = {
  __typename?: 'SyncMicrositeConfigMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Stream for the config document of the microsite location */
  configDocStream?: Maybe<GStream>;
};

export type GTaskAlreadyResolved = GUserErrorInterface & {
  __typename?: 'TaskAlreadyResolved';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GTaskNotFound = GUserErrorInterface & {
  __typename?: 'TaskNotFound';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GTaskNoteRequired = GUserErrorInterface & {
  __typename?: 'TaskNoteRequired';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** A Square Terminal checkout session */
export type GTerminalCheckout = {
  __typename?: 'TerminalCheckout';
  /** Amount to collect */
  amountMoney: Scalars['JSON'];
  /** Creation timestamp */
  createdAt?: Maybe<Scalars['String']>;
  /** Terminal device ID */
  deviceId?: Maybe<Scalars['String']>;
  /** Terminal checkout ID */
  id: Scalars['String'];
  /** Location ID */
  locationId?: Maybe<Scalars['String']>;
  /** Associated Square order ID */
  orderId?: Maybe<Scalars['String']>;
  /** Checkout status (PENDING, IN_PROGRESS, COMPLETED, CANCELED) */
  status: Scalars['String'];
};

/** Mark, unmark, dispatch or re-quote a route for a third-party provider, or escalate stops to one: possible error types */
export type GThirdPartyDispatchError = GDispatchNotAllowed | GDispatchProfileIncomplete | GProviderNotAvailable | GProviderRejected | GRouteNotFound | GRouteNotMarkable | GStopsNotEscalatable | GUnmarkNotAllowed;

/** An external delivery provider that can execute a route. */
export enum GThirdPartyProvider {
  /** Burq. Dispatched by API from the DMP, with status and proof flowing back. */
  Burq = 'burq',
  /** Metrobi. Handed over outside the DMP: the GM downloads the route CSV and uploads it, and completion is manual. */
  Metrobi = 'metrobi'
}

export type GTimePeriod = {
  __typename?: 'TimePeriod';
  countRatings: GCountRatings;
  countScans: Scalars['Int'];
};

export type GTimeseriesEntry = {
  __typename?: 'TimeseriesEntry';
  date: Scalars['ISO8601Date'];
  rating?: Maybe<Scalars['Float']>;
  ratingCount: Scalars['Int'];
};

/** Error indicating that tip cannot be set because merchant has not enabled tips. */
export type GTipsNotEnabled = GError & {
  __typename?: 'TipsNotEnabled';
  /** A description of the error. */
  message: Scalars['String'];
};

export type GTrafficCongestionFee = GFeeInterface & {
  __typename?: 'TrafficCongestionFee';
  /** The threshold amount in cents at which the fee is applied. */
  feeThresholds: Array<GFeeThreshold>;
  id: Scalars['ID'];
  /** Indicates if the fee is active or not. */
  isActive: Scalars['Boolean'];
  odekoUuid: Scalars['ID'];
  /** The amount of the traffic congestion fee in cents. */
  warehouseFeeAmountCents: Scalars['Int'];
  /** Unique identifier of the warehouse associated with this traffic congestion fee. */
  warehouseId: Scalars['ID'];
};

/**
 * A location's transaction-sync situation: which state it is in, how old that
 * state is, what the retained audit found, and what has been synced. Reading it
 * has no side effects — no NetSuite request and no republish work.
 */
export type GTransactionSync = {
  __typename?: 'TransactionSync';
  /** Whether an audit can be started: true whenever nothing is in flight. */
  auditEnabled: Scalars['Boolean'];
  /** Whether an audit is running right now. Blocks starting anything else. */
  auditInFlight: Scalars['Boolean'];
  /**
   * This location's sync attempts, newest first, including one still in flight.
   * Bounded and unpaginated: manual syncs for a single location are rare, so this
   * is a short list by construction rather than a browsable history.
   */
  history: Array<GTransactionSyncAttempt>;
  /**
   * The sync running right now, so a viewer arriving mid-sync re-attaches to it
   * rather than seeing nothing. Null when nothing is running.
   */
  inFlightSync?: Maybe<GTransactionSyncAttempt>;
  /**
   * Whether the retained audit comparison found nothing to fix. False when there
   * is no retained comparison at all, so it is a claim about what was checked
   * rather than the absence of a complaint.
   */
  inSync: Scalars['Boolean'];
  /** This location's audit row, carrying its retained comparison. Null when nothing has ever been audited here. */
  latestAudit?: Maybe<GTransactionSyncAudit>;
  /**
   * Whether the event this state is about happened yesterday or earlier. A
   * calendar-day comparison in the location's own zone, not an elapsed-time one,
   * so an event at 11 PM yesterday is stale at 8 AM today — and so every viewer
   * gets the same answer regardless of where they are.
   */
  stale: Scalars['Boolean'];
  state: GTransactionSyncState;
  /** When the event this state is about happened. Null for a location with no history, and for a sync that has not finished. */
  stateAt?: Maybe<Scalars['ISO8601DateTime']>;
  /**
   * Whether a sync can be started. A sync refreshes what an audit flagged, so it
   * needs a comparison made today that found something to fix, and nothing else running.
   */
  syncEnabled: Scalars['Boolean'];
  /**
   * The zone staleness was evaluated in. Displayed times belong in the viewer's
   * zone; this is the zone the stale flag was decided in.
   */
  timeZone: Scalars['String'];
};


/**
 * A location's transaction-sync situation: which state it is in, how old that
 * state is, what the retained audit found, and what has been synced. Reading it
 * has no side effects — no NetSuite request and no republish work.
 */
export type GTransactionSyncHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

/**
 * One manual refresh of a location's NetSuite records. Describes the attempt
 * itself, not the location's current audit or sync situation.
 */
export type GTransactionSyncAttempt = {
  __typename?: 'TransactionSyncAttempt';
  /** Identifies the republish work this sync asked for. The value to quote when escalating a sync that did not converge. */
  batchUuid: Scalars['ID'];
  /** Null while the sync is in flight. */
  completedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** How long the sync took. Null while it is in flight. */
  durationSeconds?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  /**
   * The location that was refreshed. Resolves even when this service holds no
   * local copy of it, so display fields still come from the subgraph that owns them.
   */
  location: GLocation;
  /** How far the sync has got. Still reported after it is over, as the record of what happened. */
  progress: GTransactionSyncProgress;
  /** How many records the sync asked NetSuite to republish. */
  recordCount: Scalars['Int'];
  /** The records the sync asked NetSuite to publish again, in the order they were requested. */
  records: Array<GTransactionSyncRecord>;
  startedAt: Scalars['ISO8601DateTime'];
  status: GTransactionSyncStatus;
  /** The user who started the sync. Null when that user record is no longer present. */
  triggeredBy?: Maybe<GArAssignableUser>;
};

/**
 * A location's retained comparison against NetSuite, plus the state of the most
 * recent run. One per location: each successful run replaces the last.
 */
export type GTransactionSyncAudit = {
  __typename?: 'TransactionSyncAudit';
  /** Why the most recent run could not be completed. Present alongside a retained comparison from an earlier successful run. */
  failureMessage?: Maybe<Scalars['String']>;
  /** The records the retained comparison found wrong. Empty when there is no retained comparison. */
  flaggedRecords: Array<GTransactionSyncFlaggedRecord>;
  id: Scalars['ID'];
  /** Whether the retained comparison found nothing to fix. False when there is none. */
  inSync: Scalars['Boolean'];
  /**
   * When the retained comparison was made. Null when there is no retained
   * comparison, which is what distinguishes "never successfully compared" from
   * "compared and found nothing wrong".
   */
  ranAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** When the most recent run was asked for. */
  requestedAt: Scalars['ISO8601DateTime'];
  /** Where the most recent run got to. Describes the run, not the retained comparison. */
  status: GTransactionSyncAuditStatus;
  /** Per-record-kind counts, one row per kind in a fixed order. Empty when there is no retained comparison. */
  summary: Array<GTransactionSyncAuditSummaryRow>;
};

/** Where the most recent audit run got to. */
export enum GTransactionSyncAuditStatus {
  /** Could not be completed. Any earlier comparison is still retained and still reported, so a failed read loses nothing. */
  Failed = 'FAILED',
  /** Asked for, not started yet. */
  Requested = 'REQUESTED',
  /** Comparing against NetSuite now. */
  Running = 'RUNNING',
  /** Finished; its comparison is the retained one. */
  Succeeded = 'SUCCEEDED'
}

/** One kind of record, counted on both sides. Every kind is always present, zeros included, so the table has a fixed shape. */
export type GTransactionSyncAuditSummaryRow = {
  __typename?: 'TransactionSyncAuditSummaryRow';
  /** How many NetSuite holds. */
  inNetsuite: Scalars['Int'];
  /** How many this service holds. */
  inPortal: Scalars['Int'];
  /** The record kind's display name. */
  label: Scalars['String'];
  /** How many NetSuite holds and this service does not. */
  missing: Scalars['Int'];
  /** How many both hold but disagree about. */
  outOfDate: Scalars['Int'];
  recordType: GTransactionSyncRecordKind;
};

/** Why the audit flagged a record. */
export enum GTransactionSyncFlagReason {
  /** NetSuite has the record and the portal holds no copy of it. */
  Missing = 'MISSING',
  /** Both hold the record and they disagree. */
  OutOfDate = 'OUT_OF_DATE'
}

/** One record the audit found wrong, described as the two sides see it. This is also the set a sync refreshes. */
export type GTransactionSyncFlaggedRecord = {
  __typename?: 'TransactionSyncFlaggedRecord';
  /** Signed, NetSuite minus portal, and the whole NetSuite amount when this service holds no copy. */
  differenceCents: Scalars['Int'];
  /**
   * The document number, when there is one. Journal entries carry none, and
   * neither does a record this service has never stored.
   */
  documentNumber?: Maybe<Scalars['String']>;
  /** When this service last received an update for the record. Null when the reason is MISSING. */
  lastUpdateReceivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  netsuiteInternalId: Scalars['ID'];
  /** What NetSuite shows for the record. */
  netsuiteShows: Scalars['String'];
  /** What this service currently shows for the record. Null when the reason is MISSING: there is no portal side to describe. */
  portalShows?: Maybe<Scalars['String']>;
  reason: GTransactionSyncFlagReason;
  recordType: GTransactionSyncRecordKind;
};

/**
 * How far a sync has got. Structured facts only, no prose: it is rewritten every
 * few seconds, so any sentence stored here would make a copy change a data migration.
 */
export type GTransactionSyncProgress = {
  __typename?: 'TransactionSyncProgress';
  /** How many of the requested records have come back. */
  recordsReceived: Scalars['Int'];
  /**
   * How many records the refresh was recorded against. The republish derives its
   * own set from a later comparison, so this and recordsReceived can legitimately
   * differ in their denominators; both are reported as stored.
   */
  recordsTotal: Scalars['Int'];
  /** All four steps, in order. */
  steps: Array<GTransactionSyncStep>;
};

/** One record a sync asked NetSuite to publish again. */
export type GTransactionSyncRecord = {
  __typename?: 'TransactionSyncRecord';
  /** When refreshed data for this record came back. Null while it is still outstanding. */
  arrivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /**
   * The document number, when there is one. Journal entries carry none, and
   * neither does a record this service has never stored.
   */
  documentNumber?: Maybe<Scalars['String']>;
  /** The signed difference the audit found for this record when the refresh was recorded. */
  expectedDifferenceCents: Scalars['Int'];
  netsuiteInternalId: Scalars['ID'];
  recordType: GTransactionSyncRecordKind;
};

/** A kind of NetSuite transaction the audit compares. */
export enum GTransactionSyncRecordKind {
  /** Credit memos. */
  CreditMemo = 'CREDIT_MEMO',
  /** Payments. */
  CustomerPayment = 'CUSTOMER_PAYMENT',
  /** Refunds. */
  CustomerRefund = 'CUSTOMER_REFUND',
  /** Invoices. */
  Invoice = 'INVOICE',
  /** Journal entries. */
  JournalEntry = 'JOURNAL_ENTRY'
}

/**
 * The one situation a location is currently in. A running audit is reported
 * alongside this rather than as a state of its own: it does not change what is
 * known, it only blocks starting anything else.
 */
export enum GTransactionSyncState {
  /** The most recent event was an audit. Check inSync for what it found. */
  Audited = 'AUDITED',
  /** The most recent event was a sync that converged. */
  CompletedSync = 'COMPLETED_SYNC',
  /** The most recent event was a sync that was given up on. */
  FailedSync = 'FAILED_SYNC',
  /** Nothing has ever been audited or synced for this location. */
  NeverAuditedOrSynced = 'NEVER_AUDITED_OR_SYNCED',
  /** A sync is running right now. */
  SyncInFlight = 'SYNC_IN_FLIGHT'
}

export enum GTransactionSyncStatus {
  /** The portal's records were verified to match NetSuite. */
  Converged = 'CONVERGED',
  /** The sync is still running; it has no outcome or duration yet. */
  InFlight = 'IN_FLIGHT',
  /** The sync did not converge within its time bound and was given up on. */
  TimedOut = 'TIMED_OUT'
}

/** One step of a sync, as last observed. */
export type GTransactionSyncStep = {
  __typename?: 'TransactionSyncStep';
  /**
   * How many records NetSuite accepted for republishing. Null until the republish
   * has worked out what it is sending — absent, not zero.
   */
  accepted?: Maybe<Scalars['Int']>;
  /**
   * When the step reached its current state, for states that happen at an instant.
   * Null for a step that has not started and for one still running.
   */
  at?: Maybe<Scalars['ISO8601DateTime']>;
  key: GTransactionSyncStepKey;
  /** How many records were submitted for republishing. Null on the same terms as accepted. */
  requested?: Maybe<Scalars['Int']>;
  state: GTransactionSyncStepState;
  /**
   * The bound this step was judged against, present only on a failed step. Stamped
   * at the time rather than read from the current setting, which is adjustable and
   * would otherwise misdescribe an older failure.
   */
  timeoutMinutes?: Maybe<Scalars['Int']>;
};

/** One of the four fixed steps a sync passes through. All four are always reported. */
export enum GTransactionSyncStepKey {
  /** Waiting for the refreshed records to arrive. */
  AwaitingData = 'AWAITING_DATA',
  /** NetSuite was asked to publish the records again. */
  Republishing = 'REPUBLISHING',
  /** The refresh was recorded. */
  Requested = 'REQUESTED',
  /** Re-comparing against NetSuite to confirm the records now match. */
  Verify = 'VERIFY'
}

/** How far one step has got. */
export enum GTransactionSyncStepState {
  /** Happening now. */
  Active = 'ACTIVE',
  /** Finished. */
  Done = 'DONE',
  /** This is the step the sync was given up on. */
  Failed = 'FAILED',
  /** Not started. */
  Todo = 'TODO'
}

export type GTransformProductImageInput = {
  /**
   * Optional custom prompt for image adjustment.
   * Examples: "Make the product packaging brighter", "Move the product right by 10px"
   * When provided, a router LLM classifies the instruction and routes to AI/sharp/both.
   * When omitted, default transform is applied (vision check + background removal + centering).
   */
  customPrompt?: InputMaybe<Scalars['String']>;
  /**
   * Image URL - can be:
   * 1. S3 URL from signedUploadImageByKey (after upload via signedUploadImageUrl)
   * 2. Existing S3 URL from item.imgUrl
   */
  imageUrl: Scalars['String'];
};

export type GTransformProductImageResult = {
  __typename?: 'TransformProductImageResult';
  /** When success=false: error description. When success=true: informational message (e.g. "Image already matches catalog standards"). */
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  /** S3 URL of the transformed image */
  transformedUrl?: Maybe<Scalars['String']>;
};

/** Error indicating that a mutation failed due to a transient payment processor error. */
export type GTransientPaymentProcessorError = GError & {
  __typename?: 'TransientPaymentProcessorError';
  /** A description of the error. */
  message: Scalars['String'];
};

export enum GTransitMethod {
  Delivered = 'DELIVERED',
  PickUp = 'PICK_UP'
}

/** Autogenerated input type of TranslateDeliveryInstructionMutation */
export type GTranslateDeliveryInstructionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ISO 639-1 language code; currently only es (Spanish) is supported */
  targetLanguage?: InputMaybe<Scalars['String']>;
  /** The instruction's opaque translationId */
  translationId: Scalars['ID'];
};

/** Autogenerated return type of TranslateDeliveryInstructionMutation. */
export type GTranslateDeliveryInstructionMutationPayload = {
  __typename?: 'TranslateDeliveryInstructionMutationPayload';
  cached: Scalars['Boolean'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GDeliveryInstructionTranslationError>;
  translation?: Maybe<GDeliveryInstructionTranslation>;
};

/** Autogenerated input type of TriggerHubspotRepSync */
export type GTriggerHubspotRepSyncInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of TriggerHubspotRepSync. */
export type GTriggerHubspotRepSyncPayload = {
  __typename?: 'TriggerHubspotRepSyncPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GUserError>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of TriggerManualRoutificRun */
export type GTriggerManualRoutificRunInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Run mode: etas_only or re_sequence. */
  mode: GManualRoutificRunMode;
  /** Delivery date (night end). */
  nightEnd: Scalars['ISO8601Date'];
  /** Warehouse id. */
  warehouseId: Scalars['ID'];
};

/** Autogenerated return type of TriggerManualRoutificRun. */
export type GTriggerManualRoutificRunPayload = {
  __typename?: 'TriggerManualRoutificRunPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  triggered: Scalars['Boolean'];
  userErrors: Array<GRouteError>;
};

/** Autogenerated input type of TriggerRoutesSync */
export type GTriggerRoutesSyncInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Night end for route synchronization. */
  nightEnd: Scalars['ISO8601Date'];
  /** Warehouse id. */
  warehouseId: Scalars['ID'];
};

/** Autogenerated return type of TriggerRoutesSync. */
export type GTriggerRoutesSyncPayload = {
  __typename?: 'TriggerRoutesSyncPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  triggered: Scalars['Boolean'];
  userErrors: Array<GRouteError>;
};

/** Autogenerated input type of TriggerRoutificScenarioRun */
export type GTriggerRoutificScenarioRunInput = {
  /** Whether Routific routes around toll roads. */
  avoidTolls?: InputMaybe<Scalars['Boolean']>;
  /** Whether Routific balances workload across vehicles. */
  balance?: InputMaybe<Scalars['Boolean']>;
  /** Length in minutes of each placed break. Placement is unchanged; only the duration varies. */
  breakDurationMinutes?: InputMaybe<Scalars['Int']>;
  /** How much of each truck's max capacity to route against, 1-100. 100 is the current configuration. */
  capacityPercent?: InputMaybe<Scalars['Int']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Per-cohort truck count overrides for the proposed run (cohort mode only). Omit to run at the plan's current truck counts. */
  cohorts?: InputMaybe<Array<GRoutingCohortInput>>;
  /** Driver shift length in hours. Keeps the shift start and sets the end to start + this many hours. */
  driverShiftHours?: InputMaybe<Scalars['Float']>;
  /**
   * Whether this scenario run should also route stops already bucketed as
   * third_party (Metrobi). When true, the run previews routing them. When false or
   * omitted (the default), they stay bucketed, matching automated and manual runs.
   */
  includeThirdParty?: InputMaybe<Scalars['Boolean']>;
  /** GM-supplied name for the scenario, shown when comparing runs. */
  label: Scalars['String'];
  /**
   * Whether to cap each vehicle at 25 stops. On enforces the cap on every vehicle;
   * off lets Routific pack vehicles without a per-vehicle stop limit.
   */
  maxStopsPerVehicle?: InputMaybe<Scalars['Boolean']>;
  /** Whether Routific minimizes the number of vehicles used. */
  minVehicles?: InputMaybe<Scalars['Boolean']>;
  /** Routing import plan night end. */
  nightEnd: Scalars['ISO8601Date'];
  /** Allowed overtime in minutes, sent to Routific as max_vehicle_overtime. 0 means none. */
  overtimeMinutes?: InputMaybe<Scalars['Int']>;
  /**
   * Routing rule overrides for the proposed run, keyed by rule id, e.g. {
   * "frozen_items_first": { "enabled": true, "hours": 1 } }. Layers over the
   * warehouse's rules_config, which layers over the rule's defaults. Omit to run
   * at the warehouse's configured rules.
   */
  rules?: InputMaybe<Scalars['JSON']>;
  /**
   * Per-shift truck counts for the proposed run, overriding the warehouse's
   * persisted shift assignment. Omit to leave it at the persisted assignment.
   */
  shifts?: InputMaybe<Array<GRoutingShiftAssignmentInput>>;
  /** Whether Routific optimizes for shortest distance rather than time. */
  shortestDistance?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether this scenario run should model 3PD (Metrobi) separation
   * non-destructively: when true, the run computes the 3PD-eligible stops,
   * excludes them from the native routes (which re-optimize without them), and
   * exposes them as a separate preview group. When false or omitted (the default),
   * the native routes are unchanged. Nothing is marked or bucketed.
   */
  thirdPartyEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Whether to route per-cohort (true, default) or cohort-agnostically against a single fleet size (false). */
  useCohorts?: InputMaybe<Scalars['Boolean']>;
  /**
   * How many vehicles the run may use (how many drivers are staffed). Types are
   * chosen from the fleet composition, smallest that fit demand. When useCohorts
   * is false this is the fleet size and must be positive; it may be omitted there
   * only while the deprecated totalFleetSize fallback is supplied. In cohort mode,
   * omit to let routing decide over the full fleet.
   */
  vehicleCount?: InputMaybe<Scalars['Int']>;
  /** Routific visit-balance coefficient (>= 0). 0 disables balancing by coefficient. */
  visitBalanceCoefficient?: InputMaybe<Scalars['Float']>;
  /** Warehouse id. */
  warehouseId: Scalars['ID'];
};

/** Autogenerated return type of TriggerRoutificScenarioRun. */
export type GTriggerRoutificScenarioRunPayload = {
  __typename?: 'TriggerRoutificScenarioRunPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  triggered: Scalars['Boolean'];
  userErrors: Array<GRoutingImportPlanError>;
};

export type GTruck = {
  __typename?: 'Truck';
  id: Scalars['ID'];
  /** Maximum volume in in³ */
  maxVolume: Scalars['Int'];
  /** Maximum weight in lbs */
  maxWeight: Scalars['Int'];
  /** Vehicle tag assigned by the warehouse */
  vehicleTag?: Maybe<Scalars['String']>;
  /** Vehicle type */
  vehicleType?: Maybe<Scalars['String']>;
  /** Vehicle identification number */
  vin?: Maybe<Scalars['String']>;
};

export type GTruckCountInvalid = GUserErrorInterface & {
  __typename?: 'TruckCountInvalid';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of TurnOffLocationSupplyMutation */
export type GTurnOffLocationSupplyMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Location UUID to turn supply off for */
  locationId: Scalars['ID'];
};

/** Autogenerated return type of TurnOffLocationSupplyMutation. */
export type GTurnOffLocationSupplyMutationPayload = {
  __typename?: 'TurnOffLocationSupplyMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  location?: Maybe<GLocation>;
};

/** Autogenerated input type of UnapproveCutoffDiscrepancy */
export type GUnapproveCutoffDiscrepancyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  locationsVendorId: Scalars['ID'];
};

/** Autogenerated return type of UnapproveCutoffDiscrepancy. */
export type GUnapproveCutoffDiscrepancyPayload = {
  __typename?: 'UnapproveCutoffDiscrepancyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  cutoffDiscrepancyApproval?: Maybe<GCutoffDiscrepancyApproval>;
  errors: Array<GUserError>;
};

/** Error indicating that the user is not authorized to perform the action. */
export type GUnauthorizedError = GError & {
  __typename?: 'UnauthorizedError';
  /** A description of the error. */
  message: Scalars['String'];
};

export type GUnavailableItemsInterval = GAvailabilityInterval & {
  __typename?: 'UnavailableItemsInterval';
  /** Lower bound. */
  lowerBound: Scalars['ISO8601DateTime'];
  /** Unavailable menu items. */
  unavailableMenuItems: Array<GMenuItem>;
  /** Upper bound. */
  upperBound: Scalars['ISO8601DateTime'];
};

export type GUncountedLineTrackedOrders = GUserErrorInterface & {
  __typename?: 'UncountedLineTrackedOrders';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  orderIds: Array<Scalars['ID']>;
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
  stopIds: Array<Scalars['ID']>;
};

/** Autogenerated input type of UndoReplenishmentPick */
export type GUndoReplenishmentPickInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Id of the command returned by recordReplenishmentPick. */
  commandId: Scalars['ID'];
  idempotencyKey: Scalars['ID'];
};

/** Autogenerated return type of UndoReplenishmentPick. */
export type GUndoReplenishmentPickPayload = {
  __typename?: 'UndoReplenishmentPickPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  command?: Maybe<GWarehouseBinTransferCommand>;
  userErrors: Array<GUserError>;
};

export type GUnit = {
  __typename?: 'Unit';
  /** Short display label for compact contexts (e.g., oz, lb, g) */
  abbreviation?: Maybe<Scalars['String']>;
  baseUnit?: Maybe<GUnit>;
  /**
   * Answers the question: how many/much of the base unit is in this unit?
   * Conversion rate for base units should be 1
   * Example: 1 gallon = 8 pints, so a pint could be represented as
   * having a conversion rate of .125 gallons
   */
  conversionRate: Scalars['Float'];
  id: Scalars['ID'];
  name: Scalars['String'];
  unitType: GUnitType;
};

export enum GUnitSortOrder {
  ConversionRateAsc = 'CONVERSION_RATE_ASC',
  ConversionRateDesc = 'CONVERSION_RATE_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

export enum GUnitType {
  Case = 'CASE',
  Mass = 'MASS',
  Pounds = 'POUNDS',
  Volume = 'VOLUME'
}

export type GUnmarkNotAllowed = GUserErrorInterface & {
  __typename?: 'UnmarkNotAllowed';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of UnmarkRouteProvider */
export type GUnmarkRouteProviderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The route to unmark. */
  routeId: Scalars['ID'];
};

/** Autogenerated return type of UnmarkRouteProvider. */
export type GUnmarkRouteProviderPayload = {
  __typename?: 'UnmarkRouteProviderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  route?: Maybe<GRoute>;
  userErrors: Array<GThirdPartyDispatchError>;
};

/** An item mentioned in transcript but not found in menu */
export type GUnmatchedItem = {
  __typename?: 'UnmatchedItem';
  /** Number of items requested */
  quantity: Scalars['Int'];
  /** Full phrase as customer said it */
  raw: Scalars['String'];
  /** Closest menu item name if match exists */
  suggestedItemName?: Maybe<Scalars['String']>;
  /** Price in cents for the suggested variation */
  suggestedPriceCents?: Maybe<Scalars['Int']>;
  /** Square variation ID for the suggestion (looked up from catalog) */
  suggestedVariationId?: Maybe<Scalars['String']>;
  /** Variation for the suggestion */
  suggestedVariationName?: Maybe<Scalars['String']>;
};

export type GUnresolvedTasks = GUserErrorInterface & {
  __typename?: 'UnresolvedTasks';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GUnservedStop = {
  __typename?: 'UnservedStop';
  /** The location associated with the unserved stop, or null if the stop no longer resolves */
  locationId?: Maybe<Scalars['ID']>;
  /** The unserved stop's location name, or null if the stop no longer resolves */
  locationName?: Maybe<Scalars['String']>;
  /** The raw reason string Routific returned for leaving this stop unserved */
  reason: Scalars['String'];
  /** The delivery route stop Routific could not assign to a vehicle */
  stopId: Scalars['ID'];
};

/** Autogenerated input type of UnsubscribeFromBackInStockNotificationMutation */
export type GUnsubscribeFromBackInStockNotificationMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Item UUID */
  itemId: Scalars['ID'];
  /** Location UUID */
  locationId: Scalars['ID'];
};

/** Autogenerated return type of UnsubscribeFromBackInStockNotificationMutation. */
export type GUnsubscribeFromBackInStockNotificationMutationPayload = {
  __typename?: 'UnsubscribeFromBackInStockNotificationMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<GUserError>>;
  subscriptionExisted?: Maybe<Scalars['Boolean']>;
  succeeded: Scalars['Boolean'];
};

/** Autogenerated input type of UpdateArrivedAtStopTime */
export type GUpdateArrivedAtStopTimeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Client-provided time the driver arrived (e.g. a geofence crossing). Defaults to server time when omitted. */
  occurredAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Indicates if the stop is a redelivery stop */
  redelivery?: InputMaybe<Scalars['Boolean']>;
  /** Delivery stop id. */
  stopId: Scalars['ID'];
};

/** Autogenerated return type of UpdateArrivedAtStopTime. */
export type GUpdateArrivedAtStopTimePayload = {
  __typename?: 'UpdateArrivedAtStopTimePayload';
  /** The time the driver arrived at the stop */
  arrivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userErrors: Array<GDeliveryRouteStopError>;
};

/** Autogenerated input type of UpdateBrandedItemDealMutation */
export type GUpdateBrandedItemDealMutationInput = {
  /** Branded item deal id */
  brandedItemDealId: Scalars['ID'];
  /** Status of the branded item deal */
  brandedItemDealStatus: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateBrandedItemDealMutation. */
export type GUpdateBrandedItemDealMutationPayload = {
  __typename?: 'UpdateBrandedItemDealMutationPayload';
  brandedItemDeal?: Maybe<GBrandedItemDeal>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GUserError>;
};

/** Input for updating an existing cart item. */
export type GUpdateCartItemInput = {
  /** ID of the CartItem to update. */
  cartItemId: Scalars['ID'];
  /** ID of desired MenuItemSize. */
  menuItemSizeId: Scalars['ID'];
  /**
   * Desired modifiers. This should include any previously added modifiers you wish
   * to keep as well as any modifiers you wish to add. Previously added modifiers
   * that don't appear in this list will be removed.
   */
  modifiers: Array<GCartItemModifierInput>;
  /** Note. If omitted, any previously set note will be cleared. */
  note?: InputMaybe<Scalars['String']>;
  /** Desired quantity. */
  quantity: Scalars['Int'];
  /** Expected unit price of MenuItemSize. Item will only be updated if the desired size's price matches the expected price. */
  unitPrice: GMoneyInput;
};

/** Data that was provided as mutation input. */
export type GUpdateCartItemInputEcho = {
  __typename?: 'UpdateCartItemInputEcho';
  /** ID of the CartItem to update. */
  cartItemId: Scalars['ID'];
  /** ID of desired MenuItemSize. */
  menuItemSizeId: Scalars['ID'];
  /**
   * Desired modifiers. This should include any previously added modifiers you wish
   * to keep as well as any modifiers you wish to add. Previously added modifiers
   * that don't appear in this list will be removed.
   */
  modifiers: Array<GCartItemModifierInputEcho>;
  /** Desired quantity. */
  quantity: Scalars['Int'];
  /** Expected unit price of MenuItemSize. Item will only be updated if the desired size's price matches the expected price. */
  unitPrice: GMoney;
};

/** Autogenerated input type of UpdateCartItems */
export type GUpdateCartItemsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Opaque token identifying a specific version of the cart. */
  fingerprint: Scalars['String'];
  /**
   * List of desired updates. This list only needs to include updates for the items
   * it wants to modify. Any cart items not represented in the listed updates will
   * remain unchanged.
   */
  updates: Array<GUpdateCartItemInput>;
};

/** Autogenerated return type of UpdateCartItems */
export type GUpdateCartItemsPayload = {
  __typename?: 'UpdateCartItemsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to update cart items. */
  result: GCartResult;
};

/** Autogenerated input type of UpdateConfig */
export type GUpdateConfigInput = {
  /** App config attributes */
  attributes: GConfigAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Current config's edition (update is rejected if this is out of date) */
  currentEdition?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of UpdateConfig */
export type GUpdateConfigPayload = {
  __typename?: 'UpdateConfigPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** @deprecated Use the "result" field instead. */
  configResult: GConfigResult;
  /** Updated config's edition */
  currentEdition?: Maybe<Scalars['Int']>;
  /** Result of attempting to update the config */
  result: GConfigResult;
};

/** Autogenerated input type of UpdateCurrentConsumerAppUser */
export type GUpdateCurrentConsumerAppUserInput = {
  /** Accepts promotional emails. May be omitted, but if specified, cannot be null. */
  acceptsPromotionalEmails?: InputMaybe<Scalars['Boolean']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Email. May be omitted, but if specified, cannot be null. */
  email?: InputMaybe<Scalars['String']>;
  /** Merchant can contact. May be omitted, but if specified, cannot be null. */
  merchantCanContact?: InputMaybe<Scalars['Boolean']>;
  /** Username. May be omitted, but if specified, cannot be null. */
  username?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateCurrentConsumerAppUser */
export type GUpdateCurrentConsumerAppUserPayload = {
  __typename?: 'UpdateCurrentConsumerAppUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to update the consumer app user. */
  result: GConsumerAppUserResult;
};

/** Autogenerated input type of UpdateCurrentConsumerAppUserPhoneNumber */
export type GUpdateCurrentConsumerAppUserPhoneNumberInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Phone number in E.164 format, but without the "+" prefix. E.g. "15551231234". */
  phoneNumber: Scalars['String'];
  /** ID received when verifying phone number. */
  phoneVerificationId: Scalars['ID'];
};

/** Autogenerated return type of UpdateCurrentConsumerAppUserPhoneNumber */
export type GUpdateCurrentConsumerAppUserPhoneNumberPayload = {
  __typename?: 'UpdateCurrentConsumerAppUserPhoneNumberPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to update the consumer app user's phone number. */
  result: GConsumerAppUserResult;
};

/** Autogenerated input type of UpdateCustomIngredientMutation */
export type GUpdateCustomIngredientMutationInput = {
  /** Brand name of the ingredient */
  brand?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the custom ingredient */
  id: Scalars['ID'];
  /** Name of the ingredient */
  name?: InputMaybe<Scalars['String']>;
  /** Price purchased at */
  purchasePrice?: InputMaybe<GMoneyInput>;
  /** Unit purchased at */
  purchaseUnit?: InputMaybe<Scalars['ID']>;
  /** Purchased from */
  purchaseVendor?: InputMaybe<Scalars['String']>;
  /** Quantity portion of item size */
  sizeQuantity?: InputMaybe<Scalars['Float']>;
  /** Unit portion of item size */
  sizeUnit?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of UpdateCustomIngredientMutation. */
export type GUpdateCustomIngredientMutationPayload = {
  __typename?: 'UpdateCustomIngredientMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  customIngredient?: Maybe<GCustomIngredient>;
  errors: Array<GUserError>;
};

/** Autogenerated input type of UpdateCustomerTagMutation */
export type GUpdateCustomerTagMutationInput = {
  /** Replacement kind of audience the tag describes: when a location takes delivery, where it is, or what it sells. */
  category?: InputMaybe<GCustomerTagCategoryEnum>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Id of the tag to update, as returned by CustomerTag.id. */
  id: Scalars['ID'];
  /** Replacement display name. The tag's slug is fixed at creation and is not affected. */
  name?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateCustomerTagMutation. */
export type GUpdateCustomerTagMutationPayload = {
  __typename?: 'UpdateCustomerTagMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  customerTag?: Maybe<GCustomerTag>;
  errors: Array<Scalars['String']>;
};

/** Autogenerated input type of UpdateCustomerTrackingSettings */
export type GUpdateCustomerTrackingSettingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  expectedRevision: Scalars['Int'];
  restoreDefaults?: InputMaybe<Scalars['Boolean']>;
  settings?: InputMaybe<GCustomerTrackingSettingsInput>;
  warehouseId: Scalars['ID'];
};

/** Autogenerated return type of UpdateCustomerTrackingSettings. */
export type GUpdateCustomerTrackingSettingsPayload = {
  __typename?: 'UpdateCustomerTrackingSettingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  settings: GCustomerTrackingSettings;
};

/** Autogenerated input type of UpdateDepartedAtStopTime */
export type GUpdateDepartedAtStopTimeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Client-provided time the driver departed (e.g. a geofence crossing). Defaults to server time when omitted. */
  occurredAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Indicates if the stop is a redelivery stop */
  redelivery?: InputMaybe<Scalars['Boolean']>;
  /** Delivery stop id. */
  stopId: Scalars['ID'];
};

/** Autogenerated return type of UpdateDepartedAtStopTime. */
export type GUpdateDepartedAtStopTimePayload = {
  __typename?: 'UpdateDepartedAtStopTimePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The time the driver departed from the stop */
  departedAt?: Maybe<Scalars['ISO8601DateTime']>;
  userErrors: Array<GDeliveryRouteStopError>;
};

/** Autogenerated input type of UpdateExternalBaseBrandedItemMutation */
export type GUpdateExternalBaseBrandedItemMutationInput = {
  /** Base item attributes */
  baseBrandedItem: GBaseBrandedItemInput;
  /** Base branded item to update */
  baseBrandedItemId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  deliveryPrice: GMoneyInput;
  /** External item's procurement vendor */
  procurementVendor: Scalars['ID'];
  /** Variants of the item that are offered */
  variants: Array<GExternalBaseBrandedItemVariantInput>;
};

/** Autogenerated return type of UpdateExternalBaseBrandedItemMutation. */
export type GUpdateExternalBaseBrandedItemMutationPayload = {
  __typename?: 'UpdateExternalBaseBrandedItemMutationPayload';
  baseBrandedItem?: Maybe<GBaseBrandedItem>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GUserError>;
};

/** Autogenerated input type of UpdateGeneratedOrderQuantitiesMutation */
export type GUpdateGeneratedOrderQuantitiesMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** PROTOTYPE an array of the reified order information. */
  generatedOrderQuantitiesInput: Array<GUpdateGeneratedOrderQuantityInput>;
};

/** Autogenerated return type of UpdateGeneratedOrderQuantitiesMutation. */
export type GUpdateGeneratedOrderQuantitiesMutationPayload = {
  __typename?: 'UpdateGeneratedOrderQuantitiesMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  /** PROTOTYPE the GeneratedOrderQuantities updated. */
  generatedOrderQuantities: Array<GGeneratedOrderQuantity>;
};

export type GUpdateGeneratedOrderQuantityInput = {
  /** PROTOTYPE The inventory-service-2 id of the GeneratedOrderQuantity. */
  id: Scalars['ID'];
  /** PROTOTYPE The Odeko UUID of the reified order. */
  orderId?: InputMaybe<Scalars['ID']>;
  /** PROTOTYPE The Odeko UUID of the reified order line. */
  orderLineId?: InputMaybe<Scalars['ID']>;
  /** PROTOTYPE The quantity of the reified order line. */
  orderedQuantity?: InputMaybe<Scalars['Float']>;
};

/** Autogenerated input type of UpdateGuestUsernameMutation */
export type GUpdateGuestUsernameMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the guest profile to update */
  guestProfileId: Scalars['ID'];
  /** New username for the player */
  newUsername: Scalars['String'];
};

/** Autogenerated return type of UpdateGuestUsernameMutation. */
export type GUpdateGuestUsernameMutationPayload = {
  __typename?: 'UpdateGuestUsernameMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']>;
  /** The updated guest profile */
  guestProfile?: Maybe<GGuestProfile>;
};

export type GUpdateHomepageDisplayRulesInput = {
  endDate?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  ruleIds: Array<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['String']>;
  warehouseIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type GUpdateHomepageDisplayRulesPayload = {
  __typename?: 'UpdateHomepageDisplayRulesPayload';
  errors: Array<GHomepageDisplayRuleError>;
  updatedRuleIds: Array<Scalars['ID']>;
};

/** Autogenerated input type of UpdateInHouseBaseBrandedItemMutation */
export type GUpdateInHouseBaseBrandedItemMutationInput = {
  /** Base item attributes */
  baseBrandedItem: GBaseBrandedItemInput;
  /** Base branded item to update */
  baseBrandedItemId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** In-house item's associated supply item */
  supplyItem: Scalars['ID'];
  /** Variants of the item that are offered */
  variants: Array<GInHouseBaseBrandedItemVariantInput>;
};

/** Autogenerated return type of UpdateInHouseBaseBrandedItemMutation. */
export type GUpdateInHouseBaseBrandedItemMutationPayload = {
  __typename?: 'UpdateInHouseBaseBrandedItemMutationPayload';
  baseBrandedItem?: Maybe<GBaseBrandedItem>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GUserError>;
};

/** Autogenerated input type of UpdateInProgressCustomerMutation */
export type GUpdateInProgressCustomerMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID (uuid) for the InProgressCustomer */
  id: Scalars['ID'];
  /** Input of the values to be updated. */
  inProgressCustomerInput: GInProgressCustomerInput;
};

/** Autogenerated return type of UpdateInProgressCustomerMutation. */
export type GUpdateInProgressCustomerMutationPayload = {
  __typename?: 'UpdateInProgressCustomerMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  inProgressCustomer?: Maybe<GInProgressCustomer>;
};

export type GUpdateItemPalletConfigurationError = {
  __typename?: 'UpdateItemPalletConfigurationError';
  /** The offending argument, when a single one can be blamed. */
  field?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/**
 * Validation failures arrive in `errors` rather than as a thrown error, so the associate sees the actual
 * reason instead of the gateway's redacted message. `item` is null whenever `errors` is non-empty.
 */
export type GUpdateItemPalletConfigurationPayload = {
  __typename?: 'UpdateItemPalletConfigurationPayload';
  errors: Array<GUpdateItemPalletConfigurationError>;
  item?: Maybe<GSupplyItem>;
};

/** Attributes for creating or updating landed-cost and sale-price */
export type GUpdateItemPriceInput = {
  /** Item UUID */
  itemOdekoUuid: Scalars['String'];
  newLandedCost?: InputMaybe<GMoneyInput>;
  newSalePrice?: InputMaybe<GMoneyInput>;
  previousLandedCost?: InputMaybe<GMoneyInput>;
  previousSalePrice?: InputMaybe<GMoneyInput>;
  /** Warehouse UUID */
  warehouseOdekoUuid: Scalars['String'];
};

/** Autogenerated input type of UpdateItemPrices */
export type GUpdateItemPricesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  customPrices?: InputMaybe<Array<GUpdateLocationPriceInput>>;
  prices: Array<GUpdateItemPriceInput>;
};

/** Autogenerated return type of UpdateItemPrices. */
export type GUpdateItemPricesPayload = {
  __typename?: 'UpdateItemPricesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  result?: Maybe<GItemPricesResult>;
};

/** Autogenerated input type of UpdateLocationOpeningHoursFromGoogle */
export type GUpdateLocationOpeningHoursFromGoogleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Location UUID to update */
  locationUuid: Scalars['ID'];
};

/** Autogenerated return type of UpdateLocationOpeningHoursFromGoogle. */
export type GUpdateLocationOpeningHoursFromGooglePayload = {
  __typename?: 'UpdateLocationOpeningHoursFromGooglePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  openingHours?: Maybe<Array<GOpeningHour>>;
};

/** Autogenerated input type of UpdateLocationOpeningHoursMutation */
export type GUpdateLocationOpeningHoursMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Store hours have been confirmed by the user within the user interface */
  confirmed?: InputMaybe<Scalars['Boolean']>;
  /** List of days with opening and closing times */
  days: Array<GOpeningHoursDayInput>;
  /** Location UUID to update */
  locationId: Scalars['ID'];
};

/** Autogenerated return type of UpdateLocationOpeningHoursMutation. */
export type GUpdateLocationOpeningHoursMutationPayload = {
  __typename?: 'UpdateLocationOpeningHoursMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  openingHours?: Maybe<Array<GOpeningHour>>;
  storeHoursConfirmed?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of UpdateLocationPlatformProfileMutation */
export type GUpdateLocationPlatformProfileMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  destroy?: InputMaybe<Scalars['Boolean']>;
  locationUuid: Scalars['String'];
  platformId: GPlatformIds;
  profileId: Scalars['String'];
};

/** Autogenerated return type of UpdateLocationPlatformProfileMutation. */
export type GUpdateLocationPlatformProfileMutationPayload = {
  __typename?: 'UpdateLocationPlatformProfileMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  profile: GProfile;
};

/** Attributes for creating or updating custom-price */
export type GUpdateLocationPriceInput = {
  /** Item UUID */
  itemOdekoUuid: Scalars['String'];
  /** Location UUID */
  locationOdekoUuid: Scalars['String'];
  newCustomPrice?: InputMaybe<GMoneyInput>;
  previousCustomPrice?: InputMaybe<GMoneyInput>;
};

/** Autogenerated input type of UpdateLocationsDeliverWithinStoreHoursMutation */
export type GUpdateLocationsDeliverWithinStoreHoursMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Boolean value to set for deliver_within_store_hours on all specified locations */
  deliverWithinStoreHours: Scalars['Boolean'];
  /** Array of location UUIDs to update */
  locationIds: Array<Scalars['ID']>;
};

/** Autogenerated return type of UpdateLocationsDeliverWithinStoreHoursMutation. */
export type GUpdateLocationsDeliverWithinStoreHoursMutationPayload = {
  __typename?: 'UpdateLocationsDeliverWithinStoreHoursMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GUserError>;
  updatedLocations: Array<GLocation>;
};

/** Autogenerated input type of UpdateLocationsRoutingCohortMutation */
export type GUpdateLocationsRoutingCohortMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The id of routing cohort associated with the warehouse */
  cohortId: Scalars['ID'];
  /** List of locations ids. */
  locationIds: Array<Scalars['ID']>;
};

/** Autogenerated return type of UpdateLocationsRoutingCohortMutation. */
export type GUpdateLocationsRoutingCohortMutationPayload = {
  __typename?: 'UpdateLocationsRoutingCohortMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of UpdateMarketingQrCodeMutation */
export type GUpdateMarketingQrCodeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID (UUID) of the QR code to update */
  id: Scalars['ID'];
  redirectUrl?: InputMaybe<Scalars['String']>;
  utmMedium?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateMarketingQrCodeMutation. */
export type GUpdateMarketingQrCodeMutationPayload = {
  __typename?: 'UpdateMarketingQrCodeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  qrCode: GMarketingQrCode;
};

/** Autogenerated input type of UpdateMarketingQrCodesFromCsvMutation */
export type GUpdateMarketingQrCodesFromCsvMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** CSV contents */
  csvContents: Scalars['String'];
};

/** Autogenerated return type of UpdateMarketingQrCodesFromCsvMutation. */
export type GUpdateMarketingQrCodesFromCsvMutationPayload = {
  __typename?: 'UpdateMarketingQrCodesFromCsvMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  results: Array<GMarketingQrCodeBulkUpdateResult>;
};

/** Autogenerated input type of UpdateMenuItemSavedVisibility */
export type GUpdateMenuItemSavedVisibilityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /**
   * MenuItem's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
  /** MenuItem ID. */
  menuItemId: Scalars['ID'];
  /**
   * Visibility value to save. This sets the menu-item's "visibility.savedValue",
   * whichi will determine its "visibility.effectiveValue" as well iff it belongs
   * to a visible submenu that belongs to a visible menu. If either the submenu or
   * its parent menu are hidden, the menu-item is effectively hidden regardless of
   * its saved visibility value.
   */
  value: GVisibilityEnum;
};

/** Autogenerated return type of UpdateMenuItemSavedVisibility */
export type GUpdateMenuItemSavedVisibilityPayload = {
  __typename?: 'UpdateMenuItemSavedVisibilityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to update the menu-item's saved visibility value. */
  result: GMenuItemResult;
};

/** Input for updating the sort order of a menu-item. */
export type GUpdateMenuItemSortOrderInput = {
  /**
   * MenuItem's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
  /** MenuItem ID */
  menuItemId: Scalars['ID'];
};

/** Autogenerated input type of UpdateMenuItemsSortOrder */
export type GUpdateMenuItemsSortOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /**
   * List describing the desired sort order of submenu's menu-items. This list must
   * be exhaustive, i.e. it should contain an element for each menu-item the
   * submenu has. The operation will be rejected if given a non-exhaustive list or
   * a list that contains duplicates. It will also be rejected if any of the list
   * elements identify menu-items that don't belong to the right submenu.
   */
  elements: Array<GUpdateMenuItemSortOrderInput>;
  /** The ID of the submenu whose menu-items are being sorted. */
  submenuId: Scalars['ID'];
};

/** Autogenerated return type of UpdateMenuItemsSortOrder */
export type GUpdateMenuItemsSortOrderPayload = {
  __typename?: 'UpdateMenuItemsSortOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to update the menu-items' sort order. */
  result: GMenuItemsResult;
};

/** Autogenerated input type of UpdateMenuSavedVisibility */
export type GUpdateMenuSavedVisibilityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /**
   * Menu's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
  /** Menu ID. */
  menuId: Scalars['ID'];
  /**
   * Visibility value to save. This sets the menu's "visibility.savedValue" and has
   * a cascading effect on the "visibility.effectiveValue" of its submenus and
   * their menu-items. I.e. hiding a menu also changes the effective visibility of
   * its submenus and their menu-items, hiding them from consumers regardless of
   * what the individual "visibility.savedValue" fields hold. Their individual
   * saved values are retained, and will become relevant in determining their
   * effective visibility if the menu is later unhidden.
   */
  value: GVisibilityEnum;
};

/** Autogenerated return type of UpdateMenuSavedVisibility */
export type GUpdateMenuSavedVisibilityPayload = {
  __typename?: 'UpdateMenuSavedVisibilityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to update the menu's saved visibility value. */
  result: GMenuResult;
};

/** Input for updating the sort order of a menu. */
export type GUpdateMenuSortOrderInput = {
  /**
   * Menu's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
  /** Menu ID */
  menuId: Scalars['ID'];
};

/** Autogenerated input type of UpdateMenusSortOrder */
export type GUpdateMenusSortOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /**
   * List describing the desired sort order of merchant's menus. This list must be
   * exhaustive, i.e. it should contain an element for each menu the merchant has.
   * The operation will be rejected if given a non-exhaustive list or a list that
   * contains duplicates. It will also be rejected if any of the list elements
   * identify menus that don't belong to the right merchant.
   */
  elements: Array<GUpdateMenuSortOrderInput>;
  /** The ID of the merchant whose menus are being sorted. */
  merchantId: Scalars['ID'];
};

/** Autogenerated return type of UpdateMenusSortOrder */
export type GUpdateMenusSortOrderPayload = {
  __typename?: 'UpdateMenusSortOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to update the menus' sort order. */
  result: GMenusResult;
};

/** Autogenerated input type of UpdateMerchantCurbsidePickup */
export type GUpdateMerchantCurbsidePickupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Whether curbside pickup is offered. */
  curbsidePickup: Scalars['Boolean'];
  /**
   * Merchant's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
  /** The ID of the merchant to update. */
  merchantId: Scalars['ID'];
};

/** Autogenerated return type of UpdateMerchantCurbsidePickup */
export type GUpdateMerchantCurbsidePickupPayload = {
  __typename?: 'UpdateMerchantCurbsidePickupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to update curbsidePickup. */
  result: GMerchantResult;
};

/** Autogenerated input type of UpdateMerchantNotificationSound */
export type GUpdateMerchantNotificationSoundInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /**
   * Merchant's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
  /** The ID of the merchant to update. */
  merchantId: Scalars['ID'];
  /** Audio filename to play on notifications for this merchant */
  notificationSound: Scalars['String'];
};

/** Autogenerated return type of UpdateMerchantNotificationSound */
export type GUpdateMerchantNotificationSoundPayload = {
  __typename?: 'UpdateMerchantNotificationSoundPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to update notification sound. */
  result: GMerchantResult;
};

/** Autogenerated input type of UpdateMerchantPickupText */
export type GUpdateMerchantPickupTextInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /**
   * Merchant's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
  /** The ID of the merchant to update. */
  merchantId: Scalars['ID'];
  /** Pickup text. */
  pickupText?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateMerchantPickupText */
export type GUpdateMerchantPickupTextPayload = {
  __typename?: 'UpdateMerchantPickupTextPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to update pickup text. */
  result: GMerchantResult;
};

/** Autogenerated input type of UpdateMerchantStatus */
export type GUpdateMerchantStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /**
   * Merchant's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
  /** The ID of the merchant to update. */
  merchantId: Scalars['ID'];
  /** Status to set. */
  status: GMerchantStatusEnum;
};

/** Autogenerated return type of UpdateMerchantStatus */
export type GUpdateMerchantStatusPayload = {
  __typename?: 'UpdateMerchantStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to update the merchant status. */
  result: GMerchantResult;
};

/** Autogenerated input type of UpdateMicrositeAdInfo */
export type GUpdateMicrositeAdInfoInput = {
  adInfo: GMicrositeAdInfoInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  micrositeLocationId: Scalars['ID'];
};

/** Autogenerated return type of UpdateMicrositeAdInfo. */
export type GUpdateMicrositeAdInfoPayload = {
  __typename?: 'UpdateMicrositeAdInfoPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  micrositeLocation?: Maybe<GMicrositeLocation>;
};

/** Autogenerated input type of UpdateMicrositeModulesOrder */
export type GUpdateMicrositeModulesOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the microsite location. */
  micrositeLocationId: Scalars['ID'];
  /**
   * The ordered list of module types to apply to the microsite location. The order
   * of this list will determine the display order of the modules.
   */
  moduleTypesInOrder: Array<GMicrositeModule>;
};

/** Autogenerated return type of UpdateMicrositeModulesOrder. */
export type GUpdateMicrositeModulesOrderPayload = {
  __typename?: 'UpdateMicrositeModulesOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  micrositeLocation: GMicrositeLocation;
};

/** Autogenerated input type of UpdateMicrositeMutation */
export type GUpdateMicrositeMutationInput = {
  actions?: InputMaybe<GMicrositeActionsInput>;
  /** Business profile details for the microsite */
  businessProfile?: InputMaybe<GMicrositeBusinessProfileInput>;
  calendarEvents?: InputMaybe<GMicrositeCalendarEventsInput>;
  checkIn?: InputMaybe<GMicrositeCheckInInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  coffeeGrind?: InputMaybe<GMicrositeCoffeeGrindInput>;
  /** Contact details for the microsite */
  contact?: InputMaybe<GMicrositeContactInput>;
  cuppy?: InputMaybe<GMicrositeCuppyInput>;
  /** Google Places API place ID to link this microsite to a Google location */
  googlePlaceId?: InputMaybe<Scalars['String']>;
  /** ID of the microsite location to update */
  id: Scalars['ID'];
  mailingList?: InputMaybe<GMicrositeMailingListInput>;
  /** Media module configuration for the microsite */
  media?: InputMaybe<GMicrositeMediaInput>;
  photobooth?: InputMaybe<GMicrositePhotoboothInput>;
  polls?: InputMaybe<GMicrositePollsInput>;
  relevantReviews?: InputMaybe<GMicrositeRelevantReviewInput>;
  relevantReviewsModule?: InputMaybe<GMicrositeRelevantReviewsModuleInput>;
  restroomCode?: InputMaybe<GMicrositeRestroomInput>;
  socials?: InputMaybe<GMicrositeSocialsInput>;
  suggestedMenu?: InputMaybe<GMicrositeSuggestedMenuInput>;
  suggestion?: InputMaybe<GMicrositeSuggestionConfigInput>;
  teamProfiles?: InputMaybe<GMicrositeTeamProfilesInput>;
  theme?: InputMaybe<GMicrositeThemeInput>;
  wifiInfo?: InputMaybe<GMicrositeWifiInput>;
};

/** Autogenerated return type of UpdateMicrositeMutation. */
export type GUpdateMicrositeMutationPayload = {
  __typename?: 'UpdateMicrositeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  micrositeLocation: GMicrositeLocation;
};

/** Autogenerated input type of UpdateModifierGroupSavedVisibility */
export type GUpdateModifierGroupSavedVisibilityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /**
   * Modifier group's current lock version. If an outdated lock version is
   * provided, the operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
  /** Modifier Group ID. */
  modifierGroupId: Scalars['ID'];
  /**
   * Visibility value to save. This sets the modifier group's
   * "visibility.savedValue" and has a cascading effect on the
   * "visibility.effectiveValue" of the options within the group. I.e. hiding a
   * modifier group also changes the effective visibility of its modifier options,
   * hiding them from consumers regardless of what their individual
   * "visibility.savedValue" fields hold. Their individual saved values are
   * retained, and will become relevant in determining their effective visibility
   * if the group is later unhidden.
   */
  value: GVisibilityEnum;
};

/** Autogenerated return type of UpdateModifierGroupSavedVisibility */
export type GUpdateModifierGroupSavedVisibilityPayload = {
  __typename?: 'UpdateModifierGroupSavedVisibilityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to update the modifier group's saved visibility value. */
  result: GModifierGroupResult;
};

/** Input for updating the sort order of a modifier group. */
export type GUpdateModifierGroupSortOrderInput = {
  /**
   * ModifierGroup's current lock version. If an outdated lock version is provided,
   * the operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
  /** ModifierGroup ID */
  modifierGroupId: Scalars['ID'];
};

/** Autogenerated input type of UpdateModifierGroupsSortOrder */
export type GUpdateModifierGroupsSortOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /**
   * List describing the desired sort order of merchant's modifier groups. This
   * list must be exhaustive, i.e. it should contain an element for each modifier
   * group the merchant has. The operation will be rejected if given a
   * non-exhaustive list or a list that contains duplicates. It will also be
   * rejected if any of the list elements identify modifier groups that don't
   * belong to the right merchant.
   */
  elements: Array<GUpdateModifierGroupSortOrderInput>;
  /** The ID of the merchant whose modifier groups are being sorted. */
  merchantId: Scalars['ID'];
};

/** Autogenerated return type of UpdateModifierGroupsSortOrder */
export type GUpdateModifierGroupsSortOrderPayload = {
  __typename?: 'UpdateModifierGroupsSortOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to update the modifier groups' sort order. */
  result: GModifierGroupsResult;
};

/** Autogenerated input type of UpdateModifierOptionSavedVisibility */
export type GUpdateModifierOptionSavedVisibilityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /**
   * ModifierOption's current lock version. If an outdated lock version is
   * provided, the operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
  /** ModifierOption ID. */
  modifierOptionId: Scalars['ID'];
  /**
   * Visibility value to save. This sets the modifier option's
   * "visibility.savedValue". It also determines the option's effective visibility
   * if it belongs to a visible modifier group. If it belongs to a hidden modifier
   * group, the option remains effectively hidden regardless of its saved
   * visibility value.
   */
  value: GVisibilityEnum;
};

/** Autogenerated return type of UpdateModifierOptionSavedVisibility */
export type GUpdateModifierOptionSavedVisibilityPayload = {
  __typename?: 'UpdateModifierOptionSavedVisibilityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to update the modifier option's saved visibility value. */
  result: GModifierOptionResult;
};

/** Input for updating the sort order of a modifier option. */
export type GUpdateModifierOptionSortOrderInput = {
  /**
   * ModifierOption's current lock version. If an outdated lock version is
   * provided, the operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
  /** ModifierOption ID */
  modifierOptionId: Scalars['ID'];
};

/** Autogenerated input type of UpdateModifierOptionsSortOrder */
export type GUpdateModifierOptionsSortOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /**
   * List describing the desired sort order of modifier group's options. This list
   * must be exhaustive, i.e. it should contain an element for each option in the
   * group. The operation will be rejected if given a non-exhaustive list. It will
   * also be rejected if any of the list elements identify options that don't
   * belong to the right group.
   */
  elements: Array<GUpdateModifierOptionSortOrderInput>;
  /** The ID of the modifier group whose options are being sorted. */
  modifierGroupId: Scalars['ID'];
};

/** Autogenerated return type of UpdateModifierOptionsSortOrder */
export type GUpdateModifierOptionsSortOrderPayload = {
  __typename?: 'UpdateModifierOptionsSortOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to update the modifier options' sort order. */
  result: GModifierOptionsResult;
};

/** Autogenerated input type of UpdateOdekoItemInventoryMutation */
export type GUpdateOdekoItemInventoryMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** PROTOTYPE The Odeko UUID of the location. */
  locationId: Scalars['ID'];
  /** PROTOTYPE The Odeko UUID of the item. */
  odekoItemId: Scalars['ID'];
  /** PROTOTYPE The Inventory information to be updated. */
  odekoItemInventoryInput: GOdekoItemInventoryInput;
};

/** Autogenerated return type of UpdateOdekoItemInventoryMutation. */
export type GUpdateOdekoItemInventoryMutationPayload = {
  __typename?: 'UpdateOdekoItemInventoryMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  inventoryInfo?: Maybe<GInventoryInfo>;
  inventoryLocationItem: GInventoryLocationItem;
};

/** Autogenerated input type of UpdateOrderDeliveryMethodMutation */
export type GUpdateOrderDeliveryMethodMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /**
   * The new delivery method for the order(s). Omit to restore each order's own
   * pre-3PD delivery method (requires thirdPartyMarkingAllowed: false).
   */
  deliveryMethod?: InputMaybe<GOrderDeliveryMethodEnum>;
  /** ID of the order(s) to update */
  orderIds: Array<Scalars['ID']>;
  /** Admin-only. Set to false to exclude the order(s) from future automated third-party-delivery marking. */
  thirdPartyMarkingAllowed?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of UpdateOrderDeliveryMethodMutation. */
export type GUpdateOrderDeliveryMethodMutationPayload = {
  __typename?: 'UpdateOrderDeliveryMethodMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<GUserError>>;
  orders?: Maybe<Array<GOrder>>;
};

/** Autogenerated input type of UpdatePlatformMicrositeLocationMutation */
export type GUpdatePlatformMicrositeLocationMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  entityId: Scalars['String'];
  micrositeLocationId: Scalars['ID'];
  platformId: GPlatformIds;
};

/** Autogenerated return type of UpdatePlatformMicrositeLocationMutation. */
export type GUpdatePlatformMicrositeLocationMutationPayload = {
  __typename?: 'UpdatePlatformMicrositeLocationMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  platformMicrositeLocation: GPlatformMicrosite;
};

/** Autogenerated input type of UpdateReceivableNote */
export type GUpdateReceivableNoteInput = {
  body: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of UpdateReceivableNote. */
export type GUpdateReceivableNotePayload = {
  __typename?: 'UpdateReceivableNotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  receivableNote?: Maybe<GReceivableNote>;
};

/** Autogenerated input type of UpdateSoApiRoutingImportPlanTruckCountMutation */
export type GUpdateSoApiRoutingImportPlanTruckCountMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Routing import plan night end. */
  nightEnd: Scalars['ISO8601Date'];
  /** Routing import plan truck count. */
  truckCount: Scalars['Int'];
  /** Warehouse id. */
  warehouseId: Scalars['ID'];
};

/** Autogenerated return type of UpdateSoApiRoutingImportPlanTruckCountMutation. */
export type GUpdateSoApiRoutingImportPlanTruckCountMutationPayload = {
  __typename?: 'UpdateSoApiRoutingImportPlanTruckCountMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GUserError>;
};

/** Autogenerated input type of UpdateSquareOrderSuggestionFromTranscriptMutation */
export type GUpdateSquareOrderSuggestionFromTranscriptMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the order suggestion to update */
  suggestionId: Scalars['ID'];
  /** Additional transcript to append and parse */
  transcript: Scalars['String'];
};

/** Autogenerated return type of UpdateSquareOrderSuggestionFromTranscriptMutation. */
export type GUpdateSquareOrderSuggestionFromTranscriptMutationPayload = {
  __typename?: 'UpdateSquareOrderSuggestionFromTranscriptMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']>;
  /** The updated order suggestion */
  orderSuggestion?: Maybe<GSquareOrderSuggestion>;
};

/** Autogenerated input type of UpdateSquareOrderSuggestionMutation */
export type GUpdateSquareOrderSuggestionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Complete list of line items (replaces existing) */
  lineItems: Array<GSquareOrderSuggestionLineItemInput>;
  /** Optional note to update */
  note?: InputMaybe<Scalars['String']>;
  /** The ID of the order suggestion to update */
  suggestionId: Scalars['ID'];
};

/** Autogenerated return type of UpdateSquareOrderSuggestionMutation. */
export type GUpdateSquareOrderSuggestionMutationPayload = {
  __typename?: 'UpdateSquareOrderSuggestionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']>;
  /** The updated order suggestion */
  orderSuggestion?: Maybe<GSquareOrderSuggestion>;
};

/** Autogenerated input type of UpdateSubmenuSavedVisibility */
export type GUpdateSubmenuSavedVisibilityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /**
   * Submenu's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
  /** Submenu ID. */
  submenuId: Scalars['ID'];
  /**
   * Visibility value to save. This sets the submenu's "visibility.savedValue" and
   * has a cascading effect on the "visibility.effectiveValue" of its menu-items.
   * This also determines the submenu's effective visibility if it belongs to a
   * visible menu. If it belongs to a hidden menu, the submenu remains effectively
   * hidden regardless of its saved visibility value.
   */
  value: GVisibilityEnum;
};

/** Autogenerated return type of UpdateSubmenuSavedVisibility */
export type GUpdateSubmenuSavedVisibilityPayload = {
  __typename?: 'UpdateSubmenuSavedVisibilityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to update the submenu's saved visibility value. */
  result: GSubmenuResult;
};

/** Input for updating the sort order of a submenu. */
export type GUpdateSubmenuSortOrderInput = {
  /**
   * Submenu's current lock version. If an outdated lock version is provided, the
   * operation will be rejected to prevent stale/concurrent updates.
   */
  lockVersion: Scalars['Int'];
  /** Submenu ID */
  submenuId: Scalars['ID'];
};

/** Autogenerated input type of UpdateSubmenusSortOrder */
export type GUpdateSubmenusSortOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /**
   * List describing the desired sort order of menu's submenus. This list must be
   * exhaustive, i.e. it should contain an element for each submenu the menu has.
   * The operation will be rejected if given a non-exhaustive list or a list that
   * contains duplicates. It will also be rejected if any of the list elements
   * identify submenus that don't belong to the right menu.
   */
  elements: Array<GUpdateSubmenuSortOrderInput>;
  /** The ID of the menu whose submenus are being sorted. */
  menuId: Scalars['ID'];
};

/** Autogenerated return type of UpdateSubmenusSortOrder */
export type GUpdateSubmenusSortOrderPayload = {
  __typename?: 'UpdateSubmenusSortOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Result of attempting to update the submenus' sort order. */
  result: GSubmenusResult;
};

/** Autogenerated input type of UpdateSubscriptionSessionMutation */
export type GUpdateSubscriptionSessionMutationInput = {
  /** Auth0 user ID for newly created user (sets existing_auth0_user_id) */
  auth0UserId?: InputMaybe<Scalars['String']>;
  /** Business name */
  businessName?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Context for the subscription session */
  context?: InputMaybe<Scalars['String']>;
  /** User email address */
  email?: InputMaybe<Scalars['String']>;
  /** Google Location name for linking */
  googleLocationName?: InputMaybe<Scalars['String']>;
  /** Google Places API place ID */
  googlePlaceId?: InputMaybe<Scalars['String']>;
  /** Pricing package ID */
  pricingPackageId?: InputMaybe<Scalars['Int']>;
  /** Frontend origin URL for return navigation */
  returnOrigin?: InputMaybe<Scalars['String']>;
  /** Physical sign color preference */
  signColor?: InputMaybe<Scalars['String']>;
  /** Physical sign material preference */
  signMaterial?: InputMaybe<Scalars['String']>;
  /** ID of the subscription session to update */
  subscriptionSessionId: Scalars['ID'];
  /** URL-friendly slug for microsite */
  urlSlug?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateSubscriptionSessionMutation. */
export type GUpdateSubscriptionSessionMutationPayload = {
  __typename?: 'UpdateSubscriptionSessionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']>;
  /** Updated subscription session */
  subscriptionSession?: Maybe<GSubscriptionSession>;
};

/** Autogenerated input type of UpdateUserMutation */
export type GUpdateUserMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Required for admin actors; ignored for customer-role actors. */
  companyOdekoUuid?: InputMaybe<Scalars['ID']>;
  /** Updated email address */
  email?: InputMaybe<Scalars['String']>;
  /** Updated first name */
  firstName?: InputMaybe<Scalars['String']>;
  /** Updated last name */
  lastName?: InputMaybe<Scalars['String']>;
  /** Full desired set of location UUIDs (replace semantics). Omit to leave unchanged. */
  locationOdekoUuids?: InputMaybe<Array<Scalars['String']>>;
  /** Updated phone number */
  phone?: InputMaybe<Scalars['String']>;
  /** Updated role */
  role?: InputMaybe<Scalars['String']>;
  /** Auth0 user ID of the user to update */
  userId: Scalars['ID'];
};

/** Autogenerated return type of UpdateUserMutation. */
export type GUpdateUserMutationPayload = {
  __typename?: 'UpdateUserMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GUserError>;
  user?: Maybe<GUser>;
};

/** Autogenerated input type of UpdateUserNotificationPreferencesMutation */
export type GUpdateUserNotificationPreferencesMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Whether the user is subscribed to app updates and news email notifications */
  notifAppUpdatesNewsEmail?: InputMaybe<Scalars['Boolean']>;
  /** Whether the user is subscribed to app updates and news push notifications */
  notifAppUpdatesNewsPush?: InputMaybe<Scalars['Boolean']>;
  /** Whether the user is subscribed to new products email notifications */
  notifNewProductsEmail?: InputMaybe<Scalars['Boolean']>;
  /** Whether the user is subscribed to new products push notifications */
  notifNewProductsPush?: InputMaybe<Scalars['Boolean']>;
  /** Whether the user is subscribed to order cancelled email notifications. */
  notifOrderCancelledEmail?: InputMaybe<Scalars['Boolean']>;
  /** Whether the user is subscribed to order cancelled push notifications. */
  notifOrderCancelledPush?: InputMaybe<Scalars['Boolean']>;
  /** Whether the user is subscribed to order confirmed email notifications. */
  notifOrderConfirmedEmail?: InputMaybe<Scalars['Boolean']>;
  /** Whether the user is subscribed to order confirmed push notifications. */
  notifOrderConfirmedPush?: InputMaybe<Scalars['Boolean']>;
  /** Whether the user is subscribed to order delivered email notifications. */
  notifOrderDeliveredEmail?: InputMaybe<Scalars['Boolean']>;
  /** Whether the user is subscribed to order delivered push notifications. */
  notifOrderDeliveredPush?: InputMaybe<Scalars['Boolean']>;
  /** Whether the user is subscribed to order issue email notifications. */
  notifOrderIssueEmail?: InputMaybe<Scalars['Boolean']>;
  /** Whether the user is subscribed to order issue push notifications. */
  notifOrderIssuePush?: InputMaybe<Scalars['Boolean']>;
  /** Whether the user is subscribed to order shipped email notifications. */
  notifOrderShippedEmail?: InputMaybe<Scalars['Boolean']>;
  /** Whether the user is subscribed to order shipped push notifications. */
  notifOrderShippedPush?: InputMaybe<Scalars['Boolean']>;
  /** Whether the user is subscribed to order updated email notifications. */
  notifOrderUpdatedEmail?: InputMaybe<Scalars['Boolean']>;
  /** Whether the user is subscribed to order updated push notifications. */
  notifOrderUpdatedPush?: InputMaybe<Scalars['Boolean']>;
  /** Whether the user is subscribed to product back in stock email notifications. */
  notifProductBackInStockEmail?: InputMaybe<Scalars['Boolean']>;
  /** Whether the user is subscribed to product back in stock push notifications. */
  notifProductBackInStockPush?: InputMaybe<Scalars['Boolean']>;
  /** Whether the user is subscribed to promotions and discounts email notifications */
  notifPromotionsDiscountsEmail?: InputMaybe<Scalars['Boolean']>;
  /** Whether the user is subscribed to promotions and discounts push notifications */
  notifPromotionsDiscountsPush?: InputMaybe<Scalars['Boolean']>;
  /** Whether the user is subscribed to redelivery email notifications. */
  notifRedeliveryEmail?: InputMaybe<Scalars['Boolean']>;
  /** Whether the user is subscribed to redelivery push notifications. */
  notifRedeliveryPush?: InputMaybe<Scalars['Boolean']>;
  /** UUID of the user whose notification preferences to update. Defaults to the current user. */
  userUuid?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateUserNotificationPreferencesMutation. */
export type GUpdateUserNotificationPreferencesMutationPayload = {
  __typename?: 'UpdateUserNotificationPreferencesMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  user?: Maybe<GUser>;
};

/** Autogenerated input type of UpdateWarehouseArrivedAtRouteTime */
export type GUpdateWarehouseArrivedAtRouteTimeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Delivery route id. */
  deliveryRouteId: Scalars['ID'];
  /** Client-provided time the driver returned to the warehouse (a geofence crossing). Defaults to server time when omitted. */
  occurredAt?: InputMaybe<Scalars['ISO8601DateTime']>;
};

/** Autogenerated return type of UpdateWarehouseArrivedAtRouteTime. */
export type GUpdateWarehouseArrivedAtRouteTimePayload = {
  __typename?: 'UpdateWarehouseArrivedAtRouteTimePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  route?: Maybe<GRoute>;
  userErrors: Array<GRouteError>;
};

/** Autogenerated input type of UpdateWarehouseDepartedAtRouteTime */
export type GUpdateWarehouseDepartedAtRouteTimeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Delivery route id. */
  deliveryRouteId: Scalars['ID'];
  /** Client-provided time the driver departed the warehouse (a geofence crossing). Defaults to server time when omitted. */
  occurredAt?: InputMaybe<Scalars['ISO8601DateTime']>;
};

/** Autogenerated return type of UpdateWarehouseDepartedAtRouteTime. */
export type GUpdateWarehouseDepartedAtRouteTimePayload = {
  __typename?: 'UpdateWarehouseDepartedAtRouteTimePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  route?: Maybe<GRoute>;
  userErrors: Array<GRouteError>;
};

/** Autogenerated input type of UpdateWarehousesLeadTimeMutation */
export type GUpdateWarehousesLeadTimeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  warehouses: Array<GWarehouseLeadTimeInput>;
};

/** Autogenerated return type of UpdateWarehousesLeadTimeMutation. */
export type GUpdateWarehousesLeadTimeMutationPayload = {
  __typename?: 'UpdateWarehousesLeadTimeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UploadArtworkForItemMutation */
export type GUploadArtworkForItemMutationInput = {
  /** The S3 object key for the uploaded artwork */
  artworkS3Key?: InputMaybe<Scalars['String']>;
  /** The artwork to apply to the custom item */
  brandedItemArtworkId?: InputMaybe<Scalars['ID']>;
  /** The deal the artwork is being uploaded to */
  brandedItemDeal: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Any notes about the colors in the deal */
  colorNotes?: InputMaybe<Scalars['String']>;
  /** The company the artwork would belong to */
  company?: InputMaybe<Scalars['ID']>;
  /** The custom branded item the artwork is being uploaded to */
  customBrandedItemId: Scalars['ID'];
  /** Any misc notes about the deal */
  notes?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UploadArtworkForItemMutation. */
export type GUploadArtworkForItemMutationPayload = {
  __typename?: 'UploadArtworkForItemMutationPayload';
  brandedItemDeal?: Maybe<GBrandedItemDeal>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GUserError>;
};

/** Autogenerated input type of UploadArtworkMutation */
export type GUploadArtworkMutationInput = {
  /** The S3 object key for the uploaded artwork */
  artworkS3Key: Scalars['String'];
  /** The deal the artwork is being uploaded to */
  brandedItemDeal: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Any notes about the colors in the deal */
  colorNotes?: InputMaybe<Scalars['String']>;
  /** The company the artwork would belong to */
  company: Scalars['ID'];
  /** Any misc notes about the deal */
  notes?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UploadArtworkMutation. */
export type GUploadArtworkMutationPayload = {
  __typename?: 'UploadArtworkMutationPayload';
  brandedItemDeal?: Maybe<GBrandedItemDeal>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GUserError>;
};

export type GUploadItemImage = {
  __typename?: 'UploadItemImage';
  key: Scalars['String'];
  url: Scalars['String'];
};

export type GUploadItemImageByKey = {
  __typename?: 'UploadItemImageByKey';
  url: Scalars['String'];
};

/** Autogenerated input type of UpsertAccountCreationSession */
export type GUpsertAccountCreationSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Session data for create or update */
  session: GAccountCreationSessionInput;
};

/** Autogenerated return type of UpsertAccountCreationSession. */
export type GUpsertAccountCreationSessionPayload = {
  __typename?: 'UpsertAccountCreationSessionPayload';
  /** The created or updated account creation session */
  accountCreationSession?: Maybe<GAccountCreationSession>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpsertAdminOrderItemMutation */
export type GUpsertAdminOrderItemMutationInput = {
  /** The channel from which the order is being created */
  channel?: InputMaybe<GOrderChannelEnum>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the item to add to an order */
  itemUuid: Scalars['ID'];
  /** ID of the location for the order */
  locationUuid: Scalars['ID'];
  /** Quantity of item to order */
  quantity: Scalars['Int'];
  /**
   * Optional delivery date for the order. If provided, the system will attempt to
   * place the order for the next available delivery starting from this date. If
   * not provided, the system will calculate the next available delivery date based
   * on the location and vendor.
   */
  requestedDeliveryDate?: InputMaybe<Scalars['ISO8601Date']>;
};

/** Autogenerated return type of UpsertAdminOrderItemMutation. */
export type GUpsertAdminOrderItemMutationPayload = {
  __typename?: 'UpsertAdminOrderItemMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<GUserError>>;
  order?: Maybe<GOrder>;
};

/** Autogenerated input type of UpsertArAssignment */
export type GUpsertArAssignmentInput = {
  assigneeUuid: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyUuid: Scalars['String'];
};

/** Autogenerated return type of UpsertArAssignment. */
export type GUpsertArAssignmentPayload = {
  __typename?: 'UpsertArAssignmentPayload';
  arAssignment?: Maybe<GArAssignment>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
};

/** Autogenerated input type of UpsertBackInStockSubscriptionMutation */
export type GUpsertBackInStockSubscriptionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Notify the user once this quantity is available to purchase */
  desiredQuantity: Scalars['Int'];
  /** Item UUID */
  itemId: Scalars['ID'];
  /** Location UUID */
  locationId: Scalars['ID'];
};

/** Autogenerated return type of UpsertBackInStockSubscriptionMutation. */
export type GUpsertBackInStockSubscriptionMutationPayload = {
  __typename?: 'UpsertBackInStockSubscriptionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<GUserError>>;
  /** If true, mutation created a new subscription rather than update an existing one. */
  isNew?: Maybe<Scalars['Boolean']>;
  subscription?: Maybe<GBackInStockSubscription>;
};

export type GUpsertCategoryBannerInput = {
  /** The category or subcategory this banner is configured on. */
  categoryId: Scalars['ID'];
  /**
   * The creative every market inherits unless it carries its own. Unlike
   * `warehouses` it is not a full set a caller resends: omit it and whatever is
   * stored stays, because a call naming only per-market creative says nothing about
   * the default. Send null to remove it.
   */
  defaultCreative?: InputMaybe<GCategoryBannerDefaultInput>;
  /**
   * One entry per market that departs from `defaultCreative`, by carrying its own creative or by
   * being hidden. Markets left out are reset to inheriting the default, so a caller must send back
   * every market it means to keep — leaving one out is not how it is made to show nothing, which is
   * what `hidden` is for. May be empty when the banner has a default; use `deleteCategoryBanner` to
   * remove it outright.
   */
  warehouses: Array<GCategoryBannerWarehouseInput>;
};

/** Autogenerated input type of UpsertDeliveryDatePoNumbersMutation */
export type GUpsertDeliveryDatePoNumbersMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  deliveryDatePoNumbers: Array<GDeliveryDatePoNumberInput>;
  /** UUID for the Location */
  locationId: Scalars['ID'];
};

/** Autogenerated return type of UpsertDeliveryDatePoNumbersMutation. */
export type GUpsertDeliveryDatePoNumbersMutationPayload = {
  __typename?: 'UpsertDeliveryDatePoNumbersMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  deliveryDatePoNumbers?: Maybe<Array<GDeliveryDatePoNumber>>;
  errors: Array<GUserError>;
};

/** Autogenerated input type of UpsertExternalDeliveryMutation */
export type GUpsertExternalDeliveryMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Order id denoting the order that should be delivered via the 3rd party delivery partner. */
  orderId: Scalars['ID'];
  /** The number of containers used to pack the order. */
  totalContainers: Scalars['Int'];
};

/** Autogenerated return type of UpsertExternalDeliveryMutation. */
export type GUpsertExternalDeliveryMutationPayload = {
  __typename?: 'UpsertExternalDeliveryMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<GUserError>>;
  externalDelivery?: Maybe<GExternalDelivery>;
};

/** Autogenerated input type of UpsertExternalSupplier */
export type GUpsertExternalSupplierInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

/** Autogenerated return type of UpsertExternalSupplier. */
export type GUpsertExternalSupplierPayload = {
  __typename?: 'UpsertExternalSupplierPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  externalSupplier?: Maybe<GExternalSupplier>;
};

/** Autogenerated input type of UpsertLocationAccountsReceivableCollectionsStatus */
export type GUpsertLocationAccountsReceivableCollectionsStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  locationUuid: Scalars['String'];
  status: Scalars['String'];
};

/** Autogenerated return type of UpsertLocationAccountsReceivableCollectionsStatus. */
export type GUpsertLocationAccountsReceivableCollectionsStatusPayload = {
  __typename?: 'UpsertLocationAccountsReceivableCollectionsStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  locationArCollectionsStatus?: Maybe<GAccountsReceivableCollectionsStatus>;
};

/** Autogenerated input type of UpsertLocationItemBackupMutation */
export type GUpsertLocationItemBackupMutationInput = {
  /** UUID of the item to use instead */
  backupItemId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** UUID of the item the location orders */
  itemId: Scalars['ID'];
  /** Location UUID */
  locationId: Scalars['ID'];
};

/** Autogenerated return type of UpsertLocationItemBackupMutation. */
export type GUpsertLocationItemBackupMutationPayload = {
  __typename?: 'UpsertLocationItemBackupMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<GUserError>>;
  itemBackup?: Maybe<GLocationItemBackup>;
};

/** Autogenerated input type of UpsertLocationOrdersMutation */
export type GUpsertLocationOrdersMutationInput = {
  /** When true, skip the cutoff time check for authorized users (can_modify_order_after_cutoff). */
  bypassCutoff?: InputMaybe<Scalars['Boolean']>;
  /** Submission channel (e.g. WEB_PORTAL) */
  channel?: InputMaybe<GOrderChannelEnum>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** UUID of the location placing the orders */
  locationId: Scalars['ID'];
  /** One entry per delivery date, each containing one or more vendor orders */
  orders: Array<GLocationOrderDateInput>;
  /** Payment method type for the orders. Must match the location's configured payment method. */
  paymentMethodType?: InputMaybe<GPaymentMethodTypeEnum>;
};

/** Autogenerated return type of UpsertLocationOrdersMutation. */
export type GUpsertLocationOrdersMutationPayload = {
  __typename?: 'UpsertLocationOrdersMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GLocationOrderError>;
  results: Array<GLocationOrderResult>;
};

/** Autogenerated input type of UpsertLocationPhoneNumberMutation */
export type GUpsertLocationPhoneNumberMutationInput = {
  /** Allow drivers to contact the recipient between 6 PM and 6 AM in the location's time zone */
  afterHoursContactAllowed?: InputMaybe<Scalars['Boolean']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** UUID for the Location */
  locationUuid: Scalars['String'];
  /** A phone number in E.164 format */
  phoneNumber: Scalars['String'];
  /** Type of the phone number */
  phoneType: GLocationPhoneTypeEnum;
};

/** Autogenerated return type of UpsertLocationPhoneNumberMutation. */
export type GUpsertLocationPhoneNumberMutationPayload = {
  __typename?: 'UpsertLocationPhoneNumberMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneType?: Maybe<GLocationPhoneTypeEnum>;
};

export type GUpsertMasterHomepageInput = {
  endDate: Scalars['ISO8601Date'];
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  startDate: Scalars['ISO8601Date'];
};

export type GUpsertMasterHomepagePayload = {
  __typename?: 'UpsertMasterHomepagePayload';
  errors: Array<GMasterHomepageError>;
  masterHomepage?: Maybe<GMasterHomepageListItem>;
};

/** Autogenerated input type of UpsertMicrositeGuestbookMessageMutation */
export type GUpsertMicrositeGuestbookMessageMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  ip?: InputMaybe<Scalars['String']>;
  /** ID of the microsite location */
  locationId: Scalars['ID'];
  /** Content of the guestbook message */
  message: Scalars['String'];
  /** ID of the existing message to update (if any) */
  messageId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of UpsertMicrositeGuestbookMessageMutation. */
export type GUpsertMicrositeGuestbookMessageMutationPayload = {
  __typename?: 'UpsertMicrositeGuestbookMessageMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The upserted or updated guestbook message */
  micrositeGuestbookMessage?: Maybe<GMicrositeMessage>;
};

/** Autogenerated input type of UpsertMicrositeMenuItem */
export type GUpsertMicrositeMenuItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  menuItem: GMicrositeMenuItemInput;
  micrositeLocationId: Scalars['ID'];
};

/** Autogenerated return type of UpsertMicrositeMenuItem. */
export type GUpsertMicrositeMenuItemPayload = {
  __typename?: 'UpsertMicrositeMenuItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  micrositeMenuItem?: Maybe<GMicrositeMenuItem>;
};

export type GUpsertNewItemPinInput = {
  itemId: Scalars['ID'];
  /** Absolute carousel slot to pin to; appended to the end of that slot's succession queue. */
  position: Scalars['Int'];
  /** Mark this pin as a paid (sponsored) placement; defaults off. Internal merchandising/seasonal pins stay unlabeled. */
  sponsored?: InputMaybe<Scalars['Boolean']>;
  warehouseId: Scalars['ID'];
};

export type GUpsertOrderItemInput = {
  /** Item ID */
  id: Scalars['ID'];
  /** Quantity for the item */
  quantity: Scalars['Int'];
};

/** Autogenerated input type of UpsertOrderMutation */
export type GUpsertOrderMutationInput = {
  /** The channel from which the order is being created or updated (e.g., web_portal, mobile_ios, mobile_android) */
  channel?: InputMaybe<GOrderChannelEnum>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** List of coupon codes to apply. */
  couponCodes?: InputMaybe<Array<Scalars['String']>>;
  /** The requested delivery for the items */
  deliveryDate: Scalars['ISO8601Date'];
  /** List of items the caller is requesting */
  items: Array<GUpsertOrderItemInput>;
  /** ID of the location for the order */
  locationId: Scalars['ID'];
  /**
   * The payment method type for the order. Used to determine the payment
   * processing fee. Must match the location's payment method type.
   */
  paymentMethodType?: InputMaybe<GPaymentMethodTypeEnum>;
  /** List of sales tax estimates to apply. */
  salesTaxEstimates?: InputMaybe<Array<GSalesTaxEstimateInput>>;
};

/** Autogenerated return type of UpsertOrderMutation. */
export type GUpsertOrderMutationPayload = {
  __typename?: 'UpsertOrderMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GError>;
  orders?: Maybe<Array<GOrder>>;
};

/** Autogenerated input type of UpsertProvisionalOrderMutation */
export type GUpsertProvisionalOrderMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  customerPoNumber?: InputMaybe<Scalars['String']>;
  deliveryDate?: InputMaybe<Scalars['ISO8601Date']>;
  /** The integration account to act for. Required for now; first-party clients only. */
  enrolledSenderId?: InputMaybe<Scalars['ID']>;
  /** Required to edit. */
  expectedVersion?: InputMaybe<Scalars['Int']>;
  /** The order to edit; omit to create. */
  id?: InputMaybe<Scalars['ID']>;
  /** Required to create. */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  intent?: InputMaybe<GProvisionalOrderIntentEnum>;
  /** Omit to leave the lines alone; an empty list removes them all. */
  lines?: InputMaybe<Array<GProvisionalOrderLineInput>>;
  locationId?: InputMaybe<Scalars['ID']>;
  mappingVersion?: InputMaybe<Scalars['Int']>;
  policyVersion?: InputMaybe<Scalars['Int']>;
  purchaseOrder?: InputMaybe<GProvisionalOrderPurchaseOrderInput>;
};

/** Autogenerated return type of UpsertProvisionalOrderMutation. */
export type GUpsertProvisionalOrderMutationPayload = {
  __typename?: 'UpsertProvisionalOrderMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GProvisionalOrderError>;
  provisionalOrder?: Maybe<GProvisionalOrder>;
};

/** Autogenerated input type of UpsertRecipeMutation */
export type GUpsertRecipeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Ingredients */
  ingredients: Array<GRecipeIngredientInput>;
  /** UUID for the Location */
  locationId: Scalars['ID'];
  /** ID for the MenuItemSize */
  menuItemSizeUuid: Scalars['ID'];
  /** ID for the MenuItem */
  menuItemUuid: Scalars['ID'];
};

/** Autogenerated return type of UpsertRecipeMutation. */
export type GUpsertRecipeMutationPayload = {
  __typename?: 'UpsertRecipeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GUserError>;
  recipe?: Maybe<GRecipe>;
};

/** Autogenerated input type of UpsertShippingInstructionsMutation */
export type GUpsertShippingInstructionsMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** UUID for the Location */
  locationId: Scalars['ID'];
  shippingInstructions: GShippingInstructionsInput;
};

/** Autogenerated return type of UpsertShippingInstructionsMutation. */
export type GUpsertShippingInstructionsMutationPayload = {
  __typename?: 'UpsertShippingInstructionsMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GUserError>;
  shippingInstructions?: Maybe<GShippingInstructions>;
};

export type GUpsertSubstitutionOverrideInput = {
  priority?: InputMaybe<Scalars['Int']>;
  reason?: InputMaybe<Scalars['String']>;
  sourceItemId: Scalars['ID'];
  substituteItemId: Scalars['ID'];
};

/** Autogenerated input type of UpsertSurveyMutation */
export type GUpsertSurveyMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Is survey fully completed */
  completed: Scalars['Boolean'];
  /** Location UUID */
  locationId: Scalars['ID'];
  /** Survey name */
  name: Scalars['String'];
  /** User answers */
  responses: Array<GSurveyResponseInput>;
  /** Survey belongs to a Company or Location */
  surveyLevel: GSurveyLevelEnum;
};

/** Autogenerated return type of UpsertSurveyMutation. */
export type GUpsertSurveyMutationPayload = {
  __typename?: 'UpsertSurveyMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GUserError>;
  survey?: Maybe<GSurvey>;
};

/** Autogenerated input type of UpsertWarehouseZipcodes */
export type GUpsertWarehouseZipcodesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  warehouseId: Scalars['ID'];
  zipcodes: Array<Scalars['String']>;
};

/** Autogenerated return type of UpsertWarehouseZipcodes. */
export type GUpsertWarehouseZipcodesPayload = {
  __typename?: 'UpsertWarehouseZipcodesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<GUserError>;
  zipcodes: Array<GZipcode>;
};

/** Autogenerated input type of UpsertZipcodeDeliveryRule */
export type GUpsertZipcodeDeliveryRuleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Delivery rule day, 0-6, 0 is Sunday */
  deliveryDay: Scalars['Int'];
  /** Lead time for delivery in days, 1-365 */
  leadTime: Scalars['Int'];
  /** Deadline for ordering to be submitted in format HH:MM */
  orderDeadline: Scalars['String'];
  /** The Zipcode to upsert a delivery rule for */
  zipcode: Scalars['String'];
};

/** Autogenerated return type of UpsertZipcodeDeliveryRule. */
export type GUpsertZipcodeDeliveryRulePayload = {
  __typename?: 'UpsertZipcodeDeliveryRulePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  deliveryRule?: Maybe<GDeliveryRule>;
  errors: Array<GUserError>;
};

/** Autogenerated input type of UpsertZipcodeDeliveryWindow */
export type GUpsertZipcodeDeliveryWindowInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** End time in the format of HH:MM */
  endTime: Scalars['String'];
  /** Start time in the format of HH:MM */
  startTime: Scalars['String'];
  /** The Zipcode to upsert a delivery window */
  zipcode: Scalars['String'];
};

/** Autogenerated return type of UpsertZipcodeDeliveryWindow. */
export type GUpsertZipcodeDeliveryWindowPayload = {
  __typename?: 'UpsertZipcodeDeliveryWindowPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  deliveryWindow?: Maybe<GZipcodeDeliveryWindow>;
  errors: Array<GUserError>;
};

/**
 * A user is an individual's account on Odeko that can access services according to
 * their roles and permissions.
 */
export type GUser = {
  __typename?: 'User';
  /**
   * Locations assigned to this user (the target), scoped to the viewer's own
   * location access. Admin viewers see all of the target's locations; every other
   * viewer sees only the intersection of the target's locations and the locations
   * the viewer can themselves access. Unlike `locations`, this is resolved against
   * the target user, not the viewer.
   */
  assignedLocations: Array<GLocation>;
  auditLogs: GAuditLogConnection;
  /**
   * The Auth0 user ID associated with this user. Usually you can rely on the `id`
   * field instead, but in cases where you need to access the Auth0 ID
   * specifically, this field is provided.
   */
  auth0UserId?: Maybe<Scalars['String']>;
  /** @deprecated Use Query.availableItemBarcodeMatch; this lookup is not user-scoped. */
  availableItemBarcodeMatch?: Maybe<GItemBarcodeMatch>;
  availableItemById?: Maybe<GSupplyItem>;
  availableItemByName?: Maybe<GSupplyItem>;
  /** @deprecated Use Query.availableItemByUpcCode; this lookup is not user-scoped. */
  availableItemByUpcCode?: Maybe<GSupplyItem>;
  /** Extended fields */
  availableItems: GItemConnection;
  /** Unacknowledged back-in-stock notifications for one of a user's locations, oldest first. */
  backInStockNotifications: Array<GBackInStockNotification>;
  /** Link to the Business Portal admin interface for this user */
  bpAdminLink?: Maybe<Scalars['String']>;
  /**
   * The user's email from business-portal database. Use this instead of the
   * federated `email` field when querying users through location.users due to
   * federation key mismatch.
   */
  bpEmail?: Maybe<Scalars['String']>;
  /** Whether the user is permitted to submit orders after the cutoff time. */
  canModifyOrderAfterCutoff: Scalars['Boolean'];
  /** Client applications available to the user */
  clientApps: Array<Scalars['String']>;
  /** Whether the current viewer can edit this user, and why not if they can't. */
  editPermissionForViewer: GEditPermissionForViewerEnum;
  /** The user's email. */
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  /** The user's unique identifier. */
  id: Scalars['ID'];
  itemTags: GItemTagConnection;
  lastName?: Maybe<Scalars['String']>;
  /** An item's location assignment history, collapsed into runs by user and paged by run, newest first */
  locationChangeGroups: GLocationChangeGroupConnection;
  locations: GLocationConnection;
  /** Number of locations assigned to this user. */
  locationsCount: Scalars['Int'];
  /** The user's name. */
  name?: Maybe<Scalars['String']>;
  /**
   * Admin/preview entry point into the shared New Items ordering for an explicit
   * market. Unlike Location.newItems — which derives the market from a shopper's
   * location — this takes warehouseId directly, so internal tooling (the
   * merchandising studio's View All) can render true carousel order for any market,
   * search within it, and pin in context. Delegates to the same shared resolution as
   * Location.newItems, so the admin view can never drift from what shoppers see.
   * searchQuery runs against the catalog directly (no Algolia), so admin results are
   * deterministic. Returns plain SupplyItems; pin state is overlaid client-side from
   * newItemPins.
   */
  newItems: GItemConnection;
  /** Whether the user is subscribed to app updates and news email notifications */
  notifAppUpdatesNewsEmail: Scalars['Boolean'];
  /** Whether the user is subscribed to app updates and news push notifications */
  notifAppUpdatesNewsPush: Scalars['Boolean'];
  /** Whether the user is subscribed to new products email notifications */
  notifNewProductsEmail: Scalars['Boolean'];
  /** Whether the user is subscribed to new products push notifications */
  notifNewProductsPush: Scalars['Boolean'];
  /** Whether the user is subscribed to order cancelled email notifications. */
  notifOrderCancelledEmail: Scalars['Boolean'];
  /** Whether the user is subscribed to order cancelled push notifications. */
  notifOrderCancelledPush: Scalars['Boolean'];
  /** Whether the user is subscribed to order confirmed email notifications. */
  notifOrderConfirmedEmail: Scalars['Boolean'];
  /** Whether the user is subscribed to order confirmed push notifications. */
  notifOrderConfirmedPush: Scalars['Boolean'];
  /** Whether the user is subscribed to order delivered email notifications. */
  notifOrderDeliveredEmail: Scalars['Boolean'];
  /** Whether the user is subscribed to order delivered push notifications. */
  notifOrderDeliveredPush: Scalars['Boolean'];
  /** Whether the user is subscribed to order issue email notifications. */
  notifOrderIssueEmail: Scalars['Boolean'];
  /** Whether the user is subscribed to order issue push notifications. */
  notifOrderIssuePush: Scalars['Boolean'];
  /** Whether the user is subscribed to order shipped email notifications. */
  notifOrderShippedEmail: Scalars['Boolean'];
  /** Whether the user is subscribed to order shipped push notifications. */
  notifOrderShippedPush: Scalars['Boolean'];
  /** Whether the user is subscribed to order updated email notifications. */
  notifOrderUpdatedEmail: Scalars['Boolean'];
  /** Whether the user is subscribed to order updated push notifications. */
  notifOrderUpdatedPush: Scalars['Boolean'];
  /** Whether the user is subscribed to product back in stock email notifications. */
  notifProductBackInStockEmail: Scalars['Boolean'];
  /** Whether the user is subscribed to product back in stock push notifications. */
  notifProductBackInStockPush: Scalars['Boolean'];
  /** Whether the user is subscribed to promotions and discounts email notifications */
  notifPromotionsDiscountsEmail: Scalars['Boolean'];
  /** Whether the user is subscribed to promotions and discounts push notifications */
  notifPromotionsDiscountsPush: Scalars['Boolean'];
  /** Whether the user is subscribed to redelivery email notifications. */
  notifRedeliveryEmail: Scalars['Boolean'];
  /** Whether the user is subscribed to redelivery push notifications. */
  notifRedeliveryPush: Scalars['Boolean'];
  /** The user's payroll identifier (assigned in ARMhr), if one is set. */
  payrollId?: Maybe<Scalars['String']>;
  /** The user's phone number in ###-###-#### format. */
  phoneNumber?: Maybe<Scalars['String']>;
  /** The user's role with display name, summary, and permissions. */
  role?: Maybe<GRole>;
  uuid: Scalars['String'];
};


/**
 * A user is an individual's account on Odeko that can access services according to
 * their roles and permissions.
 */
export type GUserAuditLogsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  excludeObjectTypes?: InputMaybe<Array<Scalars['String']>>;
  first?: InputMaybe<Scalars['Int']>;
  itemId?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  objects?: InputMaybe<Array<InputMaybe<GAuditLogObjectInput>>>;
  sortOrder?: InputMaybe<Array<InputMaybe<GAuditLogSortOrder>>>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']>;
};


/**
 * A user is an individual's account on Odeko that can access services according to
 * their roles and permissions.
 */
export type GUserAvailableItemBarcodeMatchArgs = {
  code: Scalars['String'];
};


/**
 * A user is an individual's account on Odeko that can access services according to
 * their roles and permissions.
 */
export type GUserAvailableItemByIdArgs = {
  id: Scalars['ID'];
};


/**
 * A user is an individual's account on Odeko that can access services according to
 * their roles and permissions.
 */
export type GUserAvailableItemByNameArgs = {
  name: Scalars['String'];
};


/**
 * A user is an individual's account on Odeko that can access services according to
 * their roles and permissions.
 */
export type GUserAvailableItemByUpcCodeArgs = {
  upcCode: Scalars['String'];
};


/**
 * A user is an individual's account on Odeko that can access services according to
 * their roles and permissions.
 */
export type GUserAvailableItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  categories?: InputMaybe<Array<InputMaybe<GItemsCategoryInput>>>;
  filters?: InputMaybe<GItemsFiltersInput>;
  first?: InputMaybe<Scalars['Int']>;
  itemTypes?: InputMaybe<Array<InputMaybe<GItemType>>>;
  last?: InputMaybe<Scalars['Int']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Array<InputMaybe<GItemsSortOrder>>>;
  subcategories?: InputMaybe<Array<InputMaybe<GItemsSubcategoryInput>>>;
  vendors?: InputMaybe<Array<InputMaybe<GItemsVendorInput>>>;
  warehouses?: InputMaybe<Array<InputMaybe<GItemsWarehouseInput>>>;
};


/**
 * A user is an individual's account on Odeko that can access services according to
 * their roles and permissions.
 */
export type GUserBackInStockNotificationsArgs = {
  locationId: Scalars['ID'];
};


/**
 * A user is an individual's account on Odeko that can access services according to
 * their roles and permissions.
 */
export type GUserItemTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<GItemTagFiltersInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Array<InputMaybe<GItemTagSortOrder>>>;
};


/**
 * A user is an individual's account on Odeko that can access services according to
 * their roles and permissions.
 */
export type GUserLocationChangeGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  itemId: Scalars['ID'];
  last?: InputMaybe<Scalars['Int']>;
};


/**
 * A user is an individual's account on Odeko that can access services according to
 * their roles and permissions.
 */
export type GUserLocationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<GLocationsFilter>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<GLocationSearchFiltersInput>;
};


/**
 * A user is an individual's account on Odeko that can access services according to
 * their roles and permissions.
 */
export type GUserNewItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<GNewItemsFiltersInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  warehouseId: Scalars['ID'];
};

/** User-readable error */
export type GUserError = GError & {
  __typename?: 'UserError';
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** UserError interface to allow to return one or multiple types of errors. */
export type GUserErrorInterface = {
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** A UserMicrositeLocation. Represents a user's association with a microsite location. */
export type GUserMicrositeLocation = {
  __typename?: 'UserMicrositeLocation';
  /** ID of the UserMicrositeAssociation */
  id: Scalars['ID'];
  /** Whether this is the user's first microsite */
  isFirstMicrosite: Scalars['Boolean'];
  /** The microsite location associated with the user */
  micrositeLocation: GMicrositeLocation;
  /** The Auth0 user id associated with the microsite */
  userId: Scalars['ID'];
};

/** User platform connection with platform entities (accounts/profiles) and their microsites */
export type GUserPlatformConnection = {
  __typename?: 'UserPlatformConnection';
  /** The user's default microsite (the first microsite they created) */
  defaultMicrositeLocation?: Maybe<GMicrositeLocation>;
  /** The user's email for their identity on the connected platform. */
  email?: Maybe<Scalars['String']>;
  /** Whether the user has connected to the platform */
  isConnected: Scalars['Boolean'];
  /** The platform identifier */
  platformId: GPlatformIds;
  /** List of platform entities (accounts/profiles) with their microsite associations */
  platformMicrosites: Array<GPlatformMicrosite>;
};

/** Autogenerated input type of ValidateAndCompleteSubscriptionSessionMutation */
export type GValidateAndCompleteSubscriptionSessionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Stripe checkout session ID to validate and complete */
  stripeCheckoutSessionId: Scalars['String'];
};

/** Autogenerated return type of ValidateAndCompleteSubscriptionSessionMutation. */
export type GValidateAndCompleteSubscriptionSessionMutationPayload = {
  __typename?: 'ValidateAndCompleteSubscriptionSessionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']>;
  /** Completed subscription session */
  subscriptionSession?: Maybe<GSubscriptionSession>;
};

/** Autogenerated input type of ValidateSubscriptionSessionCheckoutMutation */
export type GValidateSubscriptionSessionCheckoutMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Stripe checkout session ID to validate */
  stripeCheckoutSessionId: Scalars['String'];
};

/** Autogenerated return type of ValidateSubscriptionSessionCheckoutMutation. */
export type GValidateSubscriptionSessionCheckoutMutationPayload = {
  __typename?: 'ValidateSubscriptionSessionCheckoutMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Any errors that occurred */
  errors: Array<Scalars['String']>;
  /** Updated subscription session */
  subscriptionSession?: Maybe<GSubscriptionSession>;
};

export type GVehicleInspectionPhaseStatus = {
  __typename?: 'VehicleInspectionPhaseStatus';
  reportId?: Maybe<Scalars['ID']>;
  submitted: Scalars['Boolean'];
  submittedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type GVehicleInspectionPhoto = {
  __typename?: 'VehicleInspectionPhoto';
  contentType?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  position: Scalars['Int'];
  url?: Maybe<Scalars['String']>;
};

export type GVehicleInspectionReport = {
  __typename?: 'VehicleInspectionReport';
  deliveryRouteId: Scalars['ID'];
  driver?: Maybe<GDriver>;
  hasIssues: Scalars['Boolean'];
  id: Scalars['ID'];
  inspectionType: Scalars['String'];
  issueCount: Scalars['Int'];
  photos: Array<GVehicleInspectionPhoto>;
  responses: Scalars['JSON'];
  schemaVersion: Scalars['Int'];
  submittedAt: Scalars['ISO8601DateTime'];
  /** Display name captured at submission; legacy reports fall back to responses or the associated driver. */
  submittedByName?: Maybe<Scalars['String']>;
  /** Authenticated user id captured at submission; legacy reports fall back to the associated driver. */
  submittedByUserId?: Maybe<Scalars['String']>;
  truck: GTruck;
  warehouse: GWarehouse;
};

/** Autogenerated input type of VehicleInspectionReportCreate */
export type GVehicleInspectionReportCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  deliveryRouteId: Scalars['ID'];
  inspectionType: Scalars['String'];
  responses: Scalars['JSON'];
  schemaVersion: Scalars['Int'];
  submittedAt: Scalars['ISO8601DateTime'];
  /** Authenticated submitter's display name. */
  submittedByName?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of VehicleInspectionReportCreate. */
export type GVehicleInspectionReportCreatePayload = {
  __typename?: 'VehicleInspectionReportCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  report?: Maybe<GVehicleInspectionReport>;
  userErrors: Array<GUserError>;
};

export type GVehicleInspectionRouteStatus = {
  __typename?: 'VehicleInspectionRouteStatus';
  deliveryRouteId: Scalars['ID'];
  /** Driver assigned to the route. */
  driverName?: Maybe<Scalars['String']>;
  /** True when any issue was reported across the route's pre/post inspections. */
  hasIssues: Scalars['Boolean'];
  /** Total issues reported across the route's pre/post inspections. */
  issueCount: Scalars['Int'];
  /** Labels of the flagged questions across the route's pre/post inspections, de-duplicated. */
  issueLabels: Array<Scalars['String']>;
  nightEnd: Scalars['ISO8601Date'];
  /** Post-trip inspection status; submitted is false when none was logged. */
  post: GVehicleInspectionPhaseStatus;
  /** Pre-trip inspection status; submitted is false when none was logged. */
  pre: GVehicleInspectionPhaseStatus;
  /** Display name of the assigned route. */
  routeName?: Maybe<Scalars['String']>;
  /** The truck these route statuses belong to. */
  truck: GTruck;
};

export type GVehicleInspectionStatus = {
  __typename?: 'VehicleInspectionStatus';
  deliveryRouteId: Scalars['ID'];
  post: GVehicleInspectionPhaseStatus;
  pre: GVehicleInspectionPhaseStatus;
};

export type GVehicleInspectionTruckStatus = {
  __typename?: 'VehicleInspectionTruckStatus';
  hasIssues: Scalars['Boolean'];
  inspected: Scalars['Boolean'];
  issueCount: Scalars['Int'];
  latestSubmittedAt?: Maybe<Scalars['ISO8601DateTime']>;
  postTripReportCount: Scalars['Int'];
  preTripReportCount: Scalars['Int'];
  reportCount: Scalars['Int'];
  routeCount: Scalars['Int'];
  truck: GTruck;
};

export type GVendor = {
  __typename?: 'Vendor';
  address?: Maybe<GAddress>;
  id: Scalars['ID'];
  isWarehouse: Scalars['Boolean'];
  itemLevelTracking: Scalars['Boolean'];
  /**
   * Legal vendor name — only use on internal-facing surfaces where the distinction
   * from the display name matters (e.g. driver and ops tooling)
   */
  legalName: Scalars['String'];
  /** Display name — returns display_name when set, otherwise the legal name */
  name: Scalars['String'];
  numericId: Scalars['Int'];
  vendorAccessInstruction?: Maybe<GVendorAccessInstruction>;
  vendorItemInstruction?: Maybe<GVendorItemInstruction>;
  warehouse?: Maybe<GWarehouse>;
};

export type GVendorAccessInstruction = {
  __typename?: 'VendorAccessInstruction';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  imageUrls?: Maybe<Array<Scalars['String']>>;
  note?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  videoUrls?: Maybe<Array<Scalars['String']>>;
};

export type GVendorItemInstruction = {
  __typename?: 'VendorItemInstruction';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  imageUrls?: Maybe<Array<Scalars['String']>>;
  note?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  videoUrls?: Maybe<Array<Scalars['String']>>;
};

export type GVendorOrdersInput = {
  nightEnd: Scalars['ISO8601Date'];
  vendorId?: InputMaybe<Scalars['ID']>;
  warehouseId: Scalars['ID'];
};

export type GVendorReceivingCheckinInput = {
  nightEnd: Scalars['ISO8601Date'];
  vendorId: Scalars['ID'];
  warehouseId: Scalars['ID'];
};

/** Aggregated item data for vendor receiving check-in view */
export type GVendorReceivingCheckinItem = {
  __typename?: 'VendorReceivingCheckinItem';
  /** List of customer location names that ordered this item */
  customerNames: Array<Scalars['String']>;
  itemId: Scalars['ID'];
  itemName: Scalars['String'];
  /** Item markup percentage from IMS */
  markupPercentage?: Maybe<Scalars['Float']>;
  /** Total ordered quantity across all customers */
  orderedQty: Scalars['Int'];
  receivedQty?: Maybe<Scalars['Float']>;
  sellingPricePerUnitCents?: Maybe<Scalars['Int']>;
  /** The underlying supply item */
  supplyItem?: Maybe<GSupplyItem>;
  vendorPricePerUnitCents?: Maybe<Scalars['Int']>;
  vendorPriceTotalCents?: Maybe<Scalars['Int']>;
  /** When the receiving window expires for this session */
  windowClosesAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type GVendorReceivingListInput = {
  nightEnd: Scalars['ISO8601Date'];
  warehouseId: Scalars['ID'];
};

export enum GVendorReceivingStatus {
  /** All market-priced lines are fully allocated */
  Allocated = 'ALLOCATED',
  /** Some market-priced lines have been allocated but not all */
  Allocating = 'ALLOCATING',
  /** Check-in data exists but no lines have been allocated */
  CheckedIn = 'CHECKED_IN',
  /** No check-in saved and no lines allocated yet */
  Pending = 'PENDING',
  /** All market-priced lines are allocated but at least one is short */
  Shortage = 'SHORTAGE'
}

/** Summary of a vendor's market-priced orders for a given delivery date */
export type GVendorReceivingSummary = {
  __typename?: 'VendorReceivingSummary';
  orderCount: Scalars['Int'];
  /** Total units short across all allocated market-priced lines */
  shortageCount?: Maybe<Scalars['Int']>;
  /** Current receiving state for this vendor */
  status: GVendorReceivingStatus;
  totalOrderedQty: Scalars['Int'];
  vendor?: Maybe<GVendor>;
  vendorId: Scalars['ID'];
  vendorName?: Maybe<Scalars['String']>;
  /**
   * Receiving window close time for this vendor's session at the given
   * warehouse/night_end. Nil if no check-in has started (window not open). Past =
   * window closed (UI should disable edits and show a view-only state). Reflects
   * state at response time; the API still enforces the window on submit.
   */
  windowClosesAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type GVisibility = {
  __typename?: 'Visibility';
  /** Effective value, accounting for saved value and the visibility of parent objects. */
  effectiveValue: GVisibilityEnum;
  /**
   * Saved value. This does not account for the visibility of parent objects, which
   * could mask an otherwise visible object. See effectiveValue.
   */
  savedValue: GVisibilityEnum;
};

/** The possible visibility values. */
export enum GVisibilityEnum {
  /** Hidden. */
  Hidden = 'hidden',
  /** Visible. */
  Visible = 'visible'
}

/** Autogenerated input type of VoteMicrositePollMutation */
export type GVoteMicrositePollMutationInput = {
  /** ID of the answer to vote for (new frontend) */
  answerId?: InputMaybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  micrositePollId: Scalars['ID'];
};

/** Autogenerated return type of VoteMicrositePollMutation. */
export type GVoteMicrositePollMutationPayload = {
  __typename?: 'VoteMicrositePollMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  poll: GMicrositePoll;
};

/** Wallet. */
export type GWallet = {
  __typename?: 'Wallet';
  /** Square default card id. */
  squareDefaultCardId?: Maybe<Scalars['String']>;
};

/** Error indicating that a mutation failed because the wallet balance is insufficient. */
export type GWalletBalanceInsufficient = GError & {
  __typename?: 'WalletBalanceInsufficient';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Wallet mutation result. */
export type GWalletResult = GErrorsResult | GWalletSuccess;

/** Error indicating that a mutation failed because the wallet's squareUserId is blank. */
export type GWalletSquareUserIdBlank = GError & {
  __typename?: 'WalletSquareUserIdBlank';
  /** A description of the error. */
  message: Scalars['String'];
};

/** Result of a successful wallet mutation. */
export type GWalletSuccess = {
  __typename?: 'WalletSuccess';
  /** Resulting wallet. */
  wallet: GWallet;
};

export type GWarehouse = {
  __typename?: 'Warehouse';
  brandedPaperLeadTime?: Maybe<Scalars['Int']>;
  categories: Array<GCategory>;
  currentNightEnd?: Maybe<Scalars['ISO8601DateTime']>;
  fees: Array<GFeeInterface>;
  /**
   * Delivery geofence radius in meters, used for stop/warehouse arrive-depart
   * detection in the driver app and the geofence circles drawn in
   * logistics-web-app. Note: iOS OS region monitoring is unreliable below ~150m,
   * so values under 150m may silently degrade arrival detection.
   */
  geofenceRadiusMeters: Scalars['Int'];
  id: Scalars['ID'];
  /**
   * A prefill for the mark-time pickup field (epic D8), as a 24-hour "HH:MM" time
   * of day in this warehouse's own time zone, never a date: the newest marked
   * route's pickup time for this provider at this warehouse, or the dispatch
   * profile's default_pickup_time when none has one yet.
   */
  lastThirdPartyPickupTime?: Maybe<Scalars['String']>;
  /** WGS84 latitude of the warehouse address. Null if the address is not geocoded. */
  latitude?: Maybe<Scalars['Float']>;
  locations?: Maybe<Array<GLocation>>;
  /** WGS84 longitude of the warehouse address. Null if the address is not geocoded. */
  longitude?: Maybe<Scalars['Float']>;
  membershipProgramEnabled: Scalars['Boolean'];
  name: Scalars['String'];
  pkId?: Maybe<Scalars['ID']>;
  /** Current routing cohorts associated with the warehouse */
  routingCohorts: Array<GRoutingCohort>;
  spendTiers: Array<GWarehouseSpendTier>;
  /**
   * The external delivery providers this warehouse can currently be offered, in
   * registry order. A provider Odeko hands over manually (Metrobi) is always
   * listed. A provider Odeko dispatches by API (Burq) is listed only once it could
   * actually be pushed to: its per-warehouse flag is on, its store id is set, and
   * the warehouse has a phone number a courier can reach. Empty is never expected,
   * since Metrobi is always listed.
   */
  thirdPartyProviders: Array<GThirdPartyProvider>;
  timeZone: Scalars['String'];
  /** Trucks belonging to this warehouse (the per-warehouse roster) */
  trucks: Array<GTruck>;
  vendor?: Maybe<Array<GVendor>>;
  /** LDS-owned shift definitions for this warehouse, ordered by start time. */
  warehouseShifts: Array<GWarehouseShift>;
  zipcodes?: Maybe<Array<GZipcode>>;
};


export type GWarehouseCategoriesArgs = {
  filter?: InputMaybe<GCategoriesFilter>;
  forType?: InputMaybe<GCategoryType>;
  sortOrder?: InputMaybe<Array<InputMaybe<GCategoriesSortOrder>>>;
};


export type GWarehouseLastThirdPartyPickupTimeArgs = {
  provider: GThirdPartyProvider;
};


export type GWarehouseZipcodesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated input type of WarehouseAssociateBadgeRevoke */
export type GWarehouseAssociateBadgeRevokeInput = {
  associateId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of WarehouseAssociateBadgeRevoke. */
export type GWarehouseAssociateBadgeRevokePayload = {
  __typename?: 'WarehouseAssociateBadgeRevokePayload';
  associateId?: Maybe<Scalars['ID']>;
  badgeVersion?: Maybe<Scalars['Int']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

export enum GWarehouseAssociateStatus {
  /** Currently employed. */
  Active = 'ACTIVE',
  /** Disabled in ARMHR. */
  Disabled = 'DISABLED',
  /** No longer active (e.g. terminated). */
  Inactive = 'INACTIVE'
}

export type GWarehouseBaseBrandedItem = {
  __typename?: 'WarehouseBaseBrandedItem';
  catalogStatus: GBrandedItemCatalogStatus;
  id: Scalars['ID'];
  warehouse: GWarehouse;
};

export type GWarehouseBaseBrandedItemInput = {
  catalogStatus: GBrandedItemCatalogStatus;
  warehouse: Scalars['ID'];
};

/** Interpreted bins for a warehouse, grouped for Layout Builder consumption. */
export type GWarehouseBinLayout = {
  __typename?: 'WarehouseBinLayout';
  groups: Array<GBinGroup>;
  /** Bins whose names didn't match the grammar, surfaced so coverage gaps stay visible. */
  unrecognized: Array<GInterpretedBin>;
  warehouseId: Scalars['ID'];
};

export type GWarehouseBinTransferCommand = {
  __typename?: 'WarehouseBinTransferCommand';
  baseUnitQuantity: Scalars['String'];
  confirmedAt?: Maybe<Scalars['ISO8601DateTime']>;
  destinationBinInternalId: Scalars['String'];
  destinationBinName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  netSuiteInternalId?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['ISO8601DateTime']>;
  requestedAt: Scalars['ISO8601DateTime'];
  sourceBinName?: Maybe<Scalars['String']>;
  status: GBinTransferCommandStatus;
  statusMessage?: Maybe<Scalars['String']>;
  statusReasonCode?: Maybe<Scalars['String']>;
  stockUnitQuantity: Scalars['String'];
};

/** The connection type for SupplyItem. */
export type GWarehouseBulkPickedItemsConnection = {
  __typename?: 'WarehouseBulkPickedItemsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GSupplyItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GSupplyItem>>>;
  /** Information to aid in pagination. */
  pageInfo: GPageInfo;
  /** The total count of records in the connection. */
  totalCount: Scalars['Int'];
};

export type GWarehouseBulkPickedItemsInput = {
  warehouseId: Scalars['ID'];
};

export type GWarehouseCategoryMedian = {
  __typename?: 'WarehouseCategoryMedian';
  categoryId: Scalars['ID'];
  categoryName: Scalars['String'];
  /**
   * This category's share of the warehouse's total 90d spend across all locations
   * (0-100). Denominator includes all categorized + uncategorized order lines.
   * Nullable for warehouses where the nightly job has not yet populated the column.
   */
  categorySharePct?: Maybe<Scalars['Float']>;
  computedAt: Scalars['ISO8601DateTime'];
  locationCount: Scalars['Int'];
  medianSpend90dCents: Scalars['Int'];
  warehouseId: Scalars['ID'];
};

/**
 * One commitment-discrepancy order line: NetSuite committed a different quantity
 * than was ordered. The ordered vs committed numbers convey the discrepancy type
 * (under / not / over committed).
 */
export type GWarehouseCommitmentDiscrepancyLine = {
  __typename?: 'WarehouseCommitmentDiscrepancyLine';
  /** Units NetSuite committed (order_lines.committed_quantity; null = not yet committed, reported as 0). */
  committedUnits: Scalars['Int'];
  /** The line item's name (nil when the item is unknown). */
  itemName?: Maybe<Scalars['String']>;
  /**
   * The order location's name (nil when the order has no location).
   * @deprecated Use `order.location.businessName`. Kept until the old LWA operation drains from prod.
   */
  locationName?: Maybe<Scalars['String']>;
  /**
   * The line's order, as a federated reference. so-api resolves the human order
   * number, ERP record URL, and location (business name + id) the Commitment
   * drill-down links to.
   */
  order: GOrder;
  /**
   * The line's order id.
   * @deprecated Use `order.orderNumber` (this is the order id, not the human number). Kept until the old LWA operation drains from prod.
   */
  orderNumber: Scalars['ID'];
  /** Units ordered (order_lines.unit_quantity). */
  orderedUnits: Scalars['Int'];
  /**
   * Name of the route the order is on — the Lobby bucket (or a pickup /
   * third-party bucket) until it's routed onto a driven route. Nil only when the
   * order has no stop at all.
   */
  routeName?: Maybe<Scalars['String']>;
  /**
   * The order's 1-indexed stop position on that route (sequence_number + 1). For a
   * bucket this is a position within the bucket, not a driven-stop sequence. Nil
   * only when the order has no stop at all.
   */
  stopNumber?: Maybe<Scalars['Int']>;
};

/**
 * Flat, offset-paginated list of every commitment-discrepancy order line for a
 * warehouse + delivery date (under-, not-, and over-committed). See
 * Resolvers::WarehouseCommitmentDiscrepancyLines.
 */
export type GWarehouseCommitmentDiscrepancyLinesReport = {
  __typename?: 'WarehouseCommitmentDiscrepancyLinesReport';
  /** The current page of discrepancy lines, in a stable order. */
  orderLines: Array<GWarehouseCommitmentDiscrepancyLine>;
  /** Total discrepancy lines matching the query, unpaginated — for page counts. */
  totalCount: Scalars['Int'];
};

/** An order NetSuite committed short of what was ordered, aggregated to order grain. */
export type GWarehouseCommitmentDiscrepancyOrder = {
  __typename?: 'WarehouseCommitmentDiscrepancyOrder';
  /** Total units NetSuite committed, including any over-commitment (a not-yet-committed line counts as 0). */
  committedUnits: Scalars['Int'];
  /** The order location's name (nil when the order has no location). */
  locationName?: Maybe<Scalars['String']>;
  /** The order's id. */
  orderNumber: Scalars['ID'];
  /** Total units ordered across the order's lines. */
  orderedUnits: Scalars['Int'];
  /**
   * Units committed short, summed from positive per-line deficits. Over-committed
   * and not-yet-committed lines contribute 0, so this is never negative and is not
   * simply orderedUnits - committedUnits.
   */
  shortfall: Scalars['Int'];
};

/**
 * Commitment stage-gate report for a warehouse + delivery date: how many orders
 * were committed short of what was ordered, plus those orders. See
 * Resolvers::WarehouseCommitmentDiscrepancies.
 */
export type GWarehouseCommitmentDiscrepancyReport = {
  __typename?: 'WarehouseCommitmentDiscrepancyReport';
  /** Orders with any short-committed line (committed_quantity < ordered). */
  discrepancyCount: Scalars['Int'];
  /** The short-committed orders. */
  orders: Array<GWarehouseCommitmentDiscrepancyOrder>;
  /**
   * Non-discrepant orders with a line NetSuite hasn't committed yet (null
   * committed_quantity). Waiting on the Commit Orders run, not short.
   */
  pendingCount: Scalars['Int'];
  /** Total (non-canceled) orders for the warehouse + delivery date. */
  totalOrderCount: Scalars['Int'];
};

/**
 * Ordered-vs-committed unit totals for a warehouse + delivery date. Raw totals
 * only; the clear/needs_review/waiting decision is composed on the frontend.
 */
export type GWarehouseCommitmentSummary = {
  __typename?: 'WarehouseCommitmentSummary';
  /**
   * Σ COALESCE(order_lines.committed_quantity, 0). A not-yet-committed line
   * contributes 0 committed units, so post-Sync it reads as a shortfall.
   */
  committedUnits: Scalars['Int'];
  /** Number of (non-canceled) orders in scope, for tile context. */
  orderCount: Scalars['Int'];
  /** Σ order_lines.unit_quantity across the scope. */
  orderedUnits: Scalars['Int'];
};

export type GWarehouseDockCapacity = {
  __typename?: 'WarehouseDockCapacity';
  /** Admin minimum the FTL daily ceiling cannot be set below. */
  ftlMinPerDay: Scalars['Int'];
  /** Declared daily FTL truck ceiling; window ftl_max values sum up to this. */
  ftlTrucksPerDay: Scalars['Int'];
  /** Admin minimum the LTL daily ceiling cannot be set below. */
  ltlMinPerDay: Scalars['Int'];
  /** Declared daily LTL truck ceiling; window ltl_max values sum up to this. */
  ltlTrucksPerDay: Scalars['Int'];
};

export type GWarehouseEcomBulkItemsInput = {
  warehouseId: Scalars['ID'];
};

/**
 * One fulfillment-discrepancy order line: the warehouse fulfilled a different
 * quantity than NetSuite committed. The committed vs fulfilled numbers convey the
 * discrepancy (under / over fulfilled).
 */
export type GWarehouseFulfillmentDiscrepancyLine = {
  __typename?: 'WarehouseFulfillmentDiscrepancyLine';
  /** Units NetSuite committed (order_lines.committed_quantity; null = not yet committed, reported as 0). */
  committedUnits: Scalars['Int'];
  /** Units the warehouse fulfilled (order_lines.fulfillment_quantity; null = not yet fulfilled, reported as 0). */
  fulfillmentUnits: Scalars['Int'];
  /** The line item's name (nil when the item is unknown). */
  itemName?: Maybe<Scalars['String']>;
  /**
   * The line's order, as a federated reference. so-api resolves the human order
   * number, ERP record URL, and location (business name + id) the Fulfillment
   * drill-down links to.
   */
  order: GOrder;
  /** Units ordered (order_lines.unit_quantity). */
  orderedUnits: Scalars['Int'];
  /**
   * Name of the route the order is on — the Lobby bucket (or a pickup /
   * third-party bucket) until it's routed onto a driven route. Nil only when the
   * order has no stop at all.
   */
  routeName?: Maybe<Scalars['String']>;
  /**
   * The order's 1-indexed stop position on that route (sequence_number + 1). For a
   * bucket this is a position within the bucket, not a driven-stop sequence. Nil
   * only when the order has no stop at all.
   */
  stopNumber?: Maybe<Scalars['Int']>;
};

/**
 * Flat, offset-paginated list of every fulfillment-discrepancy order line for a
 * warehouse + delivery date (fulfilled quantity differs from committed). See
 * Resolvers::WarehouseFulfillmentDiscrepancyLines.
 */
export type GWarehouseFulfillmentDiscrepancyLinesReport = {
  __typename?: 'WarehouseFulfillmentDiscrepancyLinesReport';
  /** The current page of discrepancy lines, in a stable order. */
  orderLines: Array<GWarehouseFulfillmentDiscrepancyLine>;
  /** Total discrepancy lines matching the query, unpaginated — for page counts. */
  totalCount: Scalars['Int'];
};

/**
 * Committed-vs-fulfilled unit totals for a warehouse + delivery date. Raw totals
 * only; the waiting/needs_attention/clear decision is composed on the frontend.
 */
export type GWarehouseFulfillmentSummary = {
  __typename?: 'WarehouseFulfillmentSummary';
  /** Σ COALESCE(order_lines.committed_quantity, 0) across the scope. */
  committedUnits: Scalars['Int'];
  /**
   * Σ COALESCE(order_lines.fulfillment_quantity, 0). A not-yet-fulfilled line
   * contributes 0 fulfilled units, so post-fulfillment it reads as a shortfall.
   */
  fulfilledUnits: Scalars['Int'];
  /** Number of (non-canceled) orders in scope, for tile context. */
  orderCount: Scalars['Int'];
};

export type GWarehouseItemTask = {
  __typename?: 'WarehouseItemTask';
  /**
   * Total current base-unit balance less submitted moves across this item's source
   * tasks in the selected warehouse and workstreams, regardless of category.
   */
  currentQuantity: Scalars['Float'];
  /** Inventory item shared by every source task in this group. */
  inventoryItem?: Maybe<GInventoryItem>;
  item: GWarehouseTaskItem;
  lotCount: Scalars['Int'];
  /** Catalog pallet configuration shared by every source task in this group. */
  palletConfiguration?: Maybe<GPutawayTaskPalletConfiguration>;
  /** Catalog pallet configuration error shared by every source task in this group. */
  palletConfigurationReview?: Maybe<GPutawayTaskConfigurationReview>;
  /** One catalog pallet expressed in purchase, base, and stock units when shared by every source task. */
  palletFootprint?: Maybe<GPutawayTaskPalletFootprint>;
  sourceBinCount: Scalars['Int'];
  /** All current source tasks for this item in the selected warehouse and workstreams, regardless of category. */
  tasks: GWarehouseTaskConnection;
  unitConfiguration?: Maybe<GPutawayTaskUnitConfiguration>;
};


export type GWarehouseItemTaskTasksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for WarehouseItemTask. */
export type GWarehouseItemTaskConnection = {
  __typename?: 'WarehouseItemTaskConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GWarehouseItemTaskEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GWarehouseItemTask>>>;
  /** Information to aid in pagination. */
  pageInfo: GPageInfo;
  /** The total count of records in the connection. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type GWarehouseItemTaskEdge = {
  __typename?: 'WarehouseItemTaskEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GWarehouseItemTask>;
};

export type GWarehouseItemTaskFilterInput = {
  /** Find items with a task resolved to this inventory item ID. */
  inventoryItemId?: InputMaybe<Scalars['ID']>;
  /** Find items with a matching source task without restricting their summaries or child tasks. */
  putawayCategory?: InputMaybe<GWarehouseTaskPutawayCategory>;
  /** Find items with a task whose item, lot, source bin, or exposed suggested destination bin contains this text. */
  search?: InputMaybe<Scalars['String']>;
  workstreams?: InputMaybe<Array<GWarehouseTaskWorkstream>>;
};

/**
 * Everything the Layout Builder needs for a warehouse in one load: the current
 * interpreted bin catalog and the saved layout draft (if any).
 */
export type GWarehouseLayoutBuilder = {
  __typename?: 'WarehouseLayoutBuilder';
  /** Current interpreted bin catalog (sc-65273). Group membership/order is always re-derived here, never stored on the draft. */
  catalog: GWarehouseBinLayout;
  /** Saved layout draft, or null when none exists yet (fall back to the deterministic default arrangement). */
  draft?: Maybe<GWarehouseLayoutDraft>;
};

/** A warehouse's saved layout draft (epic 65270, sc-65275). One draft per warehouse (MVP). */
export type GWarehouseLayoutDraft = {
  __typename?: 'WarehouseLayoutDraft';
  /**
   * Canvas grid width in cells. Null when the draft predates the control bar; the
   * builder falls back to its auto-size / default.
   */
  gridCols?: Maybe<Scalars['Int']>;
  /**
   * Canvas grid height in cells. Null when the draft predates the control bar; the
   * builder falls back to its auto-size / default.
   */
  gridRows?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  placements: Array<GWarehouseLayoutPlacement>;
  /** Optimistic-concurrency key. Send this revision back on save; a stale value is rejected. */
  revision: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
  updatedBy?: Maybe<Scalars['String']>;
};

/** A placed element in a saved layout draft — a source-backed bin group or a facility shape. */
export type GWarehouseLayoutPlacement = {
  __typename?: 'WarehouseLayoutPlacement';
  /** source_group only: bin arrangement. */
  arrangement?: Maybe<GLayoutArrangement>;
  /** source_group only: per-bay offsets that nudge individual bays off their computed run cells. */
  bayOffsets?: Maybe<Array<GBayOffset>>;
  /** source_group only: bay numbering direction (low_high | high_low). */
  bayOrder?: Maybe<GLayoutBayOrder>;
  /** source_group only: blank grid cells between the odd and even lanes (Odd-Even arrangement). */
  columnGap?: Maybe<Scalars['Int']>;
  /** facility only: shape kind. */
  facilityType?: Maybe<GFacilityElementType>;
  /** source_group only: interpreted bin family. */
  family?: Maybe<GBinFamily>;
  /** source_group only: interpretation key (aisle letter, ABULK, DOCK, ...). */
  groupKey?: Maybe<Scalars['String']>;
  /** facility only: shape height in grid units. */
  height?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  kind: GLayoutPlacementKind;
  /** facility only: free text label. */
  label?: Maybe<Scalars['String']>;
  /** Rotation in degrees. */
  orientation: Scalars['Int'];
  /** facility only: shape width in grid units. */
  width?: Maybe<Scalars['Int']>;
  /** Grid x position. */
  x: Scalars['Int'];
  /** Grid y position. */
  y: Scalars['Int'];
};

/** A placement to persist. Provide the source_group fields for a bin group, or the facility fields for a shape. */
export type GWarehouseLayoutPlacementInput = {
  arrangement?: InputMaybe<GLayoutArrangement>;
  /** Per-bay offsets nudging individual bays off their computed run cells; omitted = none. */
  bayOffsets?: InputMaybe<Array<GBayOffsetInput>>;
  /** Bay numbering direction; omitted = low_high. */
  bayOrder?: InputMaybe<GLayoutBayOrder>;
  /** Blank grid cells between the odd and even lanes (Odd-Even arrangement); omitted = null (treated as 0). */
  columnGap?: InputMaybe<Scalars['Int']>;
  facilityType?: InputMaybe<GFacilityElementType>;
  family?: InputMaybe<GBinFamily>;
  /** Interpretation key (aisle letter, ABULK, DOCK, ...). */
  groupKey?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  kind: GLayoutPlacementKind;
  label?: InputMaybe<Scalars['String']>;
  /** Rotation in degrees; omitted = 0. */
  orientation?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
  x: Scalars['Int'];
  y: Scalars['Int'];
};

/** A recoverable error from saving a layout draft (e.g. a stale revision the client can retry). */
export type GWarehouseLayoutSaveError = {
  __typename?: 'WarehouseLayoutSaveError';
  /** Machine-readable error reason. */
  code: GLayoutSaveErrorCode;
  /** Human-readable description of the error. */
  message: Scalars['String'];
};

/** Autogenerated input type of WarehouseLayoutSave */
export type GWarehouseLayoutSaveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Canvas grid width in cells. Persisted wholesale with the draft; null clears it. */
  gridCols?: InputMaybe<Scalars['Int']>;
  /** Canvas grid height in cells. Persisted wholesale with the draft; null clears it. */
  gridRows?: InputMaybe<Scalars['Int']>;
  placements: Array<GWarehouseLayoutPlacementInput>;
  /** The revision the client loaded (0 when no draft existed). A stale value is rejected. */
  revision: Scalars['Int'];
  warehouseId: Scalars['ID'];
};

/** Autogenerated return type of WarehouseLayoutSave. */
export type GWarehouseLayoutSavePayload = {
  __typename?: 'WarehouseLayoutSavePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  draft?: Maybe<GWarehouseLayoutDraft>;
  userErrors: Array<GWarehouseLayoutSaveError>;
};

export type GWarehouseLeadTimeInput = {
  /** lead time for base braned paper, set after proof approved */
  brandedPaperLeadTime: Scalars['Int'];
  /** Warehouse UUID */
  warehouseUuid: Scalars['String'];
};

export type GWarehouseNotFound = GUserErrorInterface & {
  __typename?: 'WarehouseNotFound';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

/** Whether/when 'Sync routes' last completed for a warehouse + night_end. */
export type GWarehouseRoutesSyncStatus = {
  __typename?: 'WarehouseRoutesSyncStatus';
  /**
   * True when a planner changed stop composition/order after the last sync, so
   * routes need re-syncing. Regresses the Sync card clear -> needs_sync.
   */
  planChangedSinceSync: Scalars['Boolean'];
  /** Last successful sync completion; null if never synced. */
  syncedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type GWarehouseShift = {
  __typename?: 'WarehouseShift';
  breaks: Array<GWarehouseShiftBreak>;
  /** Warehouse-local wall clock, e.g. "06:00". */
  endTime: Scalars['String'];
  id: Scalars['ID'];
  /** Shift label, e.g. "night_time". */
  shiftType: Scalars['String'];
  /** Warehouse-local wall clock, e.g. "20:00". */
  startTime: Scalars['String'];
};

export type GWarehouseShiftBreak = {
  __typename?: 'WarehouseShiftBreak';
  /** Whether the break may be taken while in transit. */
  allowInTransit: Scalars['Boolean'];
  /** Break length in minutes. */
  duration: Scalars['Int'];
  id: Scalars['ID'];
  label: Scalars['String'];
};

export type GWarehouseShiftBreakInput = {
  /** Whether the break may be taken while in transit; omitted/null = false. */
  allowInTransit?: InputMaybe<Scalars['Boolean']>;
  /** Break length in minutes; must be greater than 0. */
  duration: Scalars['Int'];
  label: Scalars['String'];
};

/** Autogenerated input type of WarehouseShiftCreate */
export type GWarehouseShiftCreateInput = {
  breaks?: InputMaybe<Array<GWarehouseShiftBreakInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Warehouse-local wall clock, e.g. "06:00". */
  endTime: Scalars['String'];
  shiftType: Scalars['String'];
  /** Warehouse-local wall clock, e.g. "20:00". */
  startTime: Scalars['String'];
  warehouseId: Scalars['ID'];
};

/** Autogenerated return type of WarehouseShiftCreate. */
export type GWarehouseShiftCreatePayload = {
  __typename?: 'WarehouseShiftCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userErrors: Array<GWarehouseShiftError>;
  warehouseShift?: Maybe<GWarehouseShift>;
};

/** Autogenerated input type of WarehouseShiftDelete */
export type GWarehouseShiftDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  shiftId: Scalars['ID'];
};

/** Autogenerated return type of WarehouseShiftDelete. */
export type GWarehouseShiftDeletePayload = {
  __typename?: 'WarehouseShiftDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedWarehouseShiftId?: Maybe<Scalars['ID']>;
  userErrors: Array<GWarehouseShiftError>;
};

/** Warehouse shift possible error types */
export type GWarehouseShiftError = GInvalidShift | GShiftNotFound | GWarehouseNotFound;

/** Autogenerated input type of WarehouseShiftUpdate */
export type GWarehouseShiftUpdateInput = {
  /** When given, replaces the full set of breaks. Omit to leave breaks unchanged. */
  breaks?: InputMaybe<Array<GWarehouseShiftBreakInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Warehouse-local wall clock, e.g. "06:00". */
  endTime?: InputMaybe<Scalars['String']>;
  shiftId: Scalars['ID'];
  shiftType?: InputMaybe<Scalars['String']>;
  /** Warehouse-local wall clock, e.g. "20:00". */
  startTime?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of WarehouseShiftUpdate. */
export type GWarehouseShiftUpdatePayload = {
  __typename?: 'WarehouseShiftUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userErrors: Array<GWarehouseShiftError>;
  warehouseShift?: Maybe<GWarehouseShift>;
};

/** An active bin an associate scanned as the source of a manual transfer. */
export type GWarehouseSourceBin = {
  __typename?: 'WarehouseSourceBin';
  /** The item's lots with usable stock in this bin, earliest expiry first. Empty when the bin holds none of the item. */
  lots: Array<GWarehouseSourceBinLot>;
  name: Scalars['String'];
  netsuiteInternalId: Scalars['String'];
};


/** An active bin an associate scanned as the source of a manual transfer. */
export type GWarehouseSourceBinLotsArgs = {
  inventoryItemId: Scalars['ID'];
};

/** One lot of an item in a source bin, with a positive balance and an available inventory status. */
export type GWarehouseSourceBinLot = {
  __typename?: 'WarehouseSourceBinLot';
  expiration: GPutawayExpiration;
  /** Bin inventory balance id for this lot. */
  id: Scalars['ID'];
  inventoryNumber?: Maybe<GWarehouseTaskInventoryNumber>;
  /** Balance in the item's stock unit. Null when the item's units can't be resolved. */
  quantityDetails?: Maybe<GPutawayTaskQuantityDetails>;
  /** Why quantityDetails is missing. */
  statusReason?: Maybe<GWarehouseTaskStatusReason>;
};

export type GWarehouseSpendTier = {
  __typename?: 'WarehouseSpendTier';
  minOrderAmountDollars: Scalars['Int'];
  thresholdAmountDollars: Scalars['Int'];
  tierName: Scalars['String'];
};

export type GWarehouseSubcategoryThreshold = {
  __typename?: 'WarehouseSubcategoryThreshold';
  computedAt: Scalars['ISO8601DateTime'];
  medianPenetrationPct: Scalars['Float'];
  medianRevenueSharePct: Scalars['Float'];
  warehouseId: Scalars['ID'];
};

export type GWarehouseTask = {
  id: Scalars['ID'];
  state: GWarehouseTaskState;
  statusReason?: Maybe<GWarehouseTaskStatusReason>;
  taskType: GWarehouseTaskType;
  workstream: GWarehouseTaskWorkstream;
};

export type GWarehouseTaskBin = {
  __typename?: 'WarehouseTaskBin';
  name?: Maybe<Scalars['String']>;
  netsuiteInternalId: Scalars['String'];
};

/** The connection type for WarehouseTask. */
export type GWarehouseTaskConnection = {
  __typename?: 'WarehouseTaskConnection';
  /**
   * REPLEN only: counts for every cohort, unaffected by the filters, from the same
   * calculation as the list. Empty for other task types.
   */
  cohortCounts: Array<GReplenCohortCount>;
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GWarehouseTaskEdge>>>;
  needsReviewCount: Scalars['Int'];
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GWarehouseTask>>>;
  /** Information to aid in pagination. */
  pageInfo: GPageInfo;
  /**
   * Pallets of work still to move. REPLEN: whole pallets plus one for any
   * leftover, over actionable tasks only. A task missing pallet info is left out
   * because its pallet size is unknown (its cases can still be worked;
   * ReplenCohortCount.missingInfoCount says how many there are), and a blocked
   * task is counted in needsReviewCount instead.
   */
  remainingPalletCount: Scalars['Int'];
  /** The total count of records in the connection. */
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type GWarehouseTaskEdge = {
  __typename?: 'WarehouseTaskEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<GWarehouseTask>;
};

export type GWarehouseTaskFilterInput = {
  /** REPLEN only. Finds the tasks for this inventory item, as resolved from a scanned barcode. */
  inventoryItemId?: InputMaybe<Scalars['ID']>;
  /** PUTAWAY only; ignored for other task types. */
  putawayCategory?: InputMaybe<GWarehouseTaskPutawayCategory>;
  /** REPLEN only. Omitted returns every task; combines with the cohort, zone, state and missing-info filters. */
  replenCategory?: InputMaybe<GReplenTaskCategory>;
  /** REPLEN only. Omitted returns every cohort; an empty list returns none. */
  replenCohorts?: InputMaybe<Array<GReplenTaskCohort>>;
  /** REPLEN only. true returns only tasks missing pallet info, false only the others, omitted both. */
  replenMissingInfo?: InputMaybe<Scalars['Boolean']>;
  /**
   * REPLEN only. NetSuite pick-zone ids (3 PICK-A, 8 PICK-B, 9 CHILLED, 6 BULK, 14
   * ECOM); a task matches when any of its routed zones is listed. Omitted returns
   * every zone; an empty list returns none.
   */
  replenPickZoneNetsuiteIds?: InputMaybe<Array<Scalars['String']>>;
  /**
   * REPLEN only. BLOCKED returns the tasks that need review, ACTIONABLE the ones
   * that can be worked. Omitted returns both; an empty list returns none.
   */
  replenStates?: InputMaybe<Array<GWarehouseTaskState>>;
  /**
   * REPLEN only. Finds tasks whose item name or NetSuite id, reserve bin, lot or
   * pick-face bin contains this text, ignoring case. PUTAWAY search is on
   * warehouseItemTasks.
   */
  search?: InputMaybe<Scalars['String']>;
  taskId?: InputMaybe<Scalars['ID']>;
  /** REPLEN only. Demand lookahead in days, 1 to 7; defaults to 3 when omitted. */
  windowDays?: InputMaybe<Scalars['Int']>;
  /** PUTAWAY only; ignored for other task types. Replenishment tasks are all AMBIENT. */
  workstreams?: InputMaybe<Array<GWarehouseTaskWorkstream>>;
};

export type GWarehouseTaskInventoryNumber = {
  __typename?: 'WarehouseTaskInventoryNumber';
  name?: Maybe<Scalars['String']>;
  netsuiteInternalId?: Maybe<Scalars['String']>;
};

export type GWarehouseTaskItem = {
  __typename?: 'WarehouseTaskItem';
  displayName?: Maybe<Scalars['String']>;
  netsuiteInternalId: Scalars['String'];
};

export enum GWarehouseTaskPutawayCategory {
  Loose = 'LOOSE',
  MissingInfo = 'MISSING_INFO',
  Pallets = 'PALLETS'
}

export enum GWarehouseTaskState {
  Actionable = 'ACTIONABLE',
  Blocked = 'BLOCKED'
}

export type GWarehouseTaskStatusReason = {
  __typename?: 'WarehouseTaskStatusReason';
  code: GWarehouseTaskStatusReasonCode;
  message: Scalars['String'];
};

export enum GWarehouseTaskStatusReasonCode {
  CasesPerPalletInvalid = 'CASES_PER_PALLET_INVALID',
  CurrentQuantityMissing = 'CURRENT_QUANTITY_MISSING',
  ExpirationConflict = 'EXPIRATION_CONFLICT',
  InvalidCurrentQuantity = 'INVALID_CURRENT_QUANTITY',
  InvalidReceiptQuantity = 'INVALID_RECEIPT_QUANTITY',
  InvalidStockUnitConversion = 'INVALID_STOCK_UNIT_CONVERSION',
  InventoryItemAmbiguous = 'INVENTORY_ITEM_AMBIGUOUS',
  InventoryItemMissing = 'INVENTORY_ITEM_MISSING',
  InventoryStatusNotAvailable = 'INVENTORY_STATUS_NOT_AVAILABLE',
  ItemUnitConfigurationAmbiguous = 'ITEM_UNIT_CONFIGURATION_AMBIGUOUS',
  ItemUnitConfigurationInvalid = 'ITEM_UNIT_CONFIGURATION_INVALID',
  ItemUnitConfigurationMissing = 'ITEM_UNIT_CONFIGURATION_MISSING',
  NonInventoryItem = 'NON_INVENTORY_ITEM',
  NoEligibleDestination = 'NO_ELIGIBLE_DESTINATION',
  NoReserveStock = 'NO_RESERVE_STOCK',
  PalletConfigurationMissing = 'PALLET_CONFIGURATION_MISSING',
  ReceiptQuantityMissing = 'RECEIPT_QUANTITY_MISSING',
  StockUnitConfigurationMissing = 'STOCK_UNIT_CONFIGURATION_MISSING',
  StockUnitConversionMissing = 'STOCK_UNIT_CONVERSION_MISSING',
  SuggestionsDisabled = 'SUGGESTIONS_DISABLED',
  SuggestionUpdating = 'SUGGESTION_UPDATING'
}

export enum GWarehouseTaskType {
  Putaway = 'PUTAWAY',
  Replen = 'REPLEN'
}

export enum GWarehouseTaskWorkstream {
  Ambient = 'AMBIENT',
  ChilledFrozen = 'CHILLED_FROZEN'
}

export type GWarehouseTopSubcategory = {
  __typename?: 'WarehouseTopSubcategory';
  computedAt: Scalars['ISO8601DateTime'];
  netRevenueCents90d: Scalars['Int'];
  orderingCompanyCount: Scalars['Int'];
  parentCategoryName: Scalars['String'];
  parentCompanyCount: Scalars['Int'];
  parentCompanyPenetrationPct: Scalars['Float'];
  revenueSharePct: Scalars['Float'];
  subcategoryId: Scalars['ID'];
  subcategoryName: Scalars['String'];
  warehouseId: Scalars['ID'];
};

/** Available measurements, not necessarily complete warehouse totals. Display each value with its route coverage. */
export type GWarehouseTrendAvailableMetrics = {
  __typename?: 'WarehouseTrendAvailableMetrics';
  coverage: GWarehouseTrendCoverage;
  /** DPRH for only routes with known positive hours; null when no routes qualify. */
  dprh?: Maybe<Scalars['Float']>;
  /** Delivery count from exactly the routes contributing dprhDriverHours; zero when no routes qualify. */
  dprhDeliveries: Scalars['Int'];
  /** Unrounded positive hours paired with dprhDeliveries. Sum this pair across dates for weighted DPRH. */
  dprhDriverHours?: Maybe<Scalars['Float']>;
  /**
   * Sum of routes with known nonnegative hours. Original and dispatch series use
   * planned times; only actual hours require GPS-backed distance.
   */
  driverHours?: Maybe<Scalars['Float']>;
  /** Sum of routes with known nonnegative distance; null when no routes are measured. */
  miles?: Maybe<Scalars['Float']>;
};

/** Changes between the original Routific plan and final dispatched routes. */
export type GWarehouseTrendChanges = {
  __typename?: 'WarehouseTrendChanges';
  /** Routes assessed for breadcrumb coverage; denominator for low_breadcrumb_routes. */
  breadcrumbTrackedRoutes: Scalars['Int'];
  /** Per-route detail for the routes counted in low_breadcrumb_routes. */
  lowBreadcrumbRouteDetails: Array<GWarehouseTrendLowBreadcrumbRoute>;
  /** Routes that ran a real workload but recorded almost no GPS trail (phone barely reported breadcrumbs). */
  lowBreadcrumbRoutes: Scalars['Int'];
  recoveryStopsCompleted: Scalars['Int'];
  recoveryStopsTotal: Scalars['Int'];
  routesAdded?: Maybe<Scalars['Int']>;
  routesRemoved?: Maybe<Scalars['Int']>;
  /** Delivered stops completed out of their dispatched sequence order. */
  stopsDeliveredOutOfOrder: Scalars['Int'];
  /** Total stops delivered (completed); denominator for stops_delivered_out_of_order. */
  stopsDeliveredTotal: Scalars['Int'];
  stopsReordered: Scalars['Int'];
  /** Routes added + routes removed + stops reordered; recovery is reported separately. */
  totalChanges?: Maybe<Scalars['Int']>;
};

/**
 * Route coverage for one series on one date. Missing or unstarted routes remain in
 * totalRoutes, never silently treated as measured zeros.
 */
export type GWarehouseTrendCoverage = {
  __typename?: 'WarehouseTrendCoverage';
  /** Routes with known positive hours contributing both the DPRH numerator and denominator. */
  dprhRoutes: Scalars['Int'];
  /** Routes contributing known nonnegative hours, including measured zero. */
  driverHoursRoutes: Scalars['Int'];
  /** Routes contributing known nonnegative mileage. */
  milesRoutes: Scalars['Int'];
  /** All routes in this series, including routes without measurements; zero when the series has no routes or baseline. */
  totalRoutes: Scalars['Int'];
};

/** Original-plan, dispatch-plan, and actual metrics for one warehouse delivery date. */
export type GWarehouseTrendDay = {
  __typename?: 'WarehouseTrendDay';
  /**
   * Measured execution across regular and recovery routes: driven miles,
   * GPS-backed driver hours, and completed delivery/recovery stops. Miles are null
   * if any route lacks measured distance. Hours require both persisted distance
   * and time for every route to exclude legacy lifecycle fallbacks. This is
   * distinct from actualRoutesSummary's dispatched-stop/lifecycle-time metrics.
   */
  actual: GWarehouseTrendMetrics;
  changes: GWarehouseTrendChanges;
  date: Scalars['ISO8601Date'];
  dispatchPlan: GWarehouseTrendMetrics;
  /**
   * Dispatch routes whose delivery stops are all Metrobi (third-party). Excluded
   * from every route count and rate metric in the other series.
   */
  metrobiRoutes: Scalars['Int'];
  originalRoutificPlan: GWarehouseTrendMetrics;
};

/** A route counted in low_breadcrumb_routes: it ran a real workload but recorded almost no GPS trail. */
export type GWarehouseTrendLowBreadcrumbRoute = {
  __typename?: 'WarehouseTrendLowBreadcrumbRoute';
  /** Measured driven distance for the route; null when no trail was recorded. */
  drivenDistanceMiles?: Maybe<Scalars['Float']>;
  /** DeliveryRoute id. */
  id: Scalars['ID'];
  /** Dispatched route number. */
  routeNo?: Maybe<Scalars['Int']>;
};

/** One plan or execution series for a warehouse trend day. */
export type GWarehouseTrendMetrics = {
  __typename?: 'WarehouseTrendMetrics';
  /** Opt-in measured-route aggregates with coverage. Existing scalar fields remain strict full-series totals. */
  available: GWarehouseTrendAvailableMetrics;
  deliveries?: Maybe<Scalars['Int']>;
  /** Deliveries divided by driver hours for this series. */
  dprh?: Maybe<Scalars['Float']>;
  driverHours?: Maybe<Scalars['Float']>;
  miles?: Maybe<Scalars['Float']>;
};

/** Autogenerated input type of WarehouseUpdateClosedDays */
export type GWarehouseUpdateClosedDaysInput = {
  /** Weekdays closed for booking (Ruby wday: 0=Sunday..6=Saturday). Replaces the full set. */
  blockedWeekdays: Array<Scalars['Int']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  warehouseId: Scalars['ID'];
};

/** Autogenerated return type of WarehouseUpdateClosedDays. */
export type GWarehouseUpdateClosedDaysPayload = {
  __typename?: 'WarehouseUpdateClosedDaysPayload';
  blockedWeekdays?: Maybe<Array<Scalars['Int']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userErrors: Array<GDockBookingError>;
};

/** Autogenerated input type of WarehouseUpdateDailyCapacity */
export type GWarehouseUpdateDailyCapacityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Declared daily FTL truck ceiling. */
  ftlTrucksPerDay: Scalars['Int'];
  /** Declared daily LTL truck ceiling. */
  ltlTrucksPerDay: Scalars['Int'];
  warehouseId: Scalars['ID'];
};

/** Autogenerated return type of WarehouseUpdateDailyCapacity. */
export type GWarehouseUpdateDailyCapacityPayload = {
  __typename?: 'WarehouseUpdateDailyCapacityPayload';
  capacity?: Maybe<GWarehouseDockCapacity>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  userErrors: Array<GDockBookingError>;
};

export type GWithinLeadTime = GUserErrorInterface & {
  __typename?: 'WithinLeadTime';
  errorCode: Scalars['String'];
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type GWorkThread = {
  __typename?: 'WorkThread';
  agentBranch?: Maybe<Scalars['String']>;
  agentRuns: Array<GAgentRun>;
  createdAt: Scalars['ISO8601DateTime'];
  events: Array<GWorkThreadEvent>;
  id: Scalars['ID'];
  kind: Scalars['String'];
  metadata: Scalars['JSON'];
  repoSlug?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};


export type GWorkThreadAgentRunsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


export type GWorkThreadEventsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type GWorkThreadEvent = {
  __typename?: 'WorkThreadEvent';
  agentRunId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['ISO8601DateTime'];
  details: Scalars['JSON'];
  eventType: Scalars['String'];
  id: Scalars['ID'];
  occurredAt: Scalars['ISO8601DateTime'];
  source: Scalars['String'];
  summary: Scalars['String'];
};

export type GZipcode = {
  __typename?: 'Zipcode';
  active: Scalars['Boolean'];
  deliveryRules?: Maybe<Array<GDeliveryRule>>;
  deliveryWindow?: Maybe<GZipcodeDeliveryWindow>;
  id: Scalars['ID'];
  warehouseId?: Maybe<Scalars['ID']>;
  warehouseName?: Maybe<Scalars['String']>;
  zipCode: Scalars['String'];
};

/** A single per-weekday delivery rule to apply to a zipcode */
export type GZipcodeDeliveryRuleInput = {
  /** Delivery rule day, 0-6, 0 is Sunday */
  deliveryDay: Scalars['Int'];
  /** Lead time for delivery in days */
  leadTime: Scalars['Int'];
  /** Deadline for ordering to be submitted in format HH:MM */
  orderDeadline: Scalars['String'];
};

export type GZipcodeDeliveryWindow = {
  __typename?: 'ZipcodeDeliveryWindow';
  /** End time in HH:MM format. */
  endTime: Scalars['String'];
  /** Start time in HH:MM format. */
  startTime: Scalars['String'];
};

/** A delivery window to apply to a zipcode */
export type GZipcodeDeliveryWindowInput = {
  /** End time in the format of HH:MM */
  endTime: Scalars['String'];
  /** Start time in the format of HH:MM */
  startTime: Scalars['String'];
};

export type GGetItemsPerRouteQueryVariables = Exact<{
  input: GRouteInput;
}>;


export type GGetItemsPerRouteQuery = { __typename?: 'Query', route: { __typename?: 'Route', id: string, name: string, isLobby: boolean, stops?: Array<{ __typename?: 'Delivery', id: string, sequenceNumber?: string, deliveryStatusDmp: GDeliveryStatusDmp, location?: { __typename?: 'Location', id: string, businessName: string }, orders?: Array<{ __typename?: 'Order', id: string, erpRecordUrl?: string, itemLevelTracking: boolean, fulfillmentStatus: string, orderLines: Array<{ __typename?: 'OrderLine', id: string, orderUnitQuantity: number, deliveredQuantity?: number, quantityType: string, itemsPerLot: number, fulfillmentQuantity?: number, unitCostCents: number, isMarketPriced: boolean, isPounds: boolean, orderedWeightLb?: number, unitWeightLb?: number, totalWeightLb?: number, sku: { __typename?: 'Sku', id: string, name: string, refrigerationState: string, categoryName: string, subcategoryName: string, item?: { __typename?: 'InventoryItem', category: { __typename?: 'Category', name: string } } | { __typename?: 'NonInventoryItem', category: { __typename?: 'Category', name: string } } } }>, vendor: { __typename?: 'Vendor', id: string, name: string, legalName: string } }> } | { __typename?: 'PickUp' }>, redeliveryStops: Array<{ __typename?: 'Redelivery', id: string, sequenceNumber?: string, deliveryStatusDmp: GDeliveryStatusDmp, location?: { __typename?: 'Location', id: string, businessName: string }, orders?: Array<{ __typename?: 'Order', id: string, erpRecordUrl?: string, itemLevelTracking: boolean, fulfillmentStatus: string, orderLines: Array<{ __typename?: 'OrderLine', id: string, orderUnitQuantity: number, deliveredQuantity?: number, quantityType: string, itemsPerLot: number, fulfillmentQuantity?: number, unitCostCents: number, isMarketPriced: boolean, isPounds: boolean, orderedWeightLb?: number, unitWeightLb?: number, totalWeightLb?: number, sku: { __typename?: 'Sku', id: string, name: string, refrigerationState: string, categoryName: string, subcategoryName: string, item?: { __typename?: 'InventoryItem', category: { __typename?: 'Category', name: string } } | { __typename?: 'NonInventoryItem', category: { __typename?: 'Category', name: string } } } }>, vendor: { __typename?: 'Vendor', id: string, name: string } }> }> } };

export type GApproveCutoffDiscrepancyMutationVariables = Exact<{
  input: GApproveCutoffDiscrepancyInput;
}>;


export type GApproveCutoffDiscrepancyMutation = { __typename?: 'Mutation', approveCutoffDiscrepancy?: { __typename?: 'ApproveCutoffDiscrepancyPayload', cutoffDiscrepancyApproval?: { __typename?: 'CutoffDiscrepancyApproval', id: string, locationsVendorId: string }, errors: Array<{ __typename: 'UserError' }> } };

export type GApprovedCutoffDiscrepanciesQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
}>;


export type GApprovedCutoffDiscrepanciesQuery = { __typename?: 'Query', approvedCutoffDiscrepancies: Array<{ __typename?: 'CutoffDiscrepancyApproval', id: string, locationId: string, locationName?: string, locationsVendorId: string, vendorId: string, vendorName: string, approvedBy?: string, approvedAt: any, address?: string, vendorDeliveryRules: Array<{ __typename?: 'CutoffDeliveryRule', deliveryDay: string, orderDeadline?: string, leadTimeDays?: number }>, deliveryRules: Array<{ __typename?: 'CutoffDeliveryRule', deliveryDay: string, orderDeadline?: string, leadTimeDays?: number }> }> };

export type GBulkUpdateRouteStopsDeliveryInfoMutationVariables = Exact<{
  input: GBulkUpdateRouteStopsDeliveryInfoInput;
}>;


export type GBulkUpdateRouteStopsDeliveryInfoMutation = { __typename?: 'Mutation', bulkUpdateRouteStopsDeliveryInfo?: { __typename?: 'BulkUpdateRouteStopsDeliveryInfoPayload', route?: { __typename?: 'Route', id: string }, userErrors: Array<{ __typename: 'AutomatedRoutingPending' } | { __typename: 'BulkUpdateDeprecated', errorCode: string, message: string } | { __typename: 'InvalidNightEnd' } | { __typename: 'ProviderRouteGuarded' } | { __typename: 'RouteEnded' }> } };

export type GCancelProviderRouteMutationVariables = Exact<{
  input: GCancelProviderRouteInput;
}>;


export type GCancelProviderRouteMutation = { __typename?: 'Mutation', cancelProviderRoute?: { __typename?: 'CancelProviderRoutePayload', route?: { __typename?: 'Route', id: string, providerDispatch?: { __typename?: 'ProviderDispatch', status: GProviderDispatchStatus, error?: string, cancelRequestedAt?: any, cancelable: boolean, unmarkable: boolean } }, userErrors: Array<{ __typename: 'DispatchNotAllowed', message: string } | { __typename: 'DispatchProfileIncomplete', message: string } | { __typename: 'ProviderNotAvailable', message: string } | { __typename: 'ProviderRejected', message: string } | { __typename: 'RouteNotFound', message: string } | { __typename: 'RouteNotMarkable', message: string } | { __typename: 'StopsNotEscalatable', message: string } | { __typename: 'UnmarkNotAllowed', message: string }> } };

export type GCheckinOrderVendorReceivingMutationVariables = Exact<{
  input: GCheckinOrderVendorReceivingInput;
}>;


export type GCheckinOrderVendorReceivingMutation = { __typename?: 'Mutation', checkinOrderVendorReceiving?: { __typename?: 'CheckinOrderVendorReceivingPayload', orderVendorReceivings?: Array<{ __typename?: 'OrderVendorReceiving', itemId: string, receivedQty: number, vendorPriceTotalCents: number, vendorPricePerUnitCents?: number, sellingPricePerUnitCents?: number, windowClosesAt?: any }>, userErrors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> }> } };

export type GConfirmOrderReviewMutationVariables = Exact<{
  input: GOrderReviewConfirmInput;
}>;


export type GConfirmOrderReviewMutation = { __typename?: 'Mutation', confirmOrderReview?: { __typename?: 'OrderReviewConfirmPayload', order?: { __typename?: 'Order', id: string, reviewStatus: GOrderReviewStatus, reviewConfirmedAt?: any }, userErrors: Array<{ __typename: 'BlankNote', message: string, path?: Array<string> } | { __typename: 'InvalidDeliveredQuantity', message: string, path?: Array<string> } | { __typename: 'InvalidFulfillmentQuantity', message: string, path?: Array<string> } | { __typename: 'MissingQtyDelivered', message: string, path?: Array<string> } | { __typename: 'OrderLineNotFound', message: string, path?: Array<string> } | { __typename: 'OrderNotEligibleForReview', message: string, path?: Array<string> } | { __typename: 'OrderNotFound', message: string, path?: Array<string> } | { __typename: 'RecoveryQuantityOutOfRange', message: string, path?: Array<string> } | { __typename: 'ReviewConfirmationMismatch', message: string, path?: Array<string> } | { __typename: 'RouteEnded', message: string, path?: Array<string> }> } };

export type GCreateDriverSafetyAcknowledgementMutationVariables = Exact<{
  input: GDriverSafetyAcknowledgementCreateInput;
}>;


export type GCreateDriverSafetyAcknowledgementMutation = { __typename?: 'Mutation', createDriverSafetyAcknowledgement?: { __typename?: 'DriverSafetyAcknowledgementCreatePayload', acknowledgement?: { __typename?: 'DriverSafetyAcknowledgement', id: string, name: string, acknowledgementText: string, acknowledgementCopy: string, publishOn: any, status: GDriverSafetyAcknowledgementStatus, driverAcknowledgementsCount: number, createdAt: any }, userErrors: Array<{ __typename: 'UserError' }> } };

export type GCustomerTrackingSettingsFieldsFragment = { __typename?: 'CustomerTrackingSettings', mode: string, policy: string, revision: number, startHour: number, endHour: number, pageRadiusMiles: number, driverRadiusMiles: number, pageStops: number, driverStops: number, timeZone?: string };

export type GGetCustomerTrackingSettingsQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
}>;


export type GGetCustomerTrackingSettingsQuery = { __typename?: 'Query', customerTrackingSettings: { __typename?: 'CustomerTrackingSettings', mode: string, policy: string, revision: number, startHour: number, endHour: number, pageRadiusMiles: number, driverRadiusMiles: number, pageStops: number, driverStops: number, timeZone?: string } };

export type GUpdateCustomerTrackingSettingsMutationVariables = Exact<{
  input: GUpdateCustomerTrackingSettingsInput;
}>;


export type GUpdateCustomerTrackingSettingsMutation = { __typename?: 'Mutation', updateCustomerTrackingSettings?: { __typename?: 'UpdateCustomerTrackingSettingsPayload', settings: { __typename?: 'CustomerTrackingSettings', mode: string, policy: string, revision: number, startHour: number, endHour: number, pageRadiusMiles: number, driverRadiusMiles: number, pageStops: number, driverStops: number, timeZone?: string } } };

export type GDeleteDriverSafetyAcknowledgementMutationVariables = Exact<{
  input: GDriverSafetyAcknowledgementDeleteInput;
}>;


export type GDeleteDriverSafetyAcknowledgementMutation = { __typename?: 'Mutation', deleteDriverSafetyAcknowledgement?: { __typename?: 'DriverSafetyAcknowledgementDeletePayload', deletedId?: string, userErrors: Array<{ __typename: 'UserError' }> } };

export type GCutoffBufferFieldsFragment = { __typename?: 'DeliveryOverrideCutoffBuffer', seconds: number, vendor: { __typename?: 'Vendor', name: string, isWarehouse: boolean, warehouse?: { __typename?: 'Warehouse', name: string } } };

export type GOverrideRuleFieldsFragment = { __typename?: 'DeliveryOverrideRule', id: string, deliveryDate: any, scope: GDeliveryOverrideRuleScopeEnum, dayAction?: GDeliveryOverrideDayActionEnum, substituteDeliveryDate?: any, leadTime?: number, orderDeadline?: string, reachMode?: GDeliveryOverrideReachModeEnum, audienceKind?: GDeliveryOverrideAudienceKindEnum, tagMatchMode?: GDeliveryOverrideTagMatchModeEnum, reachedLocationCount: number, cancelledOrderCount: number, location?: { __typename?: 'Location', businessName: string }, vendor?: { __typename?: 'Vendor', name: string, isWarehouse: boolean, warehouse?: { __typename?: 'Warehouse', name: string } }, audienceTags: Array<{ __typename?: 'CustomerTag', id: string, name: string }>, cutoffBuffers: Array<{ __typename?: 'DeliveryOverrideCutoffBuffer', seconds: number, vendor: { __typename?: 'Vendor', name: string, isWarehouse: boolean, warehouse?: { __typename?: 'Warehouse', name: string } } }> };

export type GOverrideOverlapFieldsFragment = { __typename?: 'DeliveryOverrideOverlap', locationCount: number, rule: { __typename?: 'DeliveryOverrideRule', id: string, deliveryDate: any, scope: GDeliveryOverrideRuleScopeEnum, dayAction?: GDeliveryOverrideDayActionEnum, substituteDeliveryDate?: any, leadTime?: number, orderDeadline?: string, reachMode?: GDeliveryOverrideReachModeEnum, audienceKind?: GDeliveryOverrideAudienceKindEnum, tagMatchMode?: GDeliveryOverrideTagMatchModeEnum, reachedLocationCount: number, cancelledOrderCount: number, location?: { __typename?: 'Location', businessName: string }, vendor?: { __typename?: 'Vendor', name: string, isWarehouse: boolean, warehouse?: { __typename?: 'Warehouse', name: string } }, audienceTags: Array<{ __typename?: 'CustomerTag', id: string, name: string }>, cutoffBuffers: Array<{ __typename?: 'DeliveryOverrideCutoffBuffer', seconds: number, vendor: { __typename?: 'Vendor', name: string, isWarehouse: boolean, warehouse?: { __typename?: 'Warehouse', name: string } } }> } };

export type GGetDeliveryOverrideRulesQueryVariables = Exact<{
  warehouseId?: InputMaybe<Scalars['ID']>;
  from?: InputMaybe<Scalars['ISO8601Date']>;
  to?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type GGetDeliveryOverrideRulesQuery = { __typename?: 'Query', deliveryOverrideRules: { __typename?: 'DeliveryOverrideRulesConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, nodes?: Array<{ __typename?: 'DeliveryOverrideRule', id: string, deliveryDate: any, scope: GDeliveryOverrideRuleScopeEnum, dayAction?: GDeliveryOverrideDayActionEnum, substituteDeliveryDate?: any, leadTime?: number, orderDeadline?: string, reachMode?: GDeliveryOverrideReachModeEnum, audienceKind?: GDeliveryOverrideAudienceKindEnum, tagMatchMode?: GDeliveryOverrideTagMatchModeEnum, reachedLocationCount: number, cancelledOrderCount: number, reachedLocations?: { __typename?: 'ReachedLocationsConnection', totalCount: number, nodes?: Array<{ __typename?: 'Location', businessName: string }> }, outrankedBy?: { __typename?: 'DeliveryOverrideOverlap', rule: { __typename?: 'DeliveryOverrideRule', id: string } }, vendorExceptions: Array<{ __typename?: 'DeliveryOverrideVendorException', effect: GDeliveryOverrideVendorEffectEnum, rule: { __typename?: 'DeliveryOverrideRule', id: string } }>, location?: { __typename?: 'Location', businessName: string }, vendor?: { __typename?: 'Vendor', name: string, isWarehouse: boolean, warehouse?: { __typename?: 'Warehouse', name: string } }, audienceTags: Array<{ __typename?: 'CustomerTag', id: string, name: string }>, cutoffBuffers: Array<{ __typename?: 'DeliveryOverrideCutoffBuffer', seconds: number, vendor: { __typename?: 'Vendor', name: string, isWarehouse: boolean, warehouse?: { __typename?: 'Warehouse', name: string } } }> }> } };

export type GGetDeliveryOverrideRuleLocationsQueryVariables = Exact<{
  warehouseId?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GGetDeliveryOverrideRuleLocationsQuery = { __typename?: 'Query', deliveryOverrideRules: { __typename?: 'DeliveryOverrideRulesConnection', nodes?: Array<{ __typename?: 'DeliveryOverrideRule', id: string, audienceKind?: GDeliveryOverrideAudienceKindEnum, tagMatchMode?: GDeliveryOverrideTagMatchModeEnum, audienceTags: Array<{ __typename?: 'CustomerTag', id: string, name: string }>, reachedLocations?: { __typename?: 'ReachedLocationsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string }, nodes?: Array<{ __typename?: 'Location', id: string, businessName: string }> } }> } };

export type GGetOverrideFormStoresQueryVariables = Exact<{
  filters: GDeliveryOverrideLocationFiltersInput;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type GGetOverrideFormStoresQuery = { __typename?: 'Query', deliveryOverrideLocations: { __typename?: 'LocationConnection', totalCount: number, nodes?: Array<{ __typename?: 'Location', id: string, businessName: string }> } };

export type GGetOverrideFormTagsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type GGetOverrideFormTagsQuery = { __typename?: 'Query', customerTags: { __typename?: 'CustomerTagConnection', nodes?: Array<{ __typename?: 'CustomerTag', id: string, name: string, assignedLocationCount: number }> } };

export type GGetAllVendorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GGetAllVendorsQuery = { __typename?: 'Query', vendors: Array<{ __typename?: 'Vendor', id: string, name: string, isWarehouse: boolean, warehouse?: { __typename?: 'Warehouse', id: string, name: string } }> };

export type GGetStoreDeliveryScheduleQueryVariables = Exact<{
  odekoUuid: Scalars['ID'];
}>;


export type GGetStoreDeliveryScheduleQuery = { __typename?: 'Query', location?: { __typename?: 'Location', id: string, availableDeliveryDays: Array<{ __typename?: 'AvailableDeliveryDay', dayOfWeek: number, dayName: string, nextDeliveryDate?: any, orderDeadline: string, leadTime: number, vendor: { __typename?: 'Vendor', id: string, name: string, isWarehouse: boolean, warehouse?: { __typename?: 'Warehouse', name: string } } }> } };

export type GCreateDeliveryOverrideRuleMutationVariables = Exact<{
  input: GCreateDeliveryOverrideRuleMutationInput;
}>;


export type GCreateDeliveryOverrideRuleMutation = { __typename?: 'Mutation', createDeliveryOverrideRule?: { __typename?: 'CreateDeliveryOverrideRuleMutationPayload', deliveryOverrideRule?: { __typename?: 'DeliveryOverrideRule', id: string }, errors?: Array<{ __typename?: 'UserError', message: string, path?: Array<string> }> } };

export type GDeleteDeliveryOverrideRuleMutationVariables = Exact<{
  input: GDeleteDeliveryOverrideRuleMutationInput;
}>;


export type GDeleteDeliveryOverrideRuleMutation = { __typename?: 'Mutation', deleteDeliveryOverrideRule?: { __typename?: 'DeleteDeliveryOverrideRuleMutationPayload', deliveryOverrideRule?: { __typename?: 'DeliveryOverrideRule', id: string }, errors?: Array<{ __typename?: 'UserError', message: string, path?: Array<string> }> } };

export type GAffectedDeliveryFieldsFragment = { __typename?: 'DeliveryOverrideAffectedDelivery', kind: GDeliveryOverrideAffectedKindEnum, status: GDeliveryOverrideAffectedStatusEnum, locationUuid: string, locationName: string, vendorId: string, vendorName: string, vendorWarehouseName?: string, deliveryDate: any, orderUuid?: string, orderNumber?: string, netsuiteOrderNumber?: string, lines: Array<{ __typename?: 'DeliveryOverrideAffectedLine', itemUuid?: string, itemName: string, quantity: number }> };

export type GCopyDeliveryOverrideRulesMutationVariables = Exact<{
  input: GCopyDeliveryOverrideRulesMutationInput;
}>;


export type GCopyDeliveryOverrideRulesMutation = { __typename?: 'Mutation', copyDeliveryOverrideRules?: { __typename?: 'CopyDeliveryOverrideRulesMutationPayload', committed: boolean, errors?: Array<{ __typename?: 'UserError', message: string, path?: Array<string> }>, results: Array<{ __typename?: 'DeliveryOverrideCopyResult', sourceRuleId: string, cancelledOrderCount: number, copiedRule?: { __typename?: 'DeliveryOverrideRule', id: string, deliveryDate: any }, errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> }> }> } };

export type GCopyDeliveryOverrideRulesWithOrdersMutationVariables = Exact<{
  input: GCopyDeliveryOverrideRulesMutationInput;
}>;


export type GCopyDeliveryOverrideRulesWithOrdersMutation = { __typename?: 'Mutation', copyDeliveryOverrideRules?: { __typename?: 'CopyDeliveryOverrideRulesMutationPayload', committed: boolean, errors?: Array<{ __typename?: 'UserError', message: string, path?: Array<string> }>, results: Array<{ __typename?: 'DeliveryOverrideCopyResult', sourceRuleId: string, cancelledOrderCount: number, cancelledOrders: Array<{ __typename?: 'DeliveryOverrideAffectedDelivery', kind: GDeliveryOverrideAffectedKindEnum, status: GDeliveryOverrideAffectedStatusEnum, locationUuid: string, locationName: string, vendorId: string, vendorName: string, vendorWarehouseName?: string, deliveryDate: any, orderUuid?: string, orderNumber?: string, netsuiteOrderNumber?: string, lines: Array<{ __typename?: 'DeliveryOverrideAffectedLine', itemUuid?: string, itemName: string, quantity: number }> }>, copiedRule?: { __typename?: 'DeliveryOverrideRule', id: string, deliveryDate: any }, errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> }> }> } };

export type GGetDeliveryOverridePreviewQueryVariables = Exact<{
  scope?: InputMaybe<GDeliveryOverrideScopeEnum>;
  locationId?: InputMaybe<Scalars['ID']>;
  vendorId?: InputMaybe<Scalars['ID']>;
  audience?: InputMaybe<GDeliveryOverrideAudienceInput>;
  warehouseId?: InputMaybe<Scalars['ID']>;
  deliveryDate: Scalars['ISO8601Date'];
  dayAction?: InputMaybe<GDeliveryOverrideDayActionEnum>;
  substituteDeliveryDate?: InputMaybe<Scalars['ISO8601Date']>;
  leadTime?: InputMaybe<Scalars['Int']>;
  orderDeadline?: InputMaybe<Scalars['String']>;
  reachMode?: InputMaybe<GDeliveryOverrideReachModeEnum>;
}>;


export type GGetDeliveryOverridePreviewQuery = { __typename?: 'Query', deliveryOverridePreview: { __typename?: 'DeliveryOverridePreview', locationCount?: number, excludedLocationCount?: number, cancelledOrderCount?: number, outrankedLocationCount?: number, overlaps?: Array<{ __typename?: 'DeliveryOverrideOverlap', locationCount: number, rule: { __typename?: 'DeliveryOverrideRule', id: string, deliveryDate: any, scope: GDeliveryOverrideRuleScopeEnum, dayAction?: GDeliveryOverrideDayActionEnum, substituteDeliveryDate?: any, leadTime?: number, orderDeadline?: string, reachMode?: GDeliveryOverrideReachModeEnum, audienceKind?: GDeliveryOverrideAudienceKindEnum, tagMatchMode?: GDeliveryOverrideTagMatchModeEnum, reachedLocationCount: number, cancelledOrderCount: number, location?: { __typename?: 'Location', businessName: string }, vendor?: { __typename?: 'Vendor', name: string, isWarehouse: boolean, warehouse?: { __typename?: 'Warehouse', name: string } }, audienceTags: Array<{ __typename?: 'CustomerTag', id: string, name: string }>, cutoffBuffers: Array<{ __typename?: 'DeliveryOverrideCutoffBuffer', seconds: number, vendor: { __typename?: 'Vendor', name: string, isWarehouse: boolean, warehouse?: { __typename?: 'Warehouse', name: string } } }> } }>, outrankedBy?: { __typename?: 'DeliveryOverrideOverlap', locationCount: number, rule: { __typename?: 'DeliveryOverrideRule', id: string, deliveryDate: any, scope: GDeliveryOverrideRuleScopeEnum, dayAction?: GDeliveryOverrideDayActionEnum, substituteDeliveryDate?: any, leadTime?: number, orderDeadline?: string, reachMode?: GDeliveryOverrideReachModeEnum, audienceKind?: GDeliveryOverrideAudienceKindEnum, tagMatchMode?: GDeliveryOverrideTagMatchModeEnum, reachedLocationCount: number, cancelledOrderCount: number, location?: { __typename?: 'Location', businessName: string }, vendor?: { __typename?: 'Vendor', name: string, isWarehouse: boolean, warehouse?: { __typename?: 'Warehouse', name: string } }, audienceTags: Array<{ __typename?: 'CustomerTag', id: string, name: string }>, cutoffBuffers: Array<{ __typename?: 'DeliveryOverrideCutoffBuffer', seconds: number, vendor: { __typename?: 'Vendor', name: string, isWarehouse: boolean, warehouse?: { __typename?: 'Warehouse', name: string } } }> } }, vendorExceptions?: Array<{ __typename?: 'DeliveryOverrideVendorException', locationCount: number, effect: GDeliveryOverrideVendorEffectEnum, rule: { __typename?: 'DeliveryOverrideRule', id: string, deliveryDate: any, scope: GDeliveryOverrideRuleScopeEnum, dayAction?: GDeliveryOverrideDayActionEnum, substituteDeliveryDate?: any, leadTime?: number, orderDeadline?: string, reachMode?: GDeliveryOverrideReachModeEnum, audienceKind?: GDeliveryOverrideAudienceKindEnum, tagMatchMode?: GDeliveryOverrideTagMatchModeEnum, reachedLocationCount: number, cancelledOrderCount: number, location?: { __typename?: 'Location', businessName: string }, vendor?: { __typename?: 'Vendor', name: string, isWarehouse: boolean, warehouse?: { __typename?: 'Warehouse', name: string } }, audienceTags: Array<{ __typename?: 'CustomerTag', id: string, name: string }>, cutoffBuffers: Array<{ __typename?: 'DeliveryOverrideCutoffBuffer', seconds: number, vendor: { __typename?: 'Vendor', name: string, isWarehouse: boolean, warehouse?: { __typename?: 'Warehouse', name: string } } }> } }>, cutoffBuffers: Array<{ __typename?: 'DeliveryOverrideCutoffBuffer', seconds: number, vendor: { __typename?: 'Vendor', name: string, isWarehouse: boolean, warehouse?: { __typename?: 'Warehouse', name: string } } }>, errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> }> } };

export type GGetDeliveryOverrideAffectedDeliveriesQueryVariables = Exact<{
  scope?: InputMaybe<GDeliveryOverrideScopeEnum>;
  locationId?: InputMaybe<Scalars['ID']>;
  vendorId?: InputMaybe<Scalars['ID']>;
  audience?: InputMaybe<GDeliveryOverrideAudienceInput>;
  warehouseId?: InputMaybe<Scalars['ID']>;
  deliveryDate: Scalars['ISO8601Date'];
  reachMode?: InputMaybe<GDeliveryOverrideReachModeEnum>;
}>;


export type GGetDeliveryOverrideAffectedDeliveriesQuery = { __typename?: 'Query', deliveryOverrideAffectedDeliveries: { __typename?: 'DeliveryOverrideAffectedDeliveries', errors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> }>, deliveries?: Array<{ __typename?: 'DeliveryOverrideAffectedDelivery', kind: GDeliveryOverrideAffectedKindEnum, status: GDeliveryOverrideAffectedStatusEnum, locationUuid: string, locationName: string, vendorId: string, vendorName: string, vendorWarehouseName?: string, deliveryDate: any, orderUuid?: string, orderNumber?: string, netsuiteOrderNumber?: string, lines: Array<{ __typename?: 'DeliveryOverrideAffectedLine', itemUuid?: string, itemName: string, quantity: number }> }> } };

export type GDispatchProviderRouteMutationVariables = Exact<{
  input: GDispatchProviderRouteInput;
}>;


export type GDispatchProviderRouteMutation = { __typename?: 'Mutation', dispatchProviderRoute?: { __typename?: 'DispatchProviderRoutePayload', route?: { __typename?: 'Route', id: string, providerDispatch?: { __typename?: 'ProviderDispatch', status: GProviderDispatchStatus, error?: string } }, userErrors: Array<{ __typename: 'DispatchNotAllowed', message: string } | { __typename: 'DispatchProfileIncomplete', message: string } | { __typename: 'ProviderNotAvailable', message: string } | { __typename: 'ProviderRejected', message: string } | { __typename: 'RouteNotFound', message: string } | { __typename: 'RouteNotMarkable', message: string } | { __typename: 'StopsNotEscalatable', message: string } | { __typename: 'UnmarkNotAllowed', message: string }> } };

export type GPublicDockBookingFieldsFragment = { __typename?: 'PublicDockBooking', status: GDockBookingStatus, freightType?: GFreightType, referenceNumber: string, carrierName?: string, originName?: string, expectedDate?: any, warehouseName: string, warehouseTimeZone: string, blockedBookingWeekdays: Array<number>, contactName?: string, contactEmail?: string, contactPhone?: string, confirmationEmail?: string, confirmationNumber?: string, palletCount?: number, weightLbs?: number, scacCode?: string, deliveryType?: GDeliveryType, shipDate?: any, proNumber?: string, comments?: string, truckNumber?: string, dockName?: string, slotStartsAt?: any, slotEndsAt?: any, slotLabel?: string, windowMinutes?: number, canJoinAppointment?: boolean };

type GDockBookingErrorFields_AdHocAppointmentsNotAllowed_Fragment = { __typename?: 'AdHocAppointmentsNotAllowed', errorCode: string, message: string };

type GDockBookingErrorFields_AppointmentInPast_Fragment = { __typename?: 'AppointmentInPast', errorCode: string, message: string };

type GDockBookingErrorFields_CarrierNameRequired_Fragment = { __typename?: 'CarrierNameRequired', errorCode: string, message: string };

type GDockBookingErrorFields_CheckInNotAllowed_Fragment = { __typename?: 'CheckInNotAllowed', errorCode: string, message: string };

type GDockBookingErrorFields_ContactDetailsRequired_Fragment = { __typename?: 'ContactDetailsRequired', errorCode: string, message: string };

type GDockBookingErrorFields_DailyDeliveryExists_Fragment = { __typename?: 'DailyDeliveryExists' };

type GDockBookingErrorFields_DepartNotAllowed_Fragment = { __typename?: 'DepartNotAllowed', errorCode: string, message: string };

type GDockBookingErrorFields_DockBookingAlreadyCompleted_Fragment = { __typename?: 'DockBookingAlreadyCompleted', errorCode: string, message: string };

type GDockBookingErrorFields_DockBookingAlreadyMissed_Fragment = { __typename?: 'DockBookingAlreadyMissed' };

type GDockBookingErrorFields_DockBookingNotBooked_Fragment = { __typename?: 'DockBookingNotBooked', errorCode: string, message: string };

type GDockBookingErrorFields_DockBookingNotFound_Fragment = { __typename?: 'DockBookingNotFound', errorCode: string, message: string };

type GDockBookingErrorFields_DockBookingWarehouseNotFound_Fragment = { __typename?: 'DockBookingWarehouseNotFound', errorCode: string, message: string };

type GDockBookingErrorFields_DockCapacityInvalid_Fragment = { __typename?: 'DockCapacityInvalid', errorCode: string, message: string };

type GDockBookingErrorFields_DockInUse_Fragment = { __typename?: 'DockInUse', errorCode: string, message: string };

type GDockBookingErrorFields_DockNotFound_Fragment = { __typename?: 'DockNotFound', errorCode: string, message: string };

type GDockBookingErrorFields_DockOverrideCodeInactive_Fragment = { __typename?: 'DockOverrideCodeInactive' };

type GDockBookingErrorFields_DockReassignNotAllowed_Fragment = { __typename?: 'DockReassignNotAllowed' };

type GDockBookingErrorFields_DockRecoveryNotAllowed_Fragment = { __typename?: 'DockRecoveryNotAllowed' };

type GDockBookingErrorFields_DockSlotUnavailable_Fragment = { __typename?: 'DockSlotUnavailable', errorCode: string, message: string };

type GDockBookingErrorFields_DockVisitNotFound_Fragment = { __typename?: 'DockVisitNotFound', errorCode: string, message: string };

type GDockBookingErrorFields_OverrideCodeIssueConflict_Fragment = { __typename?: 'OverrideCodeIssueConflict' };

type GDockBookingErrorFields_OverrideCodeNotFound_Fragment = { __typename?: 'OverrideCodeNotFound' };

type GDockBookingErrorFields_OverrideVendorNotFound_Fragment = { __typename?: 'OverrideVendorNotFound' };

type GDockBookingErrorFields_ShipDateRequired_Fragment = { __typename?: 'ShipDateRequired', errorCode: string, message: string };

type GDockBookingErrorFields_WithinLeadTime_Fragment = { __typename?: 'WithinLeadTime', errorCode: string, message: string };

export type GDockBookingErrorFieldsFragment = GDockBookingErrorFields_AdHocAppointmentsNotAllowed_Fragment | GDockBookingErrorFields_AppointmentInPast_Fragment | GDockBookingErrorFields_CarrierNameRequired_Fragment | GDockBookingErrorFields_CheckInNotAllowed_Fragment | GDockBookingErrorFields_ContactDetailsRequired_Fragment | GDockBookingErrorFields_DailyDeliveryExists_Fragment | GDockBookingErrorFields_DepartNotAllowed_Fragment | GDockBookingErrorFields_DockBookingAlreadyCompleted_Fragment | GDockBookingErrorFields_DockBookingAlreadyMissed_Fragment | GDockBookingErrorFields_DockBookingNotBooked_Fragment | GDockBookingErrorFields_DockBookingNotFound_Fragment | GDockBookingErrorFields_DockBookingWarehouseNotFound_Fragment | GDockBookingErrorFields_DockCapacityInvalid_Fragment | GDockBookingErrorFields_DockInUse_Fragment | GDockBookingErrorFields_DockNotFound_Fragment | GDockBookingErrorFields_DockOverrideCodeInactive_Fragment | GDockBookingErrorFields_DockReassignNotAllowed_Fragment | GDockBookingErrorFields_DockRecoveryNotAllowed_Fragment | GDockBookingErrorFields_DockSlotUnavailable_Fragment | GDockBookingErrorFields_DockVisitNotFound_Fragment | GDockBookingErrorFields_OverrideCodeIssueConflict_Fragment | GDockBookingErrorFields_OverrideCodeNotFound_Fragment | GDockBookingErrorFields_OverrideVendorNotFound_Fragment | GDockBookingErrorFields_ShipDateRequired_Fragment | GDockBookingErrorFields_WithinLeadTime_Fragment;

export type GDockFieldsFragment = { __typename?: 'Dock', id: string, name: string, active: boolean, windows: Array<{ __typename?: 'DockWindow', id: string, openTime: string, closeTime: string, ftlMax: number, ltlMax: number }> };

export type GGetPublicDockBookingQueryVariables = Exact<{
  referenceNumber: Scalars['String'];
}>;


export type GGetPublicDockBookingQuery = { __typename?: 'Query', publicDockBooking?: { __typename?: 'PublicDockBooking', status: GDockBookingStatus, freightType?: GFreightType, referenceNumber: string, carrierName?: string, originName?: string, expectedDate?: any, warehouseName: string, warehouseTimeZone: string, blockedBookingWeekdays: Array<number>, contactName?: string, contactEmail?: string, contactPhone?: string, confirmationEmail?: string, confirmationNumber?: string, palletCount?: number, weightLbs?: number, scacCode?: string, deliveryType?: GDeliveryType, shipDate?: any, proNumber?: string, comments?: string, truckNumber?: string, dockName?: string, slotStartsAt?: any, slotEndsAt?: any, slotLabel?: string, windowMinutes?: number, canJoinAppointment?: boolean } };

export type GGetPublicDockBookingSlotsQueryVariables = Exact<{
  referenceNumber: Scalars['String'];
  date: Scalars['ISO8601Date'];
  freightType: GFreightType;
  scacCode?: InputMaybe<Scalars['String']>;
  joinConfirmationNumber?: InputMaybe<Scalars['String']>;
}>;


export type GGetPublicDockBookingSlotsQuery = { __typename?: 'Query', publicDockBooking?: { __typename?: 'PublicDockBooking', availableSlots: Array<{ __typename?: 'PublicDockSlot', startsAt: any, endsAt: any, label: string }> } };

export type GSubmitPublicDockBookingMutationVariables = Exact<{
  input: GPublicDockBookingSubmitInput;
}>;


export type GSubmitPublicDockBookingMutation = { __typename?: 'Mutation', publicDockBookingSubmit?: { __typename?: 'PublicDockBookingSubmitPayload', booking?: { __typename?: 'PublicDockBooking', status: GDockBookingStatus, freightType?: GFreightType, referenceNumber: string, carrierName?: string, originName?: string, expectedDate?: any, warehouseName: string, warehouseTimeZone: string, blockedBookingWeekdays: Array<number>, contactName?: string, contactEmail?: string, contactPhone?: string, confirmationEmail?: string, confirmationNumber?: string, palletCount?: number, weightLbs?: number, scacCode?: string, deliveryType?: GDeliveryType, shipDate?: any, proNumber?: string, comments?: string, truckNumber?: string, dockName?: string, slotStartsAt?: any, slotEndsAt?: any, slotLabel?: string, windowMinutes?: number, canJoinAppointment?: boolean }, userErrors: Array<{ __typename?: 'AdHocAppointmentsNotAllowed', errorCode: string, message: string } | { __typename?: 'AppointmentInPast', errorCode: string, message: string } | { __typename?: 'CarrierNameRequired', errorCode: string, message: string } | { __typename?: 'CheckInNotAllowed', errorCode: string, message: string } | { __typename?: 'ContactDetailsRequired', errorCode: string, message: string } | { __typename?: 'DailyDeliveryExists' } | { __typename?: 'DepartNotAllowed', errorCode: string, message: string } | { __typename?: 'DockBookingAlreadyCompleted', errorCode: string, message: string } | { __typename?: 'DockBookingAlreadyMissed' } | { __typename?: 'DockBookingNotBooked', errorCode: string, message: string } | { __typename?: 'DockBookingNotFound', errorCode: string, message: string } | { __typename?: 'DockBookingWarehouseNotFound', errorCode: string, message: string } | { __typename?: 'DockCapacityInvalid', errorCode: string, message: string } | { __typename?: 'DockInUse', errorCode: string, message: string } | { __typename?: 'DockNotFound', errorCode: string, message: string } | { __typename?: 'DockOverrideCodeInactive' } | { __typename?: 'DockReassignNotAllowed' } | { __typename?: 'DockRecoveryNotAllowed' } | { __typename?: 'DockSlotUnavailable', errorCode: string, message: string } | { __typename?: 'DockVisitNotFound', errorCode: string, message: string } | { __typename?: 'OverrideCodeIssueConflict' } | { __typename?: 'OverrideCodeNotFound' } | { __typename?: 'OverrideVendorNotFound' } | { __typename?: 'ShipDateRequired', errorCode: string, message: string } | { __typename?: 'WithinLeadTime', errorCode: string, message: string }> } };

export type GCancelPublicDockBookingMutationVariables = Exact<{
  input: GPublicDockBookingCancelInput;
}>;


export type GCancelPublicDockBookingMutation = { __typename?: 'Mutation', publicDockBookingCancel?: { __typename?: 'PublicDockBookingCancelPayload', booking?: { __typename?: 'PublicDockBooking', status: GDockBookingStatus, freightType?: GFreightType, referenceNumber: string, carrierName?: string, originName?: string, expectedDate?: any, warehouseName: string, warehouseTimeZone: string, blockedBookingWeekdays: Array<number>, contactName?: string, contactEmail?: string, contactPhone?: string, confirmationEmail?: string, confirmationNumber?: string, palletCount?: number, weightLbs?: number, scacCode?: string, deliveryType?: GDeliveryType, shipDate?: any, proNumber?: string, comments?: string, truckNumber?: string, dockName?: string, slotStartsAt?: any, slotEndsAt?: any, slotLabel?: string, windowMinutes?: number, canJoinAppointment?: boolean }, userErrors: Array<{ __typename?: 'AdHocAppointmentsNotAllowed', errorCode: string, message: string } | { __typename?: 'AppointmentInPast', errorCode: string, message: string } | { __typename?: 'CarrierNameRequired', errorCode: string, message: string } | { __typename?: 'CheckInNotAllowed', errorCode: string, message: string } | { __typename?: 'ContactDetailsRequired', errorCode: string, message: string } | { __typename?: 'DailyDeliveryExists' } | { __typename?: 'DepartNotAllowed', errorCode: string, message: string } | { __typename?: 'DockBookingAlreadyCompleted', errorCode: string, message: string } | { __typename?: 'DockBookingAlreadyMissed' } | { __typename?: 'DockBookingNotBooked', errorCode: string, message: string } | { __typename?: 'DockBookingNotFound', errorCode: string, message: string } | { __typename?: 'DockBookingWarehouseNotFound', errorCode: string, message: string } | { __typename?: 'DockCapacityInvalid', errorCode: string, message: string } | { __typename?: 'DockInUse', errorCode: string, message: string } | { __typename?: 'DockNotFound', errorCode: string, message: string } | { __typename?: 'DockOverrideCodeInactive' } | { __typename?: 'DockReassignNotAllowed' } | { __typename?: 'DockRecoveryNotAllowed' } | { __typename?: 'DockSlotUnavailable', errorCode: string, message: string } | { __typename?: 'DockVisitNotFound', errorCode: string, message: string } | { __typename?: 'OverrideCodeIssueConflict' } | { __typename?: 'OverrideCodeNotFound' } | { __typename?: 'OverrideVendorNotFound' } | { __typename?: 'ShipDateRequired', errorCode: string, message: string } | { __typename?: 'WithinLeadTime', errorCode: string, message: string }> } };

export type GGetPublicDockCheckInLookupQueryVariables = Exact<{
  reference: Scalars['String'];
}>;


export type GGetPublicDockCheckInLookupQuery = { __typename?: 'Query', publicDockCheckInLookup?: { __typename?: 'PublicDockBooking', status: GDockBookingStatus, freightType?: GFreightType, referenceNumber: string, carrierName?: string, originName?: string, expectedDate?: any, warehouseName: string, warehouseTimeZone: string, blockedBookingWeekdays: Array<number>, contactName?: string, contactEmail?: string, contactPhone?: string, confirmationEmail?: string, confirmationNumber?: string, palletCount?: number, weightLbs?: number, scacCode?: string, deliveryType?: GDeliveryType, shipDate?: any, proNumber?: string, comments?: string, truckNumber?: string, dockName?: string, slotStartsAt?: any, slotEndsAt?: any, slotLabel?: string, windowMinutes?: number, canJoinAppointment?: boolean } };

export type GPublicDockCheckInMutationVariables = Exact<{
  input: GPublicDockCheckInInput;
}>;


export type GPublicDockCheckInMutation = { __typename?: 'Mutation', publicDockCheckIn?: { __typename?: 'PublicDockCheckInPayload', booking?: { __typename?: 'PublicDockBooking', status: GDockBookingStatus, freightType?: GFreightType, referenceNumber: string, carrierName?: string, originName?: string, expectedDate?: any, warehouseName: string, warehouseTimeZone: string, blockedBookingWeekdays: Array<number>, contactName?: string, contactEmail?: string, contactPhone?: string, confirmationEmail?: string, confirmationNumber?: string, palletCount?: number, weightLbs?: number, scacCode?: string, deliveryType?: GDeliveryType, shipDate?: any, proNumber?: string, comments?: string, truckNumber?: string, dockName?: string, slotStartsAt?: any, slotEndsAt?: any, slotLabel?: string, windowMinutes?: number, canJoinAppointment?: boolean }, userErrors: Array<{ __typename?: 'AdHocAppointmentsNotAllowed', errorCode: string, message: string } | { __typename?: 'AppointmentInPast', errorCode: string, message: string } | { __typename?: 'CarrierNameRequired', errorCode: string, message: string } | { __typename?: 'CheckInNotAllowed', errorCode: string, message: string } | { __typename?: 'ContactDetailsRequired', errorCode: string, message: string } | { __typename?: 'DailyDeliveryExists' } | { __typename?: 'DepartNotAllowed', errorCode: string, message: string } | { __typename?: 'DockBookingAlreadyCompleted', errorCode: string, message: string } | { __typename?: 'DockBookingAlreadyMissed' } | { __typename?: 'DockBookingNotBooked', errorCode: string, message: string } | { __typename?: 'DockBookingNotFound', errorCode: string, message: string } | { __typename?: 'DockBookingWarehouseNotFound', errorCode: string, message: string } | { __typename?: 'DockCapacityInvalid', errorCode: string, message: string } | { __typename?: 'DockInUse', errorCode: string, message: string } | { __typename?: 'DockNotFound', errorCode: string, message: string } | { __typename?: 'DockOverrideCodeInactive' } | { __typename?: 'DockReassignNotAllowed' } | { __typename?: 'DockRecoveryNotAllowed' } | { __typename?: 'DockSlotUnavailable', errorCode: string, message: string } | { __typename?: 'DockVisitNotFound', errorCode: string, message: string } | { __typename?: 'OverrideCodeIssueConflict' } | { __typename?: 'OverrideCodeNotFound' } | { __typename?: 'OverrideVendorNotFound' } | { __typename?: 'ShipDateRequired', errorCode: string, message: string } | { __typename?: 'WithinLeadTime', errorCode: string, message: string }> } };

export type GGetPublicDockOpenVisitsQueryVariables = Exact<{
  dockId?: InputMaybe<Scalars['ID']>;
  warehouseId?: InputMaybe<Scalars['ID']>;
}>;


export type GGetPublicDockOpenVisitsQuery = { __typename?: 'Query', publicDockOpenVisits?: Array<{ __typename?: 'PublicDockVisit', id: string, checkedInAt: any, truckNumber?: string, dockName?: string, booking?: { __typename?: 'PublicDockVisitBooking', referenceNumber: string, confirmationNumber?: string, carrierName?: string } }> };

export type GPublicDockDepartMutationVariables = Exact<{
  input: GPublicDockDepartInput;
}>;


export type GPublicDockDepartMutation = { __typename?: 'Mutation', publicDockDepart?: { __typename?: 'PublicDockDepartPayload', visit?: { __typename?: 'PublicDockVisit', id: string, departedAt?: any }, userErrors: Array<{ __typename?: 'AdHocAppointmentsNotAllowed', errorCode: string, message: string } | { __typename?: 'AppointmentInPast', errorCode: string, message: string } | { __typename?: 'CarrierNameRequired', errorCode: string, message: string } | { __typename?: 'CheckInNotAllowed', errorCode: string, message: string } | { __typename?: 'ContactDetailsRequired', errorCode: string, message: string } | { __typename?: 'DailyDeliveryExists' } | { __typename?: 'DepartNotAllowed', errorCode: string, message: string } | { __typename?: 'DockBookingAlreadyCompleted', errorCode: string, message: string } | { __typename?: 'DockBookingAlreadyMissed' } | { __typename?: 'DockBookingNotBooked', errorCode: string, message: string } | { __typename?: 'DockBookingNotFound', errorCode: string, message: string } | { __typename?: 'DockBookingWarehouseNotFound', errorCode: string, message: string } | { __typename?: 'DockCapacityInvalid', errorCode: string, message: string } | { __typename?: 'DockInUse', errorCode: string, message: string } | { __typename?: 'DockNotFound', errorCode: string, message: string } | { __typename?: 'DockOverrideCodeInactive' } | { __typename?: 'DockReassignNotAllowed' } | { __typename?: 'DockRecoveryNotAllowed' } | { __typename?: 'DockSlotUnavailable', errorCode: string, message: string } | { __typename?: 'DockVisitNotFound', errorCode: string, message: string } | { __typename?: 'OverrideCodeIssueConflict' } | { __typename?: 'OverrideCodeNotFound' } | { __typename?: 'OverrideVendorNotFound' } | { __typename?: 'ShipDateRequired', errorCode: string, message: string } | { __typename?: 'WithinLeadTime', errorCode: string, message: string }> } };

export type GGetPublicDockDisplayQueryVariables = Exact<{
  dockId: Scalars['ID'];
}>;


export type GGetPublicDockDisplayQuery = { __typename?: 'Query', publicDockDisplay?: { __typename?: 'PublicDockDisplay', dockName: string, warehouseName: string, warehouseTimeZone: string, upcomingArrivals: Array<{ __typename?: 'PublicDockArrival', referenceNumber: string, carrierName?: string, vendorName?: string, originName?: string, freightType: GFreightType, contactName?: string, palletCount?: number, weightLbs?: number, scacCode?: string, confirmationNumber?: string, truckNumber?: string, slotStartsAt: any, slotEndsAt: any, slotLabel: string, checkedInAt?: any }> } };

export type GDockBookingFieldsFragment = { __typename?: 'DockBooking', id: string, token: string, status: GDockBookingStatus, bookingKind: GDockBookingKind, freightType?: GFreightType, referenceNumber: string, carrierName?: string, vendorName?: string, originName?: string, expectedDate?: any, contactName?: string, contactEmail?: string, contactPhone?: string, confirmationEmail?: string, confirmationNumber?: string, palletCount?: number, weightLbs?: number, scacCode?: string, deliveryType?: GDeliveryType, shipDate?: any, proNumber?: string, comments?: string, truckNumber?: string, slotStartsAt?: any, slotEndsAt?: any, slotLabel?: string, windowMinutes?: number, createdAt: any, bookedAt?: any, dock?: { __typename?: 'Dock', id: string, name: string }, rescheduledTo?: { __typename?: 'DockBooking', id: string }, rescheduledFrom?: { __typename?: 'DockBooking', id: string, referenceNumber: string, status: GDockBookingStatus, expectedDate?: any, slotLabel?: string }, visits: Array<{ __typename?: 'DockVisit', id: string, checkedInAt: any, checkedInVia?: GDockVisitCheckedInVia, departedAt?: any, dwellSeconds?: number, detentionSeconds?: number, truckNumber?: string, dock?: { __typename?: 'Dock', id: string, name: string } }> };

export type GGetDocksQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
}>;


export type GGetDocksQuery = { __typename?: 'Query', docks: Array<{ __typename?: 'Dock', id: string, name: string, active: boolean, windows: Array<{ __typename?: 'DockWindow', id: string, openTime: string, closeTime: string, ftlMax: number, ltlMax: number }> }> };

export type GCreateDockMutationVariables = Exact<{
  input: GDockCreateInput;
}>;


export type GCreateDockMutation = { __typename?: 'Mutation', dockCreate?: { __typename?: 'DockCreatePayload', dock?: { __typename?: 'Dock', id: string, name: string, active: boolean, windows: Array<{ __typename?: 'DockWindow', id: string, openTime: string, closeTime: string, ftlMax: number, ltlMax: number }> }, userErrors: Array<{ __typename?: 'AdHocAppointmentsNotAllowed', errorCode: string, message: string } | { __typename?: 'AppointmentInPast', errorCode: string, message: string } | { __typename?: 'CarrierNameRequired', errorCode: string, message: string } | { __typename?: 'CheckInNotAllowed', errorCode: string, message: string } | { __typename?: 'ContactDetailsRequired', errorCode: string, message: string } | { __typename?: 'DailyDeliveryExists' } | { __typename?: 'DepartNotAllowed', errorCode: string, message: string } | { __typename?: 'DockBookingAlreadyCompleted', errorCode: string, message: string } | { __typename?: 'DockBookingAlreadyMissed' } | { __typename?: 'DockBookingNotBooked', errorCode: string, message: string } | { __typename?: 'DockBookingNotFound', errorCode: string, message: string } | { __typename?: 'DockBookingWarehouseNotFound', errorCode: string, message: string } | { __typename?: 'DockCapacityInvalid', errorCode: string, message: string } | { __typename?: 'DockInUse', errorCode: string, message: string } | { __typename?: 'DockNotFound', errorCode: string, message: string } | { __typename?: 'DockOverrideCodeInactive' } | { __typename?: 'DockReassignNotAllowed' } | { __typename?: 'DockRecoveryNotAllowed' } | { __typename?: 'DockSlotUnavailable', errorCode: string, message: string } | { __typename?: 'DockVisitNotFound', errorCode: string, message: string } | { __typename?: 'OverrideCodeIssueConflict' } | { __typename?: 'OverrideCodeNotFound' } | { __typename?: 'OverrideVendorNotFound' } | { __typename?: 'ShipDateRequired', errorCode: string, message: string } | { __typename?: 'WithinLeadTime', errorCode: string, message: string }> } };

export type GUpdateDockMutationVariables = Exact<{
  input: GDockUpdateInput;
}>;


export type GUpdateDockMutation = { __typename?: 'Mutation', dockUpdate?: { __typename?: 'DockUpdatePayload', dock?: { __typename?: 'Dock', id: string, name: string, active: boolean, windows: Array<{ __typename?: 'DockWindow', id: string, openTime: string, closeTime: string, ftlMax: number, ltlMax: number }> }, userErrors: Array<{ __typename?: 'AdHocAppointmentsNotAllowed', errorCode: string, message: string } | { __typename?: 'AppointmentInPast', errorCode: string, message: string } | { __typename?: 'CarrierNameRequired', errorCode: string, message: string } | { __typename?: 'CheckInNotAllowed', errorCode: string, message: string } | { __typename?: 'ContactDetailsRequired', errorCode: string, message: string } | { __typename?: 'DailyDeliveryExists' } | { __typename?: 'DepartNotAllowed', errorCode: string, message: string } | { __typename?: 'DockBookingAlreadyCompleted', errorCode: string, message: string } | { __typename?: 'DockBookingAlreadyMissed' } | { __typename?: 'DockBookingNotBooked', errorCode: string, message: string } | { __typename?: 'DockBookingNotFound', errorCode: string, message: string } | { __typename?: 'DockBookingWarehouseNotFound', errorCode: string, message: string } | { __typename?: 'DockCapacityInvalid', errorCode: string, message: string } | { __typename?: 'DockInUse', errorCode: string, message: string } | { __typename?: 'DockNotFound', errorCode: string, message: string } | { __typename?: 'DockOverrideCodeInactive' } | { __typename?: 'DockReassignNotAllowed' } | { __typename?: 'DockRecoveryNotAllowed' } | { __typename?: 'DockSlotUnavailable', errorCode: string, message: string } | { __typename?: 'DockVisitNotFound', errorCode: string, message: string } | { __typename?: 'OverrideCodeIssueConflict' } | { __typename?: 'OverrideCodeNotFound' } | { __typename?: 'OverrideVendorNotFound' } | { __typename?: 'ShipDateRequired', errorCode: string, message: string } | { __typename?: 'WithinLeadTime', errorCode: string, message: string }> } };

export type GDeleteDockMutationVariables = Exact<{
  input: GDockDeleteInput;
}>;


export type GDeleteDockMutation = { __typename?: 'Mutation', dockDelete?: { __typename?: 'DockDeletePayload', deletedDockId?: string, userErrors: Array<{ __typename?: 'AdHocAppointmentsNotAllowed', errorCode: string, message: string } | { __typename?: 'AppointmentInPast', errorCode: string, message: string } | { __typename?: 'CarrierNameRequired', errorCode: string, message: string } | { __typename?: 'CheckInNotAllowed', errorCode: string, message: string } | { __typename?: 'ContactDetailsRequired', errorCode: string, message: string } | { __typename?: 'DailyDeliveryExists' } | { __typename?: 'DepartNotAllowed', errorCode: string, message: string } | { __typename?: 'DockBookingAlreadyCompleted', errorCode: string, message: string } | { __typename?: 'DockBookingAlreadyMissed' } | { __typename?: 'DockBookingNotBooked', errorCode: string, message: string } | { __typename?: 'DockBookingNotFound', errorCode: string, message: string } | { __typename?: 'DockBookingWarehouseNotFound', errorCode: string, message: string } | { __typename?: 'DockCapacityInvalid', errorCode: string, message: string } | { __typename?: 'DockInUse', errorCode: string, message: string } | { __typename?: 'DockNotFound', errorCode: string, message: string } | { __typename?: 'DockOverrideCodeInactive' } | { __typename?: 'DockReassignNotAllowed' } | { __typename?: 'DockRecoveryNotAllowed' } | { __typename?: 'DockSlotUnavailable', errorCode: string, message: string } | { __typename?: 'DockVisitNotFound', errorCode: string, message: string } | { __typename?: 'OverrideCodeIssueConflict' } | { __typename?: 'OverrideCodeNotFound' } | { __typename?: 'OverrideVendorNotFound' } | { __typename?: 'ShipDateRequired', errorCode: string, message: string } | { __typename?: 'WithinLeadTime', errorCode: string, message: string }> } };

export type GGetDockWarehouseClosedDaysQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
}>;


export type GGetDockWarehouseClosedDaysQuery = { __typename?: 'Query', dockWarehouseClosedDays: Array<number> };

export type GWarehouseUpdateClosedDaysMutationVariables = Exact<{
  input: GWarehouseUpdateClosedDaysInput;
}>;


export type GWarehouseUpdateClosedDaysMutation = { __typename?: 'Mutation', warehouseUpdateClosedDays?: { __typename?: 'WarehouseUpdateClosedDaysPayload', blockedWeekdays?: Array<number>, userErrors: Array<{ __typename?: 'AdHocAppointmentsNotAllowed', errorCode: string, message: string } | { __typename?: 'AppointmentInPast', errorCode: string, message: string } | { __typename?: 'CarrierNameRequired', errorCode: string, message: string } | { __typename?: 'CheckInNotAllowed', errorCode: string, message: string } | { __typename?: 'ContactDetailsRequired', errorCode: string, message: string } | { __typename?: 'DailyDeliveryExists' } | { __typename?: 'DepartNotAllowed', errorCode: string, message: string } | { __typename?: 'DockBookingAlreadyCompleted', errorCode: string, message: string } | { __typename?: 'DockBookingAlreadyMissed' } | { __typename?: 'DockBookingNotBooked', errorCode: string, message: string } | { __typename?: 'DockBookingNotFound', errorCode: string, message: string } | { __typename?: 'DockBookingWarehouseNotFound', errorCode: string, message: string } | { __typename?: 'DockCapacityInvalid', errorCode: string, message: string } | { __typename?: 'DockInUse', errorCode: string, message: string } | { __typename?: 'DockNotFound', errorCode: string, message: string } | { __typename?: 'DockOverrideCodeInactive' } | { __typename?: 'DockReassignNotAllowed' } | { __typename?: 'DockRecoveryNotAllowed' } | { __typename?: 'DockSlotUnavailable', errorCode: string, message: string } | { __typename?: 'DockVisitNotFound', errorCode: string, message: string } | { __typename?: 'OverrideCodeIssueConflict' } | { __typename?: 'OverrideCodeNotFound' } | { __typename?: 'OverrideVendorNotFound' } | { __typename?: 'ShipDateRequired', errorCode: string, message: string } | { __typename?: 'WithinLeadTime', errorCode: string, message: string }> } };

export type GGetDockWarehouseCapacityQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
}>;


export type GGetDockWarehouseCapacityQuery = { __typename?: 'Query', dockWarehouseCapacity?: { __typename?: 'WarehouseDockCapacity', ftlTrucksPerDay: number, ltlTrucksPerDay: number, ftlMinPerDay: number, ltlMinPerDay: number } };

export type GWarehouseUpdateDailyCapacityMutationVariables = Exact<{
  input: GWarehouseUpdateDailyCapacityInput;
}>;


export type GWarehouseUpdateDailyCapacityMutation = { __typename?: 'Mutation', warehouseUpdateDailyCapacity?: { __typename?: 'WarehouseUpdateDailyCapacityPayload', capacity?: { __typename?: 'WarehouseDockCapacity', ftlTrucksPerDay: number, ltlTrucksPerDay: number, ftlMinPerDay: number, ltlMinPerDay: number }, userErrors: Array<{ __typename?: 'AdHocAppointmentsNotAllowed', errorCode: string, message: string } | { __typename?: 'AppointmentInPast', errorCode: string, message: string } | { __typename?: 'CarrierNameRequired', errorCode: string, message: string } | { __typename?: 'CheckInNotAllowed', errorCode: string, message: string } | { __typename?: 'ContactDetailsRequired', errorCode: string, message: string } | { __typename?: 'DailyDeliveryExists' } | { __typename?: 'DepartNotAllowed', errorCode: string, message: string } | { __typename?: 'DockBookingAlreadyCompleted', errorCode: string, message: string } | { __typename?: 'DockBookingAlreadyMissed' } | { __typename?: 'DockBookingNotBooked', errorCode: string, message: string } | { __typename?: 'DockBookingNotFound', errorCode: string, message: string } | { __typename?: 'DockBookingWarehouseNotFound', errorCode: string, message: string } | { __typename?: 'DockCapacityInvalid', errorCode: string, message: string } | { __typename?: 'DockInUse', errorCode: string, message: string } | { __typename?: 'DockNotFound', errorCode: string, message: string } | { __typename?: 'DockOverrideCodeInactive' } | { __typename?: 'DockReassignNotAllowed' } | { __typename?: 'DockRecoveryNotAllowed' } | { __typename?: 'DockSlotUnavailable', errorCode: string, message: string } | { __typename?: 'DockVisitNotFound', errorCode: string, message: string } | { __typename?: 'OverrideCodeIssueConflict' } | { __typename?: 'OverrideCodeNotFound' } | { __typename?: 'OverrideVendorNotFound' } | { __typename?: 'ShipDateRequired', errorCode: string, message: string } | { __typename?: 'WithinLeadTime', errorCode: string, message: string }> } };

export type GGetDockBookingsQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
  date: Scalars['ISO8601Date'];
}>;


export type GGetDockBookingsQuery = { __typename?: 'Query', dockBookings: Array<{ __typename?: 'DockBooking', id: string, token: string, status: GDockBookingStatus, bookingKind: GDockBookingKind, freightType?: GFreightType, referenceNumber: string, carrierName?: string, vendorName?: string, originName?: string, expectedDate?: any, contactName?: string, contactEmail?: string, contactPhone?: string, confirmationEmail?: string, confirmationNumber?: string, palletCount?: number, weightLbs?: number, scacCode?: string, deliveryType?: GDeliveryType, shipDate?: any, proNumber?: string, comments?: string, truckNumber?: string, slotStartsAt?: any, slotEndsAt?: any, slotLabel?: string, windowMinutes?: number, createdAt: any, bookedAt?: any, dock?: { __typename?: 'Dock', id: string, name: string }, rescheduledTo?: { __typename?: 'DockBooking', id: string }, rescheduledFrom?: { __typename?: 'DockBooking', id: string, referenceNumber: string, status: GDockBookingStatus, expectedDate?: any, slotLabel?: string }, visits: Array<{ __typename?: 'DockVisit', id: string, checkedInAt: any, checkedInVia?: GDockVisitCheckedInVia, departedAt?: any, dwellSeconds?: number, detentionSeconds?: number, truckNumber?: string, dock?: { __typename?: 'Dock', id: string, name: string } }> }> };

export type GGetDockBookingsRangeQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
  startDate: Scalars['ISO8601Date'];
  endDate: Scalars['ISO8601Date'];
}>;


export type GGetDockBookingsRangeQuery = { __typename?: 'Query', dockBookingsRange: Array<{ __typename?: 'DockBooking', id: string, token: string, status: GDockBookingStatus, bookingKind: GDockBookingKind, freightType?: GFreightType, referenceNumber: string, carrierName?: string, vendorName?: string, originName?: string, expectedDate?: any, contactName?: string, contactEmail?: string, contactPhone?: string, confirmationEmail?: string, confirmationNumber?: string, palletCount?: number, weightLbs?: number, scacCode?: string, deliveryType?: GDeliveryType, shipDate?: any, proNumber?: string, comments?: string, truckNumber?: string, slotStartsAt?: any, slotEndsAt?: any, slotLabel?: string, windowMinutes?: number, createdAt: any, bookedAt?: any, dock?: { __typename?: 'Dock', id: string, name: string }, rescheduledTo?: { __typename?: 'DockBooking', id: string }, rescheduledFrom?: { __typename?: 'DockBooking', id: string, referenceNumber: string, status: GDockBookingStatus, expectedDate?: any, slotLabel?: string }, visits: Array<{ __typename?: 'DockVisit', id: string, checkedInAt: any, checkedInVia?: GDockVisitCheckedInVia, departedAt?: any, dwellSeconds?: number, detentionSeconds?: number, truckNumber?: string, dock?: { __typename?: 'Dock', id: string, name: string } }> }> };

export type GCreateAdHocAppointmentMutationVariables = Exact<{
  input: GAdHocAppointmentCreateInput;
}>;


export type GCreateAdHocAppointmentMutation = { __typename?: 'Mutation', adHocAppointmentCreate?: { __typename?: 'AdHocAppointmentCreatePayload', booking?: { __typename?: 'DockBooking', id: string, referenceNumber: string, expectedDate?: any, slotLabel?: string, dock?: { __typename?: 'Dock', id: string, name: string } }, userErrors: Array<{ __typename?: 'AdHocAppointmentsNotAllowed', errorCode: string, message: string } | { __typename?: 'AppointmentInPast', errorCode: string, message: string } | { __typename?: 'CarrierNameRequired', errorCode: string, message: string } | { __typename?: 'CheckInNotAllowed', errorCode: string, message: string } | { __typename?: 'ContactDetailsRequired', errorCode: string, message: string } | { __typename?: 'DailyDeliveryExists' } | { __typename?: 'DepartNotAllowed', errorCode: string, message: string } | { __typename?: 'DockBookingAlreadyCompleted', errorCode: string, message: string } | { __typename?: 'DockBookingAlreadyMissed' } | { __typename?: 'DockBookingNotBooked', errorCode: string, message: string } | { __typename?: 'DockBookingNotFound', errorCode: string, message: string } | { __typename?: 'DockBookingWarehouseNotFound', errorCode: string, message: string } | { __typename?: 'DockCapacityInvalid', errorCode: string, message: string } | { __typename?: 'DockInUse', errorCode: string, message: string } | { __typename?: 'DockNotFound', errorCode: string, message: string } | { __typename?: 'DockOverrideCodeInactive' } | { __typename?: 'DockReassignNotAllowed' } | { __typename?: 'DockRecoveryNotAllowed' } | { __typename?: 'DockSlotUnavailable', errorCode: string, message: string } | { __typename?: 'DockVisitNotFound', errorCode: string, message: string } | { __typename?: 'OverrideCodeIssueConflict' } | { __typename?: 'OverrideCodeNotFound' } | { __typename?: 'OverrideVendorNotFound' } | { __typename?: 'ShipDateRequired', errorCode: string, message: string } | { __typename?: 'WithinLeadTime', errorCode: string, message: string }> } };

export type GGetDockBookingByReferenceQueryVariables = Exact<{
  referenceNumber: Scalars['String'];
}>;


export type GGetDockBookingByReferenceQuery = { __typename?: 'Query', dockBookingByReference?: { __typename?: 'DockBooking', id: string, expectedDate?: any, slotLabel?: string } };

export type GGetExpectedPurchaseOrdersQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
}>;


export type GGetExpectedPurchaseOrdersQuery = { __typename?: 'Query', expectedPurchaseOrders: Array<{ __typename?: 'ExpectedPurchaseOrder', tranId: string, vendorName?: string, status?: string, dueDate?: any }> };

export type GGetExpectedTransferOrdersQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
}>;


export type GGetExpectedTransferOrdersQuery = { __typename?: 'Query', expectedTransferOrders: Array<{ __typename?: 'ExpectedTransferOrder', tranId: string, originName?: string, status?: string, dueDate?: any }> };

export type GGetStandingAppointmentVendorsQueryVariables = Exact<{
  search: Scalars['String'];
}>;


export type GGetStandingAppointmentVendorsQuery = { __typename?: 'Query', standingAppointmentVendors: Array<{ __typename?: 'NetsuiteVendor', netsuiteInternalId: string, name?: string, displayName?: string }> };

export type GGetStandingAppointmentDirectoryQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
}>;


export type GGetStandingAppointmentDirectoryQuery = { __typename?: 'Query', standingAppointmentDirectory: Array<{ __typename?: 'StandingAppointmentDirectoryEntry', status: GStandingAppointmentDirectoryStatus, standingAppointment: { __typename?: 'StandingAppointment', id: string, vendorName: string, netsuiteInternalId: string, freightType: GFreightType, weekdays: Array<number>, earliestTime: string, latestTime: string, effectiveFrom: any, effectiveUntil: any } }> };

export type GGetStandingAppointmentGapDatesQueryVariables = Exact<{
  standingAppointmentId: Scalars['ID'];
}>;


export type GGetStandingAppointmentGapDatesQuery = { __typename?: 'Query', standingAppointmentGapDates: Array<any> };

type GStandingAppointmentErrorFields_DockBookingWarehouseNotFound_Fragment = { __typename?: 'DockBookingWarehouseNotFound', errorCode: string, message: string };

type GStandingAppointmentErrorFields_DockWindowNotFound_Fragment = { __typename?: 'DockWindowNotFound', errorCode: string, message: string };

type GStandingAppointmentErrorFields_StandingAppointmentAlreadyResolved_Fragment = { __typename?: 'StandingAppointmentAlreadyResolved', errorCode: string, message: string };

type GStandingAppointmentErrorFields_StandingAppointmentIdNotFound_Fragment = { __typename?: 'StandingAppointmentIdNotFound', errorCode: string, message: string };

type GStandingAppointmentErrorFields_StandingAppointmentInvalidDate_Fragment = { __typename?: 'StandingAppointmentInvalidDate', errorCode: string, message: string };

type GStandingAppointmentErrorFields_StandingAppointmentNotAllowed_Fragment = { __typename?: 'StandingAppointmentNotAllowed', errorCode: string, message: string };

type GStandingAppointmentErrorFields_StandingAppointmentNotFound_Fragment = { __typename?: 'StandingAppointmentNotFound', errorCode: string, message: string };

type GStandingAppointmentErrorFields_StandingAppointmentUnresolvable_Fragment = { __typename?: 'StandingAppointmentUnresolvable', errorCode: string, message: string };

export type GStandingAppointmentErrorFieldsFragment = GStandingAppointmentErrorFields_DockBookingWarehouseNotFound_Fragment | GStandingAppointmentErrorFields_DockWindowNotFound_Fragment | GStandingAppointmentErrorFields_StandingAppointmentAlreadyResolved_Fragment | GStandingAppointmentErrorFields_StandingAppointmentIdNotFound_Fragment | GStandingAppointmentErrorFields_StandingAppointmentInvalidDate_Fragment | GStandingAppointmentErrorFields_StandingAppointmentNotAllowed_Fragment | GStandingAppointmentErrorFields_StandingAppointmentNotFound_Fragment | GStandingAppointmentErrorFields_StandingAppointmentUnresolvable_Fragment;

export type GCreateStandingAppointmentMutationVariables = Exact<{
  input: GStandingAppointmentCreateInput;
}>;


export type GCreateStandingAppointmentMutation = { __typename?: 'Mutation', standingAppointmentCreate?: { __typename?: 'StandingAppointmentCreatePayload', failedDates: Array<any>, standingAppointment?: { __typename?: 'StandingAppointment', id: string, vendorName: string, weekdays: Array<number>, earliestTime: string, latestTime: string, effectiveFrom: any, effectiveUntil: any }, createdBookings: Array<{ __typename?: 'DockBooking', id: string }>, userErrors: Array<{ __typename?: 'DockBookingWarehouseNotFound', errorCode: string, message: string } | { __typename?: 'DockWindowNotFound', errorCode: string, message: string } | { __typename?: 'StandingAppointmentAlreadyResolved', errorCode: string, message: string } | { __typename?: 'StandingAppointmentIdNotFound', errorCode: string, message: string } | { __typename?: 'StandingAppointmentInvalidDate', errorCode: string, message: string } | { __typename?: 'StandingAppointmentNotAllowed', errorCode: string, message: string } | { __typename?: 'StandingAppointmentNotFound', errorCode: string, message: string } | { __typename?: 'StandingAppointmentUnresolvable', errorCode: string, message: string }> } };

export type GGetStandingAppointmentCandidateWindowsQueryVariables = Exact<{
  standingAppointmentId: Scalars['ID'];
  date: Scalars['ISO8601Date'];
}>;


export type GGetStandingAppointmentCandidateWindowsQuery = { __typename?: 'Query', standingAppointmentCandidateWindows: Array<{ __typename?: 'CandidateDockWindow', overCapBy: number, dock: { __typename?: 'Dock', id: string, name: string }, window: { __typename?: 'DockWindow', id: string, openTime: string } }> };

export type GResolveStandingAppointmentFailedDateMutationVariables = Exact<{
  input: GStandingAppointmentResolveFailedDateInput;
}>;


export type GResolveStandingAppointmentFailedDateMutation = { __typename?: 'Mutation', standingAppointmentResolveFailedDate?: { __typename?: 'StandingAppointmentResolveFailedDatePayload', userErrors: Array<{ __typename?: 'DockBookingWarehouseNotFound', errorCode: string, message: string } | { __typename?: 'DockWindowNotFound', errorCode: string, message: string } | { __typename?: 'StandingAppointmentAlreadyResolved', errorCode: string, message: string } | { __typename?: 'StandingAppointmentIdNotFound', errorCode: string, message: string } | { __typename?: 'StandingAppointmentInvalidDate', errorCode: string, message: string } | { __typename?: 'StandingAppointmentNotAllowed', errorCode: string, message: string } | { __typename?: 'StandingAppointmentNotFound', errorCode: string, message: string } | { __typename?: 'StandingAppointmentUnresolvable', errorCode: string, message: string }> } };

export type GGetStandingAppointmentHistoryQueryVariables = Exact<{
  netsuiteInternalId: Scalars['String'];
  warehouseId: Scalars['ID'];
}>;


export type GGetStandingAppointmentHistoryQuery = { __typename?: 'Query', standingAppointmentHistory: Array<{ __typename?: 'StandingAppointment', id: string, vendorName: string, netsuiteInternalId: string, freightType: GFreightType, weekdays: Array<number>, earliestTime: string, latestTime: string, effectiveFrom: any, effectiveUntil: any }> };

export type GUpdateStandingAppointmentEffectiveUntilMutationVariables = Exact<{
  input: GStandingAppointmentUpdateEffectiveUntilInput;
}>;


export type GUpdateStandingAppointmentEffectiveUntilMutation = { __typename?: 'Mutation', standingAppointmentUpdateEffectiveUntil?: { __typename?: 'StandingAppointmentUpdateEffectiveUntilPayload', failedDates: Array<any>, standingAppointment?: { __typename?: 'StandingAppointment', effectiveUntil: any }, createdBookings: Array<{ __typename?: 'DockBooking', id: string }>, cancelledBookings: Array<{ __typename?: 'DockBooking', id: string }>, userErrors: Array<{ __typename?: 'DockBookingWarehouseNotFound', errorCode: string, message: string } | { __typename?: 'DockWindowNotFound', errorCode: string, message: string } | { __typename?: 'StandingAppointmentAlreadyResolved', errorCode: string, message: string } | { __typename?: 'StandingAppointmentIdNotFound', errorCode: string, message: string } | { __typename?: 'StandingAppointmentInvalidDate', errorCode: string, message: string } | { __typename?: 'StandingAppointmentNotAllowed', errorCode: string, message: string } | { __typename?: 'StandingAppointmentNotFound', errorCode: string, message: string } | { __typename?: 'StandingAppointmentUnresolvable', errorCode: string, message: string }> } };

export type GCancelDockBookingMutationVariables = Exact<{
  input: GDockBookingCancelInput;
}>;


export type GCancelDockBookingMutation = { __typename?: 'Mutation', dockBookingCancel?: { __typename?: 'DockBookingCancelPayload', dockBooking?: { __typename?: 'DockBooking', id: string, token: string, status: GDockBookingStatus, bookingKind: GDockBookingKind, freightType?: GFreightType, referenceNumber: string, carrierName?: string, vendorName?: string, originName?: string, expectedDate?: any, contactName?: string, contactEmail?: string, contactPhone?: string, confirmationEmail?: string, confirmationNumber?: string, palletCount?: number, weightLbs?: number, scacCode?: string, deliveryType?: GDeliveryType, shipDate?: any, proNumber?: string, comments?: string, truckNumber?: string, slotStartsAt?: any, slotEndsAt?: any, slotLabel?: string, windowMinutes?: number, createdAt: any, bookedAt?: any, dock?: { __typename?: 'Dock', id: string, name: string }, rescheduledTo?: { __typename?: 'DockBooking', id: string }, rescheduledFrom?: { __typename?: 'DockBooking', id: string, referenceNumber: string, status: GDockBookingStatus, expectedDate?: any, slotLabel?: string }, visits: Array<{ __typename?: 'DockVisit', id: string, checkedInAt: any, checkedInVia?: GDockVisitCheckedInVia, departedAt?: any, dwellSeconds?: number, detentionSeconds?: number, truckNumber?: string, dock?: { __typename?: 'Dock', id: string, name: string } }> }, userErrors: Array<{ __typename?: 'AdHocAppointmentsNotAllowed', errorCode: string, message: string } | { __typename?: 'AppointmentInPast', errorCode: string, message: string } | { __typename?: 'CarrierNameRequired', errorCode: string, message: string } | { __typename?: 'CheckInNotAllowed', errorCode: string, message: string } | { __typename?: 'ContactDetailsRequired', errorCode: string, message: string } | { __typename?: 'DailyDeliveryExists' } | { __typename?: 'DepartNotAllowed', errorCode: string, message: string } | { __typename?: 'DockBookingAlreadyCompleted', errorCode: string, message: string } | { __typename?: 'DockBookingAlreadyMissed' } | { __typename?: 'DockBookingNotBooked', errorCode: string, message: string } | { __typename?: 'DockBookingNotFound', errorCode: string, message: string } | { __typename?: 'DockBookingWarehouseNotFound', errorCode: string, message: string } | { __typename?: 'DockCapacityInvalid', errorCode: string, message: string } | { __typename?: 'DockInUse', errorCode: string, message: string } | { __typename?: 'DockNotFound', errorCode: string, message: string } | { __typename?: 'DockOverrideCodeInactive' } | { __typename?: 'DockReassignNotAllowed' } | { __typename?: 'DockRecoveryNotAllowed' } | { __typename?: 'DockSlotUnavailable', errorCode: string, message: string } | { __typename?: 'DockVisitNotFound', errorCode: string, message: string } | { __typename?: 'OverrideCodeIssueConflict' } | { __typename?: 'OverrideCodeNotFound' } | { __typename?: 'OverrideVendorNotFound' } | { __typename?: 'ShipDateRequired', errorCode: string, message: string } | { __typename?: 'WithinLeadTime', errorCode: string, message: string }> } };

export type GMarkDockBookingMissedMutationVariables = Exact<{
  input: GDockBookingMarkMissedInput;
}>;


export type GMarkDockBookingMissedMutation = { __typename?: 'Mutation', dockBookingMarkMissed?: { __typename?: 'DockBookingMarkMissedPayload', dockBooking?: { __typename?: 'DockBooking', id: string, token: string, status: GDockBookingStatus, bookingKind: GDockBookingKind, freightType?: GFreightType, referenceNumber: string, carrierName?: string, vendorName?: string, originName?: string, expectedDate?: any, contactName?: string, contactEmail?: string, contactPhone?: string, confirmationEmail?: string, confirmationNumber?: string, palletCount?: number, weightLbs?: number, scacCode?: string, deliveryType?: GDeliveryType, shipDate?: any, proNumber?: string, comments?: string, truckNumber?: string, slotStartsAt?: any, slotEndsAt?: any, slotLabel?: string, windowMinutes?: number, createdAt: any, bookedAt?: any, dock?: { __typename?: 'Dock', id: string, name: string }, rescheduledTo?: { __typename?: 'DockBooking', id: string }, rescheduledFrom?: { __typename?: 'DockBooking', id: string, referenceNumber: string, status: GDockBookingStatus, expectedDate?: any, slotLabel?: string }, visits: Array<{ __typename?: 'DockVisit', id: string, checkedInAt: any, checkedInVia?: GDockVisitCheckedInVia, departedAt?: any, dwellSeconds?: number, detentionSeconds?: number, truckNumber?: string, dock?: { __typename?: 'Dock', id: string, name: string } }> }, userErrors: Array<{ __typename?: 'AdHocAppointmentsNotAllowed', errorCode: string, message: string } | { __typename?: 'AppointmentInPast', errorCode: string, message: string } | { __typename?: 'CarrierNameRequired', errorCode: string, message: string } | { __typename?: 'CheckInNotAllowed', errorCode: string, message: string } | { __typename?: 'ContactDetailsRequired', errorCode: string, message: string } | { __typename?: 'DailyDeliveryExists' } | { __typename?: 'DepartNotAllowed', errorCode: string, message: string } | { __typename?: 'DockBookingAlreadyCompleted', errorCode: string, message: string } | { __typename?: 'DockBookingAlreadyMissed' } | { __typename?: 'DockBookingNotBooked', errorCode: string, message: string } | { __typename?: 'DockBookingNotFound', errorCode: string, message: string } | { __typename?: 'DockBookingWarehouseNotFound', errorCode: string, message: string } | { __typename?: 'DockCapacityInvalid', errorCode: string, message: string } | { __typename?: 'DockInUse', errorCode: string, message: string } | { __typename?: 'DockNotFound', errorCode: string, message: string } | { __typename?: 'DockOverrideCodeInactive' } | { __typename?: 'DockReassignNotAllowed' } | { __typename?: 'DockRecoveryNotAllowed' } | { __typename?: 'DockSlotUnavailable', errorCode: string, message: string } | { __typename?: 'DockVisitNotFound', errorCode: string, message: string } | { __typename?: 'OverrideCodeIssueConflict' } | { __typename?: 'OverrideCodeNotFound' } | { __typename?: 'OverrideVendorNotFound' } | { __typename?: 'ShipDateRequired', errorCode: string, message: string } | { __typename?: 'WithinLeadTime', errorCode: string, message: string }> } };

export type GGetDockOpenVisitsQueryVariables = Exact<{
  dockId?: InputMaybe<Scalars['ID']>;
  warehouseId?: InputMaybe<Scalars['ID']>;
}>;


export type GGetDockOpenVisitsQuery = { __typename?: 'Query', dockOpenVisits?: Array<{ __typename?: 'DockVisit', id: string, checkedInAt: any, truckNumber?: string, freightType?: GFreightType, scacCode?: string, dock?: { __typename?: 'Dock', id: string, name: string }, booking?: { __typename?: 'DockBooking', referenceNumber: string, carrierName?: string } }> };

export type GDockVisitDepartMutationVariables = Exact<{
  input: GDockVisitDepartInput;
}>;


export type GDockVisitDepartMutation = { __typename?: 'Mutation', dockVisitDepart?: { __typename?: 'DockVisitDepartPayload', dockVisit?: { __typename?: 'DockVisit', id: string, departedAt?: any }, userErrors: Array<{ __typename?: 'AdHocAppointmentsNotAllowed', errorCode: string, message: string } | { __typename?: 'AppointmentInPast', errorCode: string, message: string } | { __typename?: 'CarrierNameRequired', errorCode: string, message: string } | { __typename?: 'CheckInNotAllowed', errorCode: string, message: string } | { __typename?: 'ContactDetailsRequired', errorCode: string, message: string } | { __typename?: 'DailyDeliveryExists' } | { __typename?: 'DepartNotAllowed', errorCode: string, message: string } | { __typename?: 'DockBookingAlreadyCompleted', errorCode: string, message: string } | { __typename?: 'DockBookingAlreadyMissed' } | { __typename?: 'DockBookingNotBooked', errorCode: string, message: string } | { __typename?: 'DockBookingNotFound', errorCode: string, message: string } | { __typename?: 'DockBookingWarehouseNotFound', errorCode: string, message: string } | { __typename?: 'DockCapacityInvalid', errorCode: string, message: string } | { __typename?: 'DockInUse', errorCode: string, message: string } | { __typename?: 'DockNotFound', errorCode: string, message: string } | { __typename?: 'DockOverrideCodeInactive' } | { __typename?: 'DockReassignNotAllowed' } | { __typename?: 'DockRecoveryNotAllowed' } | { __typename?: 'DockSlotUnavailable', errorCode: string, message: string } | { __typename?: 'DockVisitNotFound', errorCode: string, message: string } | { __typename?: 'OverrideCodeIssueConflict' } | { __typename?: 'OverrideCodeNotFound' } | { __typename?: 'OverrideVendorNotFound' } | { __typename?: 'ShipDateRequired', errorCode: string, message: string } | { __typename?: 'WithinLeadTime', errorCode: string, message: string }> } };

export type GDockBookingOpsCheckInMutationVariables = Exact<{
  input: GDockBookingOpsCheckInInput;
}>;


export type GDockBookingOpsCheckInMutation = { __typename?: 'Mutation', dockBookingOpsCheckIn?: { __typename?: 'DockBookingOpsCheckInPayload', booking?: { __typename?: 'DockBooking', id: string, token: string, status: GDockBookingStatus, bookingKind: GDockBookingKind, freightType?: GFreightType, referenceNumber: string, carrierName?: string, vendorName?: string, originName?: string, expectedDate?: any, contactName?: string, contactEmail?: string, contactPhone?: string, confirmationEmail?: string, confirmationNumber?: string, palletCount?: number, weightLbs?: number, scacCode?: string, deliveryType?: GDeliveryType, shipDate?: any, proNumber?: string, comments?: string, truckNumber?: string, slotStartsAt?: any, slotEndsAt?: any, slotLabel?: string, windowMinutes?: number, createdAt: any, bookedAt?: any, dock?: { __typename?: 'Dock', id: string, name: string }, rescheduledTo?: { __typename?: 'DockBooking', id: string }, rescheduledFrom?: { __typename?: 'DockBooking', id: string, referenceNumber: string, status: GDockBookingStatus, expectedDate?: any, slotLabel?: string }, visits: Array<{ __typename?: 'DockVisit', id: string, checkedInAt: any, checkedInVia?: GDockVisitCheckedInVia, departedAt?: any, dwellSeconds?: number, detentionSeconds?: number, truckNumber?: string, dock?: { __typename?: 'Dock', id: string, name: string } }> }, userErrors: Array<{ __typename?: 'AdHocAppointmentsNotAllowed', errorCode: string, message: string } | { __typename?: 'AppointmentInPast', errorCode: string, message: string } | { __typename?: 'CarrierNameRequired', errorCode: string, message: string } | { __typename?: 'CheckInNotAllowed', errorCode: string, message: string } | { __typename?: 'ContactDetailsRequired', errorCode: string, message: string } | { __typename?: 'DailyDeliveryExists' } | { __typename?: 'DepartNotAllowed', errorCode: string, message: string } | { __typename?: 'DockBookingAlreadyCompleted', errorCode: string, message: string } | { __typename?: 'DockBookingAlreadyMissed' } | { __typename?: 'DockBookingNotBooked', errorCode: string, message: string } | { __typename?: 'DockBookingNotFound', errorCode: string, message: string } | { __typename?: 'DockBookingWarehouseNotFound', errorCode: string, message: string } | { __typename?: 'DockCapacityInvalid', errorCode: string, message: string } | { __typename?: 'DockInUse', errorCode: string, message: string } | { __typename?: 'DockNotFound', errorCode: string, message: string } | { __typename?: 'DockOverrideCodeInactive' } | { __typename?: 'DockReassignNotAllowed' } | { __typename?: 'DockRecoveryNotAllowed' } | { __typename?: 'DockSlotUnavailable', errorCode: string, message: string } | { __typename?: 'DockVisitNotFound', errorCode: string, message: string } | { __typename?: 'OverrideCodeIssueConflict' } | { __typename?: 'OverrideCodeNotFound' } | { __typename?: 'OverrideVendorNotFound' } | { __typename?: 'ShipDateRequired', errorCode: string, message: string } | { __typename?: 'WithinLeadTime', errorCode: string, message: string }> } };

export type GGetDockBookingCanAddPoQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GGetDockBookingCanAddPoQuery = { __typename?: 'Query', dockBooking?: { __typename?: 'DockBooking', id: string, canAddPo: boolean } };

export type GDockBookingAddPoMutationVariables = Exact<{
  input: GDockBookingAddPoInput;
}>;


export type GDockBookingAddPoMutation = { __typename?: 'Mutation', dockBookingAddPo?: { __typename?: 'DockBookingAddPoPayload', booking?: { __typename?: 'DockBooking', id: string, token: string, status: GDockBookingStatus, bookingKind: GDockBookingKind, freightType?: GFreightType, referenceNumber: string, carrierName?: string, vendorName?: string, originName?: string, expectedDate?: any, contactName?: string, contactEmail?: string, contactPhone?: string, confirmationEmail?: string, confirmationNumber?: string, palletCount?: number, weightLbs?: number, scacCode?: string, deliveryType?: GDeliveryType, shipDate?: any, proNumber?: string, comments?: string, truckNumber?: string, slotStartsAt?: any, slotEndsAt?: any, slotLabel?: string, windowMinutes?: number, createdAt: any, bookedAt?: any, dock?: { __typename?: 'Dock', id: string, name: string }, rescheduledTo?: { __typename?: 'DockBooking', id: string }, rescheduledFrom?: { __typename?: 'DockBooking', id: string, referenceNumber: string, status: GDockBookingStatus, expectedDate?: any, slotLabel?: string }, visits: Array<{ __typename?: 'DockVisit', id: string, checkedInAt: any, checkedInVia?: GDockVisitCheckedInVia, departedAt?: any, slotStartsAt?: any, dwellSeconds?: number, detentionSeconds?: number, truckNumber?: string, dock?: { __typename?: 'Dock', id: string, name: string } }> }, userErrors: Array<{ __typename?: 'AdHocAppointmentsNotAllowed', errorCode: string, message: string } | { __typename?: 'AppointmentInPast', errorCode: string, message: string } | { __typename?: 'CarrierNameRequired', errorCode: string, message: string } | { __typename?: 'CheckInNotAllowed', errorCode: string, message: string } | { __typename?: 'ContactDetailsRequired', errorCode: string, message: string } | { __typename?: 'DailyDeliveryExists' } | { __typename?: 'DepartNotAllowed', errorCode: string, message: string } | { __typename?: 'DockBookingAlreadyCompleted', errorCode: string, message: string } | { __typename?: 'DockBookingAlreadyMissed' } | { __typename?: 'DockBookingNotBooked', errorCode: string, message: string } | { __typename?: 'DockBookingNotFound', errorCode: string, message: string } | { __typename?: 'DockBookingWarehouseNotFound', errorCode: string, message: string } | { __typename?: 'DockCapacityInvalid', errorCode: string, message: string } | { __typename?: 'DockInUse', errorCode: string, message: string } | { __typename?: 'DockNotFound', errorCode: string, message: string } | { __typename?: 'DockOverrideCodeInactive' } | { __typename?: 'DockReassignNotAllowed' } | { __typename?: 'DockRecoveryNotAllowed' } | { __typename?: 'DockSlotUnavailable', errorCode: string, message: string } | { __typename?: 'DockVisitNotFound', errorCode: string, message: string } | { __typename?: 'OverrideCodeIssueConflict' } | { __typename?: 'OverrideCodeNotFound' } | { __typename?: 'OverrideVendorNotFound' } | { __typename?: 'ShipDateRequired', errorCode: string, message: string } | { __typename?: 'WithinLeadTime', errorCode: string, message: string }> } };

export type GEscalateStopsToProviderMutationVariables = Exact<{
  input: GEscalateStopsToProviderInput;
}>;


export type GEscalateStopsToProviderMutation = { __typename?: 'Mutation', escalateStopsToProvider?: { __typename?: 'EscalateStopsToProviderPayload', route?: { __typename?: 'Route', id: string, name: string, nightEnd: any, thirdPartyProvider?: GThirdPartyProvider, redeliveryStops: Array<{ __typename?: 'Redelivery', id: string, deliveryStatusDmp: GDeliveryStatusDmp, deliveryStop: { __typename?: 'Delivery', id: string } }> }, userErrors: Array<{ __typename: 'DispatchNotAllowed', message: string } | { __typename: 'DispatchProfileIncomplete', message: string } | { __typename: 'ProviderNotAvailable', message: string } | { __typename: 'ProviderRejected', message: string } | { __typename: 'RouteNotFound', message: string } | { __typename: 'RouteNotMarkable', message: string } | { __typename: 'StopsNotEscalatable', message: string } | { __typename: 'UnmarkNotAllowed', message: string }> } };

export type GAddressFragmentFragment = { __typename?: 'Address', addressLine1: string, addressLine2?: string, city: string, postalCode: string, state: string };

export type GDeliveryFragmentFragment = { __typename?: 'Delivery', id: string, sequenceNumber?: string, totalWeight?: number, totalVolume?: number, deliveryNote?: string, completedAt?: any, location?: { __typename?: 'Location', effectivelyExcluded: boolean, displayAddress: string, id: string, membershipTier: GLocationMembershipTier, includeInAutomatedRouting?: boolean, businessName: string, isDoordash: boolean, scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, address: { __typename?: 'Address', latitude?: number, longitude?: number, state: string }, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', startTime: string, endTime: string }, routingCohort?: { __typename?: 'RoutingCohort', id: string, color?: string, name: string }, warehouseDeliveryRules: Array<{ __typename?: 'DeliveryRule', deliveryDay: number }> }, orders?: Array<{ __typename?: 'Order', id: string, deliveryMethod: GOrderDeliveryMethodEnum, scheduledDeliveryTime?: { __typename?: 'ScheduledDeliveryTime', earliest: string, latest: string, timeZone: string } }>, providerDelivery?: { __typename?: 'ProviderDelivery', status?: string, courierAssigned: boolean, courierName?: string, dropoffEta?: any, trackingUrl?: string, proofUrls: Array<string>, needsAttention: boolean, needsAttentionReason?: string }, route: { __typename?: 'Route', id: string, name: string, truck?: { __typename?: 'Truck', maxWeight: number, maxVolume: number, vin?: string, vehicleTag?: string } } };

export type GPickUpFragmentFragment = { __typename?: 'PickUp', id: string, sequenceNumber?: string, vendor: { __typename?: 'Vendor', name: string, legalName: string, address?: { __typename?: 'Address', latitude?: number, longitude?: number, state: string } } };

export type GRedeliveryFragmentFragment = { __typename?: 'Redelivery', id: string, sequenceNumber?: string, deliveryStop: { __typename?: 'Delivery', id: string }, location?: { __typename?: 'Location', effectivelyExcluded: boolean, displayAddress: string, id: string, includeInAutomatedRouting?: boolean, businessName: string, isDoordash: boolean, scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, address: { __typename?: 'Address', latitude?: number, longitude?: number, state: string }, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', startTime: string, endTime: string }, routingCohort?: { __typename?: 'RoutingCohort', id: string, color?: string, name: string }, warehouseDeliveryRules: Array<{ __typename?: 'DeliveryRule', deliveryDay: number }> }, orders?: Array<{ __typename?: 'Order', id: string, deliveryMethod: GOrderDeliveryMethodEnum, scheduledDeliveryTime?: { __typename?: 'ScheduledDeliveryTime', earliest: string, latest: string, timeZone: string } }>, providerDelivery?: { __typename?: 'ProviderDelivery', status?: string, courierAssigned: boolean, courierName?: string, dropoffEta?: any, trackingUrl?: string, proofUrls: Array<string>, needsAttention: boolean, needsAttentionReason?: string }, route: { __typename?: 'Route', id: string, name: string, truck?: { __typename?: 'Truck', maxWeight: number, maxVolume: number, vin?: string, vehicleTag?: string } } };

export type GRouteFragmentFragment = { __typename?: 'Route', color?: string, id: string, name: string, isLobby: boolean, thirdPartyRoute: boolean, thirdPartyProvider?: GThirdPartyProvider, bucketRoute: boolean, customerPickupRoute: boolean, nightEnd: any, nightEndLocked: boolean, stopTime?: any, totalVolume?: number, totalWeight?: number, percentItemsWithWeight?: number, percentItemsWithVolume?: number, redeliveryRoute: boolean, routeOrigin?: string, routeCohort?: string, shiftType?: string, providerDispatch?: { __typename?: 'ProviderDispatch', status: GProviderDispatchStatus, pickupAt?: any, error?: string, courierAlertSentAt?: any, cancelRequestedAt?: any, cancelable: boolean, unmarkable: boolean, chosenQuote?: { __typename?: 'ProviderQuote', id: string, provider?: string, cost?: number, fee?: number } }, stops?: Array<{ __typename: 'Delivery', id: string, sequenceNumber?: string, totalWeight?: number, totalVolume?: number, deliveryNote?: string, completedAt?: any, location?: { __typename?: 'Location', effectivelyExcluded: boolean, displayAddress: string, id: string, membershipTier: GLocationMembershipTier, includeInAutomatedRouting?: boolean, businessName: string, isDoordash: boolean, scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, address: { __typename?: 'Address', latitude?: number, longitude?: number, state: string }, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', startTime: string, endTime: string }, routingCohort?: { __typename?: 'RoutingCohort', id: string, color?: string, name: string }, warehouseDeliveryRules: Array<{ __typename?: 'DeliveryRule', deliveryDay: number }> }, orders?: Array<{ __typename?: 'Order', id: string, deliveryMethod: GOrderDeliveryMethodEnum, scheduledDeliveryTime?: { __typename?: 'ScheduledDeliveryTime', earliest: string, latest: string, timeZone: string } }>, providerDelivery?: { __typename?: 'ProviderDelivery', status?: string, courierAssigned: boolean, courierName?: string, dropoffEta?: any, trackingUrl?: string, proofUrls: Array<string>, needsAttention: boolean, needsAttentionReason?: string }, route: { __typename?: 'Route', id: string, name: string, truck?: { __typename?: 'Truck', maxWeight: number, maxVolume: number, vin?: string, vehicleTag?: string } } } | { __typename: 'PickUp', id: string, sequenceNumber?: string, vendor: { __typename?: 'Vendor', name: string, legalName: string, address?: { __typename?: 'Address', latitude?: number, longitude?: number, state: string } } }>, redeliveryStops: Array<{ __typename?: 'Redelivery', id: string, sequenceNumber?: string, deliveryStop: { __typename?: 'Delivery', id: string }, location?: { __typename?: 'Location', effectivelyExcluded: boolean, displayAddress: string, id: string, includeInAutomatedRouting?: boolean, businessName: string, isDoordash: boolean, scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, address: { __typename?: 'Address', latitude?: number, longitude?: number, state: string }, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', startTime: string, endTime: string }, routingCohort?: { __typename?: 'RoutingCohort', id: string, color?: string, name: string }, warehouseDeliveryRules: Array<{ __typename?: 'DeliveryRule', deliveryDay: number }> }, orders?: Array<{ __typename?: 'Order', id: string, deliveryMethod: GOrderDeliveryMethodEnum, scheduledDeliveryTime?: { __typename?: 'ScheduledDeliveryTime', earliest: string, latest: string, timeZone: string } }>, providerDelivery?: { __typename?: 'ProviderDelivery', status?: string, courierAssigned: boolean, courierName?: string, dropoffEta?: any, trackingUrl?: string, proofUrls: Array<string>, needsAttention: boolean, needsAttentionReason?: string }, route: { __typename?: 'Route', id: string, name: string, truck?: { __typename?: 'Truck', maxWeight: number, maxVolume: number, vin?: string, vehicleTag?: string } } }>, driverUser?: { __typename?: 'User', id: string, name?: string, email?: string }, helperDriverUser?: { __typename?: 'User', id: string, name?: string, email?: string }, truck?: { __typename?: 'Truck', maxVolume: number, maxWeight: number, vin?: string, vehicleTag?: string }, plannedVehicle?: { __typename?: 'PlannedVehicle', maxVolume?: number, maxWeight?: number, vehicleType?: string } };

export type GIssueFragmentFragment = { __typename?: 'Issue', id: string, note?: string, type?: string, description?: string };

export type GOrderLineFragmentFragment = { __typename?: 'OrderLine', id: string, orderUnitQuantity: number, deliveredQuantity?: number, quantityType: string, itemsPerLot: number, fulfillmentQuantity?: number, unitCostCents: number, isMarketPriced: boolean, isPounds: boolean, orderedWeightLb?: number, unitWeightLb?: number, totalWeightLb?: number, sku: { __typename?: 'Sku', id: string, name: string, refrigerationState: string, categoryName: string, subcategoryName: string, item?: { __typename?: 'InventoryItem', category: { __typename?: 'Category', name: string } } | { __typename?: 'NonInventoryItem', category: { __typename?: 'Category', name: string } } } };

export type GOrderFragmentFragment = { __typename?: 'Order', totalItemQuantity: number, totalCostCents: number, totalCogsCents: number, totalFeesCents: number };

export type GOrderDetailsFragmentFragment = { __typename?: 'Order', id: string, deliveredAt?: any, partiallyDelivered: boolean, totalItemQuantity: number, vendor: { __typename?: 'Vendor', isWarehouse: boolean }, appliedFees: Array<{ __typename?: 'OrderFee', feeId: string, feeAmountCents: number }>, scheduledDeliveryTime?: { __typename?: 'ScheduledDeliveryTime', earliest: string, latest: string, timeZone: string }, orderLines: Array<{ __typename?: 'OrderLine', orderUnitQuantity: number, unitCostCents: number, sku: { __typename?: 'Sku', id: string, item?: { __typename?: 'InventoryItem', id: string, purchasePrice: { __typename?: 'Money', cents: number }, purchaseUnit: { __typename?: 'Unit', id: string, conversionRate: number }, saleUnit: { __typename?: 'Unit', id: string, conversionRate: number } } | { __typename?: 'NonInventoryItem', id: string, purchasePrice: { __typename?: 'Money', cents: number } } } }> };

export type GGetAllStopStatusesQueryVariables = Exact<{
  input: GRoutesInput;
}>;


export type GGetAllStopStatusesQuery = { __typename?: 'Query', routes: Array<{ __typename?: 'Route', id: string, stops?: Array<{ __typename?: 'Delivery', id: string, deliveryStatusDmp: GDeliveryStatusDmp, compostCollectionRequired?: boolean, compostCollectedAt?: any, donationRequired?: boolean, donationCollectedAt?: any, deliveryNote?: string, reminderMessage?: string, hasRepeatedAccessIssues: boolean, isFirstDelivery: boolean, location?: { __typename?: 'Location', effectivelyExcluded: boolean }, issues?: Array<{ __typename?: 'Issue', id: string, note?: string, type?: string, description?: string }>, orders?: Array<{ __typename?: 'Order', id: string, warehouseNote?: string, deliveredAt?: any, partiallyDelivered: boolean, itemLevelTracking: boolean, deliveryMethod: GOrderDeliveryMethodEnum, location: { __typename?: 'Location', membershipTier: GLocationMembershipTier, scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, isDoordash: boolean, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', startTime: string, endTime: string } }, issues?: Array<{ __typename?: 'Issue', id: string, note?: string, type?: string, description?: string }>, vendor: { __typename?: 'Vendor', name: string, legalName: string, isWarehouse: boolean }, orderLines: Array<{ __typename?: 'OrderLine', id: string, sku: { __typename?: 'Sku', id: string, refrigerationState: string, categoryName: string, subcategoryName: string } }>, scheduledDeliveryTime?: { __typename?: 'ScheduledDeliveryTime', earliest: string, latest: string, timeZone: string } }>, tasks?: Array<{ __typename?: 'DeliveryRouteStopTask', id: string, status: GDeliveryRouteStopTaskStatus }> } | { __typename?: 'PickUp', id: string, deliveryStatusDmp: GDeliveryStatusDmp, reminderMessage?: string, issues?: Array<{ __typename?: 'Issue', id: string, note?: string, type?: string, description?: string }>, orders?: Array<{ __typename?: 'Order', id: string, warehouseNote?: string, collectedAt?: any, location: { __typename?: 'Location', membershipTier: GLocationMembershipTier, scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', startTime: string, endTime: string } }, issues?: Array<{ __typename?: 'Issue', id: string, note?: string, type?: string, description?: string }> }> }>, redeliveryStops: Array<{ __typename?: 'Redelivery', id: string, deliveryStatusDmp: GDeliveryStatusDmp, hasRepeatedAccessIssues: boolean, reminderMessage?: string, location?: { __typename?: 'Location', effectivelyExcluded: boolean }, deliveryStop: { __typename?: 'Delivery', id: string }, issues?: Array<{ __typename?: 'Issue', id: string, note?: string, type?: string, description?: string }>, orders?: Array<{ __typename?: 'Order', id: string, warehouseNote?: string, itemLevelTracking: boolean, deliveryMethod: GOrderDeliveryMethodEnum, location: { __typename?: 'Location', membershipTier: GLocationMembershipTier, scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, isDoordash: boolean, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', startTime: string, endTime: string } }, scheduledDeliveryTime?: { __typename?: 'ScheduledDeliveryTime', earliest: string, latest: string, timeZone: string }, issues?: Array<{ __typename?: 'Issue', id: string, note?: string, type?: string, description?: string }>, vendor: { __typename?: 'Vendor', name: string, legalName: string, isWarehouse: boolean }, orderLines: Array<{ __typename?: 'OrderLine', id: string, sku: { __typename?: 'Sku', id: string, refrigerationState: string, categoryName: string, subcategoryName: string } }> }> }> }> };

export type GGetBulkItemsQueryVariables = Exact<{
  input: GWarehouseBulkPickedItemsInput;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type GGetBulkItemsQuery = { __typename?: 'Query', warehouseBulkPickedItems: { __typename?: 'WarehouseBulkPickedItemsConnection', nodes?: Array<{ __typename?: 'InventoryItem', id: string, name: string } | { __typename?: 'NonInventoryItem', id: string, name: string }> } };

export type GGetCohortsQueryVariables = Exact<{
  routePlanInput: GRoutingImportPlanInput;
}>;


export type GGetCohortsQuery = { __typename?: 'Query', routingImportPlan: { __typename?: 'RoutingImportPlan', cohorts?: Array<{ __typename?: 'RoutingPlanCohort', color?: string, id: string, name: string }> } };

export type GGetCsvDataQueryVariables = Exact<{
  input: GRoutesInput;
}>;


export type GGetCsvDataQuery = { __typename?: 'Query', routes: Array<{ __typename?: 'Route', id: string, name: string, routeOrigin?: string, routeCohort?: string, stops?: Array<{ __typename: 'Delivery', id: string, sequenceNumber?: string, location?: { __typename?: 'Location', id: string, businessName: string, scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, address: { __typename?: 'Address', addressLine1: string, addressLine2?: string, city: string, state: string, postalCode: string }, membershipStatus: { __typename?: 'LocationMembershipStatus', tier: GLocationMembershipStatusTier }, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', endTime: string, startTime: string } }, orders?: Array<{ __typename?: 'Order', id: string, orderNumber: string, deliveryDate: any, orderLines: Array<{ __typename?: 'OrderLine', id: string, orderUnitQuantity: number, fulfillmentQuantity?: number, unitCostCents: number, sku: { __typename?: 'Sku', id: string, displayName: string, refrigerationState: string, item?: { __typename?: 'InventoryItem', id: string } | { __typename?: 'NonInventoryItem', id: string } } }>, vendor: { __typename?: 'Vendor', id: string, name: string, legalName: string, isWarehouse: boolean }, scheduledDeliveryTime?: { __typename?: 'ScheduledDeliveryTime', earliest: string, latest: string, timeZone: string } }> } | { __typename: 'PickUp', id: string }> }> };

export type GGetDeliveryPhotosQueryVariables = Exact<{
  input: GStopInput;
}>;


export type GGetDeliveryPhotosQuery = { __typename?: 'Query', stop: { __typename?: 'Delivery', attachments?: Array<{ __typename?: 'Attachment', id: string, url: string, attachmentCategory: string, customerVisible: boolean, qualityStatus?: GAttachmentQualityStatus }> } | { __typename?: 'PickUp' } };

export type GGetDeliverySheetsQueryVariables = Exact<{
  input: GRoutesInput;
}>;


export type GGetDeliverySheetsQuery = { __typename?: 'Query', routes: Array<{ __typename?: 'Route', id: string, name: string, isLobby: boolean, stops?: Array<{ __typename: 'Delivery', id: string, sequenceNumber?: string, location?: { __typename?: 'Location', id: string, businessName: string, printDeliverySheetEnabled: boolean, includeFinancialsOnDeliverySheet: boolean }, orders?: Array<{ __typename?: 'Order', id: string, shippingCostCents: number, vendor: { __typename?: 'Vendor', numericId: number, name: string }, appliedFees: Array<{ __typename?: 'OrderFee', feeType: string, feeAmountCents: number }>, invoice?: { __typename?: 'NetsuiteCreditMemo' } | { __typename?: 'NetsuiteCustomerPayment' } | { __typename?: 'NetsuiteCustomerRefund' } | { __typename?: 'NetsuiteInvoice', discountTotal: { __typename?: 'Money', cents: number } } | { __typename?: 'NetsuiteJournalEntryLine' } | { __typename?: 'OdekoPaymentIntent' }, orderLines: Array<{ __typename?: 'OrderLine', id: string, orderUnitQuantity: number, deliveredQuantity?: number, quantityType: string, itemsPerLot: number, fulfillmentQuantity?: number, unitCostCents: number, isMarketPriced: boolean, isPounds: boolean, orderedWeightLb?: number, unitWeightLb?: number, totalWeightLb?: number, sku: { __typename?: 'Sku', id: string, name: string, refrigerationState: string, categoryName: string, subcategoryName: string, item?: { __typename?: 'InventoryItem', category: { __typename?: 'Category', name: string } } | { __typename?: 'NonInventoryItem', category: { __typename?: 'Category', name: string } } } }> }> } | { __typename: 'PickUp' }> }> };

export type GGetDriverLocationTrailQueryVariables = Exact<{
  input: GDriverLocationTrailInput;
}>;


export type GGetDriverLocationTrailQuery = { __typename?: 'Query', driverLocationTrail: Array<{ __typename?: 'DriverLocationPing', id: string, latitude: number, longitude: number, occurredAt: any, accuracy?: number }> };

export type GGetDriverSafetyAcknowledgementsQueryVariables = Exact<{ [key: string]: never; }>;


export type GGetDriverSafetyAcknowledgementsQuery = { __typename?: 'Query', driverSafetyAcknowledgements: Array<{ __typename?: 'DriverSafetyAcknowledgement', id: string, name: string, acknowledgementText: string, publishOn: any, status: GDriverSafetyAcknowledgementStatus, driverAcknowledgementsCount: number, createdAt: any }> };

export type GGetExternalOrdersQueryVariables = Exact<{
  input: GOrdersInput;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GGetExternalOrdersQuery = { __typename?: 'Query', orders: { __typename?: 'OrdersConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string }, nodes?: Array<{ __typename?: 'Order', id: string, orderNumber: string, dueAt: any, deliveryDate: any, location: { __typename?: 'Location', id: string, businessName: string, scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', endTime: string, startTime: string }, address: { __typename?: 'Address', latitude?: number, longitude?: number, addressLine1: string, addressLine2?: string, city: string, postalCode: string, state: string } }, vendor: { __typename?: 'Vendor', isWarehouse: boolean, name: string, legalName: string }, externalDelivery?: { __typename?: 'ExternalDelivery', id: string, status?: string, trackingUrl?: string, estimatedPickupTime?: any, estimatedDeliveryTime?: any, containerCount?: number }, orderLines: Array<{ __typename?: 'OrderLine', id: string, orderUnitQuantity: number, fulfillmentQuantity?: number, unitCostCents: number, sku: { __typename?: 'Sku', id: string, refrigerationState: string, displayName: string, item?: { __typename?: 'InventoryItem', id: string } | { __typename?: 'NonInventoryItem', id: string } } }>, scheduledDeliveryTime?: { __typename?: 'ScheduledDeliveryTime', earliest: string, latest: string, timeZone: string } }> } };

export type GGetFulfillmentDeltasPerRouteQueryVariables = Exact<{
  input: GRouteInput;
}>;


export type GGetFulfillmentDeltasPerRouteQuery = { __typename?: 'Query', route: { __typename?: 'Route', id: string, name: string, isLobby: boolean, stops?: Array<{ __typename?: 'Delivery', id: string, sequenceNumber?: string, deliveryStatusDmp: GDeliveryStatusDmp, reminderMessage?: string, location?: { __typename?: 'Location', id: string, businessName: string }, orders?: Array<{ __typename?: 'Order', id: string, erpRecordUrl?: string, itemLevelTracking: boolean, fulfillmentStatus: string, warehouseNote?: string, orderLines: Array<{ __typename?: 'OrderLine', id: string, orderUnitQuantity: number, deliveredQuantity?: number, quantityType: string, itemsPerLot: number, fulfillmentQuantity?: number, unitCostCents: number, isMarketPriced: boolean, isPounds: boolean, orderedWeightLb?: number, unitWeightLb?: number, totalWeightLb?: number, sku: { __typename?: 'Sku', id: string, name: string, refrigerationState: string, categoryName: string, subcategoryName: string, item?: { __typename?: 'InventoryItem', category: { __typename?: 'Category', name: string } } | { __typename?: 'NonInventoryItem', category: { __typename?: 'Category', name: string } } } }>, vendor: { __typename?: 'Vendor', id: string, name: string, legalName: string } }> } | { __typename?: 'PickUp' }> } };

export type GGetInvoiceByDeliveryQueueQueryVariables = Exact<{
  input: GOrdersInput;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GGetInvoiceByDeliveryQueueQuery = { __typename?: 'Query', orders: { __typename?: 'OrdersConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string }, nodes?: Array<{ __typename?: 'Order', id: string, orderNumber: string, deliveredAt?: any, deliveryStatus: GOrderDeliveryStatus, reviewConfirmedAt?: any, reviewStatus: GOrderReviewStatus, routeCompletionState: GOrderRouteCompletionState, recoveryStatus: GOrderRecoveryStatus, redeliveryAttempted: boolean, itemLevelTracking: boolean, flaggedForReview: boolean, reviewBy?: any, deliveryMethod: GOrderDeliveryMethodEnum, erpRecordUrl?: string, location: { __typename?: 'Location', id: string, businessName: string }, vendor: { __typename?: 'Vendor', id: string, name: string, legalName: string, isWarehouse: boolean }, stops?: Array<{ __typename: 'Delivery', id: string, sequenceNumber?: string, route: { __typename?: 'Route', id: string, name: string } } | { __typename: 'PickUp' }>, orderLines: Array<{ __typename?: 'OrderLine', id: string, orderUnitQuantity: number, fulfillmentQuantity?: number, deliveredQuantity?: number, recoveryQuantity?: number, unitCostCents: number }> }> } };

export type GGetLocationsQueryVariables = Exact<{
  input: GCustomerLocationsInput;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GGetLocationsQuery = { __typename?: 'Query', customerLocations: { __typename?: 'CustomerLocationsConnection', totalCount: number, nodes?: Array<{ __typename?: 'Location', id: string, locationExcluded: boolean, effectivelyExcluded: boolean, keyId: string, businessName: string, membershipTier: GLocationMembershipTier, includeInAutomatedRouting?: boolean, enforceItemScanning: boolean, isDoordash: boolean, scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, deliverWithinStoreHours: boolean, serviceTime?: number, storeHoursConfirmed: boolean, customerPickup: boolean, printDeliverySheetEnabled: boolean, includeFinancialsOnDeliverySheet: boolean, address: { __typename?: 'Address', city: string, state: string, postalCode: string }, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', startTime: string, endTime: string }, routingCohort?: { __typename?: 'RoutingCohort', id: string, color?: string, name: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string } } };

export type GGetMetrobiCsvDataQueryVariables = Exact<{
  input: GRouteInput;
}>;


export type GGetMetrobiCsvDataQuery = { __typename?: 'Query', route: { __typename?: 'Route', id: string, stops?: Array<{ __typename?: 'Delivery', id: string, location?: { __typename?: 'Location', id: string, businessName: string, internalDeliveryInstructions?: Array<{ __typename?: 'InternalDeliveryInstructions', note?: string }>, company?: { __typename?: 'Company', users: Array<{ __typename?: 'User', firstName?: string, lastName?: string }> }, address: { __typename?: 'Address', addressLine1: string, addressLine2?: string, city: string, state: string, postalCode: string }, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', startTime: string, endTime: string } }, orders?: Array<{ __typename?: 'Order', id: string, orderNumber: string, orderLines: Array<{ __typename?: 'OrderLine', orderUnitQuantity: number, unitCostCents: number }>, scheduledDeliveryTime?: { __typename?: 'ScheduledDeliveryTime', earliest: string, latest: string, timeZone: string } }> } | { __typename?: 'PickUp' }> } };

export type GGetOrderDetailsQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type GGetOrderDetailsQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: string, erpRecordUrl?: string, itemLevelTracking: boolean, deliveredAt?: any, reviewConfirmedAt?: any, warehouseNote?: string, fulfillmentStatus: string, collectedAt?: any, dueAt: any, issues?: Array<{ __typename?: 'Issue', id: string, note?: string, type?: string, description?: string }>, location: { __typename?: 'Location', id: string, businessName: string, includeInAutomatedRouting?: boolean, enforceItemScanning: boolean, membershipTier: GLocationMembershipTier, isDoordash: boolean, scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, deliverWithinStoreHours: boolean, address: { __typename?: 'Address', addressLine1: string, addressLine2?: string, city: string, postalCode: string, state: string }, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', startTime: string, endTime: string }, routingCohort?: { __typename?: 'RoutingCohort', id: string, color?: string, name: string } }, vendor: { __typename?: 'Vendor', id: string, name: string, legalName: string, isWarehouse: boolean }, scheduledDeliveryTime?: { __typename?: 'ScheduledDeliveryTime', earliest: string, latest: string, timeZone: string }, orderLines: Array<{ __typename?: 'OrderLine', id: string, orderUnitQuantity: number, deliveredQuantity?: number, quantityType: string, itemsPerLot: number, fulfillmentQuantity?: number, unitCostCents: number, isMarketPriced: boolean, isPounds: boolean, orderedWeightLb?: number, unitWeightLb?: number, totalWeightLb?: number, sku: { __typename?: 'Sku', id: string, name: string, refrigerationState: string, categoryName: string, subcategoryName: string, item?: { __typename?: 'InventoryItem', category: { __typename?: 'Category', name: string } } | { __typename?: 'NonInventoryItem', category: { __typename?: 'Category', name: string } } } }> } };

export type GGetOrderReviewDetailQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type GGetOrderReviewDetailQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: string, orderNumber: string, deliveredAt?: any, reviewStatus: GOrderReviewStatus, recoveryStatus: GOrderRecoveryStatus, redeliveryAttempted: boolean, reviewBy?: any, erpRecordUrl?: string, location: { __typename?: 'Location', id: string, businessName: string, address: { __typename?: 'Address', addressLine1: string } }, vendor: { __typename?: 'Vendor', id: string, name: string, legalName: string }, issues?: Array<{ __typename?: 'Issue', id: string }>, stops?: Array<{ __typename: 'Delivery', id: string, sequenceNumber?: string, route: { __typename?: 'Route', id: string, name: string }, attachments?: Array<{ __typename?: 'Attachment', id: string, url: string, customerVisible: boolean, qualityStatus?: GAttachmentQualityStatus }> } | { __typename: 'PickUp', id: string, sequenceNumber?: string, route: { __typename?: 'Route', id: string, name: string }, attachments?: Array<{ __typename?: 'Attachment', id: string, url: string, customerVisible: boolean, qualityStatus?: GAttachmentQualityStatus }> }>, orderLines: Array<{ __typename?: 'OrderLine', id: string, orderUnitQuantity: number, fulfillmentQuantity?: number, deliveredQuantity?: number, recoveryQuantity?: number, unitCostCents: number, sku: { __typename?: 'Sku', id: string, name: string, refrigerationState: string, categoryName: string, item?: { __typename?: 'InventoryItem', id: string, vendorCode?: string } | { __typename?: 'NonInventoryItem', id: string, vendorCode?: string } }, changeHistory: Array<{ __typename?: 'OrderLineChangeEvent', event: GChangeEventKind, resource: GAuditResourceKind, field?: string, beforeValue?: string }> }> } };

export type GGetOrderReviewLineIssuesQueryVariables = Exact<{
  orderId: Scalars['ID'];
  stopId: Scalars['ID'];
}>;


export type GGetOrderReviewLineIssuesQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: string, orderLines: Array<{ __typename?: 'OrderLine', id: string, lineLevelDeliveryIssues: Array<{ __typename?: 'LineLevelDeliveryIssue', id: string, reasonCode: GLineLevelDeliveryIssueReasonCode, description: string }> }> } };

export type GGetOrdersQueryVariables = Exact<{
  input: GOrdersInput;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GGetOrdersQuery = { __typename?: 'Query', orders: { __typename?: 'OrdersConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string }, nodes?: Array<{ __typename?: 'Order', id: string, orderNumber: string, dueAt: any, deliveryMethod: GOrderDeliveryMethodEnum, scheduledDeliveryTime?: { __typename?: 'ScheduledDeliveryTime', earliest: string, latest: string, timeZone: string }, location: { __typename?: 'Location', id: string, businessName: string, scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', endTime: string, startTime: string }, address: { __typename?: 'Address', latitude?: number, longitude?: number, addressLine1: string, addressLine2?: string, city: string, postalCode: string, state: string } }, vendor: { __typename?: 'Vendor', isWarehouse: boolean }, externalDelivery?: { __typename?: 'ExternalDelivery', id: string, status?: string, trackingUrl?: string, estimatedPickupTime?: any, estimatedDeliveryTime?: any, containerCount?: number }, orderLines: Array<{ __typename?: 'OrderLine', id: string, sku: { __typename?: 'Sku', id: string, refrigerationState: string } }> }> } };

export type GGetPackingListQueryVariables = Exact<{
  input: GRoutesInput;
}>;


export type GGetPackingListQuery = { __typename?: 'Query', routes: Array<{ __typename?: 'Route', id: string, name: string, isLobby: boolean, redeliveryRoute: boolean, stops?: Array<{ __typename?: 'Delivery', id: string, sequenceNumber?: string, deliveryStatusDmp: GDeliveryStatusDmp, reminderMessage?: string, location?: { __typename?: 'Location', id: string, businessName: string }, orders?: Array<{ __typename?: 'Order', id: string, erpRecordUrl?: string, itemLevelTracking: boolean, fulfillmentStatus: string, warehouseNote?: string, orderLines: Array<{ __typename?: 'OrderLine', bulkPickedItem: boolean, id: string, orderUnitQuantity: number, deliveredQuantity?: number, quantityType: string, itemsPerLot: number, fulfillmentQuantity?: number, unitCostCents: number, isMarketPriced: boolean, isPounds: boolean, orderedWeightLb?: number, unitWeightLb?: number, totalWeightLb?: number, sku: { __typename?: 'Sku', id: string, name: string, refrigerationState: string, categoryName: string, subcategoryName: string, item?: { __typename?: 'InventoryItem', id: string, category: { __typename?: 'Category', name: string } } | { __typename?: 'NonInventoryItem', id: string, category: { __typename?: 'Category', name: string } } } }>, vendor: { __typename?: 'Vendor', id: string, name: string, legalName: string } }> } | { __typename?: 'PickUp' }>, redeliveryStops: Array<{ __typename?: 'Redelivery', id: string, sequenceNumber?: string, deliveryStatusDmp: GDeliveryStatusDmp, reminderMessage?: string, location?: { __typename?: 'Location', id: string, businessName: string }, orders?: Array<{ __typename?: 'Order', id: string, erpRecordUrl?: string, itemLevelTracking: boolean, fulfillmentStatus: string, warehouseNote?: string, orderLines: Array<{ __typename?: 'OrderLine', bulkPickedItem: boolean, id: string, orderUnitQuantity: number, deliveredQuantity?: number, quantityType: string, itemsPerLot: number, fulfillmentQuantity?: number, unitCostCents: number, isMarketPriced: boolean, isPounds: boolean, orderedWeightLb?: number, unitWeightLb?: number, totalWeightLb?: number, sku: { __typename?: 'Sku', id: string, name: string, refrigerationState: string, categoryName: string, subcategoryName: string, item?: { __typename?: 'InventoryItem', id: string, category: { __typename?: 'Category', name: string } } | { __typename?: 'NonInventoryItem', id: string, category: { __typename?: 'Category', name: string } } } }>, vendor: { __typename?: 'Vendor', id: string, name: string } }> }> }> };

export type GRouteManagementGetPutawayReportQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
  startDate: Scalars['ISO8601Date'];
  endDate: Scalars['ISO8601Date'];
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['String']>;
}>;


export type GRouteManagementGetPutawayReportQuery = { __typename?: 'Query', putawayReport: { __typename?: 'PutawayReport', warehouseId: string, warehouseName: string, startDate: any, endDate: any, receiptCount: number, assignmentCount: number, latestSyncedAt?: any, rows: { __typename?: 'PutawayReportRowConnection', nodes?: Array<{ __typename?: 'PutawayReportRow', id: string, receiptTranId?: string, receiptNetsuiteInternalId: string, purchaseOrderTranId?: string, purchaseOrderInternalId?: string, itemInternalId?: string, itemName?: string, lotNumber?: string, quantity?: number, receiptBinName?: string, receiptLineUniqueKey?: string, tranDate?: any, syncedAt?: any, inventoryItem?: { __typename?: 'InventoryItem', id: string, name: string }, expiration: { __typename?: 'PutawayExpiration', effectiveDate?: any, recordedDate?: any, lotDerivedDate?: any, source: string, conflict: boolean }, palletBreakdown: { __typename: 'PutawayPalletBreakdown', caseQuantity: number, fullPalletCount: number, fullPalletCaseQuantity: number, remainderCaseQuantity: number, configuration: { __typename?: 'PutawayPalletConfiguration', stockUnitConversion: number, casesPerLayer?: number, layersPerPallet?: number, casesPerPallet: number } } | { __typename: 'PutawayPalletBreakdownError', code: GPutawayPalletBreakdownErrorCode, message: string }, putawayProgress: { __typename?: 'PutawayProgress', status: GPutawayProgressStatus, receivedBaseQuantity?: number, movedBaseQuantity: number, remainingBaseQuantity?: number, actions: Array<{ __typename?: 'PutawayAction', id: string, destination: string, movedBaseQuantity: number, movedOn: any, movedAt: any }>, issues: Array<{ __typename?: 'PutawayProgressIssue', code: GPutawayProgressIssueCode, message: string }> }, observedMovement?: { __typename?: 'PutawayObservedMovement', destination: string, movedOn: any } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string } } } };

export type GGetRedeliveryCsvDataQueryVariables = Exact<{
  input: GRoutesInput;
}>;


export type GGetRedeliveryCsvDataQuery = { __typename?: 'Query', routes: Array<{ __typename?: 'Route', id: string, name: string, routeOrigin?: string, routeCohort?: string, redeliveryStops: Array<{ __typename: 'Redelivery', id: string, sequenceNumber?: string, location?: { __typename?: 'Location', id: string, businessName: string, scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, address: { __typename?: 'Address', city: string, state: string }, membershipStatus: { __typename?: 'LocationMembershipStatus', tier: GLocationMembershipStatusTier }, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', endTime: string, startTime: string } }, orders?: Array<{ __typename?: 'Order', id: string, orderNumber: string, deliveryDate: any, orderLines: Array<{ __typename?: 'OrderLine', id: string, orderUnitQuantity: number, fulfillmentQuantity?: number, deliveredQuantity?: number, unitCostCents: number, sku: { __typename?: 'Sku', displayName: string, refrigerationState: string, item?: { __typename?: 'InventoryItem', id: string } | { __typename?: 'NonInventoryItem', id: string } } }>, vendor: { __typename?: 'Vendor', id: string, name: string, legalName: string, isWarehouse: boolean }, scheduledDeliveryTime?: { __typename?: 'ScheduledDeliveryTime', earliest: string, latest: string, timeZone: string } }> }> }> };

export type GGetRedeliveryStopDetailsQueryVariables = Exact<{
  input: GRedeliveryStopInput;
}>;


export type GGetRedeliveryStopDetailsQuery = { __typename?: 'Query', redeliveryStop: { __typename?: 'Redelivery', id: string, compostCollectionRequired?: boolean, compostCollectedAt?: any, donationRequired?: boolean, donationCollectedAt?: any, deliveryNote?: string, completedAt?: any, arrivedAt?: any, departedAt?: any, dwellSeconds?: number, hasRepeatedAccessIssues: boolean, repeatedAccessIssues: Array<string>, deliveryStop: { __typename?: 'Delivery', id: string }, providerDelivery?: { __typename?: 'ProviderDelivery', status?: string, proofUrls: Array<string> }, issues?: Array<{ __typename?: 'Issue', id: string, note?: string, type?: string, description?: string }>, orders?: Array<{ __typename?: 'Order', id: string, erpRecordUrl?: string, deliveredAt?: any, collectedAt?: any, fulfillmentStatus: string, partiallyDelivered: boolean, itemLevelTracking: boolean, dueAt: any, deliveryMethod: GOrderDeliveryMethodEnum, issues?: Array<{ __typename?: 'Issue', id: string, note?: string, type?: string, description?: string }>, vendor: { __typename?: 'Vendor', name: string, legalName: string, isWarehouse: boolean }, location: { __typename?: 'Location', id: string, membershipTier: GLocationMembershipTier, includeInAutomatedRouting?: boolean, enforceItemScanning: boolean, scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, deliverWithinStoreHours: boolean, isDoordash: boolean, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', startTime: string, endTime: string } }, scheduledDeliveryTime?: { __typename?: 'ScheduledDeliveryTime', earliest: string, latest: string, timeZone: string }, orderLines: Array<{ __typename?: 'OrderLine', id: string, orderUnitQuantity: number, deliveredQuantity?: number, quantityType: string, itemsPerLot: number, fulfillmentQuantity?: number, unitCostCents: number, isMarketPriced: boolean, isPounds: boolean, orderedWeightLb?: number, unitWeightLb?: number, totalWeightLb?: number, sku: { __typename?: 'Sku', id: string, name: string, refrigerationState: string, categoryName: string, subcategoryName: string, item?: { __typename?: 'InventoryItem', category: { __typename?: 'Category', name: string } } | { __typename?: 'NonInventoryItem', category: { __typename?: 'Category', name: string } } } }> }>, location?: { __typename?: 'Location', id: string, scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum } } };

export type GGetRouteDetailsQueryVariables = Exact<{
  input: GRouteInput;
}>;


export type GGetRouteDetailsQuery = { __typename?: 'Query', route: { __typename?: 'Route', id: string, name: string, redeliveryRoute: boolean, isLobby: boolean, thirdPartyRoute: boolean, thirdPartyProvider?: GThirdPartyProvider, bucketRoute: boolean, customerPickupRoute: boolean, startTime?: any, stopTime?: any, warehouseDepartedAt?: any, warehouseArrivedAt?: any, milesDriven?: number, timeOnRoad?: number, warehouse: { __typename?: 'Warehouse', id: string, latitude?: number, longitude?: number, geofenceRadiusMeters: number }, truck?: { __typename?: 'Truck', vehicleTag?: string }, driverUser?: { __typename?: 'User', id: string, name?: string }, helperDriverUser?: { __typename?: 'User', id: string, name?: string }, stops?: Array<{ __typename?: 'Delivery', id: string, sequenceNumber?: string, completedAt?: any, arrivedAt?: any, departedAt?: any, dwellSeconds?: number, revisitCount: number, deliveryStatusDmp: GDeliveryStatusDmp, visits: Array<{ __typename?: 'StopVisit', enteredAt?: any, exitedAt?: any, dwellSeconds?: number, postCompletion: boolean }>, location?: { __typename?: 'Location', id: string, businessName: string, effectivelyExcluded: boolean, displayAddress: string, serviceTime?: number, scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', startTime: string, endTime: string }, address: { __typename?: 'Address', latitude?: number, longitude?: number } }, orders?: Array<{ __typename?: 'Order', id: string, deliveredAt?: any, partiallyDelivered: boolean, totalItemQuantity: number, orderLines: Array<{ __typename?: 'OrderLine', isMarketPriced: boolean, orderedWeightLb?: number, totalWeightLb?: number, orderUnitQuantity: number, unitCostCents: number, sku: { __typename?: 'Sku', id: string, item?: { __typename?: 'InventoryItem', id: string, purchasePrice: { __typename?: 'Money', cents: number }, purchaseUnit: { __typename?: 'Unit', id: string, conversionRate: number }, saleUnit: { __typename?: 'Unit', id: string, conversionRate: number } } | { __typename?: 'NonInventoryItem', id: string, purchasePrice: { __typename?: 'Money', cents: number } } } }>, vendor: { __typename?: 'Vendor', isWarehouse: boolean }, appliedFees: Array<{ __typename?: 'OrderFee', feeId: string, feeAmountCents: number }>, scheduledDeliveryTime?: { __typename?: 'ScheduledDeliveryTime', earliest: string, latest: string, timeZone: string } }>, routingEstimates?: { __typename?: 'StopEstimates', distance?: number, routeNumber?: number, sequenceNumber?: number, startDatetime?: any, finishDatetime?: any } } | { __typename?: 'PickUp', id: string, sequenceNumber?: string, completedAt?: any, deliveryStatusDmp: GDeliveryStatusDmp, vendor: { __typename?: 'Vendor', name: string, legalName: string }, orders?: Array<{ __typename?: 'Order', collectedAt?: any }> }>, redeliveryStops: Array<{ __typename?: 'Redelivery', id: string, sequenceNumber?: string, completedAt?: any, arrivedAt?: any, departedAt?: any, dwellSeconds?: number, revisitCount: number, deliveryStatusDmp: GDeliveryStatusDmp, visits: Array<{ __typename?: 'StopVisit', enteredAt?: any, exitedAt?: any, dwellSeconds?: number, postCompletion: boolean }>, location?: { __typename?: 'Location', id: string, businessName: string, effectivelyExcluded: boolean, displayAddress: string, serviceTime?: number, scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', startTime: string, endTime: string }, address: { __typename?: 'Address', latitude?: number, longitude?: number } }, orders?: Array<{ __typename?: 'Order', id: string, deliveredAt?: any, partiallyDelivered: boolean, totalItemQuantity: number, orderLines: Array<{ __typename?: 'OrderLine', isMarketPriced: boolean, orderedWeightLb?: number, totalWeightLb?: number, orderUnitQuantity: number, unitCostCents: number, sku: { __typename?: 'Sku', id: string, item?: { __typename?: 'InventoryItem', id: string, purchasePrice: { __typename?: 'Money', cents: number }, purchaseUnit: { __typename?: 'Unit', id: string, conversionRate: number }, saleUnit: { __typename?: 'Unit', id: string, conversionRate: number } } | { __typename?: 'NonInventoryItem', id: string, purchasePrice: { __typename?: 'Money', cents: number } } } }>, vendor: { __typename?: 'Vendor', isWarehouse: boolean }, appliedFees: Array<{ __typename?: 'OrderFee', feeId: string, feeAmountCents: number }>, scheduledDeliveryTime?: { __typename?: 'ScheduledDeliveryTime', earliest: string, latest: string, timeZone: string } }> }>, routingEstimates?: { __typename?: 'RouteEstimates', travelTime?: number, distance?: number, startDatetime?: any, finishDatetime?: any, stopsCount?: number, serviceTime?: number, breakTime?: number } } };

export type GGetRouteNamesQueryVariables = Exact<{
  input: GRoutesInput;
}>;


export type GGetRouteNamesQuery = { __typename?: 'Query', routes: Array<{ __typename?: 'Route', id: string, name: string, redeliveryRoute: boolean, driverUser?: { __typename?: 'User', name?: string }, helperDriverUser?: { __typename?: 'User', name?: string } }> };

export type GGetRoutePerformanceEtasStatusQueryVariables = Exact<{
  input: GRoutingImportPlanInput;
}>;


export type GGetRoutePerformanceEtasStatusQuery = { __typename?: 'Query', routingImportPlan: { __typename?: 'RoutingImportPlan', id: string, etasStatus: { __typename?: 'EtasStatus', stale: boolean, reason?: GEtasStatusReason, lastCalculatedAt?: any, lastCalculatedRunId?: string } } };

export type GGetRouteProviderDispatchQueryVariables = Exact<{
  input: GRouteInput;
}>;


export type GGetRouteProviderDispatchQuery = { __typename?: 'Query', route: { __typename?: 'Route', id: string, thirdPartyRoute: boolean, thirdPartyProvider?: GThirdPartyProvider, stops?: Array<{ __typename: 'Delivery', id: string } | { __typename: 'PickUp', id: string }>, redeliveryStops: Array<{ __typename?: 'Redelivery', id: string }>, providerDispatch?: { __typename?: 'ProviderDispatch', status: GProviderDispatchStatus, pickupAt?: any, error?: string, externalRouteId?: string, cancelRequestedAt?: any, cancelable: boolean, unmarkable: boolean, quotes: Array<{ __typename?: 'ProviderQuote', id: string, provider?: string, cost?: number, fee?: number, expiresAt?: any }> } } };

export type GGetRoutesQueryVariables = Exact<{
  input: GRoutesInput;
}>;


export type GGetRoutesQuery = { __typename?: 'Query', routes: Array<{ __typename?: 'Route', color?: string, id: string, name: string, isLobby: boolean, thirdPartyRoute: boolean, thirdPartyProvider?: GThirdPartyProvider, bucketRoute: boolean, customerPickupRoute: boolean, nightEnd: any, nightEndLocked: boolean, stopTime?: any, totalVolume?: number, totalWeight?: number, percentItemsWithWeight?: number, percentItemsWithVolume?: number, redeliveryRoute: boolean, routeOrigin?: string, routeCohort?: string, shiftType?: string, providerDispatch?: { __typename?: 'ProviderDispatch', status: GProviderDispatchStatus, pickupAt?: any, error?: string, courierAlertSentAt?: any, cancelRequestedAt?: any, cancelable: boolean, unmarkable: boolean, chosenQuote?: { __typename?: 'ProviderQuote', id: string, provider?: string, cost?: number, fee?: number } }, stops?: Array<{ __typename: 'Delivery', id: string, sequenceNumber?: string, totalWeight?: number, totalVolume?: number, deliveryNote?: string, completedAt?: any, location?: { __typename?: 'Location', effectivelyExcluded: boolean, displayAddress: string, id: string, membershipTier: GLocationMembershipTier, includeInAutomatedRouting?: boolean, businessName: string, isDoordash: boolean, scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, address: { __typename?: 'Address', latitude?: number, longitude?: number, state: string }, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', startTime: string, endTime: string }, routingCohort?: { __typename?: 'RoutingCohort', id: string, color?: string, name: string }, warehouseDeliveryRules: Array<{ __typename?: 'DeliveryRule', deliveryDay: number }> }, orders?: Array<{ __typename?: 'Order', id: string, deliveryMethod: GOrderDeliveryMethodEnum, scheduledDeliveryTime?: { __typename?: 'ScheduledDeliveryTime', earliest: string, latest: string, timeZone: string } }>, providerDelivery?: { __typename?: 'ProviderDelivery', status?: string, courierAssigned: boolean, courierName?: string, dropoffEta?: any, trackingUrl?: string, proofUrls: Array<string>, needsAttention: boolean, needsAttentionReason?: string }, route: { __typename?: 'Route', id: string, name: string, truck?: { __typename?: 'Truck', maxWeight: number, maxVolume: number, vin?: string, vehicleTag?: string } } } | { __typename: 'PickUp', id: string, sequenceNumber?: string, vendor: { __typename?: 'Vendor', name: string, legalName: string, address?: { __typename?: 'Address', latitude?: number, longitude?: number, state: string } } }>, redeliveryStops: Array<{ __typename?: 'Redelivery', id: string, sequenceNumber?: string, deliveryStop: { __typename?: 'Delivery', id: string }, location?: { __typename?: 'Location', effectivelyExcluded: boolean, displayAddress: string, id: string, includeInAutomatedRouting?: boolean, businessName: string, isDoordash: boolean, scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, address: { __typename?: 'Address', latitude?: number, longitude?: number, state: string }, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', startTime: string, endTime: string }, routingCohort?: { __typename?: 'RoutingCohort', id: string, color?: string, name: string }, warehouseDeliveryRules: Array<{ __typename?: 'DeliveryRule', deliveryDay: number }> }, orders?: Array<{ __typename?: 'Order', id: string, deliveryMethod: GOrderDeliveryMethodEnum, scheduledDeliveryTime?: { __typename?: 'ScheduledDeliveryTime', earliest: string, latest: string, timeZone: string } }>, providerDelivery?: { __typename?: 'ProviderDelivery', status?: string, courierAssigned: boolean, courierName?: string, dropoffEta?: any, trackingUrl?: string, proofUrls: Array<string>, needsAttention: boolean, needsAttentionReason?: string }, route: { __typename?: 'Route', id: string, name: string, truck?: { __typename?: 'Truck', maxWeight: number, maxVolume: number, vin?: string, vehicleTag?: string } } }>, driverUser?: { __typename?: 'User', id: string, name?: string, email?: string }, helperDriverUser?: { __typename?: 'User', id: string, name?: string, email?: string }, truck?: { __typename?: 'Truck', maxVolume: number, maxWeight: number, vin?: string, vehicleTag?: string }, plannedVehicle?: { __typename?: 'PlannedVehicle', maxVolume?: number, maxWeight?: number, vehicleType?: string } }> };

export type GGetRoutingImportPlanComparisonQueryVariables = Exact<{
  input: GRoutingImportPlanInput;
}>;


export type GGetRoutingImportPlanComparisonQuery = { __typename?: 'Query', routingImportPlan: { __typename?: 'RoutingImportPlan', id: string, appliedRoutificRun?: { __typename?: 'RoutificRunSummary', id: string, label?: string, status: GRoutificRunStatus, truckCount: number, createdAt: any, routeCount?: number, totalStops?: number, totalDistanceMiles?: number, avgCubicUtilizationPercent?: number, estimatedDriverHours?: number, dprh?: number, unservedCount?: number, polylines?: any, vehicleStopIds?: any, routes?: Array<{ __typename?: 'RouteSummary', miles: number, stops: number, estimatedHours?: number, cubicUtilizationPercent?: number }> }, dispatchedRoutificRun?: { __typename?: 'RoutificRunSummary', id: string, status: GRoutificRunStatus, polylines?: any, vehicleStopIds?: any }, scenarios: Array<{ __typename?: 'RoutificRunSummary', id: string, label?: string, status: GRoutificRunStatus, truckCount: number, createdAt: any, routeCount?: number, totalStops?: number, totalDistanceMiles?: number, avgCubicUtilizationPercent?: number, estimatedDriverHours?: number, dprh?: number, unservedCount?: number, polylines?: any, vehicleStopIds?: any, routes?: Array<{ __typename?: 'RouteSummary', miles: number, stops: number, estimatedHours?: number, cubicUtilizationPercent?: number }> }>, manualRoutificRuns: Array<{ __typename?: 'RoutificRunSummary', id: string, label?: string, status: GRoutificRunStatus, truckCount: number, createdAt: any, routeCount?: number, totalStops?: number, totalDistanceMiles?: number, avgCubicUtilizationPercent?: number, estimatedDriverHours?: number, dprh?: number, unservedCount?: number, polylines?: any, vehicleStopIds?: any, routes?: Array<{ __typename?: 'RouteSummary', miles: number, stops: number, estimatedHours?: number, cubicUtilizationPercent?: number }> }>, actualRoutesSummary?: { __typename?: 'ActualRoutesSummary', routeCount: number, totalStops: number, totalDistanceMiles?: number, avgCubicUtilizationPercent?: number, driverHours?: number, dprh?: number, routes: Array<{ __typename?: 'ActualRouteSummary', miles?: number, stops: number }> } } };

export type GGetStopDetailsQueryVariables = Exact<{
  input: GStopInput;
}>;


export type GGetStopDetailsQuery = { __typename?: 'Query', stop: { __typename?: 'Delivery', id: string, compostCollectionRequired?: boolean, compostCollectedAt?: any, donationRequired?: boolean, donationCollectedAt?: any, deliveryNote?: string, completedAt?: any, arrivedAt?: any, departedAt?: any, dwellSeconds?: number, hasRepeatedAccessIssues: boolean, repeatedAccessIssues: Array<string>, providerDelivery?: { __typename?: 'ProviderDelivery', status?: string, proofUrls: Array<string> }, issues?: Array<{ __typename?: 'Issue', id: string, note?: string, type?: string, description?: string }>, orders?: Array<{ __typename?: 'Order', id: string, erpRecordUrl?: string, deliveredAt?: any, collectedAt?: any, fulfillmentStatus: string, partiallyDelivered: boolean, itemLevelTracking: boolean, warehouseNote?: string, dueAt: any, deliveryMethod: GOrderDeliveryMethodEnum, issues?: Array<{ __typename?: 'Issue', id: string, note?: string, type?: string, description?: string }>, vendor: { __typename?: 'Vendor', name: string, legalName: string, isWarehouse: boolean }, location: { __typename?: 'Location', membershipTier: GLocationMembershipTier, includeInAutomatedRouting?: boolean, enforceItemScanning: boolean, scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, deliverWithinStoreHours: boolean, isDoordash: boolean, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', startTime: string, endTime: string } }, scheduledDeliveryTime?: { __typename?: 'ScheduledDeliveryTime', earliest: string, latest: string, timeZone: string }, orderLines: Array<{ __typename?: 'OrderLine', id: string, orderUnitQuantity: number, deliveredQuantity?: number, quantityType: string, itemsPerLot: number, fulfillmentQuantity?: number, unitCostCents: number, isMarketPriced: boolean, isPounds: boolean, orderedWeightLb?: number, unitWeightLb?: number, totalWeightLb?: number, sku: { __typename?: 'Sku', id: string, name: string, refrigerationState: string, categoryName: string, subcategoryName: string, item?: { __typename?: 'InventoryItem', category: { __typename?: 'Category', name: string } } | { __typename?: 'NonInventoryItem', category: { __typename?: 'Category', name: string } } } }> }>, location?: { __typename?: 'Location', id: string, scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, routingCohort?: { __typename?: 'RoutingCohort', id: string, color?: string, name: string } } } | { __typename?: 'PickUp', id: string, issues?: Array<{ __typename?: 'Issue', id: string, note?: string, type?: string, description?: string }>, orders?: Array<{ __typename?: 'Order', id: string, erpRecordUrl?: string, deliveredAt?: any, collectedAt?: any, warehouseNote?: string, dueAt: any, deliveryMethod: GOrderDeliveryMethodEnum, issues?: Array<{ __typename?: 'Issue', id: string, note?: string, type?: string, description?: string }>, scheduledDeliveryTime?: { __typename?: 'ScheduledDeliveryTime', earliest: string, latest: string, timeZone: string }, location: { __typename?: 'Location', membershipTier: GLocationMembershipTier, businessName: string, scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', startTime: string, endTime: string } } }> } };

export type GGetTotalOrdersQueryVariables = Exact<{
  input: GOrdersInput;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type GGetTotalOrdersQuery = { __typename?: 'Query', orders: { __typename?: 'OrdersConnection', totalCount: number } };

export type GGetVehicleInspectionTruckStatusesQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
  from: Scalars['ISO8601DateTime'];
  to: Scalars['ISO8601DateTime'];
}>;


export type GGetVehicleInspectionTruckStatusesQuery = { __typename?: 'Query', vehicleInspectionTruckStatuses: Array<{ __typename?: 'VehicleInspectionTruckStatus', inspected: boolean, hasIssues: boolean, issueCount: number, routeCount: number, preTripReportCount: number, postTripReportCount: number, truck: { __typename?: 'Truck', id: string, vehicleTag?: string, vehicleType?: string, vin?: string } }> };

export type GGetVehicleInspectionRouteStatusesQueryVariables = Exact<{
  truckId: Scalars['ID'];
  warehouseId: Scalars['ID'];
  from: Scalars['ISO8601DateTime'];
  to: Scalars['ISO8601DateTime'];
}>;


export type GGetVehicleInspectionRouteStatusesQuery = { __typename?: 'Query', vehicleInspectionRouteStatuses: Array<{ __typename?: 'VehicleInspectionRouteStatus', deliveryRouteId: string, routeName?: string, nightEnd: any, driverName?: string, hasIssues: boolean, issueCount: number, issueLabels: Array<string>, truck: { __typename?: 'Truck', id: string, vehicleTag?: string, vehicleType?: string, vin?: string }, pre: { __typename?: 'VehicleInspectionPhaseStatus', submitted: boolean, reportId?: string, submittedAt?: any }, post: { __typename?: 'VehicleInspectionPhaseStatus', submitted: boolean, reportId?: string, submittedAt?: any } }> };

export type GGetStandaloneVehicleInspectionDrivesQueryVariables = Exact<{
  truckId: Scalars['ID'];
  warehouseId: Scalars['ID'];
  from: Scalars['ISO8601DateTime'];
  to: Scalars['ISO8601DateTime'];
}>;


export type GGetStandaloneVehicleInspectionDrivesQuery = { __typename?: 'Query', standaloneVehicleInspectionDrives: Array<{ __typename?: 'StandaloneVehicleInspectionDrive', standaloneDriveId: string, driveDate: any, driverName?: string, hasIssues: boolean, issueCount: number, issueLabels: Array<string>, truck: { __typename?: 'Truck', id: string, vehicleTag?: string, vehicleType?: string, vin?: string }, pre: { __typename?: 'VehicleInspectionPhaseStatus', submitted: boolean, reportId?: string, submittedAt?: any }, post: { __typename?: 'VehicleInspectionPhaseStatus', submitted: boolean, reportId?: string, submittedAt?: any } }> };

export type GGetVehicleInspectionReportQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GGetVehicleInspectionReportQuery = { __typename?: 'Query', vehicleInspectionReport: { __typename?: 'VehicleInspectionReport', id: string, inspectionType: string, submittedAt: any, hasIssues: boolean, issueCount: number, deliveryRouteId: string, schemaVersion: number, responses: any, submittedByName?: string, photos: Array<{ __typename?: 'VehicleInspectionPhoto', position: number, url?: string }>, driver?: { __typename?: 'Driver', id: string, name?: string }, truck: { __typename?: 'Truck', id: string, vehicleTag?: string, vehicleType?: string, vin?: string }, warehouse: { __typename?: 'Warehouse', id: string, name: string, timeZone: string } } };

export type GGetStandaloneVehicleInspectionReportQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GGetStandaloneVehicleInspectionReportQuery = { __typename?: 'Query', standaloneVehicleInspectionReport: { __typename?: 'StandaloneVehicleInspectionReport', id: string, inspectionType: string, submittedAt: any, hasIssues: boolean, issueCount: number, standaloneDriveId: string, schemaVersion: number, responses: any, submittedByName?: string, photos: Array<{ __typename?: 'VehicleInspectionPhoto', position: number, url?: string }>, driver?: { __typename?: 'Driver', id: string, name?: string }, truck: { __typename?: 'Truck', id: string, vehicleTag?: string, vehicleType?: string, vin?: string }, warehouse: { __typename?: 'Warehouse', id: string, name: string, timeZone: string } } };

export type GGetVehicleInspectionRouteNameQueryVariables = Exact<{
  input: GRouteInput;
}>;


export type GGetVehicleInspectionRouteNameQuery = { __typename?: 'Query', route: { __typename?: 'Route', id: string, name: string, nightEnd: any } };

export type GGetVendorOrdersQueryVariables = Exact<{
  input: GVendorOrdersInput;
}>;


export type GGetVendorOrdersQuery = { __typename?: 'Query', vendorOrders: Array<{ __typename?: 'Order', id: string, location: { __typename?: 'Location', id: string, businessName: string, address: { __typename?: 'Address', locality: string, addressLine1: string } }, stops?: Array<{ __typename: 'Delivery', id: string, sequenceNumber?: string, location?: { __typename?: 'Location', id: string }, route: { __typename?: 'Route', id: string, name: string } } | { __typename: 'PickUp' }>, orderLines: Array<{ __typename?: 'OrderLine', id: string, isMarketPriced: boolean, orderUnitQuantity: number, fulfillmentQuantity?: number, sku: { __typename?: 'Sku', id: string, displayName: string, item?: { __typename?: 'InventoryItem', id: string, name: string } | { __typename?: 'NonInventoryItem', id: string, name: string } } }> }> };

export type GGetVendorReceivingCheckinQueryVariables = Exact<{
  input: GVendorReceivingCheckinInput;
}>;


export type GGetVendorReceivingCheckinQuery = { __typename?: 'Query', vendorReceivingCheckin: Array<{ __typename?: 'VendorReceivingCheckinItem', itemId: string, itemName: string, orderedQty: number, customerNames: Array<string>, markupPercentage?: number, receivedQty?: number, vendorPriceTotalCents?: number, vendorPricePerUnitCents?: number, sellingPricePerUnitCents?: number, windowClosesAt?: any, supplyItem?: { __typename?: 'InventoryItem', vendorCode?: string } | { __typename?: 'NonInventoryItem', vendorCode?: string } }> };

export type GGetVendorReceivingListQueryVariables = Exact<{
  input: GVendorReceivingListInput;
}>;


export type GGetVendorReceivingListQuery = { __typename?: 'Query', vendorReceivingList: Array<{ __typename?: 'VendorReceivingSummary', vendorId: string, vendorName?: string, orderCount: number, totalOrderedQty: number, status: GVendorReceivingStatus, shortageCount?: number, windowClosesAt?: any, vendor?: { __typename?: 'Vendor', legalName: string } }> };

export type GWarehouseCommitmentDiscrepanciesQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
  deliveryDate: Scalars['ISO8601Date'];
}>;


export type GWarehouseCommitmentDiscrepanciesQuery = { __typename?: 'Query', warehouseCommitmentDiscrepancies: { __typename?: 'WarehouseCommitmentDiscrepancyReport', totalOrderCount: number, discrepancyCount: number, pendingCount: number, orders: Array<{ __typename?: 'WarehouseCommitmentDiscrepancyOrder', orderNumber: string, locationName?: string, orderedUnits: number, committedUnits: number, shortfall: number }> } };

export type GWarehouseCommitmentDiscrepancyLinesQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
  deliveryDate: Scalars['ISO8601Date'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type GWarehouseCommitmentDiscrepancyLinesQuery = { __typename?: 'Query', warehouseCommitmentDiscrepancyLines: { __typename?: 'WarehouseCommitmentDiscrepancyLinesReport', totalCount: number, orderLines: Array<{ __typename?: 'WarehouseCommitmentDiscrepancyLine', routeName?: string, stopNumber?: number, itemName?: string, orderedUnits: number, committedUnits: number, order: { __typename?: 'Order', id: string, orderNumber: string, erpRecordUrl?: string, location: { __typename?: 'Location', id: string, businessName: string } } }> } };

export type GWarehouseCommitmentSummaryQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
  deliveryDate: Scalars['ISO8601Date'];
}>;


export type GWarehouseCommitmentSummaryQuery = { __typename?: 'Query', warehouseCommitmentSummary: { __typename?: 'WarehouseCommitmentSummary', orderCount: number, orderedUnits: number, committedUnits: number } };

export type GWarehouseCutoffDiscrepanciesQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
  deliveryDate: Scalars['ISO8601Date'];
}>;


export type GWarehouseCutoffDiscrepanciesQuery = { __typename?: 'Query', warehouseCutoffDiscrepancies: { __typename?: 'CutoffDiscrepancyReport', totalOrderCount: number, discrepancyCount: number, orders: Array<{ __typename?: 'CutoffDiscrepancyOrder', orderNumber: string, locationId?: string, locationName?: string, address?: string, vendorId: string, reason: GCutoffDiscrepancyReasonEnum, dueAt?: any, order: { __typename?: 'Order', routeName?: string, stopNumber?: number }, vendorDeliveryRules: Array<{ __typename?: 'CutoffDeliveryRule', deliveryDay: string, orderDeadline?: string, leadTimeDays?: number }>, locationVendorAssociations: Array<{ __typename?: 'CutoffLocationVendorAssociation', id: string, vendorName: string, deliveryRules: Array<{ __typename?: 'CutoffDeliveryRule', deliveryDay: string, orderDeadline?: string, leadTimeDays?: number }> }> }> } };

export type GWarehouseCutoffDiscrepancyCountQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
  deliveryDate: Scalars['ISO8601Date'];
}>;


export type GWarehouseCutoffDiscrepancyCountQuery = { __typename?: 'Query', warehouseCutoffDiscrepancies: { __typename?: 'CutoffDiscrepancyReport', discrepancyCount: number } };

export type GGetWarehouseDeliveryDetailsQueryVariables = Exact<{
  input: GRoutesInput;
}>;


export type GGetWarehouseDeliveryDetailsQuery = { __typename?: 'Query', routes: Array<{ __typename?: 'Route', id: string, name: string, redeliveryRoute: boolean, isLobby: boolean, thirdPartyRoute: boolean, customerPickupRoute: boolean, bucketRoute: boolean, stops?: Array<{ __typename?: 'Delivery', id: string, sequenceNumber?: string, completedAt?: any, orders?: Array<{ __typename?: 'Order', totalItemQuantity: number, totalCostCents: number, totalCogsCents: number, totalFeesCents: number }>, routingEstimates?: { __typename?: 'StopEstimates', routeNumber?: number, sequenceNumber?: number } } | { __typename?: 'PickUp', id: string, sequenceNumber?: string, completedAt?: any }>, redeliveryStops: Array<{ __typename?: 'Redelivery', id: string, sequenceNumber?: string, completedAt?: any }>, routingEstimates?: { __typename?: 'RouteEstimates', travelTime?: number, distance?: number, stopsCount?: number, serviceTime?: number, breakTime?: number } }> };

export type GGetWarehouseDeliveryInfoQueryVariables = Exact<{
  input: GRoutesInput;
}>;


export type GGetWarehouseDeliveryInfoQuery = { __typename?: 'Query', routes: Array<{ __typename?: 'Route', id: string, name: string, warehouse: { __typename?: 'Warehouse', id: string }, redeliveryStops: Array<{ __typename?: 'Redelivery', id: string, sequenceNumber?: string, completedAt?: any, deliveryStatusDmp: GDeliveryStatusDmp, location?: { __typename?: 'Location', id: string, businessName: string, displayAddress: string, scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', startTime: string, endTime: string } }, orders?: Array<{ __typename?: 'Order', id: string, deliveredAt?: any, partiallyDelivered: boolean, totalItemQuantity: number, orderLines: Array<{ __typename?: 'OrderLine', isMarketPriced: boolean, orderedWeightLb?: number, totalWeightLb?: number, orderUnitQuantity: number, unitCostCents: number, sku: { __typename?: 'Sku', id: string, item?: { __typename?: 'InventoryItem', id: string, purchasePrice: { __typename?: 'Money', cents: number }, purchaseUnit: { __typename?: 'Unit', id: string, conversionRate: number }, saleUnit: { __typename?: 'Unit', id: string, conversionRate: number } } | { __typename?: 'NonInventoryItem', id: string, purchasePrice: { __typename?: 'Money', cents: number } } } }>, vendor: { __typename?: 'Vendor', isWarehouse: boolean }, appliedFees: Array<{ __typename?: 'OrderFee', feeId: string, feeAmountCents: number }>, scheduledDeliveryTime?: { __typename?: 'ScheduledDeliveryTime', earliest: string, latest: string, timeZone: string } }> }>, stops?: Array<{ __typename?: 'Delivery', id: string, sequenceNumber?: string, completedAt?: any, deliveryStatusDmp: GDeliveryStatusDmp, location?: { __typename?: 'Location', id: string, businessName: string, scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', startTime: string, endTime: string } }, orders?: Array<{ __typename?: 'Order', id: string, deliveredAt?: any, partiallyDelivered: boolean, totalItemQuantity: number, orderLines: Array<{ __typename?: 'OrderLine', isMarketPriced: boolean, orderedWeightLb?: number, totalWeightLb?: number, orderUnitQuantity: number, unitCostCents: number, sku: { __typename?: 'Sku', id: string, item?: { __typename?: 'InventoryItem', id: string, purchasePrice: { __typename?: 'Money', cents: number }, purchaseUnit: { __typename?: 'Unit', id: string, conversionRate: number }, saleUnit: { __typename?: 'Unit', id: string, conversionRate: number } } | { __typename?: 'NonInventoryItem', id: string, purchasePrice: { __typename?: 'Money', cents: number } } } }>, vendor: { __typename?: 'Vendor', isWarehouse: boolean }, appliedFees: Array<{ __typename?: 'OrderFee', feeId: string, feeAmountCents: number }>, scheduledDeliveryTime?: { __typename?: 'ScheduledDeliveryTime', earliest: string, latest: string, timeZone: string } }> } | { __typename?: 'PickUp', id: string, sequenceNumber?: string, completedAt?: any, deliveryStatusDmp: GDeliveryStatusDmp, vendor: { __typename?: 'Vendor', name: string, legalName: string }, orders?: Array<{ __typename?: 'Order', collectedAt?: any }> }> }> };

export type GGetWarehouseDeliveryMapDetailsQueryVariables = Exact<{
  input: GRoutesInput;
  planInput: GRoutingImportPlanInput;
}>;


export type GGetWarehouseDeliveryMapDetailsQuery = { __typename?: 'Query', routes: Array<{ __typename?: 'Route', id: string, name: string, color?: string, isLobby: boolean, thirdPartyRoute: boolean, customerPickupRoute: boolean, bucketRoute: boolean, truck?: { __typename?: 'Truck', vehicleType?: string }, stops?: Array<{ __typename?: 'Delivery', id: string, sequenceNumber?: string, location?: { __typename?: 'Location', businessName: string, address: { __typename?: 'Address', latitude?: number, longitude?: number, addressLine1: string } } } | { __typename?: 'PickUp', id: string, sequenceNumber?: string }> }>, routingImportPlan: { __typename?: 'RoutingImportPlan', appliedRoutificRun?: { __typename?: 'RoutificRunSummary', id: string, polylines?: any } } };

export type GGetWarehouseDriverPerformanceDetailsQueryVariables = Exact<{
  input: GRoutesInput;
}>;


export type GGetWarehouseDriverPerformanceDetailsQuery = { __typename?: 'Query', routes: Array<{ __typename?: 'Route', id: string, name: string, redeliveryRoute: boolean, isLobby: boolean, thirdPartyRoute: boolean, customerPickupRoute: boolean, bucketRoute: boolean, startTime?: any, stopTime?: any, truck?: { __typename?: 'Truck', vehicleTag?: string }, driverUser?: { __typename?: 'User', id: string, name?: string }, helperDriverUser?: { __typename?: 'User', id: string, name?: string }, stops?: Array<{ __typename?: 'Delivery', id: string, sequenceNumber?: string, completedAt?: any, arrivedAt?: any, departedAt?: any, dwellSeconds?: number, location?: { __typename?: 'Location', serviceTime?: number }, routingEstimates?: { __typename?: 'StopEstimates', routeNumber?: number, sequenceNumber?: number, startDatetime?: any, finishDatetime?: any } } | { __typename?: 'PickUp', id: string, sequenceNumber?: string, completedAt?: any }>, redeliveryStops: Array<{ __typename?: 'Redelivery', id: string, sequenceNumber?: string, completedAt?: any }>, routingEstimates?: { __typename?: 'RouteEstimates', travelTime?: number, startDatetime?: any, finishDatetime?: any, stopsCount?: number, serviceTime?: number, breakTime?: number } }> };

export type GWarehouseFulfillmentDiscrepancyLinesQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
  deliveryDate: Scalars['ISO8601Date'];
  first: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type GWarehouseFulfillmentDiscrepancyLinesQuery = { __typename?: 'Query', warehouseFulfillmentDiscrepancyLines: { __typename?: 'WarehouseFulfillmentDiscrepancyLinesReport', totalCount: number, orderLines: Array<{ __typename?: 'WarehouseFulfillmentDiscrepancyLine', routeName?: string, stopNumber?: number, itemName?: string, orderedUnits: number, committedUnits: number, fulfillmentUnits: number, order: { __typename?: 'Order', id: string, orderNumber: string, erpRecordUrl?: string, location: { __typename?: 'Location', id: string, businessName: string } } }> } };

export type GWarehouseFulfillmentSummaryQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
  deliveryDate: Scalars['ISO8601Date'];
}>;


export type GWarehouseFulfillmentSummaryQuery = { __typename?: 'Query', warehouseFulfillmentSummary: { __typename?: 'WarehouseFulfillmentSummary', orderCount: number, committedUnits: number, fulfilledUnits: number } };

export type GWarehouseRoutesSyncStatusQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
  nightEnd: Scalars['ISO8601Date'];
}>;


export type GWarehouseRoutesSyncStatusQuery = { __typename?: 'Query', warehouseRoutesSyncStatus: { __typename?: 'WarehouseRoutesSyncStatus', syncedAt?: any, planChangedSinceSync: boolean } };

export type GGetWarehouseRoutingImportPlanComparisonQueryVariables = Exact<{
  input: GRoutingImportPlanInput;
}>;


export type GGetWarehouseRoutingImportPlanComparisonQuery = { __typename?: 'Query', routingImportPlan: { __typename?: 'RoutingImportPlan', id: string, appliedRoutificRun?: { __typename?: 'RoutificRunSummary', id: string, status: GRoutificRunStatus, createdAt: any, routeCount?: number, totalStops?: number, totalDistanceMiles?: number, avgCubicUtilizationPercent?: number, estimatedDriverHours?: number, dprh?: number, unservedCount?: number, vehicleStopIds?: any, automatedRoutingExclusions?: Array<{ __typename?: 'AutomatedRoutingExclusion', stopId: string, locationId: string, locationName?: string, reason: GAutomatedRoutingExclusionReason }> }, manualRoutificRuns: Array<{ __typename?: 'RoutificRunSummary', id: string, status: GRoutificRunStatus, createdAt: any, runType: string }>, actualRoutesSummary?: { __typename?: 'ActualRoutesSummary', routeCount: number, totalStops: number, totalDistanceMiles?: number, avgCubicUtilizationPercent?: number, driverHours?: number, dprh?: number }, etasStatus: { __typename?: 'EtasStatus', stale: boolean, reason?: GEtasStatusReason, lastCalculatedAt?: any, lastCalculatedRunId?: string } } };

export type GGetWarehouseThirdPartyProvidersQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
}>;


export type GGetWarehouseThirdPartyProvidersQuery = { __typename?: 'Query', warehouse: { __typename?: 'Warehouse', id: string, thirdPartyProviders: Array<GThirdPartyProvider> } };

export type GGetWarehousePickupPrefillQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
  provider: GThirdPartyProvider;
}>;


export type GGetWarehousePickupPrefillQuery = { __typename?: 'Query', warehouse: { __typename?: 'Warehouse', id: string, lastThirdPartyPickupTime?: string } };

export type GGetWarehouseTrendsQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
  startDate: Scalars['ISO8601Date'];
  endDate: Scalars['ISO8601Date'];
}>;


export type GGetWarehouseTrendsQuery = { __typename?: 'Query', warehouseTrends: Array<{ __typename?: 'WarehouseTrendDay', date: any, metrobiRoutes: number, changes: { __typename?: 'WarehouseTrendChanges', routesAdded?: number, routesRemoved?: number, stopsReordered: number, stopsDeliveredOutOfOrder: number, stopsDeliveredTotal: number, lowBreadcrumbRoutes: number, breadcrumbTrackedRoutes: number, recoveryStopsCompleted: number, recoveryStopsTotal: number, totalChanges?: number, lowBreadcrumbRouteDetails: Array<{ __typename?: 'WarehouseTrendLowBreadcrumbRoute', id: string, routeNo?: number, drivenDistanceMiles?: number }> }, originalRoutificPlan: { __typename?: 'WarehouseTrendMetrics', available: { __typename?: 'WarehouseTrendAvailableMetrics', miles?: number, driverHours?: number, dprh?: number, dprhDeliveries: number, dprhDriverHours?: number, coverage: { __typename?: 'WarehouseTrendCoverage', totalRoutes: number, milesRoutes: number, driverHoursRoutes: number, dprhRoutes: number } } }, dispatchPlan: { __typename?: 'WarehouseTrendMetrics', available: { __typename?: 'WarehouseTrendAvailableMetrics', miles?: number, driverHours?: number, dprh?: number, dprhDeliveries: number, dprhDriverHours?: number, coverage: { __typename?: 'WarehouseTrendCoverage', totalRoutes: number, milesRoutes: number, driverHoursRoutes: number, dprhRoutes: number } } }, actual: { __typename?: 'WarehouseTrendMetrics', available: { __typename?: 'WarehouseTrendAvailableMetrics', miles?: number, driverHours?: number, dprh?: number, dprhDeliveries: number, dprhDriverHours?: number, coverage: { __typename?: 'WarehouseTrendCoverage', totalRoutes: number, milesRoutes: number, driverHoursRoutes: number, dprhRoutes: number } } } }> };

export type GAvailableTrendMetricsFragment = { __typename?: 'WarehouseTrendMetrics', available: { __typename?: 'WarehouseTrendAvailableMetrics', miles?: number, driverHours?: number, dprh?: number, dprhDeliveries: number, dprhDriverHours?: number, coverage: { __typename?: 'WarehouseTrendCoverage', totalRoutes: number, milesRoutes: number, driverHoursRoutes: number, dprhRoutes: number } } };

export type GMarkCustomerPickupStopsCompleteMutationVariables = Exact<{
  input: GMarkCustomerPickupStopsCompleteInput;
}>;


export type GMarkCustomerPickupStopsCompleteMutation = { __typename?: 'Mutation', markCustomerPickupStopsComplete?: { __typename?: 'MarkCustomerPickupStopsCompletePayload', routes?: Array<{ __typename?: 'Route', color?: string, id: string, name: string, isLobby: boolean, thirdPartyRoute: boolean, thirdPartyProvider?: GThirdPartyProvider, bucketRoute: boolean, customerPickupRoute: boolean, nightEnd: any, nightEndLocked: boolean, stopTime?: any, totalVolume?: number, totalWeight?: number, percentItemsWithWeight?: number, percentItemsWithVolume?: number, redeliveryRoute: boolean, routeOrigin?: string, routeCohort?: string, shiftType?: string, providerDispatch?: { __typename?: 'ProviderDispatch', status: GProviderDispatchStatus, pickupAt?: any, error?: string, courierAlertSentAt?: any, cancelRequestedAt?: any, cancelable: boolean, unmarkable: boolean, chosenQuote?: { __typename?: 'ProviderQuote', id: string, provider?: string, cost?: number, fee?: number } }, stops?: Array<{ __typename: 'Delivery', id: string, sequenceNumber?: string, totalWeight?: number, totalVolume?: number, deliveryNote?: string, completedAt?: any, location?: { __typename?: 'Location', effectivelyExcluded: boolean, displayAddress: string, id: string, membershipTier: GLocationMembershipTier, includeInAutomatedRouting?: boolean, businessName: string, isDoordash: boolean, scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, address: { __typename?: 'Address', latitude?: number, longitude?: number, state: string }, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', startTime: string, endTime: string }, routingCohort?: { __typename?: 'RoutingCohort', id: string, color?: string, name: string }, warehouseDeliveryRules: Array<{ __typename?: 'DeliveryRule', deliveryDay: number }> }, orders?: Array<{ __typename?: 'Order', id: string, deliveryMethod: GOrderDeliveryMethodEnum, scheduledDeliveryTime?: { __typename?: 'ScheduledDeliveryTime', earliest: string, latest: string, timeZone: string } }>, providerDelivery?: { __typename?: 'ProviderDelivery', status?: string, courierAssigned: boolean, courierName?: string, dropoffEta?: any, trackingUrl?: string, proofUrls: Array<string>, needsAttention: boolean, needsAttentionReason?: string }, route: { __typename?: 'Route', id: string, name: string, truck?: { __typename?: 'Truck', maxWeight: number, maxVolume: number, vin?: string, vehicleTag?: string } } } | { __typename: 'PickUp', id: string, sequenceNumber?: string, vendor: { __typename?: 'Vendor', name: string, legalName: string, address?: { __typename?: 'Address', latitude?: number, longitude?: number, state: string } } }>, redeliveryStops: Array<{ __typename?: 'Redelivery', id: string, sequenceNumber?: string, deliveryStop: { __typename?: 'Delivery', id: string }, location?: { __typename?: 'Location', effectivelyExcluded: boolean, displayAddress: string, id: string, includeInAutomatedRouting?: boolean, businessName: string, isDoordash: boolean, scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, address: { __typename?: 'Address', latitude?: number, longitude?: number, state: string }, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', startTime: string, endTime: string }, routingCohort?: { __typename?: 'RoutingCohort', id: string, color?: string, name: string }, warehouseDeliveryRules: Array<{ __typename?: 'DeliveryRule', deliveryDay: number }> }, orders?: Array<{ __typename?: 'Order', id: string, deliveryMethod: GOrderDeliveryMethodEnum, scheduledDeliveryTime?: { __typename?: 'ScheduledDeliveryTime', earliest: string, latest: string, timeZone: string } }>, providerDelivery?: { __typename?: 'ProviderDelivery', status?: string, courierAssigned: boolean, courierName?: string, dropoffEta?: any, trackingUrl?: string, proofUrls: Array<string>, needsAttention: boolean, needsAttentionReason?: string }, route: { __typename?: 'Route', id: string, name: string, truck?: { __typename?: 'Truck', maxWeight: number, maxVolume: number, vin?: string, vehicleTag?: string } } }>, driverUser?: { __typename?: 'User', id: string, name?: string, email?: string }, helperDriverUser?: { __typename?: 'User', id: string, name?: string, email?: string }, truck?: { __typename?: 'Truck', maxVolume: number, maxWeight: number, vin?: string, vehicleTag?: string }, plannedVehicle?: { __typename?: 'PlannedVehicle', maxVolume?: number, maxWeight?: number, vehicleType?: string } }>, userErrors: Array<{ __typename: 'CompletedCustomerPickupStop', message: string } | { __typename: 'InvalidNightEnd', message: string } | { __typename: 'MetrobiAssignmentBlocked', message: string } | { __typename: 'NonCustomerPickupStops', message: string } | { __typename: 'NonMovableStops', message: string } | { __typename: 'PickupRoutingDisabled', message: string } | { __typename: 'ProviderRouteGuarded', message: string } | { __typename: 'UncountedLineTrackedOrders', message: string } | { __typename: 'UnresolvedTasks', message: string }> } };

export type GMarkItemsAsBulkPickedMutationVariables = Exact<{
  input: GMarkItemsAsBulkPickedMutationInput;
}>;


export type GMarkItemsAsBulkPickedMutation = { __typename?: 'Mutation', markItemsAsBulkPicked?: { __typename?: 'MarkItemsAsBulkPickedMutationPayload', success: boolean, userErrors: Array<{ __typename?: 'BulkItemError', message: string, path?: Array<string> }> } };

export type GMarkRouteForProviderMutationVariables = Exact<{
  input: GMarkRouteForProviderInput;
}>;


export type GMarkRouteForProviderMutation = { __typename?: 'Mutation', markRouteForProvider?: { __typename?: 'MarkRouteForProviderPayload', route?: { __typename?: 'Route', color?: string, id: string, name: string, isLobby: boolean, thirdPartyRoute: boolean, thirdPartyProvider?: GThirdPartyProvider, bucketRoute: boolean, customerPickupRoute: boolean, nightEnd: any, nightEndLocked: boolean, stopTime?: any, totalVolume?: number, totalWeight?: number, percentItemsWithWeight?: number, percentItemsWithVolume?: number, redeliveryRoute: boolean, routeOrigin?: string, routeCohort?: string, shiftType?: string, providerDispatch?: { __typename?: 'ProviderDispatch', status: GProviderDispatchStatus, pickupAt?: any, error?: string, courierAlertSentAt?: any, cancelRequestedAt?: any, cancelable: boolean, unmarkable: boolean, chosenQuote?: { __typename?: 'ProviderQuote', id: string, provider?: string, cost?: number, fee?: number } }, stops?: Array<{ __typename: 'Delivery', id: string, sequenceNumber?: string, totalWeight?: number, totalVolume?: number, deliveryNote?: string, completedAt?: any, location?: { __typename?: 'Location', effectivelyExcluded: boolean, displayAddress: string, id: string, membershipTier: GLocationMembershipTier, includeInAutomatedRouting?: boolean, businessName: string, isDoordash: boolean, scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, address: { __typename?: 'Address', latitude?: number, longitude?: number, state: string }, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', startTime: string, endTime: string }, routingCohort?: { __typename?: 'RoutingCohort', id: string, color?: string, name: string }, warehouseDeliveryRules: Array<{ __typename?: 'DeliveryRule', deliveryDay: number }> }, orders?: Array<{ __typename?: 'Order', id: string, deliveryMethod: GOrderDeliveryMethodEnum, scheduledDeliveryTime?: { __typename?: 'ScheduledDeliveryTime', earliest: string, latest: string, timeZone: string } }>, providerDelivery?: { __typename?: 'ProviderDelivery', status?: string, courierAssigned: boolean, courierName?: string, dropoffEta?: any, trackingUrl?: string, proofUrls: Array<string>, needsAttention: boolean, needsAttentionReason?: string }, route: { __typename?: 'Route', id: string, name: string, truck?: { __typename?: 'Truck', maxWeight: number, maxVolume: number, vin?: string, vehicleTag?: string } } } | { __typename: 'PickUp', id: string, sequenceNumber?: string, vendor: { __typename?: 'Vendor', name: string, legalName: string, address?: { __typename?: 'Address', latitude?: number, longitude?: number, state: string } } }>, redeliveryStops: Array<{ __typename?: 'Redelivery', id: string, sequenceNumber?: string, deliveryStop: { __typename?: 'Delivery', id: string }, location?: { __typename?: 'Location', effectivelyExcluded: boolean, displayAddress: string, id: string, includeInAutomatedRouting?: boolean, businessName: string, isDoordash: boolean, scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, address: { __typename?: 'Address', latitude?: number, longitude?: number, state: string }, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', startTime: string, endTime: string }, routingCohort?: { __typename?: 'RoutingCohort', id: string, color?: string, name: string }, warehouseDeliveryRules: Array<{ __typename?: 'DeliveryRule', deliveryDay: number }> }, orders?: Array<{ __typename?: 'Order', id: string, deliveryMethod: GOrderDeliveryMethodEnum, scheduledDeliveryTime?: { __typename?: 'ScheduledDeliveryTime', earliest: string, latest: string, timeZone: string } }>, providerDelivery?: { __typename?: 'ProviderDelivery', status?: string, courierAssigned: boolean, courierName?: string, dropoffEta?: any, trackingUrl?: string, proofUrls: Array<string>, needsAttention: boolean, needsAttentionReason?: string }, route: { __typename?: 'Route', id: string, name: string, truck?: { __typename?: 'Truck', maxWeight: number, maxVolume: number, vin?: string, vehicleTag?: string } } }>, driverUser?: { __typename?: 'User', id: string, name?: string, email?: string }, helperDriverUser?: { __typename?: 'User', id: string, name?: string, email?: string }, truck?: { __typename?: 'Truck', maxVolume: number, maxWeight: number, vin?: string, vehicleTag?: string }, plannedVehicle?: { __typename?: 'PlannedVehicle', maxVolume?: number, maxWeight?: number, vehicleType?: string } }, userErrors: Array<{ __typename: 'DispatchNotAllowed', message: string } | { __typename: 'DispatchProfileIncomplete', message: string } | { __typename: 'ProviderNotAvailable', message: string } | { __typename: 'ProviderRejected', message: string } | { __typename: 'RouteNotFound', message: string } | { __typename: 'RouteNotMarkable', message: string } | { __typename: 'StopsNotEscalatable', message: string } | { __typename: 'UnmarkNotAllowed', message: string }> } };

export type GMoveDeliveryStopsToCustomerPickupMutationVariables = Exact<{
  input: GMoveDeliveryStopsToCustomerPickupInput;
}>;


export type GMoveDeliveryStopsToCustomerPickupMutation = { __typename?: 'Mutation', moveDeliveryStopsToCustomerPickup?: { __typename?: 'MoveDeliveryStopsToCustomerPickupPayload', updatedRoutes?: Array<{ __typename?: 'Route', color?: string, id: string, name: string, isLobby: boolean, thirdPartyRoute: boolean, thirdPartyProvider?: GThirdPartyProvider, bucketRoute: boolean, customerPickupRoute: boolean, nightEnd: any, nightEndLocked: boolean, stopTime?: any, totalVolume?: number, totalWeight?: number, percentItemsWithWeight?: number, percentItemsWithVolume?: number, redeliveryRoute: boolean, routeOrigin?: string, routeCohort?: string, shiftType?: string, providerDispatch?: { __typename?: 'ProviderDispatch', status: GProviderDispatchStatus, pickupAt?: any, error?: string, courierAlertSentAt?: any, cancelRequestedAt?: any, cancelable: boolean, unmarkable: boolean, chosenQuote?: { __typename?: 'ProviderQuote', id: string, provider?: string, cost?: number, fee?: number } }, stops?: Array<{ __typename: 'Delivery', id: string, sequenceNumber?: string, totalWeight?: number, totalVolume?: number, deliveryNote?: string, completedAt?: any, location?: { __typename?: 'Location', effectivelyExcluded: boolean, displayAddress: string, id: string, membershipTier: GLocationMembershipTier, includeInAutomatedRouting?: boolean, businessName: string, isDoordash: boolean, scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, address: { __typename?: 'Address', latitude?: number, longitude?: number, state: string }, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', startTime: string, endTime: string }, routingCohort?: { __typename?: 'RoutingCohort', id: string, color?: string, name: string }, warehouseDeliveryRules: Array<{ __typename?: 'DeliveryRule', deliveryDay: number }> }, orders?: Array<{ __typename?: 'Order', id: string, deliveryMethod: GOrderDeliveryMethodEnum, scheduledDeliveryTime?: { __typename?: 'ScheduledDeliveryTime', earliest: string, latest: string, timeZone: string } }>, providerDelivery?: { __typename?: 'ProviderDelivery', status?: string, courierAssigned: boolean, courierName?: string, dropoffEta?: any, trackingUrl?: string, proofUrls: Array<string>, needsAttention: boolean, needsAttentionReason?: string }, route: { __typename?: 'Route', id: string, name: string, truck?: { __typename?: 'Truck', maxWeight: number, maxVolume: number, vin?: string, vehicleTag?: string } } } | { __typename: 'PickUp', id: string, sequenceNumber?: string, vendor: { __typename?: 'Vendor', name: string, legalName: string, address?: { __typename?: 'Address', latitude?: number, longitude?: number, state: string } } }>, redeliveryStops: Array<{ __typename?: 'Redelivery', id: string, sequenceNumber?: string, deliveryStop: { __typename?: 'Delivery', id: string }, location?: { __typename?: 'Location', effectivelyExcluded: boolean, displayAddress: string, id: string, includeInAutomatedRouting?: boolean, businessName: string, isDoordash: boolean, scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, address: { __typename?: 'Address', latitude?: number, longitude?: number, state: string }, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', startTime: string, endTime: string }, routingCohort?: { __typename?: 'RoutingCohort', id: string, color?: string, name: string }, warehouseDeliveryRules: Array<{ __typename?: 'DeliveryRule', deliveryDay: number }> }, orders?: Array<{ __typename?: 'Order', id: string, deliveryMethod: GOrderDeliveryMethodEnum, scheduledDeliveryTime?: { __typename?: 'ScheduledDeliveryTime', earliest: string, latest: string, timeZone: string } }>, providerDelivery?: { __typename?: 'ProviderDelivery', status?: string, courierAssigned: boolean, courierName?: string, dropoffEta?: any, trackingUrl?: string, proofUrls: Array<string>, needsAttention: boolean, needsAttentionReason?: string }, route: { __typename?: 'Route', id: string, name: string, truck?: { __typename?: 'Truck', maxWeight: number, maxVolume: number, vin?: string, vehicleTag?: string } } }>, driverUser?: { __typename?: 'User', id: string, name?: string, email?: string }, helperDriverUser?: { __typename?: 'User', id: string, name?: string, email?: string }, truck?: { __typename?: 'Truck', maxVolume: number, maxWeight: number, vin?: string, vehicleTag?: string }, plannedVehicle?: { __typename?: 'PlannedVehicle', maxVolume?: number, maxWeight?: number, vehicleType?: string } }>, userErrors: Array<{ __typename: 'CompletedCustomerPickupStop', message: string } | { __typename: 'InvalidNightEnd', message: string } | { __typename: 'MetrobiAssignmentBlocked', message: string } | { __typename: 'NonCustomerPickupStops', message: string } | { __typename: 'NonMovableStops', message: string } | { __typename: 'PickupRoutingDisabled', message: string } | { __typename: 'ProviderRouteGuarded', message: string } | { __typename: 'UncountedLineTrackedOrders', message: string } | { __typename: 'UnresolvedTasks', message: string }> } };

export type GUpdateRouteDetailsMutationVariables = Exact<{
  input: GRouteDetailsUpdateInput;
}>;


export type GUpdateRouteDetailsMutation = { __typename?: 'Mutation', updateRouteDetails?: { __typename?: 'RouteDetailsUpdatePayload', route?: { __typename?: 'Route', id: string, driverUser?: { __typename?: 'User', id: string, name?: string }, helperDriverUser?: { __typename?: 'User', id: string, name?: string } }, userErrors: Array<{ __typename: 'AutomatedRoutingPending' } | { __typename: 'BulkUpdateDeprecated' } | { __typename: 'InvalidNightEnd' } | { __typename: 'ProviderRouteGuarded' } | { __typename: 'RouteEnded' }> } };

export type GDeliveryStopsReorderMutationVariables = Exact<{
  input: GDeliveryStopsReorderInput;
}>;


export type GDeliveryStopsReorderMutation = { __typename?: 'Mutation', deliveryStopsReorder?: { __typename?: 'DeliveryStopsReorderPayload', userErrors: Array<{ __typename: 'CompletedCustomerPickupStop' } | { __typename: 'InvalidNightEnd' } | { __typename: 'MetrobiAssignmentBlocked' } | { __typename: 'NonCustomerPickupStops' } | { __typename: 'NonMovableStops' } | { __typename: 'PickupRoutingDisabled' } | { __typename: 'ProviderRouteGuarded' } | { __typename: 'UncountedLineTrackedOrders' } | { __typename: 'UnresolvedTasks' }>, route?: { __typename?: 'Route', color?: string, id: string, name: string, isLobby: boolean, thirdPartyRoute: boolean, thirdPartyProvider?: GThirdPartyProvider, bucketRoute: boolean, customerPickupRoute: boolean, nightEnd: any, nightEndLocked: boolean, stopTime?: any, totalVolume?: number, totalWeight?: number, percentItemsWithWeight?: number, percentItemsWithVolume?: number, redeliveryRoute: boolean, routeOrigin?: string, routeCohort?: string, shiftType?: string, providerDispatch?: { __typename?: 'ProviderDispatch', status: GProviderDispatchStatus, pickupAt?: any, error?: string, courierAlertSentAt?: any, cancelRequestedAt?: any, cancelable: boolean, unmarkable: boolean, chosenQuote?: { __typename?: 'ProviderQuote', id: string, provider?: string, cost?: number, fee?: number } }, stops?: Array<{ __typename: 'Delivery', id: string, sequenceNumber?: string, totalWeight?: number, totalVolume?: number, deliveryNote?: string, completedAt?: any, location?: { __typename?: 'Location', effectivelyExcluded: boolean, displayAddress: string, id: string, membershipTier: GLocationMembershipTier, includeInAutomatedRouting?: boolean, businessName: string, isDoordash: boolean, scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, address: { __typename?: 'Address', latitude?: number, longitude?: number, state: string }, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', startTime: string, endTime: string }, routingCohort?: { __typename?: 'RoutingCohort', id: string, color?: string, name: string }, warehouseDeliveryRules: Array<{ __typename?: 'DeliveryRule', deliveryDay: number }> }, orders?: Array<{ __typename?: 'Order', id: string, deliveryMethod: GOrderDeliveryMethodEnum, scheduledDeliveryTime?: { __typename?: 'ScheduledDeliveryTime', earliest: string, latest: string, timeZone: string } }>, providerDelivery?: { __typename?: 'ProviderDelivery', status?: string, courierAssigned: boolean, courierName?: string, dropoffEta?: any, trackingUrl?: string, proofUrls: Array<string>, needsAttention: boolean, needsAttentionReason?: string }, route: { __typename?: 'Route', id: string, name: string, truck?: { __typename?: 'Truck', maxWeight: number, maxVolume: number, vin?: string, vehicleTag?: string } } } | { __typename: 'PickUp', id: string, sequenceNumber?: string, vendor: { __typename?: 'Vendor', name: string, legalName: string, address?: { __typename?: 'Address', latitude?: number, longitude?: number, state: string } } }>, redeliveryStops: Array<{ __typename?: 'Redelivery', id: string, sequenceNumber?: string, deliveryStop: { __typename?: 'Delivery', id: string }, location?: { __typename?: 'Location', effectivelyExcluded: boolean, displayAddress: string, id: string, includeInAutomatedRouting?: boolean, businessName: string, isDoordash: boolean, scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, address: { __typename?: 'Address', latitude?: number, longitude?: number, state: string }, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', startTime: string, endTime: string }, routingCohort?: { __typename?: 'RoutingCohort', id: string, color?: string, name: string }, warehouseDeliveryRules: Array<{ __typename?: 'DeliveryRule', deliveryDay: number }> }, orders?: Array<{ __typename?: 'Order', id: string, deliveryMethod: GOrderDeliveryMethodEnum, scheduledDeliveryTime?: { __typename?: 'ScheduledDeliveryTime', earliest: string, latest: string, timeZone: string } }>, providerDelivery?: { __typename?: 'ProviderDelivery', status?: string, courierAssigned: boolean, courierName?: string, dropoffEta?: any, trackingUrl?: string, proofUrls: Array<string>, needsAttention: boolean, needsAttentionReason?: string }, route: { __typename?: 'Route', id: string, name: string, truck?: { __typename?: 'Truck', maxWeight: number, maxVolume: number, vin?: string, vehicleTag?: string } } }>, driverUser?: { __typename?: 'User', id: string, name?: string, email?: string }, helperDriverUser?: { __typename?: 'User', id: string, name?: string, email?: string }, truck?: { __typename?: 'Truck', maxVolume: number, maxWeight: number, vin?: string, vehicleTag?: string }, plannedVehicle?: { __typename?: 'PlannedVehicle', maxVolume?: number, maxWeight?: number, vehicleType?: string } } } };

export type GMoveDeliveryStopsToRouteMutationVariables = Exact<{
  input: GDeliveryStopsMoveToRouteInput;
}>;


export type GMoveDeliveryStopsToRouteMutation = { __typename?: 'Mutation', moveDeliveryStopsToRoute?: { __typename?: 'DeliveryStopsMoveToRoutePayload', updatedRoutes?: Array<{ __typename?: 'Route', color?: string, id: string, name: string, isLobby: boolean, thirdPartyRoute: boolean, thirdPartyProvider?: GThirdPartyProvider, bucketRoute: boolean, customerPickupRoute: boolean, nightEnd: any, nightEndLocked: boolean, stopTime?: any, totalVolume?: number, totalWeight?: number, percentItemsWithWeight?: number, percentItemsWithVolume?: number, redeliveryRoute: boolean, routeOrigin?: string, routeCohort?: string, shiftType?: string, providerDispatch?: { __typename?: 'ProviderDispatch', status: GProviderDispatchStatus, pickupAt?: any, error?: string, courierAlertSentAt?: any, cancelRequestedAt?: any, cancelable: boolean, unmarkable: boolean, chosenQuote?: { __typename?: 'ProviderQuote', id: string, provider?: string, cost?: number, fee?: number } }, stops?: Array<{ __typename: 'Delivery', id: string, sequenceNumber?: string, totalWeight?: number, totalVolume?: number, deliveryNote?: string, completedAt?: any, location?: { __typename?: 'Location', effectivelyExcluded: boolean, displayAddress: string, id: string, membershipTier: GLocationMembershipTier, includeInAutomatedRouting?: boolean, businessName: string, isDoordash: boolean, scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, address: { __typename?: 'Address', latitude?: number, longitude?: number, state: string }, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', startTime: string, endTime: string }, routingCohort?: { __typename?: 'RoutingCohort', id: string, color?: string, name: string }, warehouseDeliveryRules: Array<{ __typename?: 'DeliveryRule', deliveryDay: number }> }, orders?: Array<{ __typename?: 'Order', id: string, deliveryMethod: GOrderDeliveryMethodEnum, scheduledDeliveryTime?: { __typename?: 'ScheduledDeliveryTime', earliest: string, latest: string, timeZone: string } }>, providerDelivery?: { __typename?: 'ProviderDelivery', status?: string, courierAssigned: boolean, courierName?: string, dropoffEta?: any, trackingUrl?: string, proofUrls: Array<string>, needsAttention: boolean, needsAttentionReason?: string }, route: { __typename?: 'Route', id: string, name: string, truck?: { __typename?: 'Truck', maxWeight: number, maxVolume: number, vin?: string, vehicleTag?: string } } } | { __typename: 'PickUp', id: string, sequenceNumber?: string, vendor: { __typename?: 'Vendor', name: string, legalName: string, address?: { __typename?: 'Address', latitude?: number, longitude?: number, state: string } } }>, redeliveryStops: Array<{ __typename?: 'Redelivery', id: string, sequenceNumber?: string, deliveryStop: { __typename?: 'Delivery', id: string }, location?: { __typename?: 'Location', effectivelyExcluded: boolean, displayAddress: string, id: string, includeInAutomatedRouting?: boolean, businessName: string, isDoordash: boolean, scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, address: { __typename?: 'Address', latitude?: number, longitude?: number, state: string }, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', startTime: string, endTime: string }, routingCohort?: { __typename?: 'RoutingCohort', id: string, color?: string, name: string }, warehouseDeliveryRules: Array<{ __typename?: 'DeliveryRule', deliveryDay: number }> }, orders?: Array<{ __typename?: 'Order', id: string, deliveryMethod: GOrderDeliveryMethodEnum, scheduledDeliveryTime?: { __typename?: 'ScheduledDeliveryTime', earliest: string, latest: string, timeZone: string } }>, providerDelivery?: { __typename?: 'ProviderDelivery', status?: string, courierAssigned: boolean, courierName?: string, dropoffEta?: any, trackingUrl?: string, proofUrls: Array<string>, needsAttention: boolean, needsAttentionReason?: string }, route: { __typename?: 'Route', id: string, name: string, truck?: { __typename?: 'Truck', maxWeight: number, maxVolume: number, vin?: string, vehicleTag?: string } } }>, driverUser?: { __typename?: 'User', id: string, name?: string, email?: string }, helperDriverUser?: { __typename?: 'User', id: string, name?: string, email?: string }, truck?: { __typename?: 'Truck', maxVolume: number, maxWeight: number, vin?: string, vehicleTag?: string }, plannedVehicle?: { __typename?: 'PlannedVehicle', maxVolume?: number, maxWeight?: number, vehicleType?: string } }>, userErrors: Array<{ __typename: 'CompletedCustomerPickupStop', message: string } | { __typename: 'InvalidNightEnd', message: string } | { __typename: 'MetrobiAssignmentBlocked', message: string, offenders: Array<{ __typename?: 'MetrobiExcludedStop', stopId: string, locationId: string, businessName?: string, address?: string }> } | { __typename: 'NonCustomerPickupStops', message: string } | { __typename: 'NonMovableStops', message: string } | { __typename: 'PickupRoutingDisabled', message: string } | { __typename: 'ProviderRouteGuarded', message: string } | { __typename: 'UncountedLineTrackedOrders', message: string } | { __typename: 'UnresolvedTasks', message: string }> } };

export type GUpdateRouteStopDriverReminderMutationVariables = Exact<{
  input: GDeliveryRouteStopReminderUpdateInput;
}>;


export type GUpdateRouteStopDriverReminderMutation = { __typename?: 'Mutation', updateRouteStopDriverReminder?: { __typename?: 'DeliveryRouteStopReminderUpdatePayload', stop?: { __typename?: 'Delivery', id: string, reminderMessage?: string } | { __typename?: 'PickUp', id: string, reminderMessage?: string }, userErrors: Array<{ __typename: 'CompletedCustomerPickupStop' } | { __typename: 'InvalidNightEnd' } | { __typename: 'MetrobiAssignmentBlocked' } | { __typename: 'NonCustomerPickupStops' } | { __typename: 'NonMovableStops' } | { __typename: 'PickupRoutingDisabled' } | { __typename: 'ProviderRouteGuarded' } | { __typename: 'UncountedLineTrackedOrders' } | { __typename: 'UnresolvedTasks' }> } };

export type GCreateRouteStopTaskMutationVariables = Exact<{
  input: GDeliveryRouteStopTaskCreateInput;
}>;


export type GCreateRouteStopTaskMutation = { __typename?: 'Mutation', createRouteStopTask?: { __typename?: 'DeliveryRouteStopTaskCreatePayload', task?: { __typename?: 'DeliveryRouteStopTask', id: string, details: string, status: GDeliveryRouteStopTaskStatus, resolvedAt?: any, driverNote?: string, createdAt: any }, userErrors: Array<{ __typename: 'InvalidNightEnd' } | { __typename: 'TaskAlreadyResolved' } | { __typename: 'TaskNotFound' } | { __typename: 'TaskNoteRequired' }> } };

export type GUpdateRouteStopTaskMutationVariables = Exact<{
  input: GDeliveryRouteStopTaskUpdateInput;
}>;


export type GUpdateRouteStopTaskMutation = { __typename?: 'Mutation', updateRouteStopTask?: { __typename?: 'DeliveryRouteStopTaskUpdatePayload', task?: { __typename?: 'DeliveryRouteStopTask', id: string, details: string, status: GDeliveryRouteStopTaskStatus, resolvedAt?: any, driverNote?: string, createdAt: any }, userErrors: Array<{ __typename: 'InvalidNightEnd' } | { __typename: 'TaskAlreadyResolved' } | { __typename: 'TaskNotFound' } | { __typename: 'TaskNoteRequired' }> } };

export type GDeleteRouteStopTaskMutationVariables = Exact<{
  input: GDeliveryRouteStopTaskDeleteInput;
}>;


export type GDeleteRouteStopTaskMutation = { __typename?: 'Mutation', deleteRouteStopTask?: { __typename?: 'DeliveryRouteStopTaskDeletePayload', userErrors: Array<{ __typename: 'InvalidNightEnd' } | { __typename: 'TaskAlreadyResolved' } | { __typename: 'TaskNotFound' } | { __typename: 'TaskNoteRequired' }> } };

export type GCreateWarehouseDeliveryRouteMutationVariables = Exact<{
  input: GDeliveryRouteCreateInput;
}>;


export type GCreateWarehouseDeliveryRouteMutation = { __typename?: 'Mutation', createWarehouseDeliveryRoute?: { __typename?: 'DeliveryRouteCreatePayload', route?: { __typename?: 'Route', color?: string, id: string, name: string, isLobby: boolean, thirdPartyRoute: boolean, thirdPartyProvider?: GThirdPartyProvider, bucketRoute: boolean, customerPickupRoute: boolean, nightEnd: any, nightEndLocked: boolean, stopTime?: any, totalVolume?: number, totalWeight?: number, percentItemsWithWeight?: number, percentItemsWithVolume?: number, redeliveryRoute: boolean, routeOrigin?: string, routeCohort?: string, shiftType?: string, providerDispatch?: { __typename?: 'ProviderDispatch', status: GProviderDispatchStatus, pickupAt?: any, error?: string, courierAlertSentAt?: any, cancelRequestedAt?: any, cancelable: boolean, unmarkable: boolean, chosenQuote?: { __typename?: 'ProviderQuote', id: string, provider?: string, cost?: number, fee?: number } }, stops?: Array<{ __typename: 'Delivery', id: string, sequenceNumber?: string, totalWeight?: number, totalVolume?: number, deliveryNote?: string, completedAt?: any, location?: { __typename?: 'Location', effectivelyExcluded: boolean, displayAddress: string, id: string, membershipTier: GLocationMembershipTier, includeInAutomatedRouting?: boolean, businessName: string, isDoordash: boolean, scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, address: { __typename?: 'Address', latitude?: number, longitude?: number, state: string }, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', startTime: string, endTime: string }, routingCohort?: { __typename?: 'RoutingCohort', id: string, color?: string, name: string }, warehouseDeliveryRules: Array<{ __typename?: 'DeliveryRule', deliveryDay: number }> }, orders?: Array<{ __typename?: 'Order', id: string, deliveryMethod: GOrderDeliveryMethodEnum, scheduledDeliveryTime?: { __typename?: 'ScheduledDeliveryTime', earliest: string, latest: string, timeZone: string } }>, providerDelivery?: { __typename?: 'ProviderDelivery', status?: string, courierAssigned: boolean, courierName?: string, dropoffEta?: any, trackingUrl?: string, proofUrls: Array<string>, needsAttention: boolean, needsAttentionReason?: string }, route: { __typename?: 'Route', id: string, name: string, truck?: { __typename?: 'Truck', maxWeight: number, maxVolume: number, vin?: string, vehicleTag?: string } } } | { __typename: 'PickUp', id: string, sequenceNumber?: string, vendor: { __typename?: 'Vendor', name: string, legalName: string, address?: { __typename?: 'Address', latitude?: number, longitude?: number, state: string } } }>, redeliveryStops: Array<{ __typename?: 'Redelivery', id: string, sequenceNumber?: string, deliveryStop: { __typename?: 'Delivery', id: string }, location?: { __typename?: 'Location', effectivelyExcluded: boolean, displayAddress: string, id: string, includeInAutomatedRouting?: boolean, businessName: string, isDoordash: boolean, scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, address: { __typename?: 'Address', latitude?: number, longitude?: number, state: string }, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', startTime: string, endTime: string }, routingCohort?: { __typename?: 'RoutingCohort', id: string, color?: string, name: string }, warehouseDeliveryRules: Array<{ __typename?: 'DeliveryRule', deliveryDay: number }> }, orders?: Array<{ __typename?: 'Order', id: string, deliveryMethod: GOrderDeliveryMethodEnum, scheduledDeliveryTime?: { __typename?: 'ScheduledDeliveryTime', earliest: string, latest: string, timeZone: string } }>, providerDelivery?: { __typename?: 'ProviderDelivery', status?: string, courierAssigned: boolean, courierName?: string, dropoffEta?: any, trackingUrl?: string, proofUrls: Array<string>, needsAttention: boolean, needsAttentionReason?: string }, route: { __typename?: 'Route', id: string, name: string, truck?: { __typename?: 'Truck', maxWeight: number, maxVolume: number, vin?: string, vehicleTag?: string } } }>, driverUser?: { __typename?: 'User', id: string, name?: string, email?: string }, helperDriverUser?: { __typename?: 'User', id: string, name?: string, email?: string }, truck?: { __typename?: 'Truck', maxVolume: number, maxWeight: number, vin?: string, vehicleTag?: string }, plannedVehicle?: { __typename?: 'PlannedVehicle', maxVolume?: number, maxWeight?: number, vehicleType?: string } }, userErrors: Array<{ __typename: 'AutomatedRoutingPending' } | { __typename: 'BulkUpdateDeprecated' } | { __typename: 'InvalidNightEnd' } | { __typename: 'ProviderRouteGuarded' } | { __typename: 'RouteEnded' }> } };

export type GUpdateOrderWarehouseNoteMutationVariables = Exact<{
  input: GOrderWarehouseNoteUpdateInput;
}>;


export type GUpdateOrderWarehouseNoteMutation = { __typename?: 'Mutation', updateOrderWarehouseNote?: { __typename?: 'OrderWarehouseNoteUpdatePayload', userErrors: Array<{ __typename?: 'BlankNote' } | { __typename?: 'InvalidDeliveredQuantity' } | { __typename?: 'InvalidFulfillmentQuantity' } | { __typename?: 'MissingQtyDelivered' } | { __typename?: 'OrderLineNotFound' } | { __typename?: 'OrderNotEligibleForReview' } | { __typename?: 'OrderNotFound', message: string } | { __typename?: 'RecoveryQuantityOutOfRange' } | { __typename?: 'ReviewConfirmationMismatch' } | { __typename?: 'RouteEnded' }>, order?: { __typename?: 'Order', warehouseNote?: string } } };

export type GUpdateRoutingImportPlanTruckCountMutationVariables = Exact<{
  input: GRoutingImportPlanTruckCountUpdateInput;
}>;


export type GUpdateRoutingImportPlanTruckCountMutation = { __typename?: 'Mutation', updateRoutingImportPlanTruckCount?: { __typename?: 'RoutingImportPlanTruckCountUpdatePayload', routingImportPlan?: { __typename?: 'RoutingImportPlan', id: string, status: GRoutingImportPlanStatus, truckCount?: number }, userErrors: Array<{ __typename: 'InvalidNightEnd' } | { __typename: 'InvalidParameterOverrides' } | { __typename: 'InvalidRules' } | { __typename: 'RoutingImportPlanNotConfigured' } | { __typename: 'RoutingImportPlanNotFound' } | { __typename: 'ScenarioLimitReached' } | { __typename: 'ScenarioNotFound' } | { __typename: 'ScenarioRunsNotEnabled' } | { __typename: 'TruckCountInvalid' }> } };

export type GCreateRedeliveryStopsMutationVariables = Exact<{
  input: GRedeliveryStopCreateInput;
}>;


export type GCreateRedeliveryStopsMutation = { __typename?: 'Mutation', createRedeliveryStops?: { __typename?: 'RedeliveryStopCreatePayload', redeliveryStops?: Array<{ __typename?: 'Redelivery', id: string, deliveryStatusDmp: GDeliveryStatusDmp, deliveryStop: { __typename?: 'Delivery', id: string }, route: { __typename?: 'Route', id: string, name: string } }>, userErrors: Array<{ __typename: 'InvalidNightEnd' } | { __typename: 'StopWithProvider' } | { __typename: 'StopsBusy' }> } };

export type GDeleteRedeliveryStopMutationVariables = Exact<{
  input: GRedeliveryStopDeleteInput;
}>;


export type GDeleteRedeliveryStopMutation = { __typename?: 'Mutation', deleteRedeliveryStop?: { __typename?: 'RedeliveryStopDeletePayload', userErrors: Array<{ __typename: 'CompletedCustomerPickupStop' } | { __typename: 'InvalidNightEnd' } | { __typename: 'MetrobiAssignmentBlocked' } | { __typename: 'NonCustomerPickupStops' } | { __typename: 'NonMovableStops' } | { __typename: 'PickupRoutingDisabled' } | { __typename: 'ProviderRouteGuarded' } | { __typename: 'UncountedLineTrackedOrders' } | { __typename: 'UnresolvedTasks' }> } };

export type GUpdateOrderQuantityDeliveredMutationVariables = Exact<{
  input: GOrderQuantityDeliveredUpdateInput;
}>;


export type GUpdateOrderQuantityDeliveredMutation = { __typename?: 'Mutation', updateOrderQuantityDelivered?: { __typename?: 'OrderQuantityDeliveredUpdatePayload', orderLines?: Array<{ __typename?: 'OrderLine', id: string }> } };

export type GTriggerRoutesSyncMutationVariables = Exact<{
  input: GTriggerRoutesSyncInput;
}>;


export type GTriggerRoutesSyncMutation = { __typename?: 'Mutation', triggerRoutesSync?: { __typename?: 'TriggerRoutesSyncPayload', triggered: boolean, userErrors: Array<{ __typename: 'AutomatedRoutingPending' } | { __typename: 'BulkUpdateDeprecated' } | { __typename: 'InvalidNightEnd' } | { __typename: 'ProviderRouteGuarded' } | { __typename: 'RouteEnded' }> } };

export type GTriggerManualRoutificRunMutationVariables = Exact<{
  input: GTriggerManualRoutificRunInput;
}>;


export type GTriggerManualRoutificRunMutation = { __typename?: 'Mutation', triggerManualRoutificRun?: { __typename?: 'TriggerManualRoutificRunPayload', triggered: boolean, userErrors: Array<{ __typename: 'AutomatedRoutingPending', message: string } | { __typename: 'BulkUpdateDeprecated', message: string } | { __typename: 'InvalidNightEnd', message: string } | { __typename: 'ProviderRouteGuarded', message: string } | { __typename: 'RouteEnded', message: string }> } };

export type GOverrideCodeFieldsFragment = { __typename?: 'DockOverrideCode', id: string, code: string, active: boolean, vendorName?: string, netsuiteInternalId: string, createdBy?: string, createdAt: any };

type GOverrideCodeErrorFields_AdHocAppointmentsNotAllowed_Fragment = { __typename?: 'AdHocAppointmentsNotAllowed' };

type GOverrideCodeErrorFields_AppointmentInPast_Fragment = { __typename?: 'AppointmentInPast' };

type GOverrideCodeErrorFields_CarrierNameRequired_Fragment = { __typename?: 'CarrierNameRequired' };

type GOverrideCodeErrorFields_CheckInNotAllowed_Fragment = { __typename?: 'CheckInNotAllowed' };

type GOverrideCodeErrorFields_ContactDetailsRequired_Fragment = { __typename?: 'ContactDetailsRequired' };

type GOverrideCodeErrorFields_DailyDeliveryExists_Fragment = { __typename?: 'DailyDeliveryExists' };

type GOverrideCodeErrorFields_DepartNotAllowed_Fragment = { __typename?: 'DepartNotAllowed' };

type GOverrideCodeErrorFields_DockBookingAlreadyCompleted_Fragment = { __typename?: 'DockBookingAlreadyCompleted' };

type GOverrideCodeErrorFields_DockBookingAlreadyMissed_Fragment = { __typename?: 'DockBookingAlreadyMissed' };

type GOverrideCodeErrorFields_DockBookingNotBooked_Fragment = { __typename?: 'DockBookingNotBooked' };

type GOverrideCodeErrorFields_DockBookingNotFound_Fragment = { __typename?: 'DockBookingNotFound' };

type GOverrideCodeErrorFields_DockBookingWarehouseNotFound_Fragment = { __typename?: 'DockBookingWarehouseNotFound' };

type GOverrideCodeErrorFields_DockCapacityInvalid_Fragment = { __typename?: 'DockCapacityInvalid' };

type GOverrideCodeErrorFields_DockInUse_Fragment = { __typename?: 'DockInUse' };

type GOverrideCodeErrorFields_DockNotFound_Fragment = { __typename?: 'DockNotFound' };

type GOverrideCodeErrorFields_DockOverrideCodeInactive_Fragment = { __typename?: 'DockOverrideCodeInactive' };

type GOverrideCodeErrorFields_DockReassignNotAllowed_Fragment = { __typename?: 'DockReassignNotAllowed' };

type GOverrideCodeErrorFields_DockRecoveryNotAllowed_Fragment = { __typename?: 'DockRecoveryNotAllowed' };

type GOverrideCodeErrorFields_DockSlotUnavailable_Fragment = { __typename?: 'DockSlotUnavailable' };

type GOverrideCodeErrorFields_DockVisitNotFound_Fragment = { __typename?: 'DockVisitNotFound' };

type GOverrideCodeErrorFields_OverrideCodeIssueConflict_Fragment = { __typename?: 'OverrideCodeIssueConflict', errorCode: string, message: string };

type GOverrideCodeErrorFields_OverrideCodeNotFound_Fragment = { __typename?: 'OverrideCodeNotFound', errorCode: string, message: string };

type GOverrideCodeErrorFields_OverrideVendorNotFound_Fragment = { __typename?: 'OverrideVendorNotFound', errorCode: string, message: string };

type GOverrideCodeErrorFields_ShipDateRequired_Fragment = { __typename?: 'ShipDateRequired' };

type GOverrideCodeErrorFields_WithinLeadTime_Fragment = { __typename?: 'WithinLeadTime' };

export type GOverrideCodeErrorFieldsFragment = GOverrideCodeErrorFields_AdHocAppointmentsNotAllowed_Fragment | GOverrideCodeErrorFields_AppointmentInPast_Fragment | GOverrideCodeErrorFields_CarrierNameRequired_Fragment | GOverrideCodeErrorFields_CheckInNotAllowed_Fragment | GOverrideCodeErrorFields_ContactDetailsRequired_Fragment | GOverrideCodeErrorFields_DailyDeliveryExists_Fragment | GOverrideCodeErrorFields_DepartNotAllowed_Fragment | GOverrideCodeErrorFields_DockBookingAlreadyCompleted_Fragment | GOverrideCodeErrorFields_DockBookingAlreadyMissed_Fragment | GOverrideCodeErrorFields_DockBookingNotBooked_Fragment | GOverrideCodeErrorFields_DockBookingNotFound_Fragment | GOverrideCodeErrorFields_DockBookingWarehouseNotFound_Fragment | GOverrideCodeErrorFields_DockCapacityInvalid_Fragment | GOverrideCodeErrorFields_DockInUse_Fragment | GOverrideCodeErrorFields_DockNotFound_Fragment | GOverrideCodeErrorFields_DockOverrideCodeInactive_Fragment | GOverrideCodeErrorFields_DockReassignNotAllowed_Fragment | GOverrideCodeErrorFields_DockRecoveryNotAllowed_Fragment | GOverrideCodeErrorFields_DockSlotUnavailable_Fragment | GOverrideCodeErrorFields_DockVisitNotFound_Fragment | GOverrideCodeErrorFields_OverrideCodeIssueConflict_Fragment | GOverrideCodeErrorFields_OverrideCodeNotFound_Fragment | GOverrideCodeErrorFields_OverrideVendorNotFound_Fragment | GOverrideCodeErrorFields_ShipDateRequired_Fragment | GOverrideCodeErrorFields_WithinLeadTime_Fragment;

export type GGetNonInventoryVendorsQueryVariables = Exact<{
  search: Scalars['String'];
}>;


export type GGetNonInventoryVendorsQuery = { __typename?: 'Query', nonInventoryVendors: Array<{ __typename?: 'NonInventoryVendor', netsuiteInternalId: string, name?: string, displayName?: string, activeOverrideCode?: { __typename?: 'DockOverrideCode', id: string, code: string, active: boolean, vendorName?: string, netsuiteInternalId: string, createdBy?: string, createdAt: any } }> };

export type GGetDockOverrideCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type GGetDockOverrideCodesQuery = { __typename?: 'Query', dockOverrideCodes: Array<{ __typename?: 'DockOverrideCode', id: string, code: string, active: boolean, vendorName?: string, netsuiteInternalId: string, createdBy?: string, createdAt: any }> };

export type GIssueDockOverrideCodeMutationVariables = Exact<{
  input: GDockOverrideCodeIssueInput;
}>;


export type GIssueDockOverrideCodeMutation = { __typename?: 'Mutation', dockOverrideCodeIssue?: { __typename?: 'DockOverrideCodeIssuePayload', dockOverrideCode?: { __typename?: 'DockOverrideCode', id: string, code: string, active: boolean, vendorName?: string, netsuiteInternalId: string, createdBy?: string, createdAt: any }, userErrors: Array<{ __typename?: 'AdHocAppointmentsNotAllowed' } | { __typename?: 'AppointmentInPast' } | { __typename?: 'CarrierNameRequired' } | { __typename?: 'CheckInNotAllowed' } | { __typename?: 'ContactDetailsRequired' } | { __typename?: 'DailyDeliveryExists' } | { __typename?: 'DepartNotAllowed' } | { __typename?: 'DockBookingAlreadyCompleted' } | { __typename?: 'DockBookingAlreadyMissed' } | { __typename?: 'DockBookingNotBooked' } | { __typename?: 'DockBookingNotFound' } | { __typename?: 'DockBookingWarehouseNotFound' } | { __typename?: 'DockCapacityInvalid' } | { __typename?: 'DockInUse' } | { __typename?: 'DockNotFound' } | { __typename?: 'DockOverrideCodeInactive' } | { __typename?: 'DockReassignNotAllowed' } | { __typename?: 'DockRecoveryNotAllowed' } | { __typename?: 'DockSlotUnavailable' } | { __typename?: 'DockVisitNotFound' } | { __typename?: 'OverrideCodeIssueConflict', errorCode: string, message: string } | { __typename?: 'OverrideCodeNotFound', errorCode: string, message: string } | { __typename?: 'OverrideVendorNotFound', errorCode: string, message: string } | { __typename?: 'ShipDateRequired' } | { __typename?: 'WithinLeadTime' }> } };

export type GRevokeDockOverrideCodeMutationVariables = Exact<{
  input: GDockOverrideCodeRevokeInput;
}>;


export type GRevokeDockOverrideCodeMutation = { __typename?: 'Mutation', dockOverrideCodeRevoke?: { __typename?: 'DockOverrideCodeRevokePayload', dockOverrideCode?: { __typename?: 'DockOverrideCode', id: string, code: string, active: boolean, vendorName?: string, netsuiteInternalId: string, createdBy?: string, createdAt: any }, userErrors: Array<{ __typename?: 'AdHocAppointmentsNotAllowed' } | { __typename?: 'AppointmentInPast' } | { __typename?: 'CarrierNameRequired' } | { __typename?: 'CheckInNotAllowed' } | { __typename?: 'ContactDetailsRequired' } | { __typename?: 'DailyDeliveryExists' } | { __typename?: 'DepartNotAllowed' } | { __typename?: 'DockBookingAlreadyCompleted' } | { __typename?: 'DockBookingAlreadyMissed' } | { __typename?: 'DockBookingNotBooked' } | { __typename?: 'DockBookingNotFound' } | { __typename?: 'DockBookingWarehouseNotFound' } | { __typename?: 'DockCapacityInvalid' } | { __typename?: 'DockInUse' } | { __typename?: 'DockNotFound' } | { __typename?: 'DockOverrideCodeInactive' } | { __typename?: 'DockReassignNotAllowed' } | { __typename?: 'DockRecoveryNotAllowed' } | { __typename?: 'DockSlotUnavailable' } | { __typename?: 'DockVisitNotFound' } | { __typename?: 'OverrideCodeIssueConflict', errorCode: string, message: string } | { __typename?: 'OverrideCodeNotFound', errorCode: string, message: string } | { __typename?: 'OverrideVendorNotFound', errorCode: string, message: string } | { __typename?: 'ShipDateRequired' } | { __typename?: 'WithinLeadTime' }> } };

export type GListScenariosQueryVariables = Exact<{
  input: GRoutingImportPlanInput;
}>;


export type GListScenariosQuery = { __typename?: 'Query', routingImportPlan: { __typename?: 'RoutingImportPlan', id: string, thirdPartyStopCount: number, rulesConfig: any, cohorts?: Array<{ __typename?: 'RoutingPlanCohort', id: string, name: string, truckCount?: number }>, appliedRoutificRun?: { __typename?: 'RoutificRunSummary', id: string, createdAt: any, truckCount: number, routeCount?: number, totalStops?: number, totalDistanceMiles?: number, avgCubicUtilizationPercent?: number, estimatedDriverHours?: number, dprh?: number, unservedCount?: number }, dispatchedRoutificRun?: { __typename?: 'RoutificRunSummary', id: string, createdAt: any, truckCount: number, routeCount?: number, totalStops?: number, totalDistanceMiles?: number, avgCubicUtilizationPercent?: number, estimatedDriverHours?: number, dprh?: number, unservedCount?: number }, actualRoutesSummary?: { __typename?: 'ActualRoutesSummary', routeCount: number }, etasStatus: { __typename?: 'EtasStatus', stale: boolean, reason?: GEtasStatusReason, lastCalculatedAt?: any, lastCalculatedRunId?: string }, currentRoutingConfiguration: { __typename?: 'RoutingConfiguration', truckCount?: number, driverShiftHours?: number, breakDurationMinutes?: number, capacityPercent: number, overtimeMinutes: number, balance: boolean, shortestDistance: boolean, minVehicles: boolean, visitBalanceCoefficient: number, avoidTolls: boolean, maxStopsPerVehicle: boolean }, scenarios: Array<{ __typename?: 'RoutificRunSummary', id: string, label?: string, name?: string, status: GRoutificRunStatus, createdAt: any, truckCount: number, inputSnapshot?: any, routeCount?: number, totalStops?: number, totalDistanceMiles?: number, avgCubicUtilizationPercent?: number, estimatedDriverHours?: number, dprh?: number, unservedCount?: number, polylines?: any, vehicleStopIds?: any }> } };

export type GSaveRoutificScenarioMutationVariables = Exact<{
  input: GSaveRoutificScenarioInput;
}>;


export type GSaveRoutificScenarioMutation = { __typename?: 'Mutation', saveRoutificScenario?: { __typename?: 'SaveRoutificScenarioPayload', scenario?: { __typename?: 'RoutificRunSummary', id: string, name?: string }, userErrors: Array<{ __typename: 'InvalidNightEnd', message: string, path?: Array<string> } | { __typename: 'InvalidParameterOverrides', message: string, path?: Array<string> } | { __typename: 'InvalidRules', message: string, path?: Array<string> } | { __typename: 'RoutingImportPlanNotConfigured', message: string, path?: Array<string> } | { __typename: 'RoutingImportPlanNotFound', message: string, path?: Array<string> } | { __typename: 'ScenarioLimitReached', message: string, path?: Array<string> } | { __typename: 'ScenarioNotFound', message: string, path?: Array<string> } | { __typename: 'ScenarioRunsNotEnabled', message: string, path?: Array<string> } | { __typename: 'TruckCountInvalid', message: string, path?: Array<string> }> } };

export type GDeleteRoutificScenarioMutationVariables = Exact<{
  input: GDeleteRoutificScenarioInput;
}>;


export type GDeleteRoutificScenarioMutation = { __typename?: 'Mutation', deleteRoutificScenario?: { __typename?: 'DeleteRoutificScenarioPayload', deletedScenarioId?: string, userErrors: Array<{ __typename: 'InvalidNightEnd', message: string, path?: Array<string> } | { __typename: 'InvalidParameterOverrides', message: string, path?: Array<string> } | { __typename: 'InvalidRules', message: string, path?: Array<string> } | { __typename: 'RoutingImportPlanNotConfigured', message: string, path?: Array<string> } | { __typename: 'RoutingImportPlanNotFound', message: string, path?: Array<string> } | { __typename: 'ScenarioLimitReached', message: string, path?: Array<string> } | { __typename: 'ScenarioNotFound', message: string, path?: Array<string> } | { __typename: 'ScenarioRunsNotEnabled', message: string, path?: Array<string> } | { __typename: 'TruckCountInvalid', message: string, path?: Array<string> }> } };

export type GProcessPathFieldsFragment = { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number };

export type GProcessPathEmployeeFieldsFragment = { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string };

export type GProcessPathSegmentFieldsFragment = { __typename?: 'ProcessPathSegment', id: string, startsAt: any, endsAt?: any, minutes: number, source: GProcessPathSource, unitsProcessed?: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number }, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string } };

export type GProcessPathEmployeeDayFieldsFragment = { __typename?: 'ProcessPathEmployeeDay', date: any, clockInAt?: any, clockOutAt?: any, clockOutSource?: GProcessPathSource, clockedMinutes: number, accountedMinutes: number, unaccountedMinutes: number, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string }, currentSegment?: { __typename?: 'ProcessPathSegment', id: string, startsAt: any, endsAt?: any, minutes: number, source: GProcessPathSource, unitsProcessed?: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number }, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string } }, segments: Array<{ __typename?: 'ProcessPathSegment', id: string, startsAt: any, endsAt?: any, minutes: number, source: GProcessPathSource, unitsProcessed?: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number }, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string } }>, totals: Array<{ __typename?: 'ProcessPathDayTotal', minutes: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number } }> };

type GProcessPathErrorFields_ProcessPathEmployeeNotFound_Fragment = { __typename?: 'ProcessPathEmployeeNotFound', errorCode: string, message: string };

type GProcessPathErrorFields_ProcessPathNotFound_Fragment = { __typename?: 'ProcessPathNotFound', errorCode: string, message: string };

type GProcessPathErrorFields_ProcessPathValidationError_Fragment = { __typename?: 'ProcessPathValidationError', errorCode: string, message: string };

export type GProcessPathErrorFieldsFragment = GProcessPathErrorFields_ProcessPathEmployeeNotFound_Fragment | GProcessPathErrorFields_ProcessPathNotFound_Fragment | GProcessPathErrorFields_ProcessPathValidationError_Fragment;

export type GGetProcessPathsQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
}>;


export type GGetProcessPathsQuery = { __typename?: 'Query', processPaths: Array<{ __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number }> };

export type GGetProcessPathCatalogQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
}>;


export type GGetProcessPathCatalogQuery = { __typename?: 'Query', processPathCatalog: Array<{ __typename?: 'ProcessPath', availableHere: boolean, id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number }> };

export type GGetProcessPathRosterQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
}>;


export type GGetProcessPathRosterQuery = { __typename?: 'Query', processPathRoster: Array<{ __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string }> };

export type GGetProcessPathFloorQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
}>;


export type GGetProcessPathFloorQuery = { __typename?: 'Query', processPathFloor: Array<{ __typename?: 'ProcessPathEmployeeDay', punchedInAt?: any, untrackedMinutes?: number, pathSelectionFlagged: boolean, date: any, clockInAt?: any, clockOutAt?: any, clockOutSource?: GProcessPathSource, clockedMinutes: number, accountedMinutes: number, unaccountedMinutes: number, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string }, currentSegment?: { __typename?: 'ProcessPathSegment', id: string, startsAt: any, endsAt?: any, minutes: number, source: GProcessPathSource, unitsProcessed?: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number }, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string } }, segments: Array<{ __typename?: 'ProcessPathSegment', id: string, startsAt: any, endsAt?: any, minutes: number, source: GProcessPathSource, unitsProcessed?: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number }, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string } }>, totals: Array<{ __typename?: 'ProcessPathDayTotal', minutes: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number } }> }> };

export type GGetProcessPathEmployeeDayQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
  employeeId: Scalars['ID'];
  date: Scalars['ISO8601Date'];
}>;


export type GGetProcessPathEmployeeDayQuery = { __typename?: 'Query', processPathEmployeeDay?: { __typename?: 'ProcessPathEmployeeDay', date: any, clockInAt?: any, clockOutAt?: any, clockOutSource?: GProcessPathSource, clockedMinutes: number, accountedMinutes: number, unaccountedMinutes: number, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string }, currentSegment?: { __typename?: 'ProcessPathSegment', id: string, startsAt: any, endsAt?: any, minutes: number, source: GProcessPathSource, unitsProcessed?: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number }, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string } }, segments: Array<{ __typename?: 'ProcessPathSegment', id: string, startsAt: any, endsAt?: any, minutes: number, source: GProcessPathSource, unitsProcessed?: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number }, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string } }>, totals: Array<{ __typename?: 'ProcessPathDayTotal', minutes: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number } }> } };

export type GGetProcessPathHourlyTotalsQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
  date: Scalars['ISO8601Date'];
}>;


export type GGetProcessPathHourlyTotalsQuery = { __typename?: 'Query', processPathHourlyTotals: Array<{ __typename?: 'ProcessPathHourlyTotal', hourlyMinutes: Array<number>, totalMinutes: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number } }> };

export type GGetProcessPathComplianceQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
  startDate: Scalars['ISO8601Date'];
  endDate: Scalars['ISO8601Date'];
}>;


export type GGetProcessPathComplianceQuery = { __typename?: 'Query', processPathCompliance: { __typename?: 'ProcessPathCompliance', clockedMinutes: number, selfReportedMinutes: number, agencySelfReportedMinutes: number, coveragePct?: number, gapMinutes: number, agencyClockedMinutes: number, agencyCoveragePct?: number, agencyGapMinutes: number, overReporters: Array<{ __typename?: 'ProcessPathOverReporter', clockedMinutes: number, accountedMinutes: number, excessMinutes: number, employee: { __typename?: 'ProcessPathEmployee', id: string, name: string } }> } };

export type GGetProcessPathWeeklyActualsQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
  weekStart: Scalars['ISO8601Date'];
}>;


export type GGetProcessPathWeeklyActualsQuery = { __typename?: 'Query', processPathWeeklyActuals: Array<{ __typename?: 'ProcessPathEmployeeDay', date: any, clockInAt?: any, clockOutAt?: any, clockOutSource?: GProcessPathSource, clockedMinutes: number, accountedMinutes: number, unaccountedMinutes: number, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string }, currentSegment?: { __typename?: 'ProcessPathSegment', id: string, startsAt: any, endsAt?: any, minutes: number, source: GProcessPathSource, unitsProcessed?: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number }, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string } }, segments: Array<{ __typename?: 'ProcessPathSegment', id: string, startsAt: any, endsAt?: any, minutes: number, source: GProcessPathSource, unitsProcessed?: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number }, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string } }>, totals: Array<{ __typename?: 'ProcessPathDayTotal', minutes: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number } }> }> };

export type GGetProcessPathCoverageTargetsQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
  weekStart: Scalars['ISO8601Date'];
}>;


export type GGetProcessPathCoverageTargetsQuery = { __typename?: 'Query', processPathCoverageTargets: Array<{ __typename?: 'ProcessPathCoverageTarget', date: any, targetHours: number, baselineRequiredHours?: number, source: GProcessPathCoverageTargetSource, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number } }> };

export type GGetProcessPathWeeklyForecastQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
  weekStart: Scalars['ISO8601Date'];
}>;


export type GGetProcessPathWeeklyForecastQuery = { __typename?: 'Query', processPathWeeklyForecast: Array<{ __typename?: 'ProcessPathDayForecast', date: any, ecomUnits?: number, localDeliveryUnits?: number, totalUnits: number, demandBasis: string }> };

export type GGetProcessPathPickHistoryQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
  startDate: Scalars['ISO8601Date'];
  endDate: Scalars['ISO8601Date'];
}>;


export type GGetProcessPathPickHistoryQuery = { __typename?: 'Query', processPathMeasuredPickDays: Array<{ __typename?: 'ProcessPathMeasuredPickDay', date: any, measuredUnits: number }> };

export type GGetProcessPathScanDaysQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
  startDate: Scalars['ISO8601Date'];
  endDate: Scalars['ISO8601Date'];
  processPathCode?: InputMaybe<Scalars['String']>;
}>;


export type GGetProcessPathScanDaysQuery = { __typename?: 'Query', processPathScanDays: Array<{ __typename?: 'ProcessPathScanDay', date: any, totalUnits: number, clockedMinutes: number }> };

export type GGetProcessPathScanHistoryStartQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
  processPathCode?: InputMaybe<Scalars['String']>;
}>;


export type GGetProcessPathScanHistoryStartQuery = { __typename?: 'Query', processPathScanHistoryStart?: any };

export type GGetProcessPathThroughputQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
  startDate: Scalars['ISO8601Date'];
  endDate: Scalars['ISO8601Date'];
}>;


export type GGetProcessPathThroughputQuery = { __typename?: 'Query', processPathThroughput: Array<{ __typename?: 'ProcessPathThroughput', date: any, units: number, laborHours: number, ratePerHour?: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number } }> };

export type GGetProcessPathEmployeeThroughputQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
  startDate: Scalars['ISO8601Date'];
  endDate: Scalars['ISO8601Date'];
}>;


export type GGetProcessPathEmployeeThroughputQuery = { __typename?: 'Query', processPathEmployeeThroughput: Array<{ __typename?: 'ProcessPathEmployeeThroughput', date: any, units: number, orphanUnits: number, laborHours: number, ratePerHour?: number, basis: string, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string }, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number } }> };

export type GGetProcessPathSelfContextQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type GGetProcessPathSelfContextQuery = { __typename?: 'Query', processPathSelfContext?: { __typename?: 'ProcessPathEmployeeDay', date: any, clockInAt?: any, clockOutAt?: any, clockOutSource?: GProcessPathSource, clockedMinutes: number, accountedMinutes: number, unaccountedMinutes: number, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string }, currentSegment?: { __typename?: 'ProcessPathSegment', id: string, startsAt: any, endsAt?: any, minutes: number, source: GProcessPathSource, unitsProcessed?: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number }, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string } }, segments: Array<{ __typename?: 'ProcessPathSegment', id: string, startsAt: any, endsAt?: any, minutes: number, source: GProcessPathSource, unitsProcessed?: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number }, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string } }>, totals: Array<{ __typename?: 'ProcessPathDayTotal', minutes: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number } }> } };

export type GAssignProcessPathMutationVariables = Exact<{
  input: GProcessPathAssignInput;
}>;


export type GAssignProcessPathMutation = { __typename?: 'Mutation', processPathAssign?: { __typename?: 'ProcessPathAssignPayload', employeeDay?: { __typename?: 'ProcessPathEmployeeDay', date: any, clockInAt?: any, clockOutAt?: any, clockOutSource?: GProcessPathSource, clockedMinutes: number, accountedMinutes: number, unaccountedMinutes: number, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string }, currentSegment?: { __typename?: 'ProcessPathSegment', id: string, startsAt: any, endsAt?: any, minutes: number, source: GProcessPathSource, unitsProcessed?: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number }, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string } }, segments: Array<{ __typename?: 'ProcessPathSegment', id: string, startsAt: any, endsAt?: any, minutes: number, source: GProcessPathSource, unitsProcessed?: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number }, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string } }>, totals: Array<{ __typename?: 'ProcessPathDayTotal', minutes: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number } }> }, userErrors: Array<{ __typename?: 'ProcessPathEmployeeNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathValidationError', errorCode: string, message: string }> } };

export type GCreateProcessPathAssociateMutationVariables = Exact<{
  input: GProcessPathAssociateCreateInput;
}>;


export type GCreateProcessPathAssociateMutation = { __typename?: 'Mutation', processPathAssociateCreate?: { __typename?: 'ProcessPathAssociateCreatePayload', employee?: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string }, userErrors: Array<{ __typename?: 'ProcessPathEmployeeNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathValidationError', errorCode: string, message: string }> } };

export type GSetProcessPathAssociateStatusMutationVariables = Exact<{
  input: GProcessPathAssociateSetStatusInput;
}>;


export type GSetProcessPathAssociateStatusMutation = { __typename?: 'Mutation', processPathAssociateSetStatus?: { __typename?: 'ProcessPathAssociateSetStatusPayload', employee?: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string }, userErrors: Array<{ __typename?: 'ProcessPathEmployeeNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathValidationError', errorCode: string, message: string }> } };

export type GUnassignProcessPathMutationVariables = Exact<{
  input: GProcessPathUnassignInput;
}>;


export type GUnassignProcessPathMutation = { __typename?: 'Mutation', processPathUnassign?: { __typename?: 'ProcessPathUnassignPayload', employeeDay?: { __typename?: 'ProcessPathEmployeeDay', date: any, clockInAt?: any, clockOutAt?: any, clockOutSource?: GProcessPathSource, clockedMinutes: number, accountedMinutes: number, unaccountedMinutes: number, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string }, currentSegment?: { __typename?: 'ProcessPathSegment', id: string, startsAt: any, endsAt?: any, minutes: number, source: GProcessPathSource, unitsProcessed?: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number }, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string } }, segments: Array<{ __typename?: 'ProcessPathSegment', id: string, startsAt: any, endsAt?: any, minutes: number, source: GProcessPathSource, unitsProcessed?: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number }, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string } }>, totals: Array<{ __typename?: 'ProcessPathDayTotal', minutes: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number } }> }, userErrors: Array<{ __typename?: 'ProcessPathEmployeeNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathValidationError', errorCode: string, message: string }> } };

export type GEditProcessPathSegmentMutationVariables = Exact<{
  input: GProcessPathSegmentEditInput;
}>;


export type GEditProcessPathSegmentMutation = { __typename?: 'Mutation', processPathSegmentEdit?: { __typename?: 'ProcessPathSegmentEditPayload', employeeDay?: { __typename?: 'ProcessPathEmployeeDay', date: any, clockInAt?: any, clockOutAt?: any, clockOutSource?: GProcessPathSource, clockedMinutes: number, accountedMinutes: number, unaccountedMinutes: number, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string }, currentSegment?: { __typename?: 'ProcessPathSegment', id: string, startsAt: any, endsAt?: any, minutes: number, source: GProcessPathSource, unitsProcessed?: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number }, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string } }, segments: Array<{ __typename?: 'ProcessPathSegment', id: string, startsAt: any, endsAt?: any, minutes: number, source: GProcessPathSource, unitsProcessed?: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number }, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string } }>, totals: Array<{ __typename?: 'ProcessPathDayTotal', minutes: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number } }> }, userErrors: Array<{ __typename?: 'ProcessPathEmployeeNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathValidationError', errorCode: string, message: string }> } };

export type GCreateProcessPathSegmentMutationVariables = Exact<{
  input: GProcessPathSegmentCreateInput;
}>;


export type GCreateProcessPathSegmentMutation = { __typename?: 'Mutation', processPathSegmentCreate?: { __typename?: 'ProcessPathSegmentCreatePayload', employeeDay?: { __typename?: 'ProcessPathEmployeeDay', date: any, clockInAt?: any, clockOutAt?: any, clockOutSource?: GProcessPathSource, clockedMinutes: number, accountedMinutes: number, unaccountedMinutes: number, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string }, currentSegment?: { __typename?: 'ProcessPathSegment', id: string, startsAt: any, endsAt?: any, minutes: number, source: GProcessPathSource, unitsProcessed?: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number }, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string } }, segments: Array<{ __typename?: 'ProcessPathSegment', id: string, startsAt: any, endsAt?: any, minutes: number, source: GProcessPathSource, unitsProcessed?: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number }, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string } }>, totals: Array<{ __typename?: 'ProcessPathDayTotal', minutes: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number } }> }, userErrors: Array<{ __typename?: 'ProcessPathEmployeeNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathValidationError', errorCode: string, message: string }> } };

export type GDeleteProcessPathSegmentMutationVariables = Exact<{
  input: GProcessPathSegmentDeleteInput;
}>;


export type GDeleteProcessPathSegmentMutation = { __typename?: 'Mutation', processPathSegmentDelete?: { __typename?: 'ProcessPathSegmentDeletePayload', deletedSegmentId?: string, userErrors: Array<{ __typename?: 'ProcessPathEmployeeNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathValidationError', errorCode: string, message: string }> } };

export type GSetProcessPathCoverageTargetMutationVariables = Exact<{
  input: GProcessPathSetCoverageTargetInput;
}>;


export type GSetProcessPathCoverageTargetMutation = { __typename?: 'Mutation', processPathSetCoverageTarget?: { __typename?: 'ProcessPathSetCoverageTargetPayload', coverageTarget?: { __typename?: 'ProcessPathCoverageTarget', date: any, targetHours: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number } }, userErrors: Array<{ __typename?: 'ProcessPathEmployeeNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathValidationError', errorCode: string, message: string }> } };

export type GClearProcessPathCoverageTargetMutationVariables = Exact<{
  input: GProcessPathClearCoverageTargetInput;
}>;


export type GClearProcessPathCoverageTargetMutation = { __typename?: 'Mutation', processPathClearCoverageTarget?: { __typename?: 'ProcessPathClearCoverageTargetPayload', coverageTarget?: { __typename?: 'ProcessPathCoverageTarget', date: any, targetHours: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number } }, userErrors: Array<{ __typename?: 'ProcessPathEmployeeNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathValidationError', errorCode: string, message: string }> } };

export type GCreateProcessPathMutationVariables = Exact<{
  input: GProcessPathCreateInput;
}>;


export type GCreateProcessPathMutation = { __typename?: 'Mutation', processPathCreate?: { __typename?: 'ProcessPathCreatePayload', processPath?: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number }, userErrors: Array<{ __typename?: 'ProcessPathEmployeeNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathValidationError', errorCode: string, message: string }> } };

export type GUpdateProcessPathMutationVariables = Exact<{
  input: GProcessPathUpdateInput;
}>;


export type GUpdateProcessPathMutation = { __typename?: 'Mutation', processPathUpdate?: { __typename?: 'ProcessPathUpdatePayload', processPath?: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number }, userErrors: Array<{ __typename?: 'ProcessPathEmployeeNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathValidationError', errorCode: string, message: string }> } };

export type GReorderProcessPathsMutationVariables = Exact<{
  input: GProcessPathReorderInput;
}>;


export type GReorderProcessPathsMutation = { __typename?: 'Mutation', processPathReorder?: { __typename?: 'ProcessPathReorderPayload', processPaths: Array<{ __typename?: 'ProcessPath', id: string, sortOrder: number }>, userErrors: Array<{ __typename?: 'ProcessPathEmployeeNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathValidationError', errorCode: string, message: string }> } };

export type GSetProcessPathAvailabilityMutationVariables = Exact<{
  input: GProcessPathSetAvailabilityInput;
}>;


export type GSetProcessPathAvailabilityMutation = { __typename?: 'Mutation', processPathSetAvailability?: { __typename?: 'ProcessPathSetAvailabilityPayload', processPath?: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number }, userErrors: Array<{ __typename?: 'ProcessPathEmployeeNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathValidationError', errorCode: string, message: string }> } };

export type GSelfAssignProcessPathMutationVariables = Exact<{
  input: GProcessPathSelfAssignInput;
}>;


export type GSelfAssignProcessPathMutation = { __typename?: 'Mutation', processPathSelfAssign?: { __typename?: 'ProcessPathSelfAssignPayload', employeeDay?: { __typename?: 'ProcessPathEmployeeDay', date: any, clockInAt?: any, clockOutAt?: any, clockOutSource?: GProcessPathSource, clockedMinutes: number, accountedMinutes: number, unaccountedMinutes: number, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string }, currentSegment?: { __typename?: 'ProcessPathSegment', id: string, startsAt: any, endsAt?: any, minutes: number, source: GProcessPathSource, unitsProcessed?: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number }, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string } }, segments: Array<{ __typename?: 'ProcessPathSegment', id: string, startsAt: any, endsAt?: any, minutes: number, source: GProcessPathSource, unitsProcessed?: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number }, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string } }>, totals: Array<{ __typename?: 'ProcessPathDayTotal', minutes: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number } }> }, userErrors: Array<{ __typename?: 'ProcessPathEmployeeNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathValidationError', errorCode: string, message: string }> } };

export type GSelfUnassignProcessPathMutationVariables = Exact<{
  input: GProcessPathSelfUnassignInput;
}>;


export type GSelfUnassignProcessPathMutation = { __typename?: 'Mutation', processPathSelfUnassign?: { __typename?: 'ProcessPathSelfUnassignPayload', employeeDay?: { __typename?: 'ProcessPathEmployeeDay', date: any, clockInAt?: any, clockOutAt?: any, clockOutSource?: GProcessPathSource, clockedMinutes: number, accountedMinutes: number, unaccountedMinutes: number, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string }, currentSegment?: { __typename?: 'ProcessPathSegment', id: string, startsAt: any, endsAt?: any, minutes: number, source: GProcessPathSource, unitsProcessed?: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number }, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string } }, segments: Array<{ __typename?: 'ProcessPathSegment', id: string, startsAt: any, endsAt?: any, minutes: number, source: GProcessPathSource, unitsProcessed?: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number }, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string } }>, totals: Array<{ __typename?: 'ProcessPathDayTotal', minutes: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number } }> }, userErrors: Array<{ __typename?: 'ProcessPathEmployeeNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathValidationError', errorCode: string, message: string }> } };

export type GClockInProcessPathMutationVariables = Exact<{
  input: GProcessPathClockInInput;
}>;


export type GClockInProcessPathMutation = { __typename?: 'Mutation', processPathClockIn?: { __typename?: 'ProcessPathClockInPayload', employeeDay?: { __typename?: 'ProcessPathEmployeeDay', date: any, clockInAt?: any, clockOutAt?: any, clockOutSource?: GProcessPathSource, clockedMinutes: number, accountedMinutes: number, unaccountedMinutes: number, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string }, currentSegment?: { __typename?: 'ProcessPathSegment', id: string, startsAt: any, endsAt?: any, minutes: number, source: GProcessPathSource, unitsProcessed?: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number }, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string } }, segments: Array<{ __typename?: 'ProcessPathSegment', id: string, startsAt: any, endsAt?: any, minutes: number, source: GProcessPathSource, unitsProcessed?: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number }, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string } }>, totals: Array<{ __typename?: 'ProcessPathDayTotal', minutes: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number } }> }, userErrors: Array<{ __typename?: 'ProcessPathEmployeeNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathValidationError', errorCode: string, message: string }> } };

export type GClockOutProcessPathMutationVariables = Exact<{
  input: GProcessPathClockOutInput;
}>;


export type GClockOutProcessPathMutation = { __typename?: 'Mutation', processPathClockOut?: { __typename?: 'ProcessPathClockOutPayload', employeeDay?: { __typename?: 'ProcessPathEmployeeDay', date: any, clockInAt?: any, clockOutAt?: any, clockOutSource?: GProcessPathSource, clockedMinutes: number, accountedMinutes: number, unaccountedMinutes: number, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string }, currentSegment?: { __typename?: 'ProcessPathSegment', id: string, startsAt: any, endsAt?: any, minutes: number, source: GProcessPathSource, unitsProcessed?: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number }, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string } }, segments: Array<{ __typename?: 'ProcessPathSegment', id: string, startsAt: any, endsAt?: any, minutes: number, source: GProcessPathSource, unitsProcessed?: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number }, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string } }>, totals: Array<{ __typename?: 'ProcessPathDayTotal', minutes: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number } }> }, userErrors: Array<{ __typename?: 'ProcessPathEmployeeNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathValidationError', errorCode: string, message: string }> } };

export type GSelfClockInProcessPathMutationVariables = Exact<{
  input: GProcessPathSelfClockInInput;
}>;


export type GSelfClockInProcessPathMutation = { __typename?: 'Mutation', processPathSelfClockIn?: { __typename?: 'ProcessPathSelfClockInPayload', employeeDay?: { __typename?: 'ProcessPathEmployeeDay', date: any, clockInAt?: any, clockOutAt?: any, clockOutSource?: GProcessPathSource, clockedMinutes: number, accountedMinutes: number, unaccountedMinutes: number, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string }, currentSegment?: { __typename?: 'ProcessPathSegment', id: string, startsAt: any, endsAt?: any, minutes: number, source: GProcessPathSource, unitsProcessed?: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number }, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string } }, segments: Array<{ __typename?: 'ProcessPathSegment', id: string, startsAt: any, endsAt?: any, minutes: number, source: GProcessPathSource, unitsProcessed?: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number }, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string } }>, totals: Array<{ __typename?: 'ProcessPathDayTotal', minutes: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number } }> }, userErrors: Array<{ __typename?: 'ProcessPathEmployeeNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathValidationError', errorCode: string, message: string }> } };

export type GSelfClockOutProcessPathMutationVariables = Exact<{
  input: GProcessPathSelfClockOutInput;
}>;


export type GSelfClockOutProcessPathMutation = { __typename?: 'Mutation', processPathSelfClockOut?: { __typename?: 'ProcessPathSelfClockOutPayload', employeeDay?: { __typename?: 'ProcessPathEmployeeDay', date: any, clockInAt?: any, clockOutAt?: any, clockOutSource?: GProcessPathSource, clockedMinutes: number, accountedMinutes: number, unaccountedMinutes: number, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string }, currentSegment?: { __typename?: 'ProcessPathSegment', id: string, startsAt: any, endsAt?: any, minutes: number, source: GProcessPathSource, unitsProcessed?: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number }, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string } }, segments: Array<{ __typename?: 'ProcessPathSegment', id: string, startsAt: any, endsAt?: any, minutes: number, source: GProcessPathSource, unitsProcessed?: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number }, employee: { __typename?: 'ProcessPathEmployee', id: string, associateId: string, positionId?: string, name: string, position?: string, warehouseId?: string, shiftLabel?: string, status?: string, source: string, agency?: string } }>, totals: Array<{ __typename?: 'ProcessPathDayTotal', minutes: number, path: { __typename?: 'ProcessPath', id: string, code: string, label: string, category: GProcessPathCategory, color: string, sortOrder: number } }> }, userErrors: Array<{ __typename?: 'ProcessPathEmployeeNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathValidationError', errorCode: string, message: string }> } };

export type GRfsmartCredentialFieldsFragment = { __typename?: 'RfsmartCredential', id: string, employeeId?: string, associateId?: string, name?: string, kind: GRfsmartCredentialKind, login: string, rotatedAt: any, updatedBy?: string, removalRequestedAt?: any, removalRequestedBy?: string, removalNote?: string };

export type GGetAssociateBadgePayloadsQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
  employeeIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GGetAssociateBadgePayloadsQuery = { __typename?: 'Query', associateBadgePayloads: Array<{ __typename?: 'AssociateBadgePayload', employeeId: string, associateId: string, name: string, payload: string }> };

export type GGetRfsmartCredentialsQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
  employeeIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GGetRfsmartCredentialsQuery = { __typename?: 'Query', rfsmartCredentials: Array<{ __typename?: 'RfsmartCredential', id: string, employeeId?: string, associateId?: string, name?: string, kind: GRfsmartCredentialKind, login: string, rotatedAt: any, updatedBy?: string, removalRequestedAt?: any, removalRequestedBy?: string, removalNote?: string }> };

export type GSetRfsmartCredentialMutationVariables = Exact<{
  input: GRfsmartCredentialSetInput;
}>;


export type GSetRfsmartCredentialMutation = { __typename?: 'Mutation', rfsmartCredentialSet?: { __typename?: 'RfsmartCredentialSetPayload', credential?: { __typename?: 'RfsmartCredential', id: string, employeeId?: string, associateId?: string, name?: string, kind: GRfsmartCredentialKind, login: string, rotatedAt: any, updatedBy?: string, removalRequestedAt?: any, removalRequestedBy?: string, removalNote?: string }, userErrors: Array<{ __typename?: 'ProcessPathEmployeeNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathValidationError', errorCode: string, message: string }> } };

export type GGetRfsmartPooledCredentialsQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
  assigned?: InputMaybe<Scalars['Boolean']>;
}>;


export type GGetRfsmartPooledCredentialsQuery = { __typename?: 'Query', rfsmartPooledCredentials: Array<{ __typename?: 'RfsmartCredential', id: string, employeeId?: string, associateId?: string, name?: string, kind: GRfsmartCredentialKind, login: string, rotatedAt: any, updatedBy?: string, removalRequestedAt?: any, removalRequestedBy?: string, removalNote?: string }> };

export type GSetRfsmartPoolCredentialMutationVariables = Exact<{
  input: GRfsmartCredentialSetPoolInput;
}>;


export type GSetRfsmartPoolCredentialMutation = { __typename?: 'Mutation', rfsmartCredentialSetPool?: { __typename?: 'RfsmartCredentialSetPoolPayload', credential?: { __typename?: 'RfsmartCredential', id: string, employeeId?: string, associateId?: string, name?: string, kind: GRfsmartCredentialKind, login: string, rotatedAt: any, updatedBy?: string, removalRequestedAt?: any, removalRequestedBy?: string, removalNote?: string }, userErrors: Array<{ __typename?: 'ProcessPathEmployeeNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathValidationError', errorCode: string, message: string }> } };

export type GAssignRfsmartCredentialMutationVariables = Exact<{
  input: GRfsmartCredentialAssignInput;
}>;


export type GAssignRfsmartCredentialMutation = { __typename?: 'Mutation', rfsmartCredentialAssign?: { __typename?: 'RfsmartCredentialAssignPayload', credential?: { __typename?: 'RfsmartCredential', id: string, employeeId?: string, associateId?: string, name?: string, kind: GRfsmartCredentialKind, login: string, rotatedAt: any, updatedBy?: string, removalRequestedAt?: any, removalRequestedBy?: string, removalNote?: string }, userErrors: Array<{ __typename?: 'ProcessPathEmployeeNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathValidationError', errorCode: string, message: string }> } };

export type GGetRfsmartPendingRemovalsQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
}>;


export type GGetRfsmartPendingRemovalsQuery = { __typename?: 'Query', rfsmartPendingRemovals: Array<{ __typename?: 'RfsmartCredential', id: string, employeeId?: string, associateId?: string, name?: string, kind: GRfsmartCredentialKind, login: string, rotatedAt: any, updatedBy?: string, removalRequestedAt?: any, removalRequestedBy?: string, removalNote?: string }> };

export type GRequestRfsmartCredentialRemovalMutationVariables = Exact<{
  input: GRfsmartCredentialRemovalRequestInput;
}>;


export type GRequestRfsmartCredentialRemovalMutation = { __typename?: 'Mutation', rfsmartCredentialRemovalRequest?: { __typename?: 'RfsmartCredentialRemovalRequestPayload', credential?: { __typename?: 'RfsmartCredential', id: string, employeeId?: string, associateId?: string, name?: string, kind: GRfsmartCredentialKind, login: string, rotatedAt: any, updatedBy?: string, removalRequestedAt?: any, removalRequestedBy?: string, removalNote?: string }, userErrors: Array<{ __typename?: 'ProcessPathEmployeeNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathValidationError', errorCode: string, message: string }> } };

export type GCancelRfsmartCredentialRemovalMutationVariables = Exact<{
  input: GRfsmartCredentialRemovalCancelInput;
}>;


export type GCancelRfsmartCredentialRemovalMutation = { __typename?: 'Mutation', rfsmartCredentialRemovalCancel?: { __typename?: 'RfsmartCredentialRemovalCancelPayload', credential?: { __typename?: 'RfsmartCredential', id: string, employeeId?: string, associateId?: string, name?: string, kind: GRfsmartCredentialKind, login: string, rotatedAt: any, updatedBy?: string, removalRequestedAt?: any, removalRequestedBy?: string, removalNote?: string }, userErrors: Array<{ __typename?: 'ProcessPathEmployeeNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathValidationError', errorCode: string, message: string }> } };

export type GCompleteRfsmartCredentialRemovalMutationVariables = Exact<{
  input: GRfsmartCredentialRemovalCompleteInput;
}>;


export type GCompleteRfsmartCredentialRemovalMutation = { __typename?: 'Mutation', rfsmartCredentialRemovalComplete?: { __typename?: 'RfsmartCredentialRemovalCompletePayload', credential?: { __typename?: 'RfsmartCredential', id: string, employeeId?: string, associateId?: string, name?: string, kind: GRfsmartCredentialKind, login: string, rotatedAt: any, updatedBy?: string, removalRequestedAt?: any, removalRequestedBy?: string, removalNote?: string }, userErrors: Array<{ __typename?: 'ProcessPathEmployeeNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathValidationError', errorCode: string, message: string }> } };

export type GRevokeWarehouseAssociateBadgeMutationVariables = Exact<{
  input: GWarehouseAssociateBadgeRevokeInput;
}>;


export type GRevokeWarehouseAssociateBadgeMutation = { __typename?: 'Mutation', warehouseAssociateBadgeRevoke?: { __typename?: 'WarehouseAssociateBadgeRevokePayload', associateId?: string, badgeVersion?: number } };

export type GUnassignRfsmartCredentialMutationVariables = Exact<{
  input: GRfsmartCredentialUnassignInput;
}>;


export type GUnassignRfsmartCredentialMutation = { __typename?: 'Mutation', rfsmartCredentialUnassign?: { __typename?: 'RfsmartCredentialUnassignPayload', credential?: { __typename?: 'RfsmartCredential', id: string, employeeId?: string, associateId?: string, name?: string, kind: GRfsmartCredentialKind, login: string, rotatedAt: any, updatedBy?: string, removalRequestedAt?: any, removalRequestedBy?: string, removalNote?: string }, userErrors: Array<{ __typename?: 'ProcessPathEmployeeNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathNotFound', errorCode: string, message: string } | { __typename?: 'ProcessPathValidationError', errorCode: string, message: string }> } };

export type GGetWarehousesQueryVariables = Exact<{ [key: string]: never; }>;


export type GGetWarehousesQuery = { __typename?: 'Query', warehouses: Array<{ __typename?: 'Warehouse', id: string, name: string, currentNightEnd?: any, timeZone: string, latitude?: number, longitude?: number }> };

export type GGetStopAddressQueryVariables = Exact<{
  input: GStopInput;
}>;


export type GGetStopAddressQuery = { __typename?: 'Query', stop: { __typename?: 'Delivery', orders?: Array<{ __typename?: 'Order', scheduledDeliveryTime?: { __typename?: 'ScheduledDeliveryTime', earliest: string, latest: string, timeZone: string } }>, location?: { __typename?: 'Location', address: { __typename?: 'Address', addressLine1: string, addressLine2?: string, city: string, postalCode: string, state: string } } } | { __typename?: 'PickUp', vendor: { __typename?: 'Vendor', address?: { __typename?: 'Address', addressLine1: string, addressLine2?: string, city: string, postalCode: string, state: string } } } };

export type GGetRedeliveryStopAddressQueryVariables = Exact<{
  input: GRedeliveryStopInput;
}>;


export type GGetRedeliveryStopAddressQuery = { __typename?: 'Query', redeliveryStop: { __typename?: 'Redelivery', location?: { __typename?: 'Location', address: { __typename?: 'Address', addressLine1: string, addressLine2?: string, city: string, postalCode: string, state: string } } } };

export type GGetStopDeliveryDetailsQueryVariables = Exact<{
  input: GStopInput;
}>;


export type GGetStopDeliveryDetailsQuery = { __typename?: 'Query', stop: { __typename?: 'Delivery', reminderMessage?: string, attachments?: Array<{ __typename?: 'Attachment', id: string, url: string, attachmentCategory: string, customerVisible: boolean, qualityStatus?: GAttachmentQualityStatus }> } | { __typename?: 'PickUp' } };

export type GGetStopTasksQueryVariables = Exact<{
  input: GStopInput;
}>;


export type GGetStopTasksQuery = { __typename?: 'Query', stop: { __typename?: 'Delivery', id: string, tasks?: Array<{ __typename?: 'DeliveryRouteStopTask', id: string, details: string, status: GDeliveryRouteStopTaskStatus, resolvedAt?: any, driverNote?: string, createdAt: any }> } | { __typename?: 'PickUp' } };

export type GGetRoutingImportPlanCutOffQueryVariables = Exact<{
  routePlanInput: GRoutingImportPlanInput;
  cutOffInput: GIsPastWarehouseCutOffTimeInput;
}>;


export type GGetRoutingImportPlanCutOffQuery = { __typename?: 'Query', isPastWarehouseCutOffTime: boolean, routingImportPlan: { __typename?: 'RoutingImportPlan', id: string, status: GRoutingImportPlanStatus, optimizationFailureReason?: GRoutingImportPlanOptimizationFailureReason, truckCount?: number, cohorts?: Array<{ __typename?: 'RoutingPlanCohort', color?: string, id: string, name: string, truckCount?: number, enabled: boolean }>, shiftTruckCounts: Array<{ __typename?: 'ShiftTruckCount', warehouseShiftId?: number, shiftType?: string, startTime?: string, endTime?: string, truckCount: number }> } };

export type GGetIsPastWarehouseCutOffQueryVariables = Exact<{
  cutOffInput: GIsPastWarehouseCutOffTimeInput;
}>;


export type GGetIsPastWarehouseCutOffQuery = { __typename?: 'Query', isPastWarehouseCutOffTime: boolean };

export type GGetUsersQueryVariables = Exact<{
  role: Scalars['String'];
}>;


export type GGetUsersQuery = { __typename?: 'Query', users?: Array<{ __typename?: 'User', id: string, name?: string, email?: string, payrollId?: string }> };

export type GGetRouteIssuesQueryVariables = Exact<{
  input: GRouteInput;
}>;


export type GGetRouteIssuesQuery = { __typename?: 'Query', route: { __typename?: 'Route', driverUser?: { __typename?: 'User', id: string, name?: string }, helperDriverUser?: { __typename?: 'User', id: string, name?: string }, stops?: Array<{ __typename?: 'Delivery', id: string, deliveryStatusDmp: GDeliveryStatusDmp, issues?: Array<{ __typename?: 'Issue', id: string, note?: string, type?: string, description?: string }>, location?: { __typename?: 'Location', id: string }, orders?: Array<{ __typename?: 'Order', id: string, deliveredAt?: any, partiallyDelivered: boolean, deliveryStatus: GOrderDeliveryStatus, itemLevelTracking: boolean, erpRecordUrl?: string, location: { __typename?: 'Location', scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', startTime: string, endTime: string } }, issues?: Array<{ __typename?: 'Issue', id: string, note?: string, type?: string, description?: string }>, orderLines: Array<{ __typename?: 'OrderLine', id: string, orderUnitQuantity: number, deliveredQuantity?: number, quantityType: string, itemsPerLot: number, fulfillmentQuantity?: number, unitCostCents: number, isMarketPriced: boolean, isPounds: boolean, orderedWeightLb?: number, unitWeightLb?: number, totalWeightLb?: number, sku: { __typename?: 'Sku', id: string, name: string, refrigerationState: string, categoryName: string, subcategoryName: string, item?: { __typename?: 'InventoryItem', category: { __typename?: 'Category', name: string } } | { __typename?: 'NonInventoryItem', category: { __typename?: 'Category', name: string } } } }>, vendor: { __typename?: 'Vendor', name: string, legalName: string, isWarehouse: boolean } }>, redeliveryStop?: { __typename?: 'Redelivery', id: string, deliveryStatusDmp: GDeliveryStatusDmp } } | { __typename?: 'PickUp', id: string, deliveryStatusDmp: GDeliveryStatusDmp, issues?: Array<{ __typename?: 'Issue', id: string, note?: string, type?: string, description?: string }>, orders?: Array<{ __typename?: 'Order', id: string, collectedAt?: any, deliveryStatus: GOrderDeliveryStatus, erpRecordUrl?: string, location: { __typename?: 'Location', scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', startTime: string, endTime: string } }, vendor: { __typename?: 'Vendor', name: string, legalName: string, isWarehouse: boolean }, issues?: Array<{ __typename?: 'Issue', id: string, note?: string, type?: string, description?: string }> }> }> } };

export type GGetWarehouseOrderCutOffTimeQueryVariables = Exact<{
  input: GStopInput;
}>;


export type GGetWarehouseOrderCutOffTimeQuery = { __typename?: 'Query', stop: { __typename?: 'Delivery', orders?: Array<{ __typename?: 'Order', dueAt: any, vendor: { __typename?: 'Vendor', isWarehouse: boolean } }> } | { __typename?: 'PickUp' } };

export type GGetPrimaryStopStatusesQueryVariables = Exact<{
  input: GRoutesInput;
}>;


export type GGetPrimaryStopStatusesQuery = { __typename?: 'Query', routes: Array<{ __typename: 'Route', id: string, stops?: Array<{ __typename: 'Delivery', deliveryStatusDmp: GDeliveryStatusDmp, id: string } | { __typename: 'PickUp', deliveryStatusDmp: GDeliveryStatusDmp, id: string }>, redeliveryStops: Array<{ __typename?: 'Redelivery', id: string, deliveryStatusDmp: GDeliveryStatusDmp }> }> };

export type GGetPickingLabelDataQueryVariables = Exact<{
  input: GRoutesInput;
}>;


export type GGetPickingLabelDataQuery = { __typename?: 'Query', routes: Array<{ __typename?: 'Route', id: string, name: string, isLobby: boolean, stops?: Array<{ __typename?: 'Delivery', id: string, sequenceNumber?: string, location?: { __typename?: 'Location', id: string, businessName: string }, orders?: Array<{ __typename?: 'Order', id: string, vendor: { __typename?: 'Vendor', isWarehouse: boolean }, orderLines: Array<{ __typename?: 'OrderLine', id: string, orderUnitQuantity: number, quantityType: string, itemsPerLot: number, bulkPickedItem: boolean, sku: { __typename?: 'Sku', id: string, refrigerationState: string, item?: { __typename?: 'InventoryItem', name: string } | { __typename?: 'NonInventoryItem', name: string } } }> }> } | { __typename?: 'PickUp' }> }> };

export type GGetIsRoutesSyncEnabledQueryVariables = Exact<{
  isRoutesSyncEnabledInput: GIsRoutesSyncEnabledInput;
}>;


export type GGetIsRoutesSyncEnabledQuery = { __typename?: 'Query', isRoutesSyncEnabled: boolean };

export type GRouteReopenMutationVariables = Exact<{
  input: GRouteReopenInput;
}>;


export type GRouteReopenMutation = { __typename?: 'Mutation', reopenRoute?: { __typename?: 'RouteReopenPayload', route?: { __typename?: 'Route', id: string, stopTime?: any }, userErrors: Array<{ __typename: 'AutomatedRoutingPending' } | { __typename: 'BulkUpdateDeprecated' } | { __typename: 'InvalidNightEnd' } | { __typename: 'ProviderRouteGuarded' } | { __typename: 'RouteEnded' }> } };

export type GRequoteProviderRouteMutationVariables = Exact<{
  input: GRequoteProviderRouteInput;
}>;


export type GRequoteProviderRouteMutation = { __typename?: 'Mutation', requoteProviderRoute?: { __typename?: 'RequoteProviderRoutePayload', route?: { __typename?: 'Route', id: string, providerDispatch?: { __typename?: 'ProviderDispatch', status: GProviderDispatchStatus, error?: string } }, userErrors: Array<{ __typename: 'DispatchNotAllowed', message: string } | { __typename: 'DispatchProfileIncomplete', message: string } | { __typename: 'ProviderNotAvailable', message: string } | { __typename: 'ProviderRejected', message: string } | { __typename: 'RouteNotFound', message: string } | { __typename: 'RouteNotMarkable', message: string } | { __typename: 'StopsNotEscalatable', message: string } | { __typename: 'UnmarkNotAllowed', message: string }> } };

export type GSaveVendorAllocationMutationVariables = Exact<{
  input: GSaveVendorAllocationInput;
}>;


export type GSaveVendorAllocationMutation = { __typename?: 'Mutation', saveVendorAllocation?: { __typename?: 'SaveVendorAllocationPayload', success: boolean, userErrors: Array<{ __typename?: 'UserError', message: string, path?: Array<string> }> } };

export type GGetScenarioConfigurationQueryVariables = Exact<{
  input: GRoutingImportPlanInput;
}>;


export type GGetScenarioConfigurationQuery = { __typename?: 'Query', routingImportPlan: { __typename?: 'RoutingImportPlan', id: string, rulesConfig: any, cohorts?: Array<{ __typename?: 'RoutingPlanCohort', id: string, name: string, color?: string, truckCount?: number, maxStops?: number, enabled: boolean }>, currentRoutingConfiguration: { __typename?: 'RoutingConfiguration', truckCount?: number, driverShiftHours?: number, breakDurationMinutes?: number, capacityPercent: number, overtimeMinutes: number, balance: boolean, shortestDistance: boolean, minVehicles: boolean, visitBalanceCoefficient: number, avoidTolls: boolean, thirdPartyEnabled: boolean, maxStopsPerVehicle: boolean }, scenarios: Array<{ __typename?: 'RoutificRunSummary', id: string }> } };

export type GGetScenarioMapStopsQueryVariables = Exact<{
  input: GRoutesInput;
}>;


export type GGetScenarioMapStopsQuery = { __typename?: 'Query', routes: Array<{ __typename?: 'Route', truck?: { __typename?: 'Truck', maxWeight: number, maxVolume: number }, stops?: Array<{ __typename: 'Delivery', id: string, sequenceNumber?: string, totalWeight?: number, totalVolume?: number, location?: { __typename?: 'Location', businessName: string, routingCohort?: { __typename?: 'RoutingCohort', id: string, name: string, color?: string }, address: { __typename?: 'Address', latitude?: number, longitude?: number, addressLine1: string } }, orders?: Array<{ __typename?: 'Order', id: string, itemLevelTracking: boolean, vendor: { __typename?: 'Vendor', legalName: string, isWarehouse: boolean }, location: { __typename?: 'Location', scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', startTime: string, endTime: string } }, orderLines: Array<{ __typename?: 'OrderLine', id: string, sku: { __typename?: 'Sku', id: string, refrigerationState: string, subcategoryName: string } }>, scheduledDeliveryTime?: { __typename?: 'ScheduledDeliveryTime', earliest: string, latest: string, timeZone: string } }> } | { __typename: 'PickUp' }> }> };

export type GGetScenarioComparisonQueryVariables = Exact<{
  input: GRoutingImportPlanInput;
}>;


export type GGetScenarioComparisonQuery = { __typename?: 'Query', routingImportPlan: { __typename?: 'RoutingImportPlan', id: string, thirdPartyStopCount: number, rulesConfig: any, thirdPartyBucketStops: Array<{ __typename: 'Delivery', id: string, location?: { __typename?: 'Location', businessName: string, address: { __typename?: 'Address', latitude?: number, longitude?: number, addressLine1: string } } } | { __typename: 'PickUp' }>, appliedRoutificRun?: { __typename?: 'RoutificRunSummary', id: string, createdAt: any, truckCount: number, routeCount?: number, totalStops?: number, totalDistanceMiles?: number, avgCubicUtilizationPercent?: number, estimatedDriverHours?: number, dprh?: number, unservedCount?: number, polylines?: any, vehicleStopIds?: any, automatedRoutingExclusions?: Array<{ __typename?: 'AutomatedRoutingExclusion', stopId: string, locationId: string, locationName?: string, reason: GAutomatedRoutingExclusionReason }>, unservedStops?: Array<{ __typename?: 'UnservedStop', stopId: string, locationId?: string, locationName?: string, reason: string }> }, dispatchedRoutificRun?: { __typename?: 'RoutificRunSummary', id: string, createdAt: any, truckCount: number, routeCount?: number, totalStops?: number, totalDistanceMiles?: number, avgCubicUtilizationPercent?: number, estimatedDriverHours?: number, dprh?: number, unservedCount?: number, polylines?: any, vehicleStopIds?: any, automatedRoutingExclusions?: Array<{ __typename?: 'AutomatedRoutingExclusion', stopId: string, locationId: string, locationName?: string, reason: GAutomatedRoutingExclusionReason }>, unservedStops?: Array<{ __typename?: 'UnservedStop', stopId: string, locationId?: string, locationName?: string, reason: string }> }, etasStatus: { __typename?: 'EtasStatus', stale: boolean, reason?: GEtasStatusReason, lastCalculatedAt?: any, lastCalculatedRunId?: string }, currentRoutingConfiguration: { __typename?: 'RoutingConfiguration', driverShiftHours?: number, breakDurationMinutes?: number, capacityPercent: number, overtimeMinutes: number }, scenarios: Array<{ __typename?: 'RoutificRunSummary', id: string, label?: string, name?: string, status: GRoutificRunStatus, createdAt: any, truckCount: number, inputSnapshot?: any, routeCount?: number, totalStops?: number, totalDistanceMiles?: number, avgCubicUtilizationPercent?: number, estimatedDriverHours?: number, dprh?: number, unservedCount?: number, polylines?: any, vehicleStopIds?: any, thirdPartyPreviewStopCount?: number, thirdPartyMarkedStopCount?: number, thirdPartyPreviewStops?: Array<{ __typename: 'Delivery', id: string, location?: { __typename?: 'Location', businessName: string, address: { __typename?: 'Address', latitude?: number, longitude?: number, addressLine1: string } } } | { __typename: 'PickUp' }>, thirdPartyMarkedStops?: Array<{ __typename: 'Delivery', id: string, location?: { __typename?: 'Location', businessName: string, address: { __typename?: 'Address', latitude?: number, longitude?: number, addressLine1: string } } } | { __typename: 'PickUp' }>, automatedRoutingExclusions?: Array<{ __typename?: 'AutomatedRoutingExclusion', stopId: string, locationId: string, locationName?: string, reason: GAutomatedRoutingExclusionReason }>, unservedStops?: Array<{ __typename?: 'UnservedStop', stopId: string, locationId?: string, locationName?: string, reason: string }> }> } };

export type GGetScenarioRunStatusQueryVariables = Exact<{
  input: GRoutingImportPlanInput;
}>;


export type GGetScenarioRunStatusQuery = { __typename?: 'Query', routingImportPlan: { __typename?: 'RoutingImportPlan', id: string, appliedRoutificRun?: { __typename?: 'RoutificRunSummary', id: string, createdAt: any, routeCount?: number, totalStops?: number, totalDistanceMiles?: number, avgCubicUtilizationPercent?: number, estimatedDriverHours?: number, dprh?: number, unservedCount?: number, polylines?: any, vehicleStopIds?: any }, scenarios: Array<{ __typename?: 'RoutificRunSummary', id: string, label?: string, name?: string, status: GRoutificRunStatus, createdAt: any, inputSnapshot?: any, routeCount?: number, totalStops?: number, totalDistanceMiles?: number, avgCubicUtilizationPercent?: number, estimatedDriverHours?: number, dprh?: number, unservedCount?: number, polylines?: any, vehicleStopIds?: any, failureReason?: { __typename?: 'RoutificRunFailureReason', type: string, cohortName?: string, dimension?: GRoutificRunFailureDimension } }> } };

export type GTriggerRoutificScenarioRunMutationVariables = Exact<{
  input: GTriggerRoutificScenarioRunInput;
}>;


export type GTriggerRoutificScenarioRunMutation = { __typename?: 'Mutation', triggerRoutificScenarioRun?: { __typename?: 'TriggerRoutificScenarioRunPayload', triggered: boolean, userErrors: Array<{ __typename: 'InvalidNightEnd', message: string, path?: Array<string> } | { __typename: 'InvalidParameterOverrides', message: string, path?: Array<string> } | { __typename: 'InvalidRules', message: string, path?: Array<string> } | { __typename: 'RoutingImportPlanNotConfigured', message: string, path?: Array<string> } | { __typename: 'RoutingImportPlanNotFound', message: string, path?: Array<string> } | { __typename: 'ScenarioLimitReached', message: string, path?: Array<string> } | { __typename: 'ScenarioNotFound', message: string, path?: Array<string> } | { __typename: 'ScenarioRunsNotEnabled', message: string, path?: Array<string> } | { __typename: 'TruckCountInvalid', message: string, path?: Array<string> }> } };

export type GApplyRoutingConfigurationMutationVariables = Exact<{
  input: GApplyRoutingConfigurationInput;
}>;


export type GApplyRoutingConfigurationMutation = { __typename?: 'Mutation', applyRoutingConfiguration?: { __typename?: 'ApplyRoutingConfigurationPayload', applied: boolean, userErrors: Array<{ __typename: 'InvalidFleetComposition', message: string, path?: Array<string> } | { __typename: 'InvalidParameterOverrides', message: string, path?: Array<string> } | { __typename: 'InvalidRules', message: string, path?: Array<string> } | { __typename: 'RoutingConfigurationNotEnabled', message: string, path?: Array<string> } | { __typename: 'RoutingConfigurationNotFound', message: string, path?: Array<string> }> } };

export type GUnapproveCutoffDiscrepancyMutationVariables = Exact<{
  input: GUnapproveCutoffDiscrepancyInput;
}>;


export type GUnapproveCutoffDiscrepancyMutation = { __typename?: 'Mutation', unapproveCutoffDiscrepancy?: { __typename?: 'UnapproveCutoffDiscrepancyPayload', cutoffDiscrepancyApproval?: { __typename?: 'CutoffDiscrepancyApproval', id: string, locationsVendorId: string }, errors: Array<{ __typename: 'UserError' }> } };

export type GUnmarkRouteProviderMutationVariables = Exact<{
  input: GUnmarkRouteProviderInput;
}>;


export type GUnmarkRouteProviderMutation = { __typename?: 'Mutation', unmarkRouteProvider?: { __typename?: 'UnmarkRouteProviderPayload', route?: { __typename?: 'Route', color?: string, id: string, name: string, isLobby: boolean, thirdPartyRoute: boolean, thirdPartyProvider?: GThirdPartyProvider, bucketRoute: boolean, customerPickupRoute: boolean, nightEnd: any, nightEndLocked: boolean, stopTime?: any, totalVolume?: number, totalWeight?: number, percentItemsWithWeight?: number, percentItemsWithVolume?: number, redeliveryRoute: boolean, routeOrigin?: string, routeCohort?: string, shiftType?: string, providerDispatch?: { __typename?: 'ProviderDispatch', status: GProviderDispatchStatus, pickupAt?: any, error?: string, courierAlertSentAt?: any, cancelRequestedAt?: any, cancelable: boolean, unmarkable: boolean, chosenQuote?: { __typename?: 'ProviderQuote', id: string, provider?: string, cost?: number, fee?: number } }, stops?: Array<{ __typename: 'Delivery', id: string, sequenceNumber?: string, totalWeight?: number, totalVolume?: number, deliveryNote?: string, completedAt?: any, location?: { __typename?: 'Location', effectivelyExcluded: boolean, displayAddress: string, id: string, membershipTier: GLocationMembershipTier, includeInAutomatedRouting?: boolean, businessName: string, isDoordash: boolean, scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, address: { __typename?: 'Address', latitude?: number, longitude?: number, state: string }, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', startTime: string, endTime: string }, routingCohort?: { __typename?: 'RoutingCohort', id: string, color?: string, name: string }, warehouseDeliveryRules: Array<{ __typename?: 'DeliveryRule', deliveryDay: number }> }, orders?: Array<{ __typename?: 'Order', id: string, deliveryMethod: GOrderDeliveryMethodEnum, scheduledDeliveryTime?: { __typename?: 'ScheduledDeliveryTime', earliest: string, latest: string, timeZone: string } }>, providerDelivery?: { __typename?: 'ProviderDelivery', status?: string, courierAssigned: boolean, courierName?: string, dropoffEta?: any, trackingUrl?: string, proofUrls: Array<string>, needsAttention: boolean, needsAttentionReason?: string }, route: { __typename?: 'Route', id: string, name: string, truck?: { __typename?: 'Truck', maxWeight: number, maxVolume: number, vin?: string, vehicleTag?: string } } } | { __typename: 'PickUp', id: string, sequenceNumber?: string, vendor: { __typename?: 'Vendor', name: string, legalName: string, address?: { __typename?: 'Address', latitude?: number, longitude?: number, state: string } } }>, redeliveryStops: Array<{ __typename?: 'Redelivery', id: string, sequenceNumber?: string, deliveryStop: { __typename?: 'Delivery', id: string }, location?: { __typename?: 'Location', effectivelyExcluded: boolean, displayAddress: string, id: string, includeInAutomatedRouting?: boolean, businessName: string, isDoordash: boolean, scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, address: { __typename?: 'Address', latitude?: number, longitude?: number, state: string }, locationDeliveryWindow: { __typename?: 'LocationDeliveryWindows', startTime: string, endTime: string }, routingCohort?: { __typename?: 'RoutingCohort', id: string, color?: string, name: string }, warehouseDeliveryRules: Array<{ __typename?: 'DeliveryRule', deliveryDay: number }> }, orders?: Array<{ __typename?: 'Order', id: string, deliveryMethod: GOrderDeliveryMethodEnum, scheduledDeliveryTime?: { __typename?: 'ScheduledDeliveryTime', earliest: string, latest: string, timeZone: string } }>, providerDelivery?: { __typename?: 'ProviderDelivery', status?: string, courierAssigned: boolean, courierName?: string, dropoffEta?: any, trackingUrl?: string, proofUrls: Array<string>, needsAttention: boolean, needsAttentionReason?: string }, route: { __typename?: 'Route', id: string, name: string, truck?: { __typename?: 'Truck', maxWeight: number, maxVolume: number, vin?: string, vehicleTag?: string } } }>, driverUser?: { __typename?: 'User', id: string, name?: string, email?: string }, helperDriverUser?: { __typename?: 'User', id: string, name?: string, email?: string }, truck?: { __typename?: 'Truck', maxVolume: number, maxWeight: number, vin?: string, vehicleTag?: string }, plannedVehicle?: { __typename?: 'PlannedVehicle', maxVolume?: number, maxWeight?: number, vehicleType?: string } }, userErrors: Array<{ __typename: 'DispatchNotAllowed', message: string } | { __typename: 'DispatchProfileIncomplete', message: string } | { __typename: 'ProviderNotAvailable', message: string } | { __typename: 'ProviderRejected', message: string } | { __typename: 'RouteNotFound', message: string } | { __typename: 'RouteNotMarkable', message: string } | { __typename: 'StopsNotEscalatable', message: string } | { __typename: 'UnmarkNotAllowed', message: string }> } };

export type GUpdateLocationsCustomerPickupMutationVariables = Exact<{
  input: GLocationsCustomerPickupUpdateInput;
}>;


export type GUpdateLocationsCustomerPickupMutation = { __typename?: 'Mutation', updateLocationsCustomerPickup?: { __typename?: 'LocationsCustomerPickupUpdatePayload', notFoundLocationIds: Array<string>, locations: Array<{ __typename?: 'Location', id: string, customerPickup: boolean }>, userErrors: Array<{ __typename: 'LocationsNotFound', message: string } | { __typename: 'RecentDeliveriesPresent', message: string, offenders: Array<{ __typename?: 'RecentDeliveryLocation', locationId: string, name?: string, stopCount: number, lastNightEnd?: any }> }> } };

export type GUpdateLocationsDeliverWithinStoreHoursMutationVariables = Exact<{
  input: GUpdateLocationsDeliverWithinStoreHoursMutationInput;
}>;


export type GUpdateLocationsDeliverWithinStoreHoursMutation = { __typename?: 'Mutation', updateLocationsDeliverWithinStoreHours?: { __typename?: 'UpdateLocationsDeliverWithinStoreHoursMutationPayload', updatedLocations: Array<{ __typename?: 'Location', id: string, scheduledDeliveryTimeSource: GScheduledDeliveryTimeSourceEnum, deliverWithinStoreHours: boolean }>, errors: Array<{ __typename: 'UserError' }> } };

export type GUpdateLocationsEnforceItemScanningMutationVariables = Exact<{
  input: GLocationsEnforceItemScanningUpdateInput;
}>;


export type GUpdateLocationsEnforceItemScanningMutation = { __typename?: 'Mutation', updateLocationsEnforceItemScanning?: { __typename?: 'LocationsEnforceItemScanningUpdatePayload', locations: Array<{ __typename?: 'Location', id: string, enforceItemScanning: boolean }> } };

export type GUpdateLocationsIncludeInAutomatedRoutingMutationVariables = Exact<{
  input: GLocationsIncludeInAutomatedRoutingUpdateInput;
}>;


export type GUpdateLocationsIncludeInAutomatedRoutingMutation = { __typename?: 'Mutation', updateLocationsIncludeInAutomatedRouting?: { __typename?: 'LocationsIncludeInAutomatedRoutingUpdatePayload', locations: Array<{ __typename?: 'Location', id: string, includeInAutomatedRouting?: boolean }> } };

export type GUpdateLocationsIncludeFinancialsOnDeliverySheetMutationVariables = Exact<{
  input: GLocationsIncludeFinancialsOnDeliverySheetUpdateInput;
}>;


export type GUpdateLocationsIncludeFinancialsOnDeliverySheetMutation = { __typename?: 'Mutation', updateLocationsIncludeFinancialsOnDeliverySheet?: { __typename?: 'LocationsIncludeFinancialsOnDeliverySheetUpdatePayload', locations: Array<{ __typename?: 'Location', id: string, includeFinancialsOnDeliverySheet: boolean }> } };

export type GUpdateLocationsPrintDeliverySheetEnabledMutationVariables = Exact<{
  input: GLocationsPrintDeliverySheetEnabledUpdateInput;
}>;


export type GUpdateLocationsPrintDeliverySheetEnabledMutation = { __typename?: 'Mutation', updateLocationsPrintDeliverySheetEnabled?: { __typename?: 'LocationsPrintDeliverySheetEnabledUpdatePayload', locations: Array<{ __typename?: 'Location', id: string, printDeliverySheetEnabled: boolean }> } };

export type GUpdateLocationsRoutingCohortMutationVariables = Exact<{
  input: GUpdateLocationsRoutingCohortMutationInput;
}>;


export type GUpdateLocationsRoutingCohortMutation = { __typename?: 'Mutation', updateLocationsRoutingCohort?: { __typename?: 'UpdateLocationsRoutingCohortMutationPayload', success: boolean } };

export type GUpdateLocationsServiceTimeMutationVariables = Exact<{
  input: GLocationsServiceTimeUpdateInput;
}>;


export type GUpdateLocationsServiceTimeMutation = { __typename?: 'Mutation', updateLocationsServiceTime?: { __typename?: 'LocationsServiceTimeUpdatePayload', locations: Array<{ __typename?: 'Location', id: string, serviceTime?: number }> } };

export type GUpdateLocationsThirdPartyExclusionMutationVariables = Exact<{
  input: GLocationsThirdPartyExclusionUpdateInput;
}>;


export type GUpdateLocationsThirdPartyExclusionMutation = { __typename?: 'Mutation', updateLocationsThirdPartyExclusion?: { __typename?: 'LocationsThirdPartyExclusionUpdatePayload', locations: Array<{ __typename?: 'Location', id: string, locationExcluded: boolean, effectivelyExcluded: boolean }>, userErrors: Array<{ __typename?: 'LocationsNotFound', message: string } | { __typename?: 'RecentDeliveriesPresent', message: string }> } };

export type GUpdateOrderDeliveryMethodMutationVariables = Exact<{
  input: GUpdateOrderDeliveryMethodMutationInput;
}>;


export type GUpdateOrderDeliveryMethodMutation = { __typename?: 'Mutation', updateOrderDeliveryMethod?: { __typename?: 'UpdateOrderDeliveryMethodMutationPayload', orders?: Array<{ __typename?: 'Order', id: string, deliveryMethod: GOrderDeliveryMethodEnum }>, errors?: Array<{ __typename?: 'UserError', message: string, path?: Array<string> }> } };

export type GUpdateOrderLineDeliveredQuantityMutationVariables = Exact<{
  input: GOrderLineDeliveredQuantityUpdateInput;
}>;


export type GUpdateOrderLineDeliveredQuantityMutation = { __typename?: 'Mutation', updateOrderLineDeliveredQuantity?: { __typename?: 'OrderLineDeliveredQuantityUpdatePayload', orderLine?: { __typename?: 'OrderLine', id: string, deliveredQuantity?: number }, userErrors: Array<{ __typename: 'BlankNote', message: string, path?: Array<string> } | { __typename: 'InvalidDeliveredQuantity', message: string, path?: Array<string> } | { __typename: 'InvalidFulfillmentQuantity', message: string, path?: Array<string> } | { __typename: 'MissingQtyDelivered', message: string, path?: Array<string> } | { __typename: 'OrderLineNotFound', message: string, path?: Array<string> } | { __typename: 'OrderNotEligibleForReview', message: string, path?: Array<string> } | { __typename: 'OrderNotFound', message: string, path?: Array<string> } | { __typename: 'RecoveryQuantityOutOfRange', message: string, path?: Array<string> } | { __typename: 'ReviewConfirmationMismatch', message: string, path?: Array<string> } | { __typename: 'RouteEnded', message: string, path?: Array<string> }> } };

export type GUpdateOrderLineRecoveryQuantityMutationVariables = Exact<{
  input: GOrderLineRecoveryQuantityUpdateInput;
}>;


export type GUpdateOrderLineRecoveryQuantityMutation = { __typename?: 'Mutation', updateOrderLineRecoveryQuantity?: { __typename?: 'OrderLineRecoveryQuantityUpdatePayload', orderLine?: { __typename?: 'OrderLine', id: string, recoveryQuantity?: number }, userErrors: Array<{ __typename: 'BlankNote', message: string, path?: Array<string> } | { __typename: 'InvalidDeliveredQuantity', message: string, path?: Array<string> } | { __typename: 'InvalidFulfillmentQuantity', message: string, path?: Array<string> } | { __typename: 'MissingQtyDelivered', message: string, path?: Array<string> } | { __typename: 'OrderLineNotFound', message: string, path?: Array<string> } | { __typename: 'OrderNotEligibleForReview', message: string, path?: Array<string> } | { __typename: 'OrderNotFound', message: string, path?: Array<string> } | { __typename: 'RecoveryQuantityOutOfRange', message: string, path?: Array<string> } | { __typename: 'ReviewConfirmationMismatch', message: string, path?: Array<string> } | { __typename: 'RouteEnded', message: string, path?: Array<string> }> } };

export type GUpdateRouteOriginMutationVariables = Exact<{
  input: GRouteOriginUpdateInput;
}>;


export type GUpdateRouteOriginMutation = { __typename?: 'Mutation', updateRouteOrigin?: { __typename?: 'RouteOriginUpdatePayload', route?: { __typename?: 'Route', id: string, routeOrigin?: string }, userErrors: Array<{ __typename: 'AutomatedRoutingPending' } | { __typename: 'BulkUpdateDeprecated' } | { __typename: 'InvalidNightEnd' } | { __typename: 'ProviderRouteGuarded' } | { __typename: 'RouteEnded' }> } };

export type GPublicOverrideBookingFieldsFragment = { __typename?: 'PublicDockBooking', status: GDockBookingStatus, freightType?: GFreightType, referenceNumber: string, rescheduledToReference?: string, carrierName?: string, expectedDate?: any, warehouseId?: string, warehouseName: string, warehouseTimeZone: string, contactName?: string, contactEmail?: string, contactPhone?: string, confirmationNumber?: string, palletCount?: number, weightLbs?: number, scacCode?: string, deliveryType?: GDeliveryType, shipDate?: any, proNumber?: string, comments?: string, truckNumber?: string, slotStartsAt?: any, slotEndsAt?: any, slotLabel?: string, windowMinutes?: number };

type GOverrideBookingErrorFields_AdHocAppointmentsNotAllowed_Fragment = { __typename?: 'AdHocAppointmentsNotAllowed' };

type GOverrideBookingErrorFields_AppointmentInPast_Fragment = { __typename?: 'AppointmentInPast', errorCode: string, message: string };

type GOverrideBookingErrorFields_CarrierNameRequired_Fragment = { __typename?: 'CarrierNameRequired' };

type GOverrideBookingErrorFields_CheckInNotAllowed_Fragment = { __typename?: 'CheckInNotAllowed' };

type GOverrideBookingErrorFields_ContactDetailsRequired_Fragment = { __typename?: 'ContactDetailsRequired', errorCode: string, message: string };

type GOverrideBookingErrorFields_DailyDeliveryExists_Fragment = { __typename?: 'DailyDeliveryExists', errorCode: string, message: string };

type GOverrideBookingErrorFields_DepartNotAllowed_Fragment = { __typename?: 'DepartNotAllowed' };

type GOverrideBookingErrorFields_DockBookingAlreadyCompleted_Fragment = { __typename?: 'DockBookingAlreadyCompleted' };

type GOverrideBookingErrorFields_DockBookingAlreadyMissed_Fragment = { __typename?: 'DockBookingAlreadyMissed' };

type GOverrideBookingErrorFields_DockBookingNotBooked_Fragment = { __typename?: 'DockBookingNotBooked' };

type GOverrideBookingErrorFields_DockBookingNotFound_Fragment = { __typename?: 'DockBookingNotFound', errorCode: string, message: string };

type GOverrideBookingErrorFields_DockBookingWarehouseNotFound_Fragment = { __typename?: 'DockBookingWarehouseNotFound', errorCode: string, message: string };

type GOverrideBookingErrorFields_DockCapacityInvalid_Fragment = { __typename?: 'DockCapacityInvalid' };

type GOverrideBookingErrorFields_DockInUse_Fragment = { __typename?: 'DockInUse' };

type GOverrideBookingErrorFields_DockNotFound_Fragment = { __typename?: 'DockNotFound' };

type GOverrideBookingErrorFields_DockOverrideCodeInactive_Fragment = { __typename?: 'DockOverrideCodeInactive', errorCode: string, message: string };

type GOverrideBookingErrorFields_DockReassignNotAllowed_Fragment = { __typename?: 'DockReassignNotAllowed' };

type GOverrideBookingErrorFields_DockRecoveryNotAllowed_Fragment = { __typename?: 'DockRecoveryNotAllowed', errorCode: string, message: string };

type GOverrideBookingErrorFields_DockSlotUnavailable_Fragment = { __typename?: 'DockSlotUnavailable', errorCode: string, message: string };

type GOverrideBookingErrorFields_DockVisitNotFound_Fragment = { __typename?: 'DockVisitNotFound' };

type GOverrideBookingErrorFields_OverrideCodeIssueConflict_Fragment = { __typename?: 'OverrideCodeIssueConflict' };

type GOverrideBookingErrorFields_OverrideCodeNotFound_Fragment = { __typename?: 'OverrideCodeNotFound' };

type GOverrideBookingErrorFields_OverrideVendorNotFound_Fragment = { __typename?: 'OverrideVendorNotFound' };

type GOverrideBookingErrorFields_ShipDateRequired_Fragment = { __typename?: 'ShipDateRequired', errorCode: string, message: string };

type GOverrideBookingErrorFields_WithinLeadTime_Fragment = { __typename?: 'WithinLeadTime', errorCode: string, message: string };

export type GOverrideBookingErrorFieldsFragment = GOverrideBookingErrorFields_AdHocAppointmentsNotAllowed_Fragment | GOverrideBookingErrorFields_AppointmentInPast_Fragment | GOverrideBookingErrorFields_CarrierNameRequired_Fragment | GOverrideBookingErrorFields_CheckInNotAllowed_Fragment | GOverrideBookingErrorFields_ContactDetailsRequired_Fragment | GOverrideBookingErrorFields_DailyDeliveryExists_Fragment | GOverrideBookingErrorFields_DepartNotAllowed_Fragment | GOverrideBookingErrorFields_DockBookingAlreadyCompleted_Fragment | GOverrideBookingErrorFields_DockBookingAlreadyMissed_Fragment | GOverrideBookingErrorFields_DockBookingNotBooked_Fragment | GOverrideBookingErrorFields_DockBookingNotFound_Fragment | GOverrideBookingErrorFields_DockBookingWarehouseNotFound_Fragment | GOverrideBookingErrorFields_DockCapacityInvalid_Fragment | GOverrideBookingErrorFields_DockInUse_Fragment | GOverrideBookingErrorFields_DockNotFound_Fragment | GOverrideBookingErrorFields_DockOverrideCodeInactive_Fragment | GOverrideBookingErrorFields_DockReassignNotAllowed_Fragment | GOverrideBookingErrorFields_DockRecoveryNotAllowed_Fragment | GOverrideBookingErrorFields_DockSlotUnavailable_Fragment | GOverrideBookingErrorFields_DockVisitNotFound_Fragment | GOverrideBookingErrorFields_OverrideCodeIssueConflict_Fragment | GOverrideBookingErrorFields_OverrideCodeNotFound_Fragment | GOverrideBookingErrorFields_OverrideVendorNotFound_Fragment | GOverrideBookingErrorFields_ShipDateRequired_Fragment | GOverrideBookingErrorFields_WithinLeadTime_Fragment;

export type GGetPublicOverrideVendorQueryVariables = Exact<{
  code: Scalars['String'];
  historyDays?: InputMaybe<Scalars['Int']>;
}>;


export type GGetPublicOverrideVendorQuery = { __typename?: 'Query', publicOverrideVendor?: { __typename?: 'PublicOverrideVendor', vendorName: string, bookings: Array<{ __typename?: 'PublicDockBooking', status: GDockBookingStatus, freightType?: GFreightType, referenceNumber: string, rescheduledToReference?: string, carrierName?: string, expectedDate?: any, warehouseId?: string, warehouseName: string, warehouseTimeZone: string, contactName?: string, contactEmail?: string, contactPhone?: string, confirmationNumber?: string, palletCount?: number, weightLbs?: number, scacCode?: string, deliveryType?: GDeliveryType, shipDate?: any, proNumber?: string, comments?: string, truckNumber?: string, slotStartsAt?: any, slotEndsAt?: any, slotLabel?: string, windowMinutes?: number }> } };

export type GGetPublicDockWarehousesQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type GGetPublicDockWarehousesQuery = { __typename?: 'Query', publicDockWarehouses: Array<{ __typename?: 'PublicDockWarehouse', id: string, name: string }> };

export type GGetPublicOverrideSlotsQueryVariables = Exact<{
  code: Scalars['String'];
  warehouseId: Scalars['ID'];
  date: Scalars['ISO8601Date'];
  freightType: GFreightType;
  scacCode?: InputMaybe<Scalars['String']>;
}>;


export type GGetPublicOverrideSlotsQuery = { __typename?: 'Query', publicOverrideSlots: Array<{ __typename?: 'PublicDockSlot', startsAt: any, endsAt: any, label: string }> };

export type GGetPublicOverrideBookingSlotsQueryVariables = Exact<{
  code: Scalars['String'];
  date: Scalars['ISO8601Date'];
  freightType: GFreightType;
  scacCode?: InputMaybe<Scalars['String']>;
  historyDays?: InputMaybe<Scalars['Int']>;
}>;


export type GGetPublicOverrideBookingSlotsQuery = { __typename?: 'Query', publicOverrideVendor?: { __typename?: 'PublicOverrideVendor', bookings: Array<{ __typename?: 'PublicDockBooking', referenceNumber: string, availableSlots: Array<{ __typename?: 'PublicDockSlot', startsAt: any, endsAt: any, label: string }> }> } };

export type GCreatePublicOverrideBookingMutationVariables = Exact<{
  input: GPublicOverrideBookingCreateInput;
}>;


export type GCreatePublicOverrideBookingMutation = { __typename?: 'Mutation', publicOverrideBookingCreate?: { __typename?: 'PublicOverrideBookingCreatePayload', booking?: { __typename?: 'PublicDockBooking', status: GDockBookingStatus, freightType?: GFreightType, referenceNumber: string, rescheduledToReference?: string, carrierName?: string, expectedDate?: any, warehouseId?: string, warehouseName: string, warehouseTimeZone: string, contactName?: string, contactEmail?: string, contactPhone?: string, confirmationNumber?: string, palletCount?: number, weightLbs?: number, scacCode?: string, deliveryType?: GDeliveryType, shipDate?: any, proNumber?: string, comments?: string, truckNumber?: string, slotStartsAt?: any, slotEndsAt?: any, slotLabel?: string, windowMinutes?: number }, userErrors: Array<{ __typename?: 'AdHocAppointmentsNotAllowed' } | { __typename?: 'AppointmentInPast', errorCode: string, message: string } | { __typename?: 'CarrierNameRequired' } | { __typename?: 'CheckInNotAllowed' } | { __typename?: 'ContactDetailsRequired', errorCode: string, message: string } | { __typename?: 'DailyDeliveryExists', errorCode: string, message: string } | { __typename?: 'DepartNotAllowed' } | { __typename?: 'DockBookingAlreadyCompleted' } | { __typename?: 'DockBookingAlreadyMissed' } | { __typename?: 'DockBookingNotBooked' } | { __typename?: 'DockBookingNotFound', errorCode: string, message: string } | { __typename?: 'DockBookingWarehouseNotFound', errorCode: string, message: string } | { __typename?: 'DockCapacityInvalid' } | { __typename?: 'DockInUse' } | { __typename?: 'DockNotFound' } | { __typename?: 'DockOverrideCodeInactive', errorCode: string, message: string } | { __typename?: 'DockReassignNotAllowed' } | { __typename?: 'DockRecoveryNotAllowed', errorCode: string, message: string } | { __typename?: 'DockSlotUnavailable', errorCode: string, message: string } | { __typename?: 'DockVisitNotFound' } | { __typename?: 'OverrideCodeIssueConflict' } | { __typename?: 'OverrideCodeNotFound' } | { __typename?: 'OverrideVendorNotFound' } | { __typename?: 'ShipDateRequired', errorCode: string, message: string } | { __typename?: 'WithinLeadTime', errorCode: string, message: string }> } };

export type GAmendPublicOverrideBookingMutationVariables = Exact<{
  input: GPublicOverrideBookingAmendInput;
}>;


export type GAmendPublicOverrideBookingMutation = { __typename?: 'Mutation', publicOverrideBookingAmend?: { __typename?: 'PublicOverrideBookingAmendPayload', booking?: { __typename?: 'PublicDockBooking', status: GDockBookingStatus, freightType?: GFreightType, referenceNumber: string, rescheduledToReference?: string, carrierName?: string, expectedDate?: any, warehouseId?: string, warehouseName: string, warehouseTimeZone: string, contactName?: string, contactEmail?: string, contactPhone?: string, confirmationNumber?: string, palletCount?: number, weightLbs?: number, scacCode?: string, deliveryType?: GDeliveryType, shipDate?: any, proNumber?: string, comments?: string, truckNumber?: string, slotStartsAt?: any, slotEndsAt?: any, slotLabel?: string, windowMinutes?: number }, userErrors: Array<{ __typename?: 'AdHocAppointmentsNotAllowed' } | { __typename?: 'AppointmentInPast', errorCode: string, message: string } | { __typename?: 'CarrierNameRequired' } | { __typename?: 'CheckInNotAllowed' } | { __typename?: 'ContactDetailsRequired', errorCode: string, message: string } | { __typename?: 'DailyDeliveryExists', errorCode: string, message: string } | { __typename?: 'DepartNotAllowed' } | { __typename?: 'DockBookingAlreadyCompleted' } | { __typename?: 'DockBookingAlreadyMissed' } | { __typename?: 'DockBookingNotBooked' } | { __typename?: 'DockBookingNotFound', errorCode: string, message: string } | { __typename?: 'DockBookingWarehouseNotFound', errorCode: string, message: string } | { __typename?: 'DockCapacityInvalid' } | { __typename?: 'DockInUse' } | { __typename?: 'DockNotFound' } | { __typename?: 'DockOverrideCodeInactive', errorCode: string, message: string } | { __typename?: 'DockReassignNotAllowed' } | { __typename?: 'DockRecoveryNotAllowed', errorCode: string, message: string } | { __typename?: 'DockSlotUnavailable', errorCode: string, message: string } | { __typename?: 'DockVisitNotFound' } | { __typename?: 'OverrideCodeIssueConflict' } | { __typename?: 'OverrideCodeNotFound' } | { __typename?: 'OverrideVendorNotFound' } | { __typename?: 'ShipDateRequired', errorCode: string, message: string } | { __typename?: 'WithinLeadTime', errorCode: string, message: string }> } };

export type GCancelPublicOverrideBookingMutationVariables = Exact<{
  input: GPublicOverrideBookingCancelInput;
}>;


export type GCancelPublicOverrideBookingMutation = { __typename?: 'Mutation', publicOverrideBookingCancel?: { __typename?: 'PublicOverrideBookingCancelPayload', booking?: { __typename?: 'PublicDockBooking', status: GDockBookingStatus, freightType?: GFreightType, referenceNumber: string, rescheduledToReference?: string, carrierName?: string, expectedDate?: any, warehouseId?: string, warehouseName: string, warehouseTimeZone: string, contactName?: string, contactEmail?: string, contactPhone?: string, confirmationNumber?: string, palletCount?: number, weightLbs?: number, scacCode?: string, deliveryType?: GDeliveryType, shipDate?: any, proNumber?: string, comments?: string, truckNumber?: string, slotStartsAt?: any, slotEndsAt?: any, slotLabel?: string, windowMinutes?: number }, userErrors: Array<{ __typename?: 'AdHocAppointmentsNotAllowed' } | { __typename?: 'AppointmentInPast', errorCode: string, message: string } | { __typename?: 'CarrierNameRequired' } | { __typename?: 'CheckInNotAllowed' } | { __typename?: 'ContactDetailsRequired', errorCode: string, message: string } | { __typename?: 'DailyDeliveryExists', errorCode: string, message: string } | { __typename?: 'DepartNotAllowed' } | { __typename?: 'DockBookingAlreadyCompleted' } | { __typename?: 'DockBookingAlreadyMissed' } | { __typename?: 'DockBookingNotBooked' } | { __typename?: 'DockBookingNotFound', errorCode: string, message: string } | { __typename?: 'DockBookingWarehouseNotFound', errorCode: string, message: string } | { __typename?: 'DockCapacityInvalid' } | { __typename?: 'DockInUse' } | { __typename?: 'DockNotFound' } | { __typename?: 'DockOverrideCodeInactive', errorCode: string, message: string } | { __typename?: 'DockReassignNotAllowed' } | { __typename?: 'DockRecoveryNotAllowed', errorCode: string, message: string } | { __typename?: 'DockSlotUnavailable', errorCode: string, message: string } | { __typename?: 'DockVisitNotFound' } | { __typename?: 'OverrideCodeIssueConflict' } | { __typename?: 'OverrideCodeNotFound' } | { __typename?: 'OverrideVendorNotFound' } | { __typename?: 'ShipDateRequired', errorCode: string, message: string } | { __typename?: 'WithinLeadTime', errorCode: string, message: string }> } };
